import type { GraphQLISO8601Date, GraphQLISO8601DateTime } from '@src/apollo/types';
import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: GraphQLISO8601Date; output: GraphQLISO8601Date; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: GraphQLISO8601DateTime; output: GraphQLISO8601DateTime; }
  /** Represents untyped JSON */
  JSON: { input: any; output: any; }
  Upload: { input: any; output: any; }
}

/** Autogenerated return type of AcceptOffer. */
export interface AcceptOfferPayload {
  readonly __typename?: 'AcceptOfferPayload';
  readonly jobOffer: JobOffer;
  readonly nurseProfile: NurseProfile;
}

export const enum AccreditationsEnum {
  /** Magnet Hospitals */
  Magnet = 'magnet',
  /** Nurse Residencies */
  Residency = 'residency',
  /** Teaching Hospitals */
  Teaching = 'teaching'
};

export const enum AccreditingBodiesEnum {
  Aacn = 'AACN',
  Ancc = 'ANCC',
  Ccne = 'CCNE'
};

export interface AccrualsInput {
  readonly covidLeaveHours?: InputMaybe<ReadonlyArray<CovidLeaveHoursInput>>;
  readonly payrollAmendmentId?: InputMaybe<Scalars['ID']['input']>;
  readonly sickLeaveHours?: InputMaybe<Scalars['Float']['input']>;
}

export interface ActionLink {
  readonly __typename?: 'ActionLink';
  readonly id: Scalars['ID']['output'];
  readonly title: Scalars['String']['output'];
  readonly url: Scalars['String']['output'];
}

export interface ActionLinkTypeInput {
  readonly _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly title: Scalars['String']['input'];
  readonly url: Scalars['String']['input'];
}

export interface ActivationRequest {
  readonly __typename?: 'ActivationRequest';
  readonly advocate?: Maybe<SalesforceUser>;
  readonly earliestStartDateAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly followingStepQuestion?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly requiredExperience?: Maybe<Scalars['Boolean']['output']>;
  readonly requiredExperienceDateAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly requiredLicenseOrCertification?: Maybe<Scalars['Boolean']['output']>;
  readonly requiredLicenseOrCertificationDateAt?: Maybe<Scalars['ISO8601Date']['output']>;
}

export interface ActorAvatar {
  readonly __typename?: 'ActorAvatar';
  readonly type: ActorAvatarType;
  readonly value: Scalars['String']['output'];
}

export const enum ActorAvatarType {
  Image = 'IMAGE',
  Initials = 'INITIALS',
  Unknown = 'UNKNOWN'
};

/** Autogenerated return type of AddCorrectionToNextPayroll. */
export interface AddCorrectionToNextPayrollPayload {
  readonly __typename?: 'AddCorrectionToNextPayrollPayload';
  readonly payroll: Payroll;
}

/** Autogenerated return type of AddPemShiftHours. */
export interface AddPemShiftHoursPayload {
  readonly __typename?: 'AddPemShiftHoursPayload';
  readonly timeSheet: TimeSheet;
}

export interface AdjustmentInvoiceLineItem {
  readonly __typename?: 'AdjustmentInvoiceLineItem';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly hours?: Maybe<Scalars['Float']['output']>;
  readonly kind: Scalars['String']['output'];
  readonly netAmount: Scalars['Float']['output'];
  readonly rate?: Maybe<Scalars['Float']['output']>;
  readonly type: Scalars['String']['output'];
}

export const enum AdjustmentKind {
  /** Acceptable Variance 5 Percent */
  AcceptableVariance_5Percent = 'acceptable_variance_5_percent',
  /** Bill Rate Issue */
  BillRateIssue = 'bill_rate_issue',
  /** Billing Rules Issue */
  BillingRulesIssue = 'billing_rules_issue',
  /** Counter Balance */
  CounterBalance = 'counter_balance',
  /** Legacy Actual Receivable Vs Recon Variance */
  LegacyActualReceivableVsReconVariance = 'legacy_actual_receivable_vs_recon_variance',
  /** Uncollectible */
  Uncollectible = 'uncollectible',
  /** Uncollectible Due To Ar */
  UncollectibleDueToAr = 'uncollectible_due_to_ar',
  /** Uncollectible Due To Nurse */
  UncollectibleDueToNurse = 'uncollectible_due_to_nurse'
};

export interface AdminNoteInput {
  readonly internalNotes?: InputMaybe<Scalars['String']['input']>;
  readonly payrollId: Scalars['ID']['input'];
}

export interface AdminUser {
  readonly __typename?: 'AdminUser';
  readonly canManageReceivableData: AuthorizationResult;
  readonly canManageVmsReverseInvoiceItemConfirm: AuthorizationResult;
  readonly canManageVmsReverseInvoiceItemUnconfirm: AuthorizationResult;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly initials?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly uuid?: Maybe<Scalars['String']['output']>;
}

export interface Affiliation {
  readonly __typename?: 'Affiliation';
  readonly id: Scalars['ID']['output'];
  readonly organizationName: Scalars['String']['output'];
}

export interface AffiliationHistory {
  readonly __typename?: 'AffiliationHistory';
  readonly descriptions: ReadonlyArray<Scalars['String']['output']>;
  readonly endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly organizationName: Scalars['String']['output'];
  readonly role?: Maybe<Scalars['String']['output']>;
  readonly startDate: Scalars['ISO8601Date']['output'];
}

export interface Agency {
  readonly __typename?: 'Agency';
  readonly id: Scalars['ID']['output'];
  readonly isTrustedHealthAgency: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly uuid?: Maybe<Scalars['String']['output']>;
}

export const enum AlliedHealthNursingLicenseType {
  /** Certified Registered Nurse Anesthetist */
  Anesthetist = 'ANESTHETIST',
  /** Cath Lab Or Interventional Technologist */
  CathLabOrInterventionalTechnologist = 'CATH_LAB_OR_INTERVENTIONAL_TECHNOLOGIST',
  /** Certified Behavior Analyst */
  CertifiedBehaviorAnalyst = 'CERTIFIED_BEHAVIOR_ANALYST',
  /** Clinical Nurse Specialist */
  Clinical = 'CLINICAL',
  /** Clinical Psychologist */
  ClinicalPsychologist = 'CLINICAL_PSYCHOLOGIST',
  /** Cytotechnologist */
  Cytotechnologist = 'CYTOTECHNOLOGIST',
  /** Dietetic Tech */
  DieteticTech = 'DIETETIC_TECH',
  /** Dietician */
  Dietician = 'DIETICIAN',
  /** Dosimetrist */
  Dosimetrist = 'DOSIMETRIST',
  /** Histotechnician */
  Histotechnician = 'HISTOTECHNICIAN',
  /** Histotechnologist */
  Histotechnologist = 'HISTOTECHNOLOGIST',
  /** Laboratory Technician */
  LaboratoryTechnician = 'LABORATORY_TECHNICIAN',
  /** Lab Scientist */
  LabScientist = 'LAB_SCIENTIST',
  /** Licensed Therapist Or Counselor */
  LicensedTherapistOrCounselor = 'LICENSED_THERAPIST_OR_COUNSELOR',
  /** Mental Health Technician */
  MentalHealthTechnician = 'MENTAL_HEALTH_TECHNICIAN',
  /** Certified Nurse Midwife */
  Midwife = 'MIDWIFE',
  /** Neurodiagnostic Technician */
  NeurodiagnosticTechnician = 'NEURODIAGNOSTIC_TECHNICIAN',
  /** Certified Nursing Assistant */
  NursingAssistant = 'NURSING_ASSISTANT',
  /** Occupational Therapist */
  OccupationalTherapist = 'OCCUPATIONAL_THERAPIST',
  /** Occupational Therapist Assistant */
  OccupationalTherapistAssistant = 'OCCUPATIONAL_THERAPIST_ASSISTANT',
  /** Pharmacist */
  Pharmacist = 'PHARMACIST',
  /** Pharmacy Technician */
  PharmacyTechnician = 'PHARMACY_TECHNICIAN',
  /** Phlebotomist */
  Phlebotomist = 'PHLEBOTOMIST',
  /** Physical Therapist */
  PhysicalTherapist = 'PHYSICAL_THERAPIST',
  /** Physical Therapist Assistant */
  PhysicalTherapistAssistant = 'PHYSICAL_THERAPIST_ASSISTANT',
  /** Licensed Vocational Nurse / Licensed Practical Nurse */
  Practical = 'PRACTICAL',
  /** Certified Nurse Practitioner */
  Practitioner = 'PRACTITIONER',
  /** Radiologic Technologist */
  RadiologicTechnologist = 'RADIOLOGIC_TECHNOLOGIST',
  /** Registered Nurse */
  Registered = 'REGISTERED',
  /** Respiratory Therapist */
  RespiratoryTherapist = 'RESPIRATORY_THERAPIST',
  /** Social Worker */
  SocialWorker = 'SOCIAL_WORKER',
  /** Sonographer */
  Sonographer = 'SONOGRAPHER',
  /** Speech Language Pathologist */
  SpeechLanguagePathologist = 'SPEECH_LANGUAGE_PATHOLOGIST',
  /** Sterile Processing Tech */
  SterileProcessingTech = 'STERILE_PROCESSING_TECH',
  /** Surgical Assistant */
  SurgicalAssistant = 'SURGICAL_ASSISTANT',
  /** Surgical Technologist */
  SurgicalTechnologist = 'SURGICAL_TECHNOLOGIST',
  /** Telemetry Technician */
  TelemetryTechnician = 'TELEMETRY_TECHNICIAN'
};

export interface Apartment {
  readonly __typename?: 'Apartment';
  readonly available?: Maybe<Scalars['String']['output']>;
  readonly bgImageUrl?: Maybe<Scalars['String']['output']>;
  readonly canApply: AuthorizationResult;
  readonly canApplyWithInstantOffer: AuthorizationResult;
  readonly city?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly price?: Maybe<Scalars['String']['output']>;
  readonly url?: Maybe<Scalars['String']['output']>;
}

/** The connection type for Apartment. */
export interface ApartmentConnection {
  readonly __typename?: 'ApartmentConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ApartmentEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Apartment>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface ApartmentEdge {
  readonly __typename?: 'ApartmentEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Apartment>;
}

export interface ApplicationReadiness {
  readonly __typename?: 'ApplicationReadiness';
  readonly meta: ApplicationReadinessResultsMeta;
  readonly results: ApplicationReadinessResults;
}

export interface ApplicationReadinessBaseResult {
  readonly __typename?: 'ApplicationReadinessBaseResult';
  readonly detailedMessage?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly label: Scalars['String']['output'];
  readonly message?: Maybe<Scalars['String']['output']>;
  readonly status: ApplicationReadinessStatus;
}

export const enum ApplicationReadinessEmploymentIncompleteReason {
  /** Missing Work Experience */
  MissingWorkExperience = 'missing_work_experience',
  /** Overlapping Work Experience */
  OverlappingWorkExperience = 'overlapping_work_experience',
  /** Positions With Missing Hours */
  PositionsWithMissingHours = 'positions_with_missing_hours'
};

export interface ApplicationReadinessEmploymentResult {
  readonly __typename?: 'ApplicationReadinessEmploymentResult';
  readonly detailedMessage?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly label: Scalars['String']['output'];
  readonly message?: Maybe<Scalars['String']['output']>;
  readonly reasonsIncomplete: ReadonlyArray<ApplicationReadinessEmploymentIncompleteReason>;
  readonly status: ApplicationReadinessStatus;
}

export const enum ApplicationReadinessPersonalInformationField {
  /** birthday */
  Birthday = 'birthday',
  /** email */
  Email = 'email',
  /** first_name */
  FirstName = 'first_name',
  /** full_ssn_collected */
  FullSsnCollected = 'full_ssn_collected',
  /** last_name */
  LastName = 'last_name',
  /** phone */
  Phone = 'phone'
};

export interface ApplicationReadinessPersonalInformationResult {
  readonly __typename?: 'ApplicationReadinessPersonalInformationResult';
  readonly detailedMessage?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly incompleteFields: ReadonlyArray<ApplicationReadinessPersonalInformationField>;
  readonly label: Scalars['String']['output'];
  readonly message?: Maybe<Scalars['String']['output']>;
  /** @deprecated Feature removed - mobile version > 3.25.4 */
  readonly needsConfirmation: Scalars['Boolean']['output'];
  readonly status: ApplicationReadinessStatus;
}

export interface ApplicationReadinessReferencesResult {
  readonly __typename?: 'ApplicationReadinessReferencesResult';
  readonly completeReferenceCount: Scalars['Int']['output'];
  readonly detailedMessage?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly label: Scalars['String']['output'];
  readonly message?: Maybe<Scalars['String']['output']>;
  readonly pendingReferenceCount: Scalars['Int']['output'];
  readonly status: ApplicationReadinessStatus;
  readonly timeframe: Scalars['Int']['output'];
}

export interface ApplicationReadinessResults {
  readonly __typename?: 'ApplicationReadinessResults';
  readonly background: ApplicationReadinessBaseResult;
  readonly certifications: ApplicationReadinessBaseResult;
  readonly covidVaccination?: Maybe<ApplicationReadinessBaseResult>;
  readonly education: ApplicationReadinessBaseResult;
  readonly employment: ApplicationReadinessEmploymentResult;
  readonly fluVaccination?: Maybe<ApplicationReadinessBaseResult>;
  readonly licenses: ApplicationReadinessBaseResult;
  readonly permanentAddress: ApplicationReadinessBaseResult;
  readonly personalInformation: ApplicationReadinessPersonalInformationResult;
  readonly proofOfIdentification?: Maybe<ApplicationReadinessBaseResult>;
  readonly references: ApplicationReadinessReferencesResult;
  readonly skillsChecklist: ApplicationReadinessBaseResult;
  readonly yearsOfExperience: ApplicationReadinessYearsOfExperienceResult;
}

export interface ApplicationReadinessResultsMeta {
  readonly __typename?: 'ApplicationReadinessResultsMeta';
  readonly aboutMe: ApplicationReadinessBaseResult;
  readonly requirements: ApplicationReadinessBaseResult;
}

export const enum ApplicationReadinessStatus {
  /** Complete */
  Complete = 'complete',
  /** Incomplete */
  Incomplete = 'incomplete',
  /** Not Required */
  NotRequired = 'not_required',
  /** Pending */
  Pending = 'pending'
};

export const enum ApplicationReadinessYearsOfExperienceIncompleteReason {
  /** Missing Years Of Exp */
  MissingYearsOfExp = 'missing_years_of_exp',
  /** Missing Years Of Travel Exp */
  MissingYearsOfTravelExp = 'missing_years_of_travel_exp'
};

export interface ApplicationReadinessYearsOfExperienceResult {
  readonly __typename?: 'ApplicationReadinessYearsOfExperienceResult';
  readonly detailedMessage?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly label: Scalars['String']['output'];
  readonly message?: Maybe<Scalars['String']['output']>;
  readonly reasonsIncomplete: ReadonlyArray<ApplicationReadinessYearsOfExperienceIncompleteReason>;
  readonly status: ApplicationReadinessStatus;
}

export type ApplyToSimilarJobsResponseUnion = JobApplication | JobWithError;

export interface ApprovalFlowMissingStep {
  readonly __typename?: 'ApprovalFlowMissingStep';
  readonly flowCompleted: Scalars['Boolean']['output'];
  readonly forRoleType?: Maybe<RoleType>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly stage?: Maybe<Scalars['String']['output']>;
}

/** Autogenerated return type of ApproveComplianceListItem. */
export interface ApproveComplianceListItemPayload {
  readonly __typename?: 'ApproveComplianceListItemPayload';
  readonly complianceListItem: ComplianceListItem;
}

export interface ArchiveInvoiceBalanceAdjustmentEntryInput {
  readonly id: Scalars['ID']['input'];
  readonly invoiceBalanceId: Scalars['ID']['input'];
}

/** Autogenerated return type of ArchiveInvoiceBalanceAdjustmentEntry. */
export interface ArchiveInvoiceBalanceAdjustmentEntryPayload {
  readonly __typename?: 'ArchiveInvoiceBalanceAdjustmentEntryPayload';
  readonly invoice: Invoice;
  readonly invoiceBalanceEntry: InvoiceBalanceEntry;
}

export interface ArchiveLedgerLinkInput {
  readonly linkId: Scalars['ID']['input'];
}

/** Autogenerated return type of ArchiveLedgerLink. */
export interface ArchiveLedgerLinkPayload {
  readonly __typename?: 'ArchiveLedgerLinkPayload';
  readonly ledgerLink: LedgerLink;
}

export interface ArchivePayBonusInput {
  readonly lineItemId: Scalars['ID']['input'];
  readonly payrollId: Scalars['ID']['input'];
}

/** Autogenerated return type of ArchivePayBonus. */
export interface ArchivePayBonusPayload {
  readonly __typename?: 'ArchivePayBonusPayload';
  readonly payroll: Payroll;
}

/** Autogenerated return type of ArchivePayHoursCancellation. */
export interface ArchivePayHoursCancellationPayload {
  readonly __typename?: 'ArchivePayHoursCancellationPayload';
  readonly payHoursCancellation: PayHoursCancellation;
}

/** Autogenerated return type of ArchivePayroll. */
export interface ArchivePayrollPayload {
  readonly __typename?: 'ArchivePayrollPayload';
  readonly payroll: Payroll;
}

export interface ArchiveReason {
  readonly __typename?: 'ArchiveReason';
  readonly archiver: AdminUser;
  readonly archiverId: Scalars['String']['output'];
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly files?: Maybe<ReadonlyArray<File>>;
  readonly id: Scalars['ID']['output'];
  readonly reason: Scalars['String']['output'];
  readonly targetId: Scalars['String']['output'];
  readonly targetType: Scalars['String']['output'];
  readonly updatedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly uuid?: Maybe<Scalars['String']['output']>;
}

export interface ArchiveShiftEntryInput {
  readonly payrollId?: InputMaybe<Scalars['ID']['input']>;
  readonly shiftId: Scalars['ID']['input'];
  readonly timeEntryId?: InputMaybe<Scalars['ID']['input']>;
}

/** Autogenerated return type of ArchiveShiftEntry. */
export interface ArchiveShiftEntryPayload {
  readonly __typename?: 'ArchiveShiftEntryPayload';
  readonly payroll?: Maybe<Payroll>;
  readonly shift: Shift;
}

/** Autogenerated return type of ArchiveTimeSheetShift. */
export interface ArchiveTimeSheetShiftPayload {
  readonly __typename?: 'ArchiveTimeSheetShiftPayload';
  readonly timeSheet: TimeSheet;
}

export interface Article {
  readonly __typename?: 'Article';
  readonly authorId: Scalars['ID']['output'];
  readonly body: Scalars['String']['output'];
  readonly createdAt: Scalars['Int']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly parentId: Scalars['ID']['output'];
  readonly parentType: Scalars['String']['output'];
  readonly state: Scalars['String']['output'];
  readonly title: Scalars['String']['output'];
  readonly type: Scalars['String']['output'];
  readonly updatedAt: Scalars['Int']['output'];
  readonly url: Scalars['String']['output'];
  readonly workspaceId: Scalars['ID']['output'];
}

export interface Assessment {
  readonly __typename?: 'Assessment';
  readonly category?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly isASkillsChecklist: Scalars['Boolean']['output'];
  readonly issuingBody?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `issuingBody` */
  readonly issuing_body?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly nurseAssessment?: Maybe<NurseAssessment>;
  /** @deprecated use `nurseAssessment` */
  readonly nurse_assessment?: Maybe<NurseAssessment>;
  readonly requestable?: Maybe<Scalars['Boolean']['output']>;
  readonly uuid?: Maybe<Scalars['String']['output']>;
}

export interface AssessmentRequest {
  readonly __typename?: 'AssessmentRequest';
  readonly assessmentId: Scalars['ID']['output'];
  readonly category?: Maybe<Scalars['String']['output']>;
  readonly completedOn?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly issuingBody?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `issuingBody` */
  readonly issuing_body?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly requestedOn?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly score?: Maybe<Scalars['String']['output']>;
  readonly state?: Maybe<Scalars['String']['output']>;
  readonly uuid?: Maybe<Scalars['String']['output']>;
}

/** Autogenerated return type of AssignAdvocate. */
export interface AssignAdvocatePayload {
  readonly __typename?: 'AssignAdvocatePayload';
  readonly nurseProfile: NurseProfile;
}

/** Autogenerated return type of AssignReliasAssessments. */
export interface AssignReliasAssessmentsPayload {
  readonly __typename?: 'AssignReliasAssessmentsPayload';
  readonly nurseAssessments: ReadonlyArray<NurseAssessment>;
  readonly nurseProfile: NurseProfile;
}

export interface AuthorizationResult {
  readonly __typename?: 'AuthorizationResult';
  /** Human-readable error message */
  readonly message?: Maybe<Scalars['String']['output']>;
  /** Reasons of check failure */
  readonly reasons?: Maybe<FailureReasons>;
  /** Result of applying a policy rule */
  readonly value: Scalars['Boolean']['output'];
}

export interface AutoApplyConfigurationInput {
  readonly autoApplyPreferences?: InputMaybe<AutoApplyPreferencesInput>;
  readonly optInUser?: InputMaybe<Scalars['Boolean']['input']>;
  readonly timeOffRequests?: InputMaybe<ReadonlyArray<AutoApplyTimeOffRequestInput>>;
}

export interface AutoApplyInfo {
  readonly __typename?: 'AutoApplyInfo';
  readonly firstTime: Scalars['Boolean']['output'];
  readonly grossPayWeeklyHistogramConfiguration: GrossPayWeeklyHistogramConfiguration;
  readonly id?: Maybe<Scalars['ID']['output']>;
  readonly optIn?: Maybe<Scalars['Boolean']['output']>;
  readonly optInExpiredDismissed: Scalars['Boolean']['output'];
  readonly validations?: Maybe<AutoApplyValidations>;
}

export interface AutoApplyPreferences {
  readonly __typename?: 'AutoApplyPreferences';
  readonly broadPrefLocations?: Maybe<ReadonlyArray<BroadPrefLocations>>;
  readonly clinicalSpecialties: ReadonlyArray<ClinicalSpecialty>;
  readonly contractLengths?: Maybe<ReadonlyArray<ContractLength>>;
  readonly id?: Maybe<Scalars['ID']['output']>;
  readonly locationStrings?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly minimumWeeklyGrossPay?: Maybe<Scalars['Int']['output']>;
  readonly preferredStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly shiftLengths?: Maybe<ReadonlyArray<ShiftLength>>;
  readonly shiftPrefs?: Maybe<ReadonlyArray<ShiftType>>;
  /** @deprecated use `clinical_specialties { display_name }` */
  readonly specialtyDisplayNames?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** @deprecated use `clinical_specialties { slug }` */
  readonly specialtySlugs?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
}

export interface AutoApplyPreferencesInput {
  readonly broadPrefLocations?: InputMaybe<ReadonlyArray<BroadPrefLocations>>;
  readonly contractLengths?: InputMaybe<ReadonlyArray<ContractLength>>;
  readonly locationStrings?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly minimumWeeklyGrossPay?: InputMaybe<Scalars['Int']['input']>;
  readonly preferredStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly shiftLengths?: InputMaybe<ReadonlyArray<ShiftLength>>;
  readonly shiftPrefs?: InputMaybe<ReadonlyArray<ShiftType>>;
  readonly specialtySlugs?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}

export interface AutoApplyTimeOffRequestInput {
  readonly fromDate: Scalars['ISO8601Date']['input'];
  readonly toDate: Scalars['ISO8601Date']['input'];
}

export const enum AutoApplyValidationKindEnum {
  Info = 'info',
  Warning = 'warning'
};

export interface AutoApplyValidations {
  readonly __typename?: 'AutoApplyValidations';
  readonly kind?: Maybe<AutoApplyValidationKindEnum>;
  readonly message?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
}

export interface AutoSaveApplicationAllowedFacilitiesInput {
  readonly facilityId: Scalars['ID']['input'];
}

export interface AutoSaveApplicationInput {
  readonly allowedFacilities?: InputMaybe<ReadonlyArray<AutoSaveApplicationAllowedFacilitiesInput>>;
  readonly allowedFacilitiesShifts?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly earliestStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly hasAllowedFacilities?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasSpecialRequest?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasTimeoffRequest?: InputMaybe<Scalars['Boolean']['input']>;
  readonly interviewAvailability?: InputMaybe<Scalars['String']['input']>;
  readonly specialRequest?: InputMaybe<Scalars['String']['input']>;
  readonly timeOffRequests?: InputMaybe<ReadonlyArray<AutoSaveApplicationTimeOffRequestsInput>>;
}

export interface AutoSaveApplicationTimeOffRequestsInput {
  readonly fromDate: Scalars['ISO8601Date']['input'];
  readonly toDate: Scalars['ISO8601Date']['input'];
}

export const enum AvStatus {
  Clean = 'CLEAN',
  Infected = 'INFECTED',
  NotScanned = 'NOT_SCANNED'
};

export interface Award {
  readonly __typename?: 'Award';
  readonly awardedOn?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly descriptions: ReadonlyArray<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly organization: Scalars['String']['output'];
  readonly uuid: Scalars['String']['output'];
}

export interface BackgroundQuestionInput {
  readonly answer: Scalars['Boolean']['input'];
  readonly date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly explanation?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly licenseAffected?: InputMaybe<Scalars['Boolean']['input']>;
  readonly open?: InputMaybe<Scalars['Boolean']['input']>;
  readonly questionType: NurseBackgroundQuestionType;
}

/** Structure for bad user input errors */
export interface BadUserInputError {
  readonly __typename?: 'BadUserInputError';
  readonly argument: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
}

export interface BadgesItemsCount {
  readonly __typename?: 'BadgesItemsCount';
  readonly completionItemsCount: Scalars['Int']['output'];
  readonly credentialsCount: Scalars['Int']['output'];
  readonly favoritesCount: Scalars['Int']['output'];
  readonly id: Scalars['ID']['output'];
  readonly matchesCount: Scalars['Int']['output'];
}

export const enum BalanceOperation {
  /** Credit */
  Credit = 'credit',
  /** Debit */
  Debit = 'debit'
};

export const enum BannerSourcePageEnum {
  /** Home */
  Home = 'home',
  /** Matches */
  Matches = 'matches',
  /** Matches Alerts */
  MatchesAlerts = 'matches_alerts',
  /** Matches Filtering */
  MatchesFiltering = 'matches_filtering',
  /** Profile */
  Profile = 'profile'
};

export interface BaseTimeEntryInput {
  readonly destroy?: InputMaybe<Scalars['Boolean']['input']>;
  readonly duration?: InputMaybe<Scalars['Float']['input']>;
  readonly endSec?: InputMaybe<Scalars['Int']['input']>;
  readonly entryType?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly parentId?: InputMaybe<Scalars['String']['input']>;
  readonly startSec?: InputMaybe<Scalars['Int']['input']>;
}

/** Basic errors union structure */
export type BasicErrorsUnion = BadUserInputError | ModelValidationError | NotFoundError | RecordNotUniqueError;

export interface BillingTag {
  readonly __typename?: 'BillingTag';
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
}

export interface BoardOfNursingUrl {
  readonly __typename?: 'BoardOfNursingUrl';
  readonly state: Scalars['String']['output'];
  readonly url: Scalars['String']['output'];
}

export interface BonusRuleJobPlacementShift {
  readonly __typename?: 'BonusRuleJobPlacementShift';
  readonly additionalCriteria?: Maybe<Scalars['String']['output']>;
  readonly agreementUrl?: Maybe<Scalars['String']['output']>;
  readonly amount: Scalars['Float']['output'];
  readonly id: Scalars['ID']['output'];
  readonly payrollCriteria?: Maybe<Scalars['String']['output']>;
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly type?: Maybe<Scalars['String']['output']>;
  readonly url?: Maybe<Scalars['String']['output']>;
}

export const enum BroadPrefLocations {
  /**
   * alias for compact_states
   * @deprecated Use compact_states
   */
  Compact = 'compact',
  /** Compact States */
  CompactStates = 'compact_states',
  /** Specific Locations */
  SpecificLocations = 'specific_locations'
};

export interface BucketConfiguration {
  readonly __typename?: 'BucketConfiguration';
  readonly id: Scalars['ID']['output'];
  readonly key: Scalars['String']['output'];
  readonly locationString?: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
}

export interface BucketSummary {
  readonly __typename?: 'BucketSummary';
  readonly bucketCount?: Maybe<Scalars['Int']['output']>;
  readonly bucketHighestPay?: Maybe<Scalars['Float']['output']>;
  readonly bucketImageCssStyle?: Maybe<Scalars['String']['output']>;
  readonly bucketImageUrl?: Maybe<Scalars['String']['output']>;
  readonly bucketKey?: Maybe<Scalars['String']['output']>;
  readonly bucketName?: Maybe<Scalars['String']['output']>;
  readonly bucketSummary?: Maybe<ReadonlyArray<BucketSummaryItem>>;
  readonly bucketType?: Maybe<Scalars['String']['output']>;
  readonly bucketVisibility?: Maybe<BucketVisibilityEnum>;
  readonly id: Scalars['ID']['output'];
}

export interface BucketSummaryItem {
  readonly __typename?: 'BucketSummaryItem';
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly value?: Maybe<Scalars['String']['output']>;
  readonly valueType?: Maybe<BucketSummaryItemValue>;
}

export const enum BucketSummaryItemValue {
  /** The value should be displayed as currency */
  Currency = 'currency'
};

export const enum BucketVisibilityEnum {
  /** All */
  All = 'all',
  /** Hidden */
  Hidden = 'hidden',
  /** Visible */
  Visible = 'visible'
};

export interface Buckets {
  readonly __typename?: 'Buckets';
  readonly categories?: Maybe<ReadonlyArray<BucketSummary>>;
  readonly locations?: Maybe<ReadonlyArray<BucketSummary>>;
}

export interface BucketsDashboard {
  readonly __typename?: 'BucketsDashboard';
  readonly buckets?: Maybe<Buckets>;
}

/** A business entity in Manage */
export interface Business {
  readonly __typename?: 'Business';
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly ahaId?: Maybe<Scalars['String']['output']>;
  /** Fallback if no background image specified */
  readonly bgImageFlickrUrl?: Maybe<Scalars['String']['output']>;
  readonly businessType?: Maybe<Scalars['String']['output']>;
  readonly ccnId?: Maybe<Scalars['String']['output']>;
  readonly city?: Maybe<Scalars['String']['output']>;
  /** The currently active compliance checklist */
  readonly complianceChecklist?: Maybe<ComplianceChecklist>;
  /** All compliance checklists, current and past */
  readonly complianceChecklists: ReadonlyArray<ComplianceChecklist>;
  readonly county?: Maybe<Scalars['String']['output']>;
  readonly dhcFirmType?: Maybe<Scalars['String']['output']>;
  readonly dhcId?: Maybe<Scalars['String']['output']>;
  readonly dhcProviderWebsite?: Maybe<Scalars['String']['output']>;
  readonly flickrAppUrl?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly jobsPageUrl?: Maybe<Scalars['String']['output']>;
  readonly latitude?: Maybe<Scalars['Float']['output']>;
  readonly longitude?: Maybe<Scalars['Float']['output']>;
  readonly name: Scalars['String']['output'];
  readonly npiId?: Maybe<Scalars['Int']['output']>;
  readonly phone?: Maybe<Scalars['String']['output']>;
  readonly sfdcId?: Maybe<Scalars['String']['output']>;
  readonly sfdcRecordTypeId?: Maybe<Scalars['String']['output']>;
  readonly slug?: Maybe<Scalars['String']['output']>;
  readonly state?: Maybe<Scalars['String']['output']>;
  readonly tkDirectInvoicingRequired?: Maybe<Scalars['String']['output']>;
  readonly updatedFromSfdcAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly zipcode?: Maybe<Scalars['String']['output']>;
}

export interface BusinessPackage {
  readonly __typename?: 'BusinessPackage';
  readonly business: Business;
  readonly durationMonths?: Maybe<Scalars['Int']['output']>;
  readonly eligibilityDays?: Maybe<Scalars['Int']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly package: Package;
  readonly packageType: Scalars['String']['output'];
}

/** Autogenerated return type of CancelVmsReverseInvoiceItem. */
export interface CancelVmsReverseInvoiceItemPayload {
  readonly __typename?: 'CancelVmsReverseInvoiceItemPayload';
  readonly vmsReverseInvoiceItem: VmsReverseInvoiceItem;
}

export interface CandidateJobApplications {
  readonly __typename?: 'CandidateJobApplications';
  readonly activelyInterviewing: JobApplicationConnection;
  readonly started: JobApplicationConnection;
}


export interface CandidateJobApplicationsActivelyInterviewingArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface CandidateJobApplicationsStartedArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface CandidateJobs {
  readonly __typename?: 'CandidateJobs';
  readonly availableFavorited: JobsConnection;
  readonly availableFavoritedTotalCount: Scalars['Int']['output'];
  readonly availablePassed: JobsConnection;
  readonly unavailableFavorited: JobsConnection;
  readonly unavailableFavoritedTotalCount: Scalars['Int']['output'];
  readonly unavailablePassed: JobsConnection;
}


export interface CandidateJobsAvailableFavoritedArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface CandidateJobsAvailablePassedArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface CandidateJobsUnavailableFavoritedArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface CandidateJobsUnavailablePassedArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface CandidateMatchBucket {
  readonly __typename?: 'CandidateMatchBucket';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly image: MatchBucketImage;
  readonly matchesCount: Scalars['Int']['output'];
  readonly slug: Scalars['ID']['output'];
  readonly title: Scalars['String']['output'];
  readonly weeklySalaryRange?: Maybe<FloatRange>;
}

export interface CandidateRequestedJobs {
  readonly __typename?: 'CandidateRequestedJobs';
  readonly activelyInterviewing?: Maybe<CandidateRequestedJobsConnection>;
  readonly drafted?: Maybe<CandidateRequestedJobsConnection>;
  readonly inProgressInstantOffers?: Maybe<CandidateRequestedJobsConnection>;
  readonly pending?: Maybe<CandidateRequestedJobsConnection>;
  readonly rejected?: Maybe<CandidateRequestedJobsConnection>;
  readonly started?: Maybe<CandidateRequestedJobsConnection>;
}


export interface CandidateRequestedJobsActivelyInterviewingArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface CandidateRequestedJobsDraftedArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface CandidateRequestedJobsInProgressInstantOffersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface CandidateRequestedJobsPendingArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface CandidateRequestedJobsRejectedArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface CandidateRequestedJobsStartedArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for Job. */
export interface CandidateRequestedJobsConnection {
  readonly __typename?: 'CandidateRequestedJobsConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<CandidateRequestedJobsEdge>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Job>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface CandidateRequestedJobsEdge {
  readonly __typename?: 'CandidateRequestedJobsEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Job>;
}

export interface CaseServiceOrder {
  readonly __typename?: 'CaseServiceOrder';
  readonly finishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly isPending: Scalars['Boolean']['output'];
  readonly secondaryStatus?: Maybe<Scalars['String']['output']>;
  readonly status: Scalars['String']['output'];
}

export interface Certification {
  readonly __typename?: 'Certification';
  readonly completeTitle?: Maybe<Scalars['ID']['output']>;
  readonly credential?: Maybe<Scalars['String']['output']>;
  readonly expiresOn?: Maybe<Scalars['ISO8601Date']['output']>;
  /** @deprecated use `expiresOn` */
  readonly expires_on?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly issuingBodies: ReadonlyArray<Scalars['String']['output']>;
  /** @deprecated use `issuingBodies` */
  readonly issuingBody?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `issuingBodies` */
  readonly issuing_body?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly nurseCertificationUuid?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `nurseCertificationUuid` */
  readonly nurse_certification_uuid?: Maybe<Scalars['String']['output']>;
  readonly useCompletionDate?: Maybe<Scalars['Boolean']['output']>;
  readonly uuid?: Maybe<Scalars['String']['output']>;
}

export interface CeuCertificate {
  readonly __typename?: 'CeuCertificate';
  readonly ceuCertificateType: CeuCertificateType;
  readonly ceuGoals: ReadonlyArray<CeuGoal>;
  readonly completionDate: Scalars['ISO8601Date']['output'];
  readonly contactHours: Scalars['Float']['output'];
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly files: ReadonlyArray<File>;
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly nurseProfile?: Maybe<NurseProfile>;
  readonly providerNumber: Scalars['String']['output'];
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** An edge in a connection. */
export interface CeuCertificateEdge {
  readonly __typename?: 'CeuCertificateEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<CeuCertificate>;
}

export const enum CeuCertificateType {
  /** Conference */
  Conference = 'CONFERENCE',
  /** Course */
  Course = 'COURSE',
  /** Degree */
  Degree = 'DEGREE'
};

/** The connection type for CeuCertificate. */
export interface CeuCertificatesConnection {
  readonly __typename?: 'CeuCertificatesConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<CeuCertificateEdge>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<CeuCertificate>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
}

export interface CeuGoal {
  readonly __typename?: 'CeuGoal';
  readonly accepted: Scalars['Boolean']['output'];
  readonly ceuCertificates: ReadonlyArray<CeuCertificate>;
  readonly ceuStateRequirement?: Maybe<CeuStateRequirement>;
  readonly completedContactHours: Scalars['Float']['output'];
  readonly deleted: Scalars['Boolean']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly goalType?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly license?: Maybe<License>;
  readonly nurseProfile: NurseProfile;
  readonly requiredContactHours: Scalars['Float']['output'];
  readonly startDate: Scalars['ISO8601Date']['output'];
  readonly systemCreated: Scalars['Boolean']['output'];
}

export interface CeuStateRequirement {
  readonly __typename?: 'CeuStateRequirement';
  readonly durationDays?: Maybe<Scalars['Int']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly licenseType?: Maybe<Scalars['String']['output']>;
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly requiredContactHours?: Maybe<Scalars['Float']['output']>;
  readonly requirementDescription?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly requirementQuantity?: Maybe<Scalars['Int']['output']>;
  readonly state: Scalars['String']['output'];
  readonly stateBonUrl?: Maybe<Scalars['String']['output']>;
}

export const enum ChangeAction {
  Added = 'ADDED',
  Changed = 'CHANGED',
  Removed = 'REMOVED'
};

export interface ChangeDiff {
  readonly __typename?: 'ChangeDiff';
  readonly attribute: Scalars['String']['output'];
  readonly newValue: Scalars['String']['output'];
  readonly oldValue: Scalars['String']['output'];
}

export interface ChangeRecord {
  readonly __typename?: 'ChangeRecord';
  readonly action: ChangeAction;
  readonly actorAvatar: ActorAvatar;
  readonly actorName: Scalars['String']['output'];
  readonly changes: ReadonlyArray<ChangeDiff>;
  readonly id: Scalars['Int']['output'];
  readonly itemDescription?: Maybe<Scalars['String']['output']>;
  readonly itemId: Scalars['Int']['output'];
  readonly itemName: Scalars['String']['output'];
  readonly itemTitle?: Maybe<Scalars['String']['output']>;
  readonly itemType: Scalars['String']['output'];
  readonly timestamp: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for ChangeRecord. */
export interface ChangeRecordConnection {
  readonly __typename?: 'ChangeRecordConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ChangeRecordEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<ChangeRecord>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface ChangeRecordEdge {
  readonly __typename?: 'ChangeRecordEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<ChangeRecord>;
}

/** Autogenerated return type of CheckSmsVerificationCode. */
export interface CheckSmsVerificationCodePayload {
  readonly __typename?: 'CheckSmsVerificationCodePayload';
  readonly user: User;
}

/** Autogenerated return type of ClearUnavailableFavoritedMatches. */
export interface ClearUnavailableFavoritedMatchesPayload {
  readonly __typename?: 'ClearUnavailableFavoritedMatchesPayload';
  readonly jobs: ReadonlyArray<Job>;
}

/** Autogenerated return type of ClearUnavailablePassedMatches. */
export interface ClearUnavailablePassedMatchesPayload {
  readonly __typename?: 'ClearUnavailablePassedMatchesPayload';
  readonly jobs: ReadonlyArray<Job>;
}

/** Autogenerated return type of ClearUnavailableRequestedMatches. */
export interface ClearUnavailableRequestedMatchesPayload {
  readonly __typename?: 'ClearUnavailableRequestedMatchesPayload';
  readonly jobs: ReadonlyArray<Job>;
}

export interface ClinicalExperience {
  readonly __typename?: 'ClinicalExperience';
  readonly clinicalSpecialty?: Maybe<ClinicalSpecialty>;
  readonly displayName?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `displayName` */
  readonly display_name?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly isPrimary?: Maybe<Scalars['Boolean']['output']>;
  readonly patientPop?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `patientPop` */
  readonly patient_pop?: Maybe<Scalars['String']['output']>;
  readonly slug?: Maybe<Scalars['String']['output']>;
  readonly specialty?: Maybe<Scalars['String']['output']>;
  readonly uuid?: Maybe<Scalars['String']['output']>;
  readonly yearsOfExp?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use `yearsOfExp` */
  readonly years_of_exp?: Maybe<Scalars['Int']['output']>;
}

export const enum ClinicalExperienceLevelTypes {
  /** Experienced */
  Experienced = 'experienced',
  /** Experienced Traveler */
  ExperiencedTraveler = 'experienced_traveler',
  /** Newbie */
  Newbie = 'newbie'
};

export interface ClinicalPosition {
  readonly __typename?: 'ClinicalPosition';
  readonly displayName?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `displayName` */
  readonly display_name?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly uuid?: Maybe<Scalars['String']['output']>;
}

export interface ClinicalSpecialty {
  readonly __typename?: 'ClinicalSpecialty';
  readonly clinicalUnits?: Maybe<ReadonlyArray<ClinicalUnit>>;
  readonly displayName: Scalars['String']['output'];
  readonly fullName?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly ignored?: Maybe<Scalars['Boolean']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly nicu: Scalars['Boolean']['output'];
  readonly pediatric: Scalars['Boolean']['output'];
  readonly slug: Scalars['String']['output'];
  readonly specialty?: Maybe<Scalars['String']['output']>;
  readonly uuid: Scalars['String']['output'];
}

/** The connection type for ClinicalSpecialty. */
export interface ClinicalSpecialtyConnection {
  readonly __typename?: 'ClinicalSpecialtyConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ClinicalSpecialtyEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<ClinicalSpecialty>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface ClinicalSpecialtyEdge {
  readonly __typename?: 'ClinicalSpecialtyEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<ClinicalSpecialty>;
}

export interface ClinicalUnit {
  readonly __typename?: 'ClinicalUnit';
  /** suggested specialties for unit */
  readonly clinicalSpecialties?: Maybe<ReadonlyArray<ClinicalSpecialty>>;
  /** default specialties for unit */
  readonly defaultClinicalSpecialties?: Maybe<ReadonlyArray<ClinicalSpecialty>>;
  readonly displayName: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  /** Job application requirements for the unit */
  readonly jobApplicationRequirements?: Maybe<ReadonlyArray<JobApplicationRequirement>>;
  /** other specialties for unit */
  readonly otherClinicalSpecialties: ReadonlyArray<ClinicalSpecialty>;
  /** primary specialties for unit */
  readonly primaryClinicalSpecialties: ReadonlyArray<ClinicalSpecialty>;
  readonly slug: Scalars['String']['output'];
  readonly synonyms: ReadonlyArray<Scalars['String']['output']>;
  readonly uuid: Scalars['String']['output'];
}

/** The connection type for ClinicalUnit. */
export interface ClinicalUnitConnection {
  readonly __typename?: 'ClinicalUnitConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ClinicalUnitEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<ClinicalUnit>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface ClinicalUnitEdge {
  readonly __typename?: 'ClinicalUnitEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<ClinicalUnit>;
}

export const enum ClinicalUnitOrderField {
  DisplayName = 'DISPLAY_NAME'
};

export interface ClinicalUnitsOrderBy {
  readonly direction: OrderDirection;
  readonly field: ClinicalUnitOrderField;
}

export interface ClinicianCredentialsOverview {
  readonly __typename?: 'ClinicianCredentialsOverview';
  readonly credentialCategories?: Maybe<ReadonlyArray<CredentialCategory>>;
  readonly credentialExpiredCount: Scalars['Int']['output'];
  readonly credentialExpiringCount: Scalars['Int']['output'];
  readonly credentialTotalCount: Scalars['Int']['output'];
  readonly credentialsNeedAttention?: Maybe<ReadonlyArray<CredentialDocumentUnion>>;
  readonly id: Scalars['ID']['output'];
}

export interface ClinicianIntent {
  readonly __typename?: 'ClinicianIntent';
  readonly availableOnDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly intent?: Maybe<IntentEnum>;
  readonly status?: Maybe<IntentStatusEnum>;
}

export interface Collection {
  readonly __typename?: 'Collection';
  readonly createdAt: Scalars['Int']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly icon: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly order: Scalars['Int']['output'];
  readonly type: Scalars['String']['output'];
  readonly updatedAt: Scalars['Int']['output'];
  readonly url: Scalars['String']['output'];
  readonly workspaceId: Scalars['ID']['output'];
}

export interface College {
  readonly __typename?: 'College';
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly location?: Maybe<Scalars['String']['output']>;
  readonly locationId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use `locationId` */
  readonly location_id?: Maybe<Scalars['Int']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly placeId?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `placeId` */
  readonly place_id?: Maybe<Scalars['String']['output']>;
}

/** Autogenerated return type of CompleteOnboardingList. */
export interface CompleteOnboardingListPayload {
  readonly __typename?: 'CompleteOnboardingListPayload';
  readonly todoList: TodoList;
}

export interface CompletionBonusAdjustment {
  readonly __typename?: 'CompletionBonusAdjustment';
  readonly amount: Scalars['Float']['output'];
  readonly breakdown: ReadonlyArray<CompletionBonusAdjustmentBreakdown>;
  readonly doubleTimeAmount: Scalars['Float']['output'];
  readonly overtimeAmount: Scalars['Float']['output'];
}

export interface CompletionBonusAdjustmentBreakdown {
  readonly __typename?: 'CompletionBonusAdjustmentBreakdown';
  readonly amount: Scalars['Float']['output'];
  readonly doubleTimeDelta: Scalars['Float']['output'];
  readonly doubleTimeHours: Scalars['Float']['output'];
  readonly doubleTimeRate: Scalars['Float']['output'];
  readonly overtimeDelta: Scalars['Float']['output'];
  readonly overtimeHours: Scalars['Float']['output'];
  readonly overtimeRate: Scalars['Float']['output'];
  readonly payrollId?: Maybe<Scalars['ID']['output']>;
  readonly regularHours: Scalars['Float']['output'];
  readonly weekEndingDate: Scalars['ISO8601Date']['output'];
  readonly workedHours: Scalars['Float']['output'];
}

/** A class that links to an uploaded compliance checklist file */
export interface ComplianceChecklist {
  readonly __typename?: 'ComplianceChecklist';
  readonly business: Business;
  /** The compliance checklist file */
  readonly checklistFile: File;
  /** The admin user that uploaded the checklist */
  readonly createdBy: AdminUser;
  /** The date this checklist became effective */
  readonly effectiveDate: Scalars['ISO8601Date']['output'];
  readonly id: Scalars['ID']['output'];
  /** The admin user that most recently modified this checklist */
  readonly updatedBy: AdminUser;
}

export interface ComplianceList {
  readonly __typename?: 'ComplianceList';
  readonly allTasksCount: Scalars['Int']['output'];
  readonly candidate?: Maybe<NurseProfile>;
  /** Returns history of changes */
  readonly changesHistoryConnection: ChangeRecordConnection;
  readonly completedTasksCount: Scalars['Int']['output'];
  readonly complianceStatus?: Maybe<Scalars['String']['output']>;
  readonly complianceStatusHumanize?: Maybe<Scalars['String']['output']>;
  readonly daysUntilExpiration?: Maybe<Scalars['Int']['output']>;
  readonly expiresOn?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly expiringTasksCount: Scalars['Int']['output'];
  readonly facilityChecklistFile?: Maybe<File>;
  readonly healthSystemChecklistFile?: Maybe<File>;
  readonly id: Scalars['ID']['output'];
  readonly internalNotes?: Maybe<Scalars['String']['output']>;
  readonly isCompliant?: Maybe<Scalars['Boolean']['output']>;
  readonly items: ReadonlyArray<ComplianceListItem>;
  readonly jobPlacement?: Maybe<JobPlacement>;
  readonly nurseProfile?: Maybe<NurseProfile>;
  readonly onboardingList?: Maybe<TodoList>;
  readonly onboardingListId?: Maybe<Scalars['Int']['output']>;
  readonly onboardingOwner?: Maybe<AdminUser>;
  readonly owner?: Maybe<AdminUser>;
  readonly pendingTasksCount: Scalars['Int']['output'];
  readonly tasksPendingActionCount: Scalars['Int']['output'];
}


export interface ComplianceListChangesHistoryConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface ComplianceListCollection {
  readonly __typename?: 'ComplianceListCollection';
  readonly records: ReadonlyArray<ComplianceList>;
  readonly totalRecords: Scalars['Int']['output'];
}

export interface ComplianceListFiltersInput {
  readonly candidateId?: InputMaybe<Scalars['String']['input']>;
  readonly city?: InputMaybe<Scalars['String']['input']>;
  readonly complianceStatus?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly facilityId?: InputMaybe<Scalars['String']['input']>;
  readonly mspVms?: InputMaybe<Scalars['String']['input']>;
  readonly ownerId?: InputMaybe<Scalars['String']['input']>;
  readonly placementStatus?: InputMaybe<Scalars['String']['input']>;
  readonly startDateFrom?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly startDateTo?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly stateCode?: InputMaybe<Scalars['String']['input']>;
  readonly withPendingTasks?: InputMaybe<Scalars['String']['input']>;
  readonly withTasksMissingCredentialData?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface ComplianceListItem {
  readonly __typename?: 'ComplianceListItem';
  readonly actionLinks: ReadonlyArray<ActionLink>;
  readonly archiveReasons?: Maybe<ReadonlyArray<ArchiveReason>>;
  readonly archivedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly canBeApproved: Scalars['Boolean']['output'];
  readonly canBeRejected: Scalars['Boolean']['output'];
  readonly canBeSubmitted: Scalars['Boolean']['output'];
  readonly candidateNotes?: Maybe<Scalars['String']['output']>;
  readonly completedOn?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly complianceStatus?: Maybe<Scalars['String']['output']>;
  readonly complianceStatusHumanize?: Maybe<Scalars['String']['output']>;
  readonly currentArchiveReason?: Maybe<ArchiveReason>;
  readonly daysToExpiry?: Maybe<Scalars['Int']['output']>;
  readonly daysUntilExpiration?: Maybe<Scalars['Int']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly expirationType?: Maybe<DocumentExpiration>;
  readonly expiresOn?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly expiresSoon?: Maybe<Scalars['Boolean']['output']>;
  readonly files?: Maybe<ReadonlyArray<File>>;
  readonly hasTarget: Scalars['Boolean']['output'];
  readonly humanDocumentSubtype?: Maybe<Scalars['String']['output']>;
  readonly humanDocumentType?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly internalNotes?: Maybe<Scalars['String']['output']>;
  readonly internalOnly?: Maybe<Scalars['Boolean']['output']>;
  readonly isCompliant?: Maybe<Scalars['Boolean']['output']>;
  readonly isExpirable?: Maybe<Scalars['Boolean']['output']>;
  readonly isExpired?: Maybe<Scalars['Boolean']['output']>;
  readonly isVerificationAlwaysRequired: Scalars['Boolean']['output'];
  readonly itemType?: Maybe<ComplianceListItemType>;
  readonly license?: Maybe<License>;
  readonly list: ComplianceList;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly nurseAssessmentTarget?: Maybe<NurseAssessment>;
  readonly nurseHealthDocTarget?: Maybe<NurseHealthDoc>;
  readonly order?: Maybe<Scalars['Int']['output']>;
  readonly outreach?: Maybe<ComplianceOutreach>;
  readonly requiresVerification?: Maybe<Scalars['Boolean']['output']>;
  readonly section?: Maybe<ComplianceListSection>;
  readonly status: ComplianceListItemStatus;
  readonly target?: Maybe<Credential>;
  readonly targetArchivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly trackCompletionDate?: Maybe<Scalars['Boolean']['output']>;
  readonly verificationNotes?: Maybe<Scalars['String']['output']>;
  readonly visibility?: Maybe<Scalars['String']['output']>;
}

export const enum ComplianceListItemStatus {
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED',
  Submitted = 'SUBMITTED'
};

export const enum ComplianceListItemType {
  /** Background Document */
  BackgroundDocument = 'BACKGROUND_DOCUMENT',
  /** Other Document */
  Document = 'DOCUMENT',
  /** Identity Document */
  IdentityDocument = 'IDENTITY_DOCUMENT',
  /** License */
  License = 'LICENSE',
  /** Nurse Assessment */
  NurseAssessment = 'NURSE_ASSESSMENT',
  /** Nurse Certification */
  NurseCertification = 'NURSE_CERTIFICATION',
  /** Nurse Health Doc */
  NurseHealthDoc = 'NURSE_HEALTH_DOC',
  /** Nurse License Verification */
  NurseLicenseVerification = 'NURSE_LICENSE_VERIFICATION'
};

export const enum ComplianceListSection {
  /** Pending Candidate Action */
  PendingCandidateAction = 'PENDING_CANDIDATE_ACTION',
  /** Pending Verification */
  PendingVerification = 'PENDING_VERIFICATION',
  /** Renewed */
  Renewed = 'RENEWED'
};

export const enum ComplianceListSortField {
  CompletedTasksCount = 'COMPLETED_TASKS_COUNT',
  DaysUntilExpiration = 'DAYS_UNTIL_EXPIRATION',
  EndDate = 'END_DATE',
  Id = 'ID',
  OwnerName = 'OWNER_NAME',
  PendingTasksCount = 'PENDING_TASKS_COUNT',
  StartDate = 'START_DATE'
};

export interface ComplianceListSortInput {
  readonly direction?: InputMaybe<OrderDirection>;
  readonly field?: InputMaybe<ComplianceListSortField>;
}

export interface ComplianceListStats {
  readonly __typename?: 'ComplianceListStats';
  readonly all: Scalars['Int']['output'];
  readonly complete: Scalars['Int']['output'];
  readonly compliant: Scalars['Int']['output'];
  readonly expired: Scalars['Int']['output'];
  readonly pending: Scalars['Int']['output'];
  readonly withPendingTasks: Scalars['Int']['output'];
}

export const enum ComplianceOutreach {
  /** Contacted */
  Contacted = 'CONTACTED',
  /** In Progress */
  InProgress = 'IN_PROGRESS',
  /** Lapsed */
  Lapsed = 'LAPSED',
  /** None */
  None = 'NONE',
  /** Renewed */
  Renewed = 'RENEWED'
};

export interface ConfirmUserEmailInput {
  readonly confirmationToken: Scalars['String']['input'];
}

/** Autogenerated return type of ConfirmUserEmail. */
export interface ConfirmUserEmailPayload {
  readonly __typename?: 'ConfirmUserEmailPayload';
  readonly user: User;
}

/** Autogenerated return type of ConfirmVmsReverseInvoiceItemContract. */
export interface ConfirmVmsReverseInvoiceItemContractPayload {
  readonly __typename?: 'ConfirmVmsReverseInvoiceItemContractPayload';
  readonly invoiceBalanceEntry: InvoiceBalanceEntry;
}

export interface Contract {
  readonly __typename?: 'Contract';
  readonly baseRate?: Maybe<Scalars['Float']['output']>;
  readonly cancellationPolicy?: Maybe<Scalars['String']['output']>;
  readonly cancellationPolicyHoursLimit?: Maybe<Scalars['Float']['output']>;
  readonly contractEndDate: Scalars['ISO8601Date']['output'];
  readonly contractNotes?: Maybe<Scalars['String']['output']>;
  readonly contractStartDate: Scalars['ISO8601Date']['output'];
  readonly contractStatus?: Maybe<Scalars['String']['output']>;
  readonly contractType?: Maybe<Scalars['String']['output']>;
  readonly contractedHours?: Maybe<Scalars['Int']['output']>;
  readonly currentGrossPayWeek?: Maybe<Scalars['Float']['output']>;
  readonly disputesWindowDays?: Maybe<Scalars['Int']['output']>;
  readonly docusignSignUrl?: Maybe<Scalars['String']['output']>;
  readonly effectiveAmendmentStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly effectiveEndDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly facility?: Maybe<Facility>;
  readonly files?: Maybe<ReadonlyArray<File>>;
  readonly helloworksCompletedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly hoursPerShift?: Maybe<Scalars['Int']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly isLocal?: Maybe<Scalars['Boolean']['output']>;
  readonly job: Job;
  readonly jobApplication?: Maybe<JobApplication>;
  readonly jobOffer?: Maybe<JobOffer>;
  readonly jobPlacement?: Maybe<JobPlacement>;
  readonly lengthInWeeks?: Maybe<Scalars['Float']['output']>;
  readonly mspName?: Maybe<Scalars['String']['output']>;
  readonly numericId: Scalars['ID']['output'];
  readonly paidLeaveRules?: Maybe<PaidLeaveRules>;
  readonly paymentDetails?: Maybe<JobPaymentDetails>;
  readonly program?: Maybe<Program>;
  readonly rateConfig?: Maybe<PayRateConfig>;
  readonly shiftType?: Maybe<Scalars['String']['output']>;
  readonly shiftsPerWeek?: Maybe<Scalars['Int']['output']>;
  readonly timeOffs?: Maybe<ReadonlyArray<TimeOff>>;
  readonly vmsName?: Maybe<Scalars['String']['output']>;
}

export interface ContractBonus {
  readonly __typename?: 'ContractBonus';
  readonly amount: Scalars['Float']['output'];
  readonly bonusAdjustment?: Maybe<ContractBonusAdjustment>;
  readonly clinician?: Maybe<NurseProfile>;
  readonly contract: Contract;
  readonly id: Scalars['ID']['output'];
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly source?: Maybe<Scalars['String']['output']>;
  readonly status: Scalars['String']['output'];
  readonly type: Scalars['String']['output'];
}

export type ContractBonusAdjustment = CompletionBonusAdjustment;

/** The connection type for ContractBonus. */
export interface ContractBonusConnection {
  readonly __typename?: 'ContractBonusConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ContractBonusEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<ContractBonus>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface ContractBonusEdge {
  readonly __typename?: 'ContractBonusEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<ContractBonus>;
}

export interface ContractBonusInput {
  readonly amount?: InputMaybe<Scalars['Float']['input']>;
  readonly notes?: InputMaybe<Scalars['String']['input']>;
}

export interface ContractBonusSortInput {
  readonly direction?: InputMaybe<Scalars['String']['input']>;
  readonly field?: InputMaybe<Scalars['String']['input']>;
}

export interface ContractBonusStatusSummary {
  readonly __typename?: 'ContractBonusStatusSummary';
  readonly approved: Scalars['Int']['output'];
  readonly pendingApproval: Scalars['Int']['output'];
  readonly processed: Scalars['Int']['output'];
  readonly refused: Scalars['Int']['output'];
  readonly upcoming: Scalars['Int']['output'];
}

export interface ContractByNurseProfile {
  readonly __typename?: 'ContractByNurseProfile';
  readonly contracts: ReadonlyArray<ContractWithInvoiceData>;
  readonly errors: ReadonlyArray<BasicErrorsUnion>;
}

export const enum ContractLength {
  /** 14+ */
  FourteenPlus = 'fourteen_plus',
  /** 1-6 */
  OneSix = 'one_six',
  /** 7-12 */
  SevenTwelve = 'seven_twelve',
  /** 13 */
  Thirteen = 'thirteen'
};

export interface ContractPayrollReviewHistory {
  readonly __typename?: 'ContractPayrollReviewHistory';
  readonly history: ReadonlyArray<PayrollReview>;
  readonly payrollId: Scalars['ID']['output'];
  readonly weekEnding: Scalars['ISO8601Date']['output'];
}

export interface ContractWithInvoiceData {
  readonly __typename?: 'ContractWithInvoiceData';
  readonly baseRate?: Maybe<Scalars['Float']['output']>;
  readonly cancellationPolicy?: Maybe<Scalars['String']['output']>;
  readonly cancellationPolicyHoursLimit?: Maybe<Scalars['Float']['output']>;
  readonly contract: Contract;
  readonly contractEndDate: Scalars['ISO8601Date']['output'];
  readonly contractNotes?: Maybe<Scalars['String']['output']>;
  readonly contractStartDate: Scalars['ISO8601Date']['output'];
  readonly contractStatus?: Maybe<Scalars['String']['output']>;
  readonly contractType?: Maybe<Scalars['String']['output']>;
  readonly contractedHours?: Maybe<Scalars['Int']['output']>;
  readonly currentGrossPayWeek?: Maybe<Scalars['Float']['output']>;
  readonly disputesWindowDays?: Maybe<Scalars['Int']['output']>;
  readonly docusignSignUrl?: Maybe<Scalars['String']['output']>;
  readonly effectiveAmendmentStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly effectiveEndDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly facility?: Maybe<Facility>;
  readonly files?: Maybe<ReadonlyArray<File>>;
  readonly helloworksCompletedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly hoursPerShift?: Maybe<Scalars['Int']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly invoiceId?: Maybe<Scalars['ID']['output']>;
  readonly invoiceNumericId?: Maybe<Scalars['ID']['output']>;
  readonly isLocal?: Maybe<Scalars['Boolean']['output']>;
  readonly job: Job;
  readonly jobApplication?: Maybe<JobApplication>;
  readonly jobOffer?: Maybe<JobOffer>;
  readonly jobPlacement?: Maybe<JobPlacement>;
  readonly lengthInWeeks?: Maybe<Scalars['Float']['output']>;
  readonly mspName?: Maybe<Scalars['String']['output']>;
  readonly numericId: Scalars['ID']['output'];
  readonly paidLeaveRules?: Maybe<PaidLeaveRules>;
  readonly paymentDetails?: Maybe<JobPaymentDetails>;
  readonly program?: Maybe<Program>;
  readonly rateConfig?: Maybe<PayRateConfig>;
  readonly shiftType?: Maybe<Scalars['String']['output']>;
  readonly shiftsPerWeek?: Maybe<Scalars['Int']['output']>;
  readonly timeOffs?: Maybe<ReadonlyArray<TimeOff>>;
  readonly vmsName?: Maybe<Scalars['String']['output']>;
}

export const enum ContractsFilter {
  PendingSignature = 'pending_signature'
};

export interface ContractsUserPermissions {
  readonly __typename?: 'ContractsUserPermissions';
  readonly contractBonus: ReadonlyArray<Scalars['String']['output']>;
}

export const enum CountryPermanentEnum {
  /** Canada */
  Ca = 'ca',
  /** Mexico */
  Mx = 'mx',
  /** United States of America */
  Us = 'us'
};

export interface CovidLeaveHoursInput {
  readonly hours: Scalars['Float']['input'];
  readonly slot: Scalars['Int']['input'];
}

export interface CreateAffiliationHistoryInput {
  readonly descriptions?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly endDate?: InputMaybe<Scalars['String']['input']>;
  readonly organizationName: Scalars['String']['input'];
  readonly role: Scalars['String']['input'];
  readonly startDate: Scalars['String']['input'];
}

/** Autogenerated return type of CreateAffiliationHistory. */
export interface CreateAffiliationHistoryPayload {
  readonly __typename?: 'CreateAffiliationHistoryPayload';
  readonly nurseProfile: NurseProfile;
}

export interface CreateAssessmentOnboardingItemInput {
  readonly actionsAttributes?: InputMaybe<ReadonlyArray<ActionLinkTypeInput>>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly requiresVerification?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Autogenerated return type of CreateAssessmentOnboardingItem. */
export interface CreateAssessmentOnboardingItemPayload {
  readonly __typename?: 'CreateAssessmentOnboardingItemPayload';
  readonly todoList: TodoList;
  readonly todoListItem: TodoListItem;
}

export interface CreateAwardInput {
  readonly awardedOn?: InputMaybe<Scalars['String']['input']>;
  readonly descriptions?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly name: Scalars['String']['input'];
  readonly organization: Scalars['String']['input'];
}

/** Autogenerated return type of CreateAward. */
export interface CreateAwardPayload {
  readonly __typename?: 'CreateAwardPayload';
  readonly nurseProfile: NurseProfile;
}

export interface CreateCertificationOnboardingItemInput {
  readonly actionsAttributes?: InputMaybe<ReadonlyArray<ActionLinkTypeInput>>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly requiresVerification?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Autogenerated return type of CreateCertificationOnboardingItem. */
export interface CreateCertificationOnboardingItemPayload {
  readonly __typename?: 'CreateCertificationOnboardingItemPayload';
  readonly todoList: TodoList;
  readonly todoListItem: TodoListItem;
}

export interface CreateCeuCertificateInput {
  readonly ceuCertificateType: CeuCertificateType;
  readonly completionDate: Scalars['ISO8601Date']['input'];
  readonly contactHours: Scalars['Float']['input'];
  readonly name: Scalars['String']['input'];
  readonly providerNumber: Scalars['String']['input'];
}

/** Autogenerated return type of CreateCeuCertificate. */
export interface CreateCeuCertificatePayload {
  readonly __typename?: 'CreateCeuCertificatePayload';
  readonly ceuCertificate: CeuCertificate;
  readonly nurseProfile: NurseProfile;
}

export interface CreateCeuGoalInput {
  readonly certificateUuids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly ceuStateRequirementId?: InputMaybe<Scalars['ID']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly endDate: Scalars['ISO8601Date']['input'];
  readonly requiredContactHours: Scalars['Float']['input'];
  readonly startDate: Scalars['ISO8601Date']['input'];
}

/** Autogenerated return type of CreateCeuGoal. */
export interface CreateCeuGoalPayload {
  readonly __typename?: 'CreateCeuGoalPayload';
  readonly ceuGoal: CeuGoal;
  readonly nurseProfile: NurseProfile;
}

/** Autogenerated return type of CreateClinicianProfile. */
export interface CreateClinicianProfilePayload {
  readonly __typename?: 'CreateClinicianProfilePayload';
  readonly nurseProfile?: Maybe<NurseProfile>;
  readonly user?: Maybe<User>;
}

export interface CreateComplianceChecklistInput {
  readonly checklistFile: Scalars['Upload']['input'];
  readonly effectiveDate: Scalars['ISO8601Date']['input'];
}

/** Autogenerated return type of CreateComplianceChecklist. */
export interface CreateComplianceChecklistPayload {
  readonly __typename?: 'CreateComplianceChecklistPayload';
  readonly complianceChecklist: ComplianceChecklist;
}

export interface CreateComplianceItemArchiveReasonInput {
  readonly reason: Scalars['String']['input'];
}

/** Autogenerated return type of CreateComplianceItemArchiveReason. */
export interface CreateComplianceItemArchiveReasonPayload {
  readonly __typename?: 'CreateComplianceItemArchiveReasonPayload';
  readonly archiveReason?: Maybe<ArchiveReason>;
  readonly complianceListItem?: Maybe<TodoListItem>;
}

export interface CreateComplianceListItemInput {
  readonly actionLinks?: InputMaybe<ReadonlyArray<ActionLinkTypeInput>>;
  readonly assessmentUuid?: InputMaybe<Scalars['String']['input']>;
  readonly certificationUuid?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly docSubtype?: InputMaybe<Scalars['String']['input']>;
  readonly docType?: InputMaybe<Scalars['String']['input']>;
  readonly healthDocCategory?: InputMaybe<Scalars['String']['input']>;
  readonly healthDocUuid?: InputMaybe<Scalars['String']['input']>;
  readonly internalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  readonly itemType: ComplianceListItemType;
  readonly licenseStateCode?: InputMaybe<Scalars['String']['input']>;
  readonly licenseType?: InputMaybe<LicenseType>;
  readonly licenseUuid?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly requiresVerification?: InputMaybe<Scalars['Boolean']['input']>;
  readonly verificationType?: InputMaybe<LicenseVerificationType>;
}

/** Autogenerated return type of CreateComplianceListItem. */
export interface CreateComplianceListItemPayload {
  readonly __typename?: 'CreateComplianceListItemPayload';
  readonly complianceListItem: ComplianceListItem;
}

export interface CreateComplianceQuestionsInput {
  readonly canCommitToOnboarding: Scalars['Boolean']['input'];
  readonly certsOrLicensesExpiringUntilStartDate: Scalars['Boolean']['input'];
  readonly certsOrLicensesExpiringUntilStartDateDetails?: InputMaybe<Scalars['String']['input']>;
  readonly chosenAddress: Scalars['String']['input'];
  readonly currentFluSeasonPlans: Scalars['String']['input'];
  readonly expectedBackgroundCheckIssues: Scalars['String']['input'];
  readonly previousOnboardingDelayDetails?: InputMaybe<Scalars['String']['input']>;
  readonly previousOnboardingDelays: Scalars['Boolean']['input'];
  readonly scheduleUntilStartDate: Scalars['String']['input'];
  readonly timezoneUntilStartDate: Scalars['String']['input'];
  readonly unavailabilityUntilStartDate: Scalars['Boolean']['input'];
  readonly unavailabilityUntilStartDateDetails?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of CreateComplianceQuestions. */
export interface CreateComplianceQuestionsPayload {
  readonly __typename?: 'CreateComplianceQuestionsPayload';
  readonly jobOffer: JobOffer;
}

export interface CreateDirectInvoiceEntryInput {
  readonly amount: Scalars['Float']['input'];
  readonly invoiceBalanceId: Scalars['ID']['input'];
  readonly netsuiteInvoiceDate: Scalars['ISO8601Date']['input'];
  readonly netsuiteInvoiceId: Scalars['String']['input'];
}

/** Autogenerated return type of CreateDirectInvoiceEntry. */
export interface CreateDirectInvoiceEntryPayload {
  readonly __typename?: 'CreateDirectInvoiceEntryPayload';
  readonly invoice: Invoice;
  readonly invoiceBalanceEntry: InvoiceBalanceEntry;
}

export interface CreateDocumentInput {
  readonly completedOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly docType: Scalars['String']['input'];
  readonly expiresOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly title?: InputMaybe<Scalars['String']['input']>;
}

export interface CreateDocumentOnboardingItemInput {
  readonly actionsAttributes?: InputMaybe<ReadonlyArray<ActionLinkTypeInput>>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly docSubtype?: InputMaybe<Scalars['String']['input']>;
  readonly docType: Scalars['String']['input'];
  readonly name: Scalars['String']['input'];
  readonly requiresVerification?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Autogenerated return type of CreateDocumentOnboardingItem. */
export interface CreateDocumentOnboardingItemPayload {
  readonly __typename?: 'CreateDocumentOnboardingItemPayload';
  readonly todoList: TodoList;
  readonly todoListItem: TodoListItem;
}

/** Autogenerated return type of CreateDocument. */
export interface CreateDocumentPayload {
  readonly __typename?: 'CreateDocumentPayload';
  readonly document?: Maybe<Document>;
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
  readonly nurseProfile?: Maybe<NurseProfile>;
}

export interface CreateEducationInput {
  readonly degree: EducationDegreeTypes;
  readonly descriptions?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly gapEndOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly gapExplanation?: InputMaybe<Scalars['String']['input']>;
  readonly gapGooglePlaceId?: InputMaybe<Scalars['String']['input']>;
  readonly gapReason?: InputMaybe<GapReasons>;
  readonly gapStartOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly googlePlaceId: Scalars['String']['input'];
  readonly gpa?: InputMaybe<Scalars['Float']['input']>;
  readonly graduatedOn: Scalars['ISO8601Date']['input'];
  readonly hasGap?: InputMaybe<Scalars['Boolean']['input']>;
  readonly major?: InputMaybe<Scalars['String']['input']>;
  readonly minor?: InputMaybe<Scalars['String']['input']>;
  readonly schoolName: Scalars['String']['input'];
  readonly startedOn: Scalars['ISO8601Date']['input'];
}

/** Autogenerated return type of CreateEducation. */
export interface CreateEducationPayload {
  readonly __typename?: 'CreateEducationPayload';
  readonly nurseProfile: NurseProfile;
}

export interface CreateEmploymentEmploymentInput {
  readonly bedCount?: InputMaybe<Scalars['Int']['input']>;
  readonly employerType: Scalars['String']['input'];
  readonly endAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly facilityAddress?: InputMaybe<Scalars['String']['input']>;
  readonly facilityLocationString?: InputMaybe<Scalars['String']['input']>;
  readonly facilityName: Scalars['String']['input'];
  readonly googlePlaceId: Scalars['String']['input'];
  readonly magnet?: InputMaybe<Scalars['Boolean']['input']>;
  readonly positions: ReadonlyArray<CreateEmploymentPositionInput>;
  readonly startAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly teaching?: InputMaybe<Scalars['Boolean']['input']>;
  readonly trauma?: InputMaybe<Scalars['Boolean']['input']>;
  readonly traumaLevel?: InputMaybe<Scalars['Int']['input']>;
}

/** Autogenerated return type of CreateEmployment. */
export interface CreateEmploymentPayload {
  readonly __typename?: 'CreateEmploymentPayload';
  readonly employment: Employment;
  readonly nurseProfile: NurseProfile;
}

export interface CreateEmploymentPositionAgencyInput {
  readonly id: Scalars['ID']['input'];
}

export interface CreateEmploymentPositionInput {
  readonly agency?: InputMaybe<CreateEmploymentPositionAgencyInput>;
  readonly bedCountInUnit?: InputMaybe<Scalars['Int']['input']>;
  readonly chargeExp?: InputMaybe<Scalars['Boolean']['input']>;
  readonly descriptions?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly duration?: InputMaybe<Scalars['String']['input']>;
  readonly employmentType: Scalars['String']['input'];
  readonly endAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly hoursWorked?: InputMaybe<Scalars['Int']['input']>;
  readonly hoursWorkedTimeframe?: InputMaybe<HoursWorkedTimeframe>;
  readonly nicuTraumaLevel?: InputMaybe<Scalars['Int']['input']>;
  readonly patientsPerNurse?: InputMaybe<Scalars['Int']['input']>;
  readonly specialties: ReadonlyArray<CreateEmploymentPositionNurseSpecialtyInput>;
  readonly startAt: Scalars['ISO8601Date']['input'];
  readonly technologies: ReadonlyArray<CreateEmploymentPositionTechnologyInput>;
  readonly title: Scalars['String']['input'];
  readonly unit: Scalars['String']['input'];
}

export interface CreateEmploymentPositionNurseSpecialtyInput {
  readonly id: Scalars['ID']['input'];
}

export interface CreateEmploymentPositionTechnologyInput {
  readonly id: Scalars['ID']['input'];
}

export interface CreateHealthDocOnboardingItemInput {
  readonly actionsAttributes?: InputMaybe<ReadonlyArray<ActionLinkTypeInput>>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly healthDocCategory?: InputMaybe<Scalars['String']['input']>;
  readonly healthDocId: Scalars['ID']['input'];
  readonly name: Scalars['String']['input'];
  readonly requiresVerification?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Autogenerated return type of CreateHealthDocOnboardingItem. */
export interface CreateHealthDocOnboardingItemPayload {
  readonly __typename?: 'CreateHealthDocOnboardingItemPayload';
  readonly todoList: TodoList;
  readonly todoListItem: TodoListItem;
}

export interface CreateIdentificationDocumentInput {
  readonly completedOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly docSubtype?: InputMaybe<Scalars['String']['input']>;
  readonly docType: Scalars['String']['input'];
  readonly expiresOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly stateCode?: InputMaybe<Scalars['String']['input']>;
  readonly title: Scalars['String']['input'];
}

/** Autogenerated return type of CreateIdentificationDocument. */
export interface CreateIdentificationDocumentPayload {
  readonly __typename?: 'CreateIdentificationDocumentPayload';
  readonly document?: Maybe<Document>;
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
  readonly nurseProfile?: Maybe<NurseProfile>;
}

export interface CreateInvoiceBalanceAdjustmentEntryInput {
  readonly amount: Scalars['Float']['input'];
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly invoiceBalanceId: Scalars['ID']['input'];
  readonly kind: Scalars['String']['input'];
}

/** Autogenerated return type of CreateInvoiceBalanceAdjustmentEntry. */
export interface CreateInvoiceBalanceAdjustmentEntryPayload {
  readonly __typename?: 'CreateInvoiceBalanceAdjustmentEntryPayload';
  readonly invoice: Invoice;
  readonly invoiceBalanceEntry: InvoiceBalanceEntry;
}

export interface CreateJobAlertInput {
  readonly broadPrefLocations?: InputMaybe<ReadonlyArray<BroadPrefLocations>>;
  readonly contractLengths?: InputMaybe<ReadonlyArray<ContractLength>>;
  readonly locationStrings?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly shiftLengths?: InputMaybe<ReadonlyArray<ShiftLength>>;
  readonly shiftPrefs?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly specialtySlugs?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}

/** Autogenerated return type of CreateJobAlert. */
export interface CreateJobAlertPayload {
  readonly __typename?: 'CreateJobAlertPayload';
  readonly nurseProfile: NurseProfile;
}

export interface CreateJobApplicationAllowedFacilitiesInput {
  readonly facilityId: Scalars['ID']['input'];
}

export interface CreateJobApplicationInput {
  readonly acceptIfOfferedCommitment?: InputMaybe<Scalars['Boolean']['input']>;
  readonly allowedFacilities?: InputMaybe<ReadonlyArray<CreateJobApplicationAllowedFacilitiesInput>>;
  readonly allowedFacilitiesShifts?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly birthday?: InputMaybe<Scalars['String']['input']>;
  readonly crimeConviction?: InputMaybe<Scalars['Boolean']['input']>;
  readonly crimeConvictionExplanation?: InputMaybe<Scalars['String']['input']>;
  readonly earliestStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly fullSsn?: InputMaybe<Scalars['String']['input']>;
  readonly hasAllowedFacilities?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasSpecialRequest?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasTimeoffRequest?: InputMaybe<Scalars['Boolean']['input']>;
  readonly interviewAvailability?: InputMaybe<Scalars['String']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly liabilityDefendant?: InputMaybe<Scalars['Boolean']['input']>;
  readonly liabilityDefendantExplanation?: InputMaybe<Scalars['String']['input']>;
  readonly licenseAction?: InputMaybe<Scalars['Boolean']['input']>;
  readonly licenseActionExplanation?: InputMaybe<Scalars['String']['input']>;
  readonly locationStringPermanent?: InputMaybe<Scalars['String']['input']>;
  readonly middleName?: InputMaybe<Scalars['String']['input']>;
  readonly phone?: InputMaybe<Scalars['String']['input']>;
  readonly placeIdPermanent?: InputMaybe<Scalars['String']['input']>;
  readonly preferredName?: InputMaybe<Scalars['String']['input']>;
  readonly previouslyTerminated?: InputMaybe<Scalars['Boolean']['input']>;
  readonly previouslyTerminatedExplanation?: InputMaybe<Scalars['String']['input']>;
  readonly specialRequest?: InputMaybe<Scalars['String']['input']>;
  readonly ssnLast4?: InputMaybe<Scalars['String']['input']>;
  readonly startImmediatelyCommitment?: InputMaybe<Scalars['Boolean']['input']>;
  readonly startPref?: InputMaybe<Scalars['String']['input']>;
  readonly streetAddressPermanent?: InputMaybe<Scalars['String']['input']>;
  readonly submissionWarningsDescription?: InputMaybe<Scalars['String']['input']>;
  readonly submittedAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  readonly submittedWithWarnings?: InputMaybe<Scalars['Boolean']['input']>;
  readonly timeOffRequests?: InputMaybe<ReadonlyArray<CreateJobApplicationTimeOffRequestsInput>>;
  readonly timeoffDescription?: InputMaybe<Scalars['String']['input']>;
  readonly zipcodePermanent?: InputMaybe<Scalars['String']['input']>;
}

export interface CreateJobApplicationTimeOffRequestsInput {
  readonly fromDate: Scalars['ISO8601Date']['input'];
  readonly toDate: Scalars['ISO8601Date']['input'];
}

/** Autogenerated return type of CreateKarmaCheckVoe. */
export interface CreateKarmaCheckVoePayload {
  readonly __typename?: 'CreateKarmaCheckVoePayload';
  readonly id: Scalars['String']['output'];
}

/** Autogenerated return type of CreateLedgerLink. */
export interface CreateLedgerLinkPayload {
  readonly __typename?: 'CreateLedgerLinkPayload';
  readonly ledgerLink?: Maybe<LedgerLink>;
}

export interface CreateLicenseInput {
  readonly compact?: InputMaybe<Scalars['Boolean']['input']>;
  readonly completedOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly expiresOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly licenseType: AlliedHealthNursingLicenseType;
  readonly licensureCompact?: InputMaybe<LicensureCompact>;
  readonly number: Scalars['String']['input'];
  readonly stateCode: Scalars['String']['input'];
}

export interface CreateLicenseOnboardingItemInput {
  readonly actionsAttributes?: InputMaybe<ReadonlyArray<ActionLinkTypeInput>>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly requiresVerification?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Autogenerated return type of CreateLicenseOnboardingItem. */
export interface CreateLicenseOnboardingItemPayload {
  readonly __typename?: 'CreateLicenseOnboardingItemPayload';
  readonly todoList: TodoList;
  readonly todoListItem: TodoListItem;
}

/** Autogenerated return type of CreateLicense. */
export interface CreateLicensePayload {
  readonly __typename?: 'CreateLicensePayload';
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
  readonly license: License;
  readonly nurseProfile: NurseProfile;
}

export interface CreateLicenseVerificationInput {
  readonly dateOfDownload?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly expiresOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly stateCode?: InputMaybe<Scalars['String']['input']>;
  readonly stateCodes?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly verificationType: LicenseVerificationType;
}

export interface CreateLicenseVerificationOnboardingItemInput {
  readonly actionsAttributes?: InputMaybe<ReadonlyArray<ActionLinkTypeInput>>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly requiresVerification?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Autogenerated return type of CreateLicenseVerificationOnboardingItem. */
export interface CreateLicenseVerificationOnboardingItemPayload {
  readonly __typename?: 'CreateLicenseVerificationOnboardingItemPayload';
  readonly todoList: TodoList;
  readonly todoListItem: TodoListItem;
}

/** Autogenerated return type of CreateLicenseVerification. */
export interface CreateLicenseVerificationPayload {
  readonly __typename?: 'CreateLicenseVerificationPayload';
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
  readonly licenseVerification?: Maybe<LicenseVerification>;
  readonly nurseProfile?: Maybe<NurseProfile>;
}

export interface CreateLocationSharedLinkInput {
  readonly path: Scalars['String']['input'];
  readonly queryParams: Scalars['String']['input'];
}

/** Autogenerated return type of CreateLocationSharedLink. */
export interface CreateLocationSharedLinkPayload {
  readonly __typename?: 'CreateLocationSharedLinkPayload';
  readonly sharedLink: SharedLink;
}

export interface CreateManualEmploymentVerificationInput {
  readonly employmentPositionId: Scalars['ID']['input'];
  readonly methodOfVerification?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of CreateManualEmploymentVerification. */
export interface CreateManualEmploymentVerificationPayload {
  readonly __typename?: 'CreateManualEmploymentVerificationPayload';
  readonly submission: EmploymentVerificationSubmission;
}

export interface CreateMultipleLicensesInput {
  readonly licenses: ReadonlyArray<CreateMultipleLicensesLicenseInput>;
}

export interface CreateMultipleLicensesLicenseInput {
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly licenseType: AlliedHealthNursingLicenseType;
  readonly licensureCompact?: InputMaybe<LicensureCompact>;
  readonly stateCode: LocationUsStates;
}

/** Autogenerated return type of CreateMultipleLicenses. */
export interface CreateMultipleLicensesPayload {
  readonly __typename?: 'CreateMultipleLicensesPayload';
  readonly nurseProfile: NurseProfile;
}

export interface CreateNurseAssessmentInput {
  readonly assessmentId: Scalars['ID']['input'];
  readonly completedOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly expiresOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly score?: InputMaybe<Scalars['Float']['input']>;
}

/** Autogenerated return type of CreateNurseAssessment. */
export interface CreateNurseAssessmentPayload {
  readonly __typename?: 'CreateNurseAssessmentPayload';
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
  readonly nurseAssessment?: Maybe<NurseAssessment>;
  readonly nurseProfile?: Maybe<NurseProfile>;
}

export interface CreateNurseCertificationInput {
  readonly completedOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly expiresOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly issuingBody?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of CreateNurseCertification. */
export interface CreateNurseCertificationPayload {
  readonly __typename?: 'CreateNurseCertificationPayload';
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
  readonly nurseCertification?: Maybe<NurseCertification>;
  readonly nurseProfile: NurseProfile;
}

export interface CreateNurseHealthDocInput {
  readonly category?: InputMaybe<Scalars['String']['input']>;
  readonly completedOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly expiresOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
}

/** Autogenerated return type of CreateNurseHealthDoc. */
export interface CreateNurseHealthDocPayload {
  readonly __typename?: 'CreateNurseHealthDocPayload';
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
  readonly nurseHealthDoc?: Maybe<NurseHealthDoc>;
  readonly nurseProfile?: Maybe<NurseProfile>;
}

/** Autogenerated return type of CreateNurseHealthDocVaccination. */
export interface CreateNurseHealthDocVaccinationPayload {
  readonly __typename?: 'CreateNurseHealthDocVaccinationPayload';
  readonly errors?: Maybe<ReadonlyArray<BasicErrorsUnion>>;
  readonly nurseHealthDoc?: Maybe<NurseHealthDoc>;
  readonly nurseProfile?: Maybe<NurseProfile>;
}

export interface CreateOnboardingItemArchiveReasonInput {
  readonly reason: Scalars['String']['input'];
}

/** Autogenerated return type of CreateOnboardingItemArchiveReason. */
export interface CreateOnboardingItemArchiveReasonPayload {
  readonly __typename?: 'CreateOnboardingItemArchiveReasonPayload';
  readonly archiveReason?: Maybe<ArchiveReason>;
  readonly todoListItem?: Maybe<TodoListItem>;
}

export interface CreateOnboardingItemInput {
  readonly actionsAttributes?: InputMaybe<ReadonlyArray<ActionLinkTypeInput>>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly internalOnly: Scalars['Boolean']['input'];
  readonly itemType: Scalars['String']['input'];
  readonly name: Scalars['String']['input'];
  readonly requiresVerification?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Autogenerated return type of CreateOnboardingItem. */
export interface CreateOnboardingItemPayload {
  readonly __typename?: 'CreateOnboardingItemPayload';
  readonly todoList: TodoList;
  readonly todoListItem: TodoListItem;
}

export interface CreateOnboardingListStatusInput {
  readonly notes: Scalars['String']['input'];
  readonly status: OnboardingListStatusEnum;
}

/** Autogenerated return type of CreateOnboardingListStatus. */
export interface CreateOnboardingListStatusPayload {
  readonly __typename?: 'CreateOnboardingListStatusPayload';
  readonly todoList: TodoList;
}

export interface CreatePayBonusInput {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly kind: Scalars['String']['input'];
  readonly netAmount: Scalars['Float']['input'];
  readonly payrollId: Scalars['ID']['input'];
}

/** Autogenerated return type of CreatePayBonus. */
export interface CreatePayBonusPayload {
  readonly __typename?: 'CreatePayBonusPayload';
  readonly payroll: Payroll;
}

export interface CreatePayHoursCancellationInput {
  readonly ghrPaid?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hours: Scalars['Float']['input'];
  readonly payrollId: Scalars['ID']['input'];
}

/** Autogenerated return type of CreatePayHoursCancellation. */
export interface CreatePayHoursCancellationPayload {
  readonly __typename?: 'CreatePayHoursCancellationPayload';
  readonly payHoursCancellation: PayHoursCancellation;
}

export interface CreatePayrollItemInput {
  readonly candidateId: Scalars['ID']['input'];
  readonly weekEndingDate: Scalars['String']['input'];
}

/** Autogenerated return type of CreatePayrollItem. */
export interface CreatePayrollItemPayload {
  readonly __typename?: 'CreatePayrollItemPayload';
  readonly payroll?: Maybe<Payroll>;
}

export interface CreateRecommendationInput {
  readonly dateCompleted: Scalars['ISO8601Date']['input'];
  readonly email: Scalars['String']['input'];
  readonly fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly phoneNumber: Scalars['String']['input'];
  readonly placeOfEmployment: Scalars['String']['input'];
  readonly recommenderName: Scalars['String']['input'];
  readonly recommenderPosition: Scalars['String']['input'];
  readonly relationship: RecommenderRelationship;
}

/** Autogenerated return type of CreateRecommendation. */
export interface CreateRecommendationPayload {
  readonly __typename?: 'CreateRecommendationPayload';
  readonly nurseProfile: NurseProfile;
  readonly recommendation: Recommendation;
}

export interface CreateReferenceOnboardingItemInput {
  readonly actionsAttributes?: InputMaybe<ReadonlyArray<ActionLinkTypeInput>>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly requiresVerification?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Autogenerated return type of CreateReferenceOnboardingItem. */
export interface CreateReferenceOnboardingItemPayload {
  readonly __typename?: 'CreateReferenceOnboardingItemPayload';
  readonly todoList: TodoList;
  readonly todoListItem: TodoListItem;
}

export interface CreateResearchInput {
  readonly descriptions: ReadonlyArray<Scalars['String']['input']>;
  readonly endOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly googlePlaceId: Scalars['String']['input'];
  readonly orgName: Scalars['String']['input'];
  readonly startOn: Scalars['ISO8601Date']['input'];
}

/** Autogenerated return type of CreateResearch. */
export interface CreateResearchPayload {
  readonly __typename?: 'CreateResearchPayload';
  readonly nurseProfile: NurseProfile;
}

export interface CreateResidencyProgramInput {
  readonly accredited: Scalars['Boolean']['input'];
  readonly accreditingBody?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly offersAllSpecialties?: InputMaybe<Scalars['Boolean']['input']>;
  readonly url?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of CreateResidencyProgram. */
export interface CreateResidencyProgramPayload {
  readonly __typename?: 'CreateResidencyProgramPayload';
  readonly residencyProgram: ResidencyProgram;
}

/** Autogenerated return type of CreateResumeFile. */
export interface CreateResumeFilePayload {
  readonly __typename?: 'CreateResumeFilePayload';
  readonly resumeFile: File;
  readonly resumeTitle: Scalars['String']['output'];
}

export interface CreateSalarySearchHistoryEntryInput {
  readonly searchParams: Scalars['String']['input'];
}

/** Autogenerated return type of CreateSalarySearchHistoryEntry. */
export interface CreateSalarySearchHistoryEntryPayload {
  readonly __typename?: 'CreateSalarySearchHistoryEntryPayload';
  readonly nurseProfile: NurseProfile;
  readonly searchHistory: SearchHistory;
}

export interface CreateSavedSearchInput {
  readonly broadPrefLocations?: InputMaybe<ReadonlyArray<BroadPrefLocations>>;
  readonly contractLengths?: InputMaybe<ReadonlyArray<ContractLength>>;
  readonly locationStrings?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly shiftLengths?: InputMaybe<ReadonlyArray<ShiftLength>>;
  readonly shiftPrefs?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly specialtySlugs?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}

/** Autogenerated return type of CreateSavedSearch. */
export interface CreateSavedSearchPayload {
  readonly __typename?: 'CreateSavedSearchPayload';
  readonly nurseProfile: NurseProfile;
  readonly search: SavedSearch;
}

export interface CreateSharedLinkInput {
  readonly path: Scalars['String']['input'];
  readonly queryParams: Scalars['String']['input'];
}

/** Autogenerated return type of CreateSharedLink. */
export interface CreateSharedLinkPayload {
  readonly __typename?: 'CreateSharedLinkPayload';
  readonly sharedLink: SharedLink;
}

export interface CreateShiftEntryInput {
  readonly calculatePayroll?: InputMaybe<Scalars['Boolean']['input']>;
  readonly candidateId: Scalars['ID']['input'];
  readonly duration?: InputMaybe<Scalars['Float']['input']>;
  readonly endDatetime?: InputMaybe<Scalars['String']['input']>;
  readonly entryType: Scalars['String']['input'];
  readonly jobPlacementScheduleUuid?: InputMaybe<Scalars['ID']['input']>;
  readonly kind?: InputMaybe<Scalars['String']['input']>;
  readonly payrollId?: InputMaybe<Scalars['ID']['input']>;
  readonly shiftDate?: InputMaybe<Scalars['String']['input']>;
  readonly startDatetime?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of CreateShiftWithEntry. */
export interface CreateShiftWithEntryPayload {
  readonly __typename?: 'CreateShiftWithEntryPayload';
  readonly payroll?: Maybe<Payroll>;
  readonly shift: Shift;
}

export interface CreateStudentClinicalExperienceExperienceInput {
  readonly descriptions?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly experienceType: StudentExperienceTypes;
  readonly experienceYear: Scalars['Int']['input'];
  readonly experienceYearTerm: YearTerms;
  readonly facilityName: Scalars['String']['input'];
  readonly facilityType: FacilityTypes;
  readonly locationString: Scalars['String']['input'];
  readonly units?: InputMaybe<ReadonlyArray<CreateStudentClinicalExperienceUnitInput>>;
}

export interface CreateStudentClinicalExperienceInput {
  readonly experience: CreateStudentClinicalExperienceExperienceInput;
}

/** Autogenerated return type of CreateStudentClinicalExperience. */
export interface CreateStudentClinicalExperiencePayload {
  readonly __typename?: 'CreateStudentClinicalExperiencePayload';
  readonly nurseProfile?: Maybe<NurseProfile>;
  readonly studentClinicalExperience?: Maybe<StudentClinicalExperience>;
}

export interface CreateStudentClinicalExperienceUnitInput {
  readonly descriptions?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly hoursWorked: Scalars['Int']['input'];
  readonly name: Scalars['String']['input'];
}

export interface CreateSurveyResponseInput {
  readonly answers: ReadonlyArray<CreateSurveyUserAnswersInput>;
  readonly userLeadEmail?: InputMaybe<Scalars['String']['input']>;
  readonly userSurveyToken?: InputMaybe<Scalars['ID']['input']>;
}

export interface CreateSurveyUserAnswersInput {
  readonly answerJson?: InputMaybe<Scalars['String']['input']>;
  readonly answerText?: InputMaybe<Scalars['String']['input']>;
  readonly comments?: InputMaybe<Scalars['String']['input']>;
  readonly questionId: Scalars['ID']['input'];
}

/** Autogenerated return type of CreateSurveyUserAnswers. */
export interface CreateSurveyUserAnswersPayload {
  readonly __typename?: 'CreateSurveyUserAnswersPayload';
  readonly facility: Facility;
  readonly surveyForUser: FacilitySurveyResponse;
}

export interface CreateTimeEntryInput {
  readonly calculatePayroll?: InputMaybe<Scalars['Boolean']['input']>;
  readonly candidateId: Scalars['ID']['input'];
  readonly duration?: InputMaybe<Scalars['Float']['input']>;
  readonly endDatetime?: InputMaybe<Scalars['String']['input']>;
  readonly entryType: Scalars['String']['input'];
  readonly jobPlacementScheduleUuid?: InputMaybe<Scalars['ID']['input']>;
  readonly payrollId?: InputMaybe<Scalars['ID']['input']>;
  readonly shiftDate?: InputMaybe<Scalars['String']['input']>;
  readonly shiftId?: InputMaybe<Scalars['ID']['input']>;
  readonly startDatetime?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of CreateTimeEntry. */
export interface CreateTimeEntryPayload {
  readonly __typename?: 'CreateTimeEntryPayload';
  readonly payroll?: Maybe<Payroll>;
  readonly shift: Shift;
}

/** Autogenerated return type of CreateTimecardOcrParsing. */
export interface CreateTimecardOcrParsingPayload {
  readonly __typename?: 'CreateTimecardOcrParsingPayload';
  readonly timecardOcrParsing: TimecardOcrParsing;
}

export interface Credential {
  readonly files?: Maybe<ReadonlyArray<File>>;
  readonly id: Scalars['ID']['output'];
  readonly isVerified?: Maybe<Scalars['Boolean']['output']>;
  readonly verifiedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly verifiedByName?: Maybe<Scalars['String']['output']>;
}

export interface CredentialCategory {
  readonly __typename?: 'CredentialCategory';
  readonly name: Scalars['String']['output'];
  readonly status: CredentialCategoryStatusEnum;
  readonly total: Scalars['Int']['output'];
}

export const enum CredentialCategoryStatusEnum {
  /** Credentials within category are valid and not expired */
  Compliant = 'compliant',
  /** Credentials within category need attention due to expiry status */
  NeedsAttention = 'needsAttention'
};

export type CredentialDocumentUnion = Document | License | NurseAssessment | NurseCertification | NurseHealthDoc | NurseLicenseVerification | Reference;

/** Autogenerated return type of DeleteAffiliationHistory. */
export interface DeleteAffiliationHistoryPayload {
  readonly __typename?: 'DeleteAffiliationHistoryPayload';
  readonly affiliationHistory: Affiliation;
  readonly nurseProfile: NurseProfile;
}

/** Autogenerated return type of DeleteAward. */
export interface DeleteAwardPayload {
  readonly __typename?: 'DeleteAwardPayload';
  readonly nurseProfile: NurseProfile;
}

/** Autogenerated return type of DeleteCeuCertificate. */
export interface DeleteCeuCertificatePayload {
  readonly __typename?: 'DeleteCeuCertificatePayload';
  readonly ceuCertificate: Affiliation;
  readonly nurseProfile: NurseProfile;
}

/** Autogenerated return type of DeleteCeuGoal. */
export interface DeleteCeuGoalPayload {
  readonly __typename?: 'DeleteCeuGoalPayload';
  readonly nurseProfile: NurseProfile;
}

export interface DeleteComplianceListItemFileInput {
  readonly fileId?: InputMaybe<Scalars['ID']['input']>;
}

/** Autogenerated return type of DeleteComplianceListItemFile. */
export interface DeleteComplianceListItemFilePayload {
  readonly __typename?: 'DeleteComplianceListItemFilePayload';
  readonly complianceListItem: ComplianceListItem;
}

/** Autogenerated return type of DeleteDocument. */
export interface DeleteDocumentPayload {
  readonly __typename?: 'DeleteDocumentPayload';
  readonly document: Document;
  readonly nurseProfile: NurseProfile;
}

/** Autogenerated return type of DeleteEducation. */
export interface DeleteEducationPayload {
  readonly __typename?: 'DeleteEducationPayload';
  readonly nurseProfile: NurseProfile;
}

/** Autogenerated return type of DeleteEmploymentGap. */
export interface DeleteEmploymentGapPayload {
  readonly __typename?: 'DeleteEmploymentGapPayload';
  readonly nurseProfile: NurseProfile;
}

/** Autogenerated return type of DeleteEmploymentPosition. */
export interface DeleteEmploymentPositionPayload {
  readonly __typename?: 'DeleteEmploymentPositionPayload';
  readonly nurseProfile: NurseProfile;
}

/** Autogenerated return type of DeleteFile. */
export interface DeleteFilePayload {
  readonly __typename?: 'DeleteFilePayload';
  readonly id: Scalars['ID']['output'];
  readonly success?: Maybe<Scalars['Boolean']['output']>;
}

/** Autogenerated return type of DeleteIdentificationDocument. */
export interface DeleteIdentificationDocumentPayload {
  readonly __typename?: 'DeleteIdentificationDocumentPayload';
  readonly nurseProfile: NurseProfile;
}

/** Autogenerated return type of DeleteInvoiceFile. */
export interface DeleteInvoiceFilePayload {
  readonly __typename?: 'DeleteInvoiceFilePayload';
  readonly invoice: Invoice;
}

/** Autogenerated return type of DeleteJobAlert. */
export interface DeleteJobAlertPayload {
  readonly __typename?: 'DeleteJobAlertPayload';
  readonly nurseProfile: NurseProfile;
}

/** Autogenerated return type of DeleteLanguage. */
export interface DeleteLanguagePayload {
  readonly __typename?: 'DeleteLanguagePayload';
  readonly errors?: Maybe<ReadonlyArray<BasicErrorsUnion>>;
  readonly nurseProfile?: Maybe<NurseProfile>;
}

/** Autogenerated return type of DeleteLicense. */
export interface DeleteLicensePayload {
  readonly __typename?: 'DeleteLicensePayload';
  readonly license: License;
  readonly nurseProfile: NurseProfile;
}

/** Autogenerated return type of DeleteLicenseVerification. */
export interface DeleteLicenseVerificationPayload {
  readonly __typename?: 'DeleteLicenseVerificationPayload';
  readonly licenseVerification: LicenseVerification;
  readonly nurseProfile: NurseProfile;
}

/** Autogenerated return type of DeleteNurseAssessment. */
export interface DeleteNurseAssessmentPayload {
  readonly __typename?: 'DeleteNurseAssessmentPayload';
  readonly nurseProfile: NurseProfile;
}

/** Autogenerated return type of DeleteNurseCertification. */
export interface DeleteNurseCertificationPayload {
  readonly __typename?: 'DeleteNurseCertificationPayload';
  readonly nurseProfile: NurseProfile;
}

/** Autogenerated return type of DeleteNurseHealthDoc. */
export interface DeleteNurseHealthDocPayload {
  readonly __typename?: 'DeleteNurseHealthDocPayload';
  readonly nurseProfile: NurseProfile;
}

/** Autogenerated return type of DeleteOnboardingItem. */
export interface DeleteOnboardingItemPayload {
  readonly __typename?: 'DeleteOnboardingItemPayload';
  readonly todoList: TodoList;
}

export interface DeleteOnboardingListItemFileInput {
  readonly fileId?: InputMaybe<Scalars['ID']['input']>;
  readonly id: Scalars['ID']['input'];
}

/** Autogenerated return type of DeleteOnboardingListItemFile. */
export interface DeleteOnboardingListItemFilePayload {
  readonly __typename?: 'DeleteOnboardingListItemFilePayload';
  readonly onboardingListItem: TodoListItem;
}

/** Autogenerated return type of DeleteOnboardingList. */
export interface DeleteOnboardingListPayload {
  readonly __typename?: 'DeleteOnboardingListPayload';
  readonly todoList: TodoList;
}

/** Autogenerated return type of DeletePayrollFile. */
export interface DeletePayrollFilePayload {
  readonly __typename?: 'DeletePayrollFilePayload';
  readonly payroll: Payroll;
}

/** Autogenerated return type of DeleteRecommendation. */
export interface DeleteRecommendationPayload {
  readonly __typename?: 'DeleteRecommendationPayload';
  readonly nurseProfile: NurseProfile;
}

/** Autogenerated return type of DeleteResearch. */
export interface DeleteResearchPayload {
  readonly __typename?: 'DeleteResearchPayload';
  readonly nurseProfile: NurseProfile;
}

/** Autogenerated return type of DeleteResidencyProgram. */
export interface DeleteResidencyProgramPayload {
  readonly __typename?: 'DeleteResidencyProgramPayload';
  readonly residencyProgram: ResidencyProgram;
}

/** Autogenerated return type of DeleteSavedFacility. */
export interface DeleteSavedFacilityPayload {
  readonly __typename?: 'DeleteSavedFacilityPayload';
  readonly nurseProfile: NurseProfile;
}

/** Autogenerated return type of DeleteSavedSearch. */
export interface DeleteSavedSearchPayload {
  readonly __typename?: 'DeleteSavedSearchPayload';
  readonly id: Scalars['ID']['output'];
  readonly nurseProfile: NurseProfile;
}

/** Autogenerated return type of DeleteSearchHistoryEntry. */
export interface DeleteSearchHistoryEntryPayload {
  readonly __typename?: 'DeleteSearchHistoryEntryPayload';
  readonly nurseProfile: NurseProfile;
}

/** Autogenerated return type of DeleteStudentClinicalExperience. */
export interface DeleteStudentClinicalExperiencePayload {
  readonly __typename?: 'DeleteStudentClinicalExperiencePayload';
  readonly nurseProfile: NurseProfile;
}

/** Autogenerated return type of DeleteStudentClinicalExperienceUnit. */
export interface DeleteStudentClinicalExperienceUnitPayload {
  readonly __typename?: 'DeleteStudentClinicalExperienceUnitPayload';
  readonly nurseProfile: NurseProfile;
}

export interface DirectInvoiceEntry {
  readonly __typename?: 'DirectInvoiceEntry';
  readonly amount?: Maybe<Scalars['Float']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly netsuiteInvoiceDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly netsuiteInvoiceId?: Maybe<Scalars['String']['output']>;
}

/** Autogenerated return type of DismissAutoApplyOptInExpired. */
export interface DismissAutoApplyOptInExpiredPayload {
  readonly __typename?: 'DismissAutoApplyOptInExpiredPayload';
  readonly autoApplyInfo: AutoApplyInfo;
}

export interface Document extends Credential {
  readonly __typename?: 'Document';
  readonly completedOn?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated use `createdAt` */
  readonly created_at?: Maybe<Scalars['String']['output']>;
  readonly daysToExpiry?: Maybe<Scalars['Int']['output']>;
  readonly daysUntilExpiration?: Maybe<Scalars['Int']['output']>;
  readonly docSubtype?: Maybe<Scalars['String']['output']>;
  readonly docType?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `docType` */
  readonly doc_type?: Maybe<Scalars['String']['output']>;
  readonly documentTemplate?: Maybe<DocumentTemplate>;
  readonly expirationType?: Maybe<DocumentExpiration>;
  readonly expiresOn?: Maybe<Scalars['ISO8601Date']['output']>;
  /** @deprecated use `expiresOn` */
  readonly expires_on?: Maybe<Scalars['String']['output']>;
  readonly files?: Maybe<ReadonlyArray<File>>;
  readonly id: Scalars['ID']['output'];
  readonly isExpirable: Scalars['Boolean']['output'];
  readonly isExpired?: Maybe<Scalars['Boolean']['output']>;
  readonly isExpiringSoon?: Maybe<Scalars['Boolean']['output']>;
  readonly isIdDoc: Scalars['Boolean']['output'];
  readonly isMiscDoc: Scalars['Boolean']['output'];
  readonly isVerified?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use `isExpired` */
  readonly is_expired?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use `isExpiringSoon` */
  readonly is_expiring_soon?: Maybe<Scalars['Boolean']['output']>;
  readonly stateCode?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
  readonly trackCompletionDate?: Maybe<Scalars['Boolean']['output']>;
  readonly uuid?: Maybe<Scalars['String']['output']>;
  readonly verifiedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly verifiedByName?: Maybe<Scalars['String']['output']>;
}

export const enum DocumentExpiration {
  /** Expirable by Completion Date */
  CompletionDate = 'COMPLETION_DATE',
  /** Expirable by Expiration Date */
  ExpirationDate = 'EXPIRATION_DATE',
  /** Non-expirable */
  NonExpirable = 'NON_EXPIRABLE'
};

export interface DocumentTemplate {
  readonly __typename?: 'DocumentTemplate';
  readonly category?: Maybe<Scalars['String']['output']>;
  readonly daysToExpiry?: Maybe<Scalars['Int']['output']>;
  readonly expirationType?: Maybe<DocumentExpiration>;
  readonly id: Scalars['Int']['output'];
  readonly internalOnly: Scalars['Boolean']['output'];
  readonly key?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly trackCompletionDate?: Maybe<Scalars['Boolean']['output']>;
  readonly types?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
}

export interface Duration {
  readonly __typename?: 'Duration';
  readonly days?: Maybe<Scalars['Int']['output']>;
  readonly hours?: Maybe<Scalars['Int']['output']>;
  readonly minutes?: Maybe<Scalars['Int']['output']>;
  readonly months?: Maybe<Scalars['Int']['output']>;
  readonly seconds?: Maybe<Scalars['Int']['output']>;
  readonly weeks?: Maybe<Scalars['Int']['output']>;
  readonly years?: Maybe<Scalars['Int']['output']>;
}

export interface Education {
  readonly __typename?: 'Education';
  readonly degree: Scalars['String']['output'];
  readonly descriptions: ReadonlyArray<Scalars['String']['output']>;
  readonly gapEndOn?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly gapExplanation?: Maybe<Scalars['String']['output']>;
  readonly gapLocation?: Maybe<Location>;
  readonly gapReason?: Maybe<Scalars['String']['output']>;
  readonly gapStartOn?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly googlePlaceId?: Maybe<Scalars['String']['output']>;
  readonly gpa?: Maybe<Scalars['Float']['output']>;
  readonly graduatedOn: Scalars['ISO8601Date']['output'];
  readonly hasGap?: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly location?: Maybe<Location>;
  readonly locationAddress?: Maybe<Scalars['String']['output']>;
  readonly locationString?: Maybe<Scalars['String']['output']>;
  readonly major?: Maybe<Scalars['String']['output']>;
  readonly schoolName: Scalars['String']['output'];
  readonly startedOn?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly uuid: Scalars['String']['output'];
}

export const enum EducationDegreeTypes {
  /** AA */
  Aa = 'AA',
  /** ADN */
  Adn = 'ADN',
  /** AS */
  As = 'AS',
  /** BA */
  Ba = 'BA',
  /** BS */
  Bs = 'BS',
  /** BSN */
  Bsn = 'BSN',
  /** BSW */
  Bsw = 'BSW',
  /** Certificate */
  Certificate = 'Certificate',
  /** DN */
  Dn = 'DN',
  /** DNP */
  Dnp = 'DNP',
  /** DNS */
  Dns = 'DNS',
  /** DPT */
  Dpt = 'DPT',
  /** Diploma */
  Diploma = 'Diploma',
  /** GED */
  Ged = 'GED',
  /** High School */
  HighSchool = 'High_School',
  /** MA */
  Ma = 'MA',
  /** MFT */
  Mft = 'MFT',
  /** MHHS */
  Mhhs = 'MHHS',
  /** MPH */
  Mph = 'MPH',
  /** MS */
  Ms = 'MS',
  /** MSN */
  Msn = 'MSN',
  /** MSW */
  Msw = 'MSW',
  /** OTD */
  Otd = 'OTD',
  /** PhD */
  PhD = 'PhD',
  /** Pharm.D */
  PharmD = 'Pharm_D',
  /** Psy.D */
  PsyD = 'Psy_D'
};

export interface EducationSuggestion {
  readonly __typename?: 'EducationSuggestion';
  readonly degree?: Maybe<Scalars['String']['output']>;
  readonly graduationDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly institution?: Maybe<College>;
  readonly institutionName?: Maybe<Scalars['String']['output']>;
  readonly location?: Maybe<Scalars['String']['output']>;
  readonly locationGoogle?: Maybe<LocationGoogle>;
  readonly parserId?: Maybe<Scalars['String']['output']>;
  readonly startDate?: Maybe<Scalars['ISO8601Date']['output']>;
}

export interface Employment {
  readonly __typename?: 'Employment';
  readonly activeReferences?: Maybe<ReadonlyArray<Reference>>;
  readonly bedCount?: Maybe<Scalars['Int']['output']>;
  readonly duration: Duration;
  readonly employerType?: Maybe<Scalars['String']['output']>;
  readonly endAt?: Maybe<Scalars['String']['output']>;
  readonly facility?: Maybe<Facility>;
  readonly facilityName: Scalars['String']['output'];
  readonly gapExplanation?: Maybe<Scalars['String']['output']>;
  readonly gapGooglePlaceId?: Maybe<Scalars['String']['output']>;
  readonly gapLocationAddress?: Maybe<Scalars['String']['output']>;
  readonly gapLocationString?: Maybe<Scalars['String']['output']>;
  readonly gapReason?: Maybe<Scalars['String']['output']>;
  readonly googlePlaceId?: Maybe<Scalars['String']['output']>;
  readonly hasGap?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated unused field */
  readonly hasPositionOverlap: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  /** @deprecated unused field */
  readonly invalidPositionOverlap: Scalars['Boolean']['output'];
  readonly location?: Maybe<Location>;
  readonly locationAddress?: Maybe<Scalars['String']['output']>;
  readonly locationCity?: Maybe<Scalars['String']['output']>;
  readonly locationStateCode?: Maybe<Scalars['String']['output']>;
  readonly locationString?: Maybe<Scalars['String']['output']>;
  readonly magnet?: Maybe<Scalars['Boolean']['output']>;
  readonly positions?: Maybe<ReadonlyArray<Position>>;
  readonly reasonForLeaving?: Maybe<Scalars['String']['output']>;
  readonly reasonForLeavingOther?: Maybe<Scalars['String']['output']>;
  readonly startAt?: Maybe<Scalars['String']['output']>;
  readonly teaching?: Maybe<Scalars['Boolean']['output']>;
  readonly trauma?: Maybe<Scalars['Boolean']['output']>;
  readonly traumaLevel?: Maybe<Scalars['Int']['output']>;
  readonly usableForReferences: Scalars['Boolean']['output'];
  readonly uuid: Scalars['String']['output'];
  /** @deprecated unused field */
  readonly validPositionOverlap: Scalars['Boolean']['output'];
}

export interface EmploymentGapData {
  readonly __typename?: 'EmploymentGapData';
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly endAt: Scalars['ISO8601Date']['output'];
  readonly reason?: Maybe<Scalars['String']['output']>;
  readonly startAt: Scalars['ISO8601Date']['output'];
  readonly type: Scalars['String']['output'];
}

export interface EmploymentPositionVerificationData {
  readonly __typename?: 'EmploymentPositionVerificationData';
  readonly facilityName?: Maybe<Scalars['String']['output']>;
  readonly gap?: Maybe<EmploymentGapData>;
  readonly position?: Maybe<Position>;
  readonly type: Scalars['String']['output'];
  readonly verification?: Maybe<EmploymentVerification>;
  readonly withinDuration: Scalars['Boolean']['output'];
}

export const enum EmploymentTypes {
  /** Staff */
  FullTime = 'full_time',
  /** Part-Time */
  PartTime = 'part_time',
  /** Per Diem */
  PerDiem = 'per_diem',
  /** Travel */
  Travel = 'travel'
};

export interface EmploymentVerification {
  readonly __typename?: 'EmploymentVerification';
  readonly agency?: Maybe<Agency>;
  readonly employmentPosition?: Maybe<Position>;
  readonly id: Scalars['ID']['output'];
  readonly methodOfVerification?: Maybe<Scalars['String']['output']>;
  readonly positionNames?: Maybe<Scalars['String']['output']>;
  readonly reference?: Maybe<Reference>;
  readonly selected?: Maybe<Scalars['Boolean']['output']>;
  readonly state: Scalars['String']['output'];
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly statusInfo: Scalars['String']['output'];
  readonly submission?: Maybe<EmploymentVerificationSubmission>;
  readonly verifiedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly verifier?: Maybe<Scalars['String']['output']>;
  readonly verifierId?: Maybe<Scalars['String']['output']>;
}

export interface EmploymentVerificationSubmission {
  readonly __typename?: 'EmploymentVerificationSubmission';
  readonly approvedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly approvedBy?: Maybe<Scalars['String']['output']>;
  readonly errorMessage?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly todoListItem?: Maybe<TodoListItem>;
  readonly triggerDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly verificationUrl?: Maybe<Scalars['String']['output']>;
  readonly verifications?: Maybe<ReadonlyArray<Maybe<EmploymentVerification>>>;
}

export interface Expense {
  readonly __typename?: 'Expense';
  readonly candidate: NurseProfile;
  readonly contract?: Maybe<Scalars['String']['output']>;
  readonly cost: Scalars['Float']['output'];
  readonly expenseType: Scalars['String']['output'];
  readonly files?: Maybe<ReadonlyArray<File>>;
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly originalPayer?: Maybe<Scalars['String']['output']>;
  readonly reimbursed: Scalars['Boolean']['output'];
  readonly stage: Scalars['String']['output'];
  readonly status: Scalars['String']['output'];
}

/** The connection type for Expense. */
export interface ExpenseConnection {
  readonly __typename?: 'ExpenseConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ExpenseEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Expense>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface ExpenseEdge {
  readonly __typename?: 'ExpenseEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Expense>;
}

export interface ExpenseStats {
  readonly __typename?: 'ExpenseStats';
  readonly all: Scalars['Int']['output'];
  readonly compliance: Scalars['Int']['output'];
  readonly onboarding: Scalars['Int']['output'];
  readonly submission: Scalars['Int']['output'];
}

export type ExperienceItemUnion = Employment | Gap | Position;

export interface ExtensionRequest {
  readonly __typename?: 'ExtensionRequest';
  readonly endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly grossPayWeekly?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use grossPayWeekly */
  readonly grossWeeklyPay?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly timeOffRequests: ReadonlyArray<ExtensionRequestTimeOff>;
}

export interface ExtensionRequestInput {
  readonly additionalInfo?: InputMaybe<Scalars['String']['input']>;
  readonly discussedWithManager?: InputMaybe<Scalars['Boolean']['input']>;
  readonly requestedEndDate: Scalars['ISO8601Date']['input'];
  readonly timeOffRequests: ReadonlyArray<TimeOffRequestInput>;
}

export interface ExtensionRequestMutation {
  readonly __typename?: 'ExtensionRequestMutation';
  readonly submitIntentCaptureSurvey?: Maybe<SubmitIntentCaptureSurveyPayload>;
  readonly updateExtensionRequest?: Maybe<UpdateExtensionRequestPayload>;
}


export interface ExtensionRequestMutationSubmitIntentCaptureSurveyArgs {
  input: IntentCaptureSurveyInput;
  jobPlacementUuid: Scalars['ID']['input'];
}


export interface ExtensionRequestMutationUpdateExtensionRequestArgs {
  input: UpdateExtensionRequestInput;
  jobPlacementUuid: Scalars['ID']['input'];
}

export const enum ExtensionRequestStatus {
  /** Approved */
  Approved = 'Approved',
  /** Available */
  Available = 'Available',
  /** Declined */
  Declined = 'Declined',
  /** Denied */
  Denied = 'Denied',
  /** Error */
  Error = 'Error',
  /** In Progress */
  InProgress = 'InProgress',
  /** Offered */
  Offered = 'Offered',
  /** Pending Signature */
  PendingSignature = 'PendingSignature'
};

export interface ExtensionRequestTimeOff {
  readonly __typename?: 'ExtensionRequestTimeOff';
  readonly fromDate: Scalars['ISO8601Date']['output'];
  readonly toDate: Scalars['ISO8601Date']['output'];
}

export const enum ExtensionRequestUpdateAction {
  AcceptOffer = 'AcceptOffer',
  DeclineOffer = 'DeclineOffer',
  MarkPreferencesUpdated = 'MarkPreferencesUpdated'
};

export interface ExternalIdentifier {
  readonly __typename?: 'ExternalIdentifier';
  readonly id: Scalars['ID']['output'];
  readonly internalId?: Maybe<Scalars['String']['output']>;
  readonly internalType: Scalars['String']['output'];
  readonly key: Scalars['String']['output'];
  readonly value: Scalars['String']['output'];
}

export interface ExternalServiceMetadata {
  readonly __typename?: 'ExternalServiceMetadata';
  readonly pandologicConversionSent: Scalars['Boolean']['output'];
  readonly zipRecruiterConversionSent: Scalars['Boolean']['output'];
}

/** The connection type for Facility. */
export interface FacilitiesConnection {
  readonly __typename?: 'FacilitiesConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<FacilitiesEdge>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Facility>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface FacilitiesEdge {
  readonly __typename?: 'FacilitiesEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Facility>;
}

export interface Facility {
  readonly __typename?: 'Facility';
  readonly accreditedResidencyProgram: Scalars['Boolean']['output'];
  readonly address: Scalars['String']['output'];
  readonly allowAutoVerificationTrusted: Scalars['Boolean']['output'];
  readonly allowVoeReferences: Scalars['Boolean']['output'];
  /** @deprecated Use hospital.totalLicensedBeds instead */
  readonly bedCount?: Maybe<Scalars['Int']['output']>;
  /** Fallback if no background image specified */
  readonly bgImageFlickrUrl?: Maybe<Scalars['String']['output']>;
  readonly city?: Maybe<Scalars['String']['output']>;
  readonly cityWalkscore?: Maybe<Walkscore>;
  readonly city_latitude?: Maybe<Scalars['Float']['output']>;
  readonly city_longitude?: Maybe<Scalars['Float']['output']>;
  readonly completeTitle: Scalars['String']['output'];
  readonly costOfLivingStats?: Maybe<ReadonlyArray<Stat>>;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly dhcProviderWebsite?: Maybe<Scalars['String']['output']>;
  readonly hideMatchInfo: Scalars['Boolean']['output'];
  readonly hospital?: Maybe<Hospital>;
  /** @deprecated Use hospital.hospitalSystem instead */
  readonly hospitalSystem?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use hospital.hospitalType instead */
  readonly hospitalType?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly jobsPageUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use hospital.jointCommission instead */
  readonly jointCommission?: Maybe<Scalars['Boolean']['output']>;
  readonly karmaCheckVoeBusinessPackage?: Maybe<BusinessPackage>;
  readonly latitude: Scalars['Float']['output'];
  readonly location?: Maybe<Location>;
  readonly logo?: Maybe<Scalars['String']['output']>;
  readonly longitude: Scalars['Float']['output'];
  /** @deprecated Use hospital.magnet instead */
  readonly magnet?: Maybe<Scalars['Boolean']['output']>;
  readonly mspName?: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly nearbyFacilities?: Maybe<ReadonlyArray<NearbyFacility>>;
  /** @deprecated Use hospital.nicuTraumaLevel instead */
  readonly nicuTraumaLevel?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use hospital.pediatricTraumaCenterLevel instead */
  readonly pediatricTraumaCenterLevel?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use hospital.technology instead */
  readonly primaryEmrTechnology?: Maybe<Technology>;
  readonly program?: Maybe<Program>;
  readonly rankings?: Maybe<ReadonlyArray<UsnewsRanking>>;
  readonly residencyPrograms?: Maybe<ReadonlyArray<ResidencyProgram>>;
  readonly slug: Scalars['String']['output'];
  readonly state?: Maybe<Scalars['String']['output']>;
  readonly surveyForUser?: Maybe<FacilitySurveyResponse>;
  readonly surveyQuestions: ReadonlyArray<FacilitySurveyQuestion>;
  readonly surveyResponses?: Maybe<ReadonlyArray<FacilitySurveyResponse>>;
  /** @deprecated Use hospital.teaching instead */
  readonly teaching?: Maybe<Scalars['Boolean']['output']>;
  readonly timekeepingAttributes?: Maybe<TimekeepingAttributes>;
  /** @deprecated Use hospital.traumaCenter instead */
  readonly traumaCenter?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use hospital.traumaCenterLevel instead */
  readonly traumaCenterLevel?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use hospital.affiliatedUnion instead */
  readonly union?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly uuid?: Maybe<Scalars['String']['output']>;
  readonly vmsName?: Maybe<Scalars['String']['output']>;
  readonly walkscore?: Maybe<Walkscore>;
  readonly walkscoreByCoordinates?: Maybe<Walkscore>;
  readonly zipcode?: Maybe<Scalars['String']['output']>;
}


export interface FacilityCostOfLivingStatsArgs {
  source?: InputMaybe<Scalars['String']['input']>;
  statsIds?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}


export interface FacilityNearbyFacilitiesArgs {
  distance?: InputMaybe<Scalars['Int']['input']>;
}


export interface FacilitySurveyForUserArgs {
  userSurveyToken?: InputMaybe<Scalars['ID']['input']>;
}

export interface FacilitySurveyAnswer {
  readonly __typename?: 'FacilitySurveyAnswer';
  readonly answerJson?: Maybe<Scalars['String']['output']>;
  readonly answerText?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly key?: Maybe<Scalars['String']['output']>;
  readonly questionText: Scalars['String']['output'];
}

export interface FacilitySurveyQuestion {
  readonly __typename?: 'FacilitySurveyQuestion';
  readonly answerOptions: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly key: Scalars['String']['output'];
  readonly position: Scalars['Int']['output'];
  readonly text: Scalars['String']['output'];
}

export interface FacilitySurveyResponse {
  readonly __typename?: 'FacilitySurveyResponse';
  readonly answers?: Maybe<ReadonlyArray<FacilitySurveyAnswer>>;
  readonly completedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly userSurveyToken: Scalars['ID']['output'];
}

export const enum FacilityTypes {
  /** Clinical - Hospital */
  ClinicalHospital = 'clinical_hospital',
  /** Clinical - Non-Hospital */
  ClinicalNonHospital = 'clinical_non_hospital',
  /** Non-Hospital */
  NonHospital = 'non_hospital'
};

export interface FailureReasons {
  readonly __typename?: 'FailureReasons';
  /** JSON-encoded map of reasons */
  readonly details: Scalars['String']['output'];
  /** Human-readable errors */
  readonly fullMessages: ReadonlyArray<Scalars['String']['output']>;
}

/** Autogenerated return type of FavoriteJob. */
export interface FavoriteJobPayload {
  readonly __typename?: 'FavoriteJobPayload';
  readonly job?: Maybe<Job>;
  readonly match?: Maybe<Match>;
}

export interface File {
  readonly __typename?: 'File';
  readonly avStatus: AvStatus;
  readonly contentType: Scalars['String']['output'];
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly downloadUrl?: Maybe<Scalars['String']['output']>;
  readonly filename: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly previewUrl?: Maybe<Scalars['String']['output']>;
  readonly size: Scalars['String']['output'];
  readonly uuid: Scalars['String']['output'];
  readonly viewUrl?: Maybe<Scalars['String']['output']>;
}

export interface FileUploadTypeInput {
  readonly originFileObj?: InputMaybe<Scalars['Upload']['input']>;
  readonly uuid?: InputMaybe<Scalars['ID']['input']>;
}

export interface FloatRange {
  readonly __typename?: 'FloatRange';
  readonly max: Scalars['Float']['output'];
  readonly min: Scalars['Float']['output'];
}

export interface Gap {
  readonly __typename?: 'Gap';
  readonly employmentId: Scalars['ID']['output'];
  readonly endAt: Scalars['ISO8601Date']['output'];
  readonly explanation?: Maybe<Scalars['String']['output']>;
  readonly googlePlaceId?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly isEducationGap?: Maybe<Scalars['Boolean']['output']>;
  readonly locationAddress?: Maybe<Scalars['String']['output']>;
  readonly locationString?: Maybe<Scalars['String']['output']>;
  readonly reason?: Maybe<Scalars['String']['output']>;
  readonly startAt: Scalars['ISO8601Date']['output'];
}

export const enum GapReasons {
  /** Education */
  Education = 'education',
  /** Family */
  Family = 'family',
  /** Health */
  Health = 'health',
  /** Looking For Work */
  LookingForWork = 'looking_for_work',
  /** Other */
  Other = 'other',
  /** Travel */
  Travel = 'travel'
};

export interface GapRule {
  readonly __typename?: 'GapRule';
  readonly message: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
  readonly value: Scalars['String']['output'];
  readonly valueType: Scalars['String']['output'];
}

/** Autogenerated return type of GeneratePayrollCorrection. */
export interface GeneratePayrollCorrectionPayload {
  readonly __typename?: 'GeneratePayrollCorrectionPayload';
  readonly payroll: Payroll;
}

/** Autogenerated return type of GenerateVerificationOfEmploymentPdf. */
export interface GenerateVerificationOfEmploymentPdfPayload {
  readonly __typename?: 'GenerateVerificationOfEmploymentPdfPayload';
  readonly verifications: ReadonlyArray<EmploymentVerification>;
}

export interface GenericEnumSuggestion {
  readonly __typename?: 'GenericEnumSuggestion';
  readonly description: Scalars['String']['output'];
  readonly id: Scalars['String']['output'];
  readonly value: Scalars['String']['output'];
}

export interface GenericSuggestion {
  readonly __typename?: 'GenericSuggestion';
  readonly id?: Maybe<Scalars['ID']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
}

export interface GrossPayWeeklyHistogramBucket {
  readonly __typename?: 'GrossPayWeeklyHistogramBucket';
  readonly count: Scalars['Int']['output'];
  readonly payValue: Scalars['Int']['output'];
}

export interface GrossPayWeeklyHistogramConfiguration {
  readonly __typename?: 'GrossPayWeeklyHistogramConfiguration';
  readonly interval: Scalars['Int']['output'];
  readonly paymentMaximum: Scalars['Int']['output'];
  readonly paymentMinimum: Scalars['Int']['output'];
}

export interface GrossPayWeeklyInformation {
  readonly __typename?: 'GrossPayWeeklyInformation';
  readonly averagePay: Scalars['Int']['output'];
  readonly histogram: ReadonlyArray<GrossPayWeeklyHistogramBucket>;
}

export interface HealthDoc {
  readonly __typename?: 'HealthDoc';
  readonly categories?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly expirationType: DocumentExpiration;
  readonly formType: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly nurseHealthDoc?: Maybe<NurseHealthDoc>;
  /** @deprecated use `nurseHealthDoc` */
  readonly nurse_health_doc?: Maybe<NurseHealthDoc>;
  readonly uuid?: Maybe<Scalars['String']['output']>;
  readonly validFor?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use `validFor` */
  readonly valid_for?: Maybe<Scalars['Int']['output']>;
}


export interface HealthDocCategoriesArgs {
  filter?: InputMaybe<HealthDocCategoriesFilter>;
}

export const enum HealthDocCategoriesFilter {
  Clinician = 'CLINICIAN',
  Provider = 'PROVIDER'
};

export interface HelpArticle {
  readonly __typename?: 'HelpArticle';
  readonly articles?: Maybe<ReadonlyArray<Maybe<HelpArticleItem>>>;
  readonly icon?: Maybe<Scalars['String']['output']>;
  readonly topic?: Maybe<Scalars['String']['output']>;
}

export interface HelpArticleItem {
  readonly __typename?: 'HelpArticleItem';
  readonly id: Scalars['ID']['output'];
  readonly link?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
}

/** Autogenerated return type of HideSuggestion. */
export interface HideSuggestionPayload {
  readonly __typename?: 'HideSuggestionPayload';
  readonly uploadedResume: UploadedResume;
}

export interface HomeClinicianJobSummary {
  readonly __typename?: 'HomeClinicianJobSummary';
  readonly applicationsCount?: Maybe<SimpleCount>;
  readonly favoritedCount?: Maybe<SimpleCount>;
  readonly favoritedOnce?: Maybe<SimpleBoolean>;
  readonly id: Scalars['ID']['output'];
  readonly offersCount?: Maybe<SimpleCount>;
  readonly submissionsCount?: Maybe<SimpleCount>;
}

export interface HomeResourceLink {
  readonly __typename?: 'HomeResourceLink';
  readonly id: Scalars['ID']['output'];
  readonly link: Scalars['String']['output'];
  readonly title: Scalars['String']['output'];
}

export interface HomeStepMapper {
  readonly __typename?: 'HomeStepMapper';
  readonly sort: ReadonlyArray<StateEnum>;
  readonly state: StateEnum;
}

export interface HomeTotalMatches {
  readonly __typename?: 'HomeTotalMatches';
  readonly matchesWaiting: Scalars['Int']['output'];
}

export interface Hospital {
  readonly __typename?: 'Hospital';
  readonly affiliatedUnion?: Maybe<Scalars['String']['output']>;
  readonly hospitalSystem?: Maybe<Scalars['String']['output']>;
  readonly hospitalType?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly jointCommission: Scalars['Boolean']['output'];
  readonly magnet: Scalars['Boolean']['output'];
  readonly nicuTraumaLevel?: Maybe<Scalars['Int']['output']>;
  readonly pediatricTraumaCenterLevel?: Maybe<Scalars['Int']['output']>;
  readonly teaching: Scalars['Boolean']['output'];
  readonly technology?: Maybe<Technology>;
  readonly totalLicensedBeds?: Maybe<Scalars['Int']['output']>;
  readonly traumaCenter: Scalars['Boolean']['output'];
  readonly traumaCenterLevel?: Maybe<Scalars['Int']['output']>;
}

export const enum HospitalTypesEnum {
  AcuteCare = 'acute_care',
  Childrens = 'childrens',
  CriticalAccess = 'critical_access'
};

export const enum HoursWorkedTimeframe {
  /** Per month */
  Month = 'MONTH',
  /** Per week */
  Week = 'WEEK'
};

export interface I9Status {
  readonly __typename?: 'I9Status';
  readonly color?: Maybe<Scalars['String']['output']>;
  readonly employeeProfileLink?: Maybe<Scalars['String']['output']>;
  readonly lastUpdated?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly nextActionDueDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly status?: Maybe<Scalars['String']['output']>;
}

export interface Identification {
  readonly __typename?: 'Identification';
  readonly completedOn?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly daysToExpiry?: Maybe<Scalars['Int']['output']>;
  readonly expirationType?: Maybe<DocumentExpiration>;
  readonly id: Scalars['ID']['output'];
  readonly internalOnly: Scalars['Boolean']['output'];
  readonly title?: Maybe<Scalars['String']['output']>;
  readonly type?: Maybe<Scalars['String']['output']>;
}

export interface IncreasedPayBanner {
  readonly __typename?: 'IncreasedPayBanner';
  readonly cta?: Maybe<Scalars['String']['output']>;
  readonly description: Scalars['String']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly redirectTo?: Maybe<Scalars['String']['output']>;
  readonly title: Scalars['String']['output'];
}

export interface IntentCaptureSurveyInput {
  readonly notInterested?: InputMaybe<NotInterestedInput>;
  readonly requestExtension?: InputMaybe<ExtensionRequestInput>;
}

export const enum IntentEnum {
  /** Looking */
  Looking = 'looking',
  /** Not Looking */
  NotLooking = 'not_looking'
};

export const enum IntentStatusEnum {
  /** Confirmed */
  Confirmed = 'confirmed',
  /** Expired */
  Expired = 'expired'
};

export interface Invoice {
  readonly __typename?: 'Invoice';
  readonly accountSfid?: Maybe<Scalars['String']['output']>;
  readonly actualReceivableAmount: Scalars['Float']['output'];
  readonly adjustmentInvoice?: Maybe<Invoice>;
  readonly adjustmentLineItems?: Maybe<ReadonlyArray<AdjustmentInvoiceLineItem>>;
  readonly businessName?: Maybe<Scalars['String']['output']>;
  readonly candidate: NurseProfile;
  readonly channelFee: Scalars['Float']['output'];
  readonly contract?: Maybe<Contract>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly disputesWindowDays?: Maybe<Scalars['Int']['output']>;
  readonly estimatedWithoutChannelFee: Scalars['Float']['output'];
  readonly facility: Facility;
  readonly files?: Maybe<ReadonlyArray<File>>;
  readonly flatChannelFee: Scalars['Float']['output'];
  readonly grossPay?: Maybe<Scalars['Float']['output']>;
  readonly hoursWorked: Scalars['Float']['output'];
  readonly id: Scalars['ID']['output'];
  readonly invoiceDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly invoiceNumber?: Maybe<Scalars['String']['output']>;
  readonly invoiceNumericId?: Maybe<Scalars['ID']['output']>;
  readonly invoicePreviousStatus?: Maybe<InvoiceStatus>;
  readonly lineItems: ReadonlyArray<InvoiceLineItem>;
  readonly linkId?: Maybe<Scalars['String']['output']>;
  readonly locationStateCode?: Maybe<Scalars['String']['output']>;
  readonly mspConfirmationUrl?: Maybe<Scalars['String']['output']>;
  readonly mspName?: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly netAmount: Scalars['Float']['output'];
  readonly payBillBonuses?: Maybe<ReadonlyArray<BonusRuleJobPlacementShift>>;
  readonly payBillRulesUrl?: Maybe<Scalars['String']['output']>;
  readonly payroll?: Maybe<Payroll>;
  readonly periodEnd: Scalars['ISO8601Date']['output'];
  readonly periodStart: Scalars['ISO8601Date']['output'];
  readonly programName?: Maybe<Scalars['String']['output']>;
  readonly reconcileDivergenceCents?: Maybe<Scalars['Int']['output']>;
  readonly reconcilePercentage?: Maybe<Scalars['Float']['output']>;
  readonly status: InvoiceStatus;
  readonly statusHumanize: Scalars['String']['output'];
  readonly statusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly tagIds: ReadonlyArray<Scalars['ID']['output']>;
  readonly tags: ReadonlyArray<BillingTag>;
  readonly takeRate?: Maybe<Scalars['Float']['output']>;
  readonly totalChannelFee: Scalars['Float']['output'];
  readonly totalEstimatedWithoutChannelFee: Scalars['Float']['output'];
  readonly totalNetAmount: Scalars['Float']['output'];
  readonly vmsName?: Maybe<Scalars['String']['output']>;
  readonly weekEnding?: Maybe<Scalars['ISO8601Date']['output']>;
}

export interface InvoiceBalance {
  readonly __typename?: 'InvoiceBalance';
  readonly balance?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['ID']['output']>;
  readonly invoiceBalanceEntries?: Maybe<ReadonlyArray<InvoiceBalanceEntry>>;
}

export interface InvoiceBalanceAdjustment {
  readonly __typename?: 'InvoiceBalanceAdjustment';
  readonly amount: Scalars['Float']['output'];
  readonly id: Scalars['ID']['output'];
  readonly kind: AdjustmentKind;
}

export interface InvoiceBalanceEntry {
  readonly __typename?: 'InvoiceBalanceEntry';
  readonly amount: Scalars['Float']['output'];
  readonly archived: Scalars['Boolean']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly operation: BalanceOperation;
  readonly recordData?: Maybe<InvoiceBalanceEntryRecordDataUnion>;
  readonly recordId: Scalars['String']['output'];
  readonly recordType: Scalars['String']['output'];
  readonly validationData: Scalars['Boolean']['output'];
}

/** Invoice Balance Entry Union Type */
export type InvoiceBalanceEntryRecordDataUnion = DirectInvoiceEntry | InvoiceBalanceAdjustment | VmsReverseInvoiceItemContract;

export interface InvoiceCollection {
  readonly __typename?: 'InvoiceCollection';
  readonly records: ReadonlyArray<Invoice>;
  readonly totalRecords: Scalars['Int']['output'];
}

export interface InvoiceFiltersInput {
  readonly candidateId?: InputMaybe<Scalars['String']['input']>;
  readonly candidateName?: InputMaybe<Scalars['String']['input']>;
  readonly contractType?: InputMaybe<Scalars['String']['input']>;
  readonly facilityId?: InputMaybe<Scalars['String']['input']>;
  readonly facilityName?: InputMaybe<Scalars['String']['input']>;
  readonly invoiceRequired?: InputMaybe<Scalars['String']['input']>;
  readonly invoiceType?: InputMaybe<Scalars['String']['input']>;
  readonly msp?: InputMaybe<Scalars['String']['input']>;
  readonly programId?: InputMaybe<Scalars['String']['input']>;
  readonly programName?: InputMaybe<Scalars['String']['input']>;
  readonly reconcileDifference?: InputMaybe<ReconcileDifferenceInput>;
  readonly roleType?: InputMaybe<Scalars['String']['input']>;
  readonly status?: InputMaybe<Scalars['String']['input']>;
  readonly tagIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly vms?: InputMaybe<Scalars['String']['input']>;
  readonly weekEndingEndDate?: InputMaybe<Scalars['String']['input']>;
  readonly weekEndingStartDate?: InputMaybe<Scalars['String']['input']>;
}

export interface InvoiceLineItem {
  readonly __typename?: 'InvoiceLineItem';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly hours?: Maybe<Scalars['Float']['output']>;
  readonly humanizedLabel?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly kind: Scalars['String']['output'];
  readonly netAmount: Scalars['Float']['output'];
  readonly rate?: Maybe<Scalars['Float']['output']>;
  readonly type: Scalars['String']['output'];
}

export interface InvoiceReconReportDetails {
  readonly __typename?: 'InvoiceReconReportDetails';
  readonly id: Scalars['ID']['output'];
  readonly reconReport?: Maybe<ReadonlyArray<ReconReport>>;
}

export interface InvoiceReconcile {
  readonly __typename?: 'InvoiceReconcile';
  readonly aging: Scalars['Int']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly differenceThreshold: Scalars['Float']['output'];
  readonly id: Scalars['ID']['output'];
  readonly invoiceId: Scalars['ID']['output'];
  readonly invoiceNumericId: Scalars['ID']['output'];
  readonly mspName?: Maybe<Scalars['String']['output']>;
  readonly nurseName?: Maybe<Scalars['String']['output']>;
  readonly programName?: Maybe<Scalars['String']['output']>;
  readonly status: Scalars['String']['output'];
  readonly tagIds: ReadonlyArray<Scalars['ID']['output']>;
  readonly totalEstimatedAmount: Scalars['Float']['output'];
  readonly totalReconciled: Scalars['Float']['output'];
  readonly vmsName?: Maybe<Scalars['String']['output']>;
  readonly weekEnding: Scalars['String']['output'];
}

export interface InvoiceShiftDetails {
  readonly __typename?: 'InvoiceShiftDetails';
  readonly id: Scalars['ID']['output'];
  readonly shifts?: Maybe<ReadonlyArray<Shift>>;
  readonly timecardUrls?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
}

export const enum InvoiceSortField {
  ActualReceivableAmount = 'ActualReceivableAmount',
  DisputesWindowDays = 'DisputesWindowDays',
  Facility = 'Facility',
  GrossPay = 'GrossPay',
  HoursWorked = 'HoursWorked',
  Msp = 'MSP',
  Name = 'Name',
  NetAmount = 'NetAmount',
  Program = 'Program',
  ReconcilePercentage = 'ReconcilePercentage',
  State = 'State',
  Status = 'Status',
  Vms = 'VMS',
  WeekEnding = 'WeekEnding'
};

export interface InvoiceSortInput {
  readonly direction?: InputMaybe<OrderDirection>;
  readonly field?: InputMaybe<InvoiceSortField>;
}

export interface InvoiceStats {
  readonly __typename?: 'InvoiceStats';
  readonly statuses: ReadonlyArray<InvoiceStatsItem>;
  readonly totalCount: Scalars['Int']['output'];
}

export interface InvoiceStatsItem {
  readonly __typename?: 'InvoiceStatsItem';
  readonly count: Scalars['Int']['output'];
  readonly displayName: Scalars['String']['output'];
  readonly status: InvoiceStatus;
}

export const enum InvoiceStatus {
  /** Adjusted */
  Adjusted = 'ADJUSTED',
  /** Completed */
  Completed = 'COMPLETED',
  /** Data Outstanding */
  DataOutstanding = 'DATA_OUTSTANDING',
  /** Disputed */
  Disputed = 'DISPUTED',
  /** New */
  New = 'NEW',
  /** Pending Vms */
  PendingVms = 'PENDING_VMS',
  /** Reviewed */
  Reviewed = 'REVIEWED',
  /** Timecard */
  Timecard = 'TIMECARD'
};

export interface InvoicesReconcilePaginatedList {
  readonly __typename?: 'InvoicesReconcilePaginatedList';
  readonly items: ReadonlyArray<InvoiceReconcile>;
  readonly pageOffset?: Maybe<Scalars['Int']['output']>;
  readonly pageSize?: Maybe<Scalars['Int']['output']>;
  readonly totalCount: Scalars['Int']['output'];
  readonly totalCountAutoCompleted: Scalars['Int']['output'];
  readonly totalCountCompleted: Scalars['Int']['output'];
  readonly totalCountReviewed: Scalars['Int']['output'];
  readonly totalCountToReview: Scalars['Int']['output'];
}

export interface Job {
  readonly __typename?: 'Job';
  readonly activeApplicantsCount?: Maybe<Scalars['Int']['output']>;
  readonly allowedFacilities: ReadonlyArray<Facility>;
  readonly auditTitle?: Maybe<Scalars['String']['output']>;
  readonly business?: Maybe<Facility>;
  readonly canApply: AuthorizationResult;
  readonly canApplyWithInstantOffer: AuthorizationResult;
  readonly canFavorite: AuthorizationResult;
  readonly canWithdraw: AuthorizationResult;
  readonly cancellationPolicy?: Maybe<Scalars['String']['output']>;
  readonly certifications?: Maybe<Scalars['String']['output']>;
  readonly cityLocation?: Maybe<Location>;
  readonly clinicalUnit?: Maybe<ClinicalUnit>;
  readonly createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated use `createdAt` */
  readonly created_at?: Maybe<Scalars['String']['output']>;
  readonly curationTitle?: Maybe<Scalars['String']['output']>;
  readonly defaultPaymentDetails?: Maybe<JobPaymentDetails>;
  /** @deprecated use `defaultPaymentDetails` */
  readonly default_payment_details?: Maybe<JobPaymentDetails>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly emr?: Maybe<ReadonlyArray<Technology>>;
  readonly endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** @deprecated use `endDate` */
  readonly end_date?: Maybe<Scalars['String']['output']>;
  readonly esMatch?: Maybe<Match>;
  /** @deprecated use `esMatch` */
  readonly es_match?: Maybe<Match>;
  readonly facilityName?: Maybe<Scalars['String']['output']>;
  readonly favoritedCount?: Maybe<Scalars['Int']['output']>;
  readonly friendlyLicenseType?: Maybe<Scalars['String']['output']>;
  readonly grossPayWeekly?: Maybe<Scalars['Float']['output']>;
  readonly hoursPerShift?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use `hoursPerShift` */
  readonly hours_per_shift?: Maybe<Scalars['Int']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly instantOffer: Scalars['Boolean']['output'];
  readonly isAsap?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use `quickTurn` */
  readonly isCrisis: Scalars['Boolean']['output'];
  /** @deprecated use `isAsap` */
  readonly is_asap?: Maybe<Scalars['Boolean']['output']>;
  readonly jarCertification?: Maybe<JobApplicationRequirementsCertification>;
  readonly jarDriversLicense?: Maybe<JobApplicationRequirementsDriverLicense>;
  /** @deprecated use `jarFluVaccine` */
  readonly jarFluVaccination?: Maybe<JobApplicationRequirementsFluVaccination>;
  readonly jarFluVaccine?: Maybe<JobApplicationRequirementsFluVaccine>;
  readonly jarLocationFloatingRuleV2?: Maybe<JobApplicationRequirementsLocationFloating>;
  readonly jarMaximumTimeOff?: Maybe<JobApplicationRequirementsMaximumTimeOffRule>;
  readonly jarNurseReference?: Maybe<JobApplicationRequirementsNurseReference>;
  readonly jarProofOfIdentification?: Maybe<JobApplicationRequirementsProofOfIdentification>;
  readonly jarRadiusRule?: Maybe<JobApplicationRequirement>;
  readonly jarRadiusRuleV2?: Maybe<JobApplicationRequirementsRadiusRule>;
  readonly jarRoleExperience?: Maybe<JobApplicationRequirementsRoleExperience>;
  readonly jarStateLicense?: Maybe<JobApplicationRequirementsStateLicense>;
  readonly jarTechnologyExperience?: Maybe<ReadonlyArray<JobApplicationRequirementsTechnologyExperience>>;
  readonly jarTravelExperience?: Maybe<JobApplicationRequirementsTravelExperience>;
  readonly jarUnitExperience?: Maybe<JobApplicationRequirementsUnitExperience>;
  readonly jarUnitFloatingRule?: Maybe<JobApplicationRequirement>;
  readonly jarUnitFloatingRuleV2?: Maybe<JobApplicationRequirementsUnitFloating>;
  /** Job Application */
  readonly jobApplication?: Maybe<JobApplication>;
  /** @deprecated use `defaultPaymentDetails` */
  readonly jobPaymentDetails?: Maybe<ReadonlyArray<Maybe<JobPaymentDetailsModel>>>;
  /** @deprecated deprecated in favor of JobApplicationRequirements */
  readonly jobRequirements?: Maybe<ReadonlyArray<JobRequirement>>;
  readonly jobType?: Maybe<Scalars['String']['output']>;
  /**
   * Job Application
   * @deprecated use `jobApplication`
   */
  readonly job_application?: Maybe<JobApplication>;
  /** @deprecated use `defaultPaymentDetails` */
  readonly job_payment_details?: Maybe<ReadonlyArray<Maybe<JobPaymentDetailsModel>>>;
  /** @deprecated use `jobType` */
  readonly job_type?: Maybe<Scalars['String']['output']>;
  readonly latitude?: Maybe<Scalars['Float']['output']>;
  readonly lengthInWeeks?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use `lengthInWeeks` */
  readonly length_in_weeks?: Maybe<Scalars['Int']['output']>;
  readonly licenseState?: Maybe<Scalars['String']['output']>;
  readonly licenseTitle?: Maybe<Scalars['String']['output']>;
  readonly licenseType?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `licenseState` */
  readonly license_state?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `licenseTitle` */
  readonly license_title?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `licenseType` */
  readonly license_type?: Maybe<Scalars['String']['output']>;
  readonly localAllowed: Scalars['Boolean']['output'];
  readonly localGrossPayWeekly?: Maybe<Scalars['Float']['output']>;
  readonly localPaymentDetails?: Maybe<JobPaymentDetails>;
  readonly location?: Maybe<Location>;
  readonly longitude?: Maybe<Scalars['Float']['output']>;
  readonly manageEditUrl?: Maybe<Scalars['String']['output']>;
  readonly manageUrl?: Maybe<Scalars['String']['output']>;
  readonly nursePatientRatio?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `nursePatientRatio` */
  readonly nurse_patient_ratio?: Maybe<Scalars['String']['output']>;
  readonly occupation?: Maybe<Scalars['String']['output']>;
  readonly onHold?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use `onHold` */
  readonly on_hold?: Maybe<Scalars['Boolean']['output']>;
  readonly payPerWeek?: Maybe<Scalars['Float']['output']>;
  /** @deprecated use `defaultPaymentDetails` */
  readonly paymentDetails?: Maybe<JobPaymentDetails>;
  /** @deprecated use `defaultPaymentDetails` */
  readonly payment_details?: Maybe<JobPaymentDetails>;
  readonly positionCount?: Maybe<Scalars['Int']['output']>;
  readonly preferredJars?: Maybe<ReadonlyArray<JobApplicationRequirement>>;
  readonly preferredJarsV2?: Maybe<ReadonlyArray<JobApplicationRequirementUnion>>;
  readonly programName?: Maybe<Scalars['String']['output']>;
  readonly publicDescription?: Maybe<Scalars['String']['output']>;
  readonly quickTurn: Scalars['Boolean']['output'];
  readonly radiusRule?: Maybe<Scalars['Int']['output']>;
  readonly rate?: Maybe<Scalars['Float']['output']>;
  readonly references?: Maybe<Scalars['Boolean']['output']>;
  readonly requiredCertifications?: Maybe<Scalars['String']['output']>;
  readonly requiredJars?: Maybe<ReadonlyArray<JobApplicationRequirement>>;
  readonly requiredJarsV2?: Maybe<ReadonlyArray<JobApplicationRequirementUnion>>;
  readonly requiredSpecialties?: Maybe<Scalars['String']['output']>;
  readonly requiredUnitExperience?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `requiredCertifications` */
  readonly required_certifications?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `requiredSpecialties` */
  readonly required_specialties?: Maybe<Scalars['String']['output']>;
  /** @deprecated use roles.first */
  readonly role?: Maybe<Scalars['String']['output']>;
  readonly roles?: Maybe<ReadonlyArray<Role>>;
  readonly ruleValidations?: Maybe<ReadonlyArray<JobApplicationRequirementRuleEngineVerification>>;
  readonly shiftEnd?: Maybe<Scalars['String']['output']>;
  readonly shiftStart?: Maybe<Scalars['String']['output']>;
  readonly shiftType?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `shiftType` */
  readonly shift_type?: Maybe<Scalars['String']['output']>;
  readonly shiftsPerWeek?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use `shiftsPerWeek` */
  readonly shifts_per_week?: Maybe<Scalars['Int']['output']>;
  readonly skillsChecklist?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use `skillsChecklist` */
  readonly skills_checklist?: Maybe<Scalars['Boolean']['output']>;
  readonly startAsap?: Maybe<Scalars['Boolean']['output']>;
  readonly startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** @deprecated use `startAsap` */
  readonly start_asap?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use `startDate` */
  readonly start_date?: Maybe<Scalars['String']['output']>;
  readonly state?: Maybe<Scalars['String']['output']>;
  readonly stateActiveAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
  readonly travelAllowed: Scalars['Boolean']['output'];
  readonly uuid?: Maybe<Scalars['String']['output']>;
  readonly viewsCount?: Maybe<Scalars['Int']['output']>;
}


export interface JobEs_MatchArgs {
  skip_matching?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface JobJobRequirementsArgs {
  state?: InputMaybe<Scalars['String']['input']>;
}

export interface JobAlert {
  readonly __typename?: 'JobAlert';
  readonly broadPrefLocations: ReadonlyArray<BroadPrefLocations>;
  readonly clinicalSpecialties: ReadonlyArray<ClinicalSpecialty>;
  readonly contractLengths: ReadonlyArray<ContractLength>;
  readonly id: Scalars['ID']['output'];
  readonly locationStrings: ReadonlyArray<Scalars['String']['output']>;
  readonly shiftLengths: ReadonlyArray<Scalars['String']['output']>;
  readonly shiftPrefs: ReadonlyArray<Scalars['String']['output']>;
  readonly smsEnabled: Scalars['Boolean']['output'];
  readonly specialties: ReadonlyArray<Scalars['String']['output']>;
}

export interface JobApplication {
  readonly __typename?: 'JobApplication';
  readonly acceptIfOfferedCommitment?: Maybe<Scalars['Boolean']['output']>;
  readonly allowedFacilities?: Maybe<ReadonlyArray<JobApplicationAllowedFacility>>;
  readonly allowedFacilitiesShifts?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly applicationReadiness?: Maybe<ApplicationReadiness>;
  readonly candidateHoldReasons: ReadonlyArray<Scalars['String']['output']>;
  readonly createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly esMatch?: Maybe<Match>;
  readonly hasAllowedFacilities?: Maybe<Scalars['Boolean']['output']>;
  readonly hasSpecialRequest?: Maybe<Scalars['Boolean']['output']>;
  readonly hasTimeoffRequest?: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly interviewAvailability?: Maybe<Scalars['String']['output']>;
  readonly isAutoApplication: Scalars['Boolean']['output'];
  readonly job: Job;
  readonly nurseProfile?: Maybe<NurseProfile>;
  readonly paymentDetails?: Maybe<JobPaymentDetails>;
  readonly preferredStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly requestedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly ruleValidations?: Maybe<ReadonlyArray<JobApplicationRequirementRuleEngineVerification>>;
  readonly specialRequest?: Maybe<Scalars['String']['output']>;
  readonly startImmediatelyCommitment?: Maybe<Scalars['Boolean']['output']>;
  readonly state?: Maybe<Scalars['String']['output']>;
  readonly timeOffRequests?: Maybe<ReadonlyArray<TimeOffRequest>>;
}

export interface JobApplicationAllowedFacility {
  readonly __typename?: 'JobApplicationAllowedFacility';
  readonly facilityId: Scalars['ID']['output'];
}

/** The connection type for JobApplication. */
export interface JobApplicationConnection {
  readonly __typename?: 'JobApplicationConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<JobApplicationEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<JobApplication>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface JobApplicationEdge {
  readonly __typename?: 'JobApplicationEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<JobApplication>;
}

export interface JobApplicationRequirement {
  readonly __typename?: 'JobApplicationRequirement';
  readonly booleanValue?: Maybe<Scalars['Boolean']['output']>;
  readonly boosterRequired?: Maybe<Scalars['Boolean']['output']>;
  readonly certification?: Maybe<Certification>;
  readonly certificationId?: Maybe<Scalars['ID']['output']>;
  readonly declinationsAccepted?: Maybe<Scalars['Boolean']['output']>;
  readonly enforcementType?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly idValue?: Maybe<Scalars['ID']['output']>;
  readonly localAllowed?: Maybe<Scalars['Boolean']['output']>;
  readonly numericValue?: Maybe<Scalars['Float']['output']>;
  readonly technology?: Maybe<Technology>;
  readonly textValue?: Maybe<Scalars['String']['output']>;
  readonly travelAllowed?: Maybe<Scalars['Boolean']['output']>;
  readonly type?: Maybe<Scalars['String']['output']>;
  readonly vaccinationRequired?: Maybe<Scalars['Boolean']['output']>;
}

export interface JobApplicationRequirementRuleEngineVerification {
  readonly __typename?: 'JobApplicationRequirementRuleEngineVerification';
  readonly errorMessages?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly type: Scalars['String']['output'];
  readonly valid?: Maybe<Scalars['Boolean']['output']>;
}

export const enum JobApplicationRequirementStageEnum {
  /** Application */
  Application = 'application',
  /** Onboarding */
  Onboarding = 'onboarding'
};

/** Job Application Requirements Union Type */
export type JobApplicationRequirementUnion = JobApplicationRequirementsCertification | JobApplicationRequirementsCovidBooster | JobApplicationRequirementsCovidVaccine | JobApplicationRequirementsDriverLicense | JobApplicationRequirementsEducation | JobApplicationRequirementsFluVaccination | JobApplicationRequirementsFluVaccine | JobApplicationRequirementsLocationFloating | JobApplicationRequirementsMaximumTimeOffRule | JobApplicationRequirementsNurseReference | JobApplicationRequirementsProofOfIdentification | JobApplicationRequirementsRadiusRule | JobApplicationRequirementsRoleExperience | JobApplicationRequirementsStateLicense | JobApplicationRequirementsTechnologyExperience | JobApplicationRequirementsTraumaLevelExperience | JobApplicationRequirementsTravelExperience | JobApplicationRequirementsUnitExperience | JobApplicationRequirementsUnitFloating;

export interface JobApplicationRequirementsCertification {
  readonly __typename?: 'JobApplicationRequirementsCertification';
  readonly certification: Certification;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly enforcementType?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly issuingBodies?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
  readonly type: Scalars['String']['output'];
}

export interface JobApplicationRequirementsCovidBooster {
  readonly __typename?: 'JobApplicationRequirementsCovidBooster';
  readonly declinationsNotAccepted?: Maybe<Scalars['Boolean']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly medicalDeclinationsAccepted?: Maybe<Scalars['Boolean']['output']>;
  readonly personalDeclinationsAccepted?: Maybe<Scalars['Boolean']['output']>;
  readonly religiousDeclinationsAccepted?: Maybe<Scalars['Boolean']['output']>;
  readonly stage: JobApplicationRequirementStageEnum;
  readonly type: Scalars['String']['output'];
}

export interface JobApplicationRequirementsCovidVaccine {
  readonly __typename?: 'JobApplicationRequirementsCovidVaccine';
  readonly declinationsNotAccepted?: Maybe<Scalars['Boolean']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly medicalDeclinationsAccepted?: Maybe<Scalars['Boolean']['output']>;
  readonly religiousDeclinationsAccepted?: Maybe<Scalars['Boolean']['output']>;
  readonly stage: JobApplicationRequirementStageEnum;
  readonly type: Scalars['String']['output'];
}

export interface JobApplicationRequirementsDriverLicense {
  readonly __typename?: 'JobApplicationRequirementsDriverLicense';
  readonly id: Scalars['ID']['output'];
  readonly required?: Maybe<Scalars['Boolean']['output']>;
  readonly stage: JobApplicationRequirementStageEnum;
  readonly type: Scalars['String']['output'];
}

export interface JobApplicationRequirementsEducation {
  readonly __typename?: 'JobApplicationRequirementsEducation';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly enforcementType: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly type: Scalars['String']['output'];
}

export interface JobApplicationRequirementsFluVaccination {
  readonly __typename?: 'JobApplicationRequirementsFluVaccination';
  readonly declinationsAccepted?: Maybe<Scalars['Boolean']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly enforcementType?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly stage: JobApplicationRequirementStageEnum;
  readonly type: Scalars['String']['output'];
  readonly vaccinationRequired?: Maybe<Scalars['Boolean']['output']>;
}

export interface JobApplicationRequirementsFluVaccine {
  readonly __typename?: 'JobApplicationRequirementsFluVaccine';
  readonly declinationsNotAccepted?: Maybe<Scalars['Boolean']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly medicalDeclinationsAccepted?: Maybe<Scalars['Boolean']['output']>;
  readonly personalDeclinationsAccepted?: Maybe<Scalars['Boolean']['output']>;
  readonly religiousDeclinationsAccepted?: Maybe<Scalars['Boolean']['output']>;
  readonly stage: JobApplicationRequirementStageEnum;
  readonly type: Scalars['String']['output'];
}

export interface JobApplicationRequirementsLocationFloating {
  readonly __typename?: 'JobApplicationRequirementsLocationFloating';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly floatToLocation?: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly type: Scalars['String']['output'];
}

export interface JobApplicationRequirementsMaximumTimeOffRule {
  readonly __typename?: 'JobApplicationRequirementsMaximumTimeOffRule';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly maximumTimeOff: Scalars['Float']['output'];
  readonly type: Scalars['String']['output'];
}

export interface JobApplicationRequirementsNurseReference {
  readonly __typename?: 'JobApplicationRequirementsNurseReference';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly occurrences?: Maybe<Scalars['Int']['output']>;
  readonly referenceType?: Maybe<Scalars['String']['output']>;
  readonly timeframe?: Maybe<Scalars['Int']['output']>;
  readonly type: Scalars['String']['output'];
}

export interface JobApplicationRequirementsProofOfIdentification {
  readonly __typename?: 'JobApplicationRequirementsProofOfIdentification';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly driversLicenseRequired?: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly required?: Maybe<Scalars['Boolean']['output']>;
  readonly stage: JobApplicationRequirementStageEnum;
  readonly type: Scalars['String']['output'];
}

export interface JobApplicationRequirementsRadiusRule {
  readonly __typename?: 'JobApplicationRequirementsRadiusRule';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly localAllowed?: Maybe<Scalars['Boolean']['output']>;
  readonly radius?: Maybe<Scalars['Float']['output']>;
  readonly travelAllowed?: Maybe<Scalars['Boolean']['output']>;
  readonly type: Scalars['String']['output'];
}

export interface JobApplicationRequirementsRoleExperience {
  readonly __typename?: 'JobApplicationRequirementsRoleExperience';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly enforcementType?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly months?: Maybe<Scalars['Float']['output']>;
  readonly type: Scalars['String']['output'];
}

export interface JobApplicationRequirementsStateLicense {
  readonly __typename?: 'JobApplicationRequirementsStateLicense';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly stage: JobApplicationRequirementStageEnum;
  readonly type: Scalars['String']['output'];
}

export interface JobApplicationRequirementsTechnologyExperience {
  readonly __typename?: 'JobApplicationRequirementsTechnologyExperience';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly enforcementType?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly months?: Maybe<Scalars['Float']['output']>;
  readonly technology: Technology;
  readonly type: Scalars['String']['output'];
}

export interface JobApplicationRequirementsTraumaLevelExperience {
  readonly __typename?: 'JobApplicationRequirementsTraumaLevelExperience';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly enforcementType: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly type: Scalars['String']['output'];
}

export interface JobApplicationRequirementsTravelExperience {
  readonly __typename?: 'JobApplicationRequirementsTravelExperience';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly enforcementType?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly months?: Maybe<Scalars['Float']['output']>;
  readonly type: Scalars['String']['output'];
}

export interface JobApplicationRequirementsUnitExperience {
  readonly __typename?: 'JobApplicationRequirementsUnitExperience';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly enforcementType?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly months?: Maybe<Scalars['Float']['output']>;
  readonly type: Scalars['String']['output'];
}

export interface JobApplicationRequirementsUnitFloating {
  readonly __typename?: 'JobApplicationRequirementsUnitFloating';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly floatToUnit?: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly type: Scalars['String']['output'];
}

export interface JobApplicationStateInstruction {
  readonly __typename?: 'JobApplicationStateInstruction';
  readonly kind: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly state: JobApplicationStateInstructionEnum;
  readonly title: Scalars['String']['output'];
}

export const enum JobApplicationStateInstructionEnum {
  ActionRequired = 'action_required',
  PendingTrustedReview = 'pending_trusted_review',
  SubmittedToFacility = 'submitted_to_facility'
};

export interface JobApplicationsSummary {
  readonly __typename?: 'JobApplicationsSummary';
  readonly actionRequired: ReadonlyArray<JobApplication>;
  readonly drafted: ReadonlyArray<JobApplication>;
  readonly id: Scalars['ID']['output'];
  readonly offer: ReadonlyArray<JobOffer>;
  readonly pendingTrustedReview: ReadonlyArray<JobApplication>;
  readonly previous: ReadonlyArray<JobApplication>;
  readonly submittedToFacility: ReadonlyArray<JobApplication>;
}

/** The connection type for Job. */
export interface JobConnection {
  readonly __typename?: 'JobConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<JobEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Job>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface JobEdge {
  readonly __typename?: 'JobEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Job>;
}

export interface JobOffer {
  readonly __typename?: 'JobOffer';
  readonly clinicianAcceptedInapp?: Maybe<Scalars['Boolean']['output']>;
  readonly contractNotes?: Maybe<Scalars['String']['output']>;
  readonly contracts?: Maybe<ReadonlyArray<Contract>>;
  readonly endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly hoursPerShift?: Maybe<Scalars['Int']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly job: Job;
  readonly jobApplication: JobApplication;
  readonly lengthInWeeks?: Maybe<Scalars['Int']['output']>;
  readonly nonClinicalRate?: Maybe<Scalars['Float']['output']>;
  readonly nurseAdvocateEmail?: Maybe<Scalars['String']['output']>;
  readonly paymentDetails?: Maybe<JobPaymentDetails>;
  readonly shiftType?: Maybe<Scalars['String']['output']>;
  readonly shiftsPerWeek?: Maybe<Scalars['Int']['output']>;
  readonly startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly status: JobOfferEnum;
  readonly timeOffs?: Maybe<ReadonlyArray<TimeOff>>;
  readonly uuid: Scalars['String']['output'];
}

export const enum JobOfferEnum {
  /** Accepted */
  Accepted = 'accepted',
  /** Declined */
  Declined = 'declined',
  /** Pending */
  Pending = 'pending',
  /** Rescinded */
  Rescinded = 'rescinded',
  /** Sent */
  Sent = 'sent',
  /** Voided */
  Voided = 'voided'
};

export const enum JobOffersFilter {
  Accepted = 'accepted',
  All = 'all',
  Pending = 'pending',
  Previous = 'previous',
  UpcomingAccepted = 'upcoming_accepted'
};

export interface JobPaymentConfig {
  readonly __typename?: 'JobPaymentConfig';
  readonly healthEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use `healthEnabled` */
  readonly health_enabled?: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly jobType?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `jobType` */
  readonly job_type?: Maybe<Scalars['String']['output']>;
  readonly relocationComp?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use `relocationComp` */
  readonly relocation_comp?: Maybe<Scalars['Int']['output']>;
  readonly uuid?: Maybe<Scalars['String']['output']>;
}

export interface JobPaymentDetails {
  readonly __typename?: 'JobPaymentDetails';
  readonly blendedWageRate?: Maybe<Scalars['Float']['output']>;
  /** @deprecated use `blendedWageRage` */
  readonly blended_wage_rate?: Maybe<Scalars['Float']['output']>;
  readonly calculatorVersion?: Maybe<Scalars['String']['output']>;
  readonly callBackRate?: Maybe<Scalars['Float']['output']>;
  /** @deprecated use `callBackRate` */
  readonly call_back_rate?: Maybe<Scalars['Float']['output']>;
  readonly chargeRate?: Maybe<Scalars['Float']['output']>;
  readonly doubleTimeMultiplier?: Maybe<Scalars['Float']['output']>;
  /** @deprecated use `doubleTimeMultiplier` */
  readonly double_time_multiplier?: Maybe<Scalars['Float']['output']>;
  readonly extraRate?: Maybe<Scalars['Float']['output']>;
  /** @deprecated use `extraRate` */
  readonly extra_rate?: Maybe<Scalars['Float']['output']>;
  readonly grossPayWeekly?: Maybe<Scalars['Float']['output']>;
  /** @deprecated use `grossPayWeekly` */
  readonly gross_pay_weekly?: Maybe<Scalars['Float']['output']>;
  readonly holidayRate?: Maybe<Scalars['Float']['output']>;
  /** @deprecated use `holidayRate` */
  readonly holiday_rate?: Maybe<Scalars['Float']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly incidentalsStipendDaily?: Maybe<Scalars['Float']['output']>;
  /** @deprecated use `incidentialsStipendDaily` */
  readonly incidentals_stipend_daily?: Maybe<Scalars['Float']['output']>;
  readonly lodgingStipendDaily?: Maybe<Scalars['Float']['output']>;
  /** @deprecated use `lodgingStipendDaily` */
  readonly lodging_stipend_daily?: Maybe<Scalars['Float']['output']>;
  readonly nonTaxableStipendWeekly?: Maybe<Scalars['Float']['output']>;
  readonly onCallRate?: Maybe<Scalars['Float']['output']>;
  /** @deprecated use `onCallRate` */
  readonly on_call_rate?: Maybe<Scalars['Float']['output']>;
  readonly overtimeHoursPerWeek?: Maybe<Scalars['Int']['output']>;
  readonly overtimeMultiplier?: Maybe<Scalars['Float']['output']>;
  readonly overtimeWageRate?: Maybe<Scalars['Float']['output']>;
  /** @deprecated use `overtimeHoursPerWeek` */
  readonly overtime_hours_per_week?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use `overtimeMultiplier` */
  readonly overtime_multiplier?: Maybe<Scalars['Float']['output']>;
  /** @deprecated use `overtimeWageRate` */
  readonly overtime_wage_rate?: Maybe<Scalars['Float']['output']>;
  readonly regularHoursPerWeek?: Maybe<Scalars['Int']['output']>;
  readonly regularWageRate?: Maybe<Scalars['Float']['output']>;
  /** @deprecated use `regularHoursPerWeek` */
  readonly regular_hours_per_week?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use `regularWageRate` */
  readonly regular_wage_rate?: Maybe<Scalars['Float']['output']>;
  readonly taxableWageRateWeekly?: Maybe<Scalars['Float']['output']>;
  readonly totalHoursPerWeek?: Maybe<Scalars['Int']['output']>;
  readonly totalStipendDaily?: Maybe<Scalars['Float']['output']>;
  /** @deprecated use `totalHoursPerWeek` */
  readonly total_hours_per_week?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use `totalStipendDaily` */
  readonly total_stipend_daily?: Maybe<Scalars['Float']['output']>;
  readonly trustedRate?: Maybe<Scalars['Float']['output']>;
  /** @deprecated use `trustedRate` */
  readonly trusted_rate?: Maybe<Scalars['Float']['output']>;
}

export interface JobPaymentDetailsModel {
  readonly __typename?: 'JobPaymentDetailsModel';
  readonly id: Scalars['ID']['output'];
  readonly job?: Maybe<Job>;
  /** @deprecated this model isn't used anymore */
  readonly jobPaymentConfig?: Maybe<JobPaymentConfig>;
  readonly paymentDetails?: Maybe<JobPaymentDetails>;
  readonly uuid?: Maybe<Scalars['String']['output']>;
}

export interface JobPlacement {
  readonly __typename?: 'JobPlacement';
  readonly adminUser?: Maybe<AdminUser>;
  readonly authorizationContractFile?: Maybe<File>;
  readonly contracts?: Maybe<ReadonlyArray<Contract>>;
  readonly endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** @deprecated use `endDate` */
  readonly end_date?: Maybe<Scalars['String']['output']>;
  readonly extensionRequest?: Maybe<ExtensionRequest>;
  readonly extensionRequestStatus?: Maybe<ExtensionRequestStatus>;
  readonly facility?: Maybe<Facility>;
  readonly facilityLocation?: Maybe<Location>;
  readonly facilityName?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `facilityLocation` */
  readonly facility_location?: Maybe<Location>;
  /** @deprecated use `facilityName` */
  readonly facility_name?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly isCurrentContract?: Maybe<Scalars['Boolean']['output']>;
  readonly isOnboardingCompleted?: Maybe<Scalars['Boolean']['output']>;
  readonly isOnboardingListPending?: Maybe<Scalars['Boolean']['output']>;
  readonly job?: Maybe<Job>;
  readonly jobPlacementSchedule: JobPlacementSchedule;
  readonly karmaCheckBackgroundCheckComplianceUrl?: Maybe<Scalars['String']['output']>;
  readonly karmaCheckBackgroundCheckOnboardingUrl?: Maybe<Scalars['String']['output']>;
  readonly karmaCheckOccuhealthComplianceUrl?: Maybe<Scalars['String']['output']>;
  readonly karmaCheckOccuhealthOnboardingUrl?: Maybe<Scalars['String']['output']>;
  readonly lat?: Maybe<Scalars['Float']['output']>;
  readonly latitude?: Maybe<Scalars['Float']['output']>;
  readonly lng?: Maybe<Scalars['Float']['output']>;
  readonly locationCityState?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `locationCityState` */
  readonly location_city_state?: Maybe<Scalars['String']['output']>;
  readonly longitude?: Maybe<Scalars['Float']['output']>;
  readonly marker_info: Scalars['String']['output'];
  readonly mealWaiverStatus?: Maybe<Scalars['String']['output']>;
  readonly nurseProfile?: Maybe<NurseProfile>;
  readonly onboardingJobOffer?: Maybe<JobOffer>;
  readonly startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** @deprecated use `startDate` */
  readonly start_date?: Maybe<Scalars['String']['output']>;
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly timekeepingAttributes?: Maybe<TimekeepingAttributes>;
  readonly uuid?: Maybe<Scalars['String']['output']>;
}

/** The connection type for JobPlacement. */
export interface JobPlacementConnection {
  readonly __typename?: 'JobPlacementConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<JobPlacementEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<JobPlacement>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface JobPlacementEdge {
  readonly __typename?: 'JobPlacementEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<JobPlacement>;
}

export interface JobPlacementSchedule {
  readonly __typename?: 'JobPlacementSchedule';
  readonly altWeeker: Scalars['Boolean']['output'];
  readonly endSec?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use `endSec` */
  readonly end_sec?: Maybe<Scalars['Int']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly jobPlacement: JobPlacement;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly startSec?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use `startSec` */
  readonly start_sec?: Maybe<Scalars['Int']['output']>;
  readonly surveys: ReadonlyArray<UserSurvey>;
  readonly timeEntryDays?: Maybe<ReadonlyArray<Maybe<TimeEntryDay>>>;
  readonly timeEntryDescriptionList?: Maybe<ReadonlyArray<TimeEntryDescription>>;
  /** @deprecated use `timeEntryDays` */
  readonly time_entry_days?: Maybe<ReadonlyArray<Maybe<TimeEntryDay>>>;
  readonly timezone?: Maybe<Scalars['String']['output']>;
  readonly totalHours: Scalars['Float']['output'];
  readonly totalShifts: Scalars['Int']['output'];
  readonly uuid?: Maybe<Scalars['String']['output']>;
  readonly viewerCanSubmit: Scalars['Boolean']['output'];
  readonly weeklyTimesheets?: Maybe<ReadonlyArray<Maybe<TimeSheet>>>;
  readonly workIntervals?: Maybe<ReadonlyArray<Maybe<WorkInterval>>>;
}

export const enum JobPlacementScope {
  /** Active Job Placements */
  Active = 'active',
  /** Working Job Placements */
  Working = 'working'
};

export interface JobRequirement {
  readonly __typename?: 'JobRequirement';
  readonly message?: Maybe<Scalars['String']['output']>;
  readonly ruleData?: Maybe<JobRequirementDataType>;
  readonly ruleLevel?: Maybe<Scalars['String']['output']>;
  readonly ruleName?: Maybe<Scalars['String']['output']>;
  readonly state: JobRequirementStateType;
}

export interface JobRequirementDataType {
  readonly __typename?: 'JobRequirementDataType';
  readonly existingJobApplication?: Maybe<JobApplication>;
  readonly missingCertification?: Maybe<Scalars['String']['output']>;
  readonly missingReferences?: Maybe<Scalars['String']['output']>;
  readonly requiredCredentials?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly requiredReferences?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
}

export const enum JobRequirementStateType {
  /** Error */
  Error = 'ERROR',
  /** Success */
  Success = 'SUCCESS',
  /** Warning */
  Warning = 'WARNING'
};

export const enum JobRole {
  Practical = 'PRACTICAL',
  Registered = 'REGISTERED'
};

export const enum JobType {
  Staff = 'STAFF',
  Travel = 'TRAVEL'
};

export interface JobVisualization {
  readonly __typename?: 'JobVisualization';
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly id: Scalars['ID']['output'];
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly viewableId?: Maybe<Scalars['String']['output']>;
  readonly viewableType?: Maybe<Scalars['String']['output']>;
}

export interface JobWithError {
  readonly __typename?: 'JobWithError';
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly job: Job;
}

export interface JobsCollection {
  readonly __typename?: 'JobsCollection';
  readonly filterType: JobsCollectionFilterTypeEnum;
  readonly id: Scalars['ID']['output'];
  readonly recommendations: ReadonlyArray<Job>;
  readonly records: ReadonlyArray<Job>;
  readonly totalRecords: Scalars['Int']['output'];
}

export interface JobsCollectionByLocation {
  readonly __typename?: 'JobsCollectionByLocation';
  readonly jobs: JobsCollection;
  readonly location: Location;
}

export const enum JobsCollectionFilterTypeEnum {
  /** Anywhere */
  Anywhere = 'anywhere',
  /** By Location */
  ByLocation = 'by_location',
  /** By State */
  ByState = 'by_state',
  /** Full */
  Full = 'full'
};

export interface JobsCollectionFiltersInput {
  readonly clinicalUnitId?: InputMaybe<Scalars['ID']['input']>;
  readonly clinicalUnitSlug?: InputMaybe<Scalars['String']['input']>;
  readonly clinicalUnitSlugs?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly compact?: InputMaybe<Scalars['Boolean']['input']>;
  readonly contractLengths?: InputMaybe<ReadonlyArray<ContractLength>>;
  readonly earliestStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly excludeFavoritedJobs?: InputMaybe<Scalars['Boolean']['input']>;
  readonly excludeJobs?: InputMaybe<Scalars['Boolean']['input']>;
  readonly firstTimeTravelerFriendly?: InputMaybe<Scalars['Boolean']['input']>;
  readonly instantOffer?: InputMaybe<Scalars['Boolean']['input']>;
  readonly jobType?: InputMaybe<JobType>;
  readonly jobTypes?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly locationString?: InputMaybe<Scalars['String']['input']>;
  readonly locationStrings?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly magnetPref?: InputMaybe<Scalars['String']['input']>;
  readonly role?: InputMaybe<JobRole>;
  readonly roleIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly roleType?: InputMaybe<Scalars['String']['input']>;
  readonly seenStatus?: InputMaybe<Scalars['String']['input']>;
  readonly shiftLengths?: InputMaybe<ReadonlyArray<ShiftLength>>;
  readonly shiftType?: InputMaybe<Scalars['String']['input']>;
  readonly shiftTypes?: InputMaybe<ReadonlyArray<ShiftType>>;
  readonly source?: InputMaybe<Scalars['String']['input']>;
  readonly specialtyFullNames?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly specialtySlugs?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly startPref?: InputMaybe<Scalars['String']['input']>;
  readonly technologies?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly unitName?: InputMaybe<Scalars['String']['input']>;
}

export const enum JobsCollectionSortField {
  /** Created At */
  CreatedAt = 'CREATED_AT',
  /** Gross Pay Weekly */
  GrossPayWeekly = 'GROSS_PAY_WEEKLY',
  /** Relevance */
  Relevance = 'RELEVANCE',
  /** Start Date */
  StartDate = 'START_DATE'
};

export interface JobsCollectionSortInput {
  readonly direction?: InputMaybe<OrderDirection>;
  readonly field?: InputMaybe<JobsCollectionSortField>;
}

export const enum JobsCollectionSortOrder {
  /** Asc */
  Asc = 'ASC',
  /** Desc */
  Desc = 'DESC'
};

/** The connection type for Job. */
export interface JobsConnection {
  readonly __typename?: 'JobsConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<JobsEdge>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Job>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface JobsEdge {
  readonly __typename?: 'JobsEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Job>;
}

export interface Language {
  readonly __typename?: 'Language';
  readonly id: Scalars['ID']['output'];
  readonly language: Scalars['String']['output'];
  readonly proficiency: Scalars['String']['output'];
  readonly uuid: Scalars['String']['output'];
}

export const enum LanguageProficiencyType {
  /** Basic */
  Basic = 'basic',
  /** Conversational */
  Conversational = 'conversational',
  /** Native / Bilingual */
  NativeBilingual = 'native_bilingual'
};

export const enum LanguageType {
  /** Akan */
  Akan = 'akan',
  /** Amharic */
  Amharic = 'amharic',
  /** Arabic */
  Arabic = 'arabic',
  /** Assamese */
  Assamese = 'assamese',
  /** Awadhi */
  Awadhi = 'awadhi',
  /** Azerbaijani */
  Azerbaijani = 'azerbaijani',
  /** Balochi */
  Balochi = 'balochi',
  /** Belarusian */
  Belarusian = 'belarusian',
  /** Bengali (Bangla) */
  Bengali = 'bengali',
  /** Bhojpuri */
  Bhojpuri = 'bhojpuri',
  /** Cebuano (Visayan) */
  Cebuano = 'cebuano',
  /** Chewa */
  Chewa = 'chewa',
  /** Chhattisgarhi */
  Chhattisgarhi = 'chhattisgarhi',
  /** Chittagonian */
  Chittagonian = 'chittagonian',
  /** Czech */
  Czech = 'czech',
  /** Deccan */
  Deccan = 'deccan',
  /** Dhundhari */
  Dhundhari = 'dhundhari',
  /** Dutch */
  Dutch = 'dutch',
  /** Eastern Min (inc. Fuzhounese) */
  EasternMin = 'eastern_min',
  /** English */
  English = 'english',
  /** French */
  French = 'french',
  /** Fula */
  Fula = 'fula',
  /** Gan Chinese */
  GanChinese = 'gan_chinese',
  /** German */
  German = 'german',
  /** Greek */
  Greek = 'greek',
  /** Gujarati */
  Gujarati = 'gujarati',
  /** Haitian Creole */
  HaitianCreole = 'haitian_creole',
  /** Hakka */
  Hakka = 'hakka',
  /** Haryanvi */
  Haryanvi = 'haryanvi',
  /** Hausa */
  Hausa = 'hausa',
  /** Hiligaynon/Ilonggo (Visayan) */
  Hiligaynon = 'hiligaynon',
  /** Hindi */
  Hindi = 'hindi',
  /** Hmong */
  Hmong = 'hmong',
  /** Hungarian */
  Hungarian = 'hungarian',
  /** Igbo */
  Igbo = 'igbo',
  /** Ilocano */
  Ilocano = 'ilocano',
  /** Italian */
  Italian = 'italian',
  /** Japanese */
  Japanese = 'japanese',
  /** Javanese */
  Javanese = 'javanese',
  /** Jin */
  Jin = 'jin',
  /** Kannada */
  Kannada = 'kannada',
  /** Kazakh */
  Kazakh = 'kazakh',
  /** Khmer */
  Khmer = 'khmer',
  /** Kinyarwanda */
  Kinyarwanda = 'kinyarwanda',
  /** Kirundi */
  Kirundi = 'kirundi',
  /** Konkani */
  Konkani = 'konkani',
  /** Korean */
  Korean = 'korean',
  /** Kurdish */
  Kurdish = 'kurdish',
  /** Madurese */
  Madurese = 'madurese',
  /** Magahi */
  Magahi = 'magahi',
  /** Maithili */
  Maithili = 'maithili',
  /** Malagasy */
  Malagasy = 'malagasy',
  /** Malay (inc. Malaysian and Indonesian) */
  Malay = 'malay',
  /** Malayalam */
  Malayalam = 'malayalam',
  /** Mandarin */
  Mandarin = 'mandarin',
  /** Marathi */
  Marathi = 'marathi',
  /** Marwari */
  Marwari = 'marwari',
  /** Mossi */
  Mossi = 'mossi',
  /** Nepali */
  Nepali = 'nepali',
  /** Northern Min */
  NorthernMin = 'northern_min',
  /** Odia */
  Odia = 'odia',
  /** Oromo */
  Oromo = 'oromo',
  /** Pashto */
  Pashto = 'pashto',
  /** Polish */
  Polish = 'polish',
  /** Portuguese */
  Portuguese = 'portuguese',
  /** Punjabi */
  Punjabi = 'punjabi',
  /** Quechua */
  Quechua = 'quechua',
  /** Romanian */
  Romanian = 'romanian',
  /** Russian */
  Russian = 'russian',
  /** Saraiki */
  Saraiki = 'saraiki',
  /** Serbo-Croatian */
  SerboCroatian = 'serbo_croatian',
  /** Shona */
  Shona = 'shona',
  /** Sindhi */
  Sindhi = 'sindhi',
  /** Sinhalese */
  Sinhalese = 'sinhalese',
  /** Somali */
  Somali = 'somali',
  /** Southern Min (incl. Hokkien and Teochew) */
  SouthernMin = 'southern_min',
  /** Spanish */
  Spanish = 'spanish',
  /** Sundanese */
  Sundanese = 'sundanese',
  /** Swedish */
  Swedish = 'swedish',
  /** Sylheti */
  Sylheti = 'sylheti',
  /** Tagalog (Filipino) */
  Tagalog = 'tagalog',
  /** Tamil */
  Tamil = 'tamil',
  /** Telugu */
  Telugu = 'telugu',
  /** Thai */
  Thai = 'thai',
  /** Turkish */
  Turkish = 'turkish',
  /** Turkmen */
  Turkmen = 'turkmen',
  /** Ukrainian */
  Ukrainian = 'ukrainian',
  /** Urdu */
  Urdu = 'urdu',
  /** Uyghur */
  Uyghur = 'uyghur',
  /** Uzbek */
  Uzbek = 'uzbek',
  /** Vietnamese */
  Vietnamese = 'vietnamese',
  /** Wu (e.g. Shanghainese) */
  Wu = 'wu',
  /** Xhosa */
  Xhosa = 'xhosa',
  /** Xiang (Hunanese) */
  Xiang = 'xiang',
  /** Yoruba */
  Yoruba = 'yoruba',
  /** Yue (incl. Cantonese) */
  Yue = 'yue',
  /** Zhuang */
  Zhuang = 'zhuang',
  /** Zulu */
  Zulu = 'zulu'
};

export interface LedgerAttachment {
  readonly __typename?: 'LedgerAttachment';
  readonly archivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly file: File;
  readonly id: Scalars['ID']['output'];
  readonly status: Scalars['String']['output'];
  readonly timecardOcrParsing?: Maybe<TimecardOcrParsing>;
}

export interface LedgerLink {
  readonly __typename?: 'LedgerLink';
  readonly description: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly ledgerId: Scalars['String']['output'];
  readonly link: Scalars['String']['output'];
}

export interface LedgerLinkInput {
  readonly description: Scalars['String']['input'];
  readonly ledgerId: Scalars['ID']['input'];
  readonly link: Scalars['String']['input'];
}

export interface License extends Credential {
  readonly __typename?: 'License';
  readonly compact?: Maybe<Scalars['Boolean']['output']>;
  readonly completedOn?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly daysUntilExpiration?: Maybe<Scalars['Int']['output']>;
  readonly expirationType: DocumentExpiration;
  readonly expiresOn?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly files?: Maybe<ReadonlyArray<File>>;
  readonly friendlyLicenseType?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly isExpired: Scalars['Boolean']['output'];
  readonly isExpiringSoon: Scalars['Boolean']['output'];
  readonly isVerified?: Maybe<Scalars['Boolean']['output']>;
  readonly licenseType?: Maybe<Scalars['String']['output']>;
  readonly licensureCompact?: Maybe<Scalars['String']['output']>;
  readonly number?: Maybe<Scalars['String']['output']>;
  readonly state?: Maybe<Scalars['String']['output']>;
  readonly stateCode?: Maybe<LocationUsStates>;
  readonly title: Scalars['String']['output'];
  readonly uuid?: Maybe<Scalars['String']['output']>;
  readonly verifiedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly verifiedByName?: Maybe<Scalars['String']['output']>;
}

export const enum LicenseType {
  /** Certified Registered Nurse Anesthetist */
  Anesthetist = 'ANESTHETIST',
  /** Cath Lab Or Interventional Technologist */
  CathLabOrInterventionalTechnologist = 'CATH_LAB_OR_INTERVENTIONAL_TECHNOLOGIST',
  /** Certified Behavior Analyst */
  CertifiedBehaviorAnalyst = 'CERTIFIED_BEHAVIOR_ANALYST',
  /** Clinical Nurse Specialist */
  Clinical = 'CLINICAL',
  /** Clinical Psychologist */
  ClinicalPsychologist = 'CLINICAL_PSYCHOLOGIST',
  /** Cytotechnologist */
  Cytotechnologist = 'CYTOTECHNOLOGIST',
  /** Dietetic Tech */
  DieteticTech = 'DIETETIC_TECH',
  /** Dietician */
  Dietician = 'DIETICIAN',
  /** Dosimetrist */
  Dosimetrist = 'DOSIMETRIST',
  /** Histotechnician */
  Histotechnician = 'HISTOTECHNICIAN',
  /** Histotechnologist */
  Histotechnologist = 'HISTOTECHNOLOGIST',
  /** Laboratory Technician */
  LaboratoryTechnician = 'LABORATORY_TECHNICIAN',
  /** Lab Scientist */
  LabScientist = 'LAB_SCIENTIST',
  /** Licensed Therapist Or Counselor */
  LicensedTherapistOrCounselor = 'LICENSED_THERAPIST_OR_COUNSELOR',
  /** Mental Health Technician */
  MentalHealthTechnician = 'MENTAL_HEALTH_TECHNICIAN',
  /** Certified Nurse Midwife */
  Midwife = 'MIDWIFE',
  /** Neurodiagnostic Technician */
  NeurodiagnosticTechnician = 'NEURODIAGNOSTIC_TECHNICIAN',
  /** Certified Nursing Assistant */
  NursingAssistant = 'NURSING_ASSISTANT',
  /** Occupational Therapist */
  OccupationalTherapist = 'OCCUPATIONAL_THERAPIST',
  /** Occupational Therapist Assistant */
  OccupationalTherapistAssistant = 'OCCUPATIONAL_THERAPIST_ASSISTANT',
  /** Pharmacist */
  Pharmacist = 'PHARMACIST',
  /** Pharmacy Technician */
  PharmacyTechnician = 'PHARMACY_TECHNICIAN',
  /** Phlebotomist */
  Phlebotomist = 'PHLEBOTOMIST',
  /** Physical Therapist */
  PhysicalTherapist = 'PHYSICAL_THERAPIST',
  /** Physical Therapist Assistant */
  PhysicalTherapistAssistant = 'PHYSICAL_THERAPIST_ASSISTANT',
  /** Licensed Vocational Nurse / Licensed Practical Nurse */
  Practical = 'PRACTICAL',
  /** Certified Nurse Practitioner */
  Practitioner = 'PRACTITIONER',
  /** Radiologic Technologist */
  RadiologicTechnologist = 'RADIOLOGIC_TECHNOLOGIST',
  /** Registered Nurse */
  Registered = 'REGISTERED',
  /** Respiratory Therapist */
  RespiratoryTherapist = 'RESPIRATORY_THERAPIST',
  /** Social Worker */
  SocialWorker = 'SOCIAL_WORKER',
  /** Sonographer */
  Sonographer = 'SONOGRAPHER',
  /** Speech Language Pathologist */
  SpeechLanguagePathologist = 'SPEECH_LANGUAGE_PATHOLOGIST',
  /** Sterile Processing Tech */
  SterileProcessingTech = 'STERILE_PROCESSING_TECH',
  /** Surgical Assistant */
  SurgicalAssistant = 'SURGICAL_ASSISTANT',
  /** Surgical Technologist */
  SurgicalTechnologist = 'SURGICAL_TECHNOLOGIST',
  /** Telemetry Technician */
  TelemetryTechnician = 'TELEMETRY_TECHNICIAN'
};

export interface LicenseVerification extends Credential {
  readonly __typename?: 'LicenseVerification';
  readonly dateOfDownload?: Maybe<Scalars['ISO8601Date']['output']>;
  /** @deprecated use `dateOfDownload` */
  readonly date_of_download?: Maybe<Scalars['String']['output']>;
  readonly daysUntilExpiration?: Maybe<Scalars['Int']['output']>;
  readonly expirationType?: Maybe<DocumentExpiration>;
  readonly expiresOn?: Maybe<Scalars['ISO8601Date']['output']>;
  /** @deprecated use `expiresOn` */
  readonly expires_on?: Maybe<Scalars['String']['output']>;
  readonly files?: Maybe<ReadonlyArray<File>>;
  readonly id: Scalars['ID']['output'];
  readonly isExpired?: Maybe<Scalars['Boolean']['output']>;
  readonly isExpiringSoon?: Maybe<Scalars['Boolean']['output']>;
  readonly isVerified?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use `isExpired` */
  readonly is_expired?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use `isExpiringSoon` */
  readonly is_expiring_soon?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use `states` */
  readonly state?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `stateCodes` */
  readonly stateCode?: Maybe<Scalars['String']['output']>;
  readonly stateCodes: ReadonlyArray<Scalars['String']['output']>;
  /** @deprecated use `stateCodes` */
  readonly state_code?: Maybe<Scalars['String']['output']>;
  readonly states: ReadonlyArray<Scalars['String']['output']>;
  readonly uuid?: Maybe<Scalars['String']['output']>;
  readonly verificationType?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `verificationType` */
  readonly verification_type?: Maybe<Scalars['String']['output']>;
  readonly verifiedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly verifiedByName?: Maybe<Scalars['String']['output']>;
}

export const enum LicenseVerificationType {
  NursysVerification = 'NURSYS_VERIFICATION',
  PrimarySourceVerification = 'PRIMARY_SOURCE_VERIFICATION'
};

export const enum LicensureCompact {
  Enlc = 'ENLC',
  No = 'NO'
};

export interface Location {
  readonly __typename?: 'Location';
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly city?: Maybe<Scalars['String']['output']>;
  readonly citySalaryStats?: Maybe<ReadonlyArray<Stat>>;
  readonly cityTravelSalaryWeeklyByExp?: Maybe<Scalars['Int']['output']>;
  readonly cityWalkscore?: Maybe<Walkscore>;
  readonly climateAverage?: Maybe<LocationClimateAverage>;
  readonly costOfLivingStats?: Maybe<ReadonlyArray<Stat>>;
  readonly country?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly facilities?: Maybe<ReadonlyArray<Facility>>;
  readonly formattedLocationString?: Maybe<Scalars['String']['output']>;
  readonly googlePlaceId?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  /** @deprecated Field no longer supported */
  readonly image?: Maybe<Scalars['String']['output']>;
  readonly isSeo?: Maybe<Scalars['Boolean']['output']>;
  readonly latitude?: Maybe<Scalars['Float']['output']>;
  readonly locationString?: Maybe<Scalars['String']['output']>;
  readonly longitude?: Maybe<Scalars['Float']['output']>;
  readonly nearbyCitiesStats?: Maybe<ReadonlyArray<Location>>;
  readonly nearbyResidencyFacilities?: Maybe<ReadonlyArray<Facility>>;
  readonly postalCode?: Maybe<Scalars['String']['output']>;
  readonly regionIncomeComparison?: Maybe<RegionIncomeComparison>;
  readonly salaryStats?: Maybe<ReadonlyArray<Stat>>;
  readonly slug?: Maybe<Scalars['String']['output']>;
  readonly stateCode?: Maybe<Scalars['String']['output']>;
  readonly stateName?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly walkscore?: Maybe<Walkscore>;
  readonly weatherForecast?: Maybe<WeatherForecast>;
}


export interface LocationCitySalaryStatsArgs {
  occupation?: InputMaybe<Scalars['String']['input']>;
}


export interface LocationCityTravelSalaryWeeklyByExpArgs {
  experience?: InputMaybe<Scalars['Int']['input']>;
}


export interface LocationCostOfLivingStatsArgs {
  source?: InputMaybe<Scalars['String']['input']>;
  statsIds?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}


export interface LocationNearbyCitiesStatsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
}


export interface LocationNearbyResidencyFacilitiesArgs {
  distance?: InputMaybe<Scalars['Int']['input']>;
}


export interface LocationRegionIncomeComparisonArgs {
  experience?: InputMaybe<Scalars['Int']['input']>;
  nurseType: Scalars['String']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
}


export interface LocationSalaryStatsArgs {
  occupation?: InputMaybe<Scalars['String']['input']>;
}

export interface LocationClimateAverage {
  readonly __typename?: 'LocationClimateAverage';
  readonly id: Scalars['ID']['output'];
  readonly latitude?: Maybe<Scalars['String']['output']>;
  readonly locationName: Scalars['String']['output'];
  readonly longitude?: Maybe<Scalars['String']['output']>;
  readonly monthlyClimateAverages?: Maybe<ReadonlyArray<MonthlyClimateAverage>>;
  readonly yearlyRainyDays?: Maybe<Scalars['Int']['output']>;
  readonly yearlySnowyDays?: Maybe<Scalars['Int']['output']>;
  readonly yearlySunnyDays?: Maybe<Scalars['Int']['output']>;
}

export interface LocationGoogle {
  readonly __typename?: 'LocationGoogle';
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly placeId?: Maybe<Scalars['String']['output']>;
}

export const enum LocationOrderField {
  StateCode = 'STATE_CODE'
};

export const enum LocationUsStates {
  /** Alaska */
  Ak = 'AK',
  /** Alabama */
  Al = 'AL',
  /** Arkansas */
  Ar = 'AR',
  /** America Samoa */
  As = 'AS',
  /** Arizona */
  Az = 'AZ',
  /** California */
  Ca = 'CA',
  /** Colorado */
  Co = 'CO',
  /** Connecticut */
  Ct = 'CT',
  /** District of Columbia */
  Dc = 'DC',
  /** Delaware */
  De = 'DE',
  /** Florida */
  Fl = 'FL',
  /** Federated States of Micronesia */
  Fm = 'FM',
  /** Georgia */
  Ga = 'GA',
  /** Guam */
  Gu = 'GU',
  /** Hawaii */
  Hi = 'HI',
  /** Iowa */
  Ia = 'IA',
  /** Idaho */
  Id = 'ID',
  /** Illinois */
  Il = 'IL',
  /** Indiana */
  In = 'IN',
  /** Kansas */
  Ks = 'KS',
  /** Kentucky */
  Ky = 'KY',
  /** Louisiana */
  La = 'LA',
  /** Massachusetts */
  Ma = 'MA',
  /** Maryland */
  Md = 'MD',
  /** Maine */
  Me = 'ME',
  /** Marshall Islands */
  Mh = 'MH',
  /** Michigan */
  Mi = 'MI',
  /** Minnesota */
  Mn = 'MN',
  /** Missouri */
  Mo = 'MO',
  /** Northern Mariana Islands */
  Mp = 'MP',
  /** Mississippi */
  Ms = 'MS',
  /** Montana */
  Mt = 'MT',
  /** North Carolina */
  Nc = 'NC',
  /** North Dakota */
  Nd = 'ND',
  /** Nebraska */
  Ne = 'NE',
  /** New Hampshire */
  Nh = 'NH',
  /** New Jersey */
  Nj = 'NJ',
  /** New Mexico */
  Nm = 'NM',
  /** Nevada */
  Nv = 'NV',
  /** New York */
  Ny = 'NY',
  /** Ohio */
  Oh = 'OH',
  /** Oklahoma */
  Ok = 'OK',
  /** Oregon */
  Or = 'OR',
  /** Pennsylvania */
  Pa = 'PA',
  /** Puerto Rico */
  Pr = 'PR',
  /** Palau */
  Pw = 'PW',
  /** Rhode Island */
  Ri = 'RI',
  /** South Carolina */
  Sc = 'SC',
  /** South Dakota */
  Sd = 'SD',
  /** Tennessee */
  Tn = 'TN',
  /** Texas */
  Tx = 'TX',
  /** Utah */
  Ut = 'UT',
  /** Virginia */
  Va = 'VA',
  /** Virgin Island */
  Vi = 'VI',
  /** Vermont */
  Vt = 'VT',
  /** Washington */
  Wa = 'WA',
  /** Wisconsin */
  Wi = 'WI',
  /** West Virginia */
  Wv = 'WV',
  /** Wyoming */
  Wy = 'WY'
};

/** Autogenerated return type of LockTimeSheetEdit. */
export interface LockTimeSheetEditPayload {
  readonly __typename?: 'LockTimeSheetEditPayload';
  readonly editorUser?: Maybe<AdminUser>;
}

/** Autogenerated return type of MarkClearedByTrustedOnboardingList. */
export interface MarkClearedByTrustedOnboardingListPayload {
  readonly __typename?: 'MarkClearedByTrustedOnboardingListPayload';
  readonly todoList: TodoList;
}

/** Autogenerated return type of MarkFacilityClearedOnboardingList. */
export interface MarkFacilityClearedOnboardingListPayload {
  readonly __typename?: 'MarkFacilityClearedOnboardingListPayload';
  readonly todoList: TodoList;
}

/** Autogenerated return type of MarkFdiSentOnboardingList. */
export interface MarkFdiSentOnboardingListPayload {
  readonly __typename?: 'MarkFdiSentOnboardingListPayload';
  readonly todoList: TodoList;
}

/** Autogenerated return type of MarkOnboardingItemCompleted. */
export interface MarkOnboardingItemCompletedPayload {
  readonly __typename?: 'MarkOnboardingItemCompletedPayload';
  readonly todoList: TodoList;
  readonly todoListItem: TodoListItem;
}

/** Autogenerated return type of MarkSentSprigSurveyAt. */
export interface MarkSentSprigSurveyAtPayload {
  readonly __typename?: 'MarkSentSprigSurveyAtPayload';
  readonly user: User;
}

/** Autogenerated return type of MarkStaleProfileNotificationDismissed. */
export interface MarkStaleProfileNotificationDismissedPayload {
  readonly __typename?: 'MarkStaleProfileNotificationDismissedPayload';
  readonly viewer: Viewer;
}

/** Autogenerated return type of MarkTentativelyClearedOnboardingList. */
export interface MarkTentativelyClearedOnboardingListPayload {
  readonly __typename?: 'MarkTentativelyClearedOnboardingListPayload';
  readonly todoList: TodoList;
}

/** Autogenerated return type of MarkVmsReverseInvoiceItemAsException. */
export interface MarkVmsReverseInvoiceItemAsExceptionPayload {
  readonly __typename?: 'MarkVmsReverseInvoiceItemAsExceptionPayload';
  readonly errors: ReadonlyArray<BasicErrorsUnion>;
}

export interface Match {
  readonly __typename?: 'Match';
  readonly canFavorite: AuthorizationResult;
  readonly canViewApplyButton: AuthorizationResult;
  readonly canWithdraw: AuthorizationResult;
  readonly clinicalSpecialty?: Maybe<ClinicalSpecialty>;
  readonly firstViewedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly interested?: Maybe<Scalars['Boolean']['output']>;
  readonly job?: Maybe<Job>;
  /** @deprecated Unused */
  readonly locationMatch?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Unused */
  readonly magnetMatch?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Unused */
  readonly shiftMatch?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Unused */
  readonly specialtyMatches?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  /** @deprecated Unused */
  readonly timingMatch?: Maybe<Scalars['Boolean']['output']>;
  readonly userState?: Maybe<Scalars['String']['output']>;
  readonly uuid?: Maybe<Scalars['String']['output']>;
}

export interface MatchBucketImage {
  readonly __typename?: 'MatchBucketImage';
  readonly contentType?: Maybe<Scalars['String']['output']>;
  readonly url: Scalars['String']['output'];
  readonly variantUrl: Scalars['String']['output'];
}


export interface MatchBucketImageVariantUrlArgs {
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
}

/** Autogenerated return type of MatchInvoice. */
export interface MatchInvoicePayload {
  readonly __typename?: 'MatchInvoicePayload';
  readonly errors: ReadonlyArray<BasicErrorsUnion>;
  readonly vmsReverseInvoiceItem?: Maybe<ReadonlyArray<VmsReverseInvoiceItem>>;
}

/** Autogenerated return type of MatchNurseContract. */
export interface MatchNurseContractPayload {
  readonly __typename?: 'MatchNurseContractPayload';
  readonly errors: ReadonlyArray<BasicErrorsUnion>;
  readonly vmsReverseInvoiceItem?: Maybe<ReadonlyArray<VmsReverseInvoiceItem>>;
}

export interface MissingPayrollStats {
  readonly __typename?: 'MissingPayrollStats';
  readonly missingPayrolls: Scalars['Int']['output'];
}

export interface MissingTimecard {
  readonly __typename?: 'MissingTimecard';
  readonly id: Scalars['ID']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly reason?: Maybe<Scalars['String']['output']>;
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly timeOffsThisWeek?: Maybe<Scalars['String']['output']>;
}

/** The connection type for MissingTimecard. */
export interface MissingTimecardConnection {
  readonly __typename?: 'MissingTimecardConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<MissingTimecardEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<MissingTimecard>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface MissingTimecardEdge {
  readonly __typename?: 'MissingTimecardEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<MissingTimecard>;
}

export interface MissingTimecardStats {
  readonly __typename?: 'MissingTimecardStats';
  readonly missingTimecards: Scalars['Int']['output'];
  readonly timeOffs: Scalars['Int']['output'];
}

export const enum MobileAppOsName {
  Android = 'android',
  Ios = 'ios'
};

export interface MobileAppUpdateInstructions {
  readonly __typename?: 'MobileAppUpdateInstructions';
  readonly contactMailto: Scalars['String']['output'];
  readonly linkToStore: Scalars['String']['output'];
  readonly updateBody: Scalars['String']['output'];
  readonly updateTitle: Scalars['String']['output'];
}

export const enum MobileAppVersionKind {
  Android = 'android',
  Ios = 'ios',
  OtaAndroid = 'ota_android',
  OtaIos = 'ota_ios'
};

export const enum MobileAppVersionStatus {
  /** App version is not supported by this server and there is no known update */
  NotSupported = 'not_supported',
  /** App is supported, but has a OTA update available */
  OtaUpdateAvailable = 'ota_update_available',
  /** App is not supported, but has a required OTA update */
  OtaUpdateRequired = 'ota_update_required',
  /** App is supported, but has a store update available */
  StoreUpdateAvailable = 'store_update_available',
  /** App is not supported, but has a required store update */
  StoreUpdateRequired = 'store_update_required',
  /** App is supported and doesn't need an update */
  Supported = 'supported',
  /** App version is not known by this server */
  Unknown = 'unknown'
};

export interface ModelValidationAttributeError {
  readonly __typename?: 'ModelValidationAttributeError';
  readonly attribute: Scalars['String']['output'];
  readonly errors: ReadonlyArray<ModelValidationAttributeErrorDetails>;
  readonly humanAttribute: Scalars['String']['output'];
}

export interface ModelValidationAttributeErrorDetails {
  readonly __typename?: 'ModelValidationAttributeErrorDetails';
  readonly code: Scalars['String']['output'];
  readonly fullMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
}

/** Structure validation errors for mutations */
export interface ModelValidationError {
  readonly __typename?: 'ModelValidationError';
  readonly attributes: ReadonlyArray<ModelValidationAttributeError>;
  readonly message: Scalars['String']['output'];
}

export interface MonthlyClimateAverage {
  readonly __typename?: 'MonthlyClimateAverage';
  readonly averageTemperature?: Maybe<Scalars['Float']['output']>;
  readonly cloud?: Maybe<Scalars['Int']['output']>;
  readonly dailyRainfall?: Maybe<Scalars['Float']['output']>;
  readonly dryDays?: Maybe<Scalars['Int']['output']>;
  readonly fogDays?: Maybe<Scalars['Int']['output']>;
  readonly humidity?: Maybe<Scalars['Int']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly maxTemperature?: Maybe<Scalars['Float']['output']>;
  readonly minTemperature?: Maybe<Scalars['Float']['output']>;
  readonly month: Scalars['String']['output'];
  readonly monthAbbr: Scalars['String']['output'];
  readonly monthNum: Scalars['Int']['output'];
  readonly monthlyRainfall?: Maybe<Scalars['Float']['output']>;
  readonly pressure?: Maybe<Scalars['Float']['output']>;
  readonly rainDays?: Maybe<Scalars['Int']['output']>;
  readonly snowDays?: Maybe<Scalars['Int']['output']>;
  readonly sunHour?: Maybe<Scalars['Float']['output']>;
  readonly thunderDays?: Maybe<Scalars['Int']['output']>;
  readonly uvIndex?: Maybe<Scalars['Int']['output']>;
  readonly visibility?: Maybe<Scalars['Float']['output']>;
  readonly windGust?: Maybe<Scalars['Float']['output']>;
  readonly windSpeed?: Maybe<Scalars['Float']['output']>;
}

export interface Mutation {
  readonly __typename?: 'Mutation';
  readonly acceptOffer?: Maybe<AcceptOfferPayload>;
  readonly addCorrectionToNextPayroll?: Maybe<AddCorrectionToNextPayrollPayload>;
  readonly addPemShiftHours?: Maybe<AddPemShiftHoursPayload>;
  readonly applyToSimilarJobs?: Maybe<ReadonlyArray<ApplyToSimilarJobsResponseUnion>>;
  readonly approveComplianceListItem?: Maybe<ApproveComplianceListItemPayload>;
  readonly archiveExpense?: Maybe<Expense>;
  readonly archiveInvoiceBalanceAdjustmentEntry?: Maybe<ArchiveInvoiceBalanceAdjustmentEntryPayload>;
  readonly archiveLedgerLink?: Maybe<ArchiveLedgerLinkPayload>;
  readonly archivePayBonus?: Maybe<ArchivePayBonusPayload>;
  readonly archivePayHoursCancellation?: Maybe<ArchivePayHoursCancellationPayload>;
  readonly archivePayroll?: Maybe<ArchivePayrollPayload>;
  readonly archiveShiftEntry?: Maybe<ArchiveShiftEntryPayload>;
  readonly archiveTimeEntry?: Maybe<TimeEntry>;
  readonly archiveTimeSheetShift?: Maybe<ArchiveTimeSheetShiftPayload>;
  readonly assignAdvocate?: Maybe<AssignAdvocatePayload>;
  readonly assignReliasAssessments?: Maybe<AssignReliasAssessmentsPayload>;
  readonly backgroundQuestionsUpsert?: Maybe<UpsertBackgroundQuestionsPayload>;
  readonly cancelVmsReverseInvoiceItem?: Maybe<CancelVmsReverseInvoiceItemPayload>;
  readonly changeDailyMatchesNotificationStatus?: Maybe<Scalars['Boolean']['output']>;
  readonly checkSMSVerificationCode?: Maybe<CheckSmsVerificationCodePayload>;
  readonly clearUnavailableFavoritedMatches: ClearUnavailableFavoritedMatchesPayload;
  readonly clearUnavailablePassedMatches: ClearUnavailablePassedMatchesPayload;
  readonly clearUnavailableRequestedMatches: ClearUnavailableRequestedMatchesPayload;
  readonly completeOnboardingList?: Maybe<CompleteOnboardingListPayload>;
  readonly confirmTodoDone?: Maybe<TodoListItem>;
  readonly confirmUserEmail?: Maybe<ConfirmUserEmailPayload>;
  readonly confirmVmsReverseInvoiceItemContract?: Maybe<ConfirmVmsReverseInvoiceItemContractPayload>;
  readonly createAffiliationHistory?: Maybe<CreateAffiliationHistoryPayload>;
  readonly createAssessmentOnboardingItem?: Maybe<CreateAssessmentOnboardingItemPayload>;
  readonly createAward?: Maybe<CreateAwardPayload>;
  readonly createCertificationOnboardingItem?: Maybe<CreateCertificationOnboardingItemPayload>;
  readonly createCeuCertificate?: Maybe<CreateCeuCertificatePayload>;
  readonly createCeuGoal?: Maybe<CreateCeuGoalPayload>;
  readonly createClinicianProfile?: Maybe<CreateClinicianProfilePayload>;
  readonly createComplianceChecklist?: Maybe<CreateComplianceChecklistPayload>;
  readonly createComplianceItemArchiveReason?: Maybe<CreateComplianceItemArchiveReasonPayload>;
  readonly createComplianceListItem?: Maybe<CreateComplianceListItemPayload>;
  readonly createComplianceQuestions?: Maybe<CreateComplianceQuestionsPayload>;
  readonly createDirectInvoiceEntry?: Maybe<CreateDirectInvoiceEntryPayload>;
  /** Create a Document */
  readonly createDocument?: Maybe<CreateDocumentPayload>;
  readonly createDocumentOnboardingItem?: Maybe<CreateDocumentOnboardingItemPayload>;
  readonly createEducation?: Maybe<CreateEducationPayload>;
  /** @deprecated use createWorkExperience */
  readonly createEmployment?: Maybe<CreateEmploymentPayload>;
  readonly createHealthDocOnboardingItem?: Maybe<CreateHealthDocOnboardingItemPayload>;
  readonly createIdentificationDocument?: Maybe<CreateIdentificationDocumentPayload>;
  readonly createInvoiceBalanceAdjustmentEntry?: Maybe<CreateInvoiceBalanceAdjustmentEntryPayload>;
  readonly createJobAlert?: Maybe<CreateJobAlertPayload>;
  readonly createJobApplication?: Maybe<JobApplication>;
  readonly createJobPlacementSchedule?: Maybe<JobPlacementSchedule>;
  readonly createKarmaCheckVoe?: Maybe<CreateKarmaCheckVoePayload>;
  readonly createLedgerLink?: Maybe<CreateLedgerLinkPayload>;
  readonly createLicense?: Maybe<CreateLicensePayload>;
  readonly createLicenseOnboardingItem?: Maybe<CreateLicenseOnboardingItemPayload>;
  readonly createLicenseVerification?: Maybe<CreateLicenseVerificationPayload>;
  readonly createLicenseVerificationOnboardingItem?: Maybe<CreateLicenseVerificationOnboardingItemPayload>;
  readonly createLocationSharedLink?: Maybe<CreateLocationSharedLinkPayload>;
  readonly createManualEmploymentVerification?: Maybe<CreateManualEmploymentVerificationPayload>;
  readonly createMultipleLicenses?: Maybe<CreateMultipleLicensesPayload>;
  /** Create a NurseAssessment */
  readonly createNurseAssessment?: Maybe<CreateNurseAssessmentPayload>;
  readonly createNurseCertification?: Maybe<CreateNurseCertificationPayload>;
  readonly createNurseHealthDoc?: Maybe<CreateNurseHealthDocPayload>;
  readonly createNurseHealthDocVaccination?: Maybe<CreateNurseHealthDocVaccinationPayload>;
  readonly createOnboardingItem?: Maybe<CreateOnboardingItemPayload>;
  readonly createOnboardingItemArchiveReason?: Maybe<CreateOnboardingItemArchiveReasonPayload>;
  readonly createOnboardingListStatus?: Maybe<CreateOnboardingListStatusPayload>;
  readonly createPayBonus?: Maybe<CreatePayBonusPayload>;
  readonly createPayHoursCancellation?: Maybe<CreatePayHoursCancellationPayload>;
  readonly createPayrollItem?: Maybe<CreatePayrollItemPayload>;
  readonly createRecommendation?: Maybe<CreateRecommendationPayload>;
  readonly createReferenceOnboardingItem?: Maybe<CreateReferenceOnboardingItemPayload>;
  readonly createResearch?: Maybe<CreateResearchPayload>;
  readonly createResidencyProgram?: Maybe<CreateResidencyProgramPayload>;
  readonly createResumeFile?: Maybe<CreateResumeFilePayload>;
  readonly createSalarySearchHistoryEntry?: Maybe<CreateSalarySearchHistoryEntryPayload>;
  /** @deprecated Use createJobAlert */
  readonly createSavedSearch?: Maybe<CreateSavedSearchPayload>;
  readonly createSharedLink?: Maybe<CreateSharedLinkPayload>;
  readonly createShiftWithEntry?: Maybe<CreateShiftWithEntryPayload>;
  readonly createStudentClinicalExperience?: Maybe<CreateStudentClinicalExperiencePayload>;
  readonly createSurveyUserAnswers?: Maybe<CreateSurveyUserAnswersPayload>;
  readonly createTimeEntry?: Maybe<CreateTimeEntryPayload>;
  readonly createTimecardOcrParsing?: Maybe<CreateTimecardOcrParsingPayload>;
  readonly deleteAffiliationHistory?: Maybe<DeleteAffiliationHistoryPayload>;
  readonly deleteAssessment?: Maybe<Assessment>;
  readonly deleteAward?: Maybe<DeleteAwardPayload>;
  readonly deleteCeuCertificate?: Maybe<DeleteCeuCertificatePayload>;
  readonly deleteCeuGoal?: Maybe<DeleteCeuGoalPayload>;
  /** Deletes clinician language */
  readonly deleteClinicianLanguage?: Maybe<DeleteLanguagePayload>;
  readonly deleteComplianceListItemFile?: Maybe<DeleteComplianceListItemFilePayload>;
  /** Delete a Document */
  readonly deleteDocument?: Maybe<DeleteDocumentPayload>;
  readonly deleteEducation?: Maybe<DeleteEducationPayload>;
  readonly deleteEmploymentGap?: Maybe<DeleteEmploymentGapPayload>;
  readonly deleteEmploymentPosition?: Maybe<DeleteEmploymentPositionPayload>;
  /**
   * Delete a file
   * @deprecated use resource-specific mutations for models with attachments
   */
  readonly deleteFile?: Maybe<DeleteFilePayload>;
  readonly deleteIdentificationDocument?: Maybe<DeleteIdentificationDocumentPayload>;
  readonly deleteInvoiceFile?: Maybe<DeleteInvoiceFilePayload>;
  readonly deleteJobAlert?: Maybe<DeleteJobAlertPayload>;
  readonly deleteLicense?: Maybe<DeleteLicensePayload>;
  readonly deleteLicenseVerification?: Maybe<DeleteLicenseVerificationPayload>;
  readonly deleteNurseAssessment?: Maybe<DeleteNurseAssessmentPayload>;
  readonly deleteNurseCertification?: Maybe<DeleteNurseCertificationPayload>;
  readonly deleteNurseHealthDoc?: Maybe<DeleteNurseHealthDocPayload>;
  readonly deleteOnboardingItem?: Maybe<DeleteOnboardingItemPayload>;
  readonly deleteOnboardingList?: Maybe<DeleteOnboardingListPayload>;
  readonly deleteOnboardingListItemFile?: Maybe<DeleteOnboardingListItemFilePayload>;
  readonly deletePayrollFile?: Maybe<DeletePayrollFilePayload>;
  readonly deleteRecommendation?: Maybe<DeleteRecommendationPayload>;
  readonly deleteResearch?: Maybe<DeleteResearchPayload>;
  readonly deleteResidencyProgram?: Maybe<DeleteResidencyProgramPayload>;
  readonly deleteSavedFacility?: Maybe<DeleteSavedFacilityPayload>;
  /** @deprecated Use deleteJobAlert */
  readonly deleteSavedSearch?: Maybe<DeleteSavedSearchPayload>;
  readonly deleteSearchHistoryEntry?: Maybe<DeleteSearchHistoryEntryPayload>;
  readonly deleteStudentClinicalExperience?: Maybe<DeleteStudentClinicalExperiencePayload>;
  readonly deleteStudentClinicalExperienceUnit?: Maybe<DeleteStudentClinicalExperienceUnitPayload>;
  /** @deprecated AutoApply is disabled */
  readonly dismissAutoApplyOptInExpired?: Maybe<DismissAutoApplyOptInExpiredPayload>;
  readonly documentUpsert?: Maybe<Document>;
  readonly employmentDelete?: Maybe<Employment>;
  /** Create an Expense */
  readonly expenseCreate?: Maybe<Expense>;
  readonly expressInterest?: Maybe<Job>;
  readonly extensionRequest: ExtensionRequestMutation;
  readonly favoriteJob?: Maybe<FavoriteJobPayload>;
  readonly generatePayrollCorrection?: Maybe<GeneratePayrollCorrectionPayload>;
  readonly generateVerificationOfEmploymentPdf?: Maybe<GenerateVerificationOfEmploymentPdfPayload>;
  readonly healthDocDelete?: Maybe<NurseHealthDoc>;
  readonly healthDocUpsert?: Maybe<NurseHealthDoc>;
  readonly hideMatch?: Maybe<Match>;
  readonly hideSuggestion?: Maybe<HideSuggestionPayload>;
  readonly jobApplicationAutoSave?: Maybe<JobApplication>;
  readonly joinAssessment?: Maybe<Assessment>;
  /** @deprecated use createNurseCertification or updateNurseCertification */
  readonly joinOrCreateCertification?: Maybe<Certification>;
  readonly licenseDelete?: Maybe<License>;
  readonly licenseVerificationDelete?: Maybe<LicenseVerification>;
  readonly lockTimeSheetEdit?: Maybe<LockTimeSheetEditPayload>;
  readonly markClearedByTrustedOnboardingList?: Maybe<MarkClearedByTrustedOnboardingListPayload>;
  readonly markExpenseAsPaid?: Maybe<Expense>;
  readonly markFacilityClearedOnboardingList?: Maybe<MarkFacilityClearedOnboardingListPayload>;
  readonly markFdiSentOnboardingList?: Maybe<MarkFdiSentOnboardingListPayload>;
  readonly markOnboardingItemCompleted?: Maybe<MarkOnboardingItemCompletedPayload>;
  readonly markTentativelyClearedOnboardingList?: Maybe<MarkTentativelyClearedOnboardingListPayload>;
  readonly markVmsReverseInvoiceItemAsException?: Maybe<MarkVmsReverseInvoiceItemAsExceptionPayload>;
  readonly matchInvoice?: Maybe<MatchInvoicePayload>;
  readonly matchNurseContract?: Maybe<MatchNurseContractPayload>;
  readonly nestedUpdateUser?: Maybe<NestedUpdateUserPayload>;
  /** Update Nurse Profile Clinical Experiences */
  readonly nurseProfileClinicalExperiencesUpdate?: Maybe<NurseProfile>;
  /**
   * Update Nurse Profile
   * @deprecated use updateNurseProfile
   */
  readonly nurseProfileUpdate?: Maybe<NurseProfile>;
  readonly onboardingItemMarkIncomplete?: Maybe<OnboardingItemMarkIncompletePayload>;
  readonly onboardingItemRejection?: Maybe<OnboardingItemRejectionPayload>;
  /** @deprecated AutoApply is disabled */
  readonly optOutAutoApply?: Maybe<OptOutAutoApplyPayload>;
  readonly payBonus?: Maybe<PayBonusPayload>;
  readonly payrollNudge?: Maybe<PayrollNudgePayload>;
  /** @deprecated not being used */
  readonly performNursysLicenseVerification?: Maybe<PerformNursysLicenseVerificationPayload>;
  readonly permanentAddressUpsert?: Maybe<UpsertPermanentAddressPayload>;
  readonly personalInfoUpsert?: Maybe<UpsertPersonalInfoPayload>;
  readonly processContractBonuses?: Maybe<ProcessContractBonusesPayload>;
  readonly publishOnboardingList?: Maybe<PublishOnboardingListPayload>;
  readonly recalculatePayroll?: Maybe<RecalculatePayrollPayload>;
  readonly refuseBonus?: Maybe<RefuseBonusPayload>;
  readonly rejectComplianceListItem?: Maybe<RejectComplianceListItemPayload>;
  readonly rejectEsMatch?: Maybe<Match>;
  readonly rejectLedgerAttachment?: Maybe<RejectLedgerAttachmentPayload>;
  /** @deprecated use onboardingItemRejection */
  readonly rejectOnboardingItem?: Maybe<RejectOnboardingItemPayload>;
  readonly removeInterest?: Maybe<Job>;
  readonly removeReference?: Maybe<RemoveReferencePayload>;
  /** Handles app self report and returns information whats the state of the version that the app is in. */
  readonly reportMobileAppVersion?: Maybe<ReportVersionPayload>;
  /** @deprecated transition no longer supported */
  readonly republishOnboardingList?: Maybe<RepublishOnboardingListPayload>;
  readonly requestActivation?: Maybe<RequestActivationPayload>;
  readonly requestSMSVerification?: Maybe<RequestSmsVerificationPayload>;
  readonly resendReferenceForm?: Maybe<ResendReferenceFormPayload>;
  readonly resetUserPassword?: Maybe<ResetUserPasswordPayload>;
  readonly retakeReliasAssessment?: Maybe<RetakeReliasAssessmentPayload>;
  readonly retryTimecardOcrParsing?: Maybe<RetryTimecardOcrParsingPayload>;
  readonly saveFacility?: Maybe<SaveFacilityPayload>;
  readonly sendConfirmationEmail?: Maybe<Scalars['Boolean']['output']>;
  readonly sendPayPreview?: Maybe<SendPayPreviewPayload>;
  readonly sendUserResetPasswordInstructions?: Maybe<SendUserResetPasswordInstructionsPayload>;
  readonly signInUser?: Maybe<SignInUserPayload>;
  readonly signOut?: Maybe<SignOutPayload>;
  readonly signUp?: Maybe<SignUpPayload>;
  readonly splitAndMatchReconReportItem?: Maybe<SplitAndMatchReconReportItemPayload>;
  readonly submitComplianceListItem?: Maybe<SubmitComplianceListItemPayload>;
  readonly submitReferenceResponse?: Maybe<Reference>;
  readonly submitTimeSheet?: Maybe<SubmitTimeSheetPayload>;
  readonly technologiesUpdate?: Maybe<ReadonlyArray<Maybe<NurseTechnology>>>;
  readonly technologyDelete?: Maybe<NurseTechnology>;
  readonly technologyUpsert?: Maybe<NurseTechnology>;
  readonly toggleComplianceListItemArchived?: Maybe<ToggleComplianceListItemArchivedPayload>;
  readonly toggleOnboardingItemLive?: Maybe<ToggleOnboardingItemLivePayload>;
  readonly toggleOnboardingListItemArchived?: Maybe<ToggleOnboardingListItemArchivedPayload>;
  readonly transitionPayrollStatus?: Maybe<TransitionPayrollStatusPayload>;
  /** calls braze api endpoint to trigger a campaign */
  readonly triggerBrazeCampaign?: Maybe<Scalars['String']['output']>;
  readonly unconfirmReconReportItem?: Maybe<ReconReportItem>;
  readonly unconfirmVmsReverseInvoiceItemContract?: Maybe<UnconfirmVmsReverseInvoiceItemContractPayload>;
  readonly unhideEsMatch?: Maybe<Match>;
  readonly unlockTimeSheetEdit?: Maybe<UnlockTimeSheetEditPayload>;
  readonly unmarkClearedByTrustedOnboardingList?: Maybe<UnmarkClearedByTrustedOnboardingListPayload>;
  readonly unmarkFacilityClearedToTentativelyClearedOnboardingList?: Maybe<UnmarkFacilityClearedToTentativelyClearedOnboardingListPayload>;
  readonly unmarkFacilityClearedToTrustedClearedOnboardingList?: Maybe<UnmarkFacilityClearedToTrustedClearedOnboardingListPayload>;
  readonly unmarkFdiSentOnboardingList?: Maybe<UnmarkFdiSentOnboardingListPayload>;
  readonly unmarkTentativelyClearedOnboardingList?: Maybe<UnmarkTentativelyClearedOnboardingListPayload>;
  readonly unpublishOnboardingList?: Maybe<UnpublishOnboardingListPayload>;
  readonly unverifyCredential?: Maybe<UnverifyCredentialPayload>;
  /** Updates about me WEB fields */
  readonly updateAboutMe?: Maybe<UpdateAboutMePayload>;
  readonly updateAdminNote?: Maybe<UpdateAdminNotePayload>;
  readonly updateAffiliationHistory?: Maybe<UpdateAffiliationHistoryPayload>;
  readonly updateAssessmentOnboardingItem?: Maybe<UpdateAssessmentOnboardingItemPayload>;
  readonly updateAward?: Maybe<UpdateAwardPayload>;
  readonly updateCeuCertificate?: Maybe<UpdateCeuCertificatePayload>;
  readonly updateCeuGoal?: Maybe<UpdateCeuGoalPayload>;
  readonly updateClickIds?: Maybe<UpdateClickIdsPayload>;
  readonly updateComplianceChecklist?: Maybe<UpdateComplianceChecklistPayload>;
  readonly updateComplianceItemTarget?: Maybe<UpdateComplianceItemTargetPayload>;
  readonly updateComplianceList?: Maybe<UpdateComplianceListPayload>;
  readonly updateComplianceListItem?: Maybe<UpdateComplianceListItemPayload>;
  readonly updateContractBonus?: Maybe<UpdateContractBonusPayload>;
  readonly updateContractBonusStatus?: Maybe<UpdateContractBonusStatusPayload>;
  /** Update a Document */
  readonly updateDocument?: Maybe<UpdateDocumentPayload>;
  readonly updateDocumentOnboardingItem?: Maybe<UpdateDocumentOnboardingItemPayload>;
  readonly updateEducation?: Maybe<UpdateEducationPayload>;
  /** @deprecated use updateWorkExperience */
  readonly updateEmployment?: Maybe<UpdateEmploymentPayload>;
  readonly updateEmploymentGap?: Maybe<UpdateEmploymentGapPayload>;
  readonly updateHealthDocOnboardingItem?: Maybe<UpdateHealthDocOnboardingItemPayload>;
  readonly updateIdentificationDocument?: Maybe<UpdateIdentificationDocumentPayload>;
  readonly updateInvoice?: Maybe<UpdateInvoicePayload>;
  readonly updateJobAlert?: Maybe<UpdateJobAlertPayload>;
  /** Update a License */
  readonly updateLicense?: Maybe<UpdateLicensePayload>;
  readonly updateLicenseOnboardingItem?: Maybe<UpdateLicenseOnboardingItemPayload>;
  readonly updateLicenseVerification?: Maybe<UpdateLicenseVerificationPayload>;
  /** Update a NurseAssessment */
  readonly updateNurseAssessment?: Maybe<UpdateNurseAssessmentPayload>;
  readonly updateNurseCertification?: Maybe<UpdateNurseCertificationPayload>;
  /** Update a NurseHealthDoc */
  readonly updateNurseHealthDoc?: Maybe<UpdateNurseHealthDocPayload>;
  readonly updateNurseHealthDocVaccination?: Maybe<UpdateNurseHealthDocVaccinationPayload>;
  readonly updateNurseNote?: Maybe<UpdateNurseNotePayload>;
  readonly updateNursePreferences?: Maybe<UpdateNursePreferencesPayload>;
  readonly updateNurseProfile?: Maybe<UpdateNurseProfilePayload>;
  readonly updateNurseRole?: Maybe<UpdateNurseRolePayload>;
  readonly updateNurseType?: Maybe<UpdateNursePayload>;
  readonly updateOnboardingItem?: Maybe<UpdateOnboardingItemPayload>;
  readonly updateOnboardingItemDateField?: Maybe<UpdateOnboardingItemDateFieldPayload>;
  readonly updateOnboardingItemInternalNotes?: Maybe<UpdateOnboardingItemInternalNotesPayload>;
  readonly updateOnboardingItemTarget?: Maybe<UpdateOnboardingItemTargetPayload>;
  readonly updateOnboardingItemUploadStatus?: Maybe<UpdateOnboardingItemUploadStatusPayload>;
  readonly updateOnboardingItemsDueDate?: Maybe<UpdateOnboardingItemsDueDatePayload>;
  readonly updateOnboardingItemsRelativeDueDate?: Maybe<UpdateOnboardingItemsRelativeDueDatePayload>;
  readonly updateOnboardingList?: Maybe<UpdateOnboardingListPayload>;
  readonly updateOnboardingNeedsToBeScheduled?: Maybe<UpdateOnboardingNeedsToBeScheduledPayload>;
  readonly updatePayrollAccruals?: Maybe<UpdatePayrollAccrualsPayload>;
  readonly updatePayrollCorrectionRate?: Maybe<UpdatePayrollCorrectionRatePayload>;
  readonly updatePayrollStatus?: Maybe<UpdatePayrollStatusPayload>;
  readonly updatePayrollTags?: Maybe<UpdatePayrollTagsPayload>;
  readonly updateProfilePhoto?: Maybe<UpdateProfilePhotoPayload>;
  /** Update Primary Specialty from Nurse Profile Page */
  readonly updateProfilePrimarySpecialty?: Maybe<UpdateProfilePrimarySpecialtyPayload>;
  readonly updateRecommendation?: Maybe<UpdateRecommendationPayload>;
  readonly updateReferenceOnboardingItem?: Maybe<UpdateReferenceOnboardingItemPayload>;
  readonly updateResearch?: Maybe<UpdateResearchPayload>;
  readonly updateResidencyProgram?: Maybe<UpdateResidencyProgramPayload>;
  readonly updateResumeParserStep?: Maybe<UpdateResumeParserStepPayload>;
  /** @deprecated Use updateJobAlert */
  readonly updateSavedSearch?: Maybe<UpdateSavedSearchPayload>;
  readonly updateSearchHistoryEntry?: Maybe<UpdateSearchHistoryEntryPayload>;
  readonly updateStaleIntent?: Maybe<UpdateStaleIntentPayload>;
  readonly updateStaleNurseProfile?: Maybe<UpdateStaleNurseProfilePayload>;
  readonly updateStudentClinicalExperience?: Maybe<UpdateStudentClinicalExperiencePayload>;
  readonly updateStudentClinicalExperienceUnit?: Maybe<UpdateStudentClinicalExperienceUnitPayload>;
  readonly updateTimeEntry?: Maybe<UpdateTimeEntryPayload>;
  readonly updateTodoCandidateNotes?: Maybe<TodoListItem>;
  /** Update a Todo List with target Document */
  readonly updateTodoListItemDocumentTarget?: Maybe<UpdateTodoListItemDocumentTargetPayload>;
  /** Update a Todo List with target Nurse Assessment */
  readonly updateTodoListItemNurseAssessmentTarget?: Maybe<UpdateTodoListItemNurseAssessmentTargetPayload>;
  /** Update a Todo List with target Nurse Certification */
  readonly updateTodoListItemNurseCertificationTarget?: Maybe<UpdateTodoListItemNurseCertificationTargetPayload>;
  /** Update a Todo List with target Nurse Health Doc */
  readonly updateTodoListItemNurseHealthDocTarget?: Maybe<UpdateTodoListItemNurseHealthDocTargetPayload>;
  readonly updateVerificationOfEmploymentOnboardingItem?: Maybe<UpdateVerificationOfEmploymentOnboardingItemPayload>;
  readonly uploadComplianceListItemFile?: Maybe<UploadComplianceListItemFilePayload>;
  readonly uploadInvoiceFile?: Maybe<UploadInvoiceFilePayload>;
  readonly uploadOnboardingListItemFile?: Maybe<UploadOnboardingListItemFilePayload>;
  readonly uploadPayrollFile?: Maybe<UploadPayrollFilePayload>;
  readonly uploadResume?: Maybe<UploadResumePayload>;
  readonly uploadShiftFile?: Maybe<UploadShiftFilePayload>;
  readonly uploadTimeSheetFile?: Maybe<UploadTimeSheetFilePayload>;
  readonly uploadVmsLookupTable?: Maybe<UploadVmsLookupTablePayload>;
  /** @deprecated AutoApply is disabled */
  readonly upsertAutoApplyConfiguration?: Maybe<UpsertAutoApplyConfigurationPayload>;
  /** Upserts clinician languages */
  readonly upsertClinicianLanguage?: Maybe<UpsertLanguagePayload>;
  readonly upsertClinicianLocation?: Maybe<UpsertClinicianLocationPayload>;
  readonly upsertEmploymentPosition?: Maybe<UpsertEmploymentPositionPayload>;
  readonly upsertPayrollCorrectionFile?: Maybe<UpsertPayrollCorrectionFilePayload>;
  readonly upsertReference?: Maybe<UpsertReferencePayload>;
  readonly upsertShiftWithEntries?: Maybe<UpsertShiftWithEntriesPayload>;
  readonly upsertTimecardWithEntries?: Maybe<UpsertTimecardWithEntriesPayload>;
  readonly userProperties: UserPropertiesMutation;
  readonly vendorIntegrationUpdateExternalIdentifier?: Maybe<UpdateExternalIdentifierPayload>;
  readonly verifyCredential?: Maybe<VerifyCredentialPayload>;
  readonly viewJob?: Maybe<JobVisualization>;
  readonly withdrawRequest?: Maybe<Job>;
  readonly yearsOfExperienceUpsert?: Maybe<UpsertYearsOfExperiencePayload>;
}


export interface MutationAcceptOfferArgs {
  jobOfferId: Scalars['ID']['input'];
}


export interface MutationAddCorrectionToNextPayrollArgs {
  payrollCorrectionId: Scalars['ID']['input'];
  weekEndingDate: Scalars['String']['input'];
}


export interface MutationAddPemShiftHoursArgs {
  hours: Scalars['Int']['input'];
  jobPlacementScheduleUuid: Scalars['ID']['input'];
}


export interface MutationApplyToSimilarJobsArgs {
  jobApplicationId: Scalars['ID']['input'];
  jobIds: ReadonlyArray<Scalars['ID']['input']>;
}


export interface MutationApproveComplianceListItemArgs {
  id: Scalars['ID']['input'];
}


export interface MutationArchiveExpenseArgs {
  id: Scalars['ID']['input'];
}


export interface MutationArchiveInvoiceBalanceAdjustmentEntryArgs {
  entry: ArchiveInvoiceBalanceAdjustmentEntryInput;
  invoiceId: Scalars['ID']['input'];
}


export interface MutationArchiveLedgerLinkArgs {
  input: ArchiveLedgerLinkInput;
}


export interface MutationArchivePayBonusArgs {
  entry: ArchivePayBonusInput;
}


export interface MutationArchivePayHoursCancellationArgs {
  uuid: Scalars['String']['input'];
}


export interface MutationArchivePayrollArgs {
  payrollUuid: Scalars['String']['input'];
}


export interface MutationArchiveShiftEntryArgs {
  entry: ArchiveShiftEntryInput;
}


export interface MutationArchiveTimeEntryArgs {
  uuid: Scalars['String']['input'];
}


export interface MutationArchiveTimeSheetShiftArgs {
  shiftId: Scalars['ID']['input'];
}


export interface MutationAssignReliasAssessmentsArgs {
  assessment_uuid_list: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
  nurseProfileId?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationBackgroundQuestionsUpsertArgs {
  input: ReadonlyArray<BackgroundQuestionInput>;
}


export interface MutationCancelVmsReverseInvoiceItemArgs {
  vmsReverseInvoiceItemId: Scalars['ID']['input'];
}


export interface MutationChangeDailyMatchesNotificationStatusArgs {
  status: Scalars['Boolean']['input'];
}


export interface MutationCheckSmsVerificationCodeArgs {
  code: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
}


export interface MutationCompleteOnboardingListArgs {
  id: Scalars['ID']['input'];
}


export interface MutationConfirmTodoDoneArgs {
  uuid?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationConfirmUserEmailArgs {
  input: ConfirmUserEmailInput;
}


export interface MutationConfirmVmsReverseInvoiceItemContractArgs {
  invoiceId: Scalars['ID']['input'];
  mspId: Scalars['ID']['input'];
  vmsId: Scalars['ID']['input'];
  vmsReverseInvoiceItemContractId: Scalars['ID']['input'];
}


export interface MutationCreateAffiliationHistoryArgs {
  input: CreateAffiliationHistoryInput;
  nurseProfileId: Scalars['ID']['input'];
}


export interface MutationCreateAssessmentOnboardingItemArgs {
  assessmentId: Scalars['ID']['input'];
  input: CreateAssessmentOnboardingItemInput;
  todoListId: Scalars['ID']['input'];
}


export interface MutationCreateAwardArgs {
  input: CreateAwardInput;
  nurseProfileId: Scalars['ID']['input'];
}


export interface MutationCreateCertificationOnboardingItemArgs {
  certificationId: Scalars['ID']['input'];
  input: CreateCertificationOnboardingItemInput;
  todoListId: Scalars['ID']['input'];
}


export interface MutationCreateCeuCertificateArgs {
  fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  goalUuids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  input: CreateCeuCertificateInput;
  nurseProfileId: Scalars['ID']['input'];
}


export interface MutationCreateCeuGoalArgs {
  input: CreateCeuGoalInput;
  nurseProfileId: Scalars['ID']['input'];
}


export interface MutationCreateClinicianProfileArgs {
  nurseType?: InputMaybe<NurseTypes>;
  roleId: Scalars['ID']['input'];
}


export interface MutationCreateComplianceChecklistArgs {
  businessId: Scalars['ID']['input'];
  complianceChecklist: CreateComplianceChecklistInput;
}


export interface MutationCreateComplianceItemArchiveReasonArgs {
  complianceListItemId: Scalars['ID']['input'];
  input: CreateComplianceItemArchiveReasonInput;
  uploads?: InputMaybe<ReadonlyArray<FileUploadTypeInput>>;
}


export interface MutationCreateComplianceListItemArgs {
  input: CreateComplianceListItemInput;
  listId: Scalars['ID']['input'];
}


export interface MutationCreateComplianceQuestionsArgs {
  input: CreateComplianceQuestionsInput;
  jobOfferId: Scalars['ID']['input'];
}


export interface MutationCreateDirectInvoiceEntryArgs {
  entry: CreateDirectInvoiceEntryInput;
  invoiceId: Scalars['ID']['input'];
}


export interface MutationCreateDocumentArgs {
  fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  input: CreateDocumentInput;
  nurseProfileId?: InputMaybe<Scalars['ID']['input']>;
  uploads?: InputMaybe<ReadonlyArray<FileUploadTypeInput>>;
}


export interface MutationCreateDocumentOnboardingItemArgs {
  input: CreateDocumentOnboardingItemInput;
  internalOnly: Scalars['Boolean']['input'];
  taskType: Scalars['String']['input'];
  todoListId: Scalars['ID']['input'];
}


export interface MutationCreateEducationArgs {
  input: CreateEducationInput;
  nurseProfileId?: InputMaybe<Scalars['ID']['input']>;
  parserId?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationCreateEmploymentArgs {
  input: CreateEmploymentEmploymentInput;
  nurseProfileId?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationCreateHealthDocOnboardingItemArgs {
  input: CreateHealthDocOnboardingItemInput;
  todoListId: Scalars['ID']['input'];
}


export interface MutationCreateIdentificationDocumentArgs {
  fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  input: CreateIdentificationDocumentInput;
  nurseProfileId?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationCreateInvoiceBalanceAdjustmentEntryArgs {
  entry: CreateInvoiceBalanceAdjustmentEntryInput;
  invoiceId: Scalars['ID']['input'];
}


export interface MutationCreateJobAlertArgs {
  input: CreateJobAlertInput;
}


export interface MutationCreateJobApplicationArgs {
  input: CreateJobApplicationInput;
  jobUuid: Scalars['ID']['input'];
}


export interface MutationCreateJobPlacementScheduleArgs {
  end_sec: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  start_sec: Scalars['Int']['input'];
  timezone: Scalars['String']['input'];
}


export interface MutationCreateKarmaCheckVoeArgs {
  employmentPositionIds: ReadonlyArray<Scalars['ID']['input']>;
  todoListItemId: Scalars['ID']['input'];
}


export interface MutationCreateLedgerLinkArgs {
  input: LedgerLinkInput;
}


export interface MutationCreateLicenseArgs {
  file_uuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  input: CreateLicenseInput;
  nurseProfileId?: InputMaybe<Scalars['ID']['input']>;
  uploads?: InputMaybe<ReadonlyArray<FileUploadTypeInput>>;
}


export interface MutationCreateLicenseOnboardingItemArgs {
  input: CreateLicenseOnboardingItemInput;
  licenseId?: InputMaybe<Scalars['ID']['input']>;
  licenseType: Scalars['String']['input'];
  todoListId: Scalars['ID']['input'];
}


export interface MutationCreateLicenseVerificationArgs {
  fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  input: CreateLicenseVerificationInput;
  nurseProfileId?: InputMaybe<Scalars['ID']['input']>;
  uploads?: InputMaybe<ReadonlyArray<FileUploadTypeInput>>;
}


export interface MutationCreateLicenseVerificationOnboardingItemArgs {
  input: CreateLicenseVerificationOnboardingItemInput;
  licenseVerificationType: Scalars['String']['input'];
  todoListId: Scalars['ID']['input'];
}


export interface MutationCreateLocationSharedLinkArgs {
  input: CreateLocationSharedLinkInput;
}


export interface MutationCreateManualEmploymentVerificationArgs {
  input?: InputMaybe<CreateManualEmploymentVerificationInput>;
  todoListItemId: Scalars['ID']['input'];
}


export interface MutationCreateMultipleLicensesArgs {
  id: Scalars['ID']['input'];
  input: CreateMultipleLicensesInput;
}


export interface MutationCreateNurseAssessmentArgs {
  fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  input: CreateNurseAssessmentInput;
  nurseProfileId?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationCreateNurseCertificationArgs {
  certificationId: Scalars['ID']['input'];
  input: CreateNurseCertificationInput;
  nurseProfileId?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationCreateNurseHealthDocArgs {
  fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  healthDocId: Scalars['ID']['input'];
  input: CreateNurseHealthDocInput;
  nurseProfileId?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationCreateNurseHealthDocVaccinationArgs {
  fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  input: ReadonlyArray<NurseHealthDocVaccinationInput>;
  nurseProfileId?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationCreateOnboardingItemArgs {
  input: CreateOnboardingItemInput;
  todoListId: Scalars['ID']['input'];
}


export interface MutationCreateOnboardingItemArchiveReasonArgs {
  input: CreateOnboardingItemArchiveReasonInput;
  todoListItemId: Scalars['ID']['input'];
  uploads?: InputMaybe<ReadonlyArray<FileUploadTypeInput>>;
}


export interface MutationCreateOnboardingListStatusArgs {
  input: CreateOnboardingListStatusInput;
  todoListId: Scalars['ID']['input'];
}


export interface MutationCreatePayBonusArgs {
  entry: CreatePayBonusInput;
}


export interface MutationCreatePayHoursCancellationArgs {
  entry: CreatePayHoursCancellationInput;
}


export interface MutationCreatePayrollItemArgs {
  input: CreatePayrollItemInput;
}


export interface MutationCreateRecommendationArgs {
  input: CreateRecommendationInput;
  nurseProfileId: Scalars['ID']['input'];
}


export interface MutationCreateReferenceOnboardingItemArgs {
  input: CreateReferenceOnboardingItemInput;
  referenceId?: InputMaybe<Scalars['ID']['input']>;
  relationship: Scalars['String']['input'];
  todoListId: Scalars['ID']['input'];
}


export interface MutationCreateResearchArgs {
  input: CreateResearchInput;
  nurseProfileId: Scalars['ID']['input'];
}


export interface MutationCreateResidencyProgramArgs {
  businessId: Scalars['ID']['input'];
  clinicalSpecialtyIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  input: CreateResidencyProgramInput;
}


export interface MutationCreateResumeFileArgs {
  nurseProfileId: Scalars['ID']['input'];
}


export interface MutationCreateSalarySearchHistoryEntryArgs {
  input: CreateSalarySearchHistoryEntryInput;
  nurseProfileId: Scalars['ID']['input'];
  searchForm: Scalars['String']['input'];
}


export interface MutationCreateSavedSearchArgs {
  input: CreateSavedSearchInput;
}


export interface MutationCreateSharedLinkArgs {
  input: CreateSharedLinkInput;
}


export interface MutationCreateShiftWithEntryArgs {
  entry: CreateShiftEntryInput;
}


export interface MutationCreateStudentClinicalExperienceArgs {
  input: CreateStudentClinicalExperienceInput;
  nurseProfileId: Scalars['ID']['input'];
}


export interface MutationCreateSurveyUserAnswersArgs {
  facilitySlug: Scalars['String']['input'];
  input: CreateSurveyResponseInput;
}


export interface MutationCreateTimeEntryArgs {
  entry: CreateTimeEntryInput;
}


export interface MutationCreateTimecardOcrParsingArgs {
  ledgerAttachmentId: Scalars['ID']['input'];
}


export interface MutationDeleteAffiliationHistoryArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteAssessmentArgs {
  nurse_assessment_uuid: Scalars['String']['input'];
}


export interface MutationDeleteAwardArgs {
  awardId: Scalars['ID']['input'];
}


export interface MutationDeleteCeuCertificateArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteCeuGoalArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteClinicianLanguageArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteComplianceListItemFileArgs {
  id: Scalars['ID']['input'];
  input: DeleteComplianceListItemFileInput;
}


export interface MutationDeleteDocumentArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteEducationArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteEmploymentGapArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteEmploymentPositionArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteFileArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteIdentificationDocumentArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteInvoiceFileArgs {
  fileId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface MutationDeleteJobAlertArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteLicenseArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteLicenseVerificationArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteNurseAssessmentArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteNurseCertificationArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteNurseHealthDocArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteOnboardingItemArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteOnboardingListArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteOnboardingListItemFileArgs {
  input: DeleteOnboardingListItemFileInput;
}


export interface MutationDeletePayrollFileArgs {
  fileId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface MutationDeleteRecommendationArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteResearchArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteResidencyProgramArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteSavedFacilityArgs {
  facilitySlug: Scalars['String']['input'];
  nurseProfileId: Scalars['ID']['input'];
}


export interface MutationDeleteSavedSearchArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteSearchHistoryEntryArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteStudentClinicalExperienceArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteStudentClinicalExperienceUnitArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDismissAutoApplyOptInExpiredArgs {
  nurseProfileId: Scalars['ID']['input'];
}


export interface MutationDocumentUpsertArgs {
  completed_on?: InputMaybe<Scalars['String']['input']>;
  doc_subtype?: InputMaybe<Scalars['String']['input']>;
  doc_type: Scalars['String']['input'];
  expires_on?: InputMaybe<Scalars['String']['input']>;
  file_uuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  state_code?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  uuid?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationEmploymentDeleteArgs {
  uuid: Scalars['String']['input'];
}


export interface MutationExpenseCreateArgs {
  candidateId: Scalars['String']['input'];
  cost: Scalars['Float']['input'];
  expenseType: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  originalPayer: Scalars['String']['input'];
  reimbursed?: InputMaybe<Scalars['Boolean']['input']>;
  stage: Scalars['String']['input'];
  uploads?: InputMaybe<ReadonlyArray<FileUploadTypeInput>>;
}


export interface MutationExpressInterestArgs {
  autoFavorited?: InputMaybe<Scalars['Boolean']['input']>;
  bucket?: InputMaybe<Scalars['ID']['input']>;
  job_uuid?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationFavoriteJobArgs {
  autoFavorited?: InputMaybe<Scalars['Boolean']['input']>;
  bucket?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationGeneratePayrollCorrectionArgs {
  payrollId: Scalars['ID']['input'];
}


export interface MutationGenerateVerificationOfEmploymentPdfArgs {
  selectedVerifications: ReadonlyArray<Scalars['ID']['input']>;
}


export interface MutationHealthDocDeleteArgs {
  uuid: Scalars['String']['input'];
}


export interface MutationHealthDocUpsertArgs {
  category?: InputMaybe<Scalars['String']['input']>;
  completed_on?: InputMaybe<Scalars['String']['input']>;
  file_uuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  health_doc_uuid: Scalars['String']['input'];
  uuid?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationHideMatchArgs {
  jobUuid: Scalars['String']['input'];
}


export interface MutationHideSuggestionArgs {
  parserId: Scalars['String']['input'];
}


export interface MutationJobApplicationAutoSaveArgs {
  input: AutoSaveApplicationInput;
  jobUuid: Scalars['ID']['input'];
}


export interface MutationJoinAssessmentArgs {
  completed_on?: InputMaybe<Scalars['String']['input']>;
  file_uuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  nurse_assessment_uuid?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Float']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationJoinOrCreateCertificationArgs {
  completed_on?: InputMaybe<Scalars['String']['input']>;
  expires_on?: InputMaybe<Scalars['String']['input']>;
  file_uuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  issuing_body?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nurse_certification_uuid?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationLicenseDeleteArgs {
  uuid: Scalars['String']['input'];
}


export interface MutationLicenseVerificationDeleteArgs {
  uuid: Scalars['String']['input'];
}


export interface MutationLockTimeSheetEditArgs {
  payrollId: Scalars['ID']['input'];
}


export interface MutationMarkClearedByTrustedOnboardingListArgs {
  id: Scalars['String']['input'];
}


export interface MutationMarkExpenseAsPaidArgs {
  id: Scalars['ID']['input'];
}


export interface MutationMarkFacilityClearedOnboardingListArgs {
  id: Scalars['String']['input'];
}


export interface MutationMarkFdiSentOnboardingListArgs {
  id: Scalars['String']['input'];
}


export interface MutationMarkOnboardingItemCompletedArgs {
  id: Scalars['ID']['input'];
}


export interface MutationMarkTentativelyClearedOnboardingListArgs {
  id: Scalars['ID']['input'];
}


export interface MutationMarkVmsReverseInvoiceItemAsExceptionArgs {
  description?: InputMaybe<Scalars['String']['input']>;
  reason: VmsReverseInvoiceItemException;
  vmsReverseInvoiceItemIds: ReadonlyArray<Scalars['ID']['input']>;
}


export interface MutationMatchInvoiceArgs {
  invoiceId: Scalars['ID']['input'];
  matchAllSimilar?: InputMaybe<Scalars['Boolean']['input']>;
  vmsReverseInvoiceItemId: ReadonlyArray<Scalars['ID']['input']>;
}


export interface MutationMatchNurseContractArgs {
  contractId: Scalars['ID']['input'];
  vmsReverseInvoiceItemId: Scalars['ID']['input'];
}


export interface MutationNestedUpdateUserArgs {
  id: Scalars['ID']['input'];
  input: NestedUpdateUserInput;
  raiseValidationErrors?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface MutationNurseProfileClinicalExperiencesUpdateArgs {
  specialtySlugs: ReadonlyArray<Scalars['String']['input']>;
}


export interface MutationNurseProfileUpdateArgs {
  backgroundQuestions?: InputMaybe<ReadonlyArray<NurseBackgroundInput>>;
  birthday?: InputMaybe<Scalars['String']['input']>;
  city_size_pref?: InputMaybe<Scalars['String']['input']>;
  crime_conviction?: InputMaybe<Scalars['Boolean']['input']>;
  crime_conviction_explanation?: InputMaybe<Scalars['String']['input']>;
  dl_expires_on?: InputMaybe<Scalars['String']['input']>;
  dl_number?: InputMaybe<Scalars['String']['input']>;
  dl_state?: InputMaybe<Scalars['String']['input']>;
  employment_type_prefs?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  facility_size_pref?: InputMaybe<Scalars['String']['input']>;
  happiness_pref?: InputMaybe<Scalars['String']['input']>;
  job_aspect_prefs?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  liability_defendant?: InputMaybe<Scalars['Boolean']['input']>;
  liability_defendant_explanation?: InputMaybe<Scalars['String']['input']>;
  license_action?: InputMaybe<Scalars['Boolean']['input']>;
  license_action_explanation?: InputMaybe<Scalars['String']['input']>;
  opportunity_type_prefs?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  patient_pop_pref?: InputMaybe<Scalars['String']['input']>;
  preference_blob?: InputMaybe<Scalars['String']['input']>;
  previously_terminated?: InputMaybe<Scalars['Boolean']['input']>;
  previously_terminated_explanation?: InputMaybe<Scalars['String']['input']>;
  relocation_pref?: InputMaybe<Scalars['String']['input']>;
  specializations?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  ssn_last4?: InputMaybe<Scalars['String']['input']>;
  years_of_exp?: InputMaybe<Scalars['Int']['input']>;
}


export interface MutationOnboardingItemMarkIncompleteArgs {
  id: Scalars['ID']['input'];
  verificationNotes?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationOnboardingItemRejectionArgs {
  id: Scalars['ID']['input'];
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  sendToCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  verificationNotes?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationOptOutAutoApplyArgs {
  nurseProfileId: Scalars['ID']['input'];
}


export interface MutationPayBonusArgs {
  input: PayBonusInput;
}


export interface MutationPayrollNudgeArgs {
  appMessage?: InputMaybe<Scalars['String']['input']>;
  endWeekDate: Scalars['String']['input'];
  startWeekDate: Scalars['String']['input'];
  status: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationPerformNursysLicenseVerificationArgs {
  input: PerformNursysLicenseVerificationInput;
  nurseProfileId: Scalars['ID']['input'];
}


export interface MutationPermanentAddressUpsertArgs {
  input: PermanentAddressInput;
}


export interface MutationPersonalInfoUpsertArgs {
  input: PersonalInfoInput;
}


export interface MutationProcessContractBonusesArgs {
  bonusIds: ReadonlyArray<Scalars['ID']['input']>;
}


export interface MutationPublishOnboardingListArgs {
  id: Scalars['ID']['input'];
}


export interface MutationRecalculatePayrollArgs {
  payrollId: Scalars['ID']['input'];
}


export interface MutationRefuseBonusArgs {
  input: RefuseBonusInput;
}


export interface MutationRejectComplianceListItemArgs {
  id: Scalars['ID']['input'];
  input: RejectComplianceListItemInput;
}


export interface MutationRejectEsMatchArgs {
  bucket?: InputMaybe<Scalars['ID']['input']>;
  uuid: Scalars['String']['input'];
}


export interface MutationRejectLedgerAttachmentArgs {
  ledgerAttachmentId: Scalars['ID']['input'];
}


export interface MutationRejectOnboardingItemArgs {
  id: Scalars['ID']['input'];
  rejectionNotes: Scalars['String']['input'];
}


export interface MutationRemoveInterestArgs {
  bucket?: InputMaybe<Scalars['ID']['input']>;
  job_uuid: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationRemoveReferenceArgs {
  id: Scalars['ID']['input'];
}


export interface MutationReportMobileAppVersionArgs {
  input: ReportMobileAppVersionInput;
}


export interface MutationRepublishOnboardingListArgs {
  id: Scalars['ID']['input'];
}


export interface MutationRequestActivationArgs {
  input: RequestActivationInput;
  nurseProfileId?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationRequestSmsVerificationArgs {
  phone: Scalars['String']['input'];
  raiseValidationErrors?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
}


export interface MutationResendReferenceFormArgs {
  id: Scalars['ID']['input'];
}


export interface MutationResetUserPasswordArgs {
  input: ResetUserPasswordInput;
}


export interface MutationRetakeReliasAssessmentArgs {
  id: Scalars['ID']['input'];
}


export interface MutationRetryTimecardOcrParsingArgs {
  ledgerAttachmentId: Scalars['ID']['input'];
}


export interface MutationSaveFacilityArgs {
  facilitySlug: Scalars['String']['input'];
  nurseProfileId: Scalars['ID']['input'];
}


export interface MutationSendPayPreviewArgs {
  input: RequestPayPreviewInput;
}


export interface MutationSendUserResetPasswordInstructionsArgs {
  input: SendUserResetPasswordInstructionsInput;
}


export interface MutationSignInUserArgs {
  input: SignInUserInput;
}


export interface MutationSignUpArgs {
  input: SignUpInput;
}


export interface MutationSplitAndMatchReconReportItemArgs {
  entry: SplitAndMatchReconReportItemEntryInput;
  reconReportItemId: Scalars['ID']['input'];
}


export interface MutationSubmitComplianceListItemArgs {
  id: Scalars['ID']['input'];
}


export interface MutationSubmitReferenceResponseArgs {
  charge_duties: Scalars['String']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  employment_date_comments?: InputMaybe<Scalars['String']['input']>;
  employment_date_confirmation?: InputMaybe<Scalars['Boolean']['input']>;
  employment_other?: InputMaybe<Scalars['String']['input']>;
  job_title: Scalars['String']['input'];
  rating_care: Scalars['String']['input'];
  rating_documentation: Scalars['String']['input'];
  rating_flexible: Scalars['String']['input'];
  rating_patient_communication: Scalars['String']['input'];
  rating_policies: Scalars['String']['input'];
  rating_professional: Scalars['String']['input'];
  rating_punctual: Scalars['String']['input'];
  rating_staff_communication: Scalars['String']['input'];
  relationship: Scalars['String']['input'];
  response_token: Scalars['String']['input'];
  signed_name: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  would_rehire: Scalars['Boolean']['input'];
}


export interface MutationSubmitTimeSheetArgs {
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  reasonForNotAttachingFile?: InputMaybe<Scalars['String']['input']>;
  weekOff?: InputMaybe<Scalars['Boolean']['input']>;
  willUploadFileLater?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface MutationTechnologiesUpdateArgs {
  technologies?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
}


export interface MutationTechnologyDeleteArgs {
  uuid: Scalars['String']['input'];
}


export interface MutationTechnologyUpsertArgs {
  proficiency?: InputMaybe<Scalars['String']['input']>;
  technology?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationToggleComplianceListItemArchivedArgs {
  id: Scalars['ID']['input'];
}


export interface MutationToggleOnboardingItemLiveArgs {
  id: Scalars['ID']['input'];
}


export interface MutationToggleOnboardingListItemArchivedArgs {
  id: Scalars['ID']['input'];
}


export interface MutationTransitionPayrollStatusArgs {
  appMessage?: InputMaybe<Scalars['String']['input']>;
  payrollId: Scalars['ID']['input'];
  transitionEvent: Scalars['String']['input'];
  transitionNotes?: InputMaybe<Scalars['String']['input']>;
  transitionReason: Scalars['String']['input'];
}


export interface MutationTriggerBrazeCampaignArgs {
  campaignId: Scalars['String']['input'];
}


export interface MutationUnconfirmReconReportItemArgs {
  id: Scalars['ID']['input'];
}


export interface MutationUnconfirmVmsReverseInvoiceItemContractArgs {
  invoiceId: Scalars['ID']['input'];
  mspId: Scalars['ID']['input'];
  vmsId: Scalars['ID']['input'];
  vmsReverseInvoiceItemContractId: Scalars['ID']['input'];
}


export interface MutationUnhideEsMatchArgs {
  bucket?: InputMaybe<Scalars['ID']['input']>;
  uuid: Scalars['String']['input'];
}


export interface MutationUnlockTimeSheetEditArgs {
  payrollId: Scalars['ID']['input'];
}


export interface MutationUnmarkClearedByTrustedOnboardingListArgs {
  id: Scalars['String']['input'];
}


export interface MutationUnmarkFacilityClearedToTentativelyClearedOnboardingListArgs {
  id: Scalars['String']['input'];
}


export interface MutationUnmarkFacilityClearedToTrustedClearedOnboardingListArgs {
  id: Scalars['String']['input'];
}


export interface MutationUnmarkFdiSentOnboardingListArgs {
  id: Scalars['String']['input'];
}


export interface MutationUnmarkTentativelyClearedOnboardingListArgs {
  id: Scalars['ID']['input'];
}


export interface MutationUnpublishOnboardingListArgs {
  id: Scalars['ID']['input'];
}


export interface MutationUnverifyCredentialArgs {
  sourceId: Scalars['String']['input'];
  type: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
}


export interface MutationUpdateAboutMeArgs {
  input: UpdateAboutMeInput;
}


export interface MutationUpdateAdminNoteArgs {
  input: AdminNoteInput;
}


export interface MutationUpdateAffiliationHistoryArgs {
  id: Scalars['ID']['input'];
  input: UpdateAffiliationHistoryInput;
}


export interface MutationUpdateAssessmentOnboardingItemArgs {
  assessmentId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  input: UpdateAssessmentOnboardingItemInput;
}


export interface MutationUpdateAwardArgs {
  awardId: Scalars['ID']['input'];
  input: UpdateAwardInput;
}


export interface MutationUpdateCeuCertificateArgs {
  fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  goalUuids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  input: UpdateCeuCertificateInput;
}


export interface MutationUpdateCeuGoalArgs {
  id: Scalars['ID']['input'];
  input: UpdateCeuGoalInput;
}


export interface MutationUpdateClickIdsArgs {
  gbraid?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
  wbraid?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationUpdateComplianceChecklistArgs {
  complianceChecklist: UpdateComplianceChecklistInput;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateComplianceItemTargetArgs {
  id: Scalars['ID']['input'];
  targetId: Scalars['ID']['input'];
}


export interface MutationUpdateComplianceListArgs {
  id: Scalars['ID']['input'];
  input: UpdateComplianceListInput;
}


export interface MutationUpdateComplianceListItemArgs {
  id: Scalars['ID']['input'];
  input: UpdateComplianceListItemInput;
}


export interface MutationUpdateContractBonusArgs {
  bonusId: Scalars['ID']['input'];
  input: ContractBonusInput;
}


export interface MutationUpdateContractBonusStatusArgs {
  bonusId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
}


export interface MutationUpdateDocumentArgs {
  fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  id: Scalars['ID']['input'];
  input: UpdateDocumentInput;
  uploads?: InputMaybe<ReadonlyArray<FileUploadTypeInput>>;
}


export interface MutationUpdateDocumentOnboardingItemArgs {
  id: Scalars['ID']['input'];
  input: UpdateDocumentOnboardingItemInput;
}


export interface MutationUpdateEducationArgs {
  id: Scalars['ID']['input'];
  input: UpdateEducationInput;
}


export interface MutationUpdateEmploymentArgs {
  id: Scalars['ID']['input'];
  input: UpdateEmploymentEmploymentInput;
}


export interface MutationUpdateEmploymentGapArgs {
  id: Scalars['ID']['input'];
  input: UpdateEmploymentGapEmploymentInput;
}


export interface MutationUpdateHealthDocOnboardingItemArgs {
  healthDocCategory?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  input: UpdateHealthDocOnboardingItemInput;
}


export interface MutationUpdateIdentificationDocumentArgs {
  documentId: Scalars['ID']['input'];
  fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  input: UpdateIdentificationDocumentInput;
}


export interface MutationUpdateInvoiceArgs {
  actualReceivableAmount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  invoiceDate?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['ID']['input'];
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  manualOverride?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<InvoiceStatus>;
  tagIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  updateReconcileReview?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface MutationUpdateJobAlertArgs {
  id: Scalars['ID']['input'];
  input: UpdateJobAlertInput;
}


export interface MutationUpdateLicenseArgs {
  file_uuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  id: Scalars['ID']['input'];
  input: UpdateLicenseInput;
  uploads?: InputMaybe<ReadonlyArray<FileUploadTypeInput>>;
}


export interface MutationUpdateLicenseOnboardingItemArgs {
  id: Scalars['ID']['input'];
  input: UpdateLicenseOnboardingItemInput;
  licenseId?: InputMaybe<Scalars['ID']['input']>;
  licenseType: AlliedHealthNursingLicenseType;
}


export interface MutationUpdateLicenseVerificationArgs {
  fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  id: Scalars['ID']['input'];
  input: UpdateLicenseVerificationInput;
  uploads?: InputMaybe<ReadonlyArray<FileUploadTypeInput>>;
}


export interface MutationUpdateNurseAssessmentArgs {
  fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  id: Scalars['ID']['input'];
  input: UpdateNurseAssessmentInput;
}


export interface MutationUpdateNurseCertificationArgs {
  certificationId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  input: UpdateNurseCertificationInput;
}


export interface MutationUpdateNurseHealthDocArgs {
  fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  healthDocId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  input: UpdateNurseHealthDocInput;
}


export interface MutationUpdateNurseHealthDocVaccinationArgs {
  fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  id: Scalars['ID']['input'];
  input: ReadonlyArray<NurseHealthDocVaccinationInput>;
  nurseProfileId?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationUpdateNurseNoteArgs {
  input: NoteInput;
}


export interface MutationUpdateNursePreferencesArgs {
  id: Scalars['ID']['input'];
  input: UpdateNursePreferencesInput;
}


export interface MutationUpdateNurseProfileArgs {
  id: Scalars['ID']['input'];
  input: UpdateNurseProfileInput;
}


export interface MutationUpdateNurseRoleArgs {
  roleId: Scalars['ID']['input'];
}


export interface MutationUpdateNurseTypeArgs {
  nurseType: NurseTypes;
}


export interface MutationUpdateOnboardingItemArgs {
  id: Scalars['ID']['input'];
  input: UpdateOnboardingItemInput;
}


export interface MutationUpdateOnboardingItemDateFieldArgs {
  date: Scalars['ISO8601Date']['input'];
  id: Scalars['ID']['input'];
}


export interface MutationUpdateOnboardingItemInternalNotesArgs {
  id: Scalars['ID']['input'];
  internalNotes: Scalars['String']['input'];
}


export interface MutationUpdateOnboardingItemTargetArgs {
  id: Scalars['ID']['input'];
  targetId: Scalars['ID']['input'];
}


export interface MutationUpdateOnboardingItemUploadStatusArgs {
  id: Scalars['ID']['input'];
  uploadStatus: TodoListItemUploadStatusEnum;
}


export interface MutationUpdateOnboardingItemsDueDateArgs {
  dueDate: Scalars['ISO8601Date']['input'];
  ids: ReadonlyArray<Scalars['ID']['input']>;
}


export interface MutationUpdateOnboardingItemsRelativeDueDateArgs {
  ids: ReadonlyArray<Scalars['ID']['input']>;
  relativeDueDate: Scalars['String']['input'];
}


export interface MutationUpdateOnboardingListArgs {
  id: Scalars['ID']['input'];
  input: UpdateOnboardingListInput;
}


export interface MutationUpdateOnboardingNeedsToBeScheduledArgs {
  id: Scalars['ID']['input'];
  needsToBeScheduled: Scalars['Boolean']['input'];
}


export interface MutationUpdatePayrollAccrualsArgs {
  accruals: AccrualsInput;
}


export interface MutationUpdatePayrollCorrectionRateArgs {
  payrollId: Scalars['ID']['input'];
  rateConfig: RateConfigInput;
}


export interface MutationUpdatePayrollStatusArgs {
  payrollId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
}


export interface MutationUpdatePayrollTagsArgs {
  payrollId: Scalars['ID']['input'];
  tagIds: ReadonlyArray<Scalars['ID']['input']>;
}


export interface MutationUpdateProfilePhotoArgs {
  file?: InputMaybe<Scalars['Upload']['input']>;
  userId: Scalars['ID']['input'];
}


export interface MutationUpdateProfilePrimarySpecialtyArgs {
  ignore: Scalars['Boolean']['input'];
  specialty: Scalars['String']['input'];
}


export interface MutationUpdateRecommendationArgs {
  id: Scalars['ID']['input'];
  input: UpdateRecommendationInput;
}


export interface MutationUpdateReferenceOnboardingItemArgs {
  id: Scalars['ID']['input'];
  input: UpdateReferenceOnboardingItemInput;
  referenceId?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationUpdateResearchArgs {
  input: UpdateResearchInput;
  researchId: Scalars['ID']['input'];
}


export interface MutationUpdateResidencyProgramArgs {
  businessId: Scalars['ID']['input'];
  clinicalSpecialtyIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  input: UpdateResidencyProgramInput;
}


export interface MutationUpdateResumeParserStepArgs {
  resumeParserStep: Scalars['String']['input'];
}


export interface MutationUpdateSavedSearchArgs {
  id: Scalars['ID']['input'];
  input: UpdateSavedSearchInput;
}


export interface MutationUpdateSearchHistoryEntryArgs {
  id: Scalars['ID']['input'];
  input: UpdateSearchHistoryEntryInput;
}


export interface MutationUpdateStaleIntentArgs {
  input: UpdateStaleIntentInput;
}


export interface MutationUpdateStaleNurseProfileArgs {
  id: Scalars['ID']['input'];
}


export interface MutationUpdateStudentClinicalExperienceArgs {
  id: Scalars['ID']['input'];
  input: UpdateStudentClinicalExperienceInput;
}


export interface MutationUpdateStudentClinicalExperienceUnitArgs {
  id: Scalars['ID']['input'];
  input: UpdateStudentClinicalExperienceUnitInput;
}


export interface MutationUpdateTimeEntryArgs {
  entry: UpdateTimeEntryInput;
}


export interface MutationUpdateTodoCandidateNotesArgs {
  text_blob?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationUpdateTodoListItemDocumentTargetArgs {
  fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  id: Scalars['ID']['input'];
  input: UpdateTodoListItemDocumentTargetInput;
  nurseProfileId?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationUpdateTodoListItemNurseAssessmentTargetArgs {
  fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  id: Scalars['ID']['input'];
  input: UpdateTodoListItemNurseAssessmentTargetInput;
  nurseProfileId?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationUpdateTodoListItemNurseCertificationTargetArgs {
  certificationInput: UpdateTodoListItemNurseCertificationInput;
  fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  id: Scalars['ID']['input'];
  input: UpdateTodoListItemNurseCertificationTargetInput;
  nurseProfileId?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationUpdateTodoListItemNurseHealthDocTargetArgs {
  fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  id: Scalars['ID']['input'];
  input: UpdateTodoListItemNurseHealthDocTargetInput;
  nurseProfileId: Scalars['ID']['input'];
}


export interface MutationUpdateVerificationOfEmploymentOnboardingItemArgs {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateVerificationOfEmploymentOnboardingItemInput>;
}


export interface MutationUploadComplianceListItemFileArgs {
  input: UploadComplianceListItemFileInput;
}


export interface MutationUploadInvoiceFileArgs {
  input: UploadInvoiceFileInput;
}


export interface MutationUploadOnboardingListItemFileArgs {
  input: UploadOnboardingListItemFileInput;
}


export interface MutationUploadPayrollFileArgs {
  input: UploadPayrollFileInput;
}


export interface MutationUploadResumeArgs {
  upload: FileUploadTypeInput;
}


export interface MutationUploadShiftFileArgs {
  input: UploadShiftFileInput;
}


export interface MutationUploadTimeSheetFileArgs {
  input: UploadTimeSheetFileInput;
}


export interface MutationUploadVmsLookupTableArgs {
  vmsLookupTableFile: Scalars['Upload']['input'];
}


export interface MutationUpsertAutoApplyConfigurationArgs {
  input: AutoApplyConfigurationInput;
  nurseProfileId: Scalars['ID']['input'];
}


export interface MutationUpsertClinicianLanguageArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertClinicianLanguageInput;
}


export interface MutationUpsertClinicianLocationArgs {
  locationString: Scalars['String']['input'];
}


export interface MutationUpsertEmploymentPositionArgs {
  agencyInput?: InputMaybe<UpsertEmploymentPositionAgencyInput>;
  facilityInput: UpsertEmploymentPositionFacilityInput;
  input: UpsertEmploymentPositionInput;
  parserId?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationUpsertPayrollCorrectionFileArgs {
  input: UpsertPayrollCorrectionFileInput;
}


export interface MutationUpsertReferenceArgs {
  input: UpsertReferenceInput;
  parserId?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationUpsertShiftWithEntriesArgs {
  entry: UpsertShiftEntryInput;
}


export interface MutationUpsertTimecardWithEntriesArgs {
  timecardInput: UpsertTimecardWithEntriesTimecardInput;
}


export interface MutationVendorIntegrationUpdateExternalIdentifierArgs {
  id: Scalars['ID']['input'];
  internalId?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationVerifyCredentialArgs {
  sourceId: Scalars['String']['input'];
  type: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
}


export interface MutationViewJobArgs {
  job_uuid: Scalars['String']['input'];
}


export interface MutationWithdrawRequestArgs {
  job_uuid?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<WithdrawReasonsEnum>;
  withdraw_reason?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationYearsOfExperienceUpsertArgs {
  input: YearsOfExperienceInput;
}

export interface NearbyFacility {
  readonly __typename?: 'NearbyFacility';
  readonly distance?: Maybe<Scalars['Float']['output']>;
  readonly facility: Facility;
}

export interface NestedUpdateNurseProfileInput {
  readonly backgroundQuestions?: InputMaybe<ReadonlyArray<NurseBackgroundInput>>;
  readonly birthday?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly dlExpiresOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly dlNumber?: InputMaybe<Scalars['String']['input']>;
  readonly dlState?: InputMaybe<Scalars['String']['input']>;
  readonly fullSsn?: InputMaybe<Scalars['String']['input']>;
  readonly ssnLast4?: InputMaybe<Scalars['String']['input']>;
}

export interface NestedUpdateUserInput {
  readonly city?: InputMaybe<Scalars['String']['input']>;
  readonly cityPermanent?: InputMaybe<Scalars['String']['input']>;
  readonly countryPermanent?: InputMaybe<CountryPermanentEnum>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly googlePlaceIdPermanent?: InputMaybe<Scalars['String']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly marketingSmsAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  readonly middleName?: InputMaybe<Scalars['String']['input']>;
  readonly nurseProfile?: InputMaybe<NestedUpdateNurseProfileInput>;
  readonly password?: InputMaybe<Scalars['String']['input']>;
  readonly passwordConfirmation?: InputMaybe<Scalars['String']['input']>;
  readonly phone?: InputMaybe<Scalars['String']['input']>;
  readonly preferredName?: InputMaybe<Scalars['String']['input']>;
  readonly preferredPronoun?: InputMaybe<Scalars['String']['input']>;
  readonly state?: InputMaybe<Scalars['String']['input']>;
  readonly statePermanent?: InputMaybe<Scalars['String']['input']>;
  readonly streetAddress?: InputMaybe<Scalars['String']['input']>;
  readonly streetAddressPermanent?: InputMaybe<Scalars['String']['input']>;
  readonly streetNumberPermanent?: InputMaybe<Scalars['String']['input']>;
  readonly subscribedBrazeRootEmail?: InputMaybe<Scalars['Boolean']['input']>;
  readonly subscribedCeuEmail?: InputMaybe<Scalars['Boolean']['input']>;
  readonly subscribedCredentialsEmail?: InputMaybe<Scalars['Boolean']['input']>;
  readonly subscribedInvitesEmail?: InputMaybe<Scalars['Boolean']['input']>;
  readonly subscribedJobApplicationsEmail?: InputMaybe<Scalars['Boolean']['input']>;
  readonly subscribedMatchesEmail?: InputMaybe<Scalars['Boolean']['input']>;
  readonly subscribedNewsletterEmail?: InputMaybe<Scalars['Boolean']['input']>;
  readonly subscribedProductUpdatesEmail?: InputMaybe<Scalars['Boolean']['input']>;
  readonly subscribedReferencesEmail?: InputMaybe<Scalars['Boolean']['input']>;
  readonly zipcode?: InputMaybe<Scalars['String']['input']>;
  readonly zipcodePermanent?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of NestedUpdateUser. */
export interface NestedUpdateUserPayload {
  readonly __typename?: 'NestedUpdateUserPayload';
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
  readonly roleType?: Maybe<Scalars['String']['output']>;
  readonly token?: Maybe<Scalars['String']['output']>;
  readonly user: User;
}

/** Structure for not found errors */
export interface NotFoundError {
  readonly __typename?: 'NotFoundError';
  readonly message: Scalars['String']['output'];
  readonly model: Scalars['String']['output'];
}

export interface NotInterestedInput {
  readonly reason?: InputMaybe<Scalars['String']['input']>;
}

export interface NoteInput {
  readonly externalNotes?: InputMaybe<Scalars['String']['input']>;
  readonly payrollId: Scalars['ID']['input'];
}

export interface NurseAssessment extends Credential {
  readonly __typename?: 'NurseAssessment';
  readonly assessment?: Maybe<Assessment>;
  readonly assessmentRequest?: Maybe<AssessmentRequest>;
  readonly category?: Maybe<Scalars['String']['output']>;
  readonly completedOn?: Maybe<Scalars['ISO8601Date']['output']>;
  /** @deprecated use `completedOn` */
  readonly completed_on?: Maybe<Scalars['String']['output']>;
  readonly daysUntilExpiration?: Maybe<Scalars['Int']['output']>;
  readonly expirationType?: Maybe<DocumentExpiration>;
  readonly expiresOn?: Maybe<Scalars['ISO8601Date']['output']>;
  /** @deprecated use `expiresOn` */
  readonly expires_on?: Maybe<Scalars['String']['output']>;
  readonly files?: Maybe<ReadonlyArray<File>>;
  readonly id: Scalars['ID']['output'];
  readonly isArchived: Scalars['Boolean']['output'];
  readonly isExpired?: Maybe<Scalars['Boolean']['output']>;
  readonly isExpiringSoon?: Maybe<Scalars['Boolean']['output']>;
  readonly isVerified?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use `isExpired` */
  readonly is_expired?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use `isExpiringSoon` */
  readonly is_expiring_soon?: Maybe<Scalars['Boolean']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly requestedOn?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly score?: Maybe<Scalars['Float']['output']>;
  readonly uuid?: Maybe<Scalars['String']['output']>;
  readonly verifiedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly verifiedByName?: Maybe<Scalars['String']['output']>;
}

export interface NurseBackgroundInput {
  readonly answer?: InputMaybe<Scalars['Boolean']['input']>;
  readonly date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly explanation?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly licenseAffected?: InputMaybe<Scalars['Boolean']['input']>;
  readonly open?: InputMaybe<Scalars['Boolean']['input']>;
  readonly questionType?: InputMaybe<NurseBackgroundQuestionType>;
}

export interface NurseBackgroundQuestion {
  readonly __typename?: 'NurseBackgroundQuestion';
  readonly answer?: Maybe<Scalars['Boolean']['output']>;
  readonly date?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly explanation?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly licenseAffected?: Maybe<Scalars['Boolean']['output']>;
  readonly open?: Maybe<Scalars['Boolean']['output']>;
  readonly questionType: NurseBackgroundQuestionType;
}

export const enum NurseBackgroundQuestionType {
  /** Background Acknowledgement */
  BackgroundAcknowledgement = 'background_acknowledgement',
  /** Crime Conviction */
  CrimeConviction = 'crime_conviction',
  /** Liability Defendant */
  LiabilityDefendant = 'liability_defendant',
  /** License Action */
  LicenseAction = 'license_action',
  /** Previously Terminated */
  PreviouslyTerminated = 'previously_terminated'
};

export interface NurseCertification extends Credential {
  readonly __typename?: 'NurseCertification';
  readonly certification: Certification;
  readonly certificationUuid?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `certificationUuid` */
  readonly certification_uuid?: Maybe<Scalars['String']['output']>;
  readonly completedOn?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly daysUntilExpiration?: Maybe<Scalars['Int']['output']>;
  readonly expirationType?: Maybe<DocumentExpiration>;
  readonly expiresOn?: Maybe<Scalars['ISO8601Date']['output']>;
  /** @deprecated use `expiresOn` */
  readonly expires_on?: Maybe<Scalars['String']['output']>;
  readonly files?: Maybe<ReadonlyArray<File>>;
  readonly id: Scalars['ID']['output'];
  readonly isExpired?: Maybe<Scalars['Boolean']['output']>;
  readonly isExpiringSoon?: Maybe<Scalars['Boolean']['output']>;
  readonly isVerified?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use `isExpired` */
  readonly is_expired?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use `isExpiringSoon` */
  readonly is_expiring_soon?: Maybe<Scalars['Boolean']['output']>;
  readonly issuingBody?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `issuingBody` */
  readonly issuing_body?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly useCompletionDate?: Maybe<Scalars['Boolean']['output']>;
  readonly uuid?: Maybe<Scalars['String']['output']>;
  readonly verifiedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly verifiedByName?: Maybe<Scalars['String']['output']>;
}

export interface NurseHealthDoc extends Credential {
  readonly __typename?: 'NurseHealthDoc';
  readonly category?: Maybe<Scalars['String']['output']>;
  readonly completedOn?: Maybe<Scalars['ISO8601Date']['output']>;
  /** @deprecated use `completedOn` */
  readonly completed_on?: Maybe<Scalars['String']['output']>;
  readonly daysUntilExpiration?: Maybe<Scalars['Int']['output']>;
  readonly details?: Maybe<NurseHealthDocDetailsUnion>;
  readonly expirationType?: Maybe<DocumentExpiration>;
  readonly expiresOn?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly files?: Maybe<ReadonlyArray<File>>;
  readonly healthDoc: HealthDoc;
  /** @deprecated use `healthDoc` */
  readonly health_doc: HealthDoc;
  readonly id: Scalars['ID']['output'];
  readonly isCovidVax?: Maybe<Scalars['Boolean']['output']>;
  readonly isExpired?: Maybe<Scalars['Boolean']['output']>;
  readonly isExpiringSoon?: Maybe<Scalars['Boolean']['output']>;
  readonly isFluVax?: Maybe<Scalars['Boolean']['output']>;
  readonly isVerified?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use `isExpired` */
  readonly is_expired?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use `isExpiringSoon` */
  readonly is_expiring_soon?: Maybe<Scalars['Boolean']['output']>;
  readonly nurseProfile: NurseProfile;
  readonly todoListItems?: Maybe<ReadonlyArray<TodoListItem>>;
  readonly uuid?: Maybe<Scalars['String']['output']>;
  readonly verifiedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly verifiedByName?: Maybe<Scalars['String']['output']>;
}

export type NurseHealthDocDetailsUnion = NurseHealthDocVaccination;

export interface NurseHealthDocVaccination {
  readonly __typename?: 'NurseHealthDocVaccination';
  readonly entries?: Maybe<ReadonlyArray<NurseHealthDocVaccinationUnion>>;
}

export const enum NurseHealthDocVaccinationEnum {
  Declination = 'declination',
  Shot = 'shot',
  Willing = 'willing'
};

export interface NurseHealthDocVaccinationInput {
  readonly brand?: InputMaybe<Scalars['String']['input']>;
  readonly completedOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly kind: NurseHealthDocVaccinationKindEnum;
  readonly reason?: InputMaybe<Scalars['String']['input']>;
  readonly type: NurseHealthDocVaccinationEnum;
}

export const enum NurseHealthDocVaccinationKindEnum {
  Booster = 'booster',
  Initial = 'initial'
};

export type NurseHealthDocVaccinationUnion = NurseHealthDocVaccineDeclination | NurseHealthDocVaccineShot | NurseHealthDocVaccineWilling;

export interface NurseHealthDocVaccineDeclination {
  readonly __typename?: 'NurseHealthDocVaccineDeclination';
  readonly kind: NurseHealthDocVaccinationKindEnum;
  readonly reason: Scalars['String']['output'];
  readonly type: Scalars['String']['output'];
}

export interface NurseHealthDocVaccineShot {
  readonly __typename?: 'NurseHealthDocVaccineShot';
  readonly brand: Scalars['String']['output'];
  readonly completedOn: Scalars['ISO8601Date']['output'];
  readonly kind: NurseHealthDocVaccinationKindEnum;
  readonly type: Scalars['String']['output'];
}

export interface NurseHealthDocVaccineWilling {
  readonly __typename?: 'NurseHealthDocVaccineWilling';
  readonly kind: NurseHealthDocVaccinationKindEnum;
  readonly type: Scalars['String']['output'];
}

export interface NurseLicenseVerification extends Credential {
  readonly __typename?: 'NurseLicenseVerification';
  readonly dateOfDownload?: Maybe<Scalars['ISO8601Date']['output']>;
  /** @deprecated use `dateOfDownload` */
  readonly date_of_download?: Maybe<Scalars['String']['output']>;
  readonly daysUntilExpiration?: Maybe<Scalars['Int']['output']>;
  readonly expirationType?: Maybe<DocumentExpiration>;
  readonly expiresOn?: Maybe<Scalars['ISO8601Date']['output']>;
  /** @deprecated use `expiresOn` */
  readonly expires_on?: Maybe<Scalars['String']['output']>;
  readonly files?: Maybe<ReadonlyArray<File>>;
  readonly id: Scalars['ID']['output'];
  readonly isExpired?: Maybe<Scalars['Boolean']['output']>;
  readonly isExpiringSoon?: Maybe<Scalars['Boolean']['output']>;
  readonly isVerified?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use `isExpired` */
  readonly is_expired?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use `isExpiringSoon` */
  readonly is_expiring_soon?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use `states` */
  readonly state?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `stateCodes` */
  readonly stateCode?: Maybe<Scalars['String']['output']>;
  readonly stateCodes: ReadonlyArray<Scalars['String']['output']>;
  /** @deprecated use `stateCodes` */
  readonly state_code?: Maybe<Scalars['String']['output']>;
  readonly states: ReadonlyArray<Scalars['String']['output']>;
  readonly uuid?: Maybe<Scalars['String']['output']>;
  readonly verificationType?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `verificationType` */
  readonly verification_type?: Maybe<Scalars['String']['output']>;
  readonly verifiedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly verifiedByName?: Maybe<Scalars['String']['output']>;
}

export interface NurseMatchingItem {
  readonly __typename?: 'NurseMatchingItem';
  readonly id: Scalars['ID']['output'];
  readonly internalId?: Maybe<Scalars['String']['output']>;
  readonly mspId?: Maybe<Scalars['String']['output']>;
  readonly mspName?: Maybe<Scalars['String']['output']>;
  readonly nurseName: Scalars['String']['output'];
  readonly vmsId?: Maybe<Scalars['String']['output']>;
  readonly vmsName?: Maybe<Scalars['String']['output']>;
  readonly vmsReverseInvoiceItemCount: Scalars['Int']['output'];
}

export interface NurseMatchingStats {
  readonly __typename?: 'NurseMatchingStats';
  readonly matched: Scalars['Int']['output'];
  readonly unmatched: Scalars['Int']['output'];
}

export interface NurseMatchingsPaginatedList {
  readonly __typename?: 'NurseMatchingsPaginatedList';
  readonly items: ReadonlyArray<NurseMatchingItem>;
  readonly pageOffset: Scalars['Int']['output'];
  readonly pageSize: Scalars['Int']['output'];
  readonly totalCount: Scalars['Int']['output'];
}

export interface NursePreferences {
  readonly __typename?: 'NursePreferences';
  /** @deprecated use `autoApplyInfo { opt_in_expired_dismissed }` */
  readonly autoApplyCheckInDismissed: Scalars['Boolean']['output'];
  /** @deprecated use `autoApplyInfo { first_time }` */
  readonly autoApplyFirstTime: Scalars['Boolean']['output'];
  /** @deprecated use `autoApplyInfo { optIn }` */
  readonly autoApplyOptIn?: Maybe<Scalars['Boolean']['output']>;
  readonly broadPrefLocations?: Maybe<ReadonlyArray<BroadPrefLocations>>;
  readonly careSettingOther?: Maybe<Scalars['String']['output']>;
  readonly careSettingPrefs?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly clinicalUnits?: Maybe<ReadonlyArray<ClinicalUnit>>;
  readonly coastLocations?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly contractLengths?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly currentOccupation?: Maybe<Scalars['String']['output']>;
  readonly earliestStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly explorerRole?: Maybe<Scalars['String']['output']>;
  readonly firstTimeTravelerFriendly?: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly importantDestinationPrefs?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly importantJobAttribute?: Maybe<Scalars['String']['output']>;
  readonly importantJobAttributeOther?: Maybe<Scalars['String']['output']>;
  readonly jobSortColumn?: Maybe<JobsCollectionSortField>;
  readonly jobSortOrder?: Maybe<JobsCollectionSortOrder>;
  readonly jobTypes?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly learningPrefs?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly locations?: Maybe<ReadonlyArray<Location>>;
  readonly magnetPref?: Maybe<Scalars['String']['output']>;
  readonly notificationPref?: Maybe<Scalars['String']['output']>;
  readonly seenStatus?: Maybe<Scalars['String']['output']>;
  readonly shiftLengths?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** @deprecated Deprecated in favor of shift_prefs */
  readonly shiftPref?: Maybe<Scalars['String']['output']>;
  readonly shiftPrefs?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly specialRequirements?: Maybe<Scalars['String']['output']>;
  readonly specificLocationFlexible?: Maybe<Scalars['Boolean']['output']>;
  readonly startPref?: Maybe<Scalars['String']['output']>;
  readonly startPrefUpdatedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly technologies?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly travelExperience?: Maybe<TravelExperiences>;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly uuid: Scalars['String']['output'];
}

export interface NurseProfile {
  readonly __typename?: 'NurseProfile';
  readonly activationRequest: ActivationRequest;
  readonly activeClinicalSpecialties: ReadonlyArray<ClinicalSpecialty>;
  readonly activeClinicalSpecialtiesConnection: ClinicalSpecialtyConnection;
  readonly affiliationHistory: ReadonlyArray<AffiliationHistory>;
  readonly affiliations: ReadonlyArray<Affiliation>;
  readonly applicationReadiness: ApplicationReadiness;
  readonly applicationSummary?: Maybe<Scalars['String']['output']>;
  readonly assessments?: Maybe<ReadonlyArray<Assessment>>;
  readonly awards?: Maybe<ReadonlyArray<Award>>;
  readonly backgroundComplete: Scalars['Boolean']['output'];
  readonly backgroundQuestions?: Maybe<ReadonlyArray<NurseBackgroundQuestion>>;
  readonly birthday?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly businesses?: Maybe<ReadonlyArray<Facility>>;
  readonly canApplyJobs: Scalars['Boolean']['output'];
  readonly canUploadResume: Scalars['Boolean']['output'];
  readonly canViewJobs: Scalars['Boolean']['output'];
  readonly candidateManageUrl: Scalars['String']['output'];
  readonly careSetting?: Maybe<Scalars['String']['output']>;
  readonly certifications?: Maybe<ReadonlyArray<Certification>>;
  readonly certificationsComplete: Scalars['Boolean']['output'];
  readonly ceuCertificates: ReadonlyArray<CeuCertificate>;
  readonly ceuCertificatesForDate: ReadonlyArray<CeuCertificate>;
  readonly ceuGoals?: Maybe<ReadonlyArray<CeuGoal>>;
  readonly ceuGoalsForDate: ReadonlyArray<CeuGoal>;
  readonly checkedByNurseAdvocate: Scalars['Boolean']['output'];
  readonly citySizePref?: Maybe<Scalars['String']['output']>;
  readonly clinicalExperienceLevel?: Maybe<ClinicalExperienceLevelTypes>;
  readonly clinicalExperiences?: Maybe<ReadonlyArray<ClinicalExperience>>;
  readonly clinicalSpecialties?: Maybe<ReadonlyArray<ClinicalSpecialty>>;
  readonly computedDaysOfExpWithGaps: Scalars['Int']['output'];
  readonly computedYearsOfExp?: Maybe<Scalars['Float']['output']>;
  readonly computedYearsOfExpWithGaps: Scalars['Int']['output'];
  readonly confirmedUpdateAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Returns contracts by filter */
  readonly contractsByFilter?: Maybe<ReadonlyArray<Contract>>;
  readonly covidVaccination?: Maybe<NurseHealthDoc>;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** @deprecated Deprecated in favor of background_questions */
  readonly crimeConviction?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Deprecated in favor of background_questions */
  readonly crimeConvictionExplanation?: Maybe<Scalars['String']['output']>;
  readonly currentCeuGoal?: Maybe<CeuGoal>;
  readonly currentContract?: Maybe<Contract>;
  readonly currentEmployment?: Maybe<Employment>;
  readonly displayName?: Maybe<Scalars['String']['output']>;
  readonly dlExpiresOn?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly dlNumber?: Maybe<Scalars['String']['output']>;
  readonly dlState?: Maybe<Scalars['String']['output']>;
  readonly documents?: Maybe<ReadonlyArray<Maybe<Document>>>;
  readonly educationComplete: Scalars['Boolean']['output'];
  readonly educations?: Maybe<ReadonlyArray<Education>>;
  readonly employmentHistoryDurationDisplay: Scalars['String']['output'];
  readonly employmentHistoryDurationMonths: Scalars['Int']['output'];
  readonly employmentTypePrefs?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly employments?: Maybe<ReadonlyArray<Employment>>;
  readonly experienceComplete: Scalars['Boolean']['output'];
  readonly facilitySizePref?: Maybe<Scalars['String']['output']>;
  readonly fullSsnCollected: Scalars['Boolean']['output'];
  readonly futureTimeOffRequests?: Maybe<NurseTimeOffRequests>;
  readonly gapBetweenEducationAndEmploymentPosition: Scalars['Boolean']['output'];
  readonly googlePlaceId?: Maybe<Scalars['String']['output']>;
  readonly happinessPref?: Maybe<Scalars['String']['output']>;
  readonly hasBeenPlaced: Scalars['Boolean']['output'];
  readonly hasPositionsInvalidHoursOverlap: Scalars['Boolean']['output'];
  readonly hasPositionsLocationOverlap: Scalars['Boolean']['output'];
  readonly hasSeenAnyMatches: Scalars['Boolean']['output'];
  readonly helpArticles?: Maybe<ReadonlyArray<HelpArticle>>;
  readonly hourlySalary?: Maybe<Scalars['Int']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly idDocs?: Maybe<ReadonlyArray<Document>>;
  readonly instantOfferRequested: Scalars['Boolean']['output'];
  readonly isActivated?: Maybe<Scalars['Boolean']['output']>;
  readonly isAllied: Scalars['Boolean']['output'];
  readonly isOnboarding: Scalars['Boolean']['output'];
  readonly isPendingOnboarding: Scalars['Boolean']['output'];
  readonly isYearsOfExpCompleted: Scalars['Boolean']['output'];
  readonly jobAlerts: ReadonlyArray<JobAlert>;
  readonly jobApplicationConnection: JobApplicationConnection;
  readonly jobApplications: CandidateJobApplications;
  readonly jobApplicationsSummary: JobApplicationsSummary;
  readonly jobAspectPrefs?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** Returns job offers */
  readonly jobOffers: ReadonlyArray<JobOffer>;
  readonly jobPlacements?: Maybe<ReadonlyArray<JobPlacement>>;
  readonly jobs: CandidateJobs;
  readonly joinedCrisisResponseAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly languages?: Maybe<ReadonlyArray<Language>>;
  /** @deprecated Deprecated in favor of background_questions */
  readonly liabilityDefendant?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Deprecated in favor of background_questions */
  readonly liabilityDefendantExplanation?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated in favor of background_questions */
  readonly licenseAction?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Deprecated in favor of background_questions */
  readonly licenseActionExplanation?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated in favor of nurse_license_verifications */
  readonly licenseVerifications?: Maybe<ReadonlyArray<LicenseVerification>>;
  readonly licenses?: Maybe<ReadonlyArray<License>>;
  readonly licensesComplete: Scalars['Boolean']['output'];
  readonly location?: Maybe<Location>;
  readonly locationAddress?: Maybe<Scalars['String']['output']>;
  readonly locationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  readonly locationMatchBuckets: ReadonlyArray<CandidateMatchBucket>;
  readonly locationSlug?: Maybe<Scalars['String']['output']>;
  readonly locationString?: Maybe<Scalars['String']['output']>;
  readonly lookingFor?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  readonly matchBucket?: Maybe<CandidateMatchBucket>;
  readonly name?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  readonly newGradProfileChecklistComplete: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  readonly nextMatchedJob?: Maybe<Job>;
  readonly numActiveReferences: Scalars['Int']['output'];
  readonly numExpiredCredentials?: Maybe<Scalars['Int']['output']>;
  readonly numExpiringCredentials?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Deprecated features >= mobile app 3.25.4 */
  readonly numStepsLeftToActivate: Scalars['Int']['output'];
  readonly numTotalCredentials?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Deprecated features >= mobile app 3.25.4 */
  readonly numTotalStepsToActivate: Scalars['Int']['output'];
  readonly nurseAdvocate?: Maybe<SalesforceUser>;
  readonly nurseAssessments?: Maybe<ReadonlyArray<NurseAssessment>>;
  readonly nurseCertifications?: Maybe<ReadonlyArray<NurseCertification>>;
  readonly nurseHealthDocs?: Maybe<ReadonlyArray<NurseHealthDoc>>;
  readonly nurseLicenseVerifications?: Maybe<ReadonlyArray<NurseLicenseVerification>>;
  readonly nursePreferences?: Maybe<NursePreferences>;
  readonly nurseType?: Maybe<Scalars['String']['output']>;
  readonly nursysVerified?: Maybe<Scalars['Boolean']['output']>;
  readonly onboardingPlacement?: Maybe<JobPlacement>;
  readonly opportunityTypePrefs?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** @deprecated Discontinued feature. Use role instead. */
  readonly otherRole?: Maybe<OtherRole>;
  readonly patientPopPref?: Maybe<Scalars['String']['output']>;
  readonly pendingFacilitySurveyEmployment?: Maybe<Employment>;
  /** @deprecated Use profile_completion.meta */
  readonly percentComplete?: Maybe<Scalars['Float']['output']>;
  readonly permanentAddressComplete: Scalars['Boolean']['output'];
  readonly phoneVerified: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  readonly popularMatchBuckets: ReadonlyArray<CandidateMatchBucket>;
  readonly positionSpecialties?: Maybe<ReadonlyArray<ClinicalSpecialty>>;
  readonly positions?: Maybe<ReadonlyArray<Position>>;
  readonly preferenceBlob?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated in favor of background_questions */
  readonly previouslyTerminated?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Deprecated in favor of background_questions */
  readonly previouslyTerminatedExplanation?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  readonly primaryMatchBucket: CandidateMatchBucket;
  readonly primarySpecialty?: Maybe<ClinicalSpecialty>;
  readonly professionalTitles?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly profileCompletion?: Maybe<NurseProfileCompletion>;
  /** It returns the uploaded resume */
  readonly profileCompletionUploadedResume?: Maybe<Document>;
  readonly recommendations?: Maybe<ReadonlyArray<Recommendation>>;
  readonly references?: Maybe<ReadonlyArray<Reference>>;
  readonly referencesComplete: Scalars['Boolean']['output'];
  readonly reliasUser?: Maybe<ReliasUser>;
  readonly relocationPref?: Maybe<Scalars['String']['output']>;
  /** Return Request Review status */
  readonly requestReview: RequestReview;
  readonly requestedJobs: CandidateRequestedJobs;
  readonly researches?: Maybe<ReadonlyArray<Research>>;
  readonly role?: Maybe<Role>;
  readonly roleAbbreviation?: Maybe<Scalars['String']['output']>;
  readonly roleKey?: Maybe<Scalars['String']['output']>;
  readonly roleName?: Maybe<Scalars['String']['output']>;
  readonly savedFacility: Scalars['Boolean']['output'];
  /** @deprecated Renamed to job_alerts */
  readonly savedSearches: ReadonlyArray<SavedSearch>;
  readonly searchHistory?: Maybe<SearchHistory>;
  /** Return assessments of type Skills Checklist */
  readonly skillsChecklists: ReadonlyArray<NurseAssessment>;
  readonly skillsComplete?: Maybe<Scalars['Boolean']['output']>;
  readonly sortedExperienceItems?: Maybe<ReadonlyArray<ExperienceItemUnion>>;
  readonly specializations?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly squatchShareUrl?: Maybe<Scalars['String']['output']>;
  readonly ssnLast4?: Maybe<Scalars['String']['output']>;
  readonly staleIntent: Scalars['Boolean']['output'];
  readonly state?: Maybe<Scalars['String']['output']>;
  readonly statusForHelpArticles?: Maybe<Scalars['String']['output']>;
  readonly studentClinicalExperiences?: Maybe<ReadonlyArray<StudentClinicalExperience>>;
  readonly studentClinicalExperiencesComplete: Scalars['Boolean']['output'];
  readonly technologies?: Maybe<ReadonlyArray<NurseTechnology>>;
  readonly thingsToDo: ThingsToDo;
  readonly timeOffRequests?: Maybe<NurseTimeOffRequests>;
  readonly todoLists: ReadonlyArray<TodoList>;
  readonly unexplainedEmploymentGaps?: Maybe<Scalars['Boolean']['output']>;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly user?: Maybe<User>;
  readonly uuid?: Maybe<Scalars['ID']['output']>;
  readonly wizardCompleted: Scalars['Boolean']['output'];
  readonly wizardCompletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly yearsOfExp?: Maybe<Scalars['Int']['output']>;
  readonly yearsOfTravelExp?: Maybe<Scalars['Int']['output']>;
}


export interface NurseProfileActiveClinicalSpecialtiesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface NurseProfileApplicationReadinessArgs {
  jobApplicationUuid?: InputMaybe<Scalars['String']['input']>;
}


export interface NurseProfileCeuCertificatesForDateArgs {
  endDate: Scalars['ISO8601Date']['input'];
  startDate: Scalars['ISO8601Date']['input'];
}


export interface NurseProfileCeuGoalsForDateArgs {
  date: Scalars['ISO8601Date']['input'];
}


export interface NurseProfileContractsByFilterArgs {
  filter: ContractsFilter;
}


export interface NurseProfileJobApplicationConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface NurseProfileJobOffersArgs {
  filter: JobOffersFilter;
}


export interface NurseProfileJobPlacementsArgs {
  scope?: InputMaybe<JobPlacementScope>;
}


export interface NurseProfileLicensesArgs {
  notExpired?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface NurseProfileLocationMatchBucketsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  withEmpty?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface NurseProfileMatchBucketArgs {
  slug?: InputMaybe<Scalars['ID']['input']>;
}


export interface NurseProfileNextMatchedJobArgs {
  bucketSlug?: InputMaybe<Scalars['ID']['input']>;
  exactMatchesOnly?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface NurseProfileNurseCertificationsArgs {
  notExpired?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface NurseProfilePopularMatchBucketsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  withEmpty?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface NurseProfileSavedFacilityArgs {
  facilitySlug: Scalars['String']['input'];
}


export interface NurseProfileSearchHistoryArgs {
  searchForm: Scalars['String']['input'];
}


export interface NurseProfileThingsToDoArgs {
  canDownloadApp?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface NurseProfileCompletion {
  readonly __typename?: 'NurseProfileCompletion';
  /** @deprecated use `steps` and `meta` */
  readonly completedExpirableSteps?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** @deprecated use `steps` and `meta` */
  readonly completedSteps?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly id: Scalars['ID']['output'];
  readonly meta: ProfileCompletionMeta;
  /** @deprecated use `steps` and `meta` */
  readonly pendingExpirableSteps?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** @deprecated use `steps` and `meta` */
  readonly pendingSteps?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly profileCompletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly steps: ProfileCompletionSteps;
  /** @deprecated use `steps` and `meta` */
  readonly totalCompleted: Scalars['Int']['output'];
  /** @deprecated use `steps` and `meta` */
  readonly totalPending: Scalars['Int']['output'];
}

export interface NurseTechnology {
  readonly __typename?: 'NurseTechnology';
  readonly id: Scalars['ID']['output'];
  readonly proficiency?: Maybe<Scalars['String']['output']>;
  readonly technology?: Maybe<Scalars['String']['output']>;
  readonly uuid?: Maybe<Scalars['String']['output']>;
}

export interface NurseTimeOffRequest {
  readonly __typename?: 'NurseTimeOffRequest';
  readonly fromDate: Scalars['ISO8601Date']['output'];
  readonly toDate: Scalars['ISO8601Date']['output'];
}

export interface NurseTimeOffRequests {
  readonly __typename?: 'NurseTimeOffRequests';
  readonly requests: ReadonlyArray<NurseTimeOffRequest>;
}

export const enum NurseTypes {
  /** Full Time Staff */
  FullTimeStaff = 'full_time_staff',
  /** New Grad */
  NewGrad = 'new_grad',
  /** Not Working */
  NotWorking = 'not_working',
  /** Part Time Staff */
  PartTimeStaff = 'part_time_staff',
  /** Staff */
  Staff = 'staff',
  /** Student */
  Student = 'student',
  /** Travel */
  Travel = 'travel'
};

export interface OffsetPaginationInput {
  readonly page?: InputMaybe<Scalars['Int']['input']>;
  readonly pageSize?: InputMaybe<Scalars['Int']['input']>;
}

/** Autogenerated return type of OnboardingItemMarkIncomplete. */
export interface OnboardingItemMarkIncompletePayload {
  readonly __typename?: 'OnboardingItemMarkIncompletePayload';
  readonly todoList: TodoList;
  readonly todoListItem: TodoListItem;
}

/** Autogenerated return type of OnboardingItemRejection. */
export interface OnboardingItemRejectionPayload {
  readonly __typename?: 'OnboardingItemRejectionPayload';
  readonly todoList: TodoList;
  readonly todoListItem: TodoListItem;
}

export interface OnboardingList {
  readonly __typename?: 'OnboardingList';
  readonly adminStatus?: Maybe<Scalars['String']['output']>;
  readonly adminUser?: Maybe<AdminUser>;
  readonly allTasksCount: Scalars['Int']['output'];
  readonly archivedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly beforeStartDeadlineDays?: Maybe<Scalars['Int']['output']>;
  readonly canComplete: Scalars['Boolean']['output'];
  readonly canMarkClearedByTrusted: Scalars['Boolean']['output'];
  readonly canMarkFacilityCleared: Scalars['Boolean']['output'];
  readonly canMarkFdiSent: Scalars['Boolean']['output'];
  readonly canMarkTentativelyCleared: Scalars['Boolean']['output'];
  readonly canPublish: Scalars['Boolean']['output'];
  readonly canUnmarkClearedByTrusted: Scalars['Boolean']['output'];
  readonly canUnmarkFacilityClearedToTentativelyCleared: Scalars['Boolean']['output'];
  readonly canUnmarkFacilityClearedToTrustedCleared: Scalars['Boolean']['output'];
  readonly canUnmarkFdiSent: Scalars['Boolean']['output'];
  readonly canUnmarkTentativelyCleared: Scalars['Boolean']['output'];
  readonly canUnpublish: Scalars['Boolean']['output'];
  /** Returns history of changes for todo lists and items */
  readonly changesHistoryConnection: ChangeRecordConnection;
  readonly completeByDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** @deprecated use `completeByDate` */
  readonly complete_by_date?: Maybe<Scalars['String']['output']>;
  readonly completedTasksCount: Scalars['Int']['output'];
  readonly complianceListUrl?: Maybe<Scalars['String']['output']>;
  readonly contractSignedDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly currentStatus?: Maybe<OnboardingListStatus>;
  readonly endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly facilityChecklistFile?: Maybe<File>;
  readonly fdiSentAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly hardDeadline?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly healthSystemChecklistFile?: Maybe<File>;
  readonly id: Scalars['ID']['output'];
  /** @deprecated no longer used */
  readonly incentiveDeadline?: Maybe<Scalars['ISO8601Date']['output']>;
  /** @deprecated no longer used */
  readonly incentive_deadline?: Maybe<Scalars['String']['output']>;
  readonly isCompliant?: Maybe<Scalars['Boolean']['output']>;
  readonly isTemplate?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use `isTemplate` */
  readonly is_template?: Maybe<Scalars['Boolean']['output']>;
  readonly items: ReadonlyArray<TodoListItem>;
  readonly jobPlacement?: Maybe<JobPlacement>;
  readonly listType?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `listType` */
  readonly list_type?: Maybe<Scalars['String']['output']>;
  readonly markedCompleteAt?: Maybe<Scalars['ISO8601Date']['output']>;
  /** @deprecated use `markedCompleteAt` */
  readonly marked_complete_at?: Maybe<Scalars['String']['output']>;
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly numCompletedItems?: Maybe<Scalars['Int']['output']>;
  readonly numExternalCompletedItems?: Maybe<Scalars['Int']['output']>;
  readonly numExternalItems?: Maybe<Scalars['Int']['output']>;
  readonly numInternalCompletedItems?: Maybe<Scalars['Int']['output']>;
  readonly numInternalItems?: Maybe<Scalars['Int']['output']>;
  readonly numInternalPendingItems?: Maybe<Scalars['Int']['output']>;
  readonly numInternalReadyForUploadItems?: Maybe<Scalars['Int']['output']>;
  readonly numInternalRejectedItems?: Maybe<Scalars['Int']['output']>;
  readonly numItems?: Maybe<Scalars['Int']['output']>;
  readonly numReadyForUpload?: Maybe<Scalars['Int']['output']>;
  readonly numTasksDue?: Maybe<Scalars['Int']['output']>;
  readonly numTasksNeedingAttention?: Maybe<Scalars['Int']['output']>;
  readonly numTasksPending?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use `numTasksDue` */
  readonly num_tasks_due?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use `numTasksNeedingAttention` */
  readonly num_tasks_needing_attention?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use `numTasksPending` */
  readonly num_tasks_pending?: Maybe<Scalars['Int']['output']>;
  readonly nurseProfile?: Maybe<NurseProfile>;
  readonly onboardingLink?: Maybe<Scalars['String']['output']>;
  readonly onboardingNote?: Maybe<Scalars['String']['output']>;
  readonly onboardingNoteTimestamp?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly owner?: Maybe<AdminUser>;
  readonly parentId?: Maybe<Scalars['Int']['output']>;
  readonly pendingTasksCount: Scalars['Int']['output'];
  readonly percentageCompletedItems: Scalars['Int']['output'];
  readonly publishedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  /** @deprecated use `publishedAt` */
  readonly published_at?: Maybe<Scalars['String']['output']>;
  readonly snapshot?: Maybe<TodoListSnapshot>;
  readonly sortedTodoListItems: SortedTodoListItems;
  readonly startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** @deprecated use `startDate` */
  readonly start_date?: Maybe<Scalars['String']['output']>;
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly targetBusinessLocation?: Maybe<Location>;
  readonly targetBusinessName?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `targetBusinessLocation` */
  readonly target_business_location?: Maybe<Location>;
  /** @deprecated use `targetBusinessName` */
  readonly target_business_name?: Maybe<Scalars['String']['output']>;
  readonly timelineTodoListItems: TimelineTodoListItems;
  readonly todoListItems: ReadonlyArray<TodoListItem>;
  /** @deprecated use `todoListItems` */
  readonly todo_list_items: ReadonlyArray<TodoListItem>;
  readonly uuid?: Maybe<Scalars['String']['output']>;
}


export interface OnboardingListChangesHistoryConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface OnboardingListSortedTodoListItemsArgs {
  filter?: InputMaybe<SortedTodoListItemsFilter>;
}


export interface OnboardingListTimelineTodoListItemsArgs {
  filter?: InputMaybe<SortedTodoListItemsFilter>;
}


export interface OnboardingListTodoListItemsArgs {
  filter?: InputMaybe<TodoListItemsFilter>;
}


export interface OnboardingListTodo_List_ItemsArgs {
  filter?: InputMaybe<TodoListItemsFilter>;
}

/** The connection type for OnboardingList. */
export interface OnboardingListConnection {
  readonly __typename?: 'OnboardingListConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<OnboardingListEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<OnboardingList>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface OnboardingListEdge {
  readonly __typename?: 'OnboardingListEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<OnboardingList>;
}

export interface OnboardingListStats {
  readonly __typename?: 'OnboardingListStats';
  readonly all: Scalars['Int']['output'];
  readonly completed: Scalars['Int']['output'];
  readonly drafts: Scalars['Int']['output'];
  readonly facilityCleared: Scalars['Int']['output'];
  readonly manualDrafts: Scalars['Int']['output'];
  readonly published: Scalars['Int']['output'];
  readonly tentativelyCleared: Scalars['Int']['output'];
  readonly trustedCleared: Scalars['Int']['output'];
}

export interface OnboardingListStatus {
  readonly __typename?: 'OnboardingListStatus';
  readonly createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly notes: Scalars['String']['output'];
  readonly status: OnboardingListStatusEnum;
}

export const enum OnboardingListStatusEnum {
  AtRisk = 'at_risk',
  OffTrack = 'off_track',
  OnTrack = 'on_track'
};

/** Autogenerated return type of OptOutAutoApply. */
export interface OptOutAutoApplyPayload {
  readonly __typename?: 'OptOutAutoApplyPayload';
  readonly autoApplyInfo: AutoApplyInfo;
}

export interface Option {
  readonly __typename?: 'Option';
  readonly text: Scalars['String']['output'];
  readonly value: Scalars['String']['output'];
}

export const enum OrderDirection {
  Asc = 'ASC',
  Desc = 'DESC',
  Ascend = 'ascend',
  Descend = 'descend'
};

export interface OtherRole {
  readonly __typename?: 'OtherRole';
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  /** @deprecated use 'type' */
  readonly roleType: Scalars['String']['output'];
  readonly type: RoleType;
}

export interface Package {
  readonly __typename?: 'Package';
  readonly enabled: Scalars['Boolean']['output'];
  readonly externalId: Scalars['String']['output'];
  readonly externalName: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly services?: Maybe<ReadonlyArray<PackageService>>;
}

export interface PackageService {
  readonly __typename?: 'PackageService';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly enabled: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly package: Package;
}

/** Information about pagination in a connection. */
export interface PageInfo {
  readonly __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
}

export interface PaidLeaveRules {
  readonly __typename?: 'PaidLeaveRules';
  readonly hoursAvailable?: Maybe<Scalars['Float']['output']>;
  readonly scopeName?: Maybe<Scalars['String']['output']>;
}

export const enum ParsingStatusEnum {
  /** Error */
  Error = 'error',
  /** Failed */
  Failed = 'failed',
  /** Success */
  Success = 'success',
  /** Waiting */
  Waiting = 'waiting'
};

export interface PayBonusInput {
  readonly bonusId: Scalars['ID']['input'];
  readonly correction: Scalars['Boolean']['input'];
  readonly payrollId: Scalars['ID']['input'];
}

/** Autogenerated return type of PayBonus. */
export interface PayBonusPayload {
  readonly __typename?: 'PayBonusPayload';
  readonly payroll: Payroll;
}

export interface PayHoursCancellation {
  readonly __typename?: 'PayHoursCancellation';
  readonly active?: Maybe<Scalars['Boolean']['output']>;
  readonly adjustment?: Maybe<Scalars['Boolean']['output']>;
  readonly ghrPaid: Scalars['Boolean']['output'];
  readonly hours: Scalars['Float']['output'];
  readonly id: Scalars['ID']['output'];
  readonly paidHours: Scalars['Float']['output'];
  readonly periodEnd: Scalars['ISO8601Date']['output'];
  readonly shiftDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly unpaidHours: Scalars['Float']['output'];
}

export interface PayHoursCancellationHistory {
  readonly __typename?: 'PayHoursCancellationHistory';
  readonly id: Scalars['ID']['output'];
  readonly payHoursCancellations: ReadonlyArray<PayHoursCancellation>;
  readonly periodEnd: Scalars['ISO8601Date']['output'];
  readonly sourceId?: Maybe<Scalars['ID']['output']>;
}

/** The connection type for PayHoursCancellationHistory. */
export interface PayHoursCancellationHistoryConnection {
  readonly __typename?: 'PayHoursCancellationHistoryConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<PayHoursCancellationHistoryEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<PayHoursCancellationHistory>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface PayHoursCancellationHistoryEdge {
  readonly __typename?: 'PayHoursCancellationHistoryEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<PayHoursCancellationHistory>;
}

export interface PayRateConfig {
  readonly __typename?: 'PayRateConfig';
  readonly callBack?: Maybe<Scalars['Float']['output']>;
  readonly charge?: Maybe<Scalars['Float']['output']>;
  readonly doubleTime?: Maybe<Scalars['Float']['output']>;
  readonly doubleTimeThresholdDaily?: Maybe<Scalars['Float']['output']>;
  readonly doubleTimeThresholdWeekly?: Maybe<Scalars['Float']['output']>;
  readonly extraTime?: Maybe<Scalars['Float']['output']>;
  readonly extraTimeWeeklyThreshold?: Maybe<Scalars['Float']['output']>;
  readonly holiday?: Maybe<Scalars['Float']['output']>;
  readonly lodgingReimbursement?: Maybe<Scalars['Float']['output']>;
  readonly lodgingReimbursementMax?: Maybe<Scalars['Float']['output']>;
  readonly mealsAndIncidentals?: Maybe<Scalars['Float']['output']>;
  readonly mealsAndIncidentalsMax?: Maybe<Scalars['Float']['output']>;
  readonly onCall?: Maybe<Scalars['Float']['output']>;
  readonly orientation?: Maybe<Scalars['Float']['output']>;
  readonly overtime?: Maybe<Scalars['Float']['output']>;
  readonly overtimeThresholdDaily?: Maybe<Scalars['Float']['output']>;
  readonly overtimeThresholdWeekly?: Maybe<Scalars['Float']['output']>;
  readonly regular?: Maybe<Scalars['Float']['output']>;
}

export interface Payroll {
  readonly __typename?: 'Payroll';
  readonly activeAdjustmentWe?: Maybe<Scalars['String']['output']>;
  readonly appMessage?: Maybe<Scalars['String']['output']>;
  readonly businessName?: Maybe<Scalars['String']['output']>;
  readonly canRecalculate?: Maybe<Scalars['Boolean']['output']>;
  readonly candidate: NurseProfile;
  /** Returns history of changes */
  readonly changesHistoryConnection: ChangeRecordConnection;
  readonly contract?: Maybe<Contract>;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly duplicated: Scalars['Boolean']['output'];
  readonly epipDates?: Maybe<Scalars['String']['output']>;
  readonly files?: Maybe<ReadonlyArray<File>>;
  readonly hoursWorked: Scalars['Float']['output'];
  readonly id: Scalars['ID']['output'];
  readonly invalidContract?: Maybe<Scalars['Boolean']['output']>;
  readonly invoice?: Maybe<Invoice>;
  readonly lastCorrectedNetAmount?: Maybe<Scalars['Float']['output']>;
  readonly ledgerAttachments?: Maybe<ReadonlyArray<LedgerAttachment>>;
  readonly lineItems?: Maybe<ReadonlyArray<PayrollLineItem>>;
  readonly linkId?: Maybe<Scalars['String']['output']>;
  readonly locationStateCode?: Maybe<Scalars['String']['output']>;
  readonly netAmount: Scalars['Float']['output'];
  readonly paidLeaveHoursAvailable?: Maybe<Scalars['Float']['output']>;
  readonly parent?: Maybe<Payroll>;
  readonly payBillBonuses?: Maybe<ReadonlyArray<BonusRuleJobPlacementShift>>;
  readonly payPreview?: Maybe<Scalars['String']['output']>;
  readonly payrollCorrection?: Maybe<Payroll>;
  readonly payrollShiftDetails?: Maybe<PayrollShiftDetails>;
  readonly payrollType: Scalars['String']['output'];
  readonly periodEnd: Scalars['ISO8601Date']['output'];
  readonly periodStart: Scalars['ISO8601Date']['output'];
  readonly previousPayroll?: Maybe<Scalars['ID']['output']>;
  readonly programName?: Maybe<Scalars['String']['output']>;
  readonly recipientId: Scalars['ID']['output'];
  readonly rejectedStatusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly requiredAttachment: Scalars['Boolean']['output'];
  readonly reviewNotes?: Maybe<Scalars['String']['output']>;
  readonly reviewType?: Maybe<Scalars['String']['output']>;
  readonly status: Scalars['String']['output'];
  readonly statusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly tags: ReadonlyArray<PayrollTag>;
  readonly timeEntries?: Maybe<Scalars['Boolean']['output']>;
  readonly timeOffs?: Maybe<Scalars['String']['output']>;
  readonly timeSheet?: Maybe<TimeSheet>;
  readonly transitionNotes?: Maybe<Scalars['String']['output']>;
  readonly transitionReason?: Maybe<Scalars['String']['output']>;
  readonly weekOff?: Maybe<Scalars['Boolean']['output']>;
}


export interface PayrollChangesHistoryConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface PayrollAccruals {
  readonly __typename?: 'PayrollAccruals';
  readonly covidLeaveHoursAvailable?: Maybe<ReadonlyArray<PayrollCovidLeaveHours>>;
  readonly daysWorked?: Maybe<Scalars['Float']['output']>;
  readonly eligibleForBenefits?: Maybe<Scalars['Boolean']['output']>;
  readonly eligibleForCovidLeave?: Maybe<Scalars['Boolean']['output']>;
  readonly historicalPayrollOverrides?: Maybe<ReadonlyArray<PayrollOverrides>>;
  readonly hoursCancelled?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['ID']['output']>;
  readonly localContract: Scalars['Boolean']['output'];
  readonly payrollOverrides?: Maybe<PayrollOverrides>;
  readonly sickLeaveAccrued?: Maybe<Scalars['Float']['output']>;
  readonly sickLeaveUsed?: Maybe<Scalars['Float']['output']>;
  readonly totalCancelledHours?: Maybe<Scalars['Float']['output']>;
}

/** The connection type for Payroll. */
export interface PayrollConnection {
  readonly __typename?: 'PayrollConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<PayrollEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Payroll>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
}

export interface PayrollCovidLeaveHours {
  readonly __typename?: 'PayrollCovidLeaveHours';
  readonly hours: Scalars['Float']['output'];
  readonly periodEnd?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly slot: Scalars['Int']['output'];
}

/** The connection type for PayrollCovidLeaveHours. */
export interface PayrollCovidLeaveHoursConnection {
  readonly __typename?: 'PayrollCovidLeaveHoursConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<PayrollCovidLeaveHoursEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<PayrollCovidLeaveHours>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface PayrollCovidLeaveHoursEdge {
  readonly __typename?: 'PayrollCovidLeaveHoursEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<PayrollCovidLeaveHours>;
}

/** An edge in a connection. */
export interface PayrollEdge {
  readonly __typename?: 'PayrollEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Payroll>;
}

export interface PayrollImagePreview {
  readonly __typename?: 'PayrollImagePreview';
  readonly downloadUrl?: Maybe<Scalars['String']['output']>;
  readonly previewUrl?: Maybe<Scalars['String']['output']>;
}

export interface PayrollLineItem {
  readonly __typename?: 'PayrollLineItem';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly groupType: PayrollLineItemGroup;
  readonly hours?: Maybe<Scalars['Float']['output']>;
  readonly humanizedLabel: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly kind: Scalars['String']['output'];
  readonly netAmount: Scalars['Float']['output'];
  readonly order: Scalars['Int']['output'];
  readonly rate?: Maybe<Scalars['Float']['output']>;
  readonly type: Scalars['String']['output'];
}

export const enum PayrollLineItemGroup {
  /** Gross Wage */
  GrossWage = 'gross_wage',
  /** Stipend */
  Stipend = 'stipend'
};

/** Autogenerated return type of PayrollNudge. */
export interface PayrollNudgePayload {
  readonly __typename?: 'PayrollNudgePayload';
  readonly reachedNurses: Scalars['Int']['output'];
}

export interface PayrollOverrides {
  readonly __typename?: 'PayrollOverrides';
  readonly cancelledShiftHours: Scalars['Float']['output'];
  readonly covidLeaveHours?: Maybe<ReadonlyArray<PayrollCovidLeaveHours>>;
  readonly externalNotes?: Maybe<Scalars['String']['output']>;
  readonly guaranteedHoursEligible: Scalars['Boolean']['output'];
  readonly guaranteedShiftCount?: Maybe<Scalars['Int']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly internalNotes?: Maybe<Scalars['String']['output']>;
  readonly perDiemShift?: Maybe<Scalars['Int']['output']>;
  readonly periodEnd: Scalars['ISO8601Date']['output'];
  readonly sickLeaveHours: Scalars['Float']['output'];
}

export interface PayrollPaidLeaveHours {
  readonly __typename?: 'PayrollPaidLeaveHours';
  readonly payrollId: Scalars['String']['output'];
  readonly totalHours: Scalars['Float']['output'];
  readonly weekEndingDate: Scalars['ISO8601Date']['output'];
}

/** The connection type for PayrollPaidLeaveHours. */
export interface PayrollPaidLeaveHoursConnection {
  readonly __typename?: 'PayrollPaidLeaveHoursConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<PayrollPaidLeaveHoursEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<PayrollPaidLeaveHours>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface PayrollPaidLeaveHoursEdge {
  readonly __typename?: 'PayrollPaidLeaveHoursEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<PayrollPaidLeaveHours>;
}

export interface PayrollReview {
  readonly __typename?: 'PayrollReview';
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly reason?: Maybe<Scalars['String']['output']>;
  readonly reviewedAt: Scalars['ISO8601DateTime']['output'];
  readonly reviewer: Scalars['String']['output'];
  readonly status: Scalars['String']['output'];
}

export interface PayrollShiftDetails {
  readonly __typename?: 'PayrollShiftDetails';
  readonly externalNotes?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly internalNotes?: Maybe<Scalars['String']['output']>;
  readonly jobPlacementScheduleUuid: Scalars['String']['output'];
  readonly lunchPenaltyRecommended: Scalars['Boolean']['output'];
  readonly perDiemShift?: Maybe<Scalars['Int']['output']>;
  readonly shifts?: Maybe<ReadonlyArray<Shift>>;
  readonly timecardUrls?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly timezone: Scalars['String']['output'];
}

export interface PayrollSickLeaveHours {
  readonly __typename?: 'PayrollSickLeaveHours';
  readonly hours: Scalars['Float']['output'];
  readonly payrollId: Scalars['String']['output'];
  readonly periodEnd?: Maybe<Scalars['ISO8601Date']['output']>;
}

/** The connection type for PayrollSickLeaveHours. */
export interface PayrollSickLeaveHoursConnection {
  readonly __typename?: 'PayrollSickLeaveHoursConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<PayrollSickLeaveHoursEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<PayrollSickLeaveHours>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface PayrollSickLeaveHoursEdge {
  readonly __typename?: 'PayrollSickLeaveHoursEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<PayrollSickLeaveHours>;
}

export const enum PayrollSortField {
  ContractHours = 'ContractHours',
  Facility = 'Facility',
  GrossPay = 'GrossPay',
  HoursWorked = 'HoursWorked',
  Name = 'Name',
  State = 'State',
  StatusUpdatedAt = 'StatusUpdatedAt'
};

export interface PayrollSortInput {
  readonly direction?: InputMaybe<OrderDirection>;
  readonly field?: InputMaybe<PayrollSortField>;
}

export interface PayrollStats {
  readonly __typename?: 'PayrollStats';
  readonly all: Scalars['Int']['output'];
  readonly approved: Scalars['Int']['output'];
  readonly completed: Scalars['Int']['output'];
  readonly exception: Scalars['Int']['output'];
  readonly pendingExport: Scalars['Int']['output'];
  readonly pendingReview: Scalars['Int']['output'];
  readonly rejected: Scalars['Int']['output'];
  readonly unsubmitted: Scalars['Int']['output'];
}

export interface PayrollTag {
  readonly __typename?: 'PayrollTag';
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
}

export interface PerformNursysLicenseVerificationInput {
  readonly birthday: Scalars['ISO8601Date']['input'];
  readonly expiresOn: Scalars['ISO8601Date']['input'];
  readonly licenseType: LicenseType;
  readonly licensureCompact?: InputMaybe<LicensureCompact>;
  readonly number: Scalars['String']['input'];
  readonly ssnLast4: Scalars['String']['input'];
  readonly stateCode: Scalars['String']['input'];
}

/** Autogenerated return type of PerformNursysLicenseVerification. */
export interface PerformNursysLicenseVerificationPayload {
  readonly __typename?: 'PerformNursysLicenseVerificationPayload';
  readonly license: License;
  readonly nurseProfile: NurseProfile;
}

export interface PermanentAddress {
  readonly __typename?: 'PermanentAddress';
  readonly city?: Maybe<Scalars['String']['output']>;
  readonly country?: Maybe<Scalars['String']['output']>;
  readonly permanentAddress?: Maybe<Scalars['String']['output']>;
  readonly postalCode?: Maybe<Scalars['String']['output']>;
  readonly state?: Maybe<Scalars['String']['output']>;
}

export interface PermanentAddressInput {
  readonly cityPermanent?: InputMaybe<Scalars['String']['input']>;
  readonly countryPermanent?: InputMaybe<CountryPermanentEnum>;
  readonly statePermanent?: InputMaybe<Scalars['String']['input']>;
  readonly streetAddressPermanent?: InputMaybe<Scalars['String']['input']>;
  readonly zipcodePermanent?: InputMaybe<Scalars['String']['input']>;
}

export interface PersonalInfoInput {
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly fullSsn?: InputMaybe<Scalars['String']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly middleName?: InputMaybe<Scalars['String']['input']>;
  readonly preferredName?: InputMaybe<Scalars['String']['input']>;
  readonly preferredPronoun?: InputMaybe<Scalars['String']['input']>;
  readonly ssnLast4?: InputMaybe<Scalars['String']['input']>;
}

export interface PersonalInformation {
  readonly __typename?: 'PersonalInformation';
  readonly dateOfBirth?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly middleName?: Maybe<Scalars['String']['output']>;
}

export interface PopularCityCostOfLiving {
  readonly __typename?: 'PopularCityCostOfLiving';
  readonly avgRent?: Maybe<Scalars['Float']['output']>;
  readonly city: Scalars['String']['output'];
  readonly id: Scalars['String']['output'];
  readonly stateCode: Scalars['String']['output'];
}

export interface PopularCityPay {
  readonly __typename?: 'PopularCityPay';
  readonly city: Scalars['String']['output'];
  readonly id: Scalars['String']['output'];
  readonly staffHourlyIncome?: Maybe<Scalars['Float']['output']>;
  readonly stateCode: Scalars['String']['output'];
  readonly travelWeeklyIncome?: Maybe<Scalars['Float']['output']>;
}

export interface Position {
  readonly __typename?: 'Position';
  readonly activeReferences?: Maybe<ReadonlyArray<Reference>>;
  readonly additionalSkills?: Maybe<Scalars['String']['output']>;
  readonly agency?: Maybe<Agency>;
  /** @deprecated use hospitalBedCount instead */
  readonly bedCount?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use unitBedCount instead */
  readonly bedCountInUnit?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use chargeExperience instead */
  readonly chargeExp?: Maybe<Scalars['Boolean']['output']>;
  readonly chargeExperience?: Maybe<Scalars['Boolean']['output']>;
  readonly classification?: Maybe<EmploymentTypes>;
  readonly clinicalUnit?: Maybe<ClinicalUnit>;
  /** @deprecated use additionalSkills instead */
  readonly descriptions: ReadonlyArray<Scalars['String']['output']>;
  readonly duration?: Maybe<Scalars['String']['output']>;
  /** @deprecated use classification instead */
  readonly employmentType?: Maybe<EmploymentTypes>;
  readonly endAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly facility?: Maybe<Facility>;
  readonly floatFrequency?: Maybe<PositionFloatFrequency>;
  readonly floatUnits?: Maybe<ReadonlyArray<ClinicalUnit>>;
  readonly friendlyEmploymentType?: Maybe<Scalars['String']['output']>;
  /** @deprecated unused field */
  readonly hasOverlap: Scalars['Boolean']['output'];
  readonly hasValidReference: Scalars['Boolean']['output'];
  readonly hospitalBedCount?: Maybe<Scalars['Int']['output']>;
  readonly hoursWorked?: Maybe<Scalars['Int']['output']>;
  readonly hoursWorkedText?: Maybe<Scalars['String']['output']>;
  readonly hoursWorkedTimeframe?: Maybe<HoursWorkedTimeframe>;
  readonly humanReadableLength?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly invalidOverlapByHours?: Maybe<Scalars['Boolean']['output']>;
  readonly invalidOverlapByLocation?: Maybe<Scalars['Boolean']['output']>;
  readonly invalidOverlapByMissingHours: Scalars['Boolean']['output'];
  readonly leadExperience?: Maybe<Scalars['Boolean']['output']>;
  readonly magnet: Scalars['Boolean']['output'];
  readonly nicuLevel?: Maybe<ReadonlyArray<Scalars['Int']['output']>>;
  /** @deprecated use nicuLevel instead */
  readonly nicuTraumaLevel?: Maybe<Scalars['Int']['output']>;
  readonly patientRatio?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use patientRatio instead */
  readonly patientsPerNurse?: Maybe<Scalars['Int']['output']>;
  readonly pediatricTraumaLevel?: Maybe<Scalars['Int']['output']>;
  readonly positionType?: Maybe<PositionTypes>;
  readonly preceptorExperience?: Maybe<Scalars['Boolean']['output']>;
  readonly reference?: Maybe<Reference>;
  readonly role?: Maybe<Role>;
  readonly specialties?: Maybe<ReadonlyArray<ClinicalSpecialty>>;
  readonly startAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly teaching: Scalars['Boolean']['output'];
  readonly technologies?: Maybe<ReadonlyArray<Technology>>;
  readonly title: Scalars['String']['output'];
  readonly trauma?: Maybe<Scalars['Boolean']['output']>;
  readonly traumaLevel?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use clinicalUnit instead */
  readonly unit?: Maybe<Scalars['String']['output']>;
  readonly unitBedCount?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use clinicalUnit instead */
  readonly unitName?: Maybe<Scalars['String']['output']>;
  /** @deprecated use clinicalUnit instead */
  readonly unitObject?: Maybe<ClinicalUnit>;
  /** @deprecated unused field */
  readonly unitOther?: Maybe<Scalars['String']['output']>;
  readonly usableForReferences: Scalars['Boolean']['output'];
  /** @deprecated use id instead */
  readonly uuid: Scalars['String']['output'];
  /** @deprecated unused field */
  readonly validOverlap: Scalars['Boolean']['output'];
  readonly wouldWorkAgain?: Maybe<Scalars['Boolean']['output']>;
}

export const enum PositionFloatFrequency {
  /** Daily */
  Daily = 'daily',
  /** Monthly */
  Monthly = 'monthly',
  /** Never */
  Never = 'never',
  /** Weekly */
  Weekly = 'weekly'
};

export const enum PositionTypes {
  /** Clinical Hospital */
  ClinicalHospital = 'clinical_hospital',
  /** Clinical Non Hospital */
  ClinicalNonHospital = 'clinical_non_hospital',
  /** Non Clinical */
  NonClinical = 'non_clinical'
};

/** Autogenerated return type of ProcessContractBonuses. */
export interface ProcessContractBonusesPayload {
  readonly __typename?: 'ProcessContractBonusesPayload';
  readonly processedBonusIds: ReadonlyArray<Scalars['ID']['output']>;
}

export interface ProfileCompletionMeta {
  readonly __typename?: 'ProfileCompletionMeta';
  readonly completeCount: Scalars['Int']['output'];
  readonly expiredCount: Scalars['Int']['output'];
  readonly expiringCount: Scalars['Int']['output'];
  readonly id: Scalars['ID']['output'];
  readonly incompleteCount: Scalars['Int']['output'];
  readonly pendingCount: Scalars['Int']['output'];
  readonly percentCompleted: Scalars['Int']['output'];
}

export const enum ProfileCompletionStatusEnum {
  /** Complete */
  Complete = 'complete',
  /** Expired */
  Expired = 'expired',
  /** Expiring */
  Expiring = 'expiring',
  /** Incomplete */
  Incomplete = 'incomplete',
  /** Pending */
  Pending = 'pending'
};

export interface ProfileCompletionStep {
  readonly __typename?: 'ProfileCompletionStep';
  readonly estimatedTimeInSeconds?: Maybe<Scalars['Int']['output']>;
  readonly label: Scalars['String']['output'];
  readonly message?: Maybe<Scalars['String']['output']>;
  readonly status: ProfileCompletionStatusEnum;
}

export interface ProfileCompletionSteps {
  readonly __typename?: 'ProfileCompletionSteps';
  readonly backgroundQuestions: ProfileCompletionStep;
  readonly certification: ProfileCompletionStep;
  readonly education: ProfileCompletionStep;
  readonly license: ProfileCompletionStep;
  readonly permanentAddress: ProfileCompletionStep;
  readonly personalInfo: ProfileCompletionStep;
  readonly references: ProfileCompletionStep;
  readonly skillsChecklist: ProfileCompletionStep;
  readonly verifyEmail: ProfileCompletionStep;
  readonly workExperience: ProfileCompletionStep;
  readonly yearsOfExperience: ProfileCompletionStep;
}

export interface ProfileCompletionSummary {
  readonly __typename?: 'ProfileCompletionSummary';
  readonly completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly meta: ProfileMeta;
  readonly steps: ReadonlyArray<ProfileStep>;
}

export interface ProfileMeta {
  readonly __typename?: 'ProfileMeta';
  readonly completeCount: Scalars['Int']['output'];
  readonly expiredCount: Scalars['Int']['output'];
  readonly expiringCount: Scalars['Int']['output'];
  readonly id: Scalars['ID']['output'];
  readonly incompleteCount: Scalars['Int']['output'];
  readonly pendingCount: Scalars['Int']['output'];
  readonly percentCompleted: Scalars['Int']['output'];
}

export const enum ProfileStatusEnum {
  /** Complete */
  Complete = 'complete',
  /** Expired */
  Expired = 'expired',
  /** Expiring */
  Expiring = 'expiring',
  /** Incomplete */
  Incomplete = 'incomplete',
  /** Pending */
  Pending = 'pending'
};

export interface ProfileStep {
  readonly __typename?: 'ProfileStep';
  readonly estimatedTimeInMinutes?: Maybe<Scalars['Int']['output']>;
  readonly hasExpiredItems: Scalars['Boolean']['output'];
  readonly hasExpiringItems: Scalars['Boolean']['output'];
  readonly hasInvalidItems: Scalars['Boolean']['output'];
  readonly key: ProfileStepsEnum;
  readonly messages?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly sectionName: Scalars['String']['output'];
  readonly status: ProfileStatusEnum;
  readonly subtitle?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
}

export const enum ProfileStepsEnum {
  /** Background questions */
  BackgroundQuestions = 'background_questions',
  /** Certification */
  Certification = 'certification',
  /** Education */
  Education = 'education',
  /** License */
  License = 'license',
  /** License and certification */
  LicenseAndCertification = 'license_and_certification',
  /** Permanent address */
  PermanentAddress = 'permanent_address',
  /** Personal info */
  PersonalInfo = 'personal_info',
  /** References */
  References = 'references',
  /** Role and specialty */
  RoleAndSpecialty = 'role_and_specialty',
  /** Skills checklist */
  SkillsChecklist = 'skills_checklist',
  /** Verify email */
  VerifyEmail = 'verify_email',
  /** Work experience */
  WorkExperience = 'work_experience',
  /** Work experience and education */
  WorkExperienceAndEducation = 'work_experience_and_education',
  /** Years of experience */
  YearsOfExperience = 'years_of_experience'
};

export interface Program {
  readonly __typename?: 'Program';
  readonly alliedClientAccountManagerName?: Maybe<Scalars['String']['output']>;
  readonly clientAccountManagerName?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly timekeepingRule?: Maybe<TimekeepingRule>;
}

/** Autogenerated return type of PublishOnboardingList. */
export interface PublishOnboardingListPayload {
  readonly __typename?: 'PublishOnboardingListPayload';
  readonly todoList: TodoList;
}

export interface Query {
  readonly __typename?: 'Query';
  /** Returns the active onboarding lists */
  readonly activeOnboardingLists?: Maybe<ReadonlyArray<TodoList>>;
  readonly adJob?: Maybe<Job>;
  /** List of adjustment payrolls */
  readonly adjustmentPayrolls: ReadonlyArray<Payroll>;
  /** Get list of admin users */
  readonly adminUsers: ReadonlyArray<AdminUser>;
  readonly allCertsByGoal?: Maybe<ReadonlyArray<CeuCertificate>>;
  readonly apartmentConnection: ApartmentConnection;
  /** Returns the current missing step for the approval flow (job seeker steps) */
  readonly approvalFlowMissingStep: ApprovalFlowMissingStep;
  /** Returns the job placements schedules for archived and past job placements */
  readonly archivedJobPlacementsSchedules?: Maybe<ReadonlyArray<JobPlacementSchedule>>;
  /** Returns data about a specific article */
  readonly article: Article;
  /** Returns a list of all articles */
  readonly articles: ReadonlyArray<Article>;
  readonly assessmentList: ReadonlyArray<Assessment>;
  /** Retrieve single AssessmentRequest by NurseProfile and Assessment IDs */
  readonly assessmentRequestForNurseProfileAndAssessment?: Maybe<AssessmentRequest>;
  /**
   * AutoApply general information
   * @deprecated AutoApply is disabled
   */
  readonly autoApplyInfo: AutoApplyInfo;
  /**
   * AutoApply Preferences or default value based on the matches prefrences
   * @deprecated AutoApply is disabled
   */
  readonly autoApplyPreferences: AutoApplyPreferences;
  readonly availableHealthDocs?: Maybe<ReadonlyArray<Maybe<HealthDoc>>>;
  /** Retrieve a list of all roles */
  readonly availableRoles?: Maybe<ReadonlyArray<Role>>;
  /** Latest VMS lookup table uploaded */
  readonly backofficeLatestVmsLookupTable?: Maybe<File>;
  /** Status count for nurse matchings */
  readonly backofficeNurseMatchingStats: NurseMatchingStats;
  /** List of nurse matchings */
  readonly backofficeNurseMatchings: NurseMatchingsPaginatedList;
  /** List of VMS reverse invoice items */
  readonly backofficeVmsReverseInvoiceItems: VmsReverseInvoiceItemsPaginatedList;
  /** Status count for VMS reverse invoice items */
  readonly backofficeVmsReverseInvoiceItemsStats: VmsReverseInvoiceItemsStats;
  readonly badgesItemsCount: BadgesItemsCount;
  readonly billingTags: ReadonlyArray<BillingTag>;
  readonly boardOfNursingUrls: ReadonlyArray<BoardOfNursingUrl>;
  /**
   * Returns bucket configuration
   * @deprecated Deprecated Bucket Dashboard page on mobile version: 3.25.4
   */
  readonly bucketConfiguration?: Maybe<BucketConfiguration>;
  /**
   * Returns jobs for specific bucket
   * @deprecated Deprecated Bucket Dashboard page on mobile version: 3.25.4
   */
  readonly bucketJobs: JobsCollection;
  /** Returns jobs for specific bucket key */
  readonly bucketJobsByKey: JobsCollection;
  /**
   * Summarized information about common segmentations for opportunities
   * @deprecated Deprecated Bucket Dashboard page on mobile version: 3.25.4
   */
  readonly bucketsDashboard: BucketsDashboard;
  /** Suggest businesses by complete_title ( name + city + state ) */
  readonly businessSuggestions: ReadonlyArray<Facility>;
  readonly certificationList: ReadonlyArray<Certification>;
  /** Accesses a single Ceu Certificate by ID */
  readonly ceuCertificate?: Maybe<CeuCertificate>;
  /** Returns certs based on filter requirements */
  readonly ceuCertsByTimeAndGoalType?: Maybe<CeuCertificatesConnection>;
  /** Return the state requirements for CEUs */
  readonly ceuStateRequirements: ReadonlyArray<CeuStateRequirement>;
  /** Returns topics that users must choose from when contacting support via chat */
  readonly chatHelpTopicsByStatus?: Maybe<Scalars['JSON']['output']>;
  /** Get all clinical specialties */
  readonly clinicalSpecialties: ReadonlyArray<ClinicalSpecialty>;
  readonly clinicalUnit?: Maybe<ClinicalUnit>;
  readonly clinicalUnits: ReadonlyArray<ClinicalUnit>;
  /** Returns list of clinical units */
  readonly clinicalUnitsConnection: ClinicalUnitConnection;
  /** Returns data about a clinicians credentials */
  readonly clinicianCredentialsOverview?: Maybe<ClinicianCredentialsOverview>;
  readonly clinicianIntent?: Maybe<ClinicianIntent>;
  /** Returns data about a specific collection */
  readonly collection: Collection;
  /** Returns a list of all collections */
  readonly collections: ReadonlyArray<Collection>;
  /** Returns Compliance List by given id */
  readonly complianceList: ComplianceList;
  /** Returns the list of Compliance Lists */
  readonly complianceListCollection: ComplianceListCollection;
  /** Returns Compliance List Item by given id */
  readonly complianceListItem: ComplianceListItem;
  /** Returns count of compliance lists in different statuses */
  readonly complianceListStats: ComplianceListStats;
  /** Get list of Compliance Owner users */
  readonly complianceOwnerUsers: ReadonlyArray<AdminUser>;
  /** A contract details */
  readonly contract?: Maybe<Contract>;
  /** Returns a list of contract bonuses */
  readonly contractBonusConnection: ContractBonusConnection;
  /** Returns the distribution of contract bonuses status */
  readonly contractBonusStatusSummary: ContractBonusStatusSummary;
  /** A list of contracts by nurse profile */
  readonly contractByNurseProfile: ContractByNurseProfile;
  /** Review history of payrolls of a contract */
  readonly contractPayrollReviewHistory: ReadonlyArray<ContractPayrollReviewHistory>;
  /** List of permissions for Contracts */
  readonly contractsUserPermissions: ContractsUserPermissions;
  /** Returns the job placements schedules for current job placements */
  readonly currentJobPlacementsSchedules?: Maybe<ReadonlyArray<JobPlacementSchedule>>;
  /** Returns whether or not the user is subscribed to daily match push notifications */
  readonly dailyMatchNotificationStatus: Scalars['Boolean']['output'];
  readonly defaultCovidVaccineHealthDoc?: Maybe<HealthDoc>;
  /** Accesses a single Document by ID */
  readonly document?: Maybe<Document>;
  readonly documentTemplates: ReadonlyArray<DocumentTemplate>;
  /** It returns a single education item */
  readonly education?: Maybe<Education>;
  /** Returns the user nurse profile educations */
  readonly educations: ReadonlyArray<Education>;
  /** Accesses a single Employment by ID */
  readonly employment: Employment;
  /** Accesses a single EmploymentPosition by ID */
  readonly employmentPosition: Position;
  /** Employment position verifications and gap information */
  readonly employmentPositionVerificationData?: Maybe<ReadonlyArray<EmploymentPositionVerificationData>>;
  /** Suggest VmsReverseInvoiceItemExceptionType by text */
  readonly exceptionReasonSuggestions: ReadonlyArray<GenericEnumSuggestion>;
  /** Lists Expenses */
  readonly expenseConnection: ExpenseConnection;
  /** Returns count of expense lists in different stages */
  readonly expenseStats: ExpenseStats;
  readonly experienceGap: Gap;
  readonly facilitiesPaginated: FacilitiesConnection;
  /** A business/facility */
  readonly facility?: Maybe<Facility>;
  /** List of all known facilities */
  readonly facilityList?: Maybe<ReadonlyArray<Maybe<Facility>>>;
  /** Suggest facilities by complete_title ( name + city + state ) */
  readonly facilitySuggestions?: Maybe<ReadonlyArray<Facility>>;
  /** List of facility survey questions */
  readonly facilitySurveyQuestions?: Maybe<ReadonlyArray<FacilitySurveyQuestion>>;
  /** Feature flags we have available for clients, it returns a shallow hash, and it's up to the clients to decide safe & sane defaults and types for the flags */
  readonly featureFlags: Scalars['JSON']['output'];
  readonly feedbackResultsUnitOptions?: Maybe<ReadonlyArray<ClinicalUnit>>;
  readonly fetchJobWithEsMatch?: Maybe<Job>;
  /** Returns a reference for a user who is performing the reference */
  readonly fetchReference?: Maybe<Reference>;
  readonly fluVaccineHealthDoc?: Maybe<HealthDoc>;
  /**
   * Matches for Fresh Matches bucket
   * @deprecated Deprecated fresh matches page
   */
  readonly freshMatches: JobsCollection;
  /** Suggest Agencies for autocompletion */
  readonly getAgencySuggestions: ReadonlyArray<Agency>;
  /** Suggest Assessments, optionally filtering by issuing_body */
  readonly getAssessmentSuggestions?: Maybe<ReadonlyArray<Assessment>>;
  /** Suggest certifications */
  readonly getCertificationSuggestions?: Maybe<ReadonlyArray<Certification>>;
  /** Suggest clinical positions */
  readonly getClinicalPositionSuggestions?: Maybe<ReadonlyArray<ClinicalPosition>>;
  /** Get all clinical positions */
  readonly getClinicalPositions?: Maybe<ReadonlyArray<ClinicalPosition>>;
  /** Suggest clinical specialties */
  readonly getClinicalSpecialtySuggestions: ReadonlyArray<ClinicalSpecialty>;
  /** Suggest clinical units */
  readonly getClinicalUnitSuggestions: ReadonlyArray<ClinicalUnit>;
  /** Suggest colleges */
  readonly getCollegeSuggestions?: Maybe<ReadonlyArray<College>>;
  /**
   * Suggest facilities by complete_title ( name + city + state )
   * @deprecated use `facilitySuggestions` instead
   */
  readonly getFacilitySuggestions?: Maybe<ReadonlyArray<Maybe<Facility>>>;
  readonly getOnboardingListDueDates?: Maybe<ReadonlyArray<TodoListDueDate>>;
  readonly getOnboardingListNeedsAttention?: Maybe<ReadonlyArray<TodoListItem>>;
  readonly getOnboardingListOwnerInfo?: Maybe<TodoListOwner>;
  /** Suggest Assessments which can be requested to complete */
  readonly getRequestableAssessmentSuggestions?: Maybe<ReadonlyArray<Assessment>>;
  /** Get todo list item */
  readonly getTodoListItem: TodoListItem;
  /** @deprecated AutoApply is disabled */
  readonly grossPayWeeklyInformation?: Maybe<GrossPayWeeklyInformation>;
  readonly helpArticles?: Maybe<ReadonlyArray<HelpArticle>>;
  readonly homeClinicianJobSummary?: Maybe<HomeClinicianJobSummary>;
  readonly homeResourceLinks: ReadonlyArray<HomeResourceLink>;
  /** Figures out in which step of the flywheel a clinician is, and returns the home state for that. */
  readonly homeStepMapper: HomeStepMapper;
  readonly homeTotalMatches: HomeTotalMatches;
  /** Fetch I9 status */
  readonly i9Status?: Maybe<I9Status>;
  /** Returns the increased pay banner for a given user */
  readonly increasedPayBanner?: Maybe<IncreasedPayBanner>;
  /** Details Invoice Balance with Invoice Balance Entries */
  readonly invoiceBalance: InvoiceBalance;
  /** Returns the list of Invoice items for a given pay period */
  readonly invoiceCollection: InvoiceCollection;
  /** Returns an Invoice item by id */
  readonly invoiceItem: Invoice;
  /** Returns ReconReport details */
  readonly invoiceReconReportDetails: InvoiceReconReportDetails;
  /** Returns shift details */
  readonly invoiceShiftDetails: InvoiceShiftDetails;
  /** Returns count of Invoices in different statuses */
  readonly invoiceStats: InvoiceStats;
  /** List of Invoices and their reconciliation status */
  readonly invoicesReconcile: InvoicesReconcilePaginatedList;
  /** Suggest item by name */
  readonly itemSuggestions: ReadonlyArray<GenericSuggestion>;
  readonly job?: Maybe<Job>;
  /** Returns a list of pending job alerts. */
  readonly jobAlertsPendingView: ReadonlyArray<JobAlert>;
  /** Returns the job application by id */
  readonly jobApplication: JobApplication;
  /** Returns the job applications instructions by state */
  readonly jobApplicationStateInstructions: ReadonlyArray<JobApplicationStateInstruction>;
  /** A job offer */
  readonly jobOffer?: Maybe<JobOffer>;
  readonly jobPaymentDetails?: Maybe<JobPaymentDetails>;
  /** Return job placement drafts */
  readonly jobPlacementDraftsConnection: JobPlacementConnection;
  /** Returns a Job Placement Schedule */
  readonly jobPlacementSchedule: JobPlacementSchedule;
  readonly jobPlacementSchedules?: Maybe<ReadonlyArray<Maybe<JobPlacementSchedule>>>;
  /** Return job placements */
  readonly jobPlacements?: Maybe<ReadonlyArray<Maybe<JobPlacement>>>;
  readonly jobsCollection: JobsCollection;
  /** Jobs for multiple locations */
  readonly jobsCollectionByLocations: ReadonlyArray<JobsCollectionByLocation>;
  /** @deprecated use jobsCollectionExactV2 */
  readonly jobsCollectionExact: JobsCollection;
  readonly jobsCollectionExactV2: JobsCollection;
  /** @deprecated use jobsCollectionExactV2 */
  readonly jobsCollectionWeighted: JobsCollection;
  /** List of ledger links */
  readonly ledgerLinks: ReadonlyArray<LedgerLink>;
  /** Accesses a single License by ID */
  readonly license: License;
  /**
   * Accesses a single License Verification by ID
   * @deprecated Deprecated in favor of nurse_license_verification
   */
  readonly licenseVerification?: Maybe<LicenseVerification>;
  readonly localPaymentDetails?: Maybe<JobPaymentDetails>;
  readonly location?: Maybe<Location>;
  readonly matchSpecialties?: Maybe<ReadonlyArray<Maybe<ClinicalSpecialty>>>;
  /** Jobs matching a given job application */
  readonly matchingJobsForApplication?: Maybe<ReadonlyArray<Job>>;
  /** Returns timesheets without payroll */
  readonly missingPayrollConnection: TimeSheetConnection;
  /** Returns count of timesheets without payroll */
  readonly missingPayrollStats: MissingPayrollStats;
  /** Returns the list of missing timecards for a given pay period */
  readonly missingTimecardConnection: MissingTimecardConnection;
  /** Returns count of expected payroll count */
  readonly missingTimecardStats: MissingTimecardStats;
  /** Suggest msp by name */
  readonly mspSuggestions: ReadonlyArray<GenericSuggestion>;
  readonly numExpiringCredentials?: Maybe<Scalars['Int']['output']>;
  readonly numInterestedMatches?: Maybe<Scalars['Int']['output']>;
  readonly numInterviewingMatches?: Maybe<Scalars['Int']['output']>;
  readonly nurseActivelyInterviewingJobs: ReadonlyArray<Job>;
  /** Access a single Nurse Assessment by ID */
  readonly nurseAssessment?: Maybe<NurseAssessment>;
  /** Access a single Nurse Certification by ID */
  readonly nurseCertification?: Maybe<NurseCertification>;
  /** Access a single Nurse Health Document by ID */
  readonly nurseHealthDoc?: Maybe<NurseHealthDoc>;
  /** Accesses a single License Verification by ID */
  readonly nurseLicenseVerification?: Maybe<NurseLicenseVerification>;
  readonly nursePreferences?: Maybe<NursePreferences>;
  /** Nurse Profile */
  readonly nurseProfile?: Maybe<NurseProfile>;
  /** Suggest nurse profiles which can be requested to complete */
  readonly nurseProfileSuggestions: ReadonlyArray<NurseProfile>;
  /** Returns data needed for rendering TodoListView frontend component */
  readonly nurseProfileTodoLists?: Maybe<ReadonlyArray<Maybe<TodoList>>>;
  readonly onboardingItemSampleImage?: Maybe<Scalars['String']['output']>;
  /** Returns the list of Todo Lists */
  readonly onboardingListConnection: OnboardingListConnection;
  /** Returns count of onboarding lists in different statuses */
  readonly onboardingListStats: OnboardingListStats;
  /** Fetch parsed education and stored education */
  readonly parsedEducation: EducationSuggestion;
  /** Fetch educations and suggestions */
  readonly parsedEducations: ReadonlyArray<EducationSuggestion>;
  /** Fetch parsed permanent address */
  readonly parsedPermanentAddress?: Maybe<PermanentAddress>;
  /** Fetch parsed personal information */
  readonly parsedPersonalInformation?: Maybe<PersonalInformation>;
  /** Fetch parsed reference */
  readonly parsedReference: ReferenceSuggestion;
  /** Fetch parsed references */
  readonly parsedReferences: ReadonlyArray<ReferenceSuggestion>;
  /** Fetch work experience suggestion */
  readonly parsedWorkExperience: WorkExperienceSuggestion;
  /** Fetch parsed work experience and profile work experience */
  readonly parsedWorkExperiences?: Maybe<ReadonlyArray<WorkExperienceSuggestion>>;
  /** Returns all pay hours cancellations for a given Job Placement */
  readonly payHoursCancellations: PayHoursCancellationHistoryConnection;
  /** Returns any running totals of accrual data for a payroll item */
  readonly payrollAccruals: PayrollAccruals;
  /** Returns a Payroll Corrections amendment contracts */
  readonly payrollAmendmentContracts: ReadonlyArray<Contract>;
  /** Returns the list of Payroll items for a given pay period */
  readonly payrollConnection: PayrollConnection;
  /** Returns a Payroll Correction item */
  readonly payrollCorrection: Payroll;
  /** Returns payroll rates associated with this payroll item */
  readonly payrollCorrectionRates: PayRateConfig;
  /** Returns all paid covid hours for a given nurse and state */
  readonly payrollCovidLeaveHoursHistory?: Maybe<PayrollCovidLeaveHoursConnection>;
  /** Returns a preview of the payroll image */
  readonly payrollImagePreview: PayrollImagePreview;
  /** Returns a Payroll item by id */
  readonly payrollItem: Payroll;
  /** Returns a Payroll item by candidate id */
  readonly payrollItemForCandidate?: Maybe<Payroll>;
  /** Returns all the payroll items for the logged in user's current contract */
  readonly payrollItems?: Maybe<ReadonlyArray<Payroll>>;
  /** Returns payroll overrides associated with this payroll item */
  readonly payrollOverrides: PayrollOverrides;
  /** Returns all paid leave hours for a given clinician */
  readonly payrollPaidLeaveHoursHistory?: Maybe<PayrollPaidLeaveHoursConnection>;
  /** Returns payroll rates associated with this payroll item */
  readonly payrollRates: PayRateConfig;
  /** Returns shift details for a payroll item */
  readonly payrollShiftDetails: PayrollShiftDetails;
  /** Returns all paid sick hours for a given nurse */
  readonly payrollSickLeaveHoursHistory?: Maybe<PayrollSickLeaveHoursConnection>;
  /** Returns count of payroll in different statuses */
  readonly payrollStats: PayrollStats;
  /** List of payroll tags */
  readonly payrollTags: ReadonlyArray<PayrollTag>;
  /** Returns a collection of cities with income data */
  readonly popularCitiesCostOfLiving?: Maybe<ReadonlyArray<PopularCityCostOfLiving>>;
  /** Returns a collection of cities with income data */
  readonly popularCitiesPay?: Maybe<ReadonlyArray<PopularCityPay>>;
  /** Clinician profile summary data */
  readonly profileCompletionSummary: ProfileCompletionSummary;
  /** Suggest program based on search keywords */
  readonly programSuggestions: ReadonlyArray<Program>;
  readonly proofOfIdentity?: Maybe<Identification>;
  /** Describes the recent references timeframe rule */
  readonly recentReferencesTimeframeRule: GapRule;
  /** It returns a single reference item */
  readonly reference?: Maybe<Reference>;
  readonly relatedJobsConnection: JobConnection;
  /** Returns Request Review copies */
  readonly requestReviewFormCopy: RequestReviewForm;
  /** Get single residency program by ID */
  readonly residencyProgram: ResidencyProgram;
  /** Returns list of residency programs */
  readonly residencyProgramsConnection: ResidencyProgramConnection;
  /** Retrieve a role by key */
  readonly role?: Maybe<Role>;
  /** Retrieve a list of roles by type */
  readonly roles: ReadonlyArray<Role>;
  /** Returns text from the invite widget in Saasquatch */
  readonly saasquatchInvitePageWidget: SaasquatchWidgetContent;
  /** Returns text from the referral widget in Saasquatch */
  readonly saasquatchMainPageWidget?: Maybe<SaasquatchWidgetContent>;
  /** Returns suggestions for affiliations */
  readonly searchAffiliations: ReadonlyArray<Affiliation>;
  readonly searchClinicalSpecialtiesConnection: ClinicalSpecialtyConnection;
  /** Returns data about a specific section */
  readonly section: Section;
  /** Returns a list of all sections */
  readonly sections: ReadonlyArray<Section>;
  readonly staticNurseConfigurations: StaticNurseConfigurations;
  /** returns the count of unread sunshine messages for a given user */
  readonly sunshineUnreadCount: Scalars['Int']['output'];
  readonly surveyForUser?: Maybe<FacilitySurveyResponse>;
  /** System messages that should be displayed on web */
  readonly systemMessages?: Maybe<ReadonlyArray<SystemMessage>>;
  /** Suggest nurse profiles that have valid contracts */
  readonly techelonNurseProfileSuggestions: ReadonlyArray<NurseProfile>;
  /** List of permissions for Techelon */
  readonly techelonUserPermissions: TechelonUserPermissions;
  readonly technologies: ReadonlyArray<Technology>;
  readonly technologiesForPosition?: Maybe<ReadonlyArray<Maybe<Technology>>>;
  readonly technologySuggestions?: Maybe<ReadonlyArray<Technology>>;
  readonly timeEntriesByDay?: Maybe<ReadonlyArray<Maybe<TimeEntryDay>>>;
  /** Retrieve a list of time entry hour types */
  readonly timeEntryHourTypeList: ReadonlyArray<TimeEntryHour>;
  readonly timeZones: ReadonlyArray<Option>;
  readonly timecardImageNotAttachedReasons: ReadonlyArray<Scalars['String']['output']>;
  /** Retrieve single Todo::TodoList by ID */
  readonly todoList: TodoList;
  /** Get single Todo::TodoListItem by ID */
  readonly todoListItem?: Maybe<TodoListItem>;
  /** Retrieve a list of Clinical Specialties ordered by usage score */
  readonly topClinicalSpecialties: ReadonlyArray<ClinicalSpecialty>;
  /** Returns the list of unsubmitted Payroll items for a given pay period */
  readonly unsubmittedPayroll: UnsubmittedPayrollConnection;
  /** Returns the upcoming job placement */
  readonly upcomingJobPlacement?: Maybe<JobPlacement>;
  /** Fetch uploaded resume metadata */
  readonly uploadedResume?: Maybe<UploadedResume>;
  readonly usStateLocations: ReadonlyArray<Location>;
  /**
   * Current User
   * @deprecated use current_user for current_user as this is the standard in GraphQL
   */
  readonly user?: Maybe<User>;
  /** Returns specific user by email */
  readonly userByEmail: Scalars['Boolean']['output'];
  /** feature gates drawn from user and global feature gates */
  readonly userFeatureGates?: Maybe<UserFeatureGate>;
  /** Retrieves an external identifier */
  readonly vendorIntegrationExternalIdentifier?: Maybe<ExternalIdentifier>;
  /** Current User */
  readonly viewer?: Maybe<Viewer>;
  /** Suggest vms */
  readonly vmsSuggestions: ReadonlyArray<GenericSuggestion>;
  /** Describes work experience gap rule */
  readonly workExperienceGapRule: GapRule;
}


export interface QueryActiveOnboardingListsArgs {
  nurseProfileId?: InputMaybe<Scalars['ID']['input']>;
}


export interface QueryAdJobArgs {
  id: Scalars['ID']['input'];
}


export interface QueryAdjustmentPayrollsArgs {
  correctionId: Scalars['ID']['input'];
}


export interface QueryAllCertsByGoalArgs {
  goalId: Scalars['ID']['input'];
}


export interface QueryApartmentConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface QueryArchivedJobPlacementsSchedulesArgs {
  nurseProfileId: Scalars['ID']['input'];
}


export interface QueryArticleArgs {
  id: Scalars['ID']['input'];
}


export interface QueryArticlesArgs {
  parentId: Scalars['Int']['input'];
  parentType: Scalars['String']['input'];
}


export interface QueryAssessmentRequestForNurseProfileAndAssessmentArgs {
  assessmentId: Scalars['ID']['input'];
  nurseProfileId: Scalars['ID']['input'];
}


export interface QueryAutoApplyInfoArgs {
  nurseProfileId?: InputMaybe<Scalars['ID']['input']>;
}


export interface QueryAutoApplyPreferencesArgs {
  nurseProfileId: Scalars['ID']['input'];
}


export interface QueryBackofficeNurseMatchingStatsArgs {
  mspId?: InputMaybe<Scalars['String']['input']>;
  nurseName?: InputMaybe<Scalars['String']['input']>;
  vmsIdentifier?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryBackofficeNurseMatchingsArgs {
  matched?: InputMaybe<Scalars['Boolean']['input']>;
  mspId?: InputMaybe<Scalars['String']['input']>;
  nurseName?: InputMaybe<Scalars['String']['input']>;
  pageOffset: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  vmsIdentifier?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryBackofficeVmsReverseInvoiceItemsArgs {
  amountFilter?: InputMaybe<Scalars['String']['input']>;
  contractId?: InputMaybe<Scalars['String']['input']>;
  exceptionReason?: InputMaybe<Scalars['String']['input']>;
  facilityName?: InputMaybe<Scalars['String']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  item?: InputMaybe<Scalars['String']['input']>;
  mspId?: InputMaybe<Scalars['String']['input']>;
  nurseName?: InputMaybe<Scalars['String']['input']>;
  nurseNameStrict?: InputMaybe<Scalars['Boolean']['input']>;
  pageOffset?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  snapshotEndDate?: InputMaybe<Scalars['String']['input']>;
  snapshotFilter?: InputMaybe<Scalars['String']['input']>;
  snapshotStartDate?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vmsId?: InputMaybe<Scalars['String']['input']>;
  vmsInvoiceDateEndDate?: InputMaybe<Scalars['String']['input']>;
  vmsInvoiceDateStartDate?: InputMaybe<Scalars['String']['input']>;
  vmsInvoiceId?: InputMaybe<Scalars['String']['input']>;
  vmsReverseInvoiceId?: InputMaybe<Scalars['String']['input']>;
  vmsReverseInvoiceItemIds?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  weekEnding?: InputMaybe<Scalars['String']['input']>;
  weekEndingEndDate?: InputMaybe<Scalars['String']['input']>;
  weekEndingStartDate?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryBackofficeVmsReverseInvoiceItemsStatsArgs {
  amountFilter?: InputMaybe<Scalars['String']['input']>;
  exceptionReason?: InputMaybe<Scalars['String']['input']>;
  facilityName?: InputMaybe<Scalars['String']['input']>;
  item?: InputMaybe<Scalars['String']['input']>;
  mspId?: InputMaybe<Scalars['String']['input']>;
  nurseName?: InputMaybe<Scalars['String']['input']>;
  snapshotEndDate?: InputMaybe<Scalars['String']['input']>;
  snapshotFilter?: InputMaybe<Scalars['String']['input']>;
  snapshotStartDate?: InputMaybe<Scalars['String']['input']>;
  vmsId?: InputMaybe<Scalars['String']['input']>;
  vmsInvoiceDateEndDate?: InputMaybe<Scalars['String']['input']>;
  vmsInvoiceDateStartDate?: InputMaybe<Scalars['String']['input']>;
  vmsInvoiceId?: InputMaybe<Scalars['String']['input']>;
  weekEndingEndDate?: InputMaybe<Scalars['String']['input']>;
  weekEndingStartDate?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryBucketConfigurationArgs {
  bucketKey?: InputMaybe<Scalars['String']['input']>;
  bucketUuid?: InputMaybe<Scalars['ID']['input']>;
}


export interface QueryBucketJobsArgs {
  bucketId: Scalars['ID']['input'];
  excludeFavoritedJobs?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<JobsCollectionFiltersInput>;
  nurseProfileId?: InputMaybe<Scalars['ID']['input']>;
  paginate?: InputMaybe<OffsetPaginationInput>;
  sortBy?: InputMaybe<JobsCollectionSortInput>;
}


export interface QueryBucketJobsByKeyArgs {
  bucketKey: Scalars['String']['input'];
  excludeFavoritedJobs?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<JobsCollectionFiltersInput>;
  nurseProfileId?: InputMaybe<Scalars['ID']['input']>;
  paginate?: InputMaybe<OffsetPaginationInput>;
  sortBy?: InputMaybe<JobsCollectionSortInput>;
}


export interface QueryBucketsDashboardArgs {
  excludeFavoritedJobs?: InputMaybe<Scalars['Boolean']['input']>;
  nurseProfileId?: InputMaybe<Scalars['ID']['input']>;
  visibility?: InputMaybe<BucketVisibilityEnum>;
}


export interface QueryBusinessSuggestionsArgs {
  businessTypes?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  query: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
}


export interface QueryCeuCertificateArgs {
  id: Scalars['ID']['input'];
}


export interface QueryCeuCertsByTimeAndGoalTypeArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goalType?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  timePeriod?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryClinicalUnitArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryClinicalUnitsArgs {
  hasActiveJobs?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<ClinicalUnitsOrderBy>;
  role: JobRole;
}


export interface QueryClinicalUnitsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  specialtyId?: InputMaybe<Scalars['ID']['input']>;
}


export interface QueryCollectionArgs {
  id: Scalars['ID']['input'];
}


export interface QueryCollectionsArgs {
  isDuckling?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface QueryComplianceListArgs {
  id: Scalars['String']['input'];
}


export interface QueryComplianceListCollectionArgs {
  filters?: InputMaybe<ComplianceListFiltersInput>;
  paginate?: InputMaybe<OffsetPaginationInput>;
  sortBy?: InputMaybe<ComplianceListSortInput>;
}


export interface QueryComplianceListItemArgs {
  id: Scalars['ID']['input'];
}


export interface QueryComplianceListStatsArgs {
  filters?: InputMaybe<ComplianceListFiltersInput>;
}


export interface QueryContractArgs {
  id: Scalars['ID']['input'];
}


export interface QueryContractBonusConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clinicianId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<ContractBonusSortInput>;
  status?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryContractBonusStatusSummaryArgs {
  clinicianId?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryContractByNurseProfileArgs {
  nurseProfileId: Scalars['ID']['input'];
  vmsReverseInvoiceItemId: Scalars['ID']['input'];
}


export interface QueryContractPayrollReviewHistoryArgs {
  contractId: Scalars['ID']['input'];
}


export interface QueryCurrentJobPlacementsSchedulesArgs {
  nurseProfileId: Scalars['ID']['input'];
}


export interface QueryDocumentArgs {
  id: Scalars['ID']['input'];
}


export interface QueryDocumentTemplatesArgs {
  categories?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}


export interface QueryEducationArgs {
  id: Scalars['ID']['input'];
}


export interface QueryEmploymentArgs {
  id: Scalars['ID']['input'];
}


export interface QueryEmploymentPositionArgs {
  id: Scalars['ID']['input'];
}


export interface QueryEmploymentPositionVerificationDataArgs {
  todoListItemId: Scalars['ID']['input'];
}


export interface QueryExceptionReasonSuggestionsArgs {
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface QueryExpenseConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  candidateId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryExpenseStatsArgs {
  candidateId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryExperienceGapArgs {
  id: Scalars['ID']['input'];
}


export interface QueryFacilitiesPaginatedArgs {
  accreditation?: InputMaybe<AccreditationsEnum>;
  accreditingBodies?: InputMaybe<ReadonlyArray<AccreditingBodiesEnum>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hospitalType?: InputMaybe<HospitalTypesEnum>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationString?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryFacilityArgs {
  slug: Scalars['String']['input'];
}


export interface QueryFacilitySuggestionsArgs {
  query: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
}


export interface QueryFeedbackResultsUnitOptionsArgs {
  facilityId: Scalars['ID']['input'];
}


export interface QueryFetchJobWithEsMatchArgs {
  bucket?: InputMaybe<Scalars['ID']['input']>;
  is_admin?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
}


export interface QueryFetchReferenceArgs {
  response_token?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryGetAgencySuggestionsArgs {
  search_string?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryGetAssessmentSuggestionsArgs {
  issuing_body?: InputMaybe<Scalars['String']['input']>;
  search_string?: InputMaybe<Scalars['String']['input']>;
  skills_checklists_only?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface QueryGetCertificationSuggestionsArgs {
  search_string?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryGetClinicalPositionSuggestionsArgs {
  search_string?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryGetClinicalSpecialtySuggestionsArgs {
  search_string?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryGetClinicalUnitSuggestionsArgs {
  clinical_specialty_slugs?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  search_string?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryGetCollegeSuggestionsArgs {
  search_string?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryGetFacilitySuggestionsArgs {
  businessType?: InputMaybe<Scalars['String']['input']>;
  search_string?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
}


export interface QueryGetOnboardingListDueDatesArgs {
  id: Scalars['ID']['input'];
}


export interface QueryGetOnboardingListNeedsAttentionArgs {
  id: Scalars['ID']['input'];
}


export interface QueryGetOnboardingListOwnerInfoArgs {
  todoListId: Scalars['String']['input'];
}


export interface QueryGetRequestableAssessmentSuggestionsArgs {
  search_string?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryGetTodoListItemArgs {
  id: Scalars['ID']['input'];
}


export interface QueryGrossPayWeeklyInformationArgs {
  activeJobsFromDays?: InputMaybe<Scalars['Int']['input']>;
  interval?: InputMaybe<Scalars['Int']['input']>;
  locationOptions?: InputMaybe<ReadonlyArray<BroadPrefLocations>>;
  locations?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  paymentMaximum?: InputMaybe<Scalars['Int']['input']>;
  paymentMinimum?: InputMaybe<Scalars['Int']['input']>;
  specialties?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}


export interface QueryI9StatusArgs {
  documentId: Scalars['ID']['input'];
}


export interface QueryIncreasedPayBannerArgs {
  sourcePage: BannerSourcePageEnum;
}


export interface QueryInvoiceBalanceArgs {
  entryType: ReadonlyArray<Scalars['String']['input']>;
  invoiceId: Scalars['ID']['input'];
}


export interface QueryInvoiceCollectionArgs {
  filters?: InputMaybe<InvoiceFiltersInput>;
  paginate?: InputMaybe<OffsetPaginationInput>;
  sortBy?: InputMaybe<InvoiceSortInput>;
}


export interface QueryInvoiceItemArgs {
  invoiceId: Scalars['ID']['input'];
}


export interface QueryInvoiceReconReportDetailsArgs {
  invoiceId: Scalars['String']['input'];
}


export interface QueryInvoiceShiftDetailsArgs {
  invoiceId: Scalars['String']['input'];
}


export interface QueryInvoiceStatsArgs {
  filters?: InputMaybe<InvoiceFiltersInput>;
}


export interface QueryInvoicesReconcileArgs {
  agingEnd?: InputMaybe<Scalars['Int']['input']>;
  agingStart?: InputMaybe<Scalars['Int']['input']>;
  currentTab?: InputMaybe<Scalars['String']['input']>;
  differenceThresholdEnd?: InputMaybe<Scalars['Int']['input']>;
  differenceThresholdStart?: InputMaybe<Scalars['Int']['input']>;
  mspId?: InputMaybe<Scalars['String']['input']>;
  nurseId?: InputMaybe<Scalars['String']['input']>;
  nurseName?: InputMaybe<Scalars['String']['input']>;
  pageOffset?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  snapshotEndDate?: InputMaybe<Scalars['String']['input']>;
  snapshotFilter?: InputMaybe<Scalars['String']['input']>;
  snapshotStartDate?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InvoiceStatus>>;
  vmsId?: InputMaybe<Scalars['String']['input']>;
  weekEndingEndDate?: InputMaybe<Scalars['String']['input']>;
  weekEndingStartDate?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryItemSuggestionsArgs {
  searchQuery: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
}


export interface QueryJobArgs {
  id: Scalars['ID']['input'];
}


export interface QueryJobApplicationArgs {
  id: Scalars['String']['input'];
}


export interface QueryJobOfferArgs {
  id: Scalars['ID']['input'];
}


export interface QueryJobPaymentDetailsArgs {
  jobId: Scalars['ID']['input'];
}


export interface QueryJobPlacementDraftsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  candidateId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  facility?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderDirection?: InputMaybe<OrderDirection>;
  orderField?: InputMaybe<TodoListOrderField>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  startDateFrom?: InputMaybe<Scalars['String']['input']>;
  startDateTo?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryJobPlacementScheduleArgs {
  id: Scalars['ID']['input'];
}


export interface QueryJobPlacementsArgs {
  state?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryJobsCollectionArgs {
  filters?: InputMaybe<JobsCollectionFiltersInput>;
  paginate?: InputMaybe<OffsetPaginationInput>;
  sortBy?: InputMaybe<JobsCollectionSortInput>;
}


export interface QueryJobsCollectionByLocationsArgs {
  filters?: InputMaybe<JobsCollectionSortField>;
  locationStrings: ReadonlyArray<Scalars['String']['input']>;
  paginate?: InputMaybe<OffsetPaginationInput>;
}


export interface QueryJobsCollectionExactArgs {
  filters?: InputMaybe<JobsCollectionFiltersInput>;
  paginate?: InputMaybe<OffsetPaginationInput>;
  sortBy?: InputMaybe<JobsCollectionSortInput>;
}


export interface QueryJobsCollectionExactV2Args {
  filters?: InputMaybe<JobsCollectionFiltersInput>;
  paginate?: InputMaybe<OffsetPaginationInput>;
  sortBy?: InputMaybe<JobsCollectionSortInput>;
}


export interface QueryJobsCollectionWeightedArgs {
  filters?: InputMaybe<JobsCollectionFiltersInput>;
  paginate?: InputMaybe<OffsetPaginationInput>;
  sortBy?: InputMaybe<JobsCollectionSortInput>;
}


export interface QueryLedgerLinksArgs {
  ledgerLinkId: Scalars['ID']['input'];
}


export interface QueryLicenseArgs {
  id: Scalars['ID']['input'];
}


export interface QueryLicenseVerificationArgs {
  id: Scalars['ID']['input'];
}


export interface QueryLocalPaymentDetailsArgs {
  jobId: Scalars['ID']['input'];
}


export interface QueryLocationArgs {
  latitude?: InputMaybe<Scalars['Float']['input']>;
  locationString?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  sharedId?: InputMaybe<Scalars['ID']['input']>;
}


export interface QueryMatchingJobsForApplicationArgs {
  jobApplicationId: Scalars['ID']['input'];
}


export interface QueryMissingPayrollConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  candidateId?: InputMaybe<Scalars['String']['input']>;
  candidateName?: InputMaybe<Scalars['String']['input']>;
  facility?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  weekEndingEndDate?: InputMaybe<Scalars['String']['input']>;
  weekEndingStartDate?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryMissingPayrollStatsArgs {
  candidateId?: InputMaybe<Scalars['String']['input']>;
  candidateName?: InputMaybe<Scalars['String']['input']>;
  facility?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  weekEndingEndDate?: InputMaybe<Scalars['String']['input']>;
  weekEndingStartDate?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryMissingTimecardConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  candidateId?: InputMaybe<Scalars['String']['input']>;
  candidateName?: InputMaybe<Scalars['String']['input']>;
  facility?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  weekEndingEndDate?: InputMaybe<Scalars['String']['input']>;
  weekEndingStartDate?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryMissingTimecardStatsArgs {
  candidateId?: InputMaybe<Scalars['String']['input']>;
  candidateName?: InputMaybe<Scalars['String']['input']>;
  facility?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  weekEndingEndDate?: InputMaybe<Scalars['String']['input']>;
  weekEndingStartDate?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryMspSuggestionsArgs {
  searchQuery: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
}


export interface QueryNurseAssessmentArgs {
  id: Scalars['ID']['input'];
}


export interface QueryNurseCertificationArgs {
  id: Scalars['ID']['input'];
}


export interface QueryNurseHealthDocArgs {
  id: Scalars['ID']['input'];
}


export interface QueryNurseLicenseVerificationArgs {
  id: Scalars['ID']['input'];
}


export interface QueryNurseProfileArgs {
  uuid?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryNurseProfileSuggestionsArgs {
  searchQuery: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
}


export interface QueryOnboardingItemSampleImageArgs {
  id: Scalars['ID']['input'];
}


export interface QueryOnboardingListConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  candidateId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  facility?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderDirection?: InputMaybe<OrderDirection>;
  orderField?: InputMaybe<TodoListOrderField>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  startDateFrom?: InputMaybe<Scalars['String']['input']>;
  startDateTo?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryOnboardingListStatsArgs {
  candidateId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  facility?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  startDateFrom?: InputMaybe<Scalars['String']['input']>;
  startDateTo?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryParsedEducationArgs {
  id: Scalars['ID']['input'];
}


export interface QueryParsedReferenceArgs {
  id: Scalars['ID']['input'];
}


export interface QueryParsedWorkExperienceArgs {
  id: Scalars['ID']['input'];
}


export interface QueryPayHoursCancellationsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  jobPlacementId: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryPayrollAccrualsArgs {
  payrollId: Scalars['String']['input'];
}


export interface QueryPayrollAmendmentContractsArgs {
  payrollId: Scalars['String']['input'];
}


export interface QueryPayrollConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  allowlist?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  candidateId?: InputMaybe<Scalars['String']['input']>;
  candidateName?: InputMaybe<Scalars['String']['input']>;
  contractType?: InputMaybe<Scalars['String']['input']>;
  facility?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hourType?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  program?: InputMaybe<Scalars['String']['input']>;
  requiredAttachment?: InputMaybe<Scalars['Boolean']['input']>;
  roleType?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<PayrollSortInput>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  weekEndingEndDate?: InputMaybe<Scalars['String']['input']>;
  weekEndingStartDate?: InputMaybe<Scalars['String']['input']>;
  weekOff?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface QueryPayrollCorrectionArgs {
  payrollId: Scalars['String']['input'];
}


export interface QueryPayrollCorrectionRatesArgs {
  payrollId: Scalars['String']['input'];
}


export interface QueryPayrollCovidLeaveHoursHistoryArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nurseProfileId: Scalars['String']['input'];
  stateCode: Scalars['String']['input'];
}


export interface QueryPayrollImagePreviewArgs {
  blobId: Scalars['String']['input'];
}


export interface QueryPayrollItemArgs {
  payrollId: Scalars['String']['input'];
}


export interface QueryPayrollItemForCandidateArgs {
  candidateId: Scalars['String']['input'];
  weekEndingDate?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryPayrollItemsArgs {
  showAllHistory?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface QueryPayrollOverridesArgs {
  payrollId: Scalars['String']['input'];
}


export interface QueryPayrollPaidLeaveHoursHistoryArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nurseProfileId: Scalars['String']['input'];
}


export interface QueryPayrollRatesArgs {
  payrollId: Scalars['String']['input'];
}


export interface QueryPayrollShiftDetailsArgs {
  payrollId: Scalars['String']['input'];
}


export interface QueryPayrollSickLeaveHoursHistoryArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nurseProfileId: Scalars['String']['input'];
}


export interface QueryPayrollStatsArgs {
  allowlist?: InputMaybe<Scalars['String']['input']>;
  candidateId?: InputMaybe<Scalars['String']['input']>;
  candidateName?: InputMaybe<Scalars['String']['input']>;
  contractType?: InputMaybe<Scalars['String']['input']>;
  facility?: InputMaybe<Scalars['String']['input']>;
  hourType?: InputMaybe<Scalars['String']['input']>;
  program?: InputMaybe<Scalars['String']['input']>;
  requiredAttachment?: InputMaybe<Scalars['Boolean']['input']>;
  roleType?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  weekEndingEndDate?: InputMaybe<Scalars['String']['input']>;
  weekEndingStartDate?: InputMaybe<Scalars['String']['input']>;
  weekOff?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface QueryPopularCitiesPayArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
}


export interface QueryProfileCompletionSummaryArgs {
  clinicianId?: InputMaybe<Scalars['ID']['input']>;
}


export interface QueryProgramSuggestionsArgs {
  searchQuery: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
}


export interface QueryReferenceArgs {
  id: Scalars['ID']['input'];
}


export interface QueryRelatedJobsConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface QueryResidencyProgramArgs {
  id: Scalars['ID']['input'];
}


export interface QueryResidencyProgramsConnectionArgs {
  accreditingBody?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface QueryRoleArgs {
  key: Scalars['String']['input'];
}


export interface QueryRolesArgs {
  marketplaceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  roleType?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<RoleType>;
  worksEnabled?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface QuerySearchAffiliationsArgs {
  query: Scalars['String']['input'];
}


export interface QuerySearchClinicalSpecialtiesConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  roleGroupType?: InputMaybe<Scalars['String']['input']>;
}


export interface QuerySectionArgs {
  id: Scalars['ID']['input'];
}


export interface QuerySectionsArgs {
  parentId?: InputMaybe<Scalars['Int']['input']>;
}


export interface QuerySurveyForUserArgs {
  facilitySlug: Scalars['String']['input'];
  userSurveyToken?: InputMaybe<Scalars['ID']['input']>;
}


export interface QuerySystemMessagesArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
}


export interface QueryTechelonNurseProfileSuggestionsArgs {
  searchQuery: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
}


export interface QueryTechnologiesForPositionArgs {
  employment_position_id: Scalars['String']['input'];
}


export interface QueryTechnologySuggestionsArgs {
  searchString: Scalars['String']['input'];
}


export interface QueryTimeEntriesByDayArgs {
  duration_days: Scalars['Int']['input'];
  job_placement_schedule_uuid: Scalars['String']['input'];
  start_sec: Scalars['Int']['input'];
}


export interface QueryTimeEntryHourTypeListArgs {
  payrollId?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryTodoListArgs {
  id: Scalars['ID']['input'];
}


export interface QueryTodoListItemArgs {
  id: Scalars['ID']['input'];
}


export interface QueryUnsubmittedPayrollArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  candidateId?: InputMaybe<Scalars['String']['input']>;
  candidateName?: InputMaybe<Scalars['String']['input']>;
  facility?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  weekEndingDate?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryUsStateLocationsArgs {
  hasActiveJobs?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<UsStateLocationsOrderBy>;
  role: JobRole;
}


export interface QueryUserByEmailArgs {
  csrfToken: Scalars['String']['input'];
  email: Scalars['String']['input'];
}


export interface QueryVendorIntegrationExternalIdentifierArgs {
  internalType?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  vmsName?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryVmsSuggestionsArgs {
  searchQuery: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
}

export interface RateConfigInput {
  readonly callBack?: InputMaybe<Scalars['Float']['input']>;
  readonly charge?: InputMaybe<Scalars['Float']['input']>;
  readonly doubleTime?: InputMaybe<Scalars['Float']['input']>;
  readonly doubleTimeThresholdDaily?: InputMaybe<Scalars['Float']['input']>;
  readonly doubleTimeThresholdWeekly?: InputMaybe<Scalars['Float']['input']>;
  readonly extraTime?: InputMaybe<Scalars['Float']['input']>;
  readonly extraTimeWeeklyThreshold?: InputMaybe<Scalars['Float']['input']>;
  readonly holiday?: InputMaybe<Scalars['Float']['input']>;
  readonly lodgingReimbursement?: InputMaybe<Scalars['Float']['input']>;
  readonly lodgingReimbursementMax?: InputMaybe<Scalars['Float']['input']>;
  readonly mealsAndIncidentals?: InputMaybe<Scalars['Float']['input']>;
  readonly mealsAndIncidentalsMax?: InputMaybe<Scalars['Float']['input']>;
  readonly onCall?: InputMaybe<Scalars['Float']['input']>;
  readonly orientation?: InputMaybe<Scalars['Float']['input']>;
  readonly overtime?: InputMaybe<Scalars['Float']['input']>;
  readonly overtimeThresholdDaily?: InputMaybe<Scalars['Float']['input']>;
  readonly overtimeThresholdWeekly?: InputMaybe<Scalars['Float']['input']>;
  readonly regular?: InputMaybe<Scalars['Float']['input']>;
}

/** Autogenerated return type of RecalculatePayroll. */
export interface RecalculatePayrollPayload {
  readonly __typename?: 'RecalculatePayrollPayload';
  readonly payroll: Payroll;
}

export interface Recommendation {
  readonly __typename?: 'Recommendation';
  readonly dateCompleted?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly files?: Maybe<ReadonlyArray<File>>;
  readonly id: Scalars['ID']['output'];
  readonly phoneNumber?: Maybe<Scalars['String']['output']>;
  readonly placeOfEmployment: Scalars['String']['output'];
  readonly recommenderName?: Maybe<Scalars['String']['output']>;
  readonly recommenderPosition?: Maybe<Scalars['String']['output']>;
  readonly relationship?: Maybe<RecommenderRelationship>;
  readonly uuid?: Maybe<Scalars['String']['output']>;
}

export const enum RecommenderRelationship {
  /** Clinical Faculty */
  ClinicalFaculty = 'clinical_faculty',
  /** Clinical Liaison */
  ClinicalLiaison = 'clinical_liaison',
  /** Clinical Manager */
  ClinicalManager = 'clinical_manager',
  /** Professor */
  Professor = 'professor'
};

export interface ReconReport {
  readonly __typename?: 'ReconReport';
  readonly externalIds: ReadonlyArray<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly reconReportItems: ReadonlyArray<ReconReportItem>;
  readonly totalAmount: Scalars['Float']['output'];
}

export interface ReconReportItem {
  readonly __typename?: 'ReconReportItem';
  readonly amount: Scalars['Float']['output'];
  readonly hours?: Maybe<Scalars['Float']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly invoiceId: Scalars['ID']['output'];
  readonly matchingStatus: Scalars['String']['output'];
  readonly netsuiteInvoiceDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly netsuiteInvoiceId?: Maybe<Scalars['ID']['output']>;
  readonly vmsInvoiceDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly vmsInvoiceId?: Maybe<Scalars['ID']['output']>;
  readonly vmsTimecardId?: Maybe<Scalars['ID']['output']>;
  readonly weekEnding: Scalars['ISO8601Date']['output'];
}

export interface ReconcileDifferenceInput {
  readonly end?: InputMaybe<Scalars['Int']['input']>;
  readonly start?: InputMaybe<Scalars['Int']['input']>;
}

/** Autogenerated return type of RecordEvent. */
export interface RecordEventPayload {
  readonly __typename?: 'RecordEventPayload';
  readonly user: User;
}

/** Structure for record not unique errors */
export interface RecordNotUniqueError {
  readonly __typename?: 'RecordNotUniqueError';
  readonly message: Scalars['String']['output'];
  readonly model: Scalars['String']['output'];
}

export interface Reference extends Credential {
  readonly __typename?: 'Reference';
  readonly bedCount?: Maybe<Scalars['Int']['output']>;
  readonly belowExpectations?: Maybe<Scalars['Boolean']['output']>;
  readonly canEdit?: Maybe<Scalars['Boolean']['output']>;
  readonly canSendReminder: Scalars['Boolean']['output'];
  readonly candidateName?: Maybe<Scalars['String']['output']>;
  readonly chargeDuties?: Maybe<Scalars['String']['output']>;
  readonly chargeExp?: Maybe<Scalars['Boolean']['output']>;
  readonly comments?: Maybe<Scalars['String']['output']>;
  readonly contactInfo?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly employment?: Maybe<Employment>;
  readonly employmentEndAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly employmentOther?: Maybe<Scalars['String']['output']>;
  readonly employmentStartAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly expired: Scalars['Boolean']['output'];
  readonly expiresOn?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly facilityName?: Maybe<Scalars['String']['output']>;
  readonly files?: Maybe<ReadonlyArray<File>>;
  readonly id: Scalars['ID']['output'];
  readonly isExpiringSoon?: Maybe<Scalars['Boolean']['output']>;
  readonly isLocked: Scalars['Boolean']['output'];
  readonly isVerified?: Maybe<Scalars['Boolean']['output']>;
  readonly jobTitle?: Maybe<Scalars['String']['output']>;
  readonly lastFailedDelivery?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly patientsPerNurse?: Maybe<Scalars['Int']['output']>;
  readonly pendingResponseDaysCountText?: Maybe<Scalars['String']['output']>;
  readonly phone?: Maybe<Scalars['String']['output']>;
  readonly position?: Maybe<Position>;
  readonly preferredContactMethod?: Maybe<Scalars['String']['output']>;
  readonly ratingCare?: Maybe<Scalars['String']['output']>;
  readonly ratingDocumentation?: Maybe<Scalars['String']['output']>;
  readonly ratingFlexible?: Maybe<Scalars['String']['output']>;
  readonly ratingPatientCommunication?: Maybe<Scalars['String']['output']>;
  readonly ratingPolicies?: Maybe<Scalars['String']['output']>;
  readonly ratingProfessional?: Maybe<Scalars['String']['output']>;
  readonly ratingPunctual?: Maybe<Scalars['String']['output']>;
  readonly ratingStaffCommunication?: Maybe<Scalars['String']['output']>;
  readonly referenceFormSentAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly relationship?: Maybe<Scalars['String']['output']>;
  readonly responseAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly signedName?: Maybe<Scalars['String']['output']>;
  readonly unit?: Maybe<Scalars['String']['output']>;
  readonly unitName?: Maybe<Scalars['String']['output']>;
  readonly uuid?: Maybe<Scalars['String']['output']>;
  readonly verifiedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly verifiedByName?: Maybe<Scalars['String']['output']>;
  readonly wouldRehire?: Maybe<Scalars['Boolean']['output']>;
}

export interface ReferenceSuggestion {
  readonly __typename?: 'ReferenceSuggestion';
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly jobTitle?: Maybe<Scalars['String']['output']>;
  readonly mobileNumber?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly parserId?: Maybe<Scalars['String']['output']>;
  readonly preferredContactMethod?: Maybe<Scalars['String']['output']>;
  readonly text?: Maybe<Scalars['String']['output']>;
}

export interface Referral {
  readonly __typename?: 'Referral';
  readonly dateConverted?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly dateReferralPaid?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly dateReferralStarted?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly firstName: Scalars['String']['output'];
  readonly lastName: Scalars['String']['output'];
  readonly status: Scalars['String']['output'];
  readonly statusDate: Scalars['ISO8601Date']['output'];
}

export interface ReferralResponse {
  readonly __typename?: 'ReferralResponse';
  readonly totalCount: Scalars['Int']['output'];
  readonly users: ReadonlyArray<Referral>;
}

export interface RefuseBonusInput {
  readonly bonusId: Scalars['ID']['input'];
  readonly correction: Scalars['Boolean']['input'];
  readonly payrollId: Scalars['ID']['input'];
}

/** Autogenerated return type of RefuseBonus. */
export interface RefuseBonusPayload {
  readonly __typename?: 'RefuseBonusPayload';
  readonly payroll: Payroll;
}

export interface RegionIncomeComparison {
  readonly __typename?: 'RegionIncomeComparison';
  readonly city?: Maybe<Scalars['Float']['output']>;
  readonly country?: Maybe<Scalars['Float']['output']>;
  readonly state?: Maybe<Scalars['Float']['output']>;
}

export interface RejectComplianceListItemInput {
  readonly rejectionNotes: Scalars['String']['input'];
}

/** Autogenerated return type of RejectComplianceListItem. */
export interface RejectComplianceListItemPayload {
  readonly __typename?: 'RejectComplianceListItemPayload';
  readonly complianceListItem: ComplianceListItem;
}

/** Autogenerated return type of RejectLedgerAttachment. */
export interface RejectLedgerAttachmentPayload {
  readonly __typename?: 'RejectLedgerAttachmentPayload';
  readonly ledgerAttachment?: Maybe<LedgerAttachment>;
}

/** Autogenerated return type of RejectOnboardingItem. */
export interface RejectOnboardingItemPayload {
  readonly __typename?: 'RejectOnboardingItemPayload';
  readonly todoList: TodoList;
  readonly todoListItem: TodoListItem;
}

export interface ReliasUser {
  readonly __typename?: 'ReliasUser';
  readonly reliasUsername: Scalars['String']['output'];
  readonly tempPassword?: Maybe<Scalars['String']['output']>;
}

/** Autogenerated return type of RemoveReference. */
export interface RemoveReferencePayload {
  readonly __typename?: 'RemoveReferencePayload';
  readonly error?: Maybe<Scalars['String']['output']>;
  readonly nurseProfile: NurseProfile;
  readonly reference: Reference;
}

export interface ReportMobileAppVersionInput {
  readonly lastTimeUpdateRequested?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  readonly lastTimeUpdateRequestedFor?: InputMaybe<Scalars['String']['input']>;
  readonly osName: MobileAppOsName;
  readonly osVersion: Scalars['String']['input'];
  readonly stage: Scalars['String']['input'];
  readonly versionKind: MobileAppVersionKind;
  readonly versionName: Scalars['String']['input'];
  readonly versionNumber: Scalars['String']['input'];
}

/** Autogenerated return type of ReportVersion. */
export interface ReportVersionPayload {
  readonly __typename?: 'ReportVersionPayload';
  readonly instructions: MobileAppUpdateInstructions;
  readonly versionStatus: MobileAppVersionStatus;
}

/** Autogenerated return type of RepublishOnboardingList. */
export interface RepublishOnboardingListPayload {
  readonly __typename?: 'RepublishOnboardingListPayload';
  readonly todoList: TodoList;
}

export interface RequestActivationInput {
  readonly earliestStartDateAt: Scalars['ISO8601Date']['input'];
  readonly followingStepQuestion?: InputMaybe<Scalars['String']['input']>;
  readonly notes: Scalars['String']['input'];
  readonly requiredExperience: Scalars['Boolean']['input'];
  readonly requiredExperienceDateAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly requiredLicenseOrCertification?: InputMaybe<Scalars['Boolean']['input']>;
  readonly requiredLicenseOrCertificationDateAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
}

/** Autogenerated return type of RequestActivation. */
export interface RequestActivationPayload {
  readonly __typename?: 'RequestActivationPayload';
  readonly errorCode?: Maybe<Scalars['String']['output']>;
  readonly nurseProfile: NurseProfile;
  readonly reasons: ReadonlyArray<Scalars['String']['output']>;
}

export interface RequestPayPreviewInput {
  readonly payrollId: Scalars['ID']['input'];
}

export interface RequestReview {
  readonly __typename?: 'RequestReview';
  readonly ctaText: Scalars['String']['output'];
  readonly description: Scalars['String']['output'];
  readonly error?: Maybe<Scalars['String']['output']>;
  readonly status: RequestReviewStatusEnum;
  readonly title: Scalars['String']['output'];
}

export interface RequestReviewForm {
  readonly __typename?: 'RequestReviewForm';
  readonly ctaText: Scalars['String']['output'];
  readonly experienceDateQuestion: RequestReviewQuestion;
  readonly experienceQuestion: RequestReviewQuestion;
  readonly followingStepQuestion: RequestReviewQuestion;
  readonly licenseOrCertificationDateQuestion: RequestReviewQuestion;
  readonly licenseOrCertificationIntentionQuestion: RequestReviewQuestion;
  readonly licenseOrCertificationQuestion: RequestReviewQuestion;
  readonly notesQuestion: RequestReviewQuestion;
  readonly startDateQuestion: RequestReviewQuestion;
  readonly title: Scalars['String']['output'];
}

export interface RequestReviewQuestion {
  readonly __typename?: 'RequestReviewQuestion';
  readonly description: Scalars['String']['output'];
  readonly title: Scalars['String']['output'];
}

export const enum RequestReviewStatusEnum {
  /** User has review-request-workflow rollout and is not able to request review */
  Disabled = 'disabled',
  /** User has review-request-workflow rollout and is able to request review */
  Enabled = 'enabled',
  /** User does not have review-request-workflow rollout */
  Hidden = 'hidden'
};

/** Autogenerated return type of RequestSmsVerification. */
export interface RequestSmsVerificationPayload {
  readonly __typename?: 'RequestSmsVerificationPayload';
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
  readonly user: User;
}

export interface Research {
  readonly __typename?: 'Research';
  readonly descriptions: ReadonlyArray<Scalars['String']['output']>;
  readonly endOn?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly googlePlaceId?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly locationAddress?: Maybe<Scalars['String']['output']>;
  readonly locationString?: Maybe<Scalars['String']['output']>;
  readonly orgName: Scalars['String']['output'];
  readonly startOn: Scalars['ISO8601Date']['output'];
  readonly summary?: Maybe<Scalars['String']['output']>;
  readonly uuid: Scalars['String']['output'];
}

/** Autogenerated return type of ResendReferenceForm. */
export interface ResendReferenceFormPayload {
  readonly __typename?: 'ResendReferenceFormPayload';
  readonly nurseProfile: NurseProfile;
  readonly reference: Reference;
}

export interface ResetUserPasswordInput {
  readonly password: Scalars['String']['input'];
  readonly passwordConfirmation: Scalars['String']['input'];
  readonly resetPasswordToken: Scalars['String']['input'];
}

/** Autogenerated return type of ResetUserPassword. */
export interface ResetUserPasswordPayload {
  readonly __typename?: 'ResetUserPasswordPayload';
  readonly roleType: Scalars['String']['output'];
  readonly token: Scalars['String']['output'];
  readonly user: User;
}

export interface ResidencyProgram {
  readonly __typename?: 'ResidencyProgram';
  readonly accredited: Scalars['Boolean']['output'];
  readonly accreditingBody?: Maybe<Scalars['String']['output']>;
  readonly clinicalSpecialties?: Maybe<ReadonlyArray<ClinicalSpecialty>>;
  readonly facility?: Maybe<Facility>;
  readonly id: Scalars['ID']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly offersAllSpecialties: Scalars['Boolean']['output'];
  readonly url?: Maybe<Scalars['String']['output']>;
}

/** The connection type for ResidencyProgram. */
export interface ResidencyProgramConnection {
  readonly __typename?: 'ResidencyProgramConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ResidencyProgramEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<ResidencyProgram>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface ResidencyProgramEdge {
  readonly __typename?: 'ResidencyProgramEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<ResidencyProgram>;
}

/** Autogenerated return type of RetakeReliasAssessment. */
export interface RetakeReliasAssessmentPayload {
  readonly __typename?: 'RetakeReliasAssessmentPayload';
  readonly nurseAssessment?: Maybe<NurseAssessment>;
  readonly nurseProfile?: Maybe<NurseProfile>;
}

/** Autogenerated return type of RetryTimecardOcrParsing. */
export interface RetryTimecardOcrParsingPayload {
  readonly __typename?: 'RetryTimecardOcrParsingPayload';
  readonly timecardOcrParsing: TimecardOcrParsing;
}

export interface Role {
  readonly __typename?: 'Role';
  readonly abbreviation: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly key?: Maybe<Scalars['String']['output']>;
  /** @deprecated column removed */
  readonly marketplaceEnabled: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  /** @deprecated use 'type' */
  readonly roleType?: Maybe<Scalars['String']['output']>;
  readonly type?: Maybe<RoleType>;
  /** @deprecated column removed */
  readonly worksEnabled: Scalars['Boolean']['output'];
}

export const enum RoleType {
  /** Healthcare professionals outside of nursing, medicine, and dentistry, who provide diagnostic, therapeutic, technical, and support services */
  Allied = 'allied',
  /** Licensed healthcare practitioners, including LPNs and RNs, who deliver direct patient care. */
  Nursing = 'nursing'
};

export interface SaasquatchWidgetContent {
  readonly __typename?: 'SaasquatchWidgetContent';
  readonly mainText?: Maybe<Scalars['String']['output']>;
  readonly titleText?: Maybe<Scalars['String']['output']>;
}

export interface SalesforceUser {
  readonly __typename?: 'SalesforceUser';
  readonly calendarLink?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `calendarLink` */
  readonly calendar_link?: Maybe<Scalars['String']['output']>;
  readonly clinicalRole?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `firstName` */
  readonly first_name?: Maybe<Scalars['String']['output']>;
  readonly fullName?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly isAlliedAdvocate?: Maybe<Scalars['Boolean']['output']>;
  readonly isNurseAdvocate?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use `isNurseAdvocate` */
  readonly is_nurse_advocate?: Maybe<Scalars['Boolean']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `lastName` */
  readonly last_name?: Maybe<Scalars['String']['output']>;
  readonly phone?: Maybe<Scalars['String']['output']>;
  readonly profileImgUrl: Scalars['String']['output'];
  /** @deprecated use `profileImgUrl` */
  readonly profile_img_url?: Maybe<Scalars['String']['output']>;
}

/** Autogenerated return type of SaveFacility. */
export interface SaveFacilityPayload {
  readonly __typename?: 'SaveFacilityPayload';
  readonly nurseProfile: NurseProfile;
}

export interface SavedSearch {
  readonly __typename?: 'SavedSearch';
  readonly broadPrefLocations: ReadonlyArray<BroadPrefLocations>;
  readonly clinicalSpecialties: ReadonlyArray<ClinicalSpecialty>;
  readonly contractLengths: ReadonlyArray<ContractLength>;
  readonly id: Scalars['ID']['output'];
  readonly locationStrings: ReadonlyArray<Scalars['String']['output']>;
  readonly shiftLengths: ReadonlyArray<Scalars['String']['output']>;
  readonly shiftPrefs: ReadonlyArray<Scalars['String']['output']>;
  readonly smsEnabled: Scalars['Boolean']['output'];
  readonly specialties: ReadonlyArray<Scalars['String']['output']>;
}

export interface SearchHistory {
  readonly __typename?: 'SearchHistory';
  readonly id: Scalars['ID']['output'];
  readonly nurseProfile: NurseProfile;
  readonly searchForm: Scalars['String']['output'];
  readonly searchHistoryEntries: ReadonlyArray<SearchHistoryEntry>;
}

export interface SearchHistoryEntry {
  readonly __typename?: 'SearchHistoryEntry';
  readonly id: Scalars['ID']['output'];
  readonly searchHistory: SearchHistory;
  readonly searchParams: Scalars['String']['output'];
}

export interface Section {
  readonly __typename?: 'Section';
  readonly createdAt: Scalars['Int']['output'];
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly order: Scalars['Int']['output'];
  readonly parentId: Scalars['Int']['output'];
  readonly type: Scalars['String']['output'];
  readonly updatedAt: Scalars['Int']['output'];
  readonly url: Scalars['String']['output'];
  readonly workspaceId: Scalars['ID']['output'];
}

/** Autogenerated return type of SendPayPreview. */
export interface SendPayPreviewPayload {
  readonly __typename?: 'SendPayPreviewPayload';
  readonly payroll: Payroll;
}

export interface SendUserResetPasswordInstructionsInput {
  readonly csrfToken?: InputMaybe<Scalars['String']['input']>;
  readonly email: Scalars['String']['input'];
}

/** Autogenerated return type of SendUserResetPasswordInstructions. */
export interface SendUserResetPasswordInstructionsPayload {
  readonly __typename?: 'SendUserResetPasswordInstructionsPayload';
  readonly success: Scalars['Boolean']['output'];
}

export interface SharedLink {
  readonly __typename?: 'SharedLink';
  readonly id: Scalars['ID']['output'];
  readonly longUrl: Scalars['String']['output'];
  readonly shortUrl?: Maybe<Scalars['String']['output']>;
  readonly userId?: Maybe<Scalars['ID']['output']>;
}

export interface Shift {
  readonly __typename?: 'Shift';
  readonly duration: Scalars['Float']['output'];
  readonly endSec?: Maybe<Scalars['Int']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly startSec?: Maybe<Scalars['Int']['output']>;
  readonly timeEntries?: Maybe<ReadonlyArray<TimeEntry>>;
  readonly timezone: Scalars['String']['output'];
}

export const enum ShiftLength {
  /** 5x8 */
  FiveEight = 'five_eight',
  /** 4x10 */
  FourTen = 'four_ten',
  /** 4x12 */
  FourTwelve = 'four_twelve',
  /** 3x12 */
  ThreeTwelve = 'three_twelve'
};

export const enum ShiftType {
  /** day */
  Day = 'day',
  /** evening */
  Evening = 'evening',
  /** night */
  Night = 'night',
  /** variable */
  Variable = 'variable'
};

export interface SignInUserInput {
  readonly email: Scalars['String']['input'];
  readonly password: Scalars['String']['input'];
}

/** Autogenerated return type of SignInUser. */
export interface SignInUserPayload {
  readonly __typename?: 'SignInUserPayload';
  readonly roleType: Scalars['String']['output'];
  readonly token: Scalars['String']['output'];
  readonly user: User;
}

/** Autogenerated return type of SignOut. */
export interface SignOutPayload {
  readonly __typename?: 'SignOutPayload';
  readonly user?: Maybe<User>;
}

export interface SignUpInput {
  readonly nurseProfile?: InputMaybe<SignUpNurseProfileInput>;
  readonly referrerCode?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly user: SignUpUserInput;
}

export interface SignUpNurseProfileInput {
  readonly nurseType: NurseTypes;
  readonly roleId: Scalars['ID']['input'];
}

/** Autogenerated return type of SignUp. */
export interface SignUpPayload {
  readonly __typename?: 'SignUpPayload';
  readonly token: Scalars['String']['output'];
  readonly user: User;
}

export interface SignUpUserInput {
  readonly email: Scalars['String']['input'];
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly gbraid?: InputMaybe<Scalars['String']['input']>;
  readonly gclid?: InputMaybe<Scalars['String']['input']>;
  readonly initialReferringDomain?: InputMaybe<Scalars['String']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly password: Scalars['String']['input'];
  readonly passwordConfirmation: Scalars['String']['input'];
  readonly preferredName?: InputMaybe<Scalars['String']['input']>;
  readonly referralCode?: InputMaybe<Scalars['String']['input']>;
  readonly signupSource: SignupTypes;
  readonly signupSourceQualifier?: InputMaybe<SignupSourceQualifiers>;
  readonly userSurveyToken?: InputMaybe<Scalars['ID']['input']>;
  readonly utmSource?: InputMaybe<Scalars['String']['input']>;
  readonly utmTerm?: InputMaybe<Scalars['String']['input']>;
  readonly wbraid?: InputMaybe<Scalars['String']['input']>;
}

export const enum SignupSourceQualifiers {
  /** Ceutracker */
  Ceutracker = 'ceutracker',
  /** Community */
  Community = 'community',
  /** Explorer */
  Explorer = 'explorer',
  /** External Jobs */
  ExternalJobs = 'external_jobs',
  /** Facility */
  Facility = 'facility',
  /** Invite */
  Invite = 'invite',
  /** New Grad */
  NewGrad = 'new_grad',
  /** Www */
  Www = 'www'
};

export const enum SignupTypes {
  /** Community */
  Community = 'community',
  /** Explorer */
  Explorer = 'explorer',
  /** External Jobs */
  ExternalJobs = 'external_jobs',
  /** Primary */
  Primary = 'primary'
};

export interface SimpleBoolean {
  readonly __typename?: 'SimpleBoolean';
  readonly id: Scalars['ID']['output'];
  readonly value?: Maybe<Scalars['Boolean']['output']>;
}

export interface SimpleCount {
  readonly __typename?: 'SimpleCount';
  readonly id: Scalars['ID']['output'];
  readonly value?: Maybe<Scalars['Int']['output']>;
}

export interface SortedTodoListItems {
  readonly __typename?: 'SortedTodoListItems';
  readonly externalItems: SortedTodoListItemsCategories;
  readonly internalItems: SortedTodoListItemsCategories;
}

export interface SortedTodoListItemsCategories {
  readonly __typename?: 'SortedTodoListItemsCategories';
  readonly assessments?: Maybe<SortedTodoListItemsCategory>;
  readonly backgroundAndIdentification?: Maybe<SortedTodoListItemsCategory>;
  readonly general?: Maybe<SortedTodoListItemsCategory>;
  readonly healthDocuments?: Maybe<SortedTodoListItemsCategory>;
  readonly kickoff?: Maybe<SortedTodoListItemsCategory>;
  readonly licensesAndCertifications?: Maybe<SortedTodoListItemsCategory>;
  readonly orientationAndAssignmentInfo?: Maybe<SortedTodoListItemsCategory>;
  readonly twentyFourHourFollowUp?: Maybe<SortedTodoListItemsCategory>;
}

export interface SortedTodoListItemsCategory {
  readonly __typename?: 'SortedTodoListItemsCategory';
  readonly displayName: Scalars['String']['output'];
  readonly items: ReadonlyArray<TodoListItem>;
}

export interface SortedTodoListItemsExternal {
  readonly __typename?: 'SortedTodoListItemsExternal';
  readonly calculatedDueDate: Scalars['ISO8601Date']['output'];
  readonly categories: SortedTodoListItemsCategories;
  readonly displayName?: Maybe<Scalars['String']['output']>;
  readonly formattedDueDate: Scalars['String']['output'];
}

export const enum SortedTodoListItemsFilter {
  Live = 'LIVE'
};

export interface SplitAndMatchReconReportItemEntryInput {
  readonly amount: Scalars['Float']['input'];
  readonly hours: Scalars['Float']['input'];
  readonly weekEnding: Scalars['ISO8601Date']['input'];
}

/** Autogenerated return type of SplitAndMatchReconReportItem. */
export interface SplitAndMatchReconReportItemPayload {
  readonly __typename?: 'SplitAndMatchReconReportItemPayload';
  readonly reconReportItems?: Maybe<ReadonlyArray<ReconReportItem>>;
}

export interface Stat {
  readonly __typename?: 'Stat';
  readonly areaResolution: Scalars['String']['output'];
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly locationAbbr?: Maybe<Scalars['String']['output']>;
  readonly locationName: Scalars['String']['output'];
  readonly occupation?: Maybe<Scalars['String']['output']>;
  readonly source: Scalars['String']['output'];
  readonly statId: Scalars['String']['output'];
  readonly statName: Scalars['String']['output'];
  readonly statType?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly uuid: Scalars['String']['output'];
  readonly valueFloat?: Maybe<Scalars['Float']['output']>;
  readonly valueInt?: Maybe<Scalars['Int']['output']>;
  readonly valueString?: Maybe<Scalars['String']['output']>;
  readonly valueType: ValueTypeEnum;
}

export const enum StateEnum {
  /** User is activated */
  ApplyToJobs = 'APPLY_TO_JOBS',
  /** User is placed - onboarding */
  Onboarding = 'ONBOARDING',
  /** User is placed - pem working */
  PemWorking = 'PEM_WORKING',
  /** User is pre placed - pending contract */
  PendingContract = 'PENDING_CONTRACT',
  /** User is pre placed - review compliance questions */
  ReviewComplianceQuestions = 'REVIEW_COMPLIANCE_QUESTIONS',
  /** User is recently acquired */
  SetPreferences = 'SET_PREFERENCES',
  /** User is pre placed - sign contract */
  SignContract = 'SIGN_CONTRACT',
  /** User is pre placed - sign offer */
  SignOffer = 'SIGN_OFFER',
  /** User is qualifying */
  ViewMatches = 'VIEW_MATCHES',
  /** User is pre placed - onboarding list is not done */
  WaitingForOnboarding = 'WAITING_FOR_ONBOARDING',
  /** User is waitlisted */
  Waitlisted = 'WAITLISTED',
  /** User is placed - working */
  Working = 'WORKING'
};

export interface StaticNurseConfigurations {
  readonly __typename?: 'StaticNurseConfigurations';
  readonly nurseReasonForNotExtendingContractList: ReadonlyArray<Scalars['String']['output']>;
}

export interface StudentClinicalExperience {
  readonly __typename?: 'StudentClinicalExperience';
  readonly experienceType: StudentExperienceTypes;
  readonly experienceYear: Scalars['Int']['output'];
  readonly experienceYearTerm: YearTerms;
  readonly facilityName: Scalars['String']['output'];
  readonly facilityType: FacilityTypes;
  readonly id: Scalars['ID']['output'];
  readonly location?: Maybe<Location>;
  readonly locationAddress?: Maybe<Scalars['String']['output']>;
  readonly locationId?: Maybe<Scalars['String']['output']>;
  readonly locationSlug?: Maybe<Scalars['String']['output']>;
  readonly locationString?: Maybe<Scalars['String']['output']>;
  readonly studentClinicalExperienceUnits?: Maybe<ReadonlyArray<StudentClinicalExperienceUnit>>;
}

export interface StudentClinicalExperienceUnit {
  readonly __typename?: 'StudentClinicalExperienceUnit';
  readonly descriptions: ReadonlyArray<Scalars['String']['output']>;
  readonly hoursWorked: Scalars['Int']['output'];
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
}

export const enum StudentExperienceTypes {
  /** Capstone */
  Capstone = 'capstone',
  /** Clinical Rotation */
  ClinicalRotation = 'clinical_rotation',
  /** Preceptorship */
  Preceptorship = 'preceptorship'
};

/** Autogenerated return type of SubmitComplianceListItem. */
export interface SubmitComplianceListItemPayload {
  readonly __typename?: 'SubmitComplianceListItemPayload';
  readonly complianceListItem: ComplianceListItem;
}

/** Autogenerated return type of SubmitIntentCaptureSurvey. */
export interface SubmitIntentCaptureSurveyPayload {
  readonly __typename?: 'SubmitIntentCaptureSurveyPayload';
  readonly jobPlacement: JobPlacement;
}

/** Autogenerated return type of SubmitTimeSheet. */
export interface SubmitTimeSheetPayload {
  readonly __typename?: 'SubmitTimeSheetPayload';
  readonly timeSheet: TimeSheet;
}

export interface SystemMessage {
  readonly __typename?: 'SystemMessage';
  readonly body: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
}

export interface TechelonUserPermissions {
  readonly __typename?: 'TechelonUserPermissions';
  readonly invoice: ReadonlyArray<Scalars['String']['output']>;
  readonly payroll: ReadonlyArray<Scalars['String']['output']>;
}

export interface Technology {
  readonly __typename?: 'Technology';
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly uuid: Scalars['String']['output'];
}

export interface ThingsToDo {
  readonly __typename?: 'ThingsToDo';
  readonly outstandingItems: ReadonlyArray<ThingsToDoItem>;
  readonly totalOutstandingItems: Scalars['Int']['output'];
}

export const enum ThingsToDoItem {
  /** Complete onboarding */
  CompleteOnboarding = 'completeOnboarding',
  /** Complete qualification questions */
  CompleteQualificationQuestions = 'completeQualificationQuestions',
  /** Continue applications */
  ContinueApplications = 'continueApplications',
  /** Download app */
  DownloadApp = 'downloadApp',
  /** Get interview ready */
  GetInterviewReady = 'getInterviewReady',
  /** Review facility */
  ReviewFacility = 'reviewFacility',
  /** Review profile */
  ReviewProfile = 'reviewProfile',
  /** Upload identity docs */
  UploadIdentityDocs = 'uploadIdentityDocs',
  /** Verify email */
  VerifyEmail = 'verifyEmail'
};

export interface TimeEntry {
  readonly __typename?: 'TimeEntry';
  readonly archived?: Maybe<Scalars['Boolean']['output']>;
  readonly children?: Maybe<ReadonlyArray<TimeEntry>>;
  readonly createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated use `createdAt` */
  readonly created_at?: Maybe<Scalars['String']['output']>;
  readonly duration?: Maybe<Scalars['Float']['output']>;
  readonly endSec?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use `endSec` */
  readonly end_sec?: Maybe<Scalars['Int']['output']>;
  readonly entryType?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `entryType` */
  readonly entry_type?: Maybe<Scalars['String']['output']>;
  readonly files?: Maybe<ReadonlyArray<File>>;
  readonly id: Scalars['ID']['output'];
  readonly jobPlacementScheduleId?: Maybe<Scalars['Int']['output']>;
  readonly jobPlacementScheduleUuid?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `jobPlacementScheduleId` */
  readonly job_placement_schedule_id?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use `jobPlacementScheduleUuid` */
  readonly job_placement_schedule_uuid?: Maybe<Scalars['String']['output']>;
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly otherNotes?: Maybe<Scalars['String']['output']>;
  readonly parentId?: Maybe<Scalars['String']['output']>;
  readonly shiftId?: Maybe<Scalars['Int']['output']>;
  readonly skippedLunch?: Maybe<Scalars['Boolean']['output']>;
  readonly startSec?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use `startSec` */
  readonly start_sec?: Maybe<Scalars['Int']['output']>;
  readonly timeType: TimeEntryTime;
  readonly timezone?: Maybe<Scalars['String']['output']>;
  readonly uuid?: Maybe<Scalars['String']['output']>;
}

export interface TimeEntryDay {
  readonly __typename?: 'TimeEntryDay';
  readonly dayEndSec?: Maybe<Scalars['Int']['output']>;
  readonly dayStartSec?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use `dayEndSec` */
  readonly day_end_sec?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use `dayStartSec` */
  readonly day_start_sec?: Maybe<Scalars['Int']['output']>;
  readonly shift?: Maybe<Shift>;
  readonly submitted?: Maybe<Scalars['Boolean']['output']>;
  readonly timeEntries?: Maybe<ReadonlyArray<Maybe<TimeEntry>>>;
  /** @deprecated use `timeEntries` */
  readonly time_entries?: Maybe<ReadonlyArray<Maybe<TimeEntry>>>;
}

export interface TimeEntryDescription {
  readonly __typename?: 'TimeEntryDescription';
  readonly defaultOption?: Maybe<Scalars['String']['output']>;
  readonly options: ReadonlyArray<Scalars['String']['output']>;
  readonly type: Scalars['String']['output'];
}

export interface TimeEntryHour {
  readonly __typename?: 'TimeEntryHour';
  readonly label: Scalars['String']['output'];
  readonly value: Scalars['String']['output'];
}

export interface TimeEntryInput {
  readonly destroy?: InputMaybe<Scalars['Boolean']['input']>;
  readonly endSec: Scalars['Int']['input'];
  readonly entryType: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly otherNotes?: InputMaybe<Scalars['String']['input']>;
  readonly startSec: Scalars['Int']['input'];
}

export const enum TimeEntryTime {
  /** Interval */
  Interval = 'INTERVAL',
  /** Range */
  Range = 'RANGE'
};

export interface TimeOff {
  readonly __typename?: 'TimeOff';
  readonly approvalStatus?: Maybe<Scalars['String']['output']>;
  readonly contractId?: Maybe<Scalars['Int']['output']>;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly isDeleted?: Maybe<Scalars['Boolean']['output']>;
  readonly jobOfferId?: Maybe<Scalars['Int']['output']>;
  readonly nurseProfileId?: Maybe<Scalars['Int']['output']>;
  readonly sfdcCandidateId?: Maybe<Scalars['String']['output']>;
  readonly sfdcContractId?: Maybe<Scalars['String']['output']>;
  readonly sfdcId?: Maybe<Scalars['String']['output']>;
  readonly sfdcJobProcessId?: Maybe<Scalars['String']['output']>;
  readonly startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly totalDays?: Maybe<Scalars['Int']['output']>;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface TimeOffRequest {
  readonly __typename?: 'TimeOffRequest';
  readonly fromDate: Scalars['ISO8601Date']['output'];
  readonly id: Scalars['ID']['output'];
  readonly toDate: Scalars['ISO8601Date']['output'];
}

export interface TimeOffRequestInput {
  readonly fromDate: Scalars['ISO8601Date']['input'];
  readonly toDate: Scalars['ISO8601Date']['input'];
}

export interface TimeSheet {
  readonly __typename?: 'TimeSheet';
  readonly currentWeek: Scalars['Boolean']['output'];
  readonly dueSec: Scalars['Int']['output'];
  readonly editorUser?: Maybe<AdminUser>;
  readonly endSec: Scalars['Int']['output'];
  readonly files?: Maybe<ReadonlyArray<File>>;
  readonly hourTypeList?: Maybe<ReadonlyArray<TimeEntryHour>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly nurseProfile: NurseProfile;
  readonly paperTimecardRequired?: Maybe<Scalars['Boolean']['output']>;
  readonly payroll?: Maybe<Payroll>;
  readonly previousActiveShifts?: Maybe<Scalars['String']['output']>;
  readonly reasonForNotAttachingFile?: Maybe<Scalars['String']['output']>;
  readonly requiredAttachment: Scalars['Boolean']['output'];
  readonly shifts: ReadonlyArray<Shift>;
  readonly startSec: Scalars['Int']['output'];
  readonly status: TimeSheetStatus;
  readonly statusReason?: Maybe<Scalars['String']['output']>;
  readonly submittedAt?: Maybe<Scalars['Int']['output']>;
  readonly timeInputType: TimeSheetTimeInput;
  readonly totalHours: Scalars['Float']['output'];
  readonly totalShifts: Scalars['Int']['output'];
  readonly updatedAt: Scalars['ISO8601Date']['output'];
  readonly updatedBy?: Maybe<Scalars['String']['output']>;
  readonly weekEndingDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly weekOff: Scalars['Boolean']['output'];
  readonly willUploadFileLater?: Maybe<Scalars['Boolean']['output']>;
  readonly workDays: ReadonlyArray<TimeEntryDay>;
}

/** The connection type for TimeSheet. */
export interface TimeSheetConnection {
  readonly __typename?: 'TimeSheetConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<TimeSheetEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<TimeSheet>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface TimeSheetEdge {
  readonly __typename?: 'TimeSheetEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<TimeSheet>;
}

export const enum TimeSheetStatus {
  /** Approved */
  Approved = 'APPROVED',
  /** Overdue */
  Overdue = 'OVERDUE',
  /** Rejected */
  Rejected = 'REJECTED',
  /** Submitted */
  Submitted = 'SUBMITTED',
  /** Unsubmitted */
  Unsubmitted = 'UNSUBMITTED'
};

export const enum TimeSheetTimeInput {
  /** Image Only */
  ImageOnly = 'IMAGE_ONLY',
  /** Image Only With Exception */
  ImageOnlyWithException = 'IMAGE_ONLY_WITH_EXCEPTION',
  /** Time Entry And Image */
  TimeEntryAndImage = 'TIME_ENTRY_AND_IMAGE'
};

export interface TimecardOcrParsing {
  readonly __typename?: 'TimecardOcrParsing';
  readonly id: Scalars['ID']['output'];
  readonly parsedData?: Maybe<Scalars['String']['output']>;
  readonly timecardTemplate: Scalars['String']['output'];
}

export interface TimekeepingAttributes {
  readonly __typename?: 'TimekeepingAttributes';
  readonly candidateTimecardProcess?: Maybe<Scalars['String']['output']>;
  readonly correctionFormUrl?: Maybe<Scalars['String']['output']>;
  readonly correctionFormUrlSecond?: Maybe<Scalars['String']['output']>;
  readonly facilityTimecardUrl?: Maybe<Scalars['String']['output']>;
  readonly facilityTimecardUrlSecond?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly parentId: Scalars['ID']['output'];
  readonly parentType: Scalars['String']['output'];
  readonly timecardDueDay?: Maybe<Scalars['Int']['output']>;
  readonly timecardDueHour?: Maybe<Scalars['Int']['output']>;
  readonly timecardDueMinute?: Maybe<Scalars['Int']['output']>;
  readonly timecardInstructions: Scalars['String']['output'];
  readonly timecardInstructionsSecond?: Maybe<Scalars['String']['output']>;
  readonly timecardProcessType?: Maybe<Scalars['String']['output']>;
  readonly timekeepingGuideUrl?: Maybe<Scalars['String']['output']>;
  readonly timekeepingGuideUrlSecond?: Maybe<Scalars['String']['output']>;
  readonly trustedInstructions?: Maybe<Scalars['String']['output']>;
  readonly workWeekEndDay?: Maybe<Scalars['Int']['output']>;
  readonly workWeekStartDay?: Maybe<Scalars['Int']['output']>;
  readonly workWeekStartHour?: Maybe<Scalars['Int']['output']>;
  readonly workWeekStartMinute?: Maybe<Scalars['Int']['output']>;
}

export interface TimekeepingRule {
  readonly __typename?: 'TimekeepingRule';
  readonly biweeklyProcessing?: Maybe<Scalars['String']['output']>;
  readonly candidateTimecardProcess?: Maybe<Scalars['String']['output']>;
  readonly candidateTimecardProcessSecond?: Maybe<Scalars['String']['output']>;
  readonly correctionFormUrl?: Maybe<Scalars['String']['output']>;
  readonly correctionFormUrlSecond?: Maybe<Scalars['String']['output']>;
  readonly directInvoicingRequired?: Maybe<Scalars['String']['output']>;
  readonly electronicTimekeepingSystem?: Maybe<Scalars['String']['output']>;
  readonly electronicTimekeepingSystemSecond?: Maybe<Scalars['String']['output']>;
  readonly facilityTimecardUrl?: Maybe<Scalars['String']['output']>;
  readonly facilityTimecardUrlSecond?: Maybe<Scalars['String']['output']>;
  readonly facilityTimekeepingSystem?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly paperTimecardOwner?: Maybe<Scalars['String']['output']>;
  readonly paperTimecardOwnerSecond?: Maybe<Scalars['String']['output']>;
  readonly shiftWorkweekRule?: Maybe<Scalars['String']['output']>;
  readonly timecardDueDay?: Maybe<Scalars['Int']['output']>;
  readonly timecardDueHour?: Maybe<Scalars['Int']['output']>;
  readonly timecardDueMinute?: Maybe<Scalars['Int']['output']>;
  readonly timecardInstructions?: Maybe<Scalars['String']['output']>;
  readonly timecardInstructionsSecond?: Maybe<Scalars['String']['output']>;
  readonly timecardProcessType?: Maybe<Scalars['String']['output']>;
  readonly timecardProcessTypeSecond?: Maybe<Scalars['String']['output']>;
  readonly timekeepingGuideUrl?: Maybe<Scalars['String']['output']>;
  readonly timekeepingGuideUrlSecond?: Maybe<Scalars['String']['output']>;
  readonly timezone?: Maybe<Scalars['String']['output']>;
  readonly trustedApprovesTime?: Maybe<Scalars['String']['output']>;
  readonly trustedInstructions?: Maybe<Scalars['String']['output']>;
  readonly trustedUploadsTimecard?: Maybe<Scalars['String']['output']>;
  readonly workWeekEndDay?: Maybe<Scalars['Int']['output']>;
  readonly workWeekStartDay?: Maybe<Scalars['Int']['output']>;
  readonly workWeekStartHour?: Maybe<Scalars['Int']['output']>;
  readonly workWeekStartMinute?: Maybe<Scalars['Int']['output']>;
}

export interface TimelineTodoListItems {
  readonly __typename?: 'TimelineTodoListItems';
  readonly externalItems: ReadonlyArray<SortedTodoListItemsExternal>;
  readonly internalItems: SortedTodoListItemsCategories;
}

export interface TodoList {
  readonly __typename?: 'TodoList';
  readonly adminStatus?: Maybe<Scalars['String']['output']>;
  readonly adminUser?: Maybe<AdminUser>;
  readonly allTasksCount: Scalars['Int']['output'];
  readonly archivedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly beforeStartDeadlineDays?: Maybe<Scalars['Int']['output']>;
  readonly canComplete: Scalars['Boolean']['output'];
  readonly canMarkClearedByTrusted: Scalars['Boolean']['output'];
  readonly canMarkFacilityCleared: Scalars['Boolean']['output'];
  readonly canMarkFdiSent: Scalars['Boolean']['output'];
  readonly canMarkTentativelyCleared: Scalars['Boolean']['output'];
  readonly canPublish: Scalars['Boolean']['output'];
  readonly canUnmarkClearedByTrusted: Scalars['Boolean']['output'];
  readonly canUnmarkFacilityClearedToTentativelyCleared: Scalars['Boolean']['output'];
  readonly canUnmarkFacilityClearedToTrustedCleared: Scalars['Boolean']['output'];
  readonly canUnmarkFdiSent: Scalars['Boolean']['output'];
  readonly canUnmarkTentativelyCleared: Scalars['Boolean']['output'];
  readonly canUnpublish: Scalars['Boolean']['output'];
  /** Returns history of changes for todo lists and items */
  readonly changesHistoryConnection: ChangeRecordConnection;
  readonly completeByDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** @deprecated use `completeByDate` */
  readonly complete_by_date?: Maybe<Scalars['String']['output']>;
  readonly completedTasksCount: Scalars['Int']['output'];
  readonly complianceListUrl?: Maybe<Scalars['String']['output']>;
  readonly contractSignedDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly currentStatus?: Maybe<OnboardingListStatus>;
  readonly endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly facilityChecklistFile?: Maybe<File>;
  readonly fdiSentAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly hardDeadline?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly healthSystemChecklistFile?: Maybe<File>;
  readonly id: Scalars['ID']['output'];
  /** @deprecated no longer used */
  readonly incentiveDeadline?: Maybe<Scalars['ISO8601Date']['output']>;
  /** @deprecated no longer used */
  readonly incentive_deadline?: Maybe<Scalars['String']['output']>;
  readonly isCompliant?: Maybe<Scalars['Boolean']['output']>;
  readonly isTemplate?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use `isTemplate` */
  readonly is_template?: Maybe<Scalars['Boolean']['output']>;
  readonly jobPlacement?: Maybe<JobPlacement>;
  readonly listType?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `listType` */
  readonly list_type?: Maybe<Scalars['String']['output']>;
  readonly markedCompleteAt?: Maybe<Scalars['ISO8601Date']['output']>;
  /** @deprecated use `markedCompleteAt` */
  readonly marked_complete_at?: Maybe<Scalars['String']['output']>;
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly numCompletedItems?: Maybe<Scalars['Int']['output']>;
  readonly numExternalCompletedItems?: Maybe<Scalars['Int']['output']>;
  readonly numExternalItems?: Maybe<Scalars['Int']['output']>;
  readonly numInternalCompletedItems?: Maybe<Scalars['Int']['output']>;
  readonly numInternalItems?: Maybe<Scalars['Int']['output']>;
  readonly numInternalPendingItems?: Maybe<Scalars['Int']['output']>;
  readonly numInternalReadyForUploadItems?: Maybe<Scalars['Int']['output']>;
  readonly numInternalRejectedItems?: Maybe<Scalars['Int']['output']>;
  readonly numItems?: Maybe<Scalars['Int']['output']>;
  readonly numReadyForUpload?: Maybe<Scalars['Int']['output']>;
  readonly numTasksDue?: Maybe<Scalars['Int']['output']>;
  readonly numTasksNeedingAttention?: Maybe<Scalars['Int']['output']>;
  readonly numTasksPending?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use `numTasksDue` */
  readonly num_tasks_due?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use `numTasksNeedingAttention` */
  readonly num_tasks_needing_attention?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use `numTasksPending` */
  readonly num_tasks_pending?: Maybe<Scalars['Int']['output']>;
  readonly nurseProfile?: Maybe<NurseProfile>;
  readonly onboardingLink?: Maybe<Scalars['String']['output']>;
  readonly onboardingNote?: Maybe<Scalars['String']['output']>;
  readonly onboardingNoteTimestamp?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly owner?: Maybe<AdminUser>;
  readonly parentId?: Maybe<Scalars['Int']['output']>;
  readonly pendingTasksCount: Scalars['Int']['output'];
  readonly percentageCompletedItems: Scalars['Int']['output'];
  readonly publishedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  /** @deprecated use `publishedAt` */
  readonly published_at?: Maybe<Scalars['String']['output']>;
  readonly snapshot?: Maybe<TodoListSnapshot>;
  readonly sortedTodoListItems: SortedTodoListItems;
  readonly startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** @deprecated use `startDate` */
  readonly start_date?: Maybe<Scalars['String']['output']>;
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly targetBusinessLocation?: Maybe<Location>;
  readonly targetBusinessName?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `targetBusinessLocation` */
  readonly target_business_location?: Maybe<Location>;
  /** @deprecated use `targetBusinessName` */
  readonly target_business_name?: Maybe<Scalars['String']['output']>;
  readonly timelineTodoListItems: TimelineTodoListItems;
  readonly todoListItems: ReadonlyArray<TodoListItem>;
  /** @deprecated use `todoListItems` */
  readonly todo_list_items: ReadonlyArray<TodoListItem>;
  readonly uuid?: Maybe<Scalars['String']['output']>;
}


export interface TodoListChangesHistoryConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface TodoListSortedTodoListItemsArgs {
  filter?: InputMaybe<SortedTodoListItemsFilter>;
}


export interface TodoListTimelineTodoListItemsArgs {
  filter?: InputMaybe<SortedTodoListItemsFilter>;
}


export interface TodoListTodoListItemsArgs {
  filter?: InputMaybe<TodoListItemsFilter>;
}


export interface TodoListTodo_List_ItemsArgs {
  filter?: InputMaybe<TodoListItemsFilter>;
}

export interface TodoListDueDate {
  readonly __typename?: 'TodoListDueDate';
  readonly key: Scalars['String']['output'];
  readonly label: Scalars['String']['output'];
  readonly value: Scalars['ISO8601Date']['output'];
}

export interface TodoListItem {
  readonly __typename?: 'TodoListItem';
  readonly actionLinks: ReadonlyArray<ActionLink>;
  readonly archiveReasons?: Maybe<ReadonlyArray<ArchiveReason>>;
  readonly archivedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly candidateNotes?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `candidateNotes` */
  readonly candidate_notes?: Maybe<Scalars['String']['output']>;
  readonly certification?: Maybe<Certification>;
  readonly completedOn?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly currentArchiveReason?: Maybe<ArchiveReason>;
  readonly daysToExpiry?: Maybe<Scalars['Int']['output']>;
  readonly daysUntilExpiration?: Maybe<Scalars['Int']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly documentTarget?: Maybe<Document>;
  /** @deprecated use `documentTarget` */
  readonly document_target?: Maybe<Document>;
  readonly dueDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** @deprecated use `dueDate` */
  readonly due_date?: Maybe<Scalars['String']['output']>;
  readonly employmentVerificationSubmission?: Maybe<EmploymentVerificationSubmission>;
  readonly expirationType?: Maybe<DocumentExpiration>;
  readonly expiresOn?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly expiresSoon?: Maybe<Scalars['Boolean']['output']>;
  readonly externalItemRejectionReasons: ReadonlyArray<Option>;
  readonly files?: Maybe<ReadonlyArray<File>>;
  readonly hasTarget: Scalars['Boolean']['output'];
  readonly humanDocumentSubtype?: Maybe<Scalars['String']['output']>;
  readonly humanDocumentType?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly incomplete: Scalars['Boolean']['output'];
  readonly incompleteReasons?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly internalNotes?: Maybe<Scalars['String']['output']>;
  readonly internalOnly?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use `internalOnly` */
  readonly internal_only?: Maybe<Scalars['Boolean']['output']>;
  readonly isCompliant?: Maybe<Scalars['Boolean']['output']>;
  readonly isExpirable?: Maybe<Scalars['Boolean']['output']>;
  readonly isExpired?: Maybe<Scalars['Boolean']['output']>;
  readonly isTemplate?: Maybe<Scalars['Boolean']['output']>;
  readonly isVerificationAlwaysRequired: Scalars['Boolean']['output'];
  /** @deprecated use `isTemplate` */
  readonly is_template?: Maybe<Scalars['Boolean']['output']>;
  readonly itemState?: Maybe<Scalars['String']['output']>;
  readonly itemType?: Maybe<Scalars['String']['output']>;
  readonly itemTypeDisplayName?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `itemState` */
  readonly item_state?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `itemType` */
  readonly item_type?: Maybe<Scalars['String']['output']>;
  readonly karmaCheckCaseServiceOrder?: Maybe<CaseServiceOrder>;
  readonly licenseTarget?: Maybe<License>;
  readonly licenseVerificationType?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `licenseTarget` */
  readonly license_target?: Maybe<License>;
  readonly liveAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly missingAllFiles?: Maybe<Scalars['Boolean']['output']>;
  readonly missingFilesUuids?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly needsToBeScheduled?: Maybe<Scalars['Boolean']['output']>;
  readonly nurseAssessmentTarget?: Maybe<NurseAssessment>;
  readonly nurseCertificationTarget?: Maybe<NurseCertification>;
  readonly nurseHealthDocTarget?: Maybe<NurseHealthDoc>;
  readonly nurseLicenseVerificationTarget?: Maybe<LicenseVerification>;
  /** @deprecated use `nurseAssessmentTarget` */
  readonly nurse_assessment_target?: Maybe<NurseAssessment>;
  /** @deprecated use `nurseCertificationTarget` */
  readonly nurse_certification_target?: Maybe<NurseCertification>;
  /** @deprecated use `nurseHealthDocTarget` */
  readonly nurse_health_doc_target?: Maybe<NurseHealthDoc>;
  /** @deprecated use `nurseLicenseVerificationTarget` */
  readonly nurse_license_verification_target?: Maybe<LicenseVerification>;
  readonly order?: Maybe<Scalars['Int']['output']>;
  readonly referenceTarget?: Maybe<Reference>;
  /** @deprecated use `referenceTarget` */
  readonly reference_target?: Maybe<Reference>;
  readonly rejectionReason?: Maybe<Scalars['String']['output']>;
  readonly relativeDueDate?: Maybe<Scalars['String']['output']>;
  readonly requirements: Scalars['JSON']['output'];
  readonly requiresVerification?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use `requiresVerification` */
  readonly requires_verification?: Maybe<Scalars['Boolean']['output']>;
  readonly schedulable: Scalars['Boolean']['output'];
  readonly target?: Maybe<TodoListItemTarget>;
  readonly targetArchivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly todoList: TodoList;
  readonly trackCompletionDate?: Maybe<Scalars['Boolean']['output']>;
  readonly uploadStatus?: Maybe<TodoListItemUploadStatusEnum>;
  readonly uuid?: Maybe<Scalars['String']['output']>;
  readonly verificationNotes?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `verificationNotes` */
  readonly verification_notes?: Maybe<Scalars['String']['output']>;
  readonly visibility?: Maybe<Scalars['String']['output']>;
}

/** Credential objects that a Todo::TodoListItem may be related to */
export type TodoListItemTarget = Document | EmploymentVerificationSubmission | License | NurseAssessment | NurseCertification | NurseHealthDoc | NurseLicenseVerification | Reference;

export const enum TodoListItemUploadStatusEnum {
  /** Not eligible */
  NotEligible = 'not_eligible',
  /** Not ready */
  NotReady = 'not_ready',
  /** Ready for upload */
  ReadyForUpload = 'ready_for_upload',
  /** Unable to upload */
  UnableToUpload = 'unable_to_upload',
  /** Uploaded to vms */
  UploadedToVms = 'uploaded_to_vms'
};

export const enum TodoListItemsFilter {
  ApprovedAfterCompletion = 'APPROVED_AFTER_COMPLETION',
  ExpiringBeforeContractEnd = 'EXPIRING_BEFORE_CONTRACT_END',
  External = 'EXTERNAL',
  Internal = 'INTERNAL',
  Live = 'LIVE',
  PendingVerification = 'PENDING_VERIFICATION'
};

export const enum TodoListOrderField {
  AdminName = 'ADMIN_NAME',
  CandidateName = 'CANDIDATE_NAME',
  CompletedTasksCount = 'COMPLETED_TASKS_COUNT',
  EndDate = 'END_DATE',
  FacilityName = 'FACILITY_NAME',
  Id = 'ID',
  MspName = 'MSP_NAME',
  OcDeadline = 'OC_DEADLINE',
  PendingTasksCount = 'PENDING_TASKS_COUNT',
  PercentageCompletedItems = 'PERCENTAGE_COMPLETED_ITEMS',
  StartDate = 'START_DATE',
  StateCode = 'STATE_CODE'
};

export interface TodoListOwner {
  readonly __typename?: 'TodoListOwner';
  readonly iconUrl?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
}

export interface TodoListSnapshot {
  readonly __typename?: 'TodoListSnapshot';
  readonly id: Scalars['ID']['output'];
  readonly todoList: TodoList;
}

/** Autogenerated return type of ToggleComplianceListItemArchived. */
export interface ToggleComplianceListItemArchivedPayload {
  readonly __typename?: 'ToggleComplianceListItemArchivedPayload';
  readonly complianceListItem: ComplianceListItem;
}

/** Autogenerated return type of ToggleOnboardingItemLive. */
export interface ToggleOnboardingItemLivePayload {
  readonly __typename?: 'ToggleOnboardingItemLivePayload';
  readonly todoList: TodoList;
  readonly todoListItem: TodoListItem;
}

/** Autogenerated return type of ToggleOnboardingListItemArchived. */
export interface ToggleOnboardingListItemArchivedPayload {
  readonly __typename?: 'ToggleOnboardingListItemArchivedPayload';
  readonly todoListItem: TodoListItem;
}

/** Autogenerated return type of TransitionPayrollStatus. */
export interface TransitionPayrollStatusPayload {
  readonly __typename?: 'TransitionPayrollStatusPayload';
  readonly payroll: Payroll;
}

export const enum TravelExperiences {
  /** Expert */
  Expert = 'EXPERT',
  /** Learner */
  Learner = 'LEARNER',
  /** Skeptical */
  Skeptical = 'SKEPTICAL'
};

/** Autogenerated return type of UnconfirmVmsReverseInvoiceItemContract. */
export interface UnconfirmVmsReverseInvoiceItemContractPayload {
  readonly __typename?: 'UnconfirmVmsReverseInvoiceItemContractPayload';
  readonly invoiceBalanceEntry: InvoiceBalanceEntry;
}

/** Autogenerated return type of UnlockTimeSheetEdit. */
export interface UnlockTimeSheetEditPayload {
  readonly __typename?: 'UnlockTimeSheetEditPayload';
  readonly editorUser?: Maybe<AdminUser>;
}

/** Autogenerated return type of UnmarkClearedByTrustedOnboardingList. */
export interface UnmarkClearedByTrustedOnboardingListPayload {
  readonly __typename?: 'UnmarkClearedByTrustedOnboardingListPayload';
  readonly todoList: TodoList;
}

/** Autogenerated return type of UnmarkFacilityClearedToTentativelyClearedOnboardingList. */
export interface UnmarkFacilityClearedToTentativelyClearedOnboardingListPayload {
  readonly __typename?: 'UnmarkFacilityClearedToTentativelyClearedOnboardingListPayload';
  readonly todoList: TodoList;
}

/** Autogenerated return type of UnmarkFacilityClearedToTrustedClearedOnboardingList. */
export interface UnmarkFacilityClearedToTrustedClearedOnboardingListPayload {
  readonly __typename?: 'UnmarkFacilityClearedToTrustedClearedOnboardingListPayload';
  readonly todoList: TodoList;
}

/** Autogenerated return type of UnmarkFdiSentOnboardingList. */
export interface UnmarkFdiSentOnboardingListPayload {
  readonly __typename?: 'UnmarkFdiSentOnboardingListPayload';
  readonly todoList: TodoList;
}

/** Autogenerated return type of UnmarkTentativelyClearedOnboardingList. */
export interface UnmarkTentativelyClearedOnboardingListPayload {
  readonly __typename?: 'UnmarkTentativelyClearedOnboardingListPayload';
  readonly todoList: TodoList;
}

/** Autogenerated return type of UnpublishOnboardingList. */
export interface UnpublishOnboardingListPayload {
  readonly __typename?: 'UnpublishOnboardingListPayload';
  readonly todoList: TodoList;
}

export interface UnsubmittedPayroll {
  readonly __typename?: 'UnsubmittedPayroll';
  readonly candidate: NurseProfile;
  readonly contract?: Maybe<Contract>;
  readonly shifts?: Maybe<ReadonlyArray<Shift>>;
}

/** The connection type for UnsubmittedPayroll. */
export interface UnsubmittedPayrollConnection {
  readonly __typename?: 'UnsubmittedPayrollConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<UnsubmittedPayrollEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<UnsubmittedPayroll>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface UnsubmittedPayrollEdge {
  readonly __typename?: 'UnsubmittedPayrollEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<UnsubmittedPayroll>;
}

/** Autogenerated return type of UnverifyCredential. */
export interface UnverifyCredentialPayload {
  readonly __typename?: 'UnverifyCredentialPayload';
  readonly credential?: Maybe<Credential>;
  readonly errors?: Maybe<ReadonlyArray<BasicErrorsUnion>>;
}

export interface UpdateAboutMeInput {
  readonly birthday: Scalars['ISO8601Date']['input'];
  readonly firstName: Scalars['String']['input'];
  readonly fullSsn?: InputMaybe<Scalars['String']['input']>;
  readonly lastName: Scalars['String']['input'];
  readonly middleName?: InputMaybe<Scalars['String']['input']>;
  readonly permanentAddress: UpdateAboutMePermanentAddressInput;
  readonly phone: Scalars['String']['input'];
  readonly preferredName?: InputMaybe<Scalars['String']['input']>;
  readonly preferredPronoun?: InputMaybe<Scalars['String']['input']>;
  readonly roleId: Scalars['ID']['input'];
  readonly specialtySlug: Scalars['ID']['input'];
  readonly yearsOfExp: Scalars['Int']['input'];
  readonly yearsOfTravelExp: Scalars['Int']['input'];
}

/** Autogenerated return type of UpdateAboutMe. */
export interface UpdateAboutMePayload {
  readonly __typename?: 'UpdateAboutMePayload';
  readonly nurseProfile: NurseProfile;
  readonly profileCompletionSummary: ProfileCompletionSummary;
  readonly user: User;
}

export interface UpdateAboutMePermanentAddressInput {
  readonly city: Scalars['String']['input'];
  readonly countryCode?: InputMaybe<CountryPermanentEnum>;
  readonly googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  readonly state: Scalars['String']['input'];
  readonly streetAddress: Scalars['String']['input'];
  readonly streetNumber?: InputMaybe<Scalars['String']['input']>;
  readonly zipcode: Scalars['String']['input'];
}

/** Autogenerated return type of UpdateAdminNote. */
export interface UpdateAdminNotePayload {
  readonly __typename?: 'UpdateAdminNotePayload';
  readonly payroll?: Maybe<Payroll>;
}

export interface UpdateAffiliationHistoryInput {
  readonly descriptions?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly endDate?: InputMaybe<Scalars['String']['input']>;
  readonly organizationName: Scalars['String']['input'];
  readonly role: Scalars['String']['input'];
  readonly startDate: Scalars['String']['input'];
}

/** Autogenerated return type of UpdateAffiliationHistory. */
export interface UpdateAffiliationHistoryPayload {
  readonly __typename?: 'UpdateAffiliationHistoryPayload';
  readonly affiliationHistory: Affiliation;
  readonly nurseProfile: NurseProfile;
}

export interface UpdateAssessmentOnboardingItemInput {
  readonly actionLinksAttributes?: InputMaybe<ReadonlyArray<ActionLinkTypeInput>>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly internalOnly: Scalars['Boolean']['input'];
  readonly name: Scalars['String']['input'];
  readonly requiresVerification?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Autogenerated return type of UpdateAssessmentOnboardingItem. */
export interface UpdateAssessmentOnboardingItemPayload {
  readonly __typename?: 'UpdateAssessmentOnboardingItemPayload';
  readonly todoList: TodoList;
  readonly todoListItem: TodoListItem;
}

export interface UpdateAwardInput {
  readonly awardedOn?: InputMaybe<Scalars['String']['input']>;
  readonly descriptions?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly name: Scalars['String']['input'];
  readonly organization: Scalars['String']['input'];
}

/** Autogenerated return type of UpdateAward. */
export interface UpdateAwardPayload {
  readonly __typename?: 'UpdateAwardPayload';
  readonly nurseProfile: NurseProfile;
}

export interface UpdateCeuCertificateInput {
  readonly ceuCertificateType: CeuCertificateType;
  readonly completionDate: Scalars['ISO8601Date']['input'];
  readonly contactHours: Scalars['Float']['input'];
  readonly name: Scalars['String']['input'];
  readonly providerNumber: Scalars['String']['input'];
}

/** Autogenerated return type of UpdateCeuCertificate. */
export interface UpdateCeuCertificatePayload {
  readonly __typename?: 'UpdateCeuCertificatePayload';
  readonly ceuCertificate: CeuCertificate;
  readonly nurseProfile: NurseProfile;
}

export interface UpdateCeuGoalInput {
  readonly accepted?: InputMaybe<Scalars['Boolean']['input']>;
  readonly certificateUuids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly ceuStateRequirementId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly requiredContactHours?: InputMaybe<Scalars['Float']['input']>;
  readonly startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
}

/** Autogenerated return type of UpdateCeuGoal. */
export interface UpdateCeuGoalPayload {
  readonly __typename?: 'UpdateCeuGoalPayload';
  readonly ceuGoal: CeuGoal;
}

/** Autogenerated return type of UpdateClickIds. */
export interface UpdateClickIdsPayload {
  readonly __typename?: 'UpdateClickIdsPayload';
  readonly ok: Scalars['Boolean']['output'];
}

export interface UpdateComplianceChecklistInput {
  readonly checklistFile?: InputMaybe<Scalars['Upload']['input']>;
  readonly effectiveDate: Scalars['ISO8601Date']['input'];
}

/** Autogenerated return type of UpdateComplianceChecklist. */
export interface UpdateComplianceChecklistPayload {
  readonly __typename?: 'UpdateComplianceChecklistPayload';
  readonly complianceChecklist: ComplianceChecklist;
}

/** Autogenerated return type of UpdateComplianceItemTarget. */
export interface UpdateComplianceItemTargetPayload {
  readonly __typename?: 'UpdateComplianceItemTargetPayload';
  readonly complianceListItem: ComplianceListItem;
}

export interface UpdateComplianceListInput {
  readonly internalNotes?: InputMaybe<Scalars['String']['input']>;
  readonly ownerId?: InputMaybe<Scalars['ID']['input']>;
}

export interface UpdateComplianceListItemInput {
  readonly actionLinks?: InputMaybe<ReadonlyArray<ActionLinkTypeInput>>;
  readonly completedOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly expirationType?: InputMaybe<DocumentExpiration>;
  readonly expiresOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly internalNotes?: InputMaybe<Scalars['String']['input']>;
  readonly licenseUuid?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly outreach?: InputMaybe<Scalars['String']['input']>;
  readonly requiresVerification?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Autogenerated return type of UpdateComplianceListItem. */
export interface UpdateComplianceListItemPayload {
  readonly __typename?: 'UpdateComplianceListItemPayload';
  readonly complianceListItem: ComplianceListItem;
}

/** Autogenerated return type of UpdateComplianceList. */
export interface UpdateComplianceListPayload {
  readonly __typename?: 'UpdateComplianceListPayload';
  readonly complianceList: ComplianceList;
}

/** Autogenerated return type of UpdateContractBonus. */
export interface UpdateContractBonusPayload {
  readonly __typename?: 'UpdateContractBonusPayload';
  readonly contractBonus: ContractBonus;
}

/** Autogenerated return type of UpdateContractBonusStatus. */
export interface UpdateContractBonusStatusPayload {
  readonly __typename?: 'UpdateContractBonusStatusPayload';
  readonly contractBonus: ContractBonus;
}

export interface UpdateDocumentInput {
  readonly completedOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly docType?: InputMaybe<Scalars['String']['input']>;
  readonly expiresOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly title?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateDocumentOnboardingItemInput {
  readonly actionLinksAttributes?: InputMaybe<ReadonlyArray<ActionLinkTypeInput>>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly docSubtype?: InputMaybe<Scalars['String']['input']>;
  readonly internalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name: Scalars['String']['input'];
  readonly requiresVerification?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Autogenerated return type of UpdateDocumentOnboardingItem. */
export interface UpdateDocumentOnboardingItemPayload {
  readonly __typename?: 'UpdateDocumentOnboardingItemPayload';
  readonly todoList: TodoList;
  readonly todoListItem: TodoListItem;
}

/** Autogenerated return type of UpdateDocument. */
export interface UpdateDocumentPayload {
  readonly __typename?: 'UpdateDocumentPayload';
  readonly document?: Maybe<Document>;
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
}

export interface UpdateEducationInput {
  readonly degree: EducationDegreeTypes;
  readonly descriptions?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly gapEndOn?: InputMaybe<Scalars['String']['input']>;
  readonly gapExplanation?: InputMaybe<Scalars['String']['input']>;
  readonly gapGooglePlaceId?: InputMaybe<Scalars['String']['input']>;
  readonly gapReason?: InputMaybe<GapReasons>;
  readonly gapStartOn?: InputMaybe<Scalars['String']['input']>;
  readonly googlePlaceId: Scalars['String']['input'];
  readonly gpa?: InputMaybe<Scalars['Float']['input']>;
  readonly graduatedOn: Scalars['String']['input'];
  readonly hasGap?: InputMaybe<Scalars['Boolean']['input']>;
  readonly major?: InputMaybe<Scalars['String']['input']>;
  readonly minor?: InputMaybe<Scalars['String']['input']>;
  readonly schoolName: Scalars['String']['input'];
  readonly startedOn: Scalars['String']['input'];
}

/** Autogenerated return type of UpdateEducation. */
export interface UpdateEducationPayload {
  readonly __typename?: 'UpdateEducationPayload';
  readonly nurseProfile: NurseProfile;
}

export interface UpdateEmploymentEmploymentInput {
  readonly bedCount?: InputMaybe<Scalars['Int']['input']>;
  readonly employerType: Scalars['String']['input'];
  readonly endAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly facilityAddress?: InputMaybe<Scalars['String']['input']>;
  readonly facilityLocationString?: InputMaybe<Scalars['String']['input']>;
  readonly facilityName: Scalars['String']['input'];
  readonly googlePlaceId: Scalars['String']['input'];
  readonly magnet?: InputMaybe<Scalars['Boolean']['input']>;
  readonly positions: ReadonlyArray<UpdateEmploymentEmploymentPositionInput>;
  readonly startAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly teaching?: InputMaybe<Scalars['Boolean']['input']>;
  readonly trauma?: InputMaybe<Scalars['Boolean']['input']>;
  readonly traumaLevel?: InputMaybe<Scalars['Int']['input']>;
}

export interface UpdateEmploymentEmploymentPositionAgencyInput {
  readonly id: Scalars['ID']['input'];
}

export interface UpdateEmploymentEmploymentPositionInput {
  readonly agency?: InputMaybe<UpdateEmploymentEmploymentPositionAgencyInput>;
  readonly bedCountInUnit?: InputMaybe<Scalars['Int']['input']>;
  readonly chargeExp?: InputMaybe<Scalars['Boolean']['input']>;
  readonly descriptions?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly duration?: InputMaybe<Scalars['String']['input']>;
  readonly employmentType: Scalars['String']['input'];
  readonly endAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly hoursWorked?: InputMaybe<Scalars['Int']['input']>;
  readonly hoursWorkedTimeframe?: InputMaybe<HoursWorkedTimeframe>;
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly nicuTraumaLevel?: InputMaybe<Scalars['Int']['input']>;
  readonly patientsPerNurse?: InputMaybe<Scalars['Int']['input']>;
  readonly specialties: ReadonlyArray<UpdateEmploymentEmploymentPositionNurseSpecialtyInput>;
  readonly startAt: Scalars['ISO8601Date']['input'];
  readonly technologies: ReadonlyArray<UpdateEmploymentEmploymentPositionTechnologyInput>;
  readonly title: Scalars['String']['input'];
  readonly unit: Scalars['String']['input'];
}

export interface UpdateEmploymentEmploymentPositionNurseSpecialtyInput {
  readonly id: Scalars['ID']['input'];
}

export interface UpdateEmploymentEmploymentPositionTechnologyInput {
  readonly id: Scalars['ID']['input'];
}

export interface UpdateEmploymentGapEmploymentInput {
  readonly gapExplanation?: InputMaybe<Scalars['String']['input']>;
  readonly gapGooglePlaceId: Scalars['String']['input'];
  readonly gapReason: Scalars['String']['input'];
}

/** Autogenerated return type of UpdateEmploymentGap. */
export interface UpdateEmploymentGapPayload {
  readonly __typename?: 'UpdateEmploymentGapPayload';
  readonly nurseProfile: NurseProfile;
}

/** Autogenerated return type of UpdateEmployment. */
export interface UpdateEmploymentPayload {
  readonly __typename?: 'UpdateEmploymentPayload';
  readonly employment: Employment;
  readonly nurseProfile: NurseProfile;
}

export interface UpdateExtensionRequestInput {
  readonly action: ExtensionRequestUpdateAction;
}

/** Autogenerated return type of UpdateExtensionRequest. */
export interface UpdateExtensionRequestPayload {
  readonly __typename?: 'UpdateExtensionRequestPayload';
  readonly jobPlacement: JobPlacement;
}

/** Autogenerated return type of UpdateExternalIdentifier. */
export interface UpdateExternalIdentifierPayload {
  readonly __typename?: 'UpdateExternalIdentifierPayload';
  readonly externalIdentifier: ExternalIdentifier;
}

export interface UpdateHealthDocOnboardingItemInput {
  readonly actionLinksAttributes?: InputMaybe<ReadonlyArray<ActionLinkTypeInput>>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly requiresVerification?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Autogenerated return type of UpdateHealthDocOnboardingItem. */
export interface UpdateHealthDocOnboardingItemPayload {
  readonly __typename?: 'UpdateHealthDocOnboardingItemPayload';
  readonly todoList: TodoList;
  readonly todoListItem: TodoListItem;
}

export interface UpdateIdentificationDocumentInput {
  readonly completedOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly docSubtype?: InputMaybe<Scalars['String']['input']>;
  readonly docType: Scalars['String']['input'];
  readonly expiresOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly stateCode?: InputMaybe<Scalars['String']['input']>;
  readonly title?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of UpdateIdentificationDocument. */
export interface UpdateIdentificationDocumentPayload {
  readonly __typename?: 'UpdateIdentificationDocumentPayload';
  readonly document?: Maybe<Document>;
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
  readonly nurseProfile?: Maybe<NurseProfile>;
}

/** Autogenerated return type of UpdateInvoice. */
export interface UpdateInvoicePayload {
  readonly __typename?: 'UpdateInvoicePayload';
  readonly invoice: Invoice;
}

export interface UpdateJobAlertInput {
  readonly broadPrefLocations?: InputMaybe<ReadonlyArray<BroadPrefLocations>>;
  readonly contractLengths?: InputMaybe<ReadonlyArray<ContractLength>>;
  readonly locationStrings?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly shiftLengths?: InputMaybe<ReadonlyArray<ShiftLength>>;
  readonly shiftPrefs?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly specialtySlugs?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}

/** Autogenerated return type of UpdateJobAlert. */
export interface UpdateJobAlertPayload {
  readonly __typename?: 'UpdateJobAlertPayload';
  readonly nurseProfile: NurseProfile;
}

export interface UpdateLicenseInput {
  readonly compact?: InputMaybe<Scalars['Boolean']['input']>;
  readonly completedOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly expiresOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly licenseType?: InputMaybe<AlliedHealthNursingLicenseType>;
  readonly licensureCompact?: InputMaybe<LicensureCompact>;
  readonly number?: InputMaybe<Scalars['String']['input']>;
  readonly stateCode?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateLicenseOnboardingItemInput {
  readonly actionLinksAttributes?: InputMaybe<ReadonlyArray<ActionLinkTypeInput>>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly requiresVerification?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Autogenerated return type of UpdateLicenseOnboardingItem. */
export interface UpdateLicenseOnboardingItemPayload {
  readonly __typename?: 'UpdateLicenseOnboardingItemPayload';
  readonly nurseProfile: NurseProfile;
  readonly todoList: TodoList;
  readonly todoListItem: TodoListItem;
}

/** Autogenerated return type of UpdateLicense. */
export interface UpdateLicensePayload {
  readonly __typename?: 'UpdateLicensePayload';
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
  readonly license?: Maybe<License>;
  readonly nurseProfile?: Maybe<NurseProfile>;
}

export interface UpdateLicenseVerificationInput {
  readonly dateOfDownload?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly expiresOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly stateCode?: InputMaybe<Scalars['String']['input']>;
  readonly stateCodes?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly verificationType: LicenseVerificationType;
}

/** Autogenerated return type of UpdateLicenseVerification. */
export interface UpdateLicenseVerificationPayload {
  readonly __typename?: 'UpdateLicenseVerificationPayload';
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
  readonly licenseVerification?: Maybe<LicenseVerification>;
  readonly nurseProfile?: Maybe<NurseProfile>;
}

export interface UpdateNurseAssessmentInput {
  readonly assessmentId?: InputMaybe<Scalars['ID']['input']>;
  readonly completedOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly expiresOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly score?: InputMaybe<Scalars['Float']['input']>;
}

/** Autogenerated return type of UpdateNurseAssessment. */
export interface UpdateNurseAssessmentPayload {
  readonly __typename?: 'UpdateNurseAssessmentPayload';
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
  readonly nurseAssessment?: Maybe<NurseAssessment>;
  readonly nurseProfile?: Maybe<NurseProfile>;
}

export interface UpdateNurseCertificationInput {
  readonly completedOn?: InputMaybe<Scalars['String']['input']>;
  readonly expiresOn?: InputMaybe<Scalars['String']['input']>;
  readonly fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly issuingBody?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of UpdateNurseCertification. */
export interface UpdateNurseCertificationPayload {
  readonly __typename?: 'UpdateNurseCertificationPayload';
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
  readonly nurseProfile?: Maybe<NurseProfile>;
}

export interface UpdateNurseHealthDocInput {
  readonly category?: InputMaybe<Scalars['String']['input']>;
  readonly completedOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly expiresOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
}

/** Autogenerated return type of UpdateNurseHealthDoc. */
export interface UpdateNurseHealthDocPayload {
  readonly __typename?: 'UpdateNurseHealthDocPayload';
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
  readonly nurseHealthDoc?: Maybe<NurseHealthDoc>;
  readonly nurseProfile?: Maybe<NurseProfile>;
}

/** Autogenerated return type of UpdateNurseHealthDocVaccination. */
export interface UpdateNurseHealthDocVaccinationPayload {
  readonly __typename?: 'UpdateNurseHealthDocVaccinationPayload';
  readonly errors?: Maybe<ReadonlyArray<BasicErrorsUnion>>;
  readonly nurseHealthDoc?: Maybe<NurseHealthDoc>;
  readonly nurseProfile?: Maybe<NurseProfile>;
}

/** Autogenerated return type of UpdateNurseNote. */
export interface UpdateNurseNotePayload {
  readonly __typename?: 'UpdateNurseNotePayload';
  readonly payroll?: Maybe<Payroll>;
}

/** Autogenerated return type of UpdateNurse. */
export interface UpdateNursePayload {
  readonly __typename?: 'UpdateNursePayload';
  readonly nurseProfile: NurseProfile;
  readonly user: User;
}

export interface UpdateNursePreferencesInput {
  readonly broadPrefLocations?: InputMaybe<ReadonlyArray<BroadPrefLocations>>;
  readonly careSettingOther?: InputMaybe<Scalars['String']['input']>;
  readonly careSettingPrefs?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly clinicalUnitSlugs?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly coastLocations?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly contractLengths?: InputMaybe<ReadonlyArray<ContractLength>>;
  readonly earliestStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly explorerRole?: InputMaybe<Scalars['String']['input']>;
  readonly firstTimeTravelerFriendly?: InputMaybe<Scalars['Boolean']['input']>;
  readonly ignoredSpecialties?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly importantDestinationPrefs?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly importantJobAttribute?: InputMaybe<Scalars['String']['input']>;
  readonly importantJobAttributeOther?: InputMaybe<Scalars['String']['input']>;
  readonly jobSortColumn?: InputMaybe<JobsCollectionSortField>;
  readonly jobSortOrder?: InputMaybe<JobsCollectionSortOrder>;
  readonly jobTypes?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly learningPrefs?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly locationStrings?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly magnetPref?: InputMaybe<Scalars['String']['input']>;
  readonly notificationPref?: InputMaybe<Scalars['String']['input']>;
  readonly seenStatus?: InputMaybe<Scalars['String']['input']>;
  readonly shiftLengths?: InputMaybe<ReadonlyArray<ShiftLength>>;
  readonly shiftPref?: InputMaybe<Scalars['String']['input']>;
  readonly shiftPrefs?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly specialRequirements?: InputMaybe<Scalars['String']['input']>;
  readonly specificLocationFlexible?: InputMaybe<Scalars['Boolean']['input']>;
  readonly startPref?: InputMaybe<Scalars['String']['input']>;
  readonly technologies?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly travelExperience?: InputMaybe<TravelExperiences>;
}

/** Autogenerated return type of UpdateNursePreferences. */
export interface UpdateNursePreferencesPayload {
  readonly __typename?: 'UpdateNursePreferencesPayload';
  readonly nursePreferences?: Maybe<NursePreferences>;
  readonly nurseProfile?: Maybe<NurseProfile>;
}

export interface UpdateNurseProfileInput {
  readonly applicationSummary?: InputMaybe<Scalars['String']['input']>;
  readonly birthday?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly clinicalExperienceLevel?: InputMaybe<ClinicalExperienceLevelTypes>;
  readonly clinicalSpecialtyIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly locationString?: InputMaybe<Scalars['String']['input']>;
  readonly lookingFor?: InputMaybe<Scalars['String']['input']>;
  readonly ssnLast4?: InputMaybe<Scalars['String']['input']>;
  readonly wizardCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  readonly yearsOfExp?: InputMaybe<Scalars['Int']['input']>;
  readonly yearsOfTravelExp?: InputMaybe<Scalars['Int']['input']>;
}

/** Autogenerated return type of UpdateNurseProfile. */
export interface UpdateNurseProfilePayload {
  readonly __typename?: 'UpdateNurseProfilePayload';
  readonly nurseProfile: NurseProfile;
}

/** Autogenerated return type of UpdateNurseRole. */
export interface UpdateNurseRolePayload {
  readonly __typename?: 'UpdateNurseRolePayload';
  readonly nurseProfile: NurseProfile;
  readonly user: User;
}

/** Autogenerated return type of UpdateOnboardingItemDateField. */
export interface UpdateOnboardingItemDateFieldPayload {
  readonly __typename?: 'UpdateOnboardingItemDateFieldPayload';
  readonly todoList: TodoList;
  readonly todoListItem: TodoListItem;
}

export interface UpdateOnboardingItemInput {
  readonly actionLinksAttributes?: InputMaybe<ReadonlyArray<ActionLinkTypeInput>>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly internalOnly: Scalars['Boolean']['input'];
  readonly name: Scalars['String']['input'];
  readonly requiresVerification?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Autogenerated return type of UpdateOnboardingItemInternalNotes. */
export interface UpdateOnboardingItemInternalNotesPayload {
  readonly __typename?: 'UpdateOnboardingItemInternalNotesPayload';
  readonly todoList: TodoList;
  readonly todoListItem: TodoListItem;
}

/** Autogenerated return type of UpdateOnboardingItem. */
export interface UpdateOnboardingItemPayload {
  readonly __typename?: 'UpdateOnboardingItemPayload';
  readonly todoList: TodoList;
  readonly todoListItem: TodoListItem;
}

/** Autogenerated return type of UpdateOnboardingItemTarget. */
export interface UpdateOnboardingItemTargetPayload {
  readonly __typename?: 'UpdateOnboardingItemTargetPayload';
  readonly todoListItem: TodoListItem;
}

/** Autogenerated return type of UpdateOnboardingItemUploadStatus. */
export interface UpdateOnboardingItemUploadStatusPayload {
  readonly __typename?: 'UpdateOnboardingItemUploadStatusPayload';
  readonly todoList: TodoList;
  readonly todoListItem: TodoListItem;
}

/** Autogenerated return type of UpdateOnboardingItemsDueDate. */
export interface UpdateOnboardingItemsDueDatePayload {
  readonly __typename?: 'UpdateOnboardingItemsDueDatePayload';
  readonly todoList: TodoList;
  readonly todoListItems: ReadonlyArray<TodoListItem>;
}

/** Autogenerated return type of UpdateOnboardingItemsRelativeDueDate. */
export interface UpdateOnboardingItemsRelativeDueDatePayload {
  readonly __typename?: 'UpdateOnboardingItemsRelativeDueDatePayload';
  readonly todoList: TodoList;
  readonly todoListItems: ReadonlyArray<TodoListItem>;
}

export interface UpdateOnboardingListInput {
  readonly hardDeadline?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly onboardingNote?: InputMaybe<Scalars['String']['input']>;
  readonly ownerId?: InputMaybe<Scalars['ID']['input']>;
}

/** Autogenerated return type of UpdateOnboardingList. */
export interface UpdateOnboardingListPayload {
  readonly __typename?: 'UpdateOnboardingListPayload';
  readonly todoList: TodoList;
}

/** Autogenerated return type of UpdateOnboardingNeedsToBeScheduled. */
export interface UpdateOnboardingNeedsToBeScheduledPayload {
  readonly __typename?: 'UpdateOnboardingNeedsToBeScheduledPayload';
  readonly todoListItem: TodoListItem;
}

/** Autogenerated return type of UpdatePayrollAccruals. */
export interface UpdatePayrollAccrualsPayload {
  readonly __typename?: 'UpdatePayrollAccrualsPayload';
  readonly payroll?: Maybe<Payroll>;
}

/** Autogenerated return type of UpdatePayrollCorrectionRate. */
export interface UpdatePayrollCorrectionRatePayload {
  readonly __typename?: 'UpdatePayrollCorrectionRatePayload';
  readonly payroll: Payroll;
  readonly payrollCorrectionRates?: Maybe<PayRateConfig>;
}

/** Autogenerated return type of UpdatePayrollStatus. */
export interface UpdatePayrollStatusPayload {
  readonly __typename?: 'UpdatePayrollStatusPayload';
  readonly payroll: Payroll;
}

/** Autogenerated return type of UpdatePayrollTags. */
export interface UpdatePayrollTagsPayload {
  readonly __typename?: 'UpdatePayrollTagsPayload';
  readonly tags: ReadonlyArray<PayrollTag>;
}

/** Autogenerated return type of UpdateProfilePhoto. */
export interface UpdateProfilePhotoPayload {
  readonly __typename?: 'UpdateProfilePhotoPayload';
  readonly user: User;
}

/** Autogenerated return type of UpdateProfilePrimarySpecialty. */
export interface UpdateProfilePrimarySpecialtyPayload {
  readonly __typename?: 'UpdateProfilePrimarySpecialtyPayload';
  readonly nurseProfile: NurseProfile;
}

export interface UpdateRecommendationInput {
  readonly dateCompleted: Scalars['ISO8601Date']['input'];
  readonly email: Scalars['String']['input'];
  readonly fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly phoneNumber: Scalars['String']['input'];
  readonly placeOfEmployment: Scalars['String']['input'];
  readonly recommenderName: Scalars['String']['input'];
  readonly recommenderPosition: Scalars['String']['input'];
  readonly relationship: RecommenderRelationship;
}

/** Autogenerated return type of UpdateRecommendation. */
export interface UpdateRecommendationPayload {
  readonly __typename?: 'UpdateRecommendationPayload';
  readonly nurseProfile: NurseProfile;
  readonly recommendation: Recommendation;
}

export interface UpdateReferenceOnboardingItemInput {
  readonly actionLinksAttributes?: InputMaybe<ReadonlyArray<ActionLinkTypeInput>>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly requiresVerification?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Autogenerated return type of UpdateReferenceOnboardingItem. */
export interface UpdateReferenceOnboardingItemPayload {
  readonly __typename?: 'UpdateReferenceOnboardingItemPayload';
  readonly nurseProfile: NurseProfile;
  readonly todoList: TodoList;
  readonly todoListItem: TodoListItem;
}

export interface UpdateResearchInput {
  readonly descriptions: ReadonlyArray<Scalars['String']['input']>;
  readonly endOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly googlePlaceId: Scalars['String']['input'];
  readonly orgName: Scalars['String']['input'];
  readonly startOn: Scalars['ISO8601Date']['input'];
}

/** Autogenerated return type of UpdateResearch. */
export interface UpdateResearchPayload {
  readonly __typename?: 'UpdateResearchPayload';
  readonly nurseProfile: NurseProfile;
}

export interface UpdateResidencyProgramInput {
  readonly accredited: Scalars['Boolean']['input'];
  readonly accreditingBody?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly offersAllSpecialties?: InputMaybe<Scalars['Boolean']['input']>;
  readonly url?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of UpdateResidencyProgram. */
export interface UpdateResidencyProgramPayload {
  readonly __typename?: 'UpdateResidencyProgramPayload';
  readonly residencyProgram: ResidencyProgram;
}

/** Autogenerated return type of UpdateResumeParserStep. */
export interface UpdateResumeParserStepPayload {
  readonly __typename?: 'UpdateResumeParserStepPayload';
  readonly uploadedResume: UploadedResume;
}

export interface UpdateSavedSearchInput {
  readonly broadPrefLocations?: InputMaybe<ReadonlyArray<BroadPrefLocations>>;
  readonly contractLengths?: InputMaybe<ReadonlyArray<ContractLength>>;
  readonly locationStrings?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly shiftLengths?: InputMaybe<ReadonlyArray<ShiftLength>>;
  readonly shiftPrefs?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly specialtySlugs?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}

/** Autogenerated return type of UpdateSavedSearch. */
export interface UpdateSavedSearchPayload {
  readonly __typename?: 'UpdateSavedSearchPayload';
  readonly nurseProfile: NurseProfile;
}

export interface UpdateSearchHistoryEntryInput {
  readonly searchParams: Scalars['String']['input'];
}

/** Autogenerated return type of UpdateSearchHistoryEntry. */
export interface UpdateSearchHistoryEntryPayload {
  readonly __typename?: 'UpdateSearchHistoryEntryPayload';
  readonly nurseProfile: NurseProfile;
  readonly searchHistory: SearchHistory;
}

export interface UpdateStaleIntentInput {
  readonly availableOnDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly earliestStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly intent?: InputMaybe<IntentEnum>;
  readonly startPref?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of UpdateStaleIntent. */
export interface UpdateStaleIntentPayload {
  readonly __typename?: 'UpdateStaleIntentPayload';
  readonly activationRequest?: Maybe<ActivationRequest>;
  readonly nursePreferences?: Maybe<NursePreferences>;
  readonly nurseProfile?: Maybe<NurseProfile>;
}

/** Autogenerated return type of UpdateStaleNurseProfile. */
export interface UpdateStaleNurseProfilePayload {
  readonly __typename?: 'UpdateStaleNurseProfilePayload';
  readonly nurseProfile: NurseProfile;
}

export interface UpdateStudentClinicalExperienceExperienceInput {
  readonly descriptions?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly experienceType: StudentExperienceTypes;
  readonly experienceYear: Scalars['Int']['input'];
  readonly experienceYearTerm: YearTerms;
  readonly facilityName: Scalars['String']['input'];
  readonly facilityType: FacilityTypes;
  readonly locationString: Scalars['String']['input'];
  readonly units?: InputMaybe<ReadonlyArray<UpdateStudentClinicalExperienceExperienceUnitInput>>;
}

export interface UpdateStudentClinicalExperienceExperienceUnitInput {
  readonly descriptions?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly hoursWorked: Scalars['Int']['input'];
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly name: Scalars['String']['input'];
}

export interface UpdateStudentClinicalExperienceInput {
  readonly experience: UpdateStudentClinicalExperienceExperienceInput;
}

/** Autogenerated return type of UpdateStudentClinicalExperience. */
export interface UpdateStudentClinicalExperiencePayload {
  readonly __typename?: 'UpdateStudentClinicalExperiencePayload';
  readonly nurseProfile?: Maybe<NurseProfile>;
  readonly studentClinicalExperience?: Maybe<StudentClinicalExperience>;
}

export interface UpdateStudentClinicalExperienceUnitInput {
  readonly unit: UpdateStudentClinicalExperienceUnitUnitInput;
}

/** Autogenerated return type of UpdateStudentClinicalExperienceUnit. */
export interface UpdateStudentClinicalExperienceUnitPayload {
  readonly __typename?: 'UpdateStudentClinicalExperienceUnitPayload';
  readonly nurseProfile?: Maybe<NurseProfile>;
  readonly studentClinicalExperienceUnit?: Maybe<StudentClinicalExperienceUnit>;
}

export interface UpdateStudentClinicalExperienceUnitUnitInput {
  readonly descriptions?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly hoursWorked: Scalars['Int']['input'];
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly name: Scalars['String']['input'];
}

export interface UpdateTimeEntryInput {
  readonly calculatePayroll?: InputMaybe<Scalars['Boolean']['input']>;
  readonly candidateId: Scalars['ID']['input'];
  readonly duration?: InputMaybe<Scalars['Float']['input']>;
  readonly endDatetime?: InputMaybe<Scalars['String']['input']>;
  readonly entryType: Scalars['String']['input'];
  readonly jobPlacementScheduleUuid?: InputMaybe<Scalars['ID']['input']>;
  readonly payrollId?: InputMaybe<Scalars['ID']['input']>;
  readonly shiftDate?: InputMaybe<Scalars['String']['input']>;
  readonly shiftId?: InputMaybe<Scalars['ID']['input']>;
  readonly startDatetime?: InputMaybe<Scalars['String']['input']>;
  readonly timeEntryId?: InputMaybe<Scalars['ID']['input']>;
}

/** Autogenerated return type of UpdateTimeEntry. */
export interface UpdateTimeEntryPayload {
  readonly __typename?: 'UpdateTimeEntryPayload';
  readonly payroll?: Maybe<Payroll>;
  readonly shift: Shift;
}

export interface UpdateTodoListItemDocumentTargetInput {
  readonly completedOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly docSubtype?: InputMaybe<Scalars['String']['input']>;
  readonly docType: Scalars['String']['input'];
  readonly expiresOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly stateCode?: InputMaybe<Scalars['String']['input']>;
  readonly title: Scalars['String']['input'];
}

/** Autogenerated return type of UpdateTodoListItemDocumentTarget. */
export interface UpdateTodoListItemDocumentTargetPayload {
  readonly __typename?: 'UpdateTodoListItemDocumentTargetPayload';
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
  readonly todoListItem?: Maybe<TodoListItem>;
}

export interface UpdateTodoListItemNurseAssessmentTargetInput {
  readonly assessmentId: Scalars['ID']['input'];
  readonly completedOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly score?: InputMaybe<Scalars['Float']['input']>;
}

/** Autogenerated return type of UpdateTodoListItemNurseAssessmentTarget. */
export interface UpdateTodoListItemNurseAssessmentTargetPayload {
  readonly __typename?: 'UpdateTodoListItemNurseAssessmentTargetPayload';
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
  readonly todoListItem?: Maybe<TodoListItem>;
}

export interface UpdateTodoListItemNurseCertificationInput {
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly issuingBody?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateTodoListItemNurseCertificationTargetInput {
  readonly completedOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly expiresOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly issuingBody?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of UpdateTodoListItemNurseCertificationTarget. */
export interface UpdateTodoListItemNurseCertificationTargetPayload {
  readonly __typename?: 'UpdateTodoListItemNurseCertificationTargetPayload';
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
  readonly todoListItem?: Maybe<TodoListItem>;
}

export interface UpdateTodoListItemNurseHealthDocTargetInput {
  readonly category?: InputMaybe<Scalars['String']['input']>;
  readonly completedOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly healthDocId: Scalars['ID']['input'];
}

/** Autogenerated return type of UpdateTodoListItemNurseHealthDocTarget. */
export interface UpdateTodoListItemNurseHealthDocTargetPayload {
  readonly __typename?: 'UpdateTodoListItemNurseHealthDocTargetPayload';
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
  readonly todoListItem?: Maybe<TodoListItem>;
}

export interface UpdateVerificationOfEmploymentOnboardingItemInput {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of UpdateVerificationOfEmploymentOnboardingItem. */
export interface UpdateVerificationOfEmploymentOnboardingItemPayload {
  readonly __typename?: 'UpdateVerificationOfEmploymentOnboardingItemPayload';
  readonly todoListItem: TodoListItem;
}

export interface UploadComplianceListItemFileInput {
  readonly file?: InputMaybe<Scalars['Upload']['input']>;
  readonly id: Scalars['ID']['input'];
}

/** Autogenerated return type of UploadComplianceListItemFile. */
export interface UploadComplianceListItemFilePayload {
  readonly __typename?: 'UploadComplianceListItemFilePayload';
  readonly complianceListItem: ComplianceListItem;
}

export interface UploadInvoiceFileInput {
  readonly file?: InputMaybe<Scalars['Upload']['input']>;
  readonly id: Scalars['ID']['input'];
}

/** Autogenerated return type of UploadInvoiceFile. */
export interface UploadInvoiceFilePayload {
  readonly __typename?: 'UploadInvoiceFilePayload';
  readonly invoice: Invoice;
}

export interface UploadOnboardingListItemFileInput {
  readonly file?: InputMaybe<Scalars['Upload']['input']>;
  readonly id: Scalars['ID']['input'];
}

/** Autogenerated return type of UploadOnboardingListItemFile. */
export interface UploadOnboardingListItemFilePayload {
  readonly __typename?: 'UploadOnboardingListItemFilePayload';
  readonly onboardingListItem: TodoListItem;
}

export interface UploadPayrollFileInput {
  readonly file?: InputMaybe<Scalars['Upload']['input']>;
  readonly id: Scalars['ID']['input'];
}

/** Autogenerated return type of UploadPayrollFile. */
export interface UploadPayrollFilePayload {
  readonly __typename?: 'UploadPayrollFilePayload';
  readonly payroll: Payroll;
}

/** Autogenerated return type of UploadResume. */
export interface UploadResumePayload {
  readonly __typename?: 'UploadResumePayload';
  readonly uploadedResume: UploadedResume;
}

export interface UploadShiftFileInput {
  readonly file?: InputMaybe<Scalars['Upload']['input']>;
  readonly id: Scalars['ID']['input'];
}

/** Autogenerated return type of UploadShiftFile. */
export interface UploadShiftFilePayload {
  readonly __typename?: 'UploadShiftFilePayload';
  readonly files: ReadonlyArray<File>;
}

export interface UploadTimeSheetFileInput {
  readonly file?: InputMaybe<Scalars['Upload']['input']>;
  readonly id: Scalars['ID']['input'];
}

/** Autogenerated return type of UploadTimeSheetFile. */
export interface UploadTimeSheetFilePayload {
  readonly __typename?: 'UploadTimeSheetFilePayload';
  readonly timeSheet: TimeSheet;
}

/** Autogenerated return type of UploadVmsLookupTable. */
export interface UploadVmsLookupTablePayload {
  readonly __typename?: 'UploadVmsLookupTablePayload';
  readonly vmsLookupTableFile: File;
}

export interface UploadedResume {
  readonly __typename?: 'UploadedResume';
  readonly fileName: Scalars['String']['output'];
  readonly hiddenSuggestions?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly id: Scalars['ID']['output'];
  readonly parserIdsCompleted: Scalars['Boolean']['output'];
  readonly resumeParserStep?: Maybe<Scalars['String']['output']>;
  readonly resumeProbability?: Maybe<Scalars['String']['output']>;
  readonly status: ParsingStatusEnum;
}

/** Autogenerated return type of UpsertAutoApplyConfiguration. */
export interface UpsertAutoApplyConfigurationPayload {
  readonly __typename?: 'UpsertAutoApplyConfigurationPayload';
  readonly autoApplyInfo: AutoApplyInfo;
  readonly autoApplyPreferences: AutoApplyPreferences;
  readonly nurseProfile: NurseProfile;
}

/** Autogenerated return type of UpsertBackgroundQuestions. */
export interface UpsertBackgroundQuestionsPayload {
  readonly __typename?: 'UpsertBackgroundQuestionsPayload';
  readonly user: User;
}

export interface UpsertClinicianLanguageInput {
  readonly language: LanguageType;
  readonly proficiency: LanguageProficiencyType;
}

/** Autogenerated return type of UpsertClinicianLocation. */
export interface UpsertClinicianLocationPayload {
  readonly __typename?: 'UpsertClinicianLocationPayload';
  readonly nurseProfile?: Maybe<NurseProfile>;
}

export interface UpsertEmploymentPositionAgencyInput {
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
}

export interface UpsertEmploymentPositionFacilityInput {
  readonly googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
}

export interface UpsertEmploymentPositionInput {
  readonly additionalSkills?: InputMaybe<Scalars['String']['input']>;
  readonly chargeExperience?: InputMaybe<Scalars['Boolean']['input']>;
  readonly classification: EmploymentTypes;
  readonly clinicalUnitId?: InputMaybe<Scalars['ID']['input']>;
  readonly endAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly floatFrequency?: InputMaybe<PositionFloatFrequency>;
  readonly floatUnits?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly hospitalBedCount?: InputMaybe<Scalars['Int']['input']>;
  readonly hoursWorked: Scalars['Int']['input'];
  readonly hoursWorkedTimeframe: HoursWorkedTimeframe;
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly leadExperience?: InputMaybe<Scalars['Boolean']['input']>;
  readonly magnet?: InputMaybe<Scalars['Boolean']['input']>;
  readonly nicuLevel?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly patientRatio?: InputMaybe<Scalars['Int']['input']>;
  readonly positionType: PositionTypes;
  readonly preceptorExperience?: InputMaybe<Scalars['Boolean']['input']>;
  readonly roleId?: InputMaybe<Scalars['ID']['input']>;
  readonly specialties?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly startAt: Scalars['ISO8601Date']['input'];
  readonly teaching?: InputMaybe<Scalars['Boolean']['input']>;
  readonly technologies?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly title?: InputMaybe<Scalars['String']['input']>;
  readonly trauma?: InputMaybe<Scalars['Boolean']['input']>;
  readonly traumaLevel?: InputMaybe<Scalars['Int']['input']>;
  readonly unitBedCount?: InputMaybe<Scalars['Int']['input']>;
  readonly wouldWorkAgain?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Autogenerated return type of UpsertEmploymentPosition. */
export interface UpsertEmploymentPositionPayload {
  readonly __typename?: 'UpsertEmploymentPositionPayload';
  readonly nurseProfile: NurseProfile;
}

/** Autogenerated return type of UpsertLanguage. */
export interface UpsertLanguagePayload {
  readonly __typename?: 'UpsertLanguagePayload';
  readonly nurseProfile: NurseProfile;
}

export interface UpsertPayrollCorrectionFileInput {
  readonly file?: InputMaybe<Scalars['Upload']['input']>;
  readonly fileId?: InputMaybe<Scalars['ID']['input']>;
  readonly id: Scalars['ID']['input'];
}

/** Autogenerated return type of UpsertPayrollCorrectionFile. */
export interface UpsertPayrollCorrectionFilePayload {
  readonly __typename?: 'UpsertPayrollCorrectionFilePayload';
  readonly payroll: Payroll;
}

/** Autogenerated return type of UpsertPermanentAddress. */
export interface UpsertPermanentAddressPayload {
  readonly __typename?: 'UpsertPermanentAddressPayload';
  readonly user: User;
}

/** Autogenerated return type of UpsertPersonalInfo. */
export interface UpsertPersonalInfoPayload {
  readonly __typename?: 'UpsertPersonalInfoPayload';
  readonly user: User;
}

export interface UpsertReferenceInput {
  readonly reference: UpsertReferenceReferenceInput;
}

/** Autogenerated return type of UpsertReference. */
export interface UpsertReferencePayload {
  readonly __typename?: 'UpsertReferencePayload';
  readonly nurseProfile?: Maybe<NurseProfile>;
}

export interface UpsertReferenceReferenceInput {
  readonly bedCount?: InputMaybe<Scalars['Int']['input']>;
  readonly chargeExp?: InputMaybe<Scalars['Boolean']['input']>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly employmentOther?: InputMaybe<Scalars['String']['input']>;
  readonly employmentUuid?: InputMaybe<Scalars['String']['input']>;
  readonly facilityName?: InputMaybe<Scalars['String']['input']>;
  readonly fileUuids?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly patientsPerNurse?: InputMaybe<Scalars['Int']['input']>;
  readonly phone?: InputMaybe<Scalars['String']['input']>;
  readonly positionId?: InputMaybe<Scalars['String']['input']>;
  readonly preferredContactMethod?: InputMaybe<Scalars['String']['input']>;
  readonly relationship?: InputMaybe<Scalars['String']['input']>;
  readonly responseAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly unit?: InputMaybe<Scalars['String']['input']>;
  readonly uuid?: InputMaybe<Scalars['String']['input']>;
  readonly wouldRehire?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface UpsertShiftEntryInput {
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly includeTimeEntryWithError?: InputMaybe<Scalars['Boolean']['input']>;
  readonly jobPlacementScheduleUuid: Scalars['ID']['input'];
  readonly timeEntries: ReadonlyArray<TimeEntryInput>;
}

/** Autogenerated return type of UpsertShiftWithEntries. */
export interface UpsertShiftWithEntriesPayload {
  readonly __typename?: 'UpsertShiftWithEntriesPayload';
  readonly timeSheet: TimeSheet;
}

export interface UpsertTimeEntryInput {
  readonly children?: InputMaybe<ReadonlyArray<BaseTimeEntryInput>>;
  readonly destroy?: InputMaybe<Scalars['Boolean']['input']>;
  readonly duration?: InputMaybe<Scalars['Float']['input']>;
  readonly endSec?: InputMaybe<Scalars['Int']['input']>;
  readonly entryType?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly parentId?: InputMaybe<Scalars['String']['input']>;
  readonly startSec?: InputMaybe<Scalars['Int']['input']>;
}

/** Autogenerated return type of UpsertTimecardWithEntries. */
export interface UpsertTimecardWithEntriesPayload {
  readonly __typename?: 'UpsertTimecardWithEntriesPayload';
  readonly errors?: Maybe<Scalars['String']['output']>;
  readonly timeSheet?: Maybe<TimeSheet>;
}

export interface UpsertTimecardWithEntriesShiftInput {
  readonly date: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly kind?: InputMaybe<Scalars['String']['input']>;
  readonly timeEntries: ReadonlyArray<UpsertTimeEntryInput>;
}

export interface UpsertTimecardWithEntriesTimecardInput {
  readonly shifts: ReadonlyArray<UpsertTimecardWithEntriesShiftInput>;
  readonly timeSheetId: Scalars['ID']['input'];
}

/** Autogenerated return type of UpsertYearsOfExperience. */
export interface UpsertYearsOfExperiencePayload {
  readonly __typename?: 'UpsertYearsOfExperiencePayload';
  readonly nurseProfile: NurseProfile;
}

export interface UsStateLocationsOrderBy {
  readonly direction: OrderDirection;
  readonly field: LocationOrderField;
}

export interface User {
  readonly __typename?: 'User';
  readonly city?: Maybe<Scalars['String']['output']>;
  readonly cityPermanent?: Maybe<Scalars['String']['output']>;
  readonly completeAddress: Scalars['Boolean']['output'];
  readonly confirmationSentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly confirmedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly countryPermanentCode?: Maybe<Scalars['String']['output']>;
  readonly countryPermanentName?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly email: Scalars['String']['output'];
  readonly emailBounced: Scalars['Boolean']['output'];
  /** @deprecated use userProperties */
  readonly externalServiceMetadata?: Maybe<ExternalServiceMetadata>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly googlePlaceIdPermanent?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly initialReferringDomain?: Maybe<Scalars['String']['output']>;
  readonly intercomUserHash?: Maybe<Scalars['String']['output']>;
  readonly jobPlacements?: Maybe<ReadonlyArray<JobPlacement>>;
  readonly lastAnswerAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly marketingSmsAllowed: Scalars['Boolean']['output'];
  readonly middleName?: Maybe<Scalars['String']['output']>;
  readonly nurseProfile?: Maybe<NurseProfile>;
  readonly phone?: Maybe<Scalars['String']['output']>;
  readonly phoneVerified: Scalars['Boolean']['output'];
  readonly preferredContactMethod?: Maybe<Scalars['String']['output']>;
  readonly preferredName?: Maybe<Scalars['String']['output']>;
  readonly preferredPronoun?: Maybe<Scalars['String']['output']>;
  readonly profilePic?: Maybe<Scalars['String']['output']>;
  readonly receivedEmailConfirmationLink?: Maybe<Scalars['Boolean']['output']>;
  readonly referralCode?: Maybe<Scalars['String']['output']>;
  /** Referrals from Saasquatch API */
  readonly referrals?: Maybe<ReferralResponse>;
  readonly referredByUuid?: Maybe<Scalars['String']['output']>;
  readonly saasquatchToken?: Maybe<Scalars['String']['output']>;
  readonly signupSource?: Maybe<SignupTypes>;
  readonly signupSourceQualifier?: Maybe<SignupSourceQualifiers>;
  readonly squatchShareUrl?: Maybe<Scalars['String']['output']>;
  readonly state?: Maybe<Scalars['String']['output']>;
  readonly statePermanent?: Maybe<Scalars['String']['output']>;
  readonly statusForHelpArticles?: Maybe<Scalars['String']['output']>;
  readonly streetAddress?: Maybe<Scalars['String']['output']>;
  readonly streetAddressPermanent?: Maybe<Scalars['String']['output']>;
  readonly streetNumberPermanent?: Maybe<Scalars['String']['output']>;
  readonly subscribedBrazeRootEmail: Scalars['Boolean']['output'];
  readonly subscribedCeuEmail: Scalars['Boolean']['output'];
  readonly subscribedCredentialsEmail: Scalars['Boolean']['output'];
  readonly subscribedInvitesEmail: Scalars['Boolean']['output'];
  readonly subscribedJobApplicationsEmail: Scalars['Boolean']['output'];
  readonly subscribedMatchesEmail: Scalars['Boolean']['output'];
  readonly subscribedNewsletterEmail: Scalars['Boolean']['output'];
  readonly subscribedProductUpdatesEmail: Scalars['Boolean']['output'];
  readonly subscribedReferencesEmail: Scalars['Boolean']['output'];
  readonly sunshineToken?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly userFeatureGates: UserFeatureGate;
  readonly userProperties: UserProperties;
  readonly userSurveyToken?: Maybe<Scalars['ID']['output']>;
  readonly uuid: Scalars['String']['output'];
  readonly validZipcode: Scalars['Boolean']['output'];
  readonly zipcode?: Maybe<Scalars['String']['output']>;
  readonly zipcodePermanent?: Maybe<Scalars['String']['output']>;
}


export interface UserReferralsArgs {
  filter?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
}

export interface UserFeatureGate {
  readonly __typename?: 'UserFeatureGate';
  readonly canReceiveJobAlerts: Scalars['Boolean']['output'];
  readonly canShareMatchDetails: Scalars['Boolean']['output'];
  readonly canUseMatchSwipes: Scalars['Boolean']['output'];
  readonly canUseMobileOnboarding: Scalars['Boolean']['output'];
  readonly canUseNativeMatches: Scalars['Boolean']['output'];
  readonly canUseSunshine: Scalars['Boolean']['output'];
  readonly canUseTimecardAttachment: Scalars['Boolean']['output'];
  readonly canViewCommunityForums: Scalars['Boolean']['output'];
  readonly canViewCommunityPage: Scalars['Boolean']['output'];
  readonly canViewFacilityPageRankings: Scalars['Boolean']['output'];
  readonly canViewJobAppUpsell: Scalars['Boolean']['output'];
  readonly canViewJobSeekerNavigation: Scalars['Boolean']['output'];
  readonly canViewJobSeekerProfile2022Q4: Scalars['Boolean']['output'];
  readonly canViewJobSeekerSplitScreenMatches: Scalars['Boolean']['output'];
  /** @deprecated Migrated to LaunchDarkly */
  readonly canViewMatchBucketLandingPage: Scalars['Boolean']['output'];
  readonly canViewMatchInsights2023: Scalars['Boolean']['output'];
  readonly canViewProfileChecklist: Scalars['Boolean']['output'];
  readonly canViewTransitionedDashboard: Scalars['Boolean']['output'];
  readonly canViewTransitionedProfile: Scalars['Boolean']['output'];
  readonly matchReferralAEnabled: Scalars['Boolean']['output'];
}

export interface UserProperties {
  readonly __typename?: 'UserProperties';
  readonly id: Scalars['ID']['output'];
  readonly shouldDisplayChatModalWhenViewApplication: Scalars['Boolean']['output'];
  readonly shouldDisplayChatModalWhenViewCuratedMatchesPage: Scalars['Boolean']['output'];
  readonly shouldDisplayChatModalWhenViewMatchDetailPage: Scalars['Boolean']['output'];
  readonly shouldDisplayFirstFavoriteMessage: Scalars['Boolean']['output'];
  readonly shouldDisplayIncompleteReferencesModal: Scalars['Boolean']['output'];
  readonly shouldDisplayIncompleteSkillsChecklistModal: Scalars['Boolean']['output'];
  readonly shouldDisplayProfileIncompleteWarning: Scalars['Boolean']['output'];
  readonly shouldDisplayStaleProfileNotification: Scalars['Boolean']['output'];
  readonly shouldSendAppcastPixel: Scalars['Boolean']['output'];
  readonly shouldSendSprigSurvey: Scalars['Boolean']['output'];
}

export const enum UserPropertiesEvent {
  /** User has received informative message after favoriting their first match */
  FirstFavoriteMessageDisplayed = 'firstFavoriteMessageDisplayed',
  /**
   * Personal information confirmed
   * @deprecated Feature removed - mobile version > 3.25.4
   */
  PersonalInformationConfirmed = 'personalInformationConfirmed',
  /** User has been shown the profile complete modal */
  ProfileCompleteModalDisplayed = 'profileCompleteModalDisplayed',
  /** Profile incomplete warning dismissed */
  ProfileIncompleteWarningDismissed = 'profileIncompleteWarningDismissed',
  /** Displayed Appcast Conversion Pixel */
  SentAppcastPixel = 'sentAppcastPixel',
  /** Sent Sprig survey */
  SentSprigSurvey = 'sentSprigSurvey',
  /** Stale profile notification dismissed */
  StaleProfileNotificationDismissed = 'staleProfileNotificationDismissed'
};

export interface UserPropertiesMutation {
  readonly __typename?: 'UserPropertiesMutation';
  /** @deprecated use recordEvent */
  readonly markSentSprigSurveyAt?: Maybe<MarkSentSprigSurveyAtPayload>;
  /** @deprecated use recordEvent */
  readonly markStaleProfileNotificationDismissed?: Maybe<MarkStaleProfileNotificationDismissedPayload>;
  readonly recordEvent?: Maybe<RecordEventPayload>;
}


export interface UserPropertiesMutationRecordEventArgs {
  event: UserPropertiesEvent;
}

export interface UserSurvey {
  readonly __typename?: 'UserSurvey';
  readonly name: Scalars['String']['output'];
}

export interface UsnewsRanking {
  readonly __typename?: 'UsnewsRanking';
  readonly fullScorecardUrl: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly rank?: Maybe<Scalars['Int']['output']>;
  readonly specialtyName?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
  readonly usnewsType: Scalars['String']['output'];
}

/** Structure validation errors for mutations */
export interface ValidationError {
  readonly __typename?: 'ValidationError';
  readonly attribute: Scalars['String']['output'];
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  readonly fullErrors: ReadonlyArray<Scalars['String']['output']>;
  readonly humanAttribute: Scalars['String']['output'];
}

export const enum ValueTypeEnum {
  /** Value stored in value_float */
  CurrencyDollar = 'CURRENCY_DOLLAR',
  /** Value stored in value_float */
  Float = 'FLOAT',
  /** Value stored in value_int */
  Int = 'INT',
  /** Value stored in value_float */
  Percent = 'PERCENT',
  /** Value stored in value_string */
  String = 'STRING',
  /** Value stored in value_string */
  Url = 'URL'
};

/** Autogenerated return type of VerifyCredential. */
export interface VerifyCredentialPayload {
  readonly __typename?: 'VerifyCredentialPayload';
  readonly credential?: Maybe<Credential>;
  readonly errors?: Maybe<ReadonlyArray<BasicErrorsUnion>>;
}

/** Users which may be viewers */
export type Viewer = AdminUser | User;

export interface VmsReverseInvoice {
  readonly __typename?: 'VmsReverseInvoice';
  readonly id: Scalars['ID']['output'];
  readonly itemCount: Scalars['Int']['output'];
  readonly matchedContractItemCount: Scalars['Int']['output'];
  readonly mspId?: Maybe<Scalars['ID']['output']>;
  readonly mspName?: Maybe<Scalars['String']['output']>;
  readonly vmsBusinessName?: Maybe<Scalars['String']['output']>;
  readonly vmsId?: Maybe<Scalars['ID']['output']>;
  readonly vmsInvoiceDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly vmsInvoiceId?: Maybe<Scalars['String']['output']>;
  readonly vmsInvoiceStatus?: Maybe<Scalars['String']['output']>;
  readonly vmsName?: Maybe<Scalars['String']['output']>;
  readonly vmsReverseInvoiceItemsLink: Scalars['String']['output'];
}

export interface VmsReverseInvoiceItem {
  readonly __typename?: 'VmsReverseInvoiceItem';
  readonly amount: Scalars['Float']['output'];
  readonly contractId?: Maybe<Scalars['ID']['output']>;
  readonly contractNumericId?: Maybe<Scalars['ID']['output']>;
  readonly description: Scalars['String']['output'];
  readonly descriptionForException?: Maybe<Scalars['String']['output']>;
  readonly exceptionReason?: Maybe<Scalars['String']['output']>;
  readonly exceptionReasonHumanized?: Maybe<Scalars['String']['output']>;
  readonly externalIdentifier?: Maybe<ExternalIdentifier>;
  readonly id: Scalars['ID']['output'];
  readonly invoiceId?: Maybe<Scalars['ID']['output']>;
  readonly invoiceNumericId?: Maybe<Scalars['ID']['output']>;
  readonly item: Scalars['String']['output'];
  readonly nurseId?: Maybe<Scalars['ID']['output']>;
  readonly nurseName: Scalars['String']['output'];
  readonly nurseNumericId?: Maybe<Scalars['ID']['output']>;
  readonly quantity: Scalars['Float']['output'];
  readonly rate: Scalars['Float']['output'];
  readonly reconciled: Scalars['Boolean']['output'];
  readonly shiftDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly uploadedToNetsuite: Scalars['Boolean']['output'];
  readonly vmsReverseInvoice: VmsReverseInvoice;
  readonly vmsReverseInvoiceItemContractId?: Maybe<Scalars['String']['output']>;
  readonly weekEnding?: Maybe<Scalars['ISO8601Date']['output']>;
}

export interface VmsReverseInvoiceItemContract {
  readonly __typename?: 'VmsReverseInvoiceItemContract';
  readonly contractId?: Maybe<Scalars['ID']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly invoiceId?: Maybe<Scalars['ID']['output']>;
  readonly vmsReverseInvoiceItemId?: Maybe<Scalars['ID']['output']>;
}

export const enum VmsReverseInvoiceItemException {
  /** Item duplicated */
  Duplicated = 'duplicated',
  /** Invalid item */
  Invalid = 'invalid',
  /** Legacy items */
  Legacy = 'legacy',
  /** Match Skipped */
  MatchSkipped = 'match_skipped',
  /** No timecard will be available */
  NoTimecardAvailable = 'no_timecard_available',
  /** Items of a non Trusted worker */
  NonTrustedWorker = 'non_trusted_worker',
  /** Nurse name change */
  NurseNameChange = 'nurse_name_change',
  /** Timecard is still stuck at the Payroll stage */
  TimecardStuckPayroll = 'timecard_stuck_payroll',
  /** Zero Amount and Quantity */
  ZeroAmountAndQuantity = 'zero_amount_and_quantity'
};

export interface VmsReverseInvoiceItemsPaginatedList {
  readonly __typename?: 'VmsReverseInvoiceItemsPaginatedList';
  readonly items: ReadonlyArray<VmsReverseInvoiceItem>;
  readonly itemsSummary: VmsReverseInvoiceSummary;
  readonly pageOffset?: Maybe<Scalars['Int']['output']>;
  readonly pageSize?: Maybe<Scalars['Int']['output']>;
  readonly totalCount: Scalars['Int']['output'];
}

export interface VmsReverseInvoiceItemsStats {
  readonly __typename?: 'VmsReverseInvoiceItemsStats';
  readonly exception: Scalars['Int']['output'];
  readonly missingMatch: Scalars['Int']['output'];
  readonly reconciled: Scalars['Int']['output'];
}

export interface VmsReverseInvoiceSummary {
  readonly __typename?: 'VmsReverseInvoiceSummary';
  readonly totalAmount: Scalars['Float']['output'];
  readonly totalCount: Scalars['Int']['output'];
  readonly totalHours: Scalars['Float']['output'];
  readonly totalReconciledAmount: Scalars['Float']['output'];
  readonly totalReconciledHours: Scalars['Float']['output'];
}

export interface Walkscore {
  readonly __typename?: 'Walkscore';
  readonly bikeDescription?: Maybe<Scalars['String']['output']>;
  readonly bikeExtraInfo?: Maybe<Scalars['String']['output']>;
  readonly bikeScore?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use `bikeDescription` */
  readonly bike_description?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `bikeScore` */
  readonly bike_score?: Maybe<Scalars['Int']['output']>;
  readonly transitDescription?: Maybe<Scalars['String']['output']>;
  readonly transitExtraInfo?: Maybe<Scalars['String']['output']>;
  readonly transitScore?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use `transitDescription` */
  readonly transit_description?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `transitScore` */
  readonly transit_score?: Maybe<Scalars['Int']['output']>;
  readonly walkDescription?: Maybe<Scalars['String']['output']>;
  readonly walkExtraInfo?: Maybe<Scalars['String']['output']>;
  readonly walkScore?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use `walkDescription` */
  readonly walk_description?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `walkScore` */
  readonly walk_score?: Maybe<Scalars['Int']['output']>;
}

export interface WeatherForecast {
  readonly __typename?: 'WeatherForecast';
  readonly icon?: Maybe<Scalars['String']['output']>;
  readonly temperature?: Maybe<Scalars['Int']['output']>;
  readonly temperatureHigh?: Maybe<Scalars['Int']['output']>;
  readonly temperatureLow?: Maybe<Scalars['Int']['output']>;
}

export const enum WithdrawReasonsEnum {
  /** Accepted another opportunity */
  AcceptedAnotherOpportunity = 'accepted_another_opportunity',
  /** Accepted another opportunity with Trusted */
  AcceptedAnotherOpportunityWithTrusted = 'accepted_another_opportunity_with_trusted',
  /** No longer available */
  NoLongerAvailable = 'no_longer_available',
  /** No longer interested */
  NoLongerInterested = 'no_longer_interested'
};

export interface WorkExperienceSuggestion {
  readonly __typename?: 'WorkExperienceSuggestion';
  readonly additionalSkills?: Maybe<Scalars['String']['output']>;
  readonly clinicalUnit?: Maybe<ClinicalUnit>;
  /** @deprecated this field will be removed after the ffWorkExperienceV2 feature flag is removed */
  readonly descriptions?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly endAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly facility?: Maybe<Facility>;
  /** @deprecated this field will be removed after the ffWorkExperienceV2 feature flag is removed */
  readonly facilityLocation?: Maybe<Scalars['String']['output']>;
  readonly facilityName?: Maybe<Scalars['String']['output']>;
  readonly hospitalBedCount?: Maybe<Scalars['Int']['output']>;
  /** @deprecated this field will be removed after the ffWorkExperienceV2 feature flag is removed */
  readonly isCurrent?: Maybe<Scalars['Boolean']['output']>;
  readonly magnet?: Maybe<Scalars['Boolean']['output']>;
  readonly parserId?: Maybe<Scalars['String']['output']>;
  /** @deprecated this field will be removed after the ffWorkExperienceV2 feature flag is removed */
  readonly positionTitle?: Maybe<Scalars['String']['output']>;
  readonly positionType?: Maybe<PositionTypes>;
  readonly role?: Maybe<Role>;
  readonly specialties?: Maybe<ReadonlyArray<ClinicalSpecialty>>;
  readonly startAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly teaching?: Maybe<Scalars['Boolean']['output']>;
  readonly technologies?: Maybe<ReadonlyArray<Technology>>;
  readonly trauma?: Maybe<Scalars['Boolean']['output']>;
  readonly traumaLevel?: Maybe<Scalars['Int']['output']>;
}

export interface WorkInterval {
  readonly __typename?: 'WorkInterval';
  readonly currentWeek: Scalars['Boolean']['output'];
  readonly endSec: Scalars['Int']['output'];
  readonly startSec: Scalars['Int']['output'];
  readonly submitted: Scalars['Boolean']['output'];
  readonly workDays: ReadonlyArray<TimeEntryDay>;
}

export const enum YearTerms {
  /** Fall */
  Fall = 'fall',
  /** Spring */
  Spring = 'spring',
  /** Summer */
  Summer = 'summer',
  /** Winter */
  Winter = 'winter'
};

export interface YearsOfExperienceInput {
  readonly yearsOfExp?: InputMaybe<Scalars['Int']['input']>;
  readonly yearsOfTravelExp?: InputMaybe<Scalars['Int']['input']>;
}

/** One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string. */
export interface __EnumValue {
  readonly __typename?: '__EnumValue';
  readonly name: Scalars['String']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly isDeprecated: Scalars['Boolean']['output'];
  readonly deprecationReason?: Maybe<Scalars['String']['output']>;
}

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export interface __Field {
  readonly __typename?: '__Field';
  readonly name: Scalars['String']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly args: ReadonlyArray<__InputValue>;
  readonly type: __Type;
  readonly isDeprecated: Scalars['Boolean']['output'];
  readonly deprecationReason?: Maybe<Scalars['String']['output']>;
}


/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export interface __FieldArgsArgs {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value. */
export interface __InputValue {
  readonly __typename?: '__InputValue';
  readonly name: Scalars['String']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly type: __Type;
  /** A GraphQL-formatted string representing the default value for this input value. */
  readonly defaultValue?: Maybe<Scalars['String']['output']>;
  readonly isDeprecated: Scalars['Boolean']['output'];
  readonly deprecationReason?: Maybe<Scalars['String']['output']>;
}

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export interface __Type {
  readonly __typename?: '__Type';
  readonly kind: __TypeKind;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly specifiedByURL?: Maybe<Scalars['String']['output']>;
  readonly fields?: Maybe<ReadonlyArray<__Field>>;
  readonly interfaces?: Maybe<ReadonlyArray<__Type>>;
  readonly possibleTypes?: Maybe<ReadonlyArray<__Type>>;
  readonly enumValues?: Maybe<ReadonlyArray<__EnumValue>>;
  readonly inputFields?: Maybe<ReadonlyArray<__InputValue>>;
  readonly ofType?: Maybe<__Type>;
  readonly isOneOf?: Maybe<Scalars['Boolean']['output']>;
}


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export interface __TypeFieldsArgs {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
}


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export interface __TypeEnumValuesArgs {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
}


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export interface __TypeInputFieldsArgs {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
}

/** An enum describing what kind of type a given `__Type` is. */
export const enum __TypeKind {
  /** Indicates this type is a scalar. */
  Scalar = 'SCALAR',
  /** Indicates this type is an object. `fields` and `interfaces` are valid fields. */
  Object = 'OBJECT',
  /** Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields. */
  Interface = 'INTERFACE',
  /** Indicates this type is a union. `possibleTypes` is a valid field. */
  Union = 'UNION',
  /** Indicates this type is an enum. `enumValues` is a valid field. */
  Enum = 'ENUM',
  /** Indicates this type is an input object. `inputFields` is a valid field. */
  InputObject = 'INPUT_OBJECT',
  /** Indicates this type is a list. `ofType` is a valid field. */
  List = 'LIST',
  /** Indicates this type is a non-null. `ofType` is a valid field. */
  NonNull = 'NON_NULL'
};

export type AdvocateFragment = { readonly __typename?: 'NurseProfile', readonly id: string, readonly nurseAdvocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly profileImgUrl: string, readonly email?: string | null, readonly firstName?: string | null, readonly phone?: string | null, readonly fullName?: string | null } | null };

export type ClinicianFragment = { readonly __typename?: 'NurseProfile', readonly id: string, readonly canUploadResume: boolean, readonly state?: string | null, readonly nurseType?: string | null, readonly wizardCompleted: boolean, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly key?: string | null, readonly name: string, readonly type?: RoleType | null } | null };

export type FacilitySuggestionFragment = { readonly __typename?: 'Facility', readonly id: string, readonly address: string, readonly city?: string | null, readonly name: string, readonly state?: string | null, readonly uuid?: string | null, readonly zipcode?: string | null, readonly hospital?: { readonly __typename?: 'Hospital', readonly id: string, readonly nicuTraumaLevel?: number | null, readonly pediatricTraumaCenterLevel?: number | null, readonly totalLicensedBeds?: number | null, readonly magnet: boolean, readonly teaching: boolean, readonly traumaCenter: boolean, readonly traumaCenterLevel?: number | null, readonly technology?: { readonly __typename?: 'Technology', readonly id: string, readonly name: string } | null } | null };

export type FileMetadataFragment = { readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null };

export type HospitalInSuggestionFragment = { readonly __typename?: 'Hospital', readonly id: string, readonly nicuTraumaLevel?: number | null, readonly pediatricTraumaCenterLevel?: number | null, readonly totalLicensedBeds?: number | null, readonly magnet: boolean, readonly teaching: boolean, readonly traumaCenter: boolean, readonly traumaCenterLevel?: number | null, readonly technology?: { readonly __typename?: 'Technology', readonly id: string, readonly name: string } | null };

export type ProfileCompletionSummaryFragment = { readonly __typename?: 'ProfileCompletionSummary', readonly id: string, readonly completedAt?: GraphQLISO8601DateTime | null, readonly meta: { readonly __typename?: 'ProfileMeta', readonly id: string, readonly completeCount: number, readonly expiredCount: number, readonly expiringCount: number, readonly incompleteCount: number, readonly pendingCount: number, readonly percentCompleted: number }, readonly steps: ReadonlyArray<{ readonly __typename?: 'ProfileStep', readonly estimatedTimeInMinutes?: number | null, readonly key: ProfileStepsEnum, readonly title?: string | null, readonly subtitle?: string | null, readonly messages?: ReadonlyArray<string> | null, readonly sectionName: string, readonly status: ProfileStatusEnum, readonly hasExpiringItems: boolean, readonly hasExpiredItems: boolean, readonly hasInvalidItems: boolean }> };

export type CompleteRoleFragment = { readonly __typename?: 'Role', readonly id: string, readonly abbreviation: string, readonly key?: string | null, readonly name: string, readonly type?: RoleType | null };

export type UserFullNameFragment = { readonly __typename?: 'User', readonly firstName?: string | null, readonly preferredName?: string | null, readonly middleName?: string | null, readonly lastName?: string | null };

export type CreateSharedLinkMutationVariables = Exact<{
  input: CreateSharedLinkInput;
}>;


export type CreateSharedLinkMutation = { readonly __typename?: 'Mutation', readonly createSharedLink?: { readonly __typename?: 'CreateSharedLinkPayload', readonly sharedLink: { readonly __typename?: 'SharedLink', readonly id: string, readonly shortUrl?: string | null, readonly longUrl: string } } | null };

export type FavoriteJobMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
}>;


export type FavoriteJobMutation = { readonly __typename?: 'Mutation', readonly favoriteJob?: { readonly __typename?: 'FavoriteJobPayload', readonly job?: { readonly __typename?: 'Job', readonly id: string } | null } | null };

export type DeleteFileMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteFileMutation = { readonly __typename?: 'Mutation', readonly deleteFile?: { readonly __typename?: 'DeleteFilePayload', readonly id: string } | null };

export type RecordEventMutationVariables = Exact<{
  event: UserPropertiesEvent;
}>;


export type RecordEventMutation = { readonly __typename?: 'Mutation', readonly userProperties: { readonly __typename?: 'UserPropertiesMutation', readonly recordEvent?: { readonly __typename?: 'RecordEventPayload', readonly user: { readonly __typename?: 'User', readonly id: string, readonly userProperties: { readonly __typename?: 'UserProperties', readonly id: string, readonly shouldDisplayFirstFavoriteMessage: boolean, readonly shouldDisplayProfileIncompleteWarning: boolean, readonly shouldDisplayStaleProfileNotification: boolean, readonly shouldSendSprigSurvey: boolean, readonly shouldSendAppcastPixel: boolean } } } | null } };

export type SaveFacilityMutationVariables = Exact<{
  nurseProfileId: Scalars['ID']['input'];
  facilitySlug: Scalars['String']['input'];
}>;


export type SaveFacilityMutation = { readonly __typename?: 'Mutation', readonly saveFacility?: { readonly __typename?: 'SaveFacilityPayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly savedFacility: boolean, readonly businesses?: ReadonlyArray<{ readonly __typename?: 'Facility', readonly id: string, readonly slug: string, readonly name: string, readonly address: string, readonly city?: string | null, readonly state?: string | null, readonly hospital?: { readonly __typename?: 'Hospital', readonly id: string, readonly hospitalSystem?: string | null } | null }> | null } } | null };

export type DeleteSavedFacilityMutationVariables = Exact<{
  nurseProfileId: Scalars['ID']['input'];
  facilitySlug: Scalars['String']['input'];
}>;


export type DeleteSavedFacilityMutation = { readonly __typename?: 'Mutation', readonly deleteSavedFacility?: { readonly __typename?: 'DeleteSavedFacilityPayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly savedFacility: boolean, readonly businesses?: ReadonlyArray<{ readonly __typename?: 'Facility', readonly id: string, readonly slug: string, readonly name: string, readonly address: string, readonly city?: string | null, readonly state?: string | null, readonly hospital?: { readonly __typename?: 'Hospital', readonly id: string, readonly hospitalSystem?: string | null } | null }> | null } } | null };

export type RequestSmsVerificationMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  phone: Scalars['String']['input'];
  marketingSmsAllowed?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RequestSmsVerificationMutation = { readonly __typename?: 'Mutation', readonly requestSMSVerification?: { readonly __typename?: 'RequestSmsVerificationPayload', readonly user: { readonly __typename?: 'User', readonly id: string, readonly phone?: string | null, readonly phoneVerified: boolean, readonly marketingSmsAllowed: boolean }, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ValidationError', readonly errors: ReadonlyArray<string> }> | null } | null, readonly nestedUpdateUser?: { readonly __typename?: 'NestedUpdateUserPayload', readonly user: { readonly __typename?: 'User', readonly id: string, readonly phone?: string | null, readonly phoneVerified: boolean, readonly marketingSmsAllowed: boolean }, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ValidationError', readonly errors: ReadonlyArray<string> }> | null } | null };

export type CheckSmsVerificationCodeMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
}>;


export type CheckSmsVerificationCodeMutation = { readonly __typename?: 'Mutation', readonly checkSMSVerificationCode?: { readonly __typename?: 'CheckSmsVerificationCodePayload', readonly user: { readonly __typename?: 'User', readonly id: string, readonly phone?: string | null, readonly phoneVerified: boolean, readonly marketingSmsAllowed: boolean } } | null };

export type SmsVerificationUserFragment = { readonly __typename?: 'User', readonly id: string, readonly phone?: string | null, readonly phoneVerified: boolean, readonly marketingSmsAllowed: boolean };

export type UpdateProfilePicMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  file?: InputMaybe<Scalars['Upload']['input']>;
}>;


export type UpdateProfilePicMutation = { readonly __typename?: 'Mutation', readonly updateProfilePhoto?: { readonly __typename?: 'UpdateProfilePhotoPayload', readonly user: { readonly __typename?: 'User', readonly id: string, readonly profilePic?: string | null } } | null };

export type SignInUserMutationVariables = Exact<{
  input: SignInUserInput;
}>;


export type SignInUserMutation = { readonly __typename?: 'Mutation', readonly signInUser?: { readonly __typename?: 'SignInUserPayload', readonly token: string, readonly roleType: string, readonly user: { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly intercomUserHash?: string | null } } | null };

export type SignOutUserMutationVariables = Exact<{ [key: string]: never; }>;


export type SignOutUserMutation = { readonly __typename?: 'Mutation', readonly signOut?: { readonly __typename?: 'SignOutPayload', readonly user?: { readonly __typename?: 'User', readonly id: string } | null } | null };

export type AdvocateQueryVariables = Exact<{ [key: string]: never; }>;


export type AdvocateQuery = { readonly __typename?: 'Query', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nurseAdvocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly profileImgUrl: string, readonly email?: string | null, readonly firstName?: string | null, readonly phone?: string | null, readonly fullName?: string | null } | null } | null };

export type ClinicianQueryVariables = Exact<{ [key: string]: never; }>;


export type ClinicianQuery = { readonly __typename?: 'Query', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly canUploadResume: boolean, readonly state?: string | null, readonly nurseType?: string | null, readonly wizardCompleted: boolean, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly key?: string | null, readonly name: string, readonly type?: RoleType | null } | null } | null };

export type EnumValueFragment = { readonly __typename?: '__EnumValue', readonly name: string, readonly description?: string | null };

export type EnumValuesTypeFragment = { readonly __typename?: '__Type', readonly name?: string | null, readonly enumValues?: ReadonlyArray<{ readonly __typename?: '__EnumValue', readonly name: string, readonly description?: string | null }> | null };

export type CeuCertificateTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type CeuCertificateTypesQuery = { readonly __typename?: 'Query', readonly __type?: { readonly __typename?: '__Type', readonly name?: string | null, readonly enumValues?: ReadonlyArray<{ readonly __typename?: '__EnumValue', readonly name: string, readonly description?: string | null }> | null } | null };

export type NurseTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type NurseTypesQuery = { readonly __typename?: 'Query', readonly __type?: { readonly __typename?: '__Type', readonly name?: string | null, readonly enumValues?: ReadonlyArray<{ readonly __typename?: '__EnumValue', readonly name: string, readonly description?: string | null }> | null } | null };

export type EmploymentTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type EmploymentTypesQuery = { readonly __typename?: 'Query', readonly __type?: { readonly __typename?: '__Type', readonly name?: string | null, readonly enumValues?: ReadonlyArray<{ readonly __typename?: '__EnumValue', readonly name: string, readonly description?: string | null }> | null } | null };

export type HoursWorkedTimeframesQueryVariables = Exact<{ [key: string]: never; }>;


export type HoursWorkedTimeframesQuery = { readonly __typename?: 'Query', readonly __type?: { readonly __typename?: '__Type', readonly name?: string | null, readonly enumValues?: ReadonlyArray<{ readonly __typename?: '__EnumValue', readonly name: string, readonly description?: string | null }> | null } | null };

export type GapReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GapReasonsQuery = { readonly __typename?: 'Query', readonly __type?: { readonly __typename?: '__Type', readonly name?: string | null, readonly enumValues?: ReadonlyArray<{ readonly __typename?: '__EnumValue', readonly name: string, readonly description?: string | null }> | null } | null };

export type RecommenderRelationshipsQueryVariables = Exact<{ [key: string]: never; }>;


export type RecommenderRelationshipsQuery = { readonly __typename?: 'Query', readonly __type?: { readonly __typename?: '__Type', readonly name?: string | null, readonly enumValues?: ReadonlyArray<{ readonly __typename?: '__EnumValue', readonly name: string, readonly description?: string | null }> | null } | null };

export type FacilityTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type FacilityTypesQuery = { readonly __typename?: 'Query', readonly __type?: { readonly __typename?: '__Type', readonly name?: string | null, readonly enumValues?: ReadonlyArray<{ readonly __typename?: '__EnumValue', readonly name: string, readonly description?: string | null }> | null } | null };

export type YearTermsQueryVariables = Exact<{ [key: string]: never; }>;


export type YearTermsQuery = { readonly __typename?: 'Query', readonly __type?: { readonly __typename?: '__Type', readonly name?: string | null, readonly enumValues?: ReadonlyArray<{ readonly __typename?: '__EnumValue', readonly name: string, readonly description?: string | null }> | null } | null };

export type StudentExperienceTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type StudentExperienceTypesQuery = { readonly __typename?: 'Query', readonly __type?: { readonly __typename?: '__Type', readonly name?: string | null, readonly enumValues?: ReadonlyArray<{ readonly __typename?: '__EnumValue', readonly name: string, readonly description?: string | null }> | null } | null };

export type ContractLengthQueryVariables = Exact<{ [key: string]: never; }>;


export type ContractLengthQuery = { readonly __typename?: 'Query', readonly __type?: { readonly __typename?: '__Type', readonly name?: string | null, readonly enumValues?: ReadonlyArray<{ readonly __typename?: '__EnumValue', readonly name: string, readonly description?: string | null }> | null } | null };

export type ShiftLengthQueryVariables = Exact<{ [key: string]: never; }>;


export type ShiftLengthQuery = { readonly __typename?: 'Query', readonly __type?: { readonly __typename?: '__Type', readonly name?: string | null, readonly enumValues?: ReadonlyArray<{ readonly __typename?: '__EnumValue', readonly name: string, readonly description?: string | null }> | null } | null };

export type RoleTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type RoleTypesQuery = { readonly __typename?: 'Query', readonly __type?: { readonly __typename?: '__Type', readonly name?: string | null, readonly enumValues?: ReadonlyArray<{ readonly __typename?: '__EnumValue', readonly name: string, readonly description?: string | null }> | null } | null };

export type FeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type FeatureFlagsQuery = { readonly __typename?: 'Query', readonly featureFlags: any };

export type RolesQueryVariables = Exact<{
  type?: InputMaybe<RoleType>;
}>;


export type RolesQuery = { readonly __typename?: 'Query', readonly roles: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: string, readonly abbreviation: string, readonly key?: string | null, readonly name: string, readonly type?: RoleType | null }> };

export type CertificationSuggestionsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type CertificationSuggestionsQuery = { readonly __typename?: 'Query', readonly getCertificationSuggestions?: ReadonlyArray<{ readonly __typename?: 'Certification', readonly id: string, readonly name?: string | null, readonly credential?: string | null, readonly issuingBody?: string | null, readonly issuingBodies: ReadonlyArray<string>, readonly useCompletionDate?: boolean | null }> | null };

export type ClinicalSpecialtySuggestionsClinicalSpecialtyFragment = { readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly slug: string, readonly fullName?: string | null, readonly displayName: string, readonly pediatric: boolean, readonly nicu: boolean };

export type ClinicalSpecialtySuggestionsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type ClinicalSpecialtySuggestionsQuery = { readonly __typename?: 'Query', readonly getClinicalSpecialtySuggestions: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly slug: string, readonly fullName?: string | null, readonly displayName: string, readonly pediatric: boolean, readonly nicu: boolean }> };

export type ClinicalUnitSuggestionsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type ClinicalUnitSuggestionsQuery = { readonly __typename?: 'Query', readonly getClinicalUnitSuggestions: ReadonlyArray<{ readonly __typename?: 'ClinicalUnit', readonly id: string, readonly slug: string, readonly displayName: string, readonly defaultClinicalSpecialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly slug: string, readonly displayName: string, readonly pediatric: boolean }> | null }> };

export type FacilitySuggestionsQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type FacilitySuggestionsQuery = { readonly __typename?: 'Query', readonly facilitySuggestions?: ReadonlyArray<{ readonly __typename?: 'Facility', readonly id: string, readonly address: string, readonly city?: string | null, readonly name: string, readonly state?: string | null, readonly uuid?: string | null, readonly zipcode?: string | null, readonly hospital?: { readonly __typename?: 'Hospital', readonly id: string, readonly nicuTraumaLevel?: number | null, readonly pediatricTraumaCenterLevel?: number | null, readonly totalLicensedBeds?: number | null, readonly magnet: boolean, readonly teaching: boolean, readonly traumaCenter: boolean, readonly traumaCenterLevel?: number | null, readonly technology?: { readonly __typename?: 'Technology', readonly id: string, readonly name: string } | null } | null }> | null };

export type IncreasedPayFragment = { readonly __typename?: 'IncreasedPayBanner', readonly title: string, readonly description: string, readonly note?: string | null, readonly redirectTo?: string | null, readonly cta?: string | null };

export type IncreasedPayBannerQueryVariables = Exact<{
  sourcePage: BannerSourcePageEnum;
}>;


export type IncreasedPayBannerQuery = { readonly __typename?: 'Query', readonly increasedPayBanner?: { readonly __typename?: 'IncreasedPayBanner', readonly title: string, readonly description: string, readonly note?: string | null, readonly redirectTo?: string | null, readonly cta?: string | null } | null };

export type PermanentAddressPanelQueryVariables = Exact<{ [key: string]: never; }>;


export type PermanentAddressPanelQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly cityPermanent?: string | null, readonly countryPermanentCode?: string | null, readonly countryPermanentName?: string | null, readonly googlePlaceIdPermanent?: string | null, readonly statePermanent?: string | null, readonly streetAddressPermanent?: string | null, readonly streetNumberPermanent?: string | null, readonly zipcodePermanent?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly permanentAddress: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly message?: string | null, readonly status: ProfileCompletionStatusEnum } } } | null } | null } | null };

export type BackgroundInfoUserFragment = { readonly __typename?: 'User', readonly id: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly state?: string | null, readonly backgroundComplete: boolean, readonly backgroundQuestions?: ReadonlyArray<{ readonly __typename?: 'NurseBackgroundQuestion', readonly id: string, readonly answer?: boolean | null, readonly date?: GraphQLISO8601Date | null, readonly explanation?: string | null, readonly licenseAffected?: boolean | null, readonly open?: boolean | null, readonly questionType: NurseBackgroundQuestionType }> | null, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly background: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly status: ApplicationReadinessStatus } } }, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly backgroundQuestions: { readonly __typename?: 'ProfileCompletionStep', readonly message?: string | null, readonly label: string, readonly status: ProfileCompletionStatusEnum } } } | null } | null };

export type BackgroundInfoNurseBackgroundQuestionFragment = { readonly __typename?: 'NurseBackgroundQuestion', readonly id: string, readonly answer?: boolean | null, readonly date?: GraphQLISO8601Date | null, readonly explanation?: string | null, readonly licenseAffected?: boolean | null, readonly open?: boolean | null, readonly questionType: NurseBackgroundQuestionType };

export type BackgroundQuestionsUpsertMutationVariables = Exact<{
  input: ReadonlyArray<BackgroundQuestionInput> | BackgroundQuestionInput;
}>;


export type BackgroundQuestionsUpsertMutation = { readonly __typename?: 'Mutation', readonly backgroundQuestionsUpsert?: { readonly __typename?: 'UpsertBackgroundQuestionsPayload', readonly user: { readonly __typename?: 'User', readonly id: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly state?: string | null, readonly backgroundComplete: boolean, readonly backgroundQuestions?: ReadonlyArray<{ readonly __typename?: 'NurseBackgroundQuestion', readonly id: string, readonly answer?: boolean | null, readonly date?: GraphQLISO8601Date | null, readonly explanation?: string | null, readonly licenseAffected?: boolean | null, readonly open?: boolean | null, readonly questionType: NurseBackgroundQuestionType }> | null, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly background: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly status: ApplicationReadinessStatus } } }, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly backgroundQuestions: { readonly __typename?: 'ProfileCompletionStep', readonly message?: string | null, readonly label: string, readonly status: ProfileCompletionStatusEnum } } } | null } | null } } | null };

export type BackgroundInfoUserPanelQueryVariables = Exact<{ [key: string]: never; }>;


export type BackgroundInfoUserPanelQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly state?: string | null, readonly backgroundComplete: boolean, readonly backgroundQuestions?: ReadonlyArray<{ readonly __typename?: 'NurseBackgroundQuestion', readonly id: string, readonly answer?: boolean | null, readonly date?: GraphQLISO8601Date | null, readonly explanation?: string | null, readonly licenseAffected?: boolean | null, readonly open?: boolean | null, readonly questionType: NurseBackgroundQuestionType }> | null, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly background: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly status: ApplicationReadinessStatus } } }, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly backgroundQuestions: { readonly __typename?: 'ProfileCompletionStep', readonly message?: string | null, readonly label: string, readonly status: ProfileCompletionStatusEnum } } } | null } | null } | null };

export type CeuCertificatesListNurseProfileFragment = { readonly __typename?: 'NurseProfile', readonly id: string, readonly ceuCertificates: ReadonlyArray<{ readonly __typename?: 'CeuCertificate', readonly id: string, readonly name: string, readonly contactHours: number, readonly ceuCertificateType: CeuCertificateType, readonly completionDate: GraphQLISO8601Date, readonly providerNumber: string, readonly files: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> }>, readonly ceuGoals?: ReadonlyArray<{ readonly __typename?: 'CeuGoal', readonly id: string, readonly goalType?: string | null, readonly accepted: boolean, readonly deleted: boolean, readonly requiredContactHours: number, readonly startDate: GraphQLISO8601Date, readonly endDate?: GraphQLISO8601Date | null, readonly systemCreated: boolean, readonly description?: string | null, readonly completedContactHours: number, readonly ceuStateRequirement?: { readonly __typename?: 'CeuStateRequirement', readonly id: string, readonly state: string, readonly requirementDescription?: ReadonlyArray<string> | null } | null, readonly ceuCertificates: ReadonlyArray<{ readonly __typename?: 'CeuCertificate', readonly id: string }> }> | null };

export type CeuCertificatesListItemCeuCertificateFragment = { readonly __typename?: 'CeuCertificate', readonly id: string, readonly name: string, readonly contactHours: number, readonly ceuCertificateType: CeuCertificateType, readonly completionDate: GraphQLISO8601Date, readonly providerNumber: string, readonly files: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> };

export type CeuCertsByTimeAndGoalTypeQueryVariables = Exact<{
  timePeriod?: InputMaybe<Scalars['String']['input']>;
  goalType?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
}>;


export type CeuCertsByTimeAndGoalTypeQuery = { readonly __typename?: 'Query', readonly ceuCertsByTimeAndGoalType?: { readonly __typename?: 'CeuCertificatesConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly startCursor?: string | null, readonly endCursor?: string | null, readonly hasPreviousPage: boolean, readonly hasNextPage: boolean }, readonly edges?: ReadonlyArray<{ readonly __typename?: 'CeuCertificateEdge', readonly cursor: string, readonly node?: { readonly __typename?: 'CeuCertificate', readonly id: string, readonly name: string, readonly contactHours: number, readonly ceuCertificateType: CeuCertificateType, readonly completionDate: GraphQLISO8601Date, readonly providerNumber: string, readonly files: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> } | null }> | null } | null };

export type CeuCertificatesForDateQueryVariables = Exact<{
  startDate: Scalars['ISO8601Date']['input'];
  endDate: Scalars['ISO8601Date']['input'];
}>;


export type CeuCertificatesForDateQuery = { readonly __typename?: 'Query', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly ceuCertificatesForDate: ReadonlyArray<{ readonly __typename?: 'CeuCertificate', readonly id: string, readonly name: string, readonly contactHours: number }> } | null };

export type CeuGoalFormCeuGoalFragment = { readonly __typename?: 'CeuGoal', readonly id: string, readonly goalType?: string | null, readonly requiredContactHours: number, readonly startDate: GraphQLISO8601Date, readonly endDate?: GraphQLISO8601Date | null, readonly description?: string | null, readonly ceuStateRequirement?: { readonly __typename?: 'CeuStateRequirement', readonly id: string } | null, readonly ceuCertificates: ReadonlyArray<{ readonly __typename?: 'CeuCertificate', readonly id: string }> };

export type CeuStateRequirementsQueryVariables = Exact<{ [key: string]: never; }>;


export type CeuStateRequirementsQuery = { readonly __typename?: 'Query', readonly ceuStateRequirements: ReadonlyArray<{ readonly __typename?: 'CeuStateRequirement', readonly id: string, readonly state: string, readonly requirementQuantity?: number | null, readonly requirementDescription?: ReadonlyArray<string> | null, readonly requiredContactHours?: number | null, readonly durationDays?: number | null, readonly stateBonUrl?: string | null, readonly notes?: string | null }> };

export type CostOfLivingFocusedStatFragment = { readonly __typename?: 'Stat', readonly statId: string, readonly statName: string, readonly valueFloat?: number | null };

export type CostOfLivingStatFragment = { readonly __typename?: 'Stat', readonly statId: string, readonly valueFloat?: number | null };

export type BackgroundAndIdDocumentTableNurseProfileFragment = { readonly __typename?: 'NurseProfile', readonly id: string, readonly idDocs?: ReadonlyArray<{ readonly __typename?: 'Document', readonly id: string, readonly title?: string | null, readonly docType?: string | null, readonly isExpirable: boolean, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly docSubtype?: string | null, readonly expirationType?: DocumentExpiration | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null };

export type BackgroundAndIdDocumentTableDocumentTemplateFragment = { readonly __typename?: 'DocumentTemplate', readonly id: number, readonly key?: string | null, readonly name?: string | null, readonly types?: ReadonlyArray<string> | null, readonly expirationType?: DocumentExpiration | null };

export type BackgroundAndIdDocumentTableIdDocumentFragment = { readonly __typename?: 'Document', readonly id: string, readonly title?: string | null, readonly docType?: string | null, readonly isExpirable: boolean, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly docSubtype?: string | null, readonly expirationType?: DocumentExpiration | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null };

export type CreateIdentificationDocumentMutationVariables = Exact<{
  input: CreateIdentificationDocumentInput;
  fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type CreateIdentificationDocumentMutation = { readonly __typename?: 'Mutation', readonly createIdentificationDocument?: { readonly __typename?: 'CreateIdentificationDocumentPayload', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly idDocs?: ReadonlyArray<{ readonly __typename?: 'Document', readonly id: string, readonly title?: string | null, readonly docType?: string | null, readonly isExpirable: boolean, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly docSubtype?: string | null, readonly expirationType?: DocumentExpiration | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ValidationError', readonly errors: ReadonlyArray<string> }> | null } | null };

export type UpdateIdentificationDocumentMutationVariables = Exact<{
  input: UpdateIdentificationDocumentInput;
  documentId: Scalars['ID']['input'];
  fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type UpdateIdentificationDocumentMutation = { readonly __typename?: 'Mutation', readonly updateIdentificationDocument?: { readonly __typename?: 'UpdateIdentificationDocumentPayload', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly idDocs?: ReadonlyArray<{ readonly __typename?: 'Document', readonly id: string, readonly title?: string | null, readonly docType?: string | null, readonly isExpirable: boolean, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly docSubtype?: string | null, readonly expirationType?: DocumentExpiration | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ValidationError', readonly errors: ReadonlyArray<string> }> | null } | null };

export type DeleteIdentificationDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteIdentificationDocumentMutation = { readonly __typename?: 'Mutation', readonly deleteIdentificationDocument?: { readonly __typename?: 'DeleteIdentificationDocumentPayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly idDocs?: ReadonlyArray<{ readonly __typename?: 'Document', readonly id: string, readonly title?: string | null, readonly docType?: string | null, readonly isExpirable: boolean, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly docSubtype?: string | null, readonly expirationType?: DocumentExpiration | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null } } | null };

export type BackgroundAndIdTableQueryVariables = Exact<{ [key: string]: never; }>;


export type BackgroundAndIdTableQuery = { readonly __typename?: 'Query', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly idDocs?: ReadonlyArray<{ readonly __typename?: 'Document', readonly id: string, readonly title?: string | null, readonly docType?: string | null, readonly isExpirable: boolean, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly docSubtype?: string | null, readonly expirationType?: DocumentExpiration | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null } | null, readonly documentTemplates: ReadonlyArray<{ readonly __typename?: 'DocumentTemplate', readonly id: number, readonly key?: string | null, readonly name?: string | null, readonly types?: ReadonlyArray<string> | null, readonly expirationType?: DocumentExpiration | null }> };

export type CertificationsTableRowNurseCertificationFragment = { readonly __typename?: 'NurseCertification', readonly id: string, readonly issuingBody?: string | null, readonly isExpiringSoon?: boolean | null, readonly isExpired?: boolean | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly name?: string | null } };

export type CertificationsTableQueryVariables = Exact<{ [key: string]: never; }>;


export type CertificationsTableQuery = { readonly __typename?: 'Query', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nurseCertifications?: ReadonlyArray<{ readonly __typename?: 'NurseCertification', readonly id: string, readonly issuingBody?: string | null, readonly isExpiringSoon?: boolean | null, readonly isExpired?: boolean | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly name?: string | null } }> | null } | null };

export type HealthDocumentsTableHealthDocFragment = { readonly __typename?: 'NurseHealthDoc', readonly id: string, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly category?: string | null, readonly completedOn?: GraphQLISO8601Date | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null, readonly healthDoc: { readonly __typename?: 'HealthDoc', readonly id: string, readonly name?: string | null, readonly categories?: ReadonlyArray<string | null> | null } };

export type HealthDocumentsTableQueryVariables = Exact<{ [key: string]: never; }>;


export type HealthDocumentsTableQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nurseHealthDocs?: ReadonlyArray<{ readonly __typename?: 'NurseHealthDoc', readonly id: string, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly category?: string | null, readonly completedOn?: GraphQLISO8601Date | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null, readonly healthDoc: { readonly __typename?: 'HealthDoc', readonly id: string, readonly name?: string | null, readonly categories?: ReadonlyArray<string | null> | null } }> | null } | null } | null };

export type LicensesTableItemLicenseFragment = { readonly __typename?: 'License', readonly id: string, readonly number?: string | null, readonly state?: string | null, readonly licensureCompact?: string | null, readonly isExpiringSoon: boolean, readonly isExpired: boolean, readonly expiresOn?: GraphQLISO8601Date | null, readonly friendlyLicenseType?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null };

export type LicensesTableVerificationItemLicenseVerificationFragment = { readonly __typename?: 'NurseLicenseVerification', readonly id: string, readonly state?: string | null, readonly states: ReadonlyArray<string>, readonly verificationType?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly dateOfDownload?: GraphQLISO8601Date | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null };

export type LicensesTableQueryVariables = Exact<{ [key: string]: never; }>;


export type LicensesTableQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly ssnLast4?: string | null, readonly birthday?: GraphQLISO8601Date | null, readonly licenses?: ReadonlyArray<{ readonly __typename?: 'License', readonly id: string, readonly number?: string | null, readonly state?: string | null, readonly licensureCompact?: string | null, readonly isExpiringSoon: boolean, readonly isExpired: boolean, readonly expiresOn?: GraphQLISO8601Date | null, readonly friendlyLicenseType?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null, readonly nurseLicenseVerifications?: ReadonlyArray<{ readonly __typename?: 'NurseLicenseVerification', readonly id: string, readonly state?: string | null, readonly states: ReadonlyArray<string>, readonly verificationType?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly dateOfDownload?: GraphQLISO8601Date | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly key?: string | null, readonly name: string, readonly type?: RoleType | null } | null } | null } | null };

export type MiscDocumentsTableDocumentFragment = { readonly __typename?: 'Document', readonly id: string, readonly title?: string | null, readonly docType?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null };

export type MiscDocumentsTableQueryVariables = Exact<{ [key: string]: never; }>;


export type MiscDocumentsTableQuery = { readonly __typename?: 'Query', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly documents?: ReadonlyArray<{ readonly __typename?: 'Document', readonly id: string, readonly title?: string | null, readonly docType?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null> | null } | null };

export type NurseAssessmentsTableNurseAssessmentFragment = { readonly __typename?: 'NurseAssessment', readonly id: string, readonly completedOn?: GraphQLISO8601Date | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly isArchived: boolean, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly score?: number | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly category?: string | null, readonly issuingBody?: string | null, readonly name?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null, readonly assessmentRequest?: { readonly __typename?: 'AssessmentRequest', readonly id: string, readonly score?: string | null } | null };

export type NurseAssessmentsTableQueryVariables = Exact<{ [key: string]: never; }>;


export type NurseAssessmentsTableQuery = { readonly __typename?: 'Query', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nurseAssessments?: ReadonlyArray<{ readonly __typename?: 'NurseAssessment', readonly id: string, readonly completedOn?: GraphQLISO8601Date | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly isArchived: boolean, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly score?: number | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly category?: string | null, readonly issuingBody?: string | null, readonly name?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null, readonly assessmentRequest?: { readonly __typename?: 'AssessmentRequest', readonly id: string, readonly score?: string | null } | null }> | null } | null };

export type ExplorerPageHeaderUserFragment = { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly canViewJobs: boolean, readonly yearsOfExp?: number | null, readonly businesses?: ReadonlyArray<{ readonly __typename?: 'Facility', readonly name: string, readonly address: string, readonly state?: string | null, readonly id: string, readonly slug: string }> | null, readonly searchHistory?: { readonly __typename?: 'SearchHistory', readonly id: string, readonly searchForm: string, readonly searchHistoryEntries: ReadonlyArray<{ readonly __typename?: 'SearchHistoryEntry', readonly id: string, readonly searchParams: string }> } | null } | null };

export type ExplorerPageHeaderLocationFragment = { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null };

export type CreateLocationSharedLinkMutationVariables = Exact<{
  input: CreateLocationSharedLinkInput;
}>;


export type CreateLocationSharedLinkMutation = { readonly __typename?: 'Mutation', readonly createLocationSharedLink?: { readonly __typename?: 'CreateLocationSharedLinkPayload', readonly sharedLink: { readonly __typename?: 'SharedLink', readonly id: string, readonly shortUrl?: string | null, readonly longUrl: string } } | null };

export type FacilitiesCardUserFragment = { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly businesses?: ReadonlyArray<{ readonly __typename?: 'Facility', readonly id: string, readonly slug: string }> | null } | null };

export type FacilitiesCardLocationFragment = { readonly __typename?: 'Location', readonly locationString?: string | null, readonly latitude?: number | null, readonly longitude?: number | null, readonly facilities?: ReadonlyArray<{ readonly __typename?: 'Facility', readonly id: string, readonly slug: string, readonly name: string, readonly logo?: string | null, readonly city?: string | null, readonly state?: string | null, readonly latitude: number, readonly longitude: number, readonly hospital?: { readonly __typename?: 'Hospital', readonly id: string, readonly affiliatedUnion?: string | null, readonly jointCommission: boolean, readonly magnet: boolean, readonly teaching: boolean, readonly totalLicensedBeds?: number | null, readonly traumaCenterLevel?: number | null, readonly hospitalType?: string | null } | null, readonly residencyPrograms?: ReadonlyArray<{ readonly __typename?: 'ResidencyProgram', readonly id: string }> | null, readonly rankings?: ReadonlyArray<{ readonly __typename?: 'UsnewsRanking', readonly id: string, readonly usnewsType: string }> | null }> | null };

export type RecentSearchesCardSearchHistoryFragment = { readonly __typename?: 'SearchHistory', readonly id: string, readonly searchForm: string, readonly searchHistoryEntries: ReadonlyArray<{ readonly __typename?: 'SearchHistoryEntry', readonly id: string, readonly searchParams: string }> };

export type RecentSearchesCardSearchHistoryEntryFragment = { readonly __typename?: 'SearchHistoryEntry', readonly id: string, readonly searchParams: string };

export type CreateSalarySearchHistoryEntryMutationVariables = Exact<{
  nurseProfileId: Scalars['ID']['input'];
  searchForm: Scalars['String']['input'];
  input: CreateSalarySearchHistoryEntryInput;
}>;


export type CreateSalarySearchHistoryEntryMutation = { readonly __typename?: 'Mutation', readonly createSalarySearchHistoryEntry?: { readonly __typename?: 'CreateSalarySearchHistoryEntryPayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly searchHistory?: { readonly __typename?: 'SearchHistory', readonly id: string, readonly searchForm: string, readonly searchHistoryEntries: ReadonlyArray<{ readonly __typename?: 'SearchHistoryEntry', readonly id: string, readonly searchParams: string }> } | null } } | null };

export type UpdateSearchHistoryEntryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateSearchHistoryEntryInput;
  searchForm: Scalars['String']['input'];
}>;


export type UpdateSearchHistoryEntryMutation = { readonly __typename?: 'Mutation', readonly updateSearchHistoryEntry?: { readonly __typename?: 'UpdateSearchHistoryEntryPayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly searchHistory?: { readonly __typename?: 'SearchHistory', readonly id: string, readonly searchForm: string, readonly searchHistoryEntries: ReadonlyArray<{ readonly __typename?: 'SearchHistoryEntry', readonly id: string, readonly searchParams: string }> } | null } } | null };

export type DeleteSearchHistoryEntryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  searchForm: Scalars['String']['input'];
}>;


export type DeleteSearchHistoryEntryMutation = { readonly __typename?: 'Mutation', readonly deleteSearchHistoryEntry?: { readonly __typename?: 'DeleteSearchHistoryEntryPayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly searchHistory?: { readonly __typename?: 'SearchHistory', readonly id: string, readonly searchForm: string, readonly searchHistoryEntries: ReadonlyArray<{ readonly __typename?: 'SearchHistoryEntry', readonly id: string, readonly searchParams: string }> } | null } } | null };

export type FacilitiesSearchItemFacilityFragment = { readonly __typename?: 'Facility', readonly id: string, readonly logo?: string | null, readonly name: string, readonly state?: string | null, readonly city?: string | null, readonly hospital?: { readonly __typename?: 'Hospital', readonly id: string, readonly totalLicensedBeds?: number | null, readonly traumaCenterLevel?: number | null, readonly hospitalType?: string | null, readonly affiliatedUnion?: string | null, readonly teaching: boolean, readonly jointCommission: boolean, readonly magnet: boolean } | null, readonly residencyPrograms?: ReadonlyArray<{ readonly __typename?: 'ResidencyProgram', readonly id: string, readonly url?: string | null, readonly accreditingBody?: string | null }> | null };

export type FacilitiesSearchItemSummaryFacilityFragment = { readonly __typename?: 'Facility', readonly id: string, readonly hospital?: { readonly __typename?: 'Hospital', readonly id: string, readonly totalLicensedBeds?: number | null, readonly traumaCenterLevel?: number | null, readonly hospitalType?: string | null, readonly affiliatedUnion?: string | null, readonly teaching: boolean, readonly jointCommission: boolean, readonly magnet: boolean } | null, readonly residencyPrograms?: ReadonlyArray<{ readonly __typename?: 'ResidencyProgram', readonly id: string, readonly url?: string | null, readonly accreditingBody?: string | null }> | null };

export type FacilityGoogleMapFacilityFragment = { readonly __typename?: 'Facility', readonly id: string, readonly slug: string, readonly name: string, readonly logo?: string | null, readonly latitude: number, readonly longitude: number };

export type FacilityLoggedInPageFacilityFragment = { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly city?: string | null, readonly state?: string | null, readonly latitude: number, readonly longitude: number, readonly address: string, readonly zipcode?: string | null, readonly slug: string, readonly logo?: string | null, readonly dhcProviderWebsite?: string | null, readonly rankings?: ReadonlyArray<{ readonly __typename?: 'UsnewsRanking', readonly id: string, readonly usnewsType: string, readonly rank?: number | null, readonly specialtyName?: string | null }> | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateName?: string | null } | null, readonly residencyPrograms?: ReadonlyArray<{ readonly __typename?: 'ResidencyProgram', readonly id: string, readonly accreditingBody?: string | null, readonly name?: string | null, readonly url?: string | null, readonly offersAllSpecialties: boolean, readonly clinicalSpecialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string }> | null }> | null, readonly nearbyFacilities?: ReadonlyArray<{ readonly __typename?: 'NearbyFacility', readonly distance?: number | null, readonly facility: { readonly __typename?: 'Facility', readonly id: string, readonly slug: string, readonly logo?: string | null, readonly name: string, readonly city?: string | null, readonly state?: string | null } }> | null, readonly costOfLivingStats?: ReadonlyArray<{ readonly __typename?: 'Stat', readonly statId: string, readonly statName: string, readonly valueFloat?: number | null }> | null, readonly hospital?: { readonly __typename?: 'Hospital', readonly id: string, readonly hospitalType?: string | null, readonly totalLicensedBeds?: number | null, readonly traumaCenterLevel?: number | null, readonly jointCommission: boolean, readonly magnet: boolean, readonly teaching: boolean, readonly affiliatedUnion?: string | null, readonly hospitalSystem?: string | null } | null, readonly walkscoreByCoordinates?: { readonly __typename?: 'Walkscore', readonly walkScore?: number | null, readonly walkDescription?: string | null, readonly walkExtraInfo?: string | null, readonly transitScore?: number | null, readonly transitDescription?: string | null, readonly transitExtraInfo?: string | null, readonly bikeScore?: number | null, readonly bikeDescription?: string | null, readonly bikeExtraInfo?: string | null } | null, readonly cityWalkscore?: { readonly __typename?: 'Walkscore', readonly walkScore?: number | null, readonly walkDescription?: string | null, readonly walkExtraInfo?: string | null, readonly transitScore?: number | null, readonly transitDescription?: string | null, readonly transitExtraInfo?: string | null, readonly bikeScore?: number | null, readonly bikeDescription?: string | null, readonly bikeExtraInfo?: string | null } | null, readonly surveyForUser?: { readonly __typename?: 'FacilitySurveyResponse', readonly completedAt?: GraphQLISO8601Date | null } | null };

export type FacilityLoggedInPageUserFragment = { readonly __typename?: 'User', readonly id: string, readonly uuid: string, readonly email: string, readonly intercomUserHash?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nurseType?: string | null, readonly savedFacility: boolean } | null };

export type FacilityLoggedOutPageFacilityFragment = { readonly __typename?: 'Facility', readonly id: string, readonly slug: string, readonly city?: string | null, readonly state?: string | null, readonly latitude: number, readonly longitude: number, readonly name: string, readonly address: string, readonly zipcode?: string | null, readonly logo?: string | null, readonly dhcProviderWebsite?: string | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateName?: string | null } | null, readonly rankings?: ReadonlyArray<{ readonly __typename?: 'UsnewsRanking', readonly id: string, readonly usnewsType: string, readonly rank?: number | null, readonly specialtyName?: string | null }> | null, readonly residencyPrograms?: ReadonlyArray<{ readonly __typename?: 'ResidencyProgram', readonly id: string, readonly accreditingBody?: string | null, readonly name?: string | null, readonly url?: string | null, readonly offersAllSpecialties: boolean, readonly clinicalSpecialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string }> | null }> | null, readonly nearbyFacilities?: ReadonlyArray<{ readonly __typename?: 'NearbyFacility', readonly distance?: number | null, readonly facility: { readonly __typename?: 'Facility', readonly id: string, readonly slug: string, readonly logo?: string | null, readonly name: string, readonly city?: string | null, readonly state?: string | null } }> | null, readonly costOfLivingStats?: ReadonlyArray<{ readonly __typename?: 'Stat', readonly statId: string, readonly statName: string, readonly valueFloat?: number | null }> | null, readonly walkscoreByCoordinates?: { readonly __typename?: 'Walkscore', readonly walkScore?: number | null, readonly walkDescription?: string | null, readonly walkExtraInfo?: string | null, readonly transitScore?: number | null, readonly transitDescription?: string | null, readonly transitExtraInfo?: string | null, readonly bikeScore?: number | null, readonly bikeDescription?: string | null, readonly bikeExtraInfo?: string | null } | null, readonly cityWalkscore?: { readonly __typename?: 'Walkscore', readonly walkScore?: number | null, readonly walkDescription?: string | null, readonly walkExtraInfo?: string | null, readonly transitScore?: number | null, readonly transitDescription?: string | null, readonly transitExtraInfo?: string | null, readonly bikeScore?: number | null, readonly bikeDescription?: string | null, readonly bikeExtraInfo?: string | null } | null, readonly hospital?: { readonly __typename?: 'Hospital', readonly id: string, readonly hospitalType?: string | null, readonly totalLicensedBeds?: number | null, readonly traumaCenterLevel?: number | null, readonly jointCommission: boolean, readonly magnet: boolean, readonly teaching: boolean, readonly affiliatedUnion?: string | null, readonly hospitalSystem?: string | null } | null, readonly surveyForUser?: { readonly __typename?: 'FacilitySurveyResponse', readonly completedAt?: GraphQLISO8601Date | null } | null };

export type FacilityPageFacilityFragment = { readonly __typename?: 'Facility', readonly id: string, readonly city?: string | null, readonly state?: string | null, readonly latitude: number, readonly longitude: number, readonly name: string, readonly address: string, readonly zipcode?: string | null, readonly slug: string, readonly logo?: string | null, readonly dhcProviderWebsite?: string | null, readonly rankings?: ReadonlyArray<{ readonly __typename?: 'UsnewsRanking', readonly id: string, readonly usnewsType: string, readonly rank?: number | null, readonly specialtyName?: string | null }> | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateName?: string | null } | null, readonly residencyPrograms?: ReadonlyArray<{ readonly __typename?: 'ResidencyProgram', readonly id: string, readonly accreditingBody?: string | null, readonly name?: string | null, readonly url?: string | null, readonly offersAllSpecialties: boolean, readonly clinicalSpecialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string }> | null }> | null, readonly nearbyFacilities?: ReadonlyArray<{ readonly __typename?: 'NearbyFacility', readonly distance?: number | null, readonly facility: { readonly __typename?: 'Facility', readonly id: string, readonly slug: string, readonly logo?: string | null, readonly name: string, readonly city?: string | null, readonly state?: string | null } }> | null, readonly costOfLivingStats?: ReadonlyArray<{ readonly __typename?: 'Stat', readonly statId: string, readonly statName: string, readonly valueFloat?: number | null }> | null, readonly walkscoreByCoordinates?: { readonly __typename?: 'Walkscore', readonly walkScore?: number | null, readonly walkDescription?: string | null, readonly walkExtraInfo?: string | null, readonly transitScore?: number | null, readonly transitDescription?: string | null, readonly transitExtraInfo?: string | null, readonly bikeScore?: number | null, readonly bikeDescription?: string | null, readonly bikeExtraInfo?: string | null } | null, readonly cityWalkscore?: { readonly __typename?: 'Walkscore', readonly walkScore?: number | null, readonly walkDescription?: string | null, readonly walkExtraInfo?: string | null, readonly transitScore?: number | null, readonly transitDescription?: string | null, readonly transitExtraInfo?: string | null, readonly bikeScore?: number | null, readonly bikeDescription?: string | null, readonly bikeExtraInfo?: string | null } | null, readonly hospital?: { readonly __typename?: 'Hospital', readonly id: string, readonly hospitalType?: string | null, readonly totalLicensedBeds?: number | null, readonly traumaCenterLevel?: number | null, readonly jointCommission: boolean, readonly magnet: boolean, readonly teaching: boolean, readonly affiliatedUnion?: string | null, readonly hospitalSystem?: string | null } | null, readonly surveyForUser?: { readonly __typename?: 'FacilitySurveyResponse', readonly completedAt?: GraphQLISO8601Date | null } | null };

export type FacilityPageUsnewsRankingFragment = { readonly __typename?: 'UsnewsRanking', readonly id: string, readonly usnewsType: string, readonly rank?: number | null, readonly specialtyName?: string | null };

export type FacilityPageUserFragment = { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nurseType?: string | null, readonly savedFacility: boolean } | null };

export type FacilityPageHeroContainerFragment = { readonly __typename?: 'Facility', readonly id: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateName?: string | null } | null };

export type FacilitySummaryFacilityFragment = { readonly __typename?: 'Facility', readonly id: string, readonly slug: string, readonly logo?: string | null, readonly name: string, readonly address: string, readonly city?: string | null, readonly state?: string | null, readonly zipcode?: string | null, readonly dhcProviderWebsite?: string | null, readonly residencyPrograms?: ReadonlyArray<{ readonly __typename?: 'ResidencyProgram', readonly id: string, readonly accreditingBody?: string | null }> | null, readonly hospital?: { readonly __typename?: 'Hospital', readonly id: string, readonly hospitalType?: string | null, readonly totalLicensedBeds?: number | null, readonly traumaCenterLevel?: number | null, readonly jointCommission: boolean, readonly magnet: boolean, readonly teaching: boolean, readonly affiliatedUnion?: string | null, readonly hospitalSystem?: string | null } | null, readonly surveyForUser?: { readonly __typename?: 'FacilitySurveyResponse', readonly completedAt?: GraphQLISO8601Date | null } | null };

export type FacilitySummarySurveyFacilityFragment = { readonly __typename?: 'Facility', readonly id: string, readonly slug: string, readonly name: string, readonly surveyForUser?: { readonly __typename?: 'FacilitySurveyResponse', readonly completedAt?: GraphQLISO8601Date | null } | null };

export type FacilitySummaryInformationFacilityFragment = { readonly __typename?: 'Facility', readonly name: string, readonly address: string, readonly city?: string | null, readonly state?: string | null, readonly zipcode?: string | null, readonly dhcProviderWebsite?: string | null, readonly hospital?: { readonly __typename?: 'Hospital', readonly id: string, readonly hospitalSystem?: string | null } | null };

export type FacilityHospitalSummaryFeaturesFacilityFragment = { readonly __typename?: 'Hospital', readonly id: string, readonly totalLicensedBeds?: number | null, readonly traumaCenterLevel?: number | null, readonly hospitalType?: string | null };

export type FacilitySummaryAccreditationsFacilityFragment = { readonly __typename?: 'Facility', readonly hospital?: { readonly __typename?: 'Hospital', readonly affiliatedUnion?: string | null, readonly teaching: boolean, readonly jointCommission: boolean, readonly magnet: boolean } | null, readonly residencyPrograms?: ReadonlyArray<{ readonly __typename?: 'ResidencyProgram', readonly accreditingBody?: string | null }> | null };

export type FacilitySurveyResponseForUserQueryVariables = Exact<{
  facilitySlug: Scalars['String']['input'];
}>;


export type FacilitySurveyResponseForUserQuery = { readonly __typename?: 'Query', readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly surveyForUser?: { readonly __typename?: 'FacilitySurveyResponse', readonly id: string, readonly completedAt?: GraphQLISO8601Date | null } | null } | null };

export type NearbyFacilitiesCardFacilityFragment = { readonly __typename?: 'NearbyFacility', readonly distance?: number | null, readonly facility: { readonly __typename?: 'Facility', readonly id: string, readonly slug: string, readonly logo?: string | null, readonly name: string, readonly city?: string | null, readonly state?: string | null } };

export type ResidencyProgramsCardFragment = { readonly __typename?: 'ResidencyProgram', readonly id: string, readonly name?: string | null, readonly accreditingBody?: string | null, readonly url?: string | null, readonly offersAllSpecialties: boolean, readonly clinicalSpecialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string }> | null };

export type UsnewsRankingContainerUsnewsRankingFragment = { readonly __typename?: 'UsnewsRanking', readonly id: string, readonly rank?: number | null, readonly specialtyName?: string | null, readonly usnewsType: string };

export type WalkscoreMapFacilityFragment = { readonly __typename?: 'Facility', readonly latitude: number, readonly longitude: number, readonly name: string, readonly address: string, readonly city?: string | null, readonly state?: string | null, readonly zipcode?: string | null, readonly walkscoreByCoordinates?: { readonly __typename?: 'Walkscore', readonly walkScore?: number | null, readonly walkDescription?: string | null, readonly walkExtraInfo?: string | null, readonly transitScore?: number | null, readonly transitDescription?: string | null, readonly transitExtraInfo?: string | null, readonly bikeScore?: number | null, readonly bikeDescription?: string | null, readonly bikeExtraInfo?: string | null } | null, readonly cityWalkscore?: { readonly __typename?: 'Walkscore', readonly walkScore?: number | null, readonly walkDescription?: string | null, readonly walkExtraInfo?: string | null, readonly transitScore?: number | null, readonly transitDescription?: string | null, readonly transitExtraInfo?: string | null, readonly bikeScore?: number | null, readonly bikeDescription?: string | null, readonly bikeExtraInfo?: string | null } | null };

export type WalkscoreMapFragment = { readonly __typename?: 'Walkscore', readonly walkScore?: number | null, readonly walkDescription?: string | null, readonly walkExtraInfo?: string | null, readonly transitScore?: number | null, readonly transitDescription?: string | null, readonly transitExtraInfo?: string | null, readonly bikeScore?: number | null, readonly bikeDescription?: string | null, readonly bikeExtraInfo?: string | null };

export type FacilityResultCardFacilityFragment = { readonly __typename?: 'Facility', readonly id: string, readonly slug: string, readonly name: string, readonly logo?: string | null, readonly city?: string | null, readonly state?: string | null, readonly hospital?: { readonly __typename?: 'Hospital', readonly id: string, readonly affiliatedUnion?: string | null, readonly jointCommission: boolean, readonly magnet: boolean, readonly teaching: boolean, readonly totalLicensedBeds?: number | null, readonly traumaCenterLevel?: number | null, readonly hospitalType?: string | null } | null, readonly residencyPrograms?: ReadonlyArray<{ readonly __typename?: 'ResidencyProgram', readonly id: string }> | null, readonly rankings?: ReadonlyArray<{ readonly __typename?: 'UsnewsRanking', readonly id: string, readonly usnewsType: string }> | null };

export type FacilityResultCardUserFragment = { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly businesses?: ReadonlyArray<{ readonly __typename?: 'Facility', readonly id: string, readonly slug: string }> | null } | null };

export type FacilityResultCardBusinessFragment = { readonly __typename?: 'Facility', readonly id: string, readonly slug: string };

export type NurseCertificationFormFragment = { readonly __typename?: 'NurseCertification', readonly id: string, readonly name?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly useCompletionDate?: boolean | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly name?: string | null, readonly issuingBody?: string | null, readonly issuingBodies: ReadonlyArray<string>, readonly credential?: string | null }, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null };

export type NurseProfileIntentFragment = { readonly __typename?: 'NurseProfile', readonly id: string, readonly staleIntent: boolean, readonly activationRequest: { readonly __typename?: 'ActivationRequest', readonly id: string, readonly earliestStartDateAt?: GraphQLISO8601Date | null }, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly startPref?: string | null, readonly broadPrefLocations?: ReadonlyArray<BroadPrefLocations> | null, readonly locations?: ReadonlyArray<{ readonly __typename?: 'Location', readonly id: string, readonly locationString?: string | null }> | null } | null };

export type IntentFormModalNursePreferencesFragment = { readonly __typename?: 'NursePreferences', readonly id: string, readonly startPref?: string | null, readonly earliestStartDate?: GraphQLISO8601Date | null };

export type IntentFormModalUpdateStaleIntentMutationVariables = Exact<{
  input: UpdateStaleIntentInput;
}>;


export type IntentFormModalUpdateStaleIntentMutation = { readonly __typename?: 'Mutation', readonly updateStaleIntent?: { readonly __typename?: 'UpdateStaleIntentPayload', readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly startPref?: string | null, readonly earliestStartDate?: GraphQLISO8601Date | null } | null } | null };

export type IntentFormDataQueryVariables = Exact<{ [key: string]: never; }>;


export type IntentFormDataQuery = { readonly __typename?: 'Query', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly staleIntent: boolean, readonly activationRequest: { readonly __typename?: 'ActivationRequest', readonly id: string, readonly earliestStartDateAt?: GraphQLISO8601Date | null }, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly startPref?: string | null, readonly broadPrefLocations?: ReadonlyArray<BroadPrefLocations> | null, readonly locations?: ReadonlyArray<{ readonly __typename?: 'Location', readonly id: string, readonly locationString?: string | null }> | null } | null } | null };

export type ReferralListReferralFragment = { readonly __typename?: 'Referral', readonly firstName: string, readonly lastName: string, readonly status: string, readonly statusDate: GraphQLISO8601Date };

export type ActivationJobAlertModalQueryVariables = Exact<{ [key: string]: never; }>;


export type ActivationJobAlertModalQuery = { readonly __typename?: 'Query', readonly jobAlertsPendingView: ReadonlyArray<{ readonly __typename?: 'JobAlert', readonly id: string, readonly broadPrefLocations: ReadonlyArray<BroadPrefLocations>, readonly contractLengths: ReadonlyArray<ContractLength>, readonly locationStrings: ReadonlyArray<string>, readonly shiftLengths: ReadonlyArray<string>, readonly shiftPrefs: ReadonlyArray<string>, readonly smsEnabled: boolean, readonly specialties: ReadonlyArray<string>, readonly clinicalSpecialties: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly slug: string }> }>, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly isActivated?: boolean | null, readonly percentComplete?: number | null, readonly state?: string | null, readonly activeClinicalSpecialties: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly slug: string }>, readonly positionSpecialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly slug: string }> | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly percentCompleted: number } } | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly key?: string | null, readonly name: string, readonly type?: RoleType | null } | null, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly broadPrefLocations?: ReadonlyArray<BroadPrefLocations> | null, readonly careSettingOther?: string | null, readonly careSettingPrefs?: ReadonlyArray<string> | null, readonly contractLengths?: ReadonlyArray<string> | null, readonly earliestStartDate?: GraphQLISO8601Date | null, readonly jobSortColumn?: JobsCollectionSortField | null, readonly jobSortOrder?: JobsCollectionSortOrder | null, readonly jobTypes?: ReadonlyArray<string> | null, readonly shiftLengths?: ReadonlyArray<string> | null, readonly shiftPrefs?: ReadonlyArray<string> | null, readonly startPref?: string | null, readonly technologies?: ReadonlyArray<string> | null, readonly locations?: ReadonlyArray<{ readonly __typename?: 'Location', readonly id: string, readonly locationString?: string | null }> | null } | null } | null };

export type JobGoogleMapLocationFragment = { readonly __typename?: 'Location', readonly id: string, readonly latitude?: number | null, readonly longitude?: number | null };

export type JobLocationBlockJobFragment = { readonly __typename?: 'Job', readonly id: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly walkscore?: { readonly __typename?: 'Walkscore', readonly bikeDescription?: string | null, readonly bikeScore?: number | null, readonly transitDescription?: string | null, readonly transitScore?: number | null, readonly walkDescription?: string | null, readonly walkScore?: number | null } | null, readonly weatherForecast?: { readonly __typename?: 'WeatherForecast', readonly icon?: string | null, readonly temperature?: number | null, readonly temperatureHigh?: number | null, readonly temperatureLow?: number | null } | null } | null };

export type JobDetailWeatherForecastQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type JobDetailWeatherForecastQuery = { readonly __typename?: 'Query', readonly adJob?: { readonly __typename?: 'Job', readonly id: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly walkscore?: { readonly __typename?: 'Walkscore', readonly bikeDescription?: string | null, readonly bikeScore?: number | null, readonly transitDescription?: string | null, readonly transitScore?: number | null, readonly walkDescription?: string | null, readonly walkScore?: number | null } | null, readonly weatherForecast?: { readonly __typename?: 'WeatherForecast', readonly icon?: string | null, readonly temperature?: number | null, readonly temperatureHigh?: number | null, readonly temperatureLow?: number | null } | null } | null } | null };

export type ContractSignUrlFragment = { readonly __typename?: 'Contract', readonly docusignSignUrl?: string | null, readonly id: string, readonly hoursPerShift?: number | null, readonly shiftsPerWeek?: number | null, readonly cancellationPolicy?: string | null, readonly contractNotes?: string | null, readonly contractStatus?: string | null, readonly contractStartDate: GraphQLISO8601Date, readonly contractEndDate: GraphQLISO8601Date, readonly contractType?: string | null, readonly shiftType?: string | null, readonly currentGrossPayWeek?: number | null, readonly baseRate?: number | null, readonly lengthInWeeks?: number | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly title?: string | null, readonly facilityName?: string | null, readonly lengthInWeeks?: number | null, readonly hoursPerShift?: number | null, readonly shiftsPerWeek?: number | null, readonly shiftType?: string | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null }, readonly jobPlacement?: { readonly __typename?: 'JobPlacement', readonly id: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly name?: string | null, readonly user?: { readonly __typename?: 'User', readonly id: string, readonly email: string } | null } | null } | null, readonly timeOffs?: ReadonlyArray<{ readonly __typename?: 'TimeOff', readonly id: string, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly approvalStatus?: string | null }> | null, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string, readonly paymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly nonTaxableStipendWeekly?: number | null, readonly taxableWageRateWeekly?: number | null, readonly grossPayWeekly?: number | null } | null } | null, readonly paymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly nonTaxableStipendWeekly?: number | null, readonly taxableWageRateWeekly?: number | null, readonly grossPayWeekly?: number | null } | null };

export type JobOfferSignContractFragment = { readonly __typename?: 'JobOffer', readonly id: string, readonly contracts?: ReadonlyArray<{ readonly __typename?: 'Contract', readonly docusignSignUrl?: string | null, readonly id: string, readonly hoursPerShift?: number | null, readonly shiftsPerWeek?: number | null, readonly cancellationPolicy?: string | null, readonly contractNotes?: string | null, readonly contractStatus?: string | null, readonly contractStartDate: GraphQLISO8601Date, readonly contractEndDate: GraphQLISO8601Date, readonly contractType?: string | null, readonly shiftType?: string | null, readonly currentGrossPayWeek?: number | null, readonly baseRate?: number | null, readonly lengthInWeeks?: number | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly title?: string | null, readonly facilityName?: string | null, readonly lengthInWeeks?: number | null, readonly hoursPerShift?: number | null, readonly shiftsPerWeek?: number | null, readonly shiftType?: string | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null }, readonly jobPlacement?: { readonly __typename?: 'JobPlacement', readonly id: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly name?: string | null, readonly user?: { readonly __typename?: 'User', readonly id: string, readonly email: string } | null } | null } | null, readonly timeOffs?: ReadonlyArray<{ readonly __typename?: 'TimeOff', readonly id: string, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly approvalStatus?: string | null }> | null, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string, readonly paymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly nonTaxableStipendWeekly?: number | null, readonly taxableWageRateWeekly?: number | null, readonly grossPayWeekly?: number | null } | null } | null, readonly paymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly nonTaxableStipendWeekly?: number | null, readonly taxableWageRateWeekly?: number | null, readonly grossPayWeekly?: number | null } | null }> | null };

export type JobOffersSignContractQueryVariables = Exact<{
  filter: JobOffersFilter;
}>;


export type JobOffersSignContractQuery = { readonly __typename?: 'Query', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly jobOffers: ReadonlyArray<{ readonly __typename?: 'JobOffer', readonly id: string, readonly contracts?: ReadonlyArray<{ readonly __typename?: 'Contract', readonly docusignSignUrl?: string | null, readonly id: string, readonly hoursPerShift?: number | null, readonly shiftsPerWeek?: number | null, readonly cancellationPolicy?: string | null, readonly contractNotes?: string | null, readonly contractStatus?: string | null, readonly contractStartDate: GraphQLISO8601Date, readonly contractEndDate: GraphQLISO8601Date, readonly contractType?: string | null, readonly shiftType?: string | null, readonly currentGrossPayWeek?: number | null, readonly baseRate?: number | null, readonly lengthInWeeks?: number | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly title?: string | null, readonly facilityName?: string | null, readonly lengthInWeeks?: number | null, readonly hoursPerShift?: number | null, readonly shiftsPerWeek?: number | null, readonly shiftType?: string | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null }, readonly jobPlacement?: { readonly __typename?: 'JobPlacement', readonly id: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly name?: string | null, readonly user?: { readonly __typename?: 'User', readonly id: string, readonly email: string } | null } | null } | null, readonly timeOffs?: ReadonlyArray<{ readonly __typename?: 'TimeOff', readonly id: string, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly approvalStatus?: string | null }> | null, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string, readonly paymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly nonTaxableStipendWeekly?: number | null, readonly taxableWageRateWeekly?: number | null, readonly grossPayWeekly?: number | null } | null } | null, readonly paymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly nonTaxableStipendWeekly?: number | null, readonly taxableWageRateWeekly?: number | null, readonly grossPayWeekly?: number | null } | null }> | null }> } | null };

export type JobSearchItemJobFragment = { readonly __typename?: 'Job', readonly id: string, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly hoursPerShift?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly lengthInWeeks?: number | null, readonly grossPayWeekly?: number | null, readonly jobType?: string | null, readonly licenseType?: string | null, readonly localGrossPayWeekly?: number | null, readonly radiusRule?: number | null, readonly travelAllowed: boolean, readonly localAllowed: boolean, readonly role?: string | null, readonly roles?: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: string, readonly name: string, readonly abbreviation: string, readonly key?: string | null, readonly type?: RoleType | null }> | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly blendedWageRate?: number | null, readonly callBackRate?: number | null, readonly doubleTimeMultiplier?: number | null, readonly grossPayWeekly?: number | null, readonly holidayRate?: number | null, readonly incidentalsStipendDaily?: number | null, readonly lodgingStipendDaily?: number | null, readonly onCallRate?: number | null, readonly overtimeHoursPerWeek?: number | null, readonly overtimeMultiplier?: number | null, readonly overtimeWageRate?: number | null, readonly regularHoursPerWeek?: number | null, readonly regularWageRate?: number | null, readonly totalHoursPerWeek?: number | null, readonly totalStipendDaily?: number | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly jarRadiusRuleV2?: { readonly __typename?: 'JobApplicationRequirementsRadiusRule', readonly id: string, readonly type: string, readonly description?: string | null } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null };

export type LicenseListItemLicenseFragment = { readonly __typename?: 'License', readonly id: string, readonly uuid?: string | null, readonly licenseType?: string | null, readonly friendlyLicenseType?: string | null, readonly licensureCompact?: string | null, readonly compact?: boolean | null, readonly stateCode?: LocationUsStates | null, readonly state?: string | null, readonly number?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly title: string, readonly isExpired: boolean, readonly isExpiringSoon: boolean, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null };

export type MatchCardJobFragment = { readonly __typename?: 'Job', readonly id: string, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly localAllowed: boolean, readonly onHold?: boolean | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly facilityName?: string | null, readonly cancellationPolicy?: string | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly business?: { readonly __typename?: 'Facility', readonly city?: string | null, readonly state?: string | null, readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null };

export type ApplicableMatchCardJobFragment = { readonly __typename?: 'Job', readonly id: string, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly localAllowed: boolean, readonly onHold?: boolean | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly facilityName?: string | null, readonly cancellationPolicy?: string | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly esMatch?: { readonly __typename?: 'Match', readonly id: string, readonly userState?: string | null } | null, readonly business?: { readonly __typename?: 'Facility', readonly city?: string | null, readonly state?: string | null, readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null };

export type DraftApplicationMatchCardJobFragment = { readonly __typename?: 'Job', readonly id: string, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly localAllowed: boolean, readonly onHold?: boolean | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly facilityName?: string | null, readonly cancellationPolicy?: string | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string } | null, readonly business?: { readonly __typename?: 'Facility', readonly city?: string | null, readonly state?: string | null, readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null };

export type MatchCardUserFragment = { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly isActivated?: boolean | null, readonly percentComplete?: number | null, readonly state?: string | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly percentCompleted: number } } | null, readonly nurseAdvocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly email?: string | null, readonly fullName?: string | null } | null } | null };

export type MatchCardFacilityFragment = { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly logo?: string | null };

export type MatchCardExpressInterestMutationVariables = Exact<{
  id: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
}>;


export type MatchCardExpressInterestMutation = { readonly __typename?: 'Mutation', readonly expressInterest?: { readonly __typename?: 'Job', readonly id: string, readonly esMatch?: { readonly __typename?: 'Match', readonly id: string, readonly userState?: string | null } | null } | null };

export type MatchCardRemoveInterestMutationVariables = Exact<{
  id: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
}>;


export type MatchCardRemoveInterestMutation = { readonly __typename?: 'Mutation', readonly removeInterest?: { readonly __typename?: 'Job', readonly id: string, readonly esMatch?: { readonly __typename?: 'Match', readonly id: string, readonly userState?: string | null } | null } | null };

export type MatchCardUnhideEsMatchMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MatchCardUnhideEsMatchMutation = { readonly __typename?: 'Mutation', readonly unhideEsMatch?: { readonly __typename?: 'Match', readonly id: string, readonly userState?: string | null } | null };

export type MatchCriteriaUserFragment = { readonly __typename?: 'User', readonly id: string, readonly cityPermanent?: string | null, readonly statePermanent?: string | null, readonly streetAddressPermanent?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly isActivated?: boolean | null, readonly percentComplete?: number | null, readonly state?: string | null, readonly activeClinicalSpecialties: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly slug: string }>, readonly positionSpecialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly slug: string }> | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly percentCompleted: number } } | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly key?: string | null, readonly name: string, readonly type?: RoleType | null } | null, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly broadPrefLocations?: ReadonlyArray<BroadPrefLocations> | null, readonly careSettingOther?: string | null, readonly careSettingPrefs?: ReadonlyArray<string> | null, readonly contractLengths?: ReadonlyArray<string> | null, readonly earliestStartDate?: GraphQLISO8601Date | null, readonly jobSortColumn?: JobsCollectionSortField | null, readonly jobSortOrder?: JobsCollectionSortOrder | null, readonly jobTypes?: ReadonlyArray<string> | null, readonly shiftLengths?: ReadonlyArray<string> | null, readonly shiftPrefs?: ReadonlyArray<string> | null, readonly startPref?: string | null, readonly technologies?: ReadonlyArray<string> | null, readonly locations?: ReadonlyArray<{ readonly __typename?: 'Location', readonly id: string, readonly locationString?: string | null }> | null } | null } | null };

export type MatchCriteriaNurseProfileFragment = { readonly __typename?: 'NurseProfile', readonly id: string, readonly isActivated?: boolean | null, readonly percentComplete?: number | null, readonly state?: string | null, readonly activeClinicalSpecialties: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly slug: string }>, readonly positionSpecialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly slug: string }> | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly percentCompleted: number } } | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly key?: string | null, readonly name: string, readonly type?: RoleType | null } | null, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly broadPrefLocations?: ReadonlyArray<BroadPrefLocations> | null, readonly careSettingOther?: string | null, readonly careSettingPrefs?: ReadonlyArray<string> | null, readonly contractLengths?: ReadonlyArray<string> | null, readonly earliestStartDate?: GraphQLISO8601Date | null, readonly jobSortColumn?: JobsCollectionSortField | null, readonly jobSortOrder?: JobsCollectionSortOrder | null, readonly jobTypes?: ReadonlyArray<string> | null, readonly shiftLengths?: ReadonlyArray<string> | null, readonly shiftPrefs?: ReadonlyArray<string> | null, readonly startPref?: string | null, readonly technologies?: ReadonlyArray<string> | null, readonly locations?: ReadonlyArray<{ readonly __typename?: 'Location', readonly id: string, readonly locationString?: string | null }> | null } | null };

export type MatchCriteriaNursePreferencesFragment = { readonly __typename?: 'NursePreferences', readonly id: string, readonly broadPrefLocations?: ReadonlyArray<BroadPrefLocations> | null, readonly careSettingOther?: string | null, readonly careSettingPrefs?: ReadonlyArray<string> | null, readonly contractLengths?: ReadonlyArray<string> | null, readonly earliestStartDate?: GraphQLISO8601Date | null, readonly jobSortColumn?: JobsCollectionSortField | null, readonly jobSortOrder?: JobsCollectionSortOrder | null, readonly jobTypes?: ReadonlyArray<string> | null, readonly shiftLengths?: ReadonlyArray<string> | null, readonly shiftPrefs?: ReadonlyArray<string> | null, readonly startPref?: string | null, readonly technologies?: ReadonlyArray<string> | null, readonly locations?: ReadonlyArray<{ readonly __typename?: 'Location', readonly id: string, readonly locationString?: string | null }> | null };

export type MatchCriteriaOnUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateNursePreferencesInput;
  specialtySlugs: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type MatchCriteriaOnUpdateMutation = { readonly __typename?: 'Mutation', readonly updateNursePreferences?: { readonly __typename?: 'UpdateNursePreferencesPayload', readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly broadPrefLocations?: ReadonlyArray<BroadPrefLocations> | null, readonly careSettingOther?: string | null, readonly careSettingPrefs?: ReadonlyArray<string> | null, readonly contractLengths?: ReadonlyArray<string> | null, readonly earliestStartDate?: GraphQLISO8601Date | null, readonly jobSortColumn?: JobsCollectionSortField | null, readonly jobSortOrder?: JobsCollectionSortOrder | null, readonly jobTypes?: ReadonlyArray<string> | null, readonly shiftLengths?: ReadonlyArray<string> | null, readonly shiftPrefs?: ReadonlyArray<string> | null, readonly startPref?: string | null, readonly technologies?: ReadonlyArray<string> | null, readonly locations?: ReadonlyArray<{ readonly __typename?: 'Location', readonly id: string, readonly locationString?: string | null }> | null } | null } | null, readonly nurseProfileClinicalExperiencesUpdate?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly isActivated?: boolean | null, readonly percentComplete?: number | null, readonly state?: string | null, readonly activeClinicalSpecialties: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly slug: string }>, readonly positionSpecialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly slug: string }> | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly percentCompleted: number } } | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly key?: string | null, readonly name: string, readonly type?: RoleType | null } | null, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly broadPrefLocations?: ReadonlyArray<BroadPrefLocations> | null, readonly careSettingOther?: string | null, readonly careSettingPrefs?: ReadonlyArray<string> | null, readonly contractLengths?: ReadonlyArray<string> | null, readonly earliestStartDate?: GraphQLISO8601Date | null, readonly jobSortColumn?: JobsCollectionSortField | null, readonly jobSortOrder?: JobsCollectionSortOrder | null, readonly jobTypes?: ReadonlyArray<string> | null, readonly shiftLengths?: ReadonlyArray<string> | null, readonly shiftPrefs?: ReadonlyArray<string> | null, readonly startPref?: string | null, readonly technologies?: ReadonlyArray<string> | null, readonly locations?: ReadonlyArray<{ readonly __typename?: 'Location', readonly id: string, readonly locationString?: string | null }> | null } | null } | null };

export type MatchCriteriaResetMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateNursePreferencesInput;
}>;


export type MatchCriteriaResetMutation = { readonly __typename?: 'Mutation', readonly updateNursePreferences?: { readonly __typename?: 'UpdateNursePreferencesPayload', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly broadPrefLocations?: ReadonlyArray<BroadPrefLocations> | null, readonly careSettingOther?: string | null, readonly careSettingPrefs?: ReadonlyArray<string> | null, readonly contractLengths?: ReadonlyArray<string> | null, readonly earliestStartDate?: GraphQLISO8601Date | null, readonly jobSortColumn?: JobsCollectionSortField | null, readonly jobSortOrder?: JobsCollectionSortOrder | null, readonly jobTypes?: ReadonlyArray<string> | null, readonly shiftLengths?: ReadonlyArray<string> | null, readonly shiftPrefs?: ReadonlyArray<string> | null, readonly startPref?: string | null, readonly technologies?: ReadonlyArray<string> | null, readonly locations?: ReadonlyArray<{ readonly __typename?: 'Location', readonly id: string, readonly locationString?: string | null }> | null } | null } | null } | null };

export type JobMatchFacilityBlockJobFragment = { readonly __typename?: 'Job', readonly business?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly address: string, readonly city?: string | null, readonly logo?: string | null, readonly state?: string | null, readonly zipcode?: string | null, readonly slug: string, readonly rankings?: ReadonlyArray<{ readonly __typename?: 'UsnewsRanking', readonly id: string, readonly usnewsType: string }> | null, readonly hospital?: { readonly __typename?: 'Hospital', readonly id: string, readonly teaching: boolean, readonly traumaCenterLevel?: number | null, readonly affiliatedUnion?: string | null, readonly totalLicensedBeds?: number | null, readonly hospitalSystem?: string | null, readonly hospitalType?: string | null, readonly jointCommission: boolean, readonly magnet: boolean } | null } | null };

export type MatchApplyButtonJobFragment = { readonly __typename?: 'Job', readonly id: string, readonly instantOffer: boolean, readonly onHold?: boolean | null, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly grossPayWeekly?: number | null, readonly hoursPerShift?: number | null, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly shiftsPerWeek?: number | null, readonly shiftType?: string | null, readonly startDate?: GraphQLISO8601Date | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly canApply: { readonly __typename?: 'AuthorizationResult', readonly value: boolean, readonly reasons?: { readonly __typename?: 'FailureReasons', readonly fullMessages: ReadonlyArray<string> } | null }, readonly esMatch?: { readonly __typename?: 'Match', readonly id: string } | null, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string, readonly state?: string | null } | null, readonly business?: { readonly __typename?: 'Facility', readonly id: string, readonly city?: string | null, readonly name: string, readonly logo?: string | null, readonly state?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null };

export type MatchApplyButtonUserFragment = { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly isActivated?: boolean | null, readonly canApplyJobs: boolean, readonly state?: string | null, readonly percentComplete?: number | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly percentCompleted: number } } | null, readonly nurseAdvocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly email?: string | null, readonly fullName?: string | null } | null } | null };

export type MarkStaleProfileNotificationDismissedMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkStaleProfileNotificationDismissedMutation = { readonly __typename?: 'Mutation', readonly userProperties: { readonly __typename?: 'UserPropertiesMutation', readonly markStaleProfileNotificationDismissed?: { readonly __typename?: 'MarkStaleProfileNotificationDismissedPayload', readonly viewer: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly isActivated?: boolean | null, readonly canApplyJobs: boolean, readonly state?: string | null, readonly percentComplete?: number | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly percentCompleted: number } } | null, readonly nurseAdvocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly email?: string | null, readonly fullName?: string | null } | null } | null } } | null } };

export type MatchFavoriteButtonJobFragment = { readonly __typename?: 'Job', readonly id: string, readonly canFavorite: { readonly __typename?: 'AuthorizationResult', readonly value: boolean, readonly reasons?: { readonly __typename?: 'FailureReasons', readonly fullMessages: ReadonlyArray<string> } | null }, readonly esMatch?: { readonly __typename?: 'Match', readonly id: string, readonly userState?: string | null } | null };

export type MatchFavoriteButtonUserFragment = { readonly __typename?: 'User', readonly id: string, readonly userProperties: { readonly __typename?: 'UserProperties', readonly id: string, readonly shouldDisplayFirstFavoriteMessage: boolean } };

export type MatchWithdrawButtonJobFragment = { readonly __typename?: 'Job', readonly id: string, readonly canWithdraw: { readonly __typename?: 'AuthorizationResult', readonly value: boolean, readonly reasons?: { readonly __typename?: 'FailureReasons', readonly fullMessages: ReadonlyArray<string> } | null } };

export type JobMatchTopCardBlockJobFragment = { readonly __typename?: 'Job', readonly id: string, readonly instantOffer: boolean, readonly hoursPerShift?: number | null, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly positionCount?: number | null, readonly shiftsPerWeek?: number | null, readonly shiftType?: string | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly localAllowed: boolean, readonly grossPayWeekly?: number | null, readonly localGrossPayWeekly?: number | null, readonly onHold?: boolean | null, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly business?: { readonly __typename?: 'Facility', readonly id: string, readonly hideMatchInfo: boolean, readonly name: string, readonly city?: string | null, readonly state?: string | null, readonly logo?: string | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string, readonly state?: string | null } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly canApply: { readonly __typename?: 'AuthorizationResult', readonly value: boolean, readonly reasons?: { readonly __typename?: 'FailureReasons', readonly fullMessages: ReadonlyArray<string> } | null }, readonly esMatch?: { readonly __typename?: 'Match', readonly id: string, readonly userState?: string | null } | null, readonly canFavorite: { readonly __typename?: 'AuthorizationResult', readonly value: boolean, readonly reasons?: { readonly __typename?: 'FailureReasons', readonly fullMessages: ReadonlyArray<string> } | null }, readonly canWithdraw: { readonly __typename?: 'AuthorizationResult', readonly value: boolean, readonly reasons?: { readonly __typename?: 'FailureReasons', readonly fullMessages: ReadonlyArray<string> } | null }, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null };

export type JobMatchTopCardBlockUserFragment = { readonly __typename?: 'User', readonly id: string, readonly referralCode?: string | null, readonly email: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly userProperties: { readonly __typename?: 'UserProperties', readonly id: string, readonly shouldDisplayFirstFavoriteMessage: boolean }, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly isActivated?: boolean | null, readonly canApplyJobs: boolean, readonly state?: string | null, readonly percentComplete?: number | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly percentCompleted: number } } | null, readonly nurseAdvocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly email?: string | null, readonly fullName?: string | null } | null } | null };

export type MatchDetailsUserFragment = { readonly __typename?: 'User', readonly id: string, readonly referralCode?: string | null, readonly email: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly userProperties: { readonly __typename?: 'UserProperties', readonly id: string, readonly shouldDisplayFirstFavoriteMessage: boolean }, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly isActivated?: boolean | null, readonly canApplyJobs: boolean, readonly state?: string | null, readonly percentComplete?: number | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly percentCompleted: number } } | null, readonly nurseAdvocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly email?: string | null, readonly fullName?: string | null } | null } | null };

export type MatchDetailsJobFragment = { readonly __typename?: 'Job', readonly id: string, readonly state?: string | null, readonly endDate?: GraphQLISO8601Date | null, readonly friendlyLicenseType?: string | null, readonly hoursPerShift?: number | null, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly nursePatientRatio?: string | null, readonly publicDescription?: string | null, readonly shiftEnd?: string | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly shiftStart?: string | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly instantOffer: boolean, readonly positionCount?: number | null, readonly title?: string | null, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly grossPayWeekly?: number | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly travelAllowed: boolean, readonly localAllowed: boolean, readonly localGrossPayWeekly?: number | null, readonly onHold?: boolean | null, readonly business?: { readonly __typename?: 'Facility', readonly id: string, readonly bgImageFlickrUrl?: string | null, readonly hideMatchInfo: boolean, readonly state?: string | null, readonly name: string, readonly city?: string | null, readonly address: string, readonly logo?: string | null, readonly zipcode?: string | null, readonly slug: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly rankings?: ReadonlyArray<{ readonly __typename?: 'UsnewsRanking', readonly id: string, readonly usnewsType: string }> | null, readonly hospital?: { readonly __typename?: 'Hospital', readonly id: string, readonly teaching: boolean, readonly traumaCenterLevel?: number | null, readonly affiliatedUnion?: string | null, readonly totalLicensedBeds?: number | null, readonly hospitalSystem?: string | null, readonly hospitalType?: string | null, readonly jointCommission: boolean, readonly magnet: boolean } | null } | null, readonly cityLocation?: { readonly __typename?: 'Location', readonly id: string, readonly latitude?: number | null, readonly longitude?: number | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string, readonly candidateHoldReasons: ReadonlyArray<string>, readonly state?: string | null } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null, readonly blendedWageRate?: number | null, readonly callBackRate?: number | null, readonly doubleTimeMultiplier?: number | null, readonly extraRate?: number | null, readonly holidayRate?: number | null, readonly incidentalsStipendDaily?: number | null, readonly lodgingStipendDaily?: number | null, readonly onCallRate?: number | null, readonly overtimeHoursPerWeek?: number | null, readonly overtimeMultiplier?: number | null, readonly overtimeWageRate?: number | null, readonly regularHoursPerWeek?: number | null, readonly regularWageRate?: number | null, readonly totalHoursPerWeek?: number | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null, readonly blendedWageRate?: number | null, readonly callBackRate?: number | null, readonly doubleTimeMultiplier?: number | null, readonly extraRate?: number | null, readonly holidayRate?: number | null, readonly incidentalsStipendDaily?: number | null, readonly lodgingStipendDaily?: number | null, readonly onCallRate?: number | null, readonly overtimeHoursPerWeek?: number | null, readonly overtimeMultiplier?: number | null, readonly overtimeWageRate?: number | null, readonly regularHoursPerWeek?: number | null, readonly regularWageRate?: number | null, readonly totalHoursPerWeek?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null, readonly latitude?: number | null, readonly longitude?: number | null } | null, readonly roles?: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: string, readonly type?: RoleType | null }> | null, readonly preferredJarsV2?: ReadonlyArray<{ readonly __typename: 'JobApplicationRequirementsCertification', readonly id: string, readonly type: string, readonly title?: string | null, readonly description?: string | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly credential?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly issuingBodies: ReadonlyArray<string> } } | { readonly __typename: 'JobApplicationRequirementsCovidBooster', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsCovidVaccine', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsDriverLicense', readonly id: string, readonly required?: boolean | null, readonly type: string, readonly stage: JobApplicationRequirementStageEnum } | { readonly __typename: 'JobApplicationRequirementsEducation', readonly id: string, readonly type: string, readonly description?: string | null, readonly enforcementType: string } | { readonly __typename: 'JobApplicationRequirementsFluVaccination', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsFluVaccine', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsLocationFloating', readonly id: string, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsMaximumTimeOffRule', readonly id: string, readonly type: string, readonly maximumTimeOff: number, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsNurseReference', readonly id: string, readonly description?: string | null, readonly occurrences?: number | null, readonly timeframe?: number | null, readonly type: string } | { readonly __typename: 'JobApplicationRequirementsProofOfIdentification', readonly id: string, readonly type: string, readonly description?: string | null, readonly required?: boolean | null, readonly stage: JobApplicationRequirementStageEnum } | { readonly __typename: 'JobApplicationRequirementsRadiusRule', readonly id: string, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsRoleExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsStateLicense', readonly id: string, readonly stage: JobApplicationRequirementStageEnum, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsTechnologyExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null, readonly technology: { readonly __typename?: 'Technology', readonly id: string, readonly uuid: string, readonly name: string } } | { readonly __typename: 'JobApplicationRequirementsTraumaLevelExperience', readonly id: string, readonly type: string, readonly description?: string | null, readonly enforcementType: string } | { readonly __typename: 'JobApplicationRequirementsTravelExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsUnitExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsUnitFloating', readonly id: string, readonly type: string, readonly description?: string | null }> | null, readonly requiredJarsV2?: ReadonlyArray<{ readonly __typename: 'JobApplicationRequirementsCertification', readonly id: string, readonly type: string, readonly title?: string | null, readonly description?: string | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly credential?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly issuingBodies: ReadonlyArray<string> } } | { readonly __typename: 'JobApplicationRequirementsCovidBooster', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsCovidVaccine', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsDriverLicense', readonly id: string, readonly required?: boolean | null, readonly type: string, readonly stage: JobApplicationRequirementStageEnum } | { readonly __typename: 'JobApplicationRequirementsEducation', readonly id: string, readonly type: string, readonly description?: string | null, readonly enforcementType: string } | { readonly __typename: 'JobApplicationRequirementsFluVaccination', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsFluVaccine', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsLocationFloating', readonly id: string, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsMaximumTimeOffRule', readonly id: string, readonly type: string, readonly maximumTimeOff: number, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsNurseReference', readonly id: string, readonly description?: string | null, readonly occurrences?: number | null, readonly timeframe?: number | null, readonly type: string } | { readonly __typename: 'JobApplicationRequirementsProofOfIdentification', readonly id: string, readonly type: string, readonly description?: string | null, readonly required?: boolean | null, readonly stage: JobApplicationRequirementStageEnum } | { readonly __typename: 'JobApplicationRequirementsRadiusRule', readonly id: string, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsRoleExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsStateLicense', readonly id: string, readonly stage: JobApplicationRequirementStageEnum, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsTechnologyExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null, readonly technology: { readonly __typename?: 'Technology', readonly id: string, readonly uuid: string, readonly name: string } } | { readonly __typename: 'JobApplicationRequirementsTraumaLevelExperience', readonly id: string, readonly type: string, readonly description?: string | null, readonly enforcementType: string } | { readonly __typename: 'JobApplicationRequirementsTravelExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsUnitExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsUnitFloating', readonly id: string, readonly type: string, readonly description?: string | null }> | null, readonly canApply: { readonly __typename?: 'AuthorizationResult', readonly value: boolean, readonly reasons?: { readonly __typename?: 'FailureReasons', readonly fullMessages: ReadonlyArray<string> } | null }, readonly esMatch?: { readonly __typename?: 'Match', readonly id: string, readonly userState?: string | null } | null, readonly canFavorite: { readonly __typename?: 'AuthorizationResult', readonly value: boolean, readonly reasons?: { readonly __typename?: 'FailureReasons', readonly fullMessages: ReadonlyArray<string> } | null }, readonly canWithdraw: { readonly __typename?: 'AuthorizationResult', readonly value: boolean, readonly reasons?: { readonly __typename?: 'FailureReasons', readonly fullMessages: ReadonlyArray<string> } | null } };

export type MatchDetailsPreferredJarsFragment = { readonly __typename?: 'Job', readonly preferredJarsV2?: ReadonlyArray<{ readonly __typename: 'JobApplicationRequirementsCertification', readonly id: string, readonly type: string, readonly title?: string | null, readonly description?: string | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly credential?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly issuingBodies: ReadonlyArray<string> } } | { readonly __typename: 'JobApplicationRequirementsCovidBooster', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsCovidVaccine', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsDriverLicense', readonly id: string, readonly required?: boolean | null, readonly type: string, readonly stage: JobApplicationRequirementStageEnum } | { readonly __typename: 'JobApplicationRequirementsEducation', readonly id: string, readonly type: string, readonly description?: string | null, readonly enforcementType: string } | { readonly __typename: 'JobApplicationRequirementsFluVaccination', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsFluVaccine', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsLocationFloating', readonly id: string, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsMaximumTimeOffRule', readonly id: string, readonly type: string, readonly maximumTimeOff: number, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsNurseReference', readonly id: string, readonly description?: string | null, readonly occurrences?: number | null, readonly timeframe?: number | null, readonly type: string } | { readonly __typename: 'JobApplicationRequirementsProofOfIdentification', readonly id: string, readonly type: string, readonly description?: string | null, readonly required?: boolean | null, readonly stage: JobApplicationRequirementStageEnum } | { readonly __typename: 'JobApplicationRequirementsRadiusRule', readonly id: string, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsRoleExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsStateLicense', readonly id: string, readonly stage: JobApplicationRequirementStageEnum, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsTechnologyExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null, readonly technology: { readonly __typename?: 'Technology', readonly id: string, readonly uuid: string, readonly name: string } } | { readonly __typename: 'JobApplicationRequirementsTraumaLevelExperience', readonly id: string, readonly type: string, readonly description?: string | null, readonly enforcementType: string } | { readonly __typename: 'JobApplicationRequirementsTravelExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsUnitExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsUnitFloating', readonly id: string, readonly type: string, readonly description?: string | null }> | null };

export type MatchDetailsRequiredJarsFragment = { readonly __typename?: 'Job', readonly requiredJarsV2?: ReadonlyArray<{ readonly __typename: 'JobApplicationRequirementsCertification', readonly id: string, readonly type: string, readonly title?: string | null, readonly description?: string | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly credential?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly issuingBodies: ReadonlyArray<string> } } | { readonly __typename: 'JobApplicationRequirementsCovidBooster', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsCovidVaccine', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsDriverLicense', readonly id: string, readonly required?: boolean | null, readonly type: string, readonly stage: JobApplicationRequirementStageEnum } | { readonly __typename: 'JobApplicationRequirementsEducation', readonly id: string, readonly type: string, readonly description?: string | null, readonly enforcementType: string } | { readonly __typename: 'JobApplicationRequirementsFluVaccination', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsFluVaccine', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsLocationFloating', readonly id: string, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsMaximumTimeOffRule', readonly id: string, readonly type: string, readonly maximumTimeOff: number, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsNurseReference', readonly id: string, readonly description?: string | null, readonly occurrences?: number | null, readonly timeframe?: number | null, readonly type: string } | { readonly __typename: 'JobApplicationRequirementsProofOfIdentification', readonly id: string, readonly type: string, readonly description?: string | null, readonly required?: boolean | null, readonly stage: JobApplicationRequirementStageEnum } | { readonly __typename: 'JobApplicationRequirementsRadiusRule', readonly id: string, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsRoleExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsStateLicense', readonly id: string, readonly stage: JobApplicationRequirementStageEnum, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsTechnologyExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null, readonly technology: { readonly __typename?: 'Technology', readonly id: string, readonly uuid: string, readonly name: string } } | { readonly __typename: 'JobApplicationRequirementsTraumaLevelExperience', readonly id: string, readonly type: string, readonly description?: string | null, readonly enforcementType: string } | { readonly __typename: 'JobApplicationRequirementsTravelExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsUnitExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsUnitFloating', readonly id: string, readonly type: string, readonly description?: string | null }> | null };

export type MatchDetailsJobPaymentDetailsFragment = { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly blendedWageRate?: number | null, readonly callBackRate?: number | null, readonly doubleTimeMultiplier?: number | null, readonly extraRate?: number | null, readonly grossPayWeekly?: number | null, readonly holidayRate?: number | null, readonly incidentalsStipendDaily?: number | null, readonly lodgingStipendDaily?: number | null, readonly onCallRate?: number | null, readonly overtimeHoursPerWeek?: number | null, readonly overtimeMultiplier?: number | null, readonly overtimeWageRate?: number | null, readonly regularHoursPerWeek?: number | null, readonly regularWageRate?: number | null, readonly totalHoursPerWeek?: number | null };

export type MatchDetailsViewJobMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MatchDetailsViewJobMutation = { readonly __typename?: 'Mutation', readonly viewJob?: { readonly __typename?: 'JobVisualization', readonly id: string } | null };

export type MatchFiltersNurseProfileFragment = { readonly __typename?: 'NurseProfile', readonly id: string, readonly activeClinicalSpecialties: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly slug: string }>, readonly positionSpecialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly slug: string }> | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly type?: RoleType | null } | null, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly broadPrefLocations?: ReadonlyArray<BroadPrefLocations> | null, readonly contractLengths?: ReadonlyArray<string> | null, readonly shiftLengths?: ReadonlyArray<string> | null, readonly shiftPrefs?: ReadonlyArray<string> | null, readonly locations?: ReadonlyArray<{ readonly __typename?: 'Location', readonly id: string, readonly locationString?: string | null }> | null } | null };

export type MatchFiltersClinicalSpecialtyFragment = { readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly slug: string };

export type MatchFiltersNursePreferencesFragment = { readonly __typename?: 'NursePreferences', readonly id: string, readonly broadPrefLocations?: ReadonlyArray<BroadPrefLocations> | null, readonly contractLengths?: ReadonlyArray<string> | null, readonly shiftLengths?: ReadonlyArray<string> | null, readonly shiftPrefs?: ReadonlyArray<string> | null, readonly locations?: ReadonlyArray<{ readonly __typename?: 'Location', readonly id: string, readonly locationString?: string | null }> | null };

export type NavigationProfileDropdownUserFragment = { readonly __typename?: 'User', readonly id: string, readonly firstName?: string | null, readonly preferredName?: string | null, readonly middleName?: string | null, readonly lastName?: string | null, readonly profilePic?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly completeCount: number, readonly expiredCount: number, readonly expiringCount: number, readonly incompleteCount: number, readonly pendingCount: number, readonly percentCompleted: number } } | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly name: string } | null } | null };

export type ProfileCompletionWidgetProfileCompletionMetaFragment = { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly completeCount: number, readonly expiredCount: number, readonly expiringCount: number, readonly incompleteCount: number, readonly pendingCount: number, readonly percentCompleted: number } };

export type NavigationUserFragment = { readonly __typename?: 'User', readonly id: string, readonly profilePic?: string | null, readonly firstName?: string | null, readonly preferredName?: string | null, readonly middleName?: string | null, readonly lastName?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly incompleteCount: number, readonly expiredCount: number, readonly percentCompleted: number, readonly pendingCount: number } } | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly name: string } | null } | null };

export type UpdateClickIdsMutationVariables = Exact<{
  gclid?: InputMaybe<Scalars['String']['input']>;
  wbraid?: InputMaybe<Scalars['String']['input']>;
  gbraid?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateClickIdsMutation = { readonly __typename?: 'Mutation', readonly updateClickIds?: { readonly __typename?: 'UpdateClickIdsPayload', readonly ok: boolean } | null };

export type NavigationQueryVariables = Exact<{ [key: string]: never; }>;


export type NavigationQuery = { readonly __typename?: 'Query', readonly systemMessages?: ReadonlyArray<{ readonly __typename?: 'SystemMessage', readonly id: string, readonly body: string }> | null, readonly saasquatchMainPageWidget?: { readonly __typename?: 'SaasquatchWidgetContent', readonly titleText?: string | null } | null, readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly uuid: string, readonly intercomUserHash?: string | null, readonly profilePic?: string | null, readonly firstName?: string | null, readonly preferredName?: string | null, readonly middleName?: string | null, readonly lastName?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly canViewJobs: boolean, readonly hasBeenPlaced: boolean, readonly uuid?: string | null, readonly isOnboarding: boolean, readonly state?: string | null, readonly jobApplicationsSummary: { readonly __typename?: 'JobApplicationsSummary', readonly id: string, readonly actionRequired: ReadonlyArray<{ readonly __typename?: 'JobApplication', readonly id: string }>, readonly offer: ReadonlyArray<{ readonly __typename?: 'JobOffer', readonly id: string }> }, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly incompleteCount: number, readonly expiredCount: number, readonly percentCompleted: number, readonly pendingCount: number, readonly completeCount: number, readonly expiringCount: number } } | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly name: string } | null } | null } | null, readonly profileCompletionSummary: { readonly __typename?: 'ProfileCompletionSummary', readonly id: string, readonly completedAt?: GraphQLISO8601DateTime | null, readonly meta: { readonly __typename?: 'ProfileMeta', readonly id: string, readonly completeCount: number, readonly expiredCount: number, readonly expiringCount: number, readonly incompleteCount: number, readonly pendingCount: number, readonly percentCompleted: number }, readonly steps: ReadonlyArray<{ readonly __typename?: 'ProfileStep', readonly estimatedTimeInMinutes?: number | null, readonly key: ProfileStepsEnum, readonly title?: string | null, readonly subtitle?: string | null, readonly messages?: ReadonlyArray<string> | null, readonly sectionName: string, readonly status: ProfileStatusEnum, readonly hasExpiringItems: boolean, readonly hasExpiredItems: boolean, readonly hasInvalidItems: boolean }> }, readonly badgesItemsCount: { readonly __typename?: 'BadgesItemsCount', readonly id: string, readonly credentialsCount: number, readonly favoritesCount: number, readonly matchesCount: number, readonly completionItemsCount: number } };

export type NurseAdvocateWidgetSalesforceUserFragment = { readonly __typename?: 'SalesforceUser', readonly id: string, readonly phone?: string | null, readonly firstName?: string | null, readonly lastName?: string | null, readonly profileImgUrl: string, readonly isNurseAdvocate?: boolean | null, readonly isAlliedAdvocate?: boolean | null, readonly clinicalRole?: string | null };

export type OnboardingCompletedBannerJobPlacementFragment = { readonly __typename?: 'JobPlacement', readonly id: string, readonly startDate?: GraphQLISO8601Date | null, readonly locationCityState?: string | null, readonly facilityName?: string | null, readonly isOnboardingCompleted?: boolean | null };

export type ExternalSortedTodoListItemsCategoryFragment = { readonly __typename?: 'SortedTodoListItemsCategory', readonly displayName: string, readonly items: ReadonlyArray<{ readonly __typename?: 'TodoListItem', readonly id: string, readonly order?: number | null, readonly itemType?: string | null, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly itemState?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly uuid?: string | null, readonly candidateNotes?: string | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }>, readonly nurseAssessmentTarget?: { readonly __typename?: 'NurseAssessment', readonly id: string, readonly uuid?: string | null, readonly completedOn?: GraphQLISO8601Date | null, readonly score?: number | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly requestable?: boolean | null, readonly uuid?: string | null, readonly name?: string | null, readonly category?: string | null, readonly issuingBody?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseHealthDocTarget?: { readonly __typename?: 'NurseHealthDoc', readonly id: string } | null, readonly documentTarget?: { readonly __typename?: 'Document', readonly id: string, readonly uuid?: string | null, readonly title?: string | null, readonly isExpirable: boolean, readonly isExpiringSoon?: boolean | null, readonly isExpired?: boolean | null, readonly expirationType?: DocumentExpiration | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly docType?: string | null, readonly docSubtype?: string | null, readonly trackCompletionDate?: boolean | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseCertificationTarget?: { readonly __typename?: 'NurseCertification', readonly id: string, readonly certificationUuid?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null }> };

export type CategoriesFragment = { readonly __typename?: 'SortedTodoListItemsExternal', readonly displayName?: string | null, readonly formattedDueDate: string, readonly categories: { readonly __typename?: 'SortedTodoListItemsCategories', readonly general?: { readonly __typename?: 'SortedTodoListItemsCategory', readonly displayName: string, readonly items: ReadonlyArray<{ readonly __typename?: 'TodoListItem', readonly id: string, readonly order?: number | null, readonly itemType?: string | null, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly itemState?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly uuid?: string | null, readonly candidateNotes?: string | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }>, readonly nurseAssessmentTarget?: { readonly __typename?: 'NurseAssessment', readonly id: string, readonly uuid?: string | null, readonly completedOn?: GraphQLISO8601Date | null, readonly score?: number | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly requestable?: boolean | null, readonly uuid?: string | null, readonly name?: string | null, readonly category?: string | null, readonly issuingBody?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseHealthDocTarget?: { readonly __typename?: 'NurseHealthDoc', readonly id: string } | null, readonly documentTarget?: { readonly __typename?: 'Document', readonly id: string, readonly uuid?: string | null, readonly title?: string | null, readonly isExpirable: boolean, readonly isExpiringSoon?: boolean | null, readonly isExpired?: boolean | null, readonly expirationType?: DocumentExpiration | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly docType?: string | null, readonly docSubtype?: string | null, readonly trackCompletionDate?: boolean | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseCertificationTarget?: { readonly __typename?: 'NurseCertification', readonly id: string, readonly certificationUuid?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null }> } | null, readonly backgroundAndIdentification?: { readonly __typename?: 'SortedTodoListItemsCategory', readonly displayName: string, readonly items: ReadonlyArray<{ readonly __typename?: 'TodoListItem', readonly id: string, readonly order?: number | null, readonly itemType?: string | null, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly itemState?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly uuid?: string | null, readonly candidateNotes?: string | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }>, readonly nurseAssessmentTarget?: { readonly __typename?: 'NurseAssessment', readonly id: string, readonly uuid?: string | null, readonly completedOn?: GraphQLISO8601Date | null, readonly score?: number | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly requestable?: boolean | null, readonly uuid?: string | null, readonly name?: string | null, readonly category?: string | null, readonly issuingBody?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseHealthDocTarget?: { readonly __typename?: 'NurseHealthDoc', readonly id: string } | null, readonly documentTarget?: { readonly __typename?: 'Document', readonly id: string, readonly uuid?: string | null, readonly title?: string | null, readonly isExpirable: boolean, readonly isExpiringSoon?: boolean | null, readonly isExpired?: boolean | null, readonly expirationType?: DocumentExpiration | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly docType?: string | null, readonly docSubtype?: string | null, readonly trackCompletionDate?: boolean | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseCertificationTarget?: { readonly __typename?: 'NurseCertification', readonly id: string, readonly certificationUuid?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null }> } | null, readonly licensesAndCertifications?: { readonly __typename?: 'SortedTodoListItemsCategory', readonly displayName: string, readonly items: ReadonlyArray<{ readonly __typename?: 'TodoListItem', readonly id: string, readonly order?: number | null, readonly itemType?: string | null, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly itemState?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly uuid?: string | null, readonly candidateNotes?: string | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }>, readonly nurseAssessmentTarget?: { readonly __typename?: 'NurseAssessment', readonly id: string, readonly uuid?: string | null, readonly completedOn?: GraphQLISO8601Date | null, readonly score?: number | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly requestable?: boolean | null, readonly uuid?: string | null, readonly name?: string | null, readonly category?: string | null, readonly issuingBody?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseHealthDocTarget?: { readonly __typename?: 'NurseHealthDoc', readonly id: string } | null, readonly documentTarget?: { readonly __typename?: 'Document', readonly id: string, readonly uuid?: string | null, readonly title?: string | null, readonly isExpirable: boolean, readonly isExpiringSoon?: boolean | null, readonly isExpired?: boolean | null, readonly expirationType?: DocumentExpiration | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly docType?: string | null, readonly docSubtype?: string | null, readonly trackCompletionDate?: boolean | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseCertificationTarget?: { readonly __typename?: 'NurseCertification', readonly id: string, readonly certificationUuid?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null }> } | null, readonly assessments?: { readonly __typename?: 'SortedTodoListItemsCategory', readonly displayName: string, readonly items: ReadonlyArray<{ readonly __typename?: 'TodoListItem', readonly id: string, readonly order?: number | null, readonly itemType?: string | null, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly itemState?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly uuid?: string | null, readonly candidateNotes?: string | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }>, readonly nurseAssessmentTarget?: { readonly __typename?: 'NurseAssessment', readonly id: string, readonly uuid?: string | null, readonly completedOn?: GraphQLISO8601Date | null, readonly score?: number | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly requestable?: boolean | null, readonly uuid?: string | null, readonly name?: string | null, readonly category?: string | null, readonly issuingBody?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseHealthDocTarget?: { readonly __typename?: 'NurseHealthDoc', readonly id: string } | null, readonly documentTarget?: { readonly __typename?: 'Document', readonly id: string, readonly uuid?: string | null, readonly title?: string | null, readonly isExpirable: boolean, readonly isExpiringSoon?: boolean | null, readonly isExpired?: boolean | null, readonly expirationType?: DocumentExpiration | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly docType?: string | null, readonly docSubtype?: string | null, readonly trackCompletionDate?: boolean | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseCertificationTarget?: { readonly __typename?: 'NurseCertification', readonly id: string, readonly certificationUuid?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null }> } | null, readonly healthDocuments?: { readonly __typename?: 'SortedTodoListItemsCategory', readonly displayName: string, readonly items: ReadonlyArray<{ readonly __typename?: 'TodoListItem', readonly id: string, readonly order?: number | null, readonly itemType?: string | null, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly itemState?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly uuid?: string | null, readonly candidateNotes?: string | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }>, readonly nurseAssessmentTarget?: { readonly __typename?: 'NurseAssessment', readonly id: string, readonly uuid?: string | null, readonly completedOn?: GraphQLISO8601Date | null, readonly score?: number | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly requestable?: boolean | null, readonly uuid?: string | null, readonly name?: string | null, readonly category?: string | null, readonly issuingBody?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseHealthDocTarget?: { readonly __typename?: 'NurseHealthDoc', readonly id: string } | null, readonly documentTarget?: { readonly __typename?: 'Document', readonly id: string, readonly uuid?: string | null, readonly title?: string | null, readonly isExpirable: boolean, readonly isExpiringSoon?: boolean | null, readonly isExpired?: boolean | null, readonly expirationType?: DocumentExpiration | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly docType?: string | null, readonly docSubtype?: string | null, readonly trackCompletionDate?: boolean | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseCertificationTarget?: { readonly __typename?: 'NurseCertification', readonly id: string, readonly certificationUuid?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null }> } | null } };

export type ExternalTimelineTodoListItemsFragment = { readonly __typename?: 'TodoList', readonly id: string, readonly timelineTodoListItems: { readonly __typename?: 'TimelineTodoListItems', readonly externalItems: ReadonlyArray<{ readonly __typename?: 'SortedTodoListItemsExternal', readonly displayName?: string | null, readonly formattedDueDate: string, readonly categories: { readonly __typename?: 'SortedTodoListItemsCategories', readonly general?: { readonly __typename?: 'SortedTodoListItemsCategory', readonly displayName: string, readonly items: ReadonlyArray<{ readonly __typename?: 'TodoListItem', readonly id: string, readonly order?: number | null, readonly itemType?: string | null, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly itemState?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly uuid?: string | null, readonly candidateNotes?: string | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }>, readonly nurseAssessmentTarget?: { readonly __typename?: 'NurseAssessment', readonly id: string, readonly uuid?: string | null, readonly completedOn?: GraphQLISO8601Date | null, readonly score?: number | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly requestable?: boolean | null, readonly uuid?: string | null, readonly name?: string | null, readonly category?: string | null, readonly issuingBody?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseHealthDocTarget?: { readonly __typename?: 'NurseHealthDoc', readonly id: string } | null, readonly documentTarget?: { readonly __typename?: 'Document', readonly id: string, readonly uuid?: string | null, readonly title?: string | null, readonly isExpirable: boolean, readonly isExpiringSoon?: boolean | null, readonly isExpired?: boolean | null, readonly expirationType?: DocumentExpiration | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly docType?: string | null, readonly docSubtype?: string | null, readonly trackCompletionDate?: boolean | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseCertificationTarget?: { readonly __typename?: 'NurseCertification', readonly id: string, readonly certificationUuid?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null }> } | null, readonly backgroundAndIdentification?: { readonly __typename?: 'SortedTodoListItemsCategory', readonly displayName: string, readonly items: ReadonlyArray<{ readonly __typename?: 'TodoListItem', readonly id: string, readonly order?: number | null, readonly itemType?: string | null, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly itemState?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly uuid?: string | null, readonly candidateNotes?: string | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }>, readonly nurseAssessmentTarget?: { readonly __typename?: 'NurseAssessment', readonly id: string, readonly uuid?: string | null, readonly completedOn?: GraphQLISO8601Date | null, readonly score?: number | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly requestable?: boolean | null, readonly uuid?: string | null, readonly name?: string | null, readonly category?: string | null, readonly issuingBody?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseHealthDocTarget?: { readonly __typename?: 'NurseHealthDoc', readonly id: string } | null, readonly documentTarget?: { readonly __typename?: 'Document', readonly id: string, readonly uuid?: string | null, readonly title?: string | null, readonly isExpirable: boolean, readonly isExpiringSoon?: boolean | null, readonly isExpired?: boolean | null, readonly expirationType?: DocumentExpiration | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly docType?: string | null, readonly docSubtype?: string | null, readonly trackCompletionDate?: boolean | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseCertificationTarget?: { readonly __typename?: 'NurseCertification', readonly id: string, readonly certificationUuid?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null }> } | null, readonly licensesAndCertifications?: { readonly __typename?: 'SortedTodoListItemsCategory', readonly displayName: string, readonly items: ReadonlyArray<{ readonly __typename?: 'TodoListItem', readonly id: string, readonly order?: number | null, readonly itemType?: string | null, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly itemState?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly uuid?: string | null, readonly candidateNotes?: string | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }>, readonly nurseAssessmentTarget?: { readonly __typename?: 'NurseAssessment', readonly id: string, readonly uuid?: string | null, readonly completedOn?: GraphQLISO8601Date | null, readonly score?: number | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly requestable?: boolean | null, readonly uuid?: string | null, readonly name?: string | null, readonly category?: string | null, readonly issuingBody?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseHealthDocTarget?: { readonly __typename?: 'NurseHealthDoc', readonly id: string } | null, readonly documentTarget?: { readonly __typename?: 'Document', readonly id: string, readonly uuid?: string | null, readonly title?: string | null, readonly isExpirable: boolean, readonly isExpiringSoon?: boolean | null, readonly isExpired?: boolean | null, readonly expirationType?: DocumentExpiration | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly docType?: string | null, readonly docSubtype?: string | null, readonly trackCompletionDate?: boolean | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseCertificationTarget?: { readonly __typename?: 'NurseCertification', readonly id: string, readonly certificationUuid?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null }> } | null, readonly assessments?: { readonly __typename?: 'SortedTodoListItemsCategory', readonly displayName: string, readonly items: ReadonlyArray<{ readonly __typename?: 'TodoListItem', readonly id: string, readonly order?: number | null, readonly itemType?: string | null, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly itemState?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly uuid?: string | null, readonly candidateNotes?: string | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }>, readonly nurseAssessmentTarget?: { readonly __typename?: 'NurseAssessment', readonly id: string, readonly uuid?: string | null, readonly completedOn?: GraphQLISO8601Date | null, readonly score?: number | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly requestable?: boolean | null, readonly uuid?: string | null, readonly name?: string | null, readonly category?: string | null, readonly issuingBody?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseHealthDocTarget?: { readonly __typename?: 'NurseHealthDoc', readonly id: string } | null, readonly documentTarget?: { readonly __typename?: 'Document', readonly id: string, readonly uuid?: string | null, readonly title?: string | null, readonly isExpirable: boolean, readonly isExpiringSoon?: boolean | null, readonly isExpired?: boolean | null, readonly expirationType?: DocumentExpiration | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly docType?: string | null, readonly docSubtype?: string | null, readonly trackCompletionDate?: boolean | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseCertificationTarget?: { readonly __typename?: 'NurseCertification', readonly id: string, readonly certificationUuid?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null }> } | null, readonly healthDocuments?: { readonly __typename?: 'SortedTodoListItemsCategory', readonly displayName: string, readonly items: ReadonlyArray<{ readonly __typename?: 'TodoListItem', readonly id: string, readonly order?: number | null, readonly itemType?: string | null, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly itemState?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly uuid?: string | null, readonly candidateNotes?: string | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }>, readonly nurseAssessmentTarget?: { readonly __typename?: 'NurseAssessment', readonly id: string, readonly uuid?: string | null, readonly completedOn?: GraphQLISO8601Date | null, readonly score?: number | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly requestable?: boolean | null, readonly uuid?: string | null, readonly name?: string | null, readonly category?: string | null, readonly issuingBody?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseHealthDocTarget?: { readonly __typename?: 'NurseHealthDoc', readonly id: string } | null, readonly documentTarget?: { readonly __typename?: 'Document', readonly id: string, readonly uuid?: string | null, readonly title?: string | null, readonly isExpirable: boolean, readonly isExpiringSoon?: boolean | null, readonly isExpired?: boolean | null, readonly expirationType?: DocumentExpiration | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly docType?: string | null, readonly docSubtype?: string | null, readonly trackCompletionDate?: boolean | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseCertificationTarget?: { readonly __typename?: 'NurseCertification', readonly id: string, readonly certificationUuid?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null }> } | null } }> } };

export type OnboardingListTodoListFragment = { readonly __typename?: 'TodoList', readonly uuid?: string | null, readonly id: string, readonly markedCompleteAt?: GraphQLISO8601Date | null, readonly contractSignedDate?: GraphQLISO8601Date | null, readonly completeByDate?: GraphQLISO8601Date | null, readonly status?: string | null, readonly startDate?: GraphQLISO8601Date | null, readonly incentiveDeadline?: GraphQLISO8601Date | null, readonly publishedAt?: GraphQLISO8601Date | null, readonly createdAt: GraphQLISO8601DateTime, readonly numTasksDue?: number | null, readonly listType?: string | null, readonly targetBusinessName?: string | null, readonly numTasksNeedingAttention?: number | null, readonly numTasksPending?: number | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly user?: { readonly __typename?: 'User', readonly id: string, readonly city?: string | null, readonly state?: string | null, readonly streetAddress?: string | null, readonly zipcode?: string | null } | null } | null, readonly todoListItems: ReadonlyArray<{ readonly __typename?: 'TodoListItem', readonly id: string, readonly name?: string | null, readonly itemType?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly itemState?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly uuid?: string | null, readonly candidateNotes?: string | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }>, readonly nurseAssessmentTarget?: { readonly __typename?: 'NurseAssessment', readonly id: string, readonly uuid?: string | null, readonly completedOn?: GraphQLISO8601Date | null, readonly score?: number | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly requestable?: boolean | null, readonly uuid?: string | null, readonly name?: string | null, readonly category?: string | null, readonly issuingBody?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseHealthDocTarget?: { readonly __typename?: 'NurseHealthDoc', readonly id: string } | null, readonly documentTarget?: { readonly __typename?: 'Document', readonly id: string, readonly uuid?: string | null, readonly title?: string | null, readonly isExpirable: boolean, readonly isExpiringSoon?: boolean | null, readonly isExpired?: boolean | null, readonly expirationType?: DocumentExpiration | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly docType?: string | null, readonly docSubtype?: string | null, readonly trackCompletionDate?: boolean | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseCertificationTarget?: { readonly __typename?: 'NurseCertification', readonly id: string, readonly certificationUuid?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null }>, readonly timelineTodoListItems: { readonly __typename?: 'TimelineTodoListItems', readonly externalItems: ReadonlyArray<{ readonly __typename?: 'SortedTodoListItemsExternal', readonly displayName?: string | null, readonly formattedDueDate: string, readonly categories: { readonly __typename?: 'SortedTodoListItemsCategories', readonly general?: { readonly __typename?: 'SortedTodoListItemsCategory', readonly displayName: string, readonly items: ReadonlyArray<{ readonly __typename?: 'TodoListItem', readonly id: string, readonly order?: number | null, readonly itemType?: string | null, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly itemState?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly uuid?: string | null, readonly candidateNotes?: string | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }>, readonly nurseAssessmentTarget?: { readonly __typename?: 'NurseAssessment', readonly id: string, readonly uuid?: string | null, readonly completedOn?: GraphQLISO8601Date | null, readonly score?: number | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly requestable?: boolean | null, readonly uuid?: string | null, readonly name?: string | null, readonly category?: string | null, readonly issuingBody?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseHealthDocTarget?: { readonly __typename?: 'NurseHealthDoc', readonly id: string } | null, readonly documentTarget?: { readonly __typename?: 'Document', readonly id: string, readonly uuid?: string | null, readonly title?: string | null, readonly isExpirable: boolean, readonly isExpiringSoon?: boolean | null, readonly isExpired?: boolean | null, readonly expirationType?: DocumentExpiration | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly docType?: string | null, readonly docSubtype?: string | null, readonly trackCompletionDate?: boolean | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseCertificationTarget?: { readonly __typename?: 'NurseCertification', readonly id: string, readonly certificationUuid?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null }> } | null, readonly backgroundAndIdentification?: { readonly __typename?: 'SortedTodoListItemsCategory', readonly displayName: string, readonly items: ReadonlyArray<{ readonly __typename?: 'TodoListItem', readonly id: string, readonly order?: number | null, readonly itemType?: string | null, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly itemState?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly uuid?: string | null, readonly candidateNotes?: string | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }>, readonly nurseAssessmentTarget?: { readonly __typename?: 'NurseAssessment', readonly id: string, readonly uuid?: string | null, readonly completedOn?: GraphQLISO8601Date | null, readonly score?: number | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly requestable?: boolean | null, readonly uuid?: string | null, readonly name?: string | null, readonly category?: string | null, readonly issuingBody?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseHealthDocTarget?: { readonly __typename?: 'NurseHealthDoc', readonly id: string } | null, readonly documentTarget?: { readonly __typename?: 'Document', readonly id: string, readonly uuid?: string | null, readonly title?: string | null, readonly isExpirable: boolean, readonly isExpiringSoon?: boolean | null, readonly isExpired?: boolean | null, readonly expirationType?: DocumentExpiration | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly docType?: string | null, readonly docSubtype?: string | null, readonly trackCompletionDate?: boolean | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseCertificationTarget?: { readonly __typename?: 'NurseCertification', readonly id: string, readonly certificationUuid?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null }> } | null, readonly licensesAndCertifications?: { readonly __typename?: 'SortedTodoListItemsCategory', readonly displayName: string, readonly items: ReadonlyArray<{ readonly __typename?: 'TodoListItem', readonly id: string, readonly order?: number | null, readonly itemType?: string | null, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly itemState?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly uuid?: string | null, readonly candidateNotes?: string | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }>, readonly nurseAssessmentTarget?: { readonly __typename?: 'NurseAssessment', readonly id: string, readonly uuid?: string | null, readonly completedOn?: GraphQLISO8601Date | null, readonly score?: number | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly requestable?: boolean | null, readonly uuid?: string | null, readonly name?: string | null, readonly category?: string | null, readonly issuingBody?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseHealthDocTarget?: { readonly __typename?: 'NurseHealthDoc', readonly id: string } | null, readonly documentTarget?: { readonly __typename?: 'Document', readonly id: string, readonly uuid?: string | null, readonly title?: string | null, readonly isExpirable: boolean, readonly isExpiringSoon?: boolean | null, readonly isExpired?: boolean | null, readonly expirationType?: DocumentExpiration | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly docType?: string | null, readonly docSubtype?: string | null, readonly trackCompletionDate?: boolean | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseCertificationTarget?: { readonly __typename?: 'NurseCertification', readonly id: string, readonly certificationUuid?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null }> } | null, readonly assessments?: { readonly __typename?: 'SortedTodoListItemsCategory', readonly displayName: string, readonly items: ReadonlyArray<{ readonly __typename?: 'TodoListItem', readonly id: string, readonly order?: number | null, readonly itemType?: string | null, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly itemState?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly uuid?: string | null, readonly candidateNotes?: string | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }>, readonly nurseAssessmentTarget?: { readonly __typename?: 'NurseAssessment', readonly id: string, readonly uuid?: string | null, readonly completedOn?: GraphQLISO8601Date | null, readonly score?: number | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly requestable?: boolean | null, readonly uuid?: string | null, readonly name?: string | null, readonly category?: string | null, readonly issuingBody?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseHealthDocTarget?: { readonly __typename?: 'NurseHealthDoc', readonly id: string } | null, readonly documentTarget?: { readonly __typename?: 'Document', readonly id: string, readonly uuid?: string | null, readonly title?: string | null, readonly isExpirable: boolean, readonly isExpiringSoon?: boolean | null, readonly isExpired?: boolean | null, readonly expirationType?: DocumentExpiration | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly docType?: string | null, readonly docSubtype?: string | null, readonly trackCompletionDate?: boolean | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseCertificationTarget?: { readonly __typename?: 'NurseCertification', readonly id: string, readonly certificationUuid?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null }> } | null, readonly healthDocuments?: { readonly __typename?: 'SortedTodoListItemsCategory', readonly displayName: string, readonly items: ReadonlyArray<{ readonly __typename?: 'TodoListItem', readonly id: string, readonly order?: number | null, readonly itemType?: string | null, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly itemState?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly uuid?: string | null, readonly candidateNotes?: string | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }>, readonly nurseAssessmentTarget?: { readonly __typename?: 'NurseAssessment', readonly id: string, readonly uuid?: string | null, readonly completedOn?: GraphQLISO8601Date | null, readonly score?: number | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly requestable?: boolean | null, readonly uuid?: string | null, readonly name?: string | null, readonly category?: string | null, readonly issuingBody?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseHealthDocTarget?: { readonly __typename?: 'NurseHealthDoc', readonly id: string } | null, readonly documentTarget?: { readonly __typename?: 'Document', readonly id: string, readonly uuid?: string | null, readonly title?: string | null, readonly isExpirable: boolean, readonly isExpiringSoon?: boolean | null, readonly isExpired?: boolean | null, readonly expirationType?: DocumentExpiration | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly docType?: string | null, readonly docSubtype?: string | null, readonly trackCompletionDate?: boolean | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseCertificationTarget?: { readonly __typename?: 'NurseCertification', readonly id: string, readonly certificationUuid?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null }> } | null } }> }, readonly targetBusinessLocation?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null };

export type IncentiveBannerTodoListFragment = { readonly __typename?: 'TodoList', readonly incentiveDeadline?: GraphQLISO8601Date | null, readonly completeByDate?: GraphQLISO8601Date | null };

export type OnboardingHeaderTodoListFragment = { readonly __typename?: 'TodoList', readonly id: string, readonly startDate?: GraphQLISO8601Date | null, readonly publishedAt?: GraphQLISO8601Date | null, readonly completeByDate?: GraphQLISO8601Date | null, readonly createdAt: GraphQLISO8601DateTime, readonly numTasksDue?: number | null, readonly listType?: string | null, readonly markedCompleteAt?: GraphQLISO8601Date | null, readonly targetBusinessName?: string | null, readonly numTasksNeedingAttention?: number | null, readonly numTasksPending?: number | null, readonly targetBusinessLocation?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null };

export type OnboardingHeaderTitleFragment = { readonly __typename?: 'TodoList', readonly id: string, readonly publishedAt?: GraphQLISO8601Date | null, readonly completeByDate?: GraphQLISO8601Date | null, readonly createdAt: GraphQLISO8601DateTime, readonly numTasksDue?: number | null, readonly listType?: string | null, readonly markedCompleteAt?: GraphQLISO8601Date | null };

export type OnboardingHeaderBodyFragment = { readonly __typename?: 'TodoList', readonly markedCompleteAt?: GraphQLISO8601Date | null, readonly publishedAt?: GraphQLISO8601Date | null, readonly targetBusinessName?: string | null };

export type OnboardingHeaderCountersTodoListFragment = { readonly __typename?: 'TodoList', readonly markedCompleteAt?: GraphQLISO8601Date | null, readonly numTasksNeedingAttention?: number | null, readonly numTasksPending?: number | null };

export type OnboardingHeaderSubtitleFragment = { readonly __typename?: 'TodoList', readonly id: string, readonly markedCompleteAt?: GraphQLISO8601Date | null, readonly targetBusinessName?: string | null, readonly targetBusinessLocation?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null };

export type OnboardingListItemContainerTodoListItemFragment = { readonly __typename?: 'TodoListItem', readonly id: string, readonly itemType?: string | null, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly itemState?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly uuid?: string | null, readonly candidateNotes?: string | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }>, readonly nurseAssessmentTarget?: { readonly __typename?: 'NurseAssessment', readonly id: string, readonly uuid?: string | null, readonly completedOn?: GraphQLISO8601Date | null, readonly score?: number | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly requestable?: boolean | null, readonly uuid?: string | null, readonly name?: string | null, readonly category?: string | null, readonly issuingBody?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseHealthDocTarget?: { readonly __typename?: 'NurseHealthDoc', readonly id: string } | null, readonly documentTarget?: { readonly __typename?: 'Document', readonly id: string, readonly uuid?: string | null, readonly title?: string | null, readonly isExpirable: boolean, readonly isExpiringSoon?: boolean | null, readonly isExpired?: boolean | null, readonly expirationType?: DocumentExpiration | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly docType?: string | null, readonly docSubtype?: string | null, readonly trackCompletionDate?: boolean | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseCertificationTarget?: { readonly __typename?: 'NurseCertification', readonly id: string, readonly certificationUuid?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null };

export type AppointmentItemFragment = { readonly __typename?: 'TodoListItem', readonly id: string, readonly itemState?: string | null, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly itemType?: string | null, readonly candidateNotes?: string | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }> };

export type BaseItemFragment = { readonly __typename?: 'TodoListItem', readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly itemState?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly itemType?: string | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }> };

export type DocumentItemFragment = { readonly __typename?: 'TodoListItem', readonly id: string, readonly itemState?: string | null, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly itemType?: string | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }>, readonly documentTarget?: { readonly __typename?: 'Document', readonly id: string, readonly uuid?: string | null, readonly title?: string | null, readonly isExpirable: boolean, readonly isExpiringSoon?: boolean | null, readonly isExpired?: boolean | null, readonly expirationType?: DocumentExpiration | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly docType?: string | null, readonly docSubtype?: string | null, readonly trackCompletionDate?: boolean | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null };

export type NurseAssessmentItemTodoListItemFragment = { readonly __typename?: 'TodoListItem', readonly id: string, readonly itemState?: string | null, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly itemType?: string | null, readonly nurseAssessmentTarget?: { readonly __typename?: 'NurseAssessment', readonly id: string, readonly uuid?: string | null, readonly completedOn?: GraphQLISO8601Date | null, readonly score?: number | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly requestable?: boolean | null, readonly uuid?: string | null, readonly name?: string | null, readonly category?: string | null, readonly issuingBody?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }> };

export type NurseAssessmentItemNurseAssessmentFragment = { readonly __typename?: 'NurseAssessment', readonly id: string, readonly name?: string | null, readonly category?: string | null, readonly requestedOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly issuingBody?: string | null } | null };

export type NurseCertificationItemFragment = { readonly __typename?: 'TodoListItem', readonly id: string, readonly itemState?: string | null, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly itemType?: string | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }>, readonly nurseCertificationTarget?: { readonly __typename?: 'NurseCertification', readonly id: string, readonly certificationUuid?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null };

export type NurseHealthDocItemFragment = { readonly __typename?: 'TodoListItem', readonly id: string, readonly itemState?: string | null, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly itemType?: string | null, readonly nurseHealthDocTarget?: { readonly __typename?: 'NurseHealthDoc', readonly id: string } | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }> };

export type PlaintextItemFragment = { readonly __typename?: 'TodoListItem', readonly id: string, readonly itemState?: string | null, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly itemType?: string | null, readonly uuid?: string | null, readonly candidateNotes?: string | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }> };

export type UpdateCurrentAddressMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: NestedUpdateUserInput;
}>;


export type UpdateCurrentAddressMutation = { readonly __typename?: 'Mutation', readonly nestedUpdateUser?: { readonly __typename?: 'NestedUpdateUserPayload', readonly user: { readonly __typename?: 'User', readonly id: string, readonly city?: string | null, readonly state?: string | null, readonly streetAddress?: string | null, readonly zipcode?: string | null } } | null };

export type AppointmentItemUpdateTodoCandidateNotesMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
  candidateNotes: Scalars['String']['input'];
}>;


export type AppointmentItemUpdateTodoCandidateNotesMutation = { readonly __typename?: 'Mutation', readonly updateTodoCandidateNotes?: { readonly __typename?: 'TodoListItem', readonly id: string, readonly description?: string | null, readonly itemState?: string | null, readonly itemType?: string | null, readonly uuid?: string | null, readonly verificationNotes?: string | null, readonly candidateNotes?: string | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly url: string, readonly title: string }> } | null };

export type ConfirmationItemConfirmTodoDoneMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ConfirmationItemConfirmTodoDoneMutation = { readonly __typename?: 'Mutation', readonly confirmTodoDone?: { readonly __typename?: 'TodoListItem', readonly id: string, readonly description?: string | null, readonly itemState?: string | null, readonly itemType?: string | null, readonly uuid?: string | null, readonly verificationNotes?: string | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly url: string, readonly title: string }> } | null };

export type DocumentItemUpdateTodoListItemDocumentTargetMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateTodoListItemDocumentTargetInput;
  fileUuids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type DocumentItemUpdateTodoListItemDocumentTargetMutation = { readonly __typename?: 'Mutation', readonly updateTodoListItemDocumentTarget?: { readonly __typename?: 'UpdateTodoListItemDocumentTargetPayload', readonly todoListItem?: { readonly __typename?: 'TodoListItem', readonly id: string, readonly itemState?: string | null, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly itemType?: string | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }>, readonly documentTarget?: { readonly __typename?: 'Document', readonly id: string, readonly uuid?: string | null, readonly title?: string | null, readonly isExpirable: boolean, readonly isExpiringSoon?: boolean | null, readonly isExpired?: boolean | null, readonly expirationType?: DocumentExpiration | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly docType?: string | null, readonly docSubtype?: string | null, readonly trackCompletionDate?: boolean | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ValidationError', readonly errors: ReadonlyArray<string> }> | null } | null };

export type UpdateTodoListItemNurseAssessmentTargetMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateTodoListItemNurseAssessmentTargetInput;
  fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type UpdateTodoListItemNurseAssessmentTargetMutation = { readonly __typename?: 'Mutation', readonly updateTodoListItemNurseAssessmentTarget?: { readonly __typename?: 'UpdateTodoListItemNurseAssessmentTargetPayload', readonly todoListItem?: { readonly __typename?: 'TodoListItem', readonly id: string, readonly itemState?: string | null, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly itemType?: string | null, readonly nurseAssessmentTarget?: { readonly __typename?: 'NurseAssessment', readonly id: string, readonly uuid?: string | null, readonly completedOn?: GraphQLISO8601Date | null, readonly score?: number | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly requestable?: boolean | null, readonly uuid?: string | null, readonly name?: string | null, readonly category?: string | null, readonly issuingBody?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }> } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ValidationError', readonly errors: ReadonlyArray<string> }> | null } | null };

export type AssignReliasAssessmentMutationVariables = Exact<{
  assessmentIds: ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type AssignReliasAssessmentMutation = { readonly __typename?: 'Mutation', readonly assignReliasAssessments?: { readonly __typename?: 'AssignReliasAssessmentsPayload', readonly nurseAssessments: ReadonlyArray<{ readonly __typename?: 'NurseAssessment', readonly id: string, readonly name?: string | null, readonly category?: string | null, readonly requestedOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly issuingBody?: string | null } | null }> } | null };

export type UpdateOnboardingItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  targetId: Scalars['ID']['input'];
}>;


export type UpdateOnboardingItemMutation = { readonly __typename?: 'Mutation', readonly updateOnboardingItemTarget?: { readonly __typename?: 'UpdateOnboardingItemTargetPayload', readonly todoListItem: { readonly __typename?: 'TodoListItem', readonly id: string, readonly itemState?: string | null, readonly target?: { readonly __typename?: 'Document' } | { readonly __typename?: 'EmploymentVerificationSubmission' } | { readonly __typename?: 'License' } | { readonly __typename?: 'NurseAssessment', readonly id: string } | { readonly __typename?: 'NurseCertification' } | { readonly __typename?: 'NurseHealthDoc' } | { readonly __typename?: 'NurseLicenseVerification' } | { readonly __typename?: 'Reference' } | null } } | null };

export type NurseCertificationItemUpdateTodoListItemHealthDocTargetMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateTodoListItemNurseCertificationTargetInput;
  certificationInput: UpdateTodoListItemNurseCertificationInput;
  fileUuids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type NurseCertificationItemUpdateTodoListItemHealthDocTargetMutation = { readonly __typename?: 'Mutation', readonly updateTodoListItemNurseCertificationTarget?: { readonly __typename?: 'UpdateTodoListItemNurseCertificationTargetPayload', readonly todoListItem?: { readonly __typename?: 'TodoListItem', readonly id: string, readonly itemState?: string | null, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly itemType?: string | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }>, readonly nurseCertificationTarget?: { readonly __typename?: 'NurseCertification', readonly id: string, readonly certificationUuid?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ValidationError', readonly errors: ReadonlyArray<string> }> | null } | null };

export type PlaintextItemUpdateTodoCandidateNotesMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
  candidateNotes: Scalars['String']['input'];
}>;


export type PlaintextItemUpdateTodoCandidateNotesMutation = { readonly __typename?: 'Mutation', readonly updateTodoCandidateNotes?: { readonly __typename?: 'TodoListItem', readonly id: string, readonly description?: string | null, readonly itemState?: string | null, readonly itemType?: string | null, readonly uuid?: string | null, readonly verificationNotes?: string | null, readonly candidateNotes?: string | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly url: string, readonly title: string }> } | null };

export type OnboardingListOwnerInfoQueryVariables = Exact<{
  todoListId: Scalars['String']['input'];
}>;


export type OnboardingListOwnerInfoQuery = { readonly __typename?: 'Query', readonly getOnboardingListOwnerInfo?: { readonly __typename?: 'TodoListOwner', readonly iconUrl?: string | null, readonly name?: string | null } | null };

export type OnboardingListAttentionItemsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OnboardingListAttentionItemsQuery = { readonly __typename?: 'Query', readonly getOnboardingListNeedsAttention?: ReadonlyArray<{ readonly __typename?: 'TodoListItem', readonly dueDate?: GraphQLISO8601Date | null, readonly id: string, readonly itemType?: string | null, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly itemState?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly uuid?: string | null, readonly candidateNotes?: string | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }>, readonly nurseAssessmentTarget?: { readonly __typename?: 'NurseAssessment', readonly id: string, readonly uuid?: string | null, readonly completedOn?: GraphQLISO8601Date | null, readonly score?: number | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly requestable?: boolean | null, readonly uuid?: string | null, readonly name?: string | null, readonly category?: string | null, readonly issuingBody?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseHealthDocTarget?: { readonly __typename?: 'NurseHealthDoc', readonly id: string } | null, readonly documentTarget?: { readonly __typename?: 'Document', readonly id: string, readonly uuid?: string | null, readonly title?: string | null, readonly isExpirable: boolean, readonly isExpiringSoon?: boolean | null, readonly isExpired?: boolean | null, readonly expirationType?: DocumentExpiration | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly docType?: string | null, readonly docSubtype?: string | null, readonly trackCompletionDate?: boolean | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseCertificationTarget?: { readonly __typename?: 'NurseCertification', readonly id: string, readonly certificationUuid?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null }> | null };

export type OnboardingItemSampleImageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OnboardingItemSampleImageQuery = { readonly __typename?: 'Query', readonly onboardingItemSampleImage?: string | null };

export type OnboardingPlaceholderJobPlacementFragment = { readonly __typename?: 'JobPlacement', readonly id: string, readonly isOnboardingCompleted?: boolean | null, readonly isOnboardingListPending?: boolean | null, readonly facilityName?: string | null, readonly locationCityState?: string | null, readonly startDate?: GraphQLISO8601Date | null, readonly status?: string | null };

export type BackgroundAndIdPanelDocumentFragment = { readonly __typename?: 'Document', readonly id: string, readonly title?: string | null, readonly docType?: string | null, readonly docSubtype?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly expirationType?: DocumentExpiration | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null };

export type BackgroundAndIdPanelDocumentTemplateFragment = { readonly __typename?: 'DocumentTemplate', readonly id: number, readonly key?: string | null, readonly name?: string | null, readonly types?: ReadonlyArray<string> | null, readonly expirationType?: DocumentExpiration | null };

export type CertificationsListPanelQueryVariables = Exact<{ [key: string]: never; }>;


export type CertificationsListPanelQuery = { readonly __typename?: 'Query', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly state?: string | null, readonly nurseCertifications?: ReadonlyArray<{ readonly __typename?: 'NurseCertification', readonly id: string, readonly name?: string | null, readonly issuingBody?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly name?: string | null, readonly issuingBody?: string | null, readonly issuingBodies: ReadonlyArray<string>, readonly credential?: string | null } }> | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly type?: RoleType | null } | null } | null, readonly profileCompletionSummary: { readonly __typename?: 'ProfileCompletionSummary', readonly id: string, readonly steps: ReadonlyArray<{ readonly __typename?: 'ProfileStep', readonly key: ProfileStepsEnum, readonly status: ProfileStatusEnum, readonly messages?: ReadonlyArray<string> | null }> } };

export type CeuCertificatePanelNurseProfileFragment = { readonly __typename?: 'NurseProfile', readonly id: string, readonly ceuGoals?: ReadonlyArray<{ readonly __typename?: 'CeuGoal', readonly id: string, readonly completedContactHours: number }> | null, readonly ceuCertificates: ReadonlyArray<{ readonly __typename?: 'CeuCertificate', readonly id: string, readonly name: string, readonly contactHours: number, readonly ceuCertificateType: CeuCertificateType, readonly completionDate: GraphQLISO8601Date, readonly providerNumber: string, readonly files: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }>, readonly ceuGoals: ReadonlyArray<{ readonly __typename?: 'CeuGoal', readonly id: string }> }> };

export type CeuCertificatePanelCeuGoalFragment = { readonly __typename?: 'CeuGoal', readonly id: string, readonly goalType?: string | null, readonly requiredContactHours: number, readonly endDate?: GraphQLISO8601Date | null, readonly description?: string | null, readonly ceuStateRequirement?: { readonly __typename?: 'CeuStateRequirement', readonly id: string, readonly state: string } | null };

export type CreateCeuCertificateMutationVariables = Exact<{
  nurseProfileId: Scalars['ID']['input'];
  input: CreateCeuCertificateInput;
  goalUuids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type CreateCeuCertificateMutation = { readonly __typename?: 'Mutation', readonly createCeuCertificate?: { readonly __typename?: 'CreateCeuCertificatePayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly ceuGoals?: ReadonlyArray<{ readonly __typename?: 'CeuGoal', readonly id: string, readonly completedContactHours: number }> | null, readonly ceuCertificates: ReadonlyArray<{ readonly __typename?: 'CeuCertificate', readonly id: string, readonly name: string, readonly contactHours: number, readonly ceuCertificateType: CeuCertificateType, readonly completionDate: GraphQLISO8601Date, readonly providerNumber: string, readonly files: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }>, readonly ceuGoals: ReadonlyArray<{ readonly __typename?: 'CeuGoal', readonly id: string }> }> } } | null };

export type DeleteCeuCertificateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCeuCertificateMutation = { readonly __typename?: 'Mutation', readonly deleteCeuCertificate?: { readonly __typename?: 'DeleteCeuCertificatePayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly ceuGoals?: ReadonlyArray<{ readonly __typename?: 'CeuGoal', readonly id: string, readonly completedContactHours: number }> | null, readonly ceuCertificates: ReadonlyArray<{ readonly __typename?: 'CeuCertificate', readonly id: string, readonly name: string, readonly contactHours: number, readonly ceuCertificateType: CeuCertificateType, readonly completionDate: GraphQLISO8601Date, readonly providerNumber: string, readonly files: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }>, readonly ceuGoals: ReadonlyArray<{ readonly __typename?: 'CeuGoal', readonly id: string }> }> } } | null };

export type UpdateCeuCertificateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  goalUuids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  input: UpdateCeuCertificateInput;
}>;


export type UpdateCeuCertificateMutation = { readonly __typename?: 'Mutation', readonly updateCeuCertificate?: { readonly __typename?: 'UpdateCeuCertificatePayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly ceuGoals?: ReadonlyArray<{ readonly __typename?: 'CeuGoal', readonly id: string, readonly completedContactHours: number }> | null, readonly ceuCertificates: ReadonlyArray<{ readonly __typename?: 'CeuCertificate', readonly id: string, readonly name: string, readonly contactHours: number, readonly ceuCertificateType: CeuCertificateType, readonly completionDate: GraphQLISO8601Date, readonly providerNumber: string, readonly files: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }>, readonly ceuGoals: ReadonlyArray<{ readonly __typename?: 'CeuGoal', readonly id: string }> }> } } | null };

export type CeuGoalsForDateQueryVariables = Exact<{
  date: Scalars['ISO8601Date']['input'];
}>;


export type CeuGoalsForDateQuery = { readonly __typename?: 'Query', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly ceuGoalsForDate: ReadonlyArray<{ readonly __typename?: 'CeuGoal', readonly id: string, readonly goalType?: string | null, readonly requiredContactHours: number, readonly endDate?: GraphQLISO8601Date | null, readonly description?: string | null, readonly ceuStateRequirement?: { readonly __typename?: 'CeuStateRequirement', readonly id: string, readonly state: string } | null }> } | null };

export type UpdateCeuCertificateContainerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UpdateCeuCertificateContainerQuery = { readonly __typename?: 'Query', readonly ceuCertificate?: { readonly __typename?: 'CeuCertificate', readonly id: string, readonly name: string, readonly contactHours: number, readonly ceuCertificateType: CeuCertificateType, readonly completionDate: GraphQLISO8601Date, readonly providerNumber: string, readonly files: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }>, readonly ceuGoals: ReadonlyArray<{ readonly __typename?: 'CeuGoal', readonly id: string }> } | null };

export type ChatHelpTopicsQueryVariables = Exact<{ [key: string]: never; }>;


export type ChatHelpTopicsQuery = { readonly __typename?: 'Query', readonly chatHelpTopicsByStatus?: any | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly statusForHelpArticles?: string | null } | null };

export type IntercomCollectionsQueryVariables = Exact<{
  isDuckling?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type IntercomCollectionsQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly statusForHelpArticles?: string | null } | null } | null, readonly collections: ReadonlyArray<{ readonly __typename?: 'Collection', readonly id: string, readonly name: string }> };

export type IntercomSectionsQueryVariables = Exact<{
  parentId: Scalars['Int']['input'];
}>;


export type IntercomSectionsQuery = { readonly __typename?: 'Query', readonly sections: ReadonlyArray<{ readonly __typename?: 'Section', readonly id: string, readonly name: string, readonly type: string, readonly parentId: number }> };

export type IntercomArticlesQueryVariables = Exact<{
  parentId: Scalars['Int']['input'];
  parentType: Scalars['String']['input'];
}>;


export type IntercomArticlesQuery = { readonly __typename?: 'Query', readonly articles: ReadonlyArray<{ readonly __typename?: 'Article', readonly id: string, readonly parentId: string, readonly parentType: string, readonly title: string, readonly description?: string | null, readonly body: string, readonly url: string }> };

export type ArticleContentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArticleContentQuery = { readonly __typename?: 'Query', readonly article: { readonly __typename?: 'Article', readonly id: string, readonly title: string, readonly description?: string | null, readonly body: string } };

export type LicensesAndCertificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type LicensesAndCertificationsQuery = { readonly __typename?: 'Query', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly state?: string | null, readonly nurseCertifications?: ReadonlyArray<{ readonly __typename?: 'NurseCertification', readonly id: string, readonly name?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly useCompletionDate?: boolean | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly name?: string | null, readonly issuingBody?: string | null, readonly issuingBodies: ReadonlyArray<string>, readonly credential?: string | null }, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null, readonly licenses?: ReadonlyArray<{ readonly __typename?: 'License', readonly id: string, readonly uuid?: string | null, readonly licenseType?: string | null, readonly friendlyLicenseType?: string | null, readonly licensureCompact?: string | null, readonly compact?: boolean | null, readonly stateCode?: LocationUsStates | null, readonly state?: string | null, readonly number?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly title: string, readonly isExpired: boolean, readonly isExpiringSoon: boolean, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null } | null };

export type CurrentAddressNestedUpdateUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: NestedUpdateUserInput;
}>;


export type CurrentAddressNestedUpdateUserMutation = { readonly __typename?: 'Mutation', readonly nestedUpdateUser?: { readonly __typename?: 'NestedUpdateUserPayload', readonly user: { readonly __typename?: 'User', readonly id: string, readonly city?: string | null, readonly state?: string | null, readonly streetAddress?: string | null, readonly zipcode?: string | null } } | null };

export type CurrentAddressPanelQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentAddressPanelQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly city?: string | null, readonly state?: string | null, readonly streetAddress?: string | null, readonly zipcode?: string | null } | null };

export type EducationPanelEducationFragment = { readonly __typename?: 'Education', readonly id: string, readonly schoolName: string, readonly degree: string, readonly major?: string | null, readonly gpa?: number | null, readonly graduatedOn: GraphQLISO8601Date, readonly startedOn?: GraphQLISO8601Date | null, readonly descriptions: ReadonlyArray<string>, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly address?: string | null, readonly googlePlaceId?: string | null } | null };

export type EducationPanelUpdateCacheFragment = { readonly __typename?: 'NurseProfile', readonly id: string, readonly educationComplete: boolean, readonly canApplyJobs: boolean, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly education: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly label: string, readonly status: ApplicationReadinessStatus } } }, readonly educations?: ReadonlyArray<{ readonly __typename?: 'Education', readonly id: string, readonly startedOn?: GraphQLISO8601Date | null, readonly graduatedOn: GraphQLISO8601Date, readonly schoolName: string, readonly locationAddress?: string | null, readonly googlePlaceId?: string | null, readonly degree: string, readonly descriptions: ReadonlyArray<string> }> | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly education: { readonly __typename?: 'ProfileCompletionStep', readonly status: ProfileCompletionStatusEnum } }, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly incompleteCount: number, readonly expiredCount: number, readonly percentCompleted: number, readonly pendingCount: number } } | null };

export type ResumeParserEducationSuggestionsFragment = { readonly __typename?: 'EducationSuggestion', readonly graduationDate?: GraphQLISO8601Date | null, readonly parserId?: string | null, readonly startDate?: GraphQLISO8601Date | null, readonly institutionName?: string | null, readonly suggestionDegree?: string | null, readonly suggestionLocation?: string | null, readonly locationGoogle?: { readonly __typename?: 'LocationGoogle', readonly address?: string | null, readonly placeId?: string | null } | null };

export type CreateEducationMutationVariables = Exact<{
  input: CreateEducationInput;
  parserId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateEducationMutation = { readonly __typename?: 'Mutation', readonly createEducation?: { readonly __typename?: 'CreateEducationPayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly educationComplete: boolean, readonly canApplyJobs: boolean, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly education: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly label: string, readonly status: ApplicationReadinessStatus } } }, readonly educations?: ReadonlyArray<{ readonly __typename?: 'Education', readonly id: string, readonly startedOn?: GraphQLISO8601Date | null, readonly graduatedOn: GraphQLISO8601Date, readonly schoolName: string, readonly locationAddress?: string | null, readonly googlePlaceId?: string | null, readonly degree: string, readonly descriptions: ReadonlyArray<string> }> | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly education: { readonly __typename?: 'ProfileCompletionStep', readonly status: ProfileCompletionStatusEnum } }, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly incompleteCount: number, readonly expiredCount: number, readonly percentCompleted: number, readonly pendingCount: number } } | null } } | null };

export type UpdateEducationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateEducationInput;
}>;


export type UpdateEducationMutation = { readonly __typename?: 'Mutation', readonly updateEducation?: { readonly __typename?: 'UpdateEducationPayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly educationComplete: boolean, readonly canApplyJobs: boolean, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly education: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly label: string, readonly status: ApplicationReadinessStatus } } }, readonly educations?: ReadonlyArray<{ readonly __typename?: 'Education', readonly id: string, readonly startedOn?: GraphQLISO8601Date | null, readonly graduatedOn: GraphQLISO8601Date, readonly schoolName: string, readonly locationAddress?: string | null, readonly googlePlaceId?: string | null, readonly degree: string, readonly descriptions: ReadonlyArray<string> }> | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly education: { readonly __typename?: 'ProfileCompletionStep', readonly status: ProfileCompletionStatusEnum } }, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly incompleteCount: number, readonly expiredCount: number, readonly percentCompleted: number, readonly pendingCount: number } } | null } } | null };

export type DeleteEducationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteEducationMutation = { readonly __typename?: 'Mutation', readonly deleteEducation?: { readonly __typename?: 'DeleteEducationPayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly educationComplete: boolean, readonly canApplyJobs: boolean, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly education: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly label: string, readonly status: ApplicationReadinessStatus } } }, readonly educations?: ReadonlyArray<{ readonly __typename?: 'Education', readonly id: string, readonly startedOn?: GraphQLISO8601Date | null, readonly graduatedOn: GraphQLISO8601Date, readonly schoolName: string, readonly locationAddress?: string | null, readonly googlePlaceId?: string | null, readonly degree: string, readonly descriptions: ReadonlyArray<string> }> | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly education: { readonly __typename?: 'ProfileCompletionStep', readonly status: ProfileCompletionStatusEnum } }, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly incompleteCount: number, readonly expiredCount: number, readonly percentCompleted: number, readonly pendingCount: number } } | null } } | null };

export type CollegeSuggestionsQueryVariables = Exact<{
  searchString?: InputMaybe<Scalars['String']['input']>;
}>;


export type CollegeSuggestionsQuery = { readonly __typename?: 'Query', readonly getCollegeSuggestions?: ReadonlyArray<{ readonly __typename?: 'College', readonly id?: number | null, readonly name?: string | null, readonly location?: string | null }> | null };

export type EducationFormOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type EducationFormOptionsQuery = { readonly __typename?: 'Query', readonly educationDegrees?: { readonly __typename?: '__Type', readonly name?: string | null, readonly enumValues?: ReadonlyArray<{ readonly __typename?: '__EnumValue', readonly name: string, readonly description?: string | null }> | null } | null };

export type EducationListPanelQueryVariables = Exact<{ [key: string]: never; }>;


export type EducationListPanelQuery = { readonly __typename?: 'Query', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly state?: string | null } | null, readonly educations: ReadonlyArray<{ readonly __typename?: 'Education', readonly id: string, readonly schoolName: string, readonly degree: string, readonly major?: string | null, readonly gpa?: number | null, readonly graduatedOn: GraphQLISO8601Date, readonly startedOn?: GraphQLISO8601Date | null, readonly descriptions: ReadonlyArray<string>, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly address?: string | null, readonly googlePlaceId?: string | null } | null }>, readonly parsedEducations: ReadonlyArray<{ readonly __typename?: 'EducationSuggestion', readonly graduationDate?: GraphQLISO8601Date | null, readonly parserId?: string | null, readonly startDate?: GraphQLISO8601Date | null, readonly institutionName?: string | null, readonly suggestionDegree?: string | null, readonly suggestionLocation?: string | null, readonly locationGoogle?: { readonly __typename?: 'LocationGoogle', readonly address?: string | null, readonly placeId?: string | null } | null }> };

export type EditEducationFormQueryVariables = Exact<{
  educationId: Scalars['ID']['input'];
}>;


export type EditEducationFormQuery = { readonly __typename?: 'Query', readonly education?: { readonly __typename?: 'Education', readonly id: string, readonly schoolName: string, readonly degree: string, readonly major?: string | null, readonly gpa?: number | null, readonly graduatedOn: GraphQLISO8601Date, readonly startedOn?: GraphQLISO8601Date | null, readonly descriptions: ReadonlyArray<string>, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly address?: string | null, readonly googlePlaceId?: string | null } | null } | null };

export type EditEducationSuggestionFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EditEducationSuggestionFormQuery = { readonly __typename?: 'Query', readonly parsedEducation: { readonly __typename?: 'EducationSuggestion', readonly graduationDate?: GraphQLISO8601Date | null, readonly parserId?: string | null, readonly startDate?: GraphQLISO8601Date | null, readonly institutionName?: string | null, readonly suggestionDegree?: string | null, readonly suggestionLocation?: string | null, readonly locationGoogle?: { readonly __typename?: 'LocationGoogle', readonly address?: string | null, readonly placeId?: string | null } | null } };

export type EmailConfirmationPanelUserFragment = { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly confirmedAt?: GraphQLISO8601DateTime | null, readonly confirmationSentAt?: GraphQLISO8601DateTime | null, readonly receivedEmailConfirmationLink?: boolean | null };

export type EmailConfirmationPanelVerifyCodeMutationVariables = Exact<{
  input: ConfirmUserEmailInput;
}>;


export type EmailConfirmationPanelVerifyCodeMutation = { readonly __typename?: 'Mutation', readonly confirmUserEmail?: { readonly __typename?: 'ConfirmUserEmailPayload', readonly user: { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly confirmedAt?: GraphQLISO8601DateTime | null, readonly confirmationSentAt?: GraphQLISO8601DateTime | null, readonly receivedEmailConfirmationLink?: boolean | null } } | null };

export type EmailConfirmationTokenFormResendConfirmationMutationVariables = Exact<{ [key: string]: never; }>;


export type EmailConfirmationTokenFormResendConfirmationMutation = { readonly __typename?: 'Mutation', readonly sendConfirmationEmail?: boolean | null };

export type EmailConfirmationPanelQueryVariables = Exact<{ [key: string]: never; }>;


export type EmailConfirmationPanelQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly confirmedAt?: GraphQLISO8601DateTime | null, readonly confirmationSentAt?: GraphQLISO8601DateTime | null, readonly receivedEmailConfirmationLink?: boolean | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly state?: string | null } | null } | null };

export type EmploymentGapPanelUpdateEmploymentGapMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateEmploymentGapEmploymentInput;
}>;


export type EmploymentGapPanelUpdateEmploymentGapMutation = { readonly __typename?: 'Mutation', readonly updateEmploymentGap?: { readonly __typename?: 'UpdateEmploymentGapPayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly sortedExperienceItems?: ReadonlyArray<{ readonly __typename?: 'Employment' } | { readonly __typename?: 'Gap', readonly gapId: string, readonly gapEndAt: GraphQLISO8601Date, readonly gapExplanation?: string | null, readonly gapGooglePlaceId?: string | null, readonly gapIsEducationGap?: boolean | null, readonly gapLocationAddress?: string | null, readonly gapReason?: string | null, readonly gapStartAt: GraphQLISO8601Date } | { readonly __typename?: 'Position', readonly id: string, readonly title: string, readonly positionType?: PositionTypes | null, readonly startAt?: GraphQLISO8601Date | null, readonly endAt?: GraphQLISO8601Date | null, readonly humanReadableLength?: string | null, readonly hoursWorked?: number | null, readonly hoursWorkedTimeframe?: HoursWorkedTimeframe | null, readonly additionalSkills?: string | null, readonly chargeExperience?: boolean | null, readonly leadExperience?: boolean | null, readonly preceptorExperience?: boolean | null, readonly floatFrequency?: PositionFloatFrequency | null, readonly friendlyEmploymentType?: string | null, readonly invalidOverlapByHours?: boolean | null, readonly invalidOverlapByLocation?: boolean | null, readonly usableForReferences: boolean, readonly nicuCareLevels?: ReadonlyArray<number> | null, readonly activeReferences?: ReadonlyArray<{ readonly __typename?: 'Reference', readonly id: string, readonly name?: string | null, readonly relationship?: string | null, readonly responseAt?: GraphQLISO8601Date | null }> | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly name: string } | null, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null, readonly country?: string | null } | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly agency?: { readonly __typename?: 'Agency', readonly id: string, readonly name: string } | null, readonly technologies?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null, readonly specialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string }> | null, readonly floatUnits?: ReadonlyArray<{ readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string }> | null }> | null } } | null };

export type EmploymentGapPanelDeleteEmploymentGapMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EmploymentGapPanelDeleteEmploymentGapMutation = { readonly __typename?: 'Mutation', readonly deleteEmploymentGap?: { readonly __typename?: 'DeleteEmploymentGapPayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly sortedExperienceItems?: ReadonlyArray<{ readonly __typename?: 'Employment' } | { readonly __typename?: 'Gap', readonly gapId: string, readonly gapEndAt: GraphQLISO8601Date, readonly gapExplanation?: string | null, readonly gapGooglePlaceId?: string | null, readonly gapIsEducationGap?: boolean | null, readonly gapLocationAddress?: string | null, readonly gapReason?: string | null, readonly gapStartAt: GraphQLISO8601Date } | { readonly __typename?: 'Position', readonly id: string, readonly title: string, readonly positionType?: PositionTypes | null, readonly startAt?: GraphQLISO8601Date | null, readonly endAt?: GraphQLISO8601Date | null, readonly humanReadableLength?: string | null, readonly hoursWorked?: number | null, readonly hoursWorkedTimeframe?: HoursWorkedTimeframe | null, readonly additionalSkills?: string | null, readonly chargeExperience?: boolean | null, readonly leadExperience?: boolean | null, readonly preceptorExperience?: boolean | null, readonly floatFrequency?: PositionFloatFrequency | null, readonly friendlyEmploymentType?: string | null, readonly invalidOverlapByHours?: boolean | null, readonly invalidOverlapByLocation?: boolean | null, readonly usableForReferences: boolean, readonly nicuCareLevels?: ReadonlyArray<number> | null, readonly activeReferences?: ReadonlyArray<{ readonly __typename?: 'Reference', readonly id: string, readonly name?: string | null, readonly relationship?: string | null, readonly responseAt?: GraphQLISO8601Date | null }> | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly name: string } | null, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null, readonly country?: string | null } | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly agency?: { readonly __typename?: 'Agency', readonly id: string, readonly name: string } | null, readonly technologies?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null, readonly specialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string }> | null, readonly floatUnits?: ReadonlyArray<{ readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string }> | null }> | null } } | null };

export type EmploymentGapPanelQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EmploymentGapPanelQuery = { readonly __typename?: 'Query', readonly experienceGap: { readonly __typename?: 'Gap', readonly gapId: string, readonly gapEndAt: GraphQLISO8601Date, readonly gapExplanation?: string | null, readonly gapGooglePlaceId?: string | null, readonly gapIsEducationGap?: boolean | null, readonly gapLocationAddress?: string | null, readonly gapReason?: string | null, readonly gapStartAt: GraphQLISO8601Date } };

export type FacilityReviewPanelFacilityFragment = { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly slug: string };

export type FacilityReviewPanelCreateUserAnswerMutationVariables = Exact<{
  facilitySlug: Scalars['String']['input'];
  input: CreateSurveyResponseInput;
}>;


export type FacilityReviewPanelCreateUserAnswerMutation = { readonly __typename?: 'Mutation', readonly createSurveyUserAnswers?: { readonly __typename?: 'CreateSurveyUserAnswersPayload', readonly facility: { readonly __typename?: 'Facility', readonly id: string, readonly surveyResponses?: ReadonlyArray<{ readonly __typename?: 'FacilitySurveyResponse', readonly id: string, readonly completedAt?: GraphQLISO8601Date | null, readonly answers?: ReadonlyArray<{ readonly __typename?: 'FacilitySurveyAnswer', readonly id: string, readonly answerText?: string | null, readonly answerJson?: string | null, readonly key?: string | null }> | null }> | null, readonly surveyForUser?: { readonly __typename?: 'FacilitySurveyResponse', readonly id: string, readonly completedAt?: GraphQLISO8601Date | null } | null } } | null };

export type FacilityReviewPanelFacilitySurveyQuestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type FacilityReviewPanelFacilitySurveyQuestionsQuery = { readonly __typename?: 'Query', readonly facilitySurveyQuestions?: ReadonlyArray<{ readonly __typename?: 'FacilitySurveyQuestion', readonly id: string, readonly key: string, readonly position: number, readonly text: string, readonly answerOptions: string }> | null };

export type LegalNameAndBirthdayFormUserFragment = { readonly __typename?: 'User', readonly id: string, readonly firstName?: string | null, readonly middleName?: string | null, readonly lastName?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly birthday?: GraphQLISO8601Date | null } | null };

export type LegalNameAndBirthdayNestedUpdateUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: NestedUpdateUserInput;
}>;


export type LegalNameAndBirthdayNestedUpdateUserMutation = { readonly __typename?: 'Mutation', readonly nestedUpdateUser?: { readonly __typename?: 'NestedUpdateUserPayload', readonly user: { readonly __typename?: 'User', readonly id: string, readonly firstName?: string | null, readonly middleName?: string | null, readonly lastName?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly birthday?: GraphQLISO8601Date | null } | null } } | null };

export type LegalNameAndBirthdayPanelQueryVariables = Exact<{ [key: string]: never; }>;


export type LegalNameAndBirthdayPanelQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly firstName?: string | null, readonly middleName?: string | null, readonly lastName?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly birthday?: GraphQLISO8601Date | null } | null } | null };

export type LicensePanelUpdateCacheFragment = { readonly __typename?: 'NurseProfile', readonly id: string, readonly licensesComplete: boolean, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly licenses: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly label: string, readonly status: ApplicationReadinessStatus } } }, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly license: { readonly __typename?: 'ProfileCompletionStep', readonly status: ProfileCompletionStatusEnum } } } | null, readonly licenses?: ReadonlyArray<{ readonly __typename?: 'License', readonly id: string, readonly uuid?: string | null, readonly licenseType?: string | null, readonly friendlyLicenseType?: string | null, readonly licensureCompact?: string | null, readonly compact?: boolean | null, readonly stateCode?: LocationUsStates | null, readonly state?: string | null, readonly number?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly title: string, readonly isExpired: boolean, readonly isExpiringSoon: boolean, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null };

export type LicensePanelCreateLicenseMutationVariables = Exact<{
  input: CreateLicenseInput;
  uploads?: InputMaybe<ReadonlyArray<FileUploadTypeInput> | FileUploadTypeInput>;
}>;


export type LicensePanelCreateLicenseMutation = { readonly __typename?: 'Mutation', readonly createLicense?: { readonly __typename?: 'CreateLicensePayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly licensesComplete: boolean, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly licenses: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly label: string, readonly status: ApplicationReadinessStatus } } }, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly license: { readonly __typename?: 'ProfileCompletionStep', readonly status: ProfileCompletionStatusEnum } } } | null, readonly licenses?: ReadonlyArray<{ readonly __typename?: 'License', readonly id: string, readonly uuid?: string | null, readonly licenseType?: string | null, readonly friendlyLicenseType?: string | null, readonly licensureCompact?: string | null, readonly compact?: boolean | null, readonly stateCode?: LocationUsStates | null, readonly state?: string | null, readonly number?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly title: string, readonly isExpired: boolean, readonly isExpiringSoon: boolean, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null }, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ValidationError', readonly errors: ReadonlyArray<string> }> | null } | null };

export type LicensePanelUpdateLicenseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateLicenseInput;
  uploads?: InputMaybe<ReadonlyArray<FileUploadTypeInput> | FileUploadTypeInput>;
}>;


export type LicensePanelUpdateLicenseMutation = { readonly __typename?: 'Mutation', readonly updateLicense?: { readonly __typename?: 'UpdateLicensePayload', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly licensesComplete: boolean, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly licenses: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly label: string, readonly status: ApplicationReadinessStatus } } }, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly license: { readonly __typename?: 'ProfileCompletionStep', readonly status: ProfileCompletionStatusEnum } } } | null, readonly licenses?: ReadonlyArray<{ readonly __typename?: 'License', readonly id: string, readonly uuid?: string | null, readonly licenseType?: string | null, readonly friendlyLicenseType?: string | null, readonly licensureCompact?: string | null, readonly compact?: boolean | null, readonly stateCode?: LocationUsStates | null, readonly state?: string | null, readonly number?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly title: string, readonly isExpired: boolean, readonly isExpiringSoon: boolean, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null } | null, readonly license?: { readonly __typename?: 'License', readonly id: string, readonly uuid?: string | null, readonly licenseType?: string | null, readonly friendlyLicenseType?: string | null, readonly licensureCompact?: string | null, readonly compact?: boolean | null, readonly stateCode?: LocationUsStates | null, readonly state?: string | null, readonly number?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly title: string, readonly isExpired: boolean, readonly isExpiringSoon: boolean, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ValidationError', readonly errors: ReadonlyArray<string> }> | null } | null };

export type LicensePanelDeleteLicenseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LicensePanelDeleteLicenseMutation = { readonly __typename?: 'Mutation', readonly deleteLicense?: { readonly __typename?: 'DeleteLicensePayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly licensesComplete: boolean, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly licenses: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly label: string, readonly status: ApplicationReadinessStatus } } }, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly license: { readonly __typename?: 'ProfileCompletionStep', readonly status: ProfileCompletionStatusEnum } } } | null, readonly licenses?: ReadonlyArray<{ readonly __typename?: 'License', readonly id: string, readonly uuid?: string | null, readonly licenseType?: string | null, readonly friendlyLicenseType?: string | null, readonly licensureCompact?: string | null, readonly compact?: boolean | null, readonly stateCode?: LocationUsStates | null, readonly state?: string | null, readonly number?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly title: string, readonly isExpired: boolean, readonly isExpiringSoon: boolean, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null } } | null };

export type LicensePanelQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LicensePanelQuery = { readonly __typename?: 'Query', readonly license: { readonly __typename?: 'License', readonly id: string, readonly uuid?: string | null, readonly licenseType?: string | null, readonly friendlyLicenseType?: string | null, readonly licensureCompact?: string | null, readonly compact?: boolean | null, readonly stateCode?: LocationUsStates | null, readonly state?: string | null, readonly number?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly title: string, readonly isExpired: boolean, readonly isExpiringSoon: boolean, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } };

export type LicensesListPanelQueryVariables = Exact<{ [key: string]: never; }>;


export type LicensesListPanelQuery = { readonly __typename?: 'Query', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly state?: string | null, readonly licenses?: ReadonlyArray<{ readonly __typename?: 'License', readonly id: string, readonly uuid?: string | null, readonly licenseType?: string | null, readonly friendlyLicenseType?: string | null, readonly licensureCompact?: string | null, readonly compact?: boolean | null, readonly stateCode?: LocationUsStates | null, readonly state?: string | null, readonly number?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly title: string, readonly isExpired: boolean, readonly isExpiringSoon: boolean, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null } | null };

export type CreateLicenseVerificationMutationVariables = Exact<{
  input: CreateLicenseVerificationInput;
  uploads?: InputMaybe<ReadonlyArray<FileUploadTypeInput> | FileUploadTypeInput>;
}>;


export type CreateLicenseVerificationMutation = { readonly __typename?: 'Mutation', readonly createLicenseVerification?: { readonly __typename?: 'CreateLicenseVerificationPayload', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nurseLicenseVerifications?: ReadonlyArray<{ readonly __typename?: 'NurseLicenseVerification', readonly id: string, readonly verificationType?: string | null, readonly dateOfDownload?: GraphQLISO8601Date | null, readonly stateCode?: string | null, readonly stateCodes: ReadonlyArray<string>, readonly state?: string | null, readonly states: ReadonlyArray<string>, readonly expiresOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ValidationError', readonly errors: ReadonlyArray<string> }> | null } | null };

export type DeleteLicenseVerificationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteLicenseVerificationMutation = { readonly __typename?: 'Mutation', readonly deleteLicenseVerification?: { readonly __typename?: 'DeleteLicenseVerificationPayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nurseLicenseVerifications?: ReadonlyArray<{ readonly __typename?: 'NurseLicenseVerification', readonly id: string, readonly verificationType?: string | null, readonly dateOfDownload?: GraphQLISO8601Date | null, readonly stateCode?: string | null, readonly stateCodes: ReadonlyArray<string>, readonly state?: string | null, readonly states: ReadonlyArray<string>, readonly expiresOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null } } | null };

export type UpdateLicenseVerificationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateLicenseVerificationInput;
  uploads?: InputMaybe<ReadonlyArray<FileUploadTypeInput> | FileUploadTypeInput>;
}>;


export type UpdateLicenseVerificationMutation = { readonly __typename?: 'Mutation', readonly updateLicenseVerification?: { readonly __typename?: 'UpdateLicenseVerificationPayload', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nurseLicenseVerifications?: ReadonlyArray<{ readonly __typename?: 'NurseLicenseVerification', readonly id: string, readonly verificationType?: string | null, readonly dateOfDownload?: GraphQLISO8601Date | null, readonly stateCode?: string | null, readonly stateCodes: ReadonlyArray<string>, readonly state?: string | null, readonly states: ReadonlyArray<string>, readonly expiresOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ValidationError', readonly errors: ReadonlyArray<string> }> | null } | null };

export type UpdateLicenseVerificationPanelQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UpdateLicenseVerificationPanelQuery = { readonly __typename?: 'Query', readonly nurseLicenseVerification?: { readonly __typename?: 'NurseLicenseVerification', readonly id: string, readonly verificationType?: string | null, readonly dateOfDownload?: GraphQLISO8601Date | null, readonly stateCode?: string | null, readonly stateCodes: ReadonlyArray<string>, readonly state?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null };

export type CreateDocumentMutationVariables = Exact<{
  input: CreateDocumentInput;
  uploads?: InputMaybe<ReadonlyArray<FileUploadTypeInput> | FileUploadTypeInput>;
}>;


export type CreateDocumentMutation = { readonly __typename?: 'Mutation', readonly createDocument?: { readonly __typename?: 'CreateDocumentPayload', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly documents?: ReadonlyArray<{ readonly __typename?: 'Document', readonly id: string, readonly title?: string | null, readonly docType?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null> | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ValidationError', readonly errors: ReadonlyArray<string> }> | null } | null };

export type UpdateMiscDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateDocumentInput;
  uploads?: InputMaybe<ReadonlyArray<FileUploadTypeInput> | FileUploadTypeInput>;
}>;


export type UpdateMiscDocumentMutation = { readonly __typename?: 'Mutation', readonly updateDocument?: { readonly __typename?: 'UpdateDocumentPayload', readonly document?: { readonly __typename?: 'Document', readonly id: string, readonly title?: string | null, readonly docType?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ValidationError', readonly errors: ReadonlyArray<string> }> | null } | null };

export type DeleteMiscDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMiscDocumentMutation = { readonly __typename?: 'Mutation', readonly deleteDocument?: { readonly __typename?: 'DeleteDocumentPayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly documents?: ReadonlyArray<{ readonly __typename?: 'Document', readonly id: string, readonly title?: string | null, readonly docType?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null> | null } } | null };

export type UpdateDocumentPanelQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UpdateDocumentPanelQuery = { readonly __typename?: 'Query', readonly document?: { readonly __typename?: 'Document', readonly id: string, readonly title?: string | null, readonly docType?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null };

export type NurseAssessmentPanelsNurseAssessmentFragment = { readonly __typename?: 'NurseAssessment', readonly id: string, readonly completedOn?: GraphQLISO8601Date | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly isArchived: boolean, readonly score?: number | null, readonly requestedOn?: GraphQLISO8601Date | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly category?: string | null, readonly issuingBody?: string | null, readonly name?: string | null } | null, readonly assessmentRequest?: { readonly __typename?: 'AssessmentRequest', readonly id: string, readonly score?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null };

export type AssessmentItemFragment = { readonly __typename?: 'Assessment', readonly id: string, readonly category?: string | null, readonly issuingBody?: string | null, readonly name?: string | null };

export type NurseAssessmentPanelProfileCompletionFragment = { readonly __typename?: 'NurseProfile', readonly id: string, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly skillsChecklist: { readonly __typename?: 'ProfileCompletionStep', readonly status: ProfileCompletionStatusEnum } } } | null };

export type CreateNurseAssessmentMutationVariables = Exact<{
  fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  input: CreateNurseAssessmentInput;
}>;


export type CreateNurseAssessmentMutation = { readonly __typename?: 'Mutation', readonly createNurseAssessment?: { readonly __typename?: 'CreateNurseAssessmentPayload', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly skillsComplete?: boolean | null, readonly nurseAssessments?: ReadonlyArray<{ readonly __typename?: 'NurseAssessment', readonly id: string, readonly completedOn?: GraphQLISO8601Date | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly isArchived: boolean, readonly score?: number | null, readonly requestedOn?: GraphQLISO8601Date | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly category?: string | null, readonly issuingBody?: string | null, readonly name?: string | null } | null, readonly assessmentRequest?: { readonly __typename?: 'AssessmentRequest', readonly id: string, readonly score?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null, readonly skillsChecklists: ReadonlyArray<{ readonly __typename?: 'NurseAssessment', readonly id: string, readonly completedOn?: GraphQLISO8601Date | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly isArchived: boolean, readonly score?: number | null, readonly requestedOn?: GraphQLISO8601Date | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly category?: string | null, readonly issuingBody?: string | null, readonly name?: string | null } | null, readonly assessmentRequest?: { readonly __typename?: 'AssessmentRequest', readonly id: string, readonly score?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }>, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly meta: { readonly __typename?: 'ApplicationReadinessResultsMeta', readonly requirements: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly status: ApplicationReadinessStatus } }, readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly skillsChecklist: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly label: string, readonly status: ApplicationReadinessStatus } } }, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly skillsChecklist: { readonly __typename?: 'ProfileCompletionStep', readonly status: ProfileCompletionStatusEnum } } } | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ValidationError', readonly errors: ReadonlyArray<string> }> | null } | null };

export type DeleteNurseAssessmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteNurseAssessmentMutation = { readonly __typename?: 'Mutation', readonly deleteNurseAssessment?: { readonly __typename?: 'DeleteNurseAssessmentPayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly skillsComplete?: boolean | null, readonly nurseAssessments?: ReadonlyArray<{ readonly __typename?: 'NurseAssessment', readonly id: string, readonly completedOn?: GraphQLISO8601Date | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly isArchived: boolean, readonly score?: number | null, readonly requestedOn?: GraphQLISO8601Date | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly category?: string | null, readonly issuingBody?: string | null, readonly name?: string | null } | null, readonly assessmentRequest?: { readonly __typename?: 'AssessmentRequest', readonly id: string, readonly score?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null, readonly skillsChecklists: ReadonlyArray<{ readonly __typename?: 'NurseAssessment', readonly id: string, readonly completedOn?: GraphQLISO8601Date | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly isArchived: boolean, readonly score?: number | null, readonly requestedOn?: GraphQLISO8601Date | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly category?: string | null, readonly issuingBody?: string | null, readonly name?: string | null } | null, readonly assessmentRequest?: { readonly __typename?: 'AssessmentRequest', readonly id: string, readonly score?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }>, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly meta: { readonly __typename?: 'ApplicationReadinessResultsMeta', readonly requirements: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly status: ApplicationReadinessStatus } }, readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly skillsChecklist: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly label: string, readonly status: ApplicationReadinessStatus } } }, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly skillsChecklist: { readonly __typename?: 'ProfileCompletionStep', readonly status: ProfileCompletionStatusEnum } } } | null } } | null };

export type UpdateNurseAssessmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  input: UpdateNurseAssessmentInput;
}>;


export type UpdateNurseAssessmentMutation = { readonly __typename?: 'Mutation', readonly updateNurseAssessment?: { readonly __typename?: 'UpdateNurseAssessmentPayload', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly skillsComplete?: boolean | null, readonly nurseAssessments?: ReadonlyArray<{ readonly __typename?: 'NurseAssessment', readonly id: string, readonly completedOn?: GraphQLISO8601Date | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly isArchived: boolean, readonly score?: number | null, readonly requestedOn?: GraphQLISO8601Date | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly category?: string | null, readonly issuingBody?: string | null, readonly name?: string | null } | null, readonly assessmentRequest?: { readonly __typename?: 'AssessmentRequest', readonly id: string, readonly score?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null, readonly skillsChecklists: ReadonlyArray<{ readonly __typename?: 'NurseAssessment', readonly id: string, readonly completedOn?: GraphQLISO8601Date | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly isArchived: boolean, readonly score?: number | null, readonly requestedOn?: GraphQLISO8601Date | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly category?: string | null, readonly issuingBody?: string | null, readonly name?: string | null } | null, readonly assessmentRequest?: { readonly __typename?: 'AssessmentRequest', readonly id: string, readonly score?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }>, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly meta: { readonly __typename?: 'ApplicationReadinessResultsMeta', readonly requirements: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly status: ApplicationReadinessStatus } }, readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly skillsChecklist: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly label: string, readonly status: ApplicationReadinessStatus } } }, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly skillsChecklist: { readonly __typename?: 'ProfileCompletionStep', readonly status: ProfileCompletionStatusEnum } } } | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ValidationError', readonly errors: ReadonlyArray<string> }> | null } | null };

export type RetakeReliasAssessmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RetakeReliasAssessmentMutation = { readonly __typename?: 'Mutation', readonly retakeReliasAssessment?: { readonly __typename?: 'RetakeReliasAssessmentPayload', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly skillsComplete?: boolean | null, readonly nurseAssessments?: ReadonlyArray<{ readonly __typename?: 'NurseAssessment', readonly id: string, readonly completedOn?: GraphQLISO8601Date | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly isArchived: boolean, readonly score?: number | null, readonly requestedOn?: GraphQLISO8601Date | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly category?: string | null, readonly issuingBody?: string | null, readonly name?: string | null } | null, readonly assessmentRequest?: { readonly __typename?: 'AssessmentRequest', readonly id: string, readonly score?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null, readonly skillsChecklists: ReadonlyArray<{ readonly __typename?: 'NurseAssessment', readonly id: string, readonly completedOn?: GraphQLISO8601Date | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly isArchived: boolean, readonly score?: number | null, readonly requestedOn?: GraphQLISO8601Date | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly category?: string | null, readonly issuingBody?: string | null, readonly name?: string | null } | null, readonly assessmentRequest?: { readonly __typename?: 'AssessmentRequest', readonly id: string, readonly score?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }>, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly meta: { readonly __typename?: 'ApplicationReadinessResultsMeta', readonly requirements: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly status: ApplicationReadinessStatus } }, readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly skillsChecklist: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly label: string, readonly status: ApplicationReadinessStatus } } }, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly skillsChecklist: { readonly __typename?: 'ProfileCompletionStep', readonly status: ProfileCompletionStatusEnum } } } | null } | null } | null };

export type NurseAssessmentPanelQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type NurseAssessmentPanelQuery = { readonly __typename?: 'Query', readonly nurseAssessment?: { readonly __typename?: 'NurseAssessment', readonly id: string, readonly completedOn?: GraphQLISO8601Date | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly isArchived: boolean, readonly score?: number | null, readonly requestedOn?: GraphQLISO8601Date | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly category?: string | null, readonly issuingBody?: string | null, readonly name?: string | null } | null, readonly assessmentRequest?: { readonly __typename?: 'AssessmentRequest', readonly id: string, readonly score?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null };

export type AssessmentSuggestionsQueryVariables = Exact<{
  searchString?: InputMaybe<Scalars['String']['input']>;
  issuingBody?: InputMaybe<Scalars['String']['input']>;
  skillsChecklistsOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AssessmentSuggestionsQuery = { readonly __typename?: 'Query', readonly getAssessmentSuggestions?: ReadonlyArray<{ readonly __typename?: 'Assessment', readonly id: string, readonly issuingBody?: string | null, readonly name?: string | null, readonly category?: string | null }> | null };

export type NurseAssessmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type NurseAssessmentsQuery = { readonly __typename?: 'Query', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly state?: string | null, readonly skillsChecklists: ReadonlyArray<{ readonly __typename?: 'NurseAssessment', readonly id: string, readonly completedOn?: GraphQLISO8601Date | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly isArchived: boolean, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly score?: number | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly category?: string | null, readonly issuingBody?: string | null, readonly name?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null, readonly assessmentRequest?: { readonly __typename?: 'AssessmentRequest', readonly id: string, readonly score?: string | null } | null }> } | null };

export type CreateNurseCertificationMutationVariables = Exact<{
  certificationId: Scalars['ID']['input'];
  input: CreateNurseCertificationInput;
}>;


export type CreateNurseCertificationMutation = { readonly __typename?: 'Mutation', readonly createNurseCertification?: { readonly __typename?: 'CreateNurseCertificationPayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly certificationsComplete: boolean, readonly nurseCertifications?: ReadonlyArray<{ readonly __typename?: 'NurseCertification', readonly id: string, readonly name?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly useCompletionDate?: boolean | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly name?: string | null, readonly issuingBody?: string | null, readonly issuingBodies: ReadonlyArray<string>, readonly credential?: string | null }, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null }, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ValidationError', readonly errors: ReadonlyArray<string> }> | null } | null };

export type UpdateNurseCertificationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  certificationId: Scalars['ID']['input'];
  input: UpdateNurseCertificationInput;
}>;


export type UpdateNurseCertificationMutation = { readonly __typename?: 'Mutation', readonly updateNurseCertification?: { readonly __typename?: 'UpdateNurseCertificationPayload', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly certificationsComplete: boolean, readonly nurseCertifications?: ReadonlyArray<{ readonly __typename?: 'NurseCertification', readonly id: string, readonly name?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly useCompletionDate?: boolean | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly name?: string | null, readonly issuingBody?: string | null, readonly issuingBodies: ReadonlyArray<string>, readonly credential?: string | null }, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ValidationError', readonly errors: ReadonlyArray<string> }> | null } | null };

export type DeleteNurseCertificationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteNurseCertificationMutation = { readonly __typename?: 'Mutation', readonly deleteNurseCertification?: { readonly __typename?: 'DeleteNurseCertificationPayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly certificationsComplete: boolean, readonly nurseCertifications?: ReadonlyArray<{ readonly __typename?: 'NurseCertification', readonly id: string, readonly name?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly useCompletionDate?: boolean | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly name?: string | null, readonly issuingBody?: string | null, readonly issuingBodies: ReadonlyArray<string>, readonly credential?: string | null }, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null } } | null };

export type NurseCertificationPanelQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type NurseCertificationPanelQuery = { readonly __typename?: 'Query', readonly nurseCertification?: { readonly __typename?: 'NurseCertification', readonly id: string, readonly name?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly useCompletionDate?: boolean | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly name?: string | null, readonly issuingBody?: string | null, readonly issuingBodies: ReadonlyArray<string>, readonly credential?: string | null }, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null };

export type NurseHealthDocumentPanelAvailableHealthDocFragment = { readonly __typename?: 'HealthDoc', readonly id: string, readonly name?: string | null, readonly categories?: ReadonlyArray<string | null> | null, readonly formType: string, readonly validFor?: number | null };

export type NurseHealthDocumentPanelHealthDocFragment = { readonly __typename?: 'NurseHealthDoc', readonly id: string, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly category?: string | null, readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string }, readonly healthDoc: { readonly __typename?: 'HealthDoc', readonly id: string, readonly name?: string | null, readonly categories?: ReadonlyArray<string | null> | null, readonly formType: string, readonly validFor?: number | null }, readonly details?: { readonly __typename?: 'NurseHealthDocVaccination', readonly entries?: ReadonlyArray<{ readonly __typename?: 'NurseHealthDocVaccineDeclination', readonly type: string, readonly kind: NurseHealthDocVaccinationKindEnum, readonly reason: string } | { readonly __typename?: 'NurseHealthDocVaccineShot', readonly type: string, readonly kind: NurseHealthDocVaccinationKindEnum, readonly brand: string, readonly completedOn: GraphQLISO8601Date } | { readonly __typename?: 'NurseHealthDocVaccineWilling', readonly type: string, readonly kind: NurseHealthDocVaccinationKindEnum }> | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null };

type AllBasicErrors_BadUserInputError_Fragment = { readonly __typename?: 'BadUserInputError', readonly argument: string, readonly message: string };

type AllBasicErrors_ModelValidationError_Fragment = { readonly __typename?: 'ModelValidationError', readonly message: string, readonly attributes: ReadonlyArray<{ readonly __typename?: 'ModelValidationAttributeError', readonly attribute: string, readonly humanAttribute: string, readonly errors: ReadonlyArray<{ readonly __typename?: 'ModelValidationAttributeErrorDetails', readonly message: string, readonly fullMessage: string, readonly code: string }> }> };

type AllBasicErrors_NotFoundError_Fragment = { readonly __typename?: 'NotFoundError', readonly model: string, readonly message: string };

type AllBasicErrors_RecordNotUniqueError_Fragment = { readonly __typename?: 'RecordNotUniqueError', readonly model: string, readonly message: string };

export type AllBasicErrorsFragment = AllBasicErrors_BadUserInputError_Fragment | AllBasicErrors_ModelValidationError_Fragment | AllBasicErrors_NotFoundError_Fragment | AllBasicErrors_RecordNotUniqueError_Fragment;

export type CovidVaccinationCardNurseProfileFragment = { readonly __typename?: 'NurseProfile', readonly id: string, readonly covidVaccination?: { readonly __typename?: 'NurseHealthDoc', readonly id: string, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null } | null, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly covidVaccination?: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly status: ApplicationReadinessStatus } | null } } };

export type CreateNurseHealthDocMutationVariables = Exact<{
  healthDocId: Scalars['ID']['input'];
  fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  input: CreateNurseHealthDocInput;
}>;


export type CreateNurseHealthDocMutation = { readonly __typename?: 'Mutation', readonly createNurseHealthDoc?: { readonly __typename?: 'CreateNurseHealthDocPayload', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nurseHealthDocs?: ReadonlyArray<{ readonly __typename?: 'NurseHealthDoc', readonly id: string, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly category?: string | null, readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string }, readonly healthDoc: { readonly __typename?: 'HealthDoc', readonly id: string, readonly name?: string | null, readonly categories?: ReadonlyArray<string | null> | null, readonly formType: string, readonly validFor?: number | null }, readonly details?: { readonly __typename?: 'NurseHealthDocVaccination', readonly entries?: ReadonlyArray<{ readonly __typename?: 'NurseHealthDocVaccineDeclination', readonly type: string, readonly kind: NurseHealthDocVaccinationKindEnum, readonly reason: string } | { readonly __typename?: 'NurseHealthDocVaccineShot', readonly type: string, readonly kind: NurseHealthDocVaccinationKindEnum, readonly brand: string, readonly completedOn: GraphQLISO8601Date } | { readonly __typename?: 'NurseHealthDocVaccineWilling', readonly type: string, readonly kind: NurseHealthDocVaccinationKindEnum }> | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null, readonly covidVaccination?: { readonly __typename?: 'NurseHealthDoc', readonly id: string, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null } | null, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly covidVaccination?: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly status: ApplicationReadinessStatus } | null } } } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ValidationError', readonly errors: ReadonlyArray<string> }> | null } | null };

export type CreateNurseHealthDocVaccinationMutationVariables = Exact<{
  fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  input: ReadonlyArray<NurseHealthDocVaccinationInput> | NurseHealthDocVaccinationInput;
}>;


export type CreateNurseHealthDocVaccinationMutation = { readonly __typename?: 'Mutation', readonly createNurseHealthDocVaccination?: { readonly __typename?: 'CreateNurseHealthDocVaccinationPayload', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nurseHealthDocs?: ReadonlyArray<{ readonly __typename?: 'NurseHealthDoc', readonly id: string, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly category?: string | null, readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string }, readonly healthDoc: { readonly __typename?: 'HealthDoc', readonly id: string, readonly name?: string | null, readonly categories?: ReadonlyArray<string | null> | null, readonly formType: string, readonly validFor?: number | null }, readonly details?: { readonly __typename?: 'NurseHealthDocVaccination', readonly entries?: ReadonlyArray<{ readonly __typename?: 'NurseHealthDocVaccineDeclination', readonly type: string, readonly kind: NurseHealthDocVaccinationKindEnum, readonly reason: string } | { readonly __typename?: 'NurseHealthDocVaccineShot', readonly type: string, readonly kind: NurseHealthDocVaccinationKindEnum, readonly brand: string, readonly completedOn: GraphQLISO8601Date } | { readonly __typename?: 'NurseHealthDocVaccineWilling', readonly type: string, readonly kind: NurseHealthDocVaccinationKindEnum }> | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null, readonly covidVaccination?: { readonly __typename?: 'NurseHealthDoc', readonly id: string, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null } | null, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly covidVaccination?: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly status: ApplicationReadinessStatus } | null } } } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'BadUserInputError', readonly argument: string, readonly message: string } | { readonly __typename?: 'ModelValidationError', readonly message: string, readonly attributes: ReadonlyArray<{ readonly __typename?: 'ModelValidationAttributeError', readonly attribute: string, readonly humanAttribute: string, readonly errors: ReadonlyArray<{ readonly __typename?: 'ModelValidationAttributeErrorDetails', readonly message: string, readonly fullMessage: string, readonly code: string }> }> } | { readonly __typename?: 'NotFoundError', readonly model: string, readonly message: string } | { readonly __typename?: 'RecordNotUniqueError', readonly model: string, readonly message: string }> | null } | null };

export type UpdateNurseHealthDocMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  healthDocId: Scalars['ID']['input'];
  fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  input: UpdateNurseHealthDocInput;
}>;


export type UpdateNurseHealthDocMutation = { readonly __typename?: 'Mutation', readonly updateNurseHealthDoc?: { readonly __typename?: 'UpdateNurseHealthDocPayload', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nurseHealthDocs?: ReadonlyArray<{ readonly __typename?: 'NurseHealthDoc', readonly id: string, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly category?: string | null, readonly todoListItems?: ReadonlyArray<{ readonly __typename?: 'TodoListItem', readonly id: string, readonly itemState?: string | null }> | null, readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string }, readonly healthDoc: { readonly __typename?: 'HealthDoc', readonly id: string, readonly name?: string | null, readonly categories?: ReadonlyArray<string | null> | null, readonly formType: string, readonly validFor?: number | null }, readonly details?: { readonly __typename?: 'NurseHealthDocVaccination', readonly entries?: ReadonlyArray<{ readonly __typename?: 'NurseHealthDocVaccineDeclination', readonly type: string, readonly kind: NurseHealthDocVaccinationKindEnum, readonly reason: string } | { readonly __typename?: 'NurseHealthDocVaccineShot', readonly type: string, readonly kind: NurseHealthDocVaccinationKindEnum, readonly brand: string, readonly completedOn: GraphQLISO8601Date } | { readonly __typename?: 'NurseHealthDocVaccineWilling', readonly type: string, readonly kind: NurseHealthDocVaccinationKindEnum }> | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null, readonly covidVaccination?: { readonly __typename?: 'NurseHealthDoc', readonly id: string, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null } | null, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly covidVaccination?: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly status: ApplicationReadinessStatus } | null } } } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ValidationError', readonly errors: ReadonlyArray<string> }> | null } | null };

export type UpdateNurseHealthDocVaccinationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  input: ReadonlyArray<NurseHealthDocVaccinationInput> | NurseHealthDocVaccinationInput;
}>;


export type UpdateNurseHealthDocVaccinationMutation = { readonly __typename?: 'Mutation', readonly updateNurseHealthDocVaccination?: { readonly __typename?: 'UpdateNurseHealthDocVaccinationPayload', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nurseHealthDocs?: ReadonlyArray<{ readonly __typename?: 'NurseHealthDoc', readonly id: string, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly category?: string | null, readonly todoListItems?: ReadonlyArray<{ readonly __typename?: 'TodoListItem', readonly id: string, readonly itemState?: string | null }> | null, readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string }, readonly healthDoc: { readonly __typename?: 'HealthDoc', readonly id: string, readonly name?: string | null, readonly categories?: ReadonlyArray<string | null> | null, readonly formType: string, readonly validFor?: number | null }, readonly details?: { readonly __typename?: 'NurseHealthDocVaccination', readonly entries?: ReadonlyArray<{ readonly __typename?: 'NurseHealthDocVaccineDeclination', readonly type: string, readonly kind: NurseHealthDocVaccinationKindEnum, readonly reason: string } | { readonly __typename?: 'NurseHealthDocVaccineShot', readonly type: string, readonly kind: NurseHealthDocVaccinationKindEnum, readonly brand: string, readonly completedOn: GraphQLISO8601Date } | { readonly __typename?: 'NurseHealthDocVaccineWilling', readonly type: string, readonly kind: NurseHealthDocVaccinationKindEnum }> | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null, readonly covidVaccination?: { readonly __typename?: 'NurseHealthDoc', readonly id: string, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null } | null, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly covidVaccination?: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly status: ApplicationReadinessStatus } | null } } } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'BadUserInputError', readonly argument: string, readonly message: string } | { readonly __typename?: 'ModelValidationError', readonly message: string, readonly attributes: ReadonlyArray<{ readonly __typename?: 'ModelValidationAttributeError', readonly attribute: string, readonly humanAttribute: string, readonly errors: ReadonlyArray<{ readonly __typename?: 'ModelValidationAttributeErrorDetails', readonly message: string, readonly fullMessage: string, readonly code: string }> }> } | { readonly __typename?: 'NotFoundError', readonly model: string, readonly message: string } | { readonly __typename?: 'RecordNotUniqueError', readonly model: string, readonly message: string }> | null } | null };

export type DeleteNurseHealthDocMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteNurseHealthDocMutation = { readonly __typename?: 'Mutation', readonly deleteNurseHealthDoc?: { readonly __typename?: 'DeleteNurseHealthDocPayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nurseHealthDocs?: ReadonlyArray<{ readonly __typename?: 'NurseHealthDoc', readonly id: string, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly category?: string | null, readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string }, readonly healthDoc: { readonly __typename?: 'HealthDoc', readonly id: string, readonly name?: string | null, readonly categories?: ReadonlyArray<string | null> | null, readonly formType: string, readonly validFor?: number | null }, readonly details?: { readonly __typename?: 'NurseHealthDocVaccination', readonly entries?: ReadonlyArray<{ readonly __typename?: 'NurseHealthDocVaccineDeclination', readonly type: string, readonly kind: NurseHealthDocVaccinationKindEnum, readonly reason: string } | { readonly __typename?: 'NurseHealthDocVaccineShot', readonly type: string, readonly kind: NurseHealthDocVaccinationKindEnum, readonly brand: string, readonly completedOn: GraphQLISO8601Date } | { readonly __typename?: 'NurseHealthDocVaccineWilling', readonly type: string, readonly kind: NurseHealthDocVaccinationKindEnum }> | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null, readonly covidVaccination?: { readonly __typename?: 'NurseHealthDoc', readonly id: string, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null } | null, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly covidVaccination?: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly status: ApplicationReadinessStatus } | null } } } } | null };

export type UpdateOnboardingNeedsToBeScheduledMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  needsToBeScheduled: Scalars['Boolean']['input'];
}>;


export type UpdateOnboardingNeedsToBeScheduledMutation = { readonly __typename?: 'Mutation', readonly updateOnboardingNeedsToBeScheduled?: { readonly __typename?: 'UpdateOnboardingNeedsToBeScheduledPayload', readonly todoListItem: { readonly __typename?: 'TodoListItem', readonly id: string, readonly needsToBeScheduled?: boolean | null } } | null };

export type AvailableHealthDocsQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableHealthDocsQuery = { readonly __typename?: 'Query', readonly availableHealthDocs?: ReadonlyArray<{ readonly __typename?: 'HealthDoc', readonly id: string, readonly name?: string | null, readonly categories?: ReadonlyArray<string | null> | null, readonly formType: string, readonly validFor?: number | null } | null> | null };

export type NurseHealthDocumentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type NurseHealthDocumentQuery = { readonly __typename?: 'Query', readonly nurseHealthDoc?: { readonly __typename?: 'NurseHealthDoc', readonly id: string, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly category?: string | null, readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string }, readonly healthDoc: { readonly __typename?: 'HealthDoc', readonly id: string, readonly name?: string | null, readonly categories?: ReadonlyArray<string | null> | null, readonly formType: string, readonly validFor?: number | null }, readonly details?: { readonly __typename?: 'NurseHealthDocVaccination', readonly entries?: ReadonlyArray<{ readonly __typename?: 'NurseHealthDocVaccineDeclination', readonly type: string, readonly kind: NurseHealthDocVaccinationKindEnum, readonly reason: string } | { readonly __typename?: 'NurseHealthDocVaccineShot', readonly type: string, readonly kind: NurseHealthDocVaccinationKindEnum, readonly brand: string, readonly completedOn: GraphQLISO8601Date } | { readonly __typename?: 'NurseHealthDocVaccineWilling', readonly type: string, readonly kind: NurseHealthDocVaccinationKindEnum }> | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null };

export type DefaultCovidVaccineHealthDocQueryVariables = Exact<{ [key: string]: never; }>;


export type DefaultCovidVaccineHealthDocQuery = { readonly __typename?: 'Query', readonly defaultCovidVaccineHealthDoc?: { readonly __typename?: 'HealthDoc', readonly id: string, readonly name?: string | null, readonly categories?: ReadonlyArray<string | null> | null, readonly formType: string } | null };

export type OnboardingAppointmentPanelTodoListItemFragment = { readonly __typename?: 'TodoListItem', readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly candidateNotes?: string | null };

export type OnboardingCertificationPanelTodoListItemFragment = { readonly __typename?: 'TodoListItem', readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly nurseCertificationTarget?: { readonly __typename?: 'NurseCertification', readonly id: string, readonly certificationUuid?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null };

export type OnboardingDocumentPanelDocumentFragment = { readonly __typename?: 'Document', readonly id: string, readonly uuid?: string | null, readonly title?: string | null, readonly isExpirable: boolean, readonly isExpiringSoon?: boolean | null, readonly isExpired?: boolean | null, readonly expirationType?: DocumentExpiration | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly docType?: string | null, readonly docSubtype?: string | null, readonly trackCompletionDate?: boolean | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null };

export type OnboardingDocumentPanelTodoListItemFragment = { readonly __typename?: 'TodoListItem', readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly documentTarget?: { readonly __typename?: 'Document', readonly id: string, readonly uuid?: string | null, readonly title?: string | null, readonly isExpirable: boolean, readonly isExpiringSoon?: boolean | null, readonly isExpired?: boolean | null, readonly expirationType?: DocumentExpiration | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly docType?: string | null, readonly docSubtype?: string | null, readonly trackCompletionDate?: boolean | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null };

export type OnboardingItemLicensePanelTodoListItemFragment = { readonly __typename?: 'TodoListItem', readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly requiresVerification?: boolean | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly url: string, readonly title: string }>, readonly licenseTarget?: { readonly __typename?: 'License', readonly id: string, readonly licenseType?: string | null } | null };

export type OnboardingItemLicenseFormLicenseFragment = { readonly __typename?: 'License', readonly id: string, readonly number?: string | null, readonly licenseType?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly stateCode?: LocationUsStates | null, readonly licensureCompact?: string | null, readonly friendlyLicenseType?: string | null };

export type UpdateLicenseOnboardingItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  licenseType: AlliedHealthNursingLicenseType;
  licenseId?: InputMaybe<Scalars['ID']['input']>;
  input: UpdateLicenseOnboardingItemInput;
}>;


export type UpdateLicenseOnboardingItemMutation = { readonly __typename?: 'Mutation', readonly updateLicenseOnboardingItem?: { readonly __typename?: 'UpdateLicenseOnboardingItemPayload', readonly todoListItem: { readonly __typename?: 'TodoListItem', readonly id: string, readonly itemState?: string | null, readonly licenseTarget?: { readonly __typename?: 'License', readonly id: string, readonly licenseType?: string | null } | null } } | null };

export type OnboardingItemLicensePanelQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OnboardingItemLicensePanelQuery = { readonly __typename?: 'Query', readonly todoListItem?: { readonly __typename?: 'TodoListItem', readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly requiresVerification?: boolean | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly url: string, readonly title: string }>, readonly licenseTarget?: { readonly __typename?: 'License', readonly id: string, readonly licenseType?: string | null } | null } | null };

export type OnboardingItemLicenseFormExistingLicensesQueryVariables = Exact<{ [key: string]: never; }>;


export type OnboardingItemLicenseFormExistingLicensesQuery = { readonly __typename?: 'Query', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly licenses?: ReadonlyArray<{ readonly __typename?: 'License', readonly id: string, readonly number?: string | null, readonly licenseType?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly stateCode?: LocationUsStates | null, readonly licensureCompact?: string | null, readonly friendlyLicenseType?: string | null }> | null } | null };

export type OnboardingNurseAssessmentPanelAssessmentFragment = { readonly __typename?: 'Assessment', readonly id: string, readonly uuid?: string | null, readonly category?: string | null, readonly issuingBody?: string | null, readonly name?: string | null, readonly requestable?: boolean | null };

export type OnboardingNurseAssessmentPanelTodoListItemFragment = { readonly __typename?: 'TodoListItem', readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly itemState?: string | null, readonly nurseAssessmentTarget?: { readonly __typename?: 'NurseAssessment', readonly id: string, readonly uuid?: string | null, readonly completedOn?: GraphQLISO8601Date | null, readonly score?: number | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly uuid?: string | null, readonly category?: string | null, readonly issuingBody?: string | null, readonly name?: string | null, readonly requestable?: boolean | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null };

export type OnboardingPlainTextPanelTodoListItemFragment = { readonly __typename?: 'TodoListItem', readonly id: string, readonly uuid?: string | null, readonly itemType?: string | null, readonly itemState?: string | null, readonly candidateNotes?: string | null, readonly description?: string | null, readonly name?: string | null };

export type OnboardingRequestAssessmentPanelTodoListItemFragment = { readonly __typename?: 'TodoListItem', readonly id: string, readonly nurseAssessmentTarget?: { readonly __typename?: 'NurseAssessment', readonly id: string, readonly assessment?: { readonly __typename?: 'Assessment', readonly uuid?: string | null, readonly name?: string | null } | null } | null };

export type PermanentAddressNestedUpdateUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: NestedUpdateUserInput;
}>;


export type PermanentAddressNestedUpdateUserMutation = { readonly __typename?: 'Mutation', readonly nestedUpdateUser?: { readonly __typename?: 'NestedUpdateUserPayload', readonly user: { readonly __typename?: 'User', readonly id: string, readonly cityPermanent?: string | null, readonly countryPermanentCode?: string | null, readonly countryPermanentName?: string | null, readonly googlePlaceIdPermanent?: string | null, readonly statePermanent?: string | null, readonly streetAddressPermanent?: string | null, readonly streetNumberPermanent?: string | null, readonly zipcodePermanent?: string | null } } | null };

export type PermanentAddressPanelV2QueryVariables = Exact<{ [key: string]: never; }>;


export type PermanentAddressPanelV2Query = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly cityPermanent?: string | null, readonly countryPermanentCode?: string | null, readonly countryPermanentName?: string | null, readonly googlePlaceIdPermanent?: string | null, readonly statePermanent?: string | null, readonly streetAddressPermanent?: string | null, readonly streetNumberPermanent?: string | null, readonly zipcodePermanent?: string | null } | null };

export type PersonalInfoSectionUserFragment = { readonly __typename?: 'User', readonly id: string, readonly firstName?: string | null, readonly middleName?: string | null, readonly lastName?: string | null, readonly preferredName?: string | null, readonly phone?: string | null, readonly preferredPronoun?: string | null, readonly cityPermanent?: string | null, readonly countryPermanentCode?: string | null, readonly countryPermanentName?: string | null, readonly googlePlaceIdPermanent?: string | null, readonly statePermanent?: string | null, readonly streetAddressPermanent?: string | null, readonly streetNumberPermanent?: string | null, readonly zipcodePermanent?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly state?: string | null, readonly birthday?: GraphQLISO8601Date | null, readonly fullSsnCollected: boolean, readonly ssnLast4?: string | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly name: string, readonly type?: RoleType | null } | null, readonly primarySpecialty?: { readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly fullName?: string | null, readonly slug: string } | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly personalInfo: { readonly __typename?: 'ProfileCompletionStep', readonly status: ProfileCompletionStatusEnum }, readonly permanentAddress: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly message?: string | null, readonly status: ProfileCompletionStatusEnum } } } | null } | null };

export type PersonalInfoPanelQueryVariables = Exact<{ [key: string]: never; }>;


export type PersonalInfoPanelQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly firstName?: string | null, readonly middleName?: string | null, readonly lastName?: string | null, readonly preferredName?: string | null, readonly phone?: string | null, readonly preferredPronoun?: string | null, readonly cityPermanent?: string | null, readonly countryPermanentCode?: string | null, readonly countryPermanentName?: string | null, readonly googlePlaceIdPermanent?: string | null, readonly statePermanent?: string | null, readonly streetAddressPermanent?: string | null, readonly streetNumberPermanent?: string | null, readonly zipcodePermanent?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly state?: string | null, readonly birthday?: GraphQLISO8601Date | null, readonly fullSsnCollected: boolean, readonly ssnLast4?: string | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly name: string, readonly type?: RoleType | null } | null, readonly primarySpecialty?: { readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly fullName?: string | null, readonly slug: string } | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly personalInfo: { readonly __typename?: 'ProfileCompletionStep', readonly status: ProfileCompletionStatusEnum }, readonly permanentAddress: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly message?: string | null, readonly status: ProfileCompletionStatusEnum } } } | null } | null } | null };

export type AssignAssessmentPanelNurseAssessmentFragment = { readonly __typename?: 'NurseAssessment', readonly id: string, readonly name?: string | null, readonly category?: string | null, readonly requestedOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly issuingBody?: string | null } | null };

export type RequestableAssessmentSuggestionFragment = { readonly __typename?: 'Assessment', readonly id: string, readonly name?: string | null, readonly category?: string | null };

export type AssignAssessmentMutationVariables = Exact<{
  assessmentIds: ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type AssignAssessmentMutation = { readonly __typename?: 'Mutation', readonly assignReliasAssessments?: { readonly __typename?: 'AssignReliasAssessmentsPayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nurseAssessments?: ReadonlyArray<{ readonly __typename?: 'NurseAssessment', readonly id: string, readonly name?: string | null, readonly category?: string | null, readonly requestedOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly issuingBody?: string | null } | null }> | null, readonly skillsChecklists: ReadonlyArray<{ readonly __typename?: 'NurseAssessment', readonly id: string, readonly name?: string | null, readonly category?: string | null, readonly requestedOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly issuingBody?: string | null } | null }> } } | null };

export type RequestableAssessmentSuggestionsQueryVariables = Exact<{
  searchString?: InputMaybe<Scalars['String']['input']>;
}>;


export type RequestableAssessmentSuggestionsQuery = { readonly __typename?: 'Query', readonly getRequestableAssessmentSuggestions?: ReadonlyArray<{ readonly __typename?: 'Assessment', readonly id: string, readonly name?: string | null, readonly category?: string | null }> | null };

export type PayPeriodTablePayrollFragment = { readonly __typename?: 'Payroll', readonly id: string, readonly periodStart: GraphQLISO8601Date, readonly periodEnd: GraphQLISO8601Date, readonly businessName?: string | null, readonly contract?: { readonly __typename?: 'Contract', readonly id: string, readonly contractStartDate: GraphQLISO8601Date, readonly contractEndDate: GraphQLISO8601Date } | null };

export type PayPeriodRowPayrollFragment = { readonly __typename?: 'Payroll', readonly id: string, readonly periodStart: GraphQLISO8601Date, readonly periodEnd: GraphQLISO8601Date, readonly businessName?: string | null };

export type PaymentSummaryPayrollLineItemFragment = { readonly __typename?: 'PayrollLineItem', readonly kind: string, readonly hours?: number | null, readonly rate?: number | null, readonly netAmount: number, readonly order: number, readonly groupType: PayrollLineItemGroup, readonly humanizedLabel: string };

export type PermanentAddressUserFragment = { readonly __typename?: 'User', readonly id: string, readonly cityPermanent?: string | null, readonly countryPermanentCode?: string | null, readonly countryPermanentName?: string | null, readonly googlePlaceIdPermanent?: string | null, readonly statePermanent?: string | null, readonly streetAddressPermanent?: string | null, readonly streetNumberPermanent?: string | null, readonly zipcodePermanent?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly permanentAddress: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly message?: string | null, readonly status: ProfileCompletionStatusEnum } } } | null } | null };

export type PopularCitiesCostOfLivingFragment = { readonly __typename?: 'PopularCityCostOfLiving', readonly id: string, readonly city: string, readonly stateCode: string, readonly avgRent?: number | null };

export type CityCardContainerCityPayFragment = { readonly __typename?: 'PopularCityPay', readonly id: string, readonly city: string, readonly stateCode: string, readonly travelWeeklyIncome?: number | null, readonly staffHourlyIncome?: number | null };

export type CertificationsListNurseProfileFragment = { readonly __typename?: 'NurseProfile', readonly id: string, readonly canApplyJobs: boolean, readonly certificationsComplete: boolean, readonly licenses?: ReadonlyArray<{ readonly __typename?: 'License', readonly id: string }> | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly certification: { readonly __typename?: 'ProfileCompletionStep', readonly status: ProfileCompletionStatusEnum } } } | null };

export type CertificationsListNurseCertificationFragment = { readonly __typename?: 'NurseCertification', readonly id: string, readonly name?: string | null, readonly issuingBody?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly name?: string | null, readonly issuingBody?: string | null, readonly issuingBodies: ReadonlyArray<string>, readonly credential?: string | null } };

export type CertificationsListProfileCompletionFragment = { readonly __typename?: 'NurseProfile', readonly id: string, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly certification: { readonly __typename?: 'ProfileCompletionStep', readonly status: ProfileCompletionStatusEnum } } } | null };

export type CertificationsListCreateNurseCertificationMutationVariables = Exact<{
  certificationId: Scalars['ID']['input'];
  input: CreateNurseCertificationInput;
}>;


export type CertificationsListCreateNurseCertificationMutation = { readonly __typename?: 'Mutation', readonly createNurseCertification?: { readonly __typename?: 'CreateNurseCertificationPayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly canApplyJobs: boolean, readonly certificationsComplete: boolean, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly meta: { readonly __typename?: 'ApplicationReadinessResultsMeta', readonly requirements: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly status: ApplicationReadinessStatus } }, readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly certifications: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly label: string, readonly status: ApplicationReadinessStatus } } }, readonly nurseCertifications?: ReadonlyArray<{ readonly __typename?: 'NurseCertification', readonly id: string, readonly name?: string | null, readonly issuingBody?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly name?: string | null, readonly issuingBody?: string | null, readonly issuingBodies: ReadonlyArray<string>, readonly credential?: string | null } }> | null, readonly licenses?: ReadonlyArray<{ readonly __typename?: 'License', readonly id: string }> | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly certification: { readonly __typename?: 'ProfileCompletionStep', readonly status: ProfileCompletionStatusEnum } } } | null } } | null };

export type CertificationsListUpdateNurseCertificationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  certificationId: Scalars['ID']['input'];
  input: UpdateNurseCertificationInput;
}>;


export type CertificationsListUpdateNurseCertificationMutation = { readonly __typename?: 'Mutation', readonly updateNurseCertification?: { readonly __typename?: 'UpdateNurseCertificationPayload', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly canApplyJobs: boolean, readonly certificationsComplete: boolean, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly meta: { readonly __typename?: 'ApplicationReadinessResultsMeta', readonly requirements: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly status: ApplicationReadinessStatus } }, readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly certifications: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly label: string, readonly status: ApplicationReadinessStatus } } }, readonly nurseCertifications?: ReadonlyArray<{ readonly __typename?: 'NurseCertification', readonly id: string, readonly name?: string | null, readonly issuingBody?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly name?: string | null, readonly issuingBody?: string | null, readonly issuingBodies: ReadonlyArray<string>, readonly credential?: string | null } }> | null, readonly licenses?: ReadonlyArray<{ readonly __typename?: 'License', readonly id: string }> | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly certification: { readonly __typename?: 'ProfileCompletionStep', readonly status: ProfileCompletionStatusEnum } } } | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ValidationError', readonly errors: ReadonlyArray<string> }> | null } | null };

export type CertificationsListDeleteNurseCertificationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CertificationsListDeleteNurseCertificationMutation = { readonly __typename?: 'Mutation', readonly deleteNurseCertification?: { readonly __typename?: 'DeleteNurseCertificationPayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly canApplyJobs: boolean, readonly certificationsComplete: boolean, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly meta: { readonly __typename?: 'ApplicationReadinessResultsMeta', readonly requirements: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly status: ApplicationReadinessStatus } }, readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly certifications: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly label: string, readonly status: ApplicationReadinessStatus } } }, readonly nurseCertifications?: ReadonlyArray<{ readonly __typename?: 'NurseCertification', readonly id: string, readonly name?: string | null, readonly issuingBody?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly name?: string | null, readonly issuingBody?: string | null, readonly issuingBodies: ReadonlyArray<string>, readonly credential?: string | null } }> | null, readonly licenses?: ReadonlyArray<{ readonly __typename?: 'License', readonly id: string }> | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly certification: { readonly __typename?: 'ProfileCompletionStep', readonly status: ProfileCompletionStatusEnum } } } | null } } | null };

export type CertificationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  includeCertification: Scalars['Boolean']['input'];
  includeCertifications: Scalars['Boolean']['input'];
}>;


export type CertificationQuery = { readonly __typename?: 'Query', readonly nurseCertification?: { readonly __typename?: 'NurseCertification', readonly id: string, readonly name?: string | null, readonly issuingBody?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly name?: string | null, readonly issuingBody?: string | null, readonly issuingBodies: ReadonlyArray<string>, readonly credential?: string | null } } | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nurseCertifications?: ReadonlyArray<{ readonly __typename?: 'NurseCertification', readonly id: string, readonly name?: string | null }> | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly type?: RoleType | null } | null } | null };

export type EducationListItemEducationFragment = { readonly __typename?: 'Education', readonly id: string, readonly startedOn?: GraphQLISO8601Date | null, readonly graduatedOn: GraphQLISO8601Date, readonly schoolName: string, readonly locationAddress?: string | null, readonly googlePlaceId?: string | null, readonly degree: string, readonly descriptions: ReadonlyArray<string> };

export type CreateResumeFileMutationVariables = Exact<{
  nurseProfileId: Scalars['ID']['input'];
}>;


export type CreateResumeFileMutation = { readonly __typename?: 'Mutation', readonly createResumeFile?: { readonly __typename?: 'CreateResumeFilePayload', readonly resumeTitle: string, readonly resumeFile: { readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null } } | null };

export type DocumentUpsertMutationVariables = Exact<{
  title: Scalars['String']['input'];
  docType: Scalars['String']['input'];
  fileUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DocumentUpsertMutation = { readonly __typename?: 'Mutation', readonly documentUpsert?: { readonly __typename?: 'Document', readonly id: string, readonly uuid?: string | null } | null };

export type ThisIsMeUserFragment = { readonly __typename?: 'User', readonly id: string, readonly profilePic?: string | null, readonly firstName?: string | null, readonly preferredName?: string | null, readonly middleName?: string | null, readonly lastName?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly applicationSummary?: string | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly name: string } | null, readonly primarySpecialty?: { readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly fullName?: string | null } | null } | null };

export type ThisIsMeProfileUserFragment = { readonly __typename?: 'User', readonly id: string, readonly signupSource?: SignupTypes | null, readonly profilePic?: string | null, readonly firstName?: string | null, readonly middleName?: string | null, readonly lastName?: string | null, readonly preferredName?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly canViewJobs: boolean, readonly locationAddress?: string | null, readonly hasBeenPlaced: boolean, readonly roleAbbreviation?: string | null, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly startPref?: string | null } | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly key?: string | null, readonly name: string, readonly type?: RoleType | null } | null, readonly primarySpecialty?: { readonly __typename?: 'ClinicalSpecialty', readonly displayName: string, readonly id: string, readonly fullName?: string | null, readonly slug: string } | null, readonly currentEmployment?: { readonly __typename?: 'Employment', readonly id: string, readonly locationAddress?: string | null } | null, readonly educations?: ReadonlyArray<{ readonly __typename?: 'Education', readonly id: string, readonly locationAddress?: string | null }> | null } | null };

export type ThisIsMeProfileNurseProfileFragment = { readonly __typename?: 'NurseProfile', readonly id: string, readonly primarySpecialty?: { readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly fullName?: string | null, readonly slug: string } | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly key?: string | null, readonly name: string, readonly type?: RoleType | null } | null };

export type ThisIsMeIntentSelectorUserFragment = { readonly __typename?: 'User', readonly id: string, readonly signupSource?: SignupTypes | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly canViewJobs: boolean, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly startPref?: string | null } | null } | null };

export type ThisIsMeProfileProfilePhotoFragment = { readonly __typename?: 'User', readonly id: string, readonly profilePic?: string | null };

export type ThisIsMeProfileSubheaderUserFragment = { readonly __typename?: 'User', readonly id: string, readonly firstName?: string | null, readonly middleName?: string | null, readonly lastName?: string | null, readonly preferredName?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly locationAddress?: string | null, readonly hasBeenPlaced: boolean, readonly roleAbbreviation?: string | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly key?: string | null, readonly name: string, readonly type?: RoleType | null } | null, readonly primarySpecialty?: { readonly __typename?: 'ClinicalSpecialty', readonly displayName: string } | null, readonly currentEmployment?: { readonly __typename?: 'Employment', readonly id: string, readonly locationAddress?: string | null } | null, readonly educations?: ReadonlyArray<{ readonly __typename?: 'Education', readonly id: string, readonly locationAddress?: string | null }> | null } | null };

export type ThisIsMeGetLocationFragment = { readonly __typename?: 'NurseProfile', readonly currentEmployment?: { readonly __typename?: 'Employment', readonly id: string, readonly locationAddress?: string | null } | null, readonly educations?: ReadonlyArray<{ readonly __typename?: 'Education', readonly id: string, readonly locationAddress?: string | null }> | null };

export type QualificationQuestionsCareSettingNursePreferencesFragment = { readonly __typename?: 'NursePreferences', readonly id: string, readonly careSettingOther?: string | null, readonly careSettingPrefs?: ReadonlyArray<string> | null };

export type QualificationQuestionsCareSettingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateNursePreferencesInput;
}>;


export type QualificationQuestionsCareSettingMutation = { readonly __typename?: 'Mutation', readonly updateNursePreferences?: { readonly __typename?: 'UpdateNursePreferencesPayload', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly careSettingOther?: string | null, readonly careSettingPrefs?: ReadonlyArray<string> | null } | null } | null } | null };

export type QualificationCareSettingQueryVariables = Exact<{ [key: string]: never; }>;


export type QualificationCareSettingQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly signupSource?: SignupTypes | null, readonly intercomUserHash?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly careSettingOther?: string | null, readonly careSettingPrefs?: ReadonlyArray<string> | null } | null } | null } | null };

export type ClinicalExperienceFormPositionFragment = { readonly __typename?: 'Position', readonly id: string, readonly specialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly displayName: string, readonly fullName?: string | null, readonly id: string, readonly nicu: boolean, readonly pediatric: boolean, readonly slug: string, readonly uuid: string }> | null };

export type ClinicalExperienceFormSpecialtyFragment = { readonly __typename?: 'ClinicalSpecialty', readonly displayName: string, readonly fullName?: string | null, readonly id: string, readonly nicu: boolean, readonly pediatric: boolean, readonly slug: string, readonly uuid: string };

export type ClinicalExperienceFormUpdateNurseProfileMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  clinicalSpecialtyIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  wizardCompleted: Scalars['Boolean']['input'];
}>;


export type ClinicalExperienceFormUpdateNurseProfileMutation = { readonly __typename?: 'Mutation', readonly updateNurseProfile?: { readonly __typename?: 'UpdateNurseProfilePayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly wizardCompleted: boolean, readonly clinicalExperiences?: ReadonlyArray<{ readonly __typename?: 'ClinicalExperience', readonly id: string, readonly isPrimary?: boolean | null, readonly clinicalSpecialty?: { readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly slug: string, readonly fullName?: string | null, readonly displayName: string, readonly pediatric: boolean, readonly nicu: boolean } | null }> | null } } | null };

export type ClinicalExperienceQualificationStepQueryVariables = Exact<{
  transitionFlow: Scalars['Boolean']['input'];
}>;


export type ClinicalExperienceQualificationStepQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly signupSource?: SignupTypes | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly wizardCompleted: boolean, readonly positions?: ReadonlyArray<{ readonly __typename?: 'Position', readonly id: string, readonly specialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly displayName: string, readonly fullName?: string | null, readonly id: string, readonly nicu: boolean, readonly pediatric: boolean, readonly slug: string, readonly uuid: string }> | null }> | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly locationString?: string | null } | null, readonly clinicalExperiences?: ReadonlyArray<{ readonly __typename?: 'ClinicalExperience', readonly id: string, readonly isPrimary?: boolean | null, readonly clinicalSpecialty?: { readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly slug: string, readonly fullName?: string | null, readonly displayName: string, readonly pediatric: boolean, readonly nicu: boolean } | null }> | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly key?: string | null, readonly name: string, readonly type?: RoleType | null } | null } | null } | null };

export type QualificationQuestionsNursePreferencesFragment = { readonly __typename?: 'NursePreferences', readonly id: string, readonly startPref?: string | null, readonly earliestStartDate?: GraphQLISO8601Date | null };

export type JobSearchInitialJobSearchMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateNursePreferencesInput;
}>;


export type JobSearchInitialJobSearchMutation = { readonly __typename?: 'Mutation', readonly updateNursePreferences?: { readonly __typename?: 'UpdateNursePreferencesPayload', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly startPref?: string | null, readonly earliestStartDate?: GraphQLISO8601Date | null } | null } | null } | null };

export type JobSearchQueryVariables = Exact<{ [key: string]: never; }>;


export type JobSearchQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly intercomUserHash?: string | null, readonly signupSource?: SignupTypes | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly startPref?: string | null, readonly earliestStartDate?: GraphQLISO8601Date | null } | null } | null } | null };

export type QualificationQuestionsNurseProfileFragment = { readonly __typename?: 'NurseProfile', readonly id: string, readonly roleKey?: string | null, readonly licenses?: ReadonlyArray<{ readonly __typename?: 'License', readonly id: string, readonly state?: string | null, readonly stateCode?: LocationUsStates | null, readonly licensureCompact?: string | null, readonly licenseType?: string | null }> | null };

export type QualificationQuestionsLicenseFragment = { readonly __typename?: 'License', readonly id: string, readonly licensureCompact?: string | null };

export type LicensesStepLicensesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: CreateMultipleLicensesInput;
}>;


export type LicensesStepLicensesMutation = { readonly __typename?: 'Mutation', readonly createMultipleLicenses?: { readonly __typename?: 'CreateMultipleLicensesPayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly licenses?: ReadonlyArray<{ readonly __typename?: 'License', readonly id: string, readonly licensureCompact?: string | null }> | null } } | null };

export type LicensesStepQueryVariables = Exact<{ [key: string]: never; }>;


export type LicensesStepQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly intercomUserHash?: string | null, readonly signupSource?: SignupTypes | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly roleKey?: string | null, readonly licenses?: ReadonlyArray<{ readonly __typename?: 'License', readonly id: string, readonly state?: string | null, readonly stateCode?: LocationUsStates | null, readonly licensureCompact?: string | null, readonly licenseType?: string | null }> | null } | null } | null };

export type LocationPreferencesNursePreferencesFragment = { readonly __typename?: 'NursePreferences', readonly id: string, readonly broadPrefLocations?: ReadonlyArray<BroadPrefLocations> | null, readonly locations?: ReadonlyArray<{ readonly __typename?: 'Location', readonly id: string, readonly locationString?: string | null, readonly googlePlaceId?: string | null, readonly formattedLocationString?: string | null }> | null };

export type LocationPreferencesUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateNursePreferencesInput;
}>;


export type LocationPreferencesUpdateMutation = { readonly __typename?: 'Mutation', readonly updateNursePreferences?: { readonly __typename?: 'UpdateNursePreferencesPayload', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly broadPrefLocations?: ReadonlyArray<BroadPrefLocations> | null } | null } | null } | null };

export type LocationPreferencesDefaultQueryVariables = Exact<{ [key: string]: never; }>;


export type LocationPreferencesDefaultQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly signupSource?: SignupTypes | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly broadPrefLocations?: ReadonlyArray<BroadPrefLocations> | null, readonly locations?: ReadonlyArray<{ readonly __typename?: 'Location', readonly id: string, readonly locationString?: string | null, readonly googlePlaceId?: string | null, readonly formattedLocationString?: string | null }> | null } | null } | null } | null };

export type ShiftPrefNursePreferencesFragment = { readonly __typename?: 'NursePreferences', readonly id: string, readonly shiftPref?: string | null, readonly shiftPrefs?: ReadonlyArray<string> | null };

export type MultipleShiftPreferencesStepMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateNursePreferencesInput;
}>;


export type MultipleShiftPreferencesStepMutation = { readonly __typename?: 'Mutation', readonly updateNursePreferences?: { readonly __typename?: 'UpdateNursePreferencesPayload', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly shiftPrefs?: ReadonlyArray<string> | null } | null } | null } | null };

export type QualificationShiftPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type QualificationShiftPreferencesQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly intercomUserHash?: string | null, readonly signupSource?: SignupTypes | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly shiftPref?: string | null, readonly shiftPrefs?: ReadonlyArray<string> | null } | null } | null } | null };

export type PhoneConfirmationStepUserFragment = { readonly __typename?: 'User', readonly id: string, readonly intercomUserHash?: string | null, readonly signupSource?: SignupTypes | null, readonly phone?: string | null, readonly phoneVerified: boolean, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string } | null } | null };

export type PrimarySignupPhoneConfirmationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateNursePreferencesInput;
}>;


export type PrimarySignupPhoneConfirmationMutation = { readonly __typename?: 'Mutation', readonly updateNursePreferences?: { readonly __typename?: 'UpdateNursePreferencesPayload', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly state?: string | null, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly learningPrefs?: ReadonlyArray<string> | null } | null } | null } | null };

export type PhoneConfirmationStepQueryVariables = Exact<{ [key: string]: never; }>;


export type PhoneConfirmationStepQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly intercomUserHash?: string | null, readonly signupSource?: SignupTypes | null, readonly phone?: string | null, readonly phoneVerified: boolean, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string } | null } | null } | null };

export type PhoneNumberStepQueryVariables = Exact<{ [key: string]: never; }>;


export type PhoneNumberStepQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly intercomUserHash?: string | null, readonly signupSource?: SignupTypes | null, readonly phone?: string | null, readonly phoneVerified: boolean, readonly marketingSmsAllowed: boolean } | null };

export type StartQualificationQuestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type StartQualificationQuestionsQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly intercomUserHash?: string | null, readonly signupSource?: SignupTypes | null } | null };

export type TravelExperienceStepNursePreferencesFragment = { readonly __typename?: 'NursePreferences', readonly id: string, readonly travelExperience?: TravelExperiences | null };

export type TravelExperienceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateNursePreferencesInput;
}>;


export type TravelExperienceMutation = { readonly __typename?: 'Mutation', readonly updateNursePreferences?: { readonly __typename?: 'UpdateNursePreferencesPayload', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly travelExperience?: TravelExperiences | null } | null } | null } | null };

export type TravelExperienceStepQueryVariables = Exact<{ [key: string]: never; }>;


export type TravelExperienceStepQuery = { readonly __typename?: 'Query', readonly __type?: { readonly __typename?: '__Type', readonly name?: string | null, readonly enumValues?: ReadonlyArray<{ readonly __typename?: '__EnumValue', readonly name: string, readonly description?: string | null }> | null } | null, readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly intercomUserHash?: string | null, readonly signupSource?: SignupTypes | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly travelExperience?: TravelExperiences | null } | null } | null } | null };

export type TravelExperienceTransitionStepQueryVariables = Exact<{ [key: string]: never; }>;


export type TravelExperienceTransitionStepQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly intercomUserHash?: string | null, readonly signupSource?: SignupTypes | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly travelExperience?: TravelExperiences | null } | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly type?: RoleType | null } | null } | null } | null };

export type RequestInterviewButtonJobFragment = { readonly __typename?: 'Job', readonly id: string, readonly instantOffer: boolean, readonly onHold?: boolean | null, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly grossPayWeekly?: number | null, readonly hoursPerShift?: number | null, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly shiftsPerWeek?: number | null, readonly shiftType?: string | null, readonly startDate?: GraphQLISO8601Date | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly canApply: { readonly __typename?: 'AuthorizationResult', readonly value: boolean, readonly reasons?: { readonly __typename?: 'FailureReasons', readonly fullMessages: ReadonlyArray<string> } | null }, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string, readonly state?: string | null } | null, readonly business?: { readonly __typename?: 'Facility', readonly id: string, readonly city?: string | null, readonly name: string, readonly logo?: string | null, readonly state?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null };

export type RequestInterviewButtonUserFragment = { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly isActivated?: boolean | null, readonly canApplyJobs: boolean, readonly state?: string | null, readonly percentComplete?: number | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly percentCompleted: number } } | null, readonly nurseAdvocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly email?: string | null, readonly fullName?: string | null } | null } | null };

export type RequestInterviewButtonNurseProfileFragment = { readonly __typename?: 'NurseProfile', readonly id: string, readonly isActivated?: boolean | null, readonly canApplyJobs: boolean, readonly state?: string | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly percentCompleted: number } } | null };

export type JobApplicationRequirementsUserFragment = { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly state?: string | null, readonly percentComplete?: number | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string } | null, readonly nurseAdvocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly email?: string | null, readonly fullName?: string | null } | null } | null };

export type JobApplicationRequirementsNurseAdvocateFragment = { readonly __typename?: 'SalesforceUser', readonly id: string, readonly email?: string | null, readonly fullName?: string | null };

export type JobApplicationRequirementsNurseProfileFragment = { readonly __typename?: 'NurseProfile', readonly id: string, readonly state?: string | null, readonly percentComplete?: number | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string } | null, readonly nurseAdvocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly email?: string | null, readonly fullName?: string | null } | null };

export type RequestInterviewButtonExpressInterestMutationVariables = Exact<{
  id: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
}>;


export type RequestInterviewButtonExpressInterestMutation = { readonly __typename?: 'Mutation', readonly expressInterest?: { readonly __typename?: 'Job', readonly id: string, readonly esMatch?: { readonly __typename?: 'Match', readonly id: string, readonly userState?: string | null } | null } | null };

export type RequestAutoOfferButtonQueryVariables = Exact<{ [key: string]: never; }>;


export type RequestAutoOfferButtonQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly requestedJobs: { readonly __typename?: 'CandidateRequestedJobs', readonly inProgressInstantOffers?: { readonly __typename?: 'CandidateRequestedJobsConnection', readonly nodes?: ReadonlyArray<{ readonly __typename?: 'Job', readonly id: string, readonly title?: string | null } | null> | null } | null } } | null } | null };

export type UploadResumeMutationVariables = Exact<{
  upload: FileUploadTypeInput;
}>;


export type UploadResumeMutation = { readonly __typename?: 'Mutation', readonly uploadResume?: { readonly __typename?: 'UploadResumePayload', readonly uploadedResume: { readonly __typename?: 'UploadedResume', readonly id: string, readonly resumeParserStep?: string | null } } | null };

export type UploadedResumeQueryVariables = Exact<{ [key: string]: never; }>;


export type UploadedResumeQuery = { readonly __typename?: 'Query', readonly uploadedResume?: { readonly __typename?: 'UploadedResume', readonly id: string, readonly fileName: string, readonly status: ParsingStatusEnum, readonly parserIdsCompleted: boolean } | null };

export type ResumePreviewAffiliationHistoryFragment = { readonly __typename?: 'AffiliationHistory', readonly id: string, readonly organizationName: string, readonly startDate: GraphQLISO8601Date, readonly endDate?: GraphQLISO8601Date | null, readonly role?: string | null, readonly descriptions: ReadonlyArray<string> };

export type ResumePreviewAwardsHonorsFragment = { readonly __typename?: 'Award', readonly id: string, readonly awardedOn?: GraphQLISO8601Date | null, readonly name: string, readonly organization: string, readonly descriptions: ReadonlyArray<string> };

export type ResumePreviewCertificationNurseCertificationFragment = { readonly __typename?: 'NurseCertification', readonly id: string, readonly expiresOn?: GraphQLISO8601Date | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly name?: string | null, readonly issuingBody?: string | null } };

export type ResumePreviewEducationFragment = { readonly __typename?: 'Education', readonly id: string, readonly locationAddress?: string | null, readonly startedOn?: GraphQLISO8601Date | null, readonly graduatedOn: GraphQLISO8601Date, readonly schoolName: string, readonly degree: string, readonly hasGap?: boolean | null, readonly gapStartOn?: GraphQLISO8601Date | null, readonly gapEndOn?: GraphQLISO8601Date | null, readonly gapReason?: string | null, readonly gapExplanation?: string | null, readonly descriptions: ReadonlyArray<string>, readonly gapLocation?: { readonly __typename?: 'Location', readonly id: string, readonly address?: string | null } | null };

export type ResumePreviewLanguageFragment = { readonly __typename?: 'Language', readonly id: string, readonly language: string, readonly proficiency: string };

export type ResumePreviewLicenseLicenseFragment = { readonly __typename?: 'License', readonly id: string, readonly expiresOn?: GraphQLISO8601Date | null, readonly state?: string | null, readonly friendlyLicenseType?: string | null, readonly number?: string | null, readonly compact?: boolean | null };

export type ResumePreviewResearchFragment = { readonly __typename?: 'Research', readonly id: string, readonly startOn: GraphQLISO8601Date, readonly endOn?: GraphQLISO8601Date | null, readonly orgName: string, readonly descriptions: ReadonlyArray<string>, readonly locationAddress?: string | null };

export type ResumePreviewStudentClinicalExperienceFragment = { readonly __typename?: 'StudentClinicalExperience', readonly id: string, readonly facilityName: string, readonly locationAddress?: string | null, readonly experienceYear: number, readonly experienceYearTerm: YearTerms, readonly experienceType: StudentExperienceTypes, readonly studentClinicalExperienceUnits?: ReadonlyArray<{ readonly __typename?: 'StudentClinicalExperienceUnit', readonly id: string, readonly name: string, readonly hoursWorked: number, readonly descriptions: ReadonlyArray<string> }> | null };

type ResumePreviewWorkExperienceItem_Employment_Fragment = { readonly __typename?: 'Employment' };

type ResumePreviewWorkExperienceItem_Gap_Fragment = { readonly __typename?: 'Gap', readonly gapId: string, readonly gapEndAt: GraphQLISO8601Date, readonly gapExplanation?: string | null, readonly gapIsEducationGap?: boolean | null, readonly gapLocationAddress?: string | null, readonly gapReason?: string | null, readonly gapStartAt: GraphQLISO8601Date };

type ResumePreviewWorkExperienceItem_Position_Fragment = { readonly __typename?: 'Position', readonly id: string, readonly title: string, readonly classification?: EmploymentTypes | null, readonly additionalSkills?: string | null, readonly startAt?: GraphQLISO8601Date | null, readonly endAt?: GraphQLISO8601Date | null, readonly floatFrequency?: PositionFloatFrequency | null, readonly hoursWorked?: number | null, readonly hoursWorkedText?: string | null, readonly hoursWorkedTimeframe?: HoursWorkedTimeframe | null, readonly leadExperience?: boolean | null, readonly chargeExperience?: boolean | null, readonly preceptorExperience?: boolean | null, readonly unitBedCount?: number | null, readonly hospitalBedCount?: number | null, readonly magnet: boolean, readonly teaching: boolean, readonly traumaLevel?: number | null, readonly patientRatio?: number | null, readonly nicuCareLevels?: ReadonlyArray<number> | null, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null } | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly name: string } | null, readonly floatUnits?: ReadonlyArray<{ readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string }> | null, readonly agency?: { readonly __typename?: 'Agency', readonly id: string, readonly name: string } | null, readonly specialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string }> | null, readonly technologies?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null };

export type ResumePreviewWorkExperienceItemFragment = ResumePreviewWorkExperienceItem_Employment_Fragment | ResumePreviewWorkExperienceItem_Gap_Fragment | ResumePreviewWorkExperienceItem_Position_Fragment;

export type ResumePreviewWorkExperienceEmploymentPositionFragment = { readonly __typename?: 'Position', readonly id: string, readonly title: string, readonly classification?: EmploymentTypes | null, readonly additionalSkills?: string | null, readonly startAt?: GraphQLISO8601Date | null, readonly endAt?: GraphQLISO8601Date | null, readonly floatFrequency?: PositionFloatFrequency | null, readonly hoursWorked?: number | null, readonly hoursWorkedText?: string | null, readonly hoursWorkedTimeframe?: HoursWorkedTimeframe | null, readonly leadExperience?: boolean | null, readonly chargeExperience?: boolean | null, readonly preceptorExperience?: boolean | null, readonly unitBedCount?: number | null, readonly hospitalBedCount?: number | null, readonly magnet: boolean, readonly teaching: boolean, readonly traumaLevel?: number | null, readonly patientRatio?: number | null, readonly nicuCareLevels?: ReadonlyArray<number> | null, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null } | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly name: string } | null, readonly floatUnits?: ReadonlyArray<{ readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string }> | null, readonly agency?: { readonly __typename?: 'Agency', readonly id: string, readonly name: string } | null, readonly specialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string }> | null, readonly technologies?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null };

export type ResumePreviewWorkExperienceEmploymentGapFragment = { readonly __typename?: 'Gap', readonly gapId: string, readonly gapEndAt: GraphQLISO8601Date, readonly gapExplanation?: string | null, readonly gapIsEducationGap?: boolean | null, readonly gapLocationAddress?: string | null, readonly gapReason?: string | null, readonly gapStartAt: GraphQLISO8601Date };

export type SavedFacilitiesSectionUserFragment = { readonly __typename?: 'User', readonly id: string, readonly email: string };

export type ClinicalExperienceListNurseProfileFragment = { readonly __typename?: 'NurseProfile', readonly id: string, readonly clinicalSpecialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly slug: string, readonly fullName?: string | null, readonly displayName: string, readonly pediatric: boolean, readonly nicu: boolean }> | null, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string } | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly key?: string | null, readonly name: string, readonly type?: RoleType | null } | null };

export type ClinicalExperienceListUpdateNurseProfileMutationVariables = Exact<{
  specialtySlugs: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ClinicalExperienceListUpdateNurseProfileMutation = { readonly __typename?: 'Mutation', readonly nurseProfileClinicalExperiencesUpdate?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly clinicalSpecialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly slug: string, readonly fullName?: string | null, readonly displayName: string, readonly pediatric: boolean, readonly nicu: boolean }> | null } | null };

export type ClinicalExperienceListQueryVariables = Exact<{ [key: string]: never; }>;


export type ClinicalExperienceListQuery = { readonly __typename?: 'Query', readonly topClinicalSpecialties: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly slug: string, readonly fullName?: string | null, readonly displayName: string, readonly pediatric: boolean, readonly nicu: boolean }>, readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly signupSource?: SignupTypes | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly clinicalSpecialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly slug: string, readonly fullName?: string | null, readonly displayName: string, readonly pediatric: boolean, readonly nicu: boolean }> | null, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string } | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly key?: string | null, readonly name: string, readonly type?: RoleType | null } | null } | null } | null };

export type ClinicalExperienceStepUserFragment = { readonly __typename?: 'User', readonly id: string, readonly signupSource?: SignupTypes | null, readonly intercomUserHash?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly clinicalExperienceLevel?: ClinicalExperienceLevelTypes | null } | null };

export type ClinicalExperienceStepUpdateNurseProfileMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateNurseProfileInput;
}>;


export type ClinicalExperienceStepUpdateNurseProfileMutation = { readonly __typename?: 'Mutation', readonly updateNurseProfile?: { readonly __typename?: 'UpdateNurseProfilePayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly clinicalExperienceLevel?: ClinicalExperienceLevelTypes | null } } | null };

export type ClinicalExperienceStepQueryVariables = Exact<{ [key: string]: never; }>;


export type ClinicalExperienceStepQuery = { readonly __typename?: 'Query', readonly __type?: { readonly __typename?: '__Type', readonly name?: string | null, readonly enumValues?: ReadonlyArray<{ readonly __typename?: '__EnumValue', readonly name: string, readonly description?: string | null }> | null } | null, readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly signupSource?: SignupTypes | null, readonly intercomUserHash?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly clinicalExperienceLevel?: ClinicalExperienceLevelTypes | null } | null } | null };

export type CurrentLocationUserFragment = { readonly __typename?: 'User', readonly id: string, readonly signupSource?: SignupTypes | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly wizardCompleted: boolean, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly googlePlaceId?: string | null, readonly locationString?: string | null } | null } | null };

export type UpsertClinicianLocationMutationVariables = Exact<{
  locationString: Scalars['String']['input'];
}>;


export type UpsertClinicianLocationMutation = { readonly __typename?: 'Mutation', readonly upsertClinicianLocation?: { readonly __typename?: 'UpsertClinicianLocationPayload', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly wizardCompleted: boolean, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly googlePlaceId?: string | null, readonly locationString?: string | null } | null, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly explorerRole?: string | null } | null } | null } | null };

export type CurrentLocationQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentLocationQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly signupSource?: SignupTypes | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly wizardCompleted: boolean, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly googlePlaceId?: string | null, readonly locationString?: string | null } | null } | null } | null };

export type UserCreationStepUserFragment = { readonly __typename?: 'User', readonly id: string, readonly signupSource?: SignupTypes | null, readonly intercomUserHash?: string | null, readonly initialReferringDomain?: string | null, readonly userProperties: { readonly __typename?: 'UserProperties', readonly shouldSendAppcastPixel: boolean } };

export type UserCreationTransitionStepQueryVariables = Exact<{ [key: string]: never; }>;


export type UserCreationTransitionStepQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly signupSource?: SignupTypes | null, readonly intercomUserHash?: string | null, readonly initialReferringDomain?: string | null, readonly userProperties: { readonly __typename?: 'UserProperties', readonly shouldSendAppcastPixel: boolean } } | null };

export type TimeEnteredShiftFragment = { readonly __typename?: 'Shift', readonly id: string, readonly duration: number, readonly startSec?: number | null, readonly timezone: string, readonly timeEntries?: ReadonlyArray<{ readonly __typename?: 'TimeEntry', readonly id: string, readonly entryType?: string | null, readonly archived?: boolean | null, readonly startSec?: number | null, readonly endSec?: number | null, readonly timezone?: string | null, readonly timeType: TimeEntryTime, readonly duration?: number | null }> | null };

export type WalkscoreCardFragment = { readonly __typename?: 'Walkscore', readonly walkScore?: number | null, readonly walkDescription?: string | null, readonly walkExtraInfo?: string | null, readonly bikeScore?: number | null, readonly bikeDescription?: string | null, readonly bikeExtraInfo?: string | null, readonly transitScore?: number | null, readonly transitDescription?: string | null, readonly transitExtraInfo?: string | null };

export type WithdrawRequestWithReasonMutationVariables = Exact<{
  id: Scalars['String']['input'];
  reason?: InputMaybe<WithdrawReasonsEnum>;
}>;


export type WithdrawRequestWithReasonMutation = { readonly __typename?: 'Mutation', readonly withdrawRequest?: { readonly __typename?: 'Job', readonly id: string } | null };

export type WithdrawModalInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type WithdrawModalInformationQuery = { readonly __typename?: 'Query', readonly __type?: { readonly __typename?: '__Type', readonly name?: string | null, readonly enumValues?: ReadonlyArray<{ readonly __typename?: '__EnumValue', readonly name: string, readonly description?: string | null }> | null } | null };

export type WithdrawJobInformationQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
}>;


export type WithdrawJobInformationQuery = { readonly __typename?: 'Query', readonly job?: { readonly __typename?: 'Job', readonly id: string, readonly licenseType?: string | null, readonly business?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null } | null };

export type EmailVerificationHintUserFragment = { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly confirmedAt?: GraphQLISO8601DateTime | null };

export type PhoneVerificationHintUserFragment = { readonly __typename?: 'User', readonly id: string, readonly phone?: string | null, readonly phoneVerified: boolean };

export type CurrentAddressUserFragment = { readonly __typename?: 'User', readonly id: string, readonly city?: string | null, readonly state?: string | null, readonly streetAddress?: string | null, readonly zipcode?: string | null };

export type AccountContactInformationPaperUserFragment = { readonly __typename?: 'User', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly middleName?: string | null, readonly preferredName?: string | null, readonly preferredPronoun?: string | null, readonly city?: string | null, readonly state?: string | null, readonly streetAddress?: string | null, readonly zipcode?: string | null, readonly email: string, readonly confirmedAt?: GraphQLISO8601DateTime | null, readonly cityPermanent?: string | null, readonly countryPermanentCode?: string | null, readonly countryPermanentName?: string | null, readonly googlePlaceIdPermanent?: string | null, readonly statePermanent?: string | null, readonly streetAddressPermanent?: string | null, readonly streetNumberPermanent?: string | null, readonly zipcodePermanent?: string | null, readonly phone?: string | null, readonly phoneVerified: boolean, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly permanentAddress: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly message?: string | null, readonly status: ProfileCompletionStatusEnum } } } | null } | null };

export type AccountPageFormUserFragment = { readonly __typename?: 'User', readonly id: string, readonly intercomUserHash?: string | null, readonly subscribedCeuEmail: boolean, readonly subscribedInvitesEmail: boolean, readonly subscribedMatchesEmail: boolean, readonly subscribedBrazeRootEmail: boolean, readonly subscribedNewsletterEmail: boolean, readonly subscribedReferencesEmail: boolean, readonly subscribedCredentialsEmail: boolean, readonly subscribedProductUpdatesEmail: boolean, readonly subscribedJobApplicationsEmail: boolean, readonly marketingSmsAllowed: boolean, readonly firstName?: string | null, readonly lastName?: string | null, readonly middleName?: string | null, readonly preferredName?: string | null, readonly preferredPronoun?: string | null, readonly city?: string | null, readonly state?: string | null, readonly streetAddress?: string | null, readonly zipcode?: string | null, readonly email: string, readonly confirmedAt?: GraphQLISO8601DateTime | null, readonly cityPermanent?: string | null, readonly countryPermanentCode?: string | null, readonly countryPermanentName?: string | null, readonly googlePlaceIdPermanent?: string | null, readonly statePermanent?: string | null, readonly streetAddressPermanent?: string | null, readonly streetNumberPermanent?: string | null, readonly zipcodePermanent?: string | null, readonly phone?: string | null, readonly phoneVerified: boolean, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly birthday?: GraphQLISO8601Date | null, readonly dlNumber?: string | null, readonly dlState?: string | null, readonly dlExpiresOn?: GraphQLISO8601Date | null, readonly ssnLast4?: string | null, readonly fullSsnCollected: boolean, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly permanentAddress: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly message?: string | null, readonly status: ProfileCompletionStatusEnum } } } | null } | null };

export type AccountPageNestedUpdateUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: NestedUpdateUserInput;
}>;


export type AccountPageNestedUpdateUserMutation = { readonly __typename?: 'Mutation', readonly nestedUpdateUser?: { readonly __typename?: 'NestedUpdateUserPayload', readonly token?: string | null, readonly roleType?: string | null, readonly user: { readonly __typename?: 'User', readonly id: string, readonly intercomUserHash?: string | null, readonly subscribedCeuEmail: boolean, readonly subscribedInvitesEmail: boolean, readonly subscribedMatchesEmail: boolean, readonly subscribedBrazeRootEmail: boolean, readonly subscribedNewsletterEmail: boolean, readonly subscribedReferencesEmail: boolean, readonly subscribedCredentialsEmail: boolean, readonly subscribedProductUpdatesEmail: boolean, readonly subscribedJobApplicationsEmail: boolean, readonly marketingSmsAllowed: boolean, readonly firstName?: string | null, readonly lastName?: string | null, readonly middleName?: string | null, readonly preferredName?: string | null, readonly preferredPronoun?: string | null, readonly city?: string | null, readonly state?: string | null, readonly streetAddress?: string | null, readonly zipcode?: string | null, readonly email: string, readonly confirmedAt?: GraphQLISO8601DateTime | null, readonly cityPermanent?: string | null, readonly countryPermanentCode?: string | null, readonly countryPermanentName?: string | null, readonly googlePlaceIdPermanent?: string | null, readonly statePermanent?: string | null, readonly streetAddressPermanent?: string | null, readonly streetNumberPermanent?: string | null, readonly zipcodePermanent?: string | null, readonly phone?: string | null, readonly phoneVerified: boolean, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly birthday?: GraphQLISO8601Date | null, readonly dlNumber?: string | null, readonly dlState?: string | null, readonly dlExpiresOn?: GraphQLISO8601Date | null, readonly ssnLast4?: string | null, readonly fullSsnCollected: boolean, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly permanentAddress: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly message?: string | null, readonly status: ProfileCompletionStatusEnum } } } | null } | null }, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ValidationError', readonly attribute: string, readonly errors: ReadonlyArray<string> }> | null } | null };

export type AccountPageQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountPageQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly intercomUserHash?: string | null, readonly subscribedCeuEmail: boolean, readonly subscribedInvitesEmail: boolean, readonly subscribedMatchesEmail: boolean, readonly subscribedBrazeRootEmail: boolean, readonly subscribedNewsletterEmail: boolean, readonly subscribedReferencesEmail: boolean, readonly subscribedCredentialsEmail: boolean, readonly subscribedProductUpdatesEmail: boolean, readonly subscribedJobApplicationsEmail: boolean, readonly marketingSmsAllowed: boolean, readonly firstName?: string | null, readonly lastName?: string | null, readonly middleName?: string | null, readonly preferredName?: string | null, readonly preferredPronoun?: string | null, readonly city?: string | null, readonly state?: string | null, readonly streetAddress?: string | null, readonly zipcode?: string | null, readonly email: string, readonly confirmedAt?: GraphQLISO8601DateTime | null, readonly cityPermanent?: string | null, readonly countryPermanentCode?: string | null, readonly countryPermanentName?: string | null, readonly googlePlaceIdPermanent?: string | null, readonly statePermanent?: string | null, readonly streetAddressPermanent?: string | null, readonly streetNumberPermanent?: string | null, readonly zipcodePermanent?: string | null, readonly phone?: string | null, readonly phoneVerified: boolean, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly birthday?: GraphQLISO8601Date | null, readonly dlNumber?: string | null, readonly dlState?: string | null, readonly dlExpiresOn?: GraphQLISO8601Date | null, readonly ssnLast4?: string | null, readonly fullSsnCollected: boolean, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly permanentAddress: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly message?: string | null, readonly status: ProfileCompletionStatusEnum } } } | null } | null } | null };

export type AppSignupCompletePageQueryVariables = Exact<{ [key: string]: never; }>;


export type AppSignupCompletePageQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly firstName?: string | null } | null };

export type JobApplicationSummaryJobOfferV2Fragment = { readonly __typename?: 'JobOffer', readonly id: string, readonly startDate?: GraphQLISO8601Date | null, readonly lengthInWeeks?: number | null, readonly shiftsPerWeek?: number | null, readonly shiftType?: string | null, readonly hoursPerShift?: number | null, readonly paymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly jobApplication: { readonly __typename?: 'JobApplication', readonly id: string, readonly paymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly grossPayWeekly?: number | null } | null }, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly startDate?: GraphQLISO8601Date | null, readonly lengthInWeeks?: number | null, readonly shiftsPerWeek?: number | null, readonly shiftType?: string | null, readonly hoursPerShift?: number | null, readonly facilityName?: string | null, readonly title?: string | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null } };

export type JobApplicationSummaryJobOfferFragment = { readonly __typename?: 'JobOffer', readonly id: string, readonly startDate?: GraphQLISO8601Date | null, readonly lengthInWeeks?: number | null, readonly shiftsPerWeek?: number | null, readonly shiftType?: string | null, readonly hoursPerShift?: number | null, readonly jobApplication: { readonly __typename?: 'JobApplication', readonly id: string, readonly state?: string | null, readonly candidateHoldReasons: ReadonlyArray<string>, readonly requestedAt?: GraphQLISO8601Date | null, readonly paymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly grossPayWeekly?: number | null } | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly localAllowed: boolean, readonly onHold?: boolean | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly facilityName?: string | null, readonly cancellationPolicy?: string | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string } | null, readonly business?: { readonly __typename?: 'Facility', readonly city?: string | null, readonly state?: string | null, readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null } }, readonly paymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly startDate?: GraphQLISO8601Date | null, readonly lengthInWeeks?: number | null, readonly shiftsPerWeek?: number | null, readonly shiftType?: string | null, readonly hoursPerShift?: number | null, readonly facilityName?: string | null, readonly title?: string | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null } };

export type JobApplicationSummaryJobApplicationFragment = { readonly __typename?: 'JobApplication', readonly id: string, readonly state?: string | null, readonly candidateHoldReasons: ReadonlyArray<string>, readonly requestedAt?: GraphQLISO8601Date | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly localAllowed: boolean, readonly onHold?: boolean | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly facilityName?: string | null, readonly cancellationPolicy?: string | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string } | null, readonly business?: { readonly __typename?: 'Facility', readonly city?: string | null, readonly state?: string | null, readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null } };

export type JobApplicationsSummaryFragment = { readonly __typename?: 'JobApplicationsSummary', readonly id: string, readonly offer: ReadonlyArray<{ readonly __typename?: 'JobOffer', readonly id: string, readonly startDate?: GraphQLISO8601Date | null, readonly lengthInWeeks?: number | null, readonly shiftsPerWeek?: number | null, readonly shiftType?: string | null, readonly hoursPerShift?: number | null, readonly jobApplication: { readonly __typename?: 'JobApplication', readonly id: string, readonly state?: string | null, readonly candidateHoldReasons: ReadonlyArray<string>, readonly requestedAt?: GraphQLISO8601Date | null, readonly paymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly grossPayWeekly?: number | null } | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly localAllowed: boolean, readonly onHold?: boolean | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly facilityName?: string | null, readonly cancellationPolicy?: string | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string } | null, readonly business?: { readonly __typename?: 'Facility', readonly city?: string | null, readonly state?: string | null, readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null } }, readonly paymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly startDate?: GraphQLISO8601Date | null, readonly lengthInWeeks?: number | null, readonly shiftsPerWeek?: number | null, readonly shiftType?: string | null, readonly hoursPerShift?: number | null, readonly facilityName?: string | null, readonly title?: string | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null } }>, readonly actionRequired: ReadonlyArray<{ readonly __typename?: 'JobApplication', readonly id: string, readonly state?: string | null, readonly candidateHoldReasons: ReadonlyArray<string>, readonly requestedAt?: GraphQLISO8601Date | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly localAllowed: boolean, readonly onHold?: boolean | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly facilityName?: string | null, readonly cancellationPolicy?: string | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string } | null, readonly business?: { readonly __typename?: 'Facility', readonly city?: string | null, readonly state?: string | null, readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null } }>, readonly submittedToFacility: ReadonlyArray<{ readonly __typename?: 'JobApplication', readonly id: string, readonly state?: string | null, readonly candidateHoldReasons: ReadonlyArray<string>, readonly requestedAt?: GraphQLISO8601Date | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly localAllowed: boolean, readonly onHold?: boolean | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly facilityName?: string | null, readonly cancellationPolicy?: string | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string } | null, readonly business?: { readonly __typename?: 'Facility', readonly city?: string | null, readonly state?: string | null, readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null } }>, readonly pendingTrustedReview: ReadonlyArray<{ readonly __typename?: 'JobApplication', readonly id: string, readonly state?: string | null, readonly candidateHoldReasons: ReadonlyArray<string>, readonly requestedAt?: GraphQLISO8601Date | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly localAllowed: boolean, readonly onHold?: boolean | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly facilityName?: string | null, readonly cancellationPolicy?: string | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string } | null, readonly business?: { readonly __typename?: 'Facility', readonly city?: string | null, readonly state?: string | null, readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null } }>, readonly previous: ReadonlyArray<{ readonly __typename?: 'JobApplication', readonly id: string, readonly state?: string | null, readonly candidateHoldReasons: ReadonlyArray<string>, readonly requestedAt?: GraphQLISO8601Date | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly localAllowed: boolean, readonly onHold?: boolean | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly facilityName?: string | null, readonly cancellationPolicy?: string | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string } | null, readonly business?: { readonly __typename?: 'Facility', readonly city?: string | null, readonly state?: string | null, readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null } }>, readonly drafted: ReadonlyArray<{ readonly __typename?: 'JobApplication', readonly id: string, readonly state?: string | null, readonly candidateHoldReasons: ReadonlyArray<string>, readonly requestedAt?: GraphQLISO8601Date | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly localAllowed: boolean, readonly onHold?: boolean | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly facilityName?: string | null, readonly cancellationPolicy?: string | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string } | null, readonly business?: { readonly __typename?: 'Facility', readonly city?: string | null, readonly state?: string | null, readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null } }> };

export type JobApplicationsSummaryUserFragment = { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly firstName?: string | null, readonly userProperties: { readonly __typename?: 'UserProperties', readonly shouldDisplayFirstFavoriteMessage: boolean }, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly canApplyJobs: boolean, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly percentCompleted: number } } | null } | null };

export type ClearUnavailableRequestedMatchesMutationVariables = Exact<{ [key: string]: never; }>;


export type ClearUnavailableRequestedMatchesMutation = { readonly __typename?: 'Mutation', readonly clearUnavailableRequestedMatches: { readonly __typename?: 'ClearUnavailableRequestedMatchesPayload', readonly jobs: ReadonlyArray<{ readonly __typename?: 'Job', readonly id: string }> } };

export type JobApplicationsSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type JobApplicationsSummaryQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly firstName?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly isActivated?: boolean | null, readonly canApplyJobs: boolean, readonly canViewJobs: boolean, readonly wizardCompleted: boolean, readonly jobApplicationsSummary: { readonly __typename?: 'JobApplicationsSummary', readonly id: string, readonly offer: ReadonlyArray<{ readonly __typename?: 'JobOffer', readonly id: string, readonly startDate?: GraphQLISO8601Date | null, readonly lengthInWeeks?: number | null, readonly shiftsPerWeek?: number | null, readonly shiftType?: string | null, readonly hoursPerShift?: number | null, readonly jobApplication: { readonly __typename?: 'JobApplication', readonly id: string, readonly state?: string | null, readonly candidateHoldReasons: ReadonlyArray<string>, readonly requestedAt?: GraphQLISO8601Date | null, readonly paymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly grossPayWeekly?: number | null } | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly localAllowed: boolean, readonly onHold?: boolean | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly facilityName?: string | null, readonly cancellationPolicy?: string | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string } | null, readonly business?: { readonly __typename?: 'Facility', readonly city?: string | null, readonly state?: string | null, readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null } }, readonly paymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly startDate?: GraphQLISO8601Date | null, readonly lengthInWeeks?: number | null, readonly shiftsPerWeek?: number | null, readonly shiftType?: string | null, readonly hoursPerShift?: number | null, readonly facilityName?: string | null, readonly title?: string | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null } }>, readonly actionRequired: ReadonlyArray<{ readonly __typename?: 'JobApplication', readonly id: string, readonly state?: string | null, readonly candidateHoldReasons: ReadonlyArray<string>, readonly requestedAt?: GraphQLISO8601Date | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly localAllowed: boolean, readonly onHold?: boolean | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly facilityName?: string | null, readonly cancellationPolicy?: string | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string } | null, readonly business?: { readonly __typename?: 'Facility', readonly city?: string | null, readonly state?: string | null, readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null } }>, readonly submittedToFacility: ReadonlyArray<{ readonly __typename?: 'JobApplication', readonly id: string, readonly state?: string | null, readonly candidateHoldReasons: ReadonlyArray<string>, readonly requestedAt?: GraphQLISO8601Date | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly localAllowed: boolean, readonly onHold?: boolean | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly facilityName?: string | null, readonly cancellationPolicy?: string | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string } | null, readonly business?: { readonly __typename?: 'Facility', readonly city?: string | null, readonly state?: string | null, readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null } }>, readonly pendingTrustedReview: ReadonlyArray<{ readonly __typename?: 'JobApplication', readonly id: string, readonly state?: string | null, readonly candidateHoldReasons: ReadonlyArray<string>, readonly requestedAt?: GraphQLISO8601Date | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly localAllowed: boolean, readonly onHold?: boolean | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly facilityName?: string | null, readonly cancellationPolicy?: string | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string } | null, readonly business?: { readonly __typename?: 'Facility', readonly city?: string | null, readonly state?: string | null, readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null } }>, readonly previous: ReadonlyArray<{ readonly __typename?: 'JobApplication', readonly id: string, readonly state?: string | null, readonly candidateHoldReasons: ReadonlyArray<string>, readonly requestedAt?: GraphQLISO8601Date | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly localAllowed: boolean, readonly onHold?: boolean | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly facilityName?: string | null, readonly cancellationPolicy?: string | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string } | null, readonly business?: { readonly __typename?: 'Facility', readonly city?: string | null, readonly state?: string | null, readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null } }>, readonly drafted: ReadonlyArray<{ readonly __typename?: 'JobApplication', readonly id: string, readonly state?: string | null, readonly candidateHoldReasons: ReadonlyArray<string>, readonly requestedAt?: GraphQLISO8601Date | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly localAllowed: boolean, readonly onHold?: boolean | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly facilityName?: string | null, readonly cancellationPolicy?: string | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string } | null, readonly business?: { readonly __typename?: 'Facility', readonly city?: string | null, readonly state?: string | null, readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null } }> }, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly percentCompleted: number } } | null, readonly previousOffers: ReadonlyArray<{ readonly __typename?: 'JobOffer', readonly id: string }> } | null, readonly userProperties: { readonly __typename?: 'UserProperties', readonly shouldDisplayFirstFavoriteMessage: boolean } } | null, readonly profileCompletionSummary: { readonly __typename?: 'ProfileCompletionSummary', readonly id: string, readonly completedAt?: GraphQLISO8601DateTime | null, readonly meta: { readonly __typename?: 'ProfileMeta', readonly id: string, readonly completeCount: number, readonly expiredCount: number, readonly expiringCount: number, readonly incompleteCount: number, readonly pendingCount: number, readonly percentCompleted: number }, readonly steps: ReadonlyArray<{ readonly __typename?: 'ProfileStep', readonly estimatedTimeInMinutes?: number | null, readonly key: ProfileStepsEnum, readonly title?: string | null, readonly subtitle?: string | null, readonly messages?: ReadonlyArray<string> | null, readonly sectionName: string, readonly status: ProfileStatusEnum, readonly hasExpiringItems: boolean, readonly hasExpiredItems: boolean, readonly hasInvalidItems: boolean }> } };

export type PreviousOffersSummaryFragment = { readonly __typename?: 'NurseProfile', readonly previousOffers: ReadonlyArray<{ readonly __typename?: 'JobOffer', readonly id: string }> };

export type MatchingJobsForApplicationQueryVariables = Exact<{
  jobApplicationId: Scalars['ID']['input'];
}>;


export type MatchingJobsForApplicationQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly referralCode?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly isActivated?: boolean | null, readonly canApplyJobs: boolean, readonly state?: string | null, readonly percentComplete?: number | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly percentCompleted: number } } | null, readonly nurseAdvocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly email?: string | null, readonly fullName?: string | null } | null } | null, readonly userProperties: { readonly __typename?: 'UserProperties', readonly id: string, readonly shouldDisplayFirstFavoriteMessage: boolean } } | null, readonly matchingJobsForApplication?: ReadonlyArray<{ readonly __typename?: 'Job', readonly id: string, readonly onHold?: boolean | null, readonly state?: string | null, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly localAllowed: boolean, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly facilityName?: string | null, readonly cancellationPolicy?: string | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string, readonly state?: string | null } | null, readonly esMatch?: { readonly __typename?: 'Match', readonly id: string, readonly userState?: string | null } | null, readonly business?: { readonly __typename?: 'Facility', readonly city?: string | null, readonly state?: string | null, readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null }> | null };

export type JobWithErrorFragment = { readonly __typename?: 'JobWithError', readonly errors?: ReadonlyArray<string> | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly grossPayWeekly?: number | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly business?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string } | null } };

export type ApplyToSimilarJobsMutationVariables = Exact<{
  jobApplicationId: Scalars['ID']['input'];
  jobIds: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ApplyToSimilarJobsMutation = { readonly __typename?: 'Mutation', readonly applyToSimilarJobs?: ReadonlyArray<{ readonly __typename?: 'JobApplication', readonly id: string, readonly state?: string | null, readonly job: { readonly __typename?: 'Job', readonly id: string } } | { readonly __typename?: 'JobWithError', readonly errors?: ReadonlyArray<string> | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly grossPayWeekly?: number | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly business?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string } | null } }> | null };

export type BucketMatchesPageQueryVariables = Exact<{
  bucketKey: Scalars['String']['input'];
  excludeFavoritedJobs?: InputMaybe<Scalars['Boolean']['input']>;
  paginate?: InputMaybe<OffsetPaginationInput>;
}>;


export type BucketMatchesPageQuery = { readonly __typename?: 'Query', readonly bucketJobsByKey: { readonly __typename?: 'JobsCollection', readonly id: string, readonly totalRecords: number, readonly records: ReadonlyArray<{ readonly __typename?: 'Job', readonly id: string, readonly state?: string | null, readonly endDate?: GraphQLISO8601Date | null, readonly friendlyLicenseType?: string | null, readonly hoursPerShift?: number | null, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly nursePatientRatio?: string | null, readonly publicDescription?: string | null, readonly shiftEnd?: string | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly shiftStart?: string | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly instantOffer: boolean, readonly positionCount?: number | null, readonly title?: string | null, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly grossPayWeekly?: number | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly travelAllowed: boolean, readonly localAllowed: boolean, readonly localGrossPayWeekly?: number | null, readonly onHold?: boolean | null, readonly business?: { readonly __typename?: 'Facility', readonly id: string, readonly bgImageFlickrUrl?: string | null, readonly hideMatchInfo: boolean, readonly state?: string | null, readonly name: string, readonly city?: string | null, readonly address: string, readonly logo?: string | null, readonly zipcode?: string | null, readonly slug: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly rankings?: ReadonlyArray<{ readonly __typename?: 'UsnewsRanking', readonly id: string, readonly usnewsType: string }> | null, readonly hospital?: { readonly __typename?: 'Hospital', readonly id: string, readonly teaching: boolean, readonly traumaCenterLevel?: number | null, readonly affiliatedUnion?: string | null, readonly totalLicensedBeds?: number | null, readonly hospitalSystem?: string | null, readonly hospitalType?: string | null, readonly jointCommission: boolean, readonly magnet: boolean } | null } | null, readonly cityLocation?: { readonly __typename?: 'Location', readonly id: string, readonly latitude?: number | null, readonly longitude?: number | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string, readonly candidateHoldReasons: ReadonlyArray<string>, readonly state?: string | null } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null, readonly blendedWageRate?: number | null, readonly callBackRate?: number | null, readonly doubleTimeMultiplier?: number | null, readonly extraRate?: number | null, readonly holidayRate?: number | null, readonly incidentalsStipendDaily?: number | null, readonly lodgingStipendDaily?: number | null, readonly onCallRate?: number | null, readonly overtimeHoursPerWeek?: number | null, readonly overtimeMultiplier?: number | null, readonly overtimeWageRate?: number | null, readonly regularHoursPerWeek?: number | null, readonly regularWageRate?: number | null, readonly totalHoursPerWeek?: number | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null, readonly blendedWageRate?: number | null, readonly callBackRate?: number | null, readonly doubleTimeMultiplier?: number | null, readonly extraRate?: number | null, readonly holidayRate?: number | null, readonly incidentalsStipendDaily?: number | null, readonly lodgingStipendDaily?: number | null, readonly onCallRate?: number | null, readonly overtimeHoursPerWeek?: number | null, readonly overtimeMultiplier?: number | null, readonly overtimeWageRate?: number | null, readonly regularHoursPerWeek?: number | null, readonly regularWageRate?: number | null, readonly totalHoursPerWeek?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null, readonly latitude?: number | null, readonly longitude?: number | null } | null, readonly roles?: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: string, readonly type?: RoleType | null }> | null, readonly preferredJarsV2?: ReadonlyArray<{ readonly __typename: 'JobApplicationRequirementsCertification', readonly id: string, readonly type: string, readonly title?: string | null, readonly description?: string | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly credential?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly issuingBodies: ReadonlyArray<string> } } | { readonly __typename: 'JobApplicationRequirementsCovidBooster', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsCovidVaccine', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsDriverLicense', readonly id: string, readonly required?: boolean | null, readonly type: string, readonly stage: JobApplicationRequirementStageEnum } | { readonly __typename: 'JobApplicationRequirementsEducation', readonly id: string, readonly type: string, readonly description?: string | null, readonly enforcementType: string } | { readonly __typename: 'JobApplicationRequirementsFluVaccination', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsFluVaccine', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsLocationFloating', readonly id: string, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsMaximumTimeOffRule', readonly id: string, readonly type: string, readonly maximumTimeOff: number, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsNurseReference', readonly id: string, readonly description?: string | null, readonly occurrences?: number | null, readonly timeframe?: number | null, readonly type: string } | { readonly __typename: 'JobApplicationRequirementsProofOfIdentification', readonly id: string, readonly type: string, readonly description?: string | null, readonly required?: boolean | null, readonly stage: JobApplicationRequirementStageEnum } | { readonly __typename: 'JobApplicationRequirementsRadiusRule', readonly id: string, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsRoleExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsStateLicense', readonly id: string, readonly stage: JobApplicationRequirementStageEnum, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsTechnologyExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null, readonly technology: { readonly __typename?: 'Technology', readonly id: string, readonly uuid: string, readonly name: string } } | { readonly __typename: 'JobApplicationRequirementsTraumaLevelExperience', readonly id: string, readonly type: string, readonly description?: string | null, readonly enforcementType: string } | { readonly __typename: 'JobApplicationRequirementsTravelExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsUnitExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsUnitFloating', readonly id: string, readonly type: string, readonly description?: string | null }> | null, readonly requiredJarsV2?: ReadonlyArray<{ readonly __typename: 'JobApplicationRequirementsCertification', readonly id: string, readonly type: string, readonly title?: string | null, readonly description?: string | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly credential?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly issuingBodies: ReadonlyArray<string> } } | { readonly __typename: 'JobApplicationRequirementsCovidBooster', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsCovidVaccine', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsDriverLicense', readonly id: string, readonly required?: boolean | null, readonly type: string, readonly stage: JobApplicationRequirementStageEnum } | { readonly __typename: 'JobApplicationRequirementsEducation', readonly id: string, readonly type: string, readonly description?: string | null, readonly enforcementType: string } | { readonly __typename: 'JobApplicationRequirementsFluVaccination', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsFluVaccine', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsLocationFloating', readonly id: string, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsMaximumTimeOffRule', readonly id: string, readonly type: string, readonly maximumTimeOff: number, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsNurseReference', readonly id: string, readonly description?: string | null, readonly occurrences?: number | null, readonly timeframe?: number | null, readonly type: string } | { readonly __typename: 'JobApplicationRequirementsProofOfIdentification', readonly id: string, readonly type: string, readonly description?: string | null, readonly required?: boolean | null, readonly stage: JobApplicationRequirementStageEnum } | { readonly __typename: 'JobApplicationRequirementsRadiusRule', readonly id: string, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsRoleExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsStateLicense', readonly id: string, readonly stage: JobApplicationRequirementStageEnum, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsTechnologyExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null, readonly technology: { readonly __typename?: 'Technology', readonly id: string, readonly uuid: string, readonly name: string } } | { readonly __typename: 'JobApplicationRequirementsTraumaLevelExperience', readonly id: string, readonly type: string, readonly description?: string | null, readonly enforcementType: string } | { readonly __typename: 'JobApplicationRequirementsTravelExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsUnitExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsUnitFloating', readonly id: string, readonly type: string, readonly description?: string | null }> | null, readonly canApply: { readonly __typename?: 'AuthorizationResult', readonly value: boolean, readonly reasons?: { readonly __typename?: 'FailureReasons', readonly fullMessages: ReadonlyArray<string> } | null }, readonly esMatch?: { readonly __typename?: 'Match', readonly id: string, readonly userState?: string | null } | null, readonly canFavorite: { readonly __typename?: 'AuthorizationResult', readonly value: boolean, readonly reasons?: { readonly __typename?: 'FailureReasons', readonly fullMessages: ReadonlyArray<string> } | null }, readonly canWithdraw: { readonly __typename?: 'AuthorizationResult', readonly value: boolean, readonly reasons?: { readonly __typename?: 'FailureReasons', readonly fullMessages: ReadonlyArray<string> } | null } }> } };

export type CeuGoalsTrackerCeuGoalFragment = { readonly __typename?: 'CeuGoal', readonly id: string, readonly goalType?: string | null, readonly accepted: boolean, readonly deleted: boolean, readonly requiredContactHours: number, readonly startDate: GraphQLISO8601Date, readonly endDate?: GraphQLISO8601Date | null, readonly systemCreated: boolean, readonly description?: string | null, readonly completedContactHours: number, readonly ceuStateRequirement?: { readonly __typename?: 'CeuStateRequirement', readonly id: string, readonly state: string, readonly requirementDescription?: ReadonlyArray<string> | null } | null, readonly ceuCertificates: ReadonlyArray<{ readonly __typename?: 'CeuCertificate', readonly id: string }> };

export type CeuGoalsTrackingContainerNurseProfileFragment = { readonly __typename?: 'NurseProfile', readonly id: string, readonly ceuGoals?: ReadonlyArray<{ readonly __typename?: 'CeuGoal', readonly id: string, readonly goalType?: string | null, readonly requiredContactHours: number, readonly startDate: GraphQLISO8601Date, readonly endDate?: GraphQLISO8601Date | null, readonly description?: string | null, readonly systemCreated: boolean, readonly accepted: boolean, readonly deleted: boolean, readonly completedContactHours: number, readonly ceuStateRequirement?: { readonly __typename?: 'CeuStateRequirement', readonly id: string, readonly state: string, readonly requiredContactHours?: number | null, readonly notes?: string | null, readonly requirementQuantity?: number | null, readonly requirementDescription?: ReadonlyArray<string> | null, readonly stateBonUrl?: string | null, readonly durationDays?: number | null, readonly licenseType?: string | null } | null, readonly ceuCertificates: ReadonlyArray<{ readonly __typename?: 'CeuCertificate', readonly id: string }> }> | null };

export type CeuGoalContainerCeuGoalFragment = { readonly __typename?: 'CeuGoal', readonly id: string, readonly goalType?: string | null, readonly requiredContactHours: number, readonly startDate: GraphQLISO8601Date, readonly endDate?: GraphQLISO8601Date | null, readonly description?: string | null, readonly systemCreated: boolean, readonly accepted: boolean, readonly deleted: boolean, readonly completedContactHours: number, readonly ceuStateRequirement?: { readonly __typename?: 'CeuStateRequirement', readonly id: string, readonly state: string, readonly requiredContactHours?: number | null, readonly notes?: string | null, readonly requirementQuantity?: number | null, readonly requirementDescription?: ReadonlyArray<string> | null, readonly stateBonUrl?: string | null, readonly durationDays?: number | null, readonly licenseType?: string | null } | null, readonly ceuCertificates: ReadonlyArray<{ readonly __typename?: 'CeuCertificate', readonly id: string }> };

export type CreateCeuGoalMutationVariables = Exact<{
  nurseProfileId: Scalars['ID']['input'];
  input: CreateCeuGoalInput;
}>;


export type CreateCeuGoalMutation = { readonly __typename?: 'Mutation', readonly createCeuGoal?: { readonly __typename?: 'CreateCeuGoalPayload', readonly ceuGoal: { readonly __typename?: 'CeuGoal', readonly id: string, readonly goalType?: string | null, readonly requiredContactHours: number, readonly startDate: GraphQLISO8601Date, readonly endDate?: GraphQLISO8601Date | null, readonly description?: string | null, readonly systemCreated: boolean, readonly accepted: boolean, readonly deleted: boolean, readonly completedContactHours: number, readonly ceuStateRequirement?: { readonly __typename?: 'CeuStateRequirement', readonly id: string, readonly state: string, readonly requiredContactHours?: number | null, readonly notes?: string | null, readonly requirementQuantity?: number | null, readonly requirementDescription?: ReadonlyArray<string> | null, readonly stateBonUrl?: string | null, readonly durationDays?: number | null, readonly licenseType?: string | null } | null, readonly ceuCertificates: ReadonlyArray<{ readonly __typename?: 'CeuCertificate', readonly id: string }> } } | null };

export type UpdateCeuGoalMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateCeuGoalInput;
}>;


export type UpdateCeuGoalMutation = { readonly __typename?: 'Mutation', readonly updateCeuGoal?: { readonly __typename?: 'UpdateCeuGoalPayload', readonly ceuGoal: { readonly __typename?: 'CeuGoal', readonly id: string, readonly goalType?: string | null, readonly requiredContactHours: number, readonly startDate: GraphQLISO8601Date, readonly endDate?: GraphQLISO8601Date | null, readonly description?: string | null, readonly systemCreated: boolean, readonly accepted: boolean, readonly deleted: boolean, readonly completedContactHours: number, readonly ceuStateRequirement?: { readonly __typename?: 'CeuStateRequirement', readonly id: string, readonly state: string, readonly requiredContactHours?: number | null, readonly notes?: string | null, readonly requirementQuantity?: number | null, readonly requirementDescription?: ReadonlyArray<string> | null, readonly stateBonUrl?: string | null, readonly durationDays?: number | null, readonly licenseType?: string | null } | null, readonly ceuCertificates: ReadonlyArray<{ readonly __typename?: 'CeuCertificate', readonly id: string }> } } | null };

export type DeleteCeuGoalMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCeuGoalMutation = { readonly __typename?: 'Mutation', readonly deleteCeuGoal?: { readonly __typename?: 'DeleteCeuGoalPayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly ceuGoals?: ReadonlyArray<{ readonly __typename?: 'CeuGoal', readonly id: string, readonly goalType?: string | null, readonly requiredContactHours: number, readonly startDate: GraphQLISO8601Date, readonly endDate?: GraphQLISO8601Date | null, readonly description?: string | null, readonly systemCreated: boolean, readonly accepted: boolean, readonly deleted: boolean, readonly completedContactHours: number, readonly ceuStateRequirement?: { readonly __typename?: 'CeuStateRequirement', readonly id: string, readonly state: string, readonly requiredContactHours?: number | null, readonly notes?: string | null, readonly requirementQuantity?: number | null, readonly requirementDescription?: ReadonlyArray<string> | null, readonly stateBonUrl?: string | null, readonly durationDays?: number | null, readonly licenseType?: string | null } | null, readonly ceuCertificates: ReadonlyArray<{ readonly __typename?: 'CeuCertificate', readonly id: string }> }> | null } } | null };

export type ContractFragment = { readonly __typename?: 'Contract', readonly id: string, readonly hoursPerShift?: number | null, readonly shiftsPerWeek?: number | null, readonly cancellationPolicy?: string | null, readonly contractNotes?: string | null, readonly contractStatus?: string | null, readonly contractStartDate: GraphQLISO8601Date, readonly contractEndDate: GraphQLISO8601Date, readonly contractType?: string | null, readonly shiftType?: string | null, readonly currentGrossPayWeek?: number | null, readonly baseRate?: number | null, readonly lengthInWeeks?: number | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly title?: string | null, readonly facilityName?: string | null, readonly lengthInWeeks?: number | null, readonly hoursPerShift?: number | null, readonly shiftsPerWeek?: number | null, readonly shiftType?: string | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null }, readonly jobPlacement?: { readonly __typename?: 'JobPlacement', readonly id: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly name?: string | null, readonly user?: { readonly __typename?: 'User', readonly id: string, readonly email: string } | null } | null } | null, readonly timeOffs?: ReadonlyArray<{ readonly __typename?: 'TimeOff', readonly id: string, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly approvalStatus?: string | null }> | null, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string, readonly paymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly nonTaxableStipendWeekly?: number | null, readonly taxableWageRateWeekly?: number | null, readonly grossPayWeekly?: number | null } | null } | null, readonly paymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly nonTaxableStipendWeekly?: number | null, readonly taxableWageRateWeekly?: number | null, readonly grossPayWeekly?: number | null } | null };

export type ContractItemV2QueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
}>;


export type ContractItemV2Query = { readonly __typename?: 'Query', readonly contract?: { readonly __typename?: 'Contract', readonly docusignSignUrl?: string | null, readonly id: string, readonly hoursPerShift?: number | null, readonly shiftsPerWeek?: number | null, readonly cancellationPolicy?: string | null, readonly contractNotes?: string | null, readonly contractStatus?: string | null, readonly contractStartDate: GraphQLISO8601Date, readonly contractEndDate: GraphQLISO8601Date, readonly contractType?: string | null, readonly shiftType?: string | null, readonly currentGrossPayWeek?: number | null, readonly baseRate?: number | null, readonly lengthInWeeks?: number | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly title?: string | null, readonly facilityName?: string | null, readonly lengthInWeeks?: number | null, readonly hoursPerShift?: number | null, readonly shiftsPerWeek?: number | null, readonly shiftType?: string | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null }, readonly jobPlacement?: { readonly __typename?: 'JobPlacement', readonly id: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly name?: string | null, readonly user?: { readonly __typename?: 'User', readonly id: string, readonly email: string } | null } | null } | null, readonly timeOffs?: ReadonlyArray<{ readonly __typename?: 'TimeOff', readonly id: string, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly approvalStatus?: string | null }> | null, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string, readonly paymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly nonTaxableStipendWeekly?: number | null, readonly taxableWageRateWeekly?: number | null, readonly grossPayWeekly?: number | null } | null } | null, readonly paymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly nonTaxableStipendWeekly?: number | null, readonly taxableWageRateWeekly?: number | null, readonly grossPayWeekly?: number | null } | null } | null };

export type ContractItemQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
}>;


export type ContractItemQuery = { readonly __typename?: 'Query', readonly contract?: { readonly __typename?: 'Contract', readonly id: string, readonly hoursPerShift?: number | null, readonly shiftsPerWeek?: number | null, readonly cancellationPolicy?: string | null, readonly contractNotes?: string | null, readonly contractStatus?: string | null, readonly contractStartDate: GraphQLISO8601Date, readonly contractEndDate: GraphQLISO8601Date, readonly contractType?: string | null, readonly shiftType?: string | null, readonly currentGrossPayWeek?: number | null, readonly baseRate?: number | null, readonly lengthInWeeks?: number | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly title?: string | null, readonly facilityName?: string | null, readonly lengthInWeeks?: number | null, readonly hoursPerShift?: number | null, readonly shiftsPerWeek?: number | null, readonly shiftType?: string | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null }, readonly jobPlacement?: { readonly __typename?: 'JobPlacement', readonly id: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly name?: string | null, readonly user?: { readonly __typename?: 'User', readonly id: string, readonly email: string } | null } | null } | null, readonly timeOffs?: ReadonlyArray<{ readonly __typename?: 'TimeOff', readonly id: string, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly approvalStatus?: string | null }> | null, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string, readonly paymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly nonTaxableStipendWeekly?: number | null, readonly taxableWageRateWeekly?: number | null, readonly grossPayWeekly?: number | null } | null } | null, readonly paymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly nonTaxableStipendWeekly?: number | null, readonly taxableWageRateWeekly?: number | null, readonly grossPayWeekly?: number | null } | null } | null };

export type ContractDetailPageViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type ContractDetailPageViewerQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly firstName?: string | null } | null };

export type CuratedJobsPageUserFragment = { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly referralCode?: string | null, readonly firstName?: string | null, readonly lastName?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly isActivated?: boolean | null, readonly percentComplete?: number | null, readonly state?: string | null, readonly canApplyJobs: boolean, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly percentCompleted: number } } | null, readonly nurseAdvocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly email?: string | null, readonly fullName?: string | null } | null, readonly activeClinicalSpecialties: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly slug: string }>, readonly positionSpecialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly slug: string }> | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly key?: string | null, readonly name: string, readonly type?: RoleType | null } | null, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly broadPrefLocations?: ReadonlyArray<BroadPrefLocations> | null, readonly careSettingOther?: string | null, readonly careSettingPrefs?: ReadonlyArray<string> | null, readonly contractLengths?: ReadonlyArray<string> | null, readonly earliestStartDate?: GraphQLISO8601Date | null, readonly jobSortColumn?: JobsCollectionSortField | null, readonly jobSortOrder?: JobsCollectionSortOrder | null, readonly jobTypes?: ReadonlyArray<string> | null, readonly shiftLengths?: ReadonlyArray<string> | null, readonly shiftPrefs?: ReadonlyArray<string> | null, readonly startPref?: string | null, readonly technologies?: ReadonlyArray<string> | null, readonly locations?: ReadonlyArray<{ readonly __typename?: 'Location', readonly id: string, readonly locationString?: string | null }> | null } | null } | null, readonly userProperties: { readonly __typename?: 'UserProperties', readonly id: string, readonly shouldDisplayFirstFavoriteMessage: boolean } };

export type CuratedJobsPageQueryVariables = Exact<{
  filters?: InputMaybe<JobsCollectionFiltersInput>;
  sortBy?: InputMaybe<JobsCollectionSortInput>;
  paginate?: InputMaybe<OffsetPaginationInput>;
}>;


export type CuratedJobsPageQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly referralCode?: string | null, readonly firstName?: string | null, readonly lastName?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly isActivated?: boolean | null, readonly percentComplete?: number | null, readonly state?: string | null, readonly canApplyJobs: boolean, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly percentCompleted: number } } | null, readonly nurseAdvocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly email?: string | null, readonly fullName?: string | null } | null, readonly activeClinicalSpecialties: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly slug: string }>, readonly positionSpecialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly slug: string }> | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly key?: string | null, readonly name: string, readonly type?: RoleType | null } | null, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly broadPrefLocations?: ReadonlyArray<BroadPrefLocations> | null, readonly careSettingOther?: string | null, readonly careSettingPrefs?: ReadonlyArray<string> | null, readonly contractLengths?: ReadonlyArray<string> | null, readonly earliestStartDate?: GraphQLISO8601Date | null, readonly jobSortColumn?: JobsCollectionSortField | null, readonly jobSortOrder?: JobsCollectionSortOrder | null, readonly jobTypes?: ReadonlyArray<string> | null, readonly shiftLengths?: ReadonlyArray<string> | null, readonly shiftPrefs?: ReadonlyArray<string> | null, readonly startPref?: string | null, readonly technologies?: ReadonlyArray<string> | null, readonly locations?: ReadonlyArray<{ readonly __typename?: 'Location', readonly id: string, readonly locationString?: string | null }> | null } | null } | null, readonly userProperties: { readonly __typename?: 'UserProperties', readonly id: string, readonly shouldDisplayFirstFavoriteMessage: boolean } } | null, readonly jobsCollectionExactV2: { readonly __typename?: 'JobsCollection', readonly id: string, readonly filterType: JobsCollectionFilterTypeEnum, readonly totalRecords: number, readonly records: ReadonlyArray<{ readonly __typename?: 'Job', readonly id: string, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly localAllowed: boolean, readonly onHold?: boolean | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly facilityName?: string | null, readonly cancellationPolicy?: string | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly esMatch?: { readonly __typename?: 'Match', readonly id: string, readonly userState?: string | null } | null, readonly business?: { readonly __typename?: 'Facility', readonly city?: string | null, readonly state?: string | null, readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null }>, readonly recommendations: ReadonlyArray<{ readonly __typename?: 'Job', readonly id: string, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly localAllowed: boolean, readonly onHold?: boolean | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly facilityName?: string | null, readonly cancellationPolicy?: string | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly esMatch?: { readonly __typename?: 'Match', readonly id: string, readonly userState?: string | null } | null, readonly business?: { readonly __typename?: 'Facility', readonly city?: string | null, readonly state?: string | null, readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null }> } };

export type CurateJobsPageNurseProfileAndNursePreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type CurateJobsPageNurseProfileAndNursePreferencesQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly cityPermanent?: string | null, readonly statePermanent?: string | null, readonly streetAddressPermanent?: string | null, readonly email: string, readonly referralCode?: string | null, readonly firstName?: string | null, readonly lastName?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly canViewJobs: boolean, readonly wizardCompleted: boolean, readonly isActivated?: boolean | null, readonly percentComplete?: number | null, readonly state?: string | null, readonly canApplyJobs: boolean, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly percentCompleted: number } } | null, readonly nurseAdvocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly email?: string | null, readonly fullName?: string | null } | null, readonly activeClinicalSpecialties: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly slug: string }>, readonly positionSpecialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly slug: string }> | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly key?: string | null, readonly name: string, readonly type?: RoleType | null } | null, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly broadPrefLocations?: ReadonlyArray<BroadPrefLocations> | null, readonly careSettingOther?: string | null, readonly careSettingPrefs?: ReadonlyArray<string> | null, readonly contractLengths?: ReadonlyArray<string> | null, readonly earliestStartDate?: GraphQLISO8601Date | null, readonly jobSortColumn?: JobsCollectionSortField | null, readonly jobSortOrder?: JobsCollectionSortOrder | null, readonly jobTypes?: ReadonlyArray<string> | null, readonly shiftLengths?: ReadonlyArray<string> | null, readonly shiftPrefs?: ReadonlyArray<string> | null, readonly startPref?: string | null, readonly technologies?: ReadonlyArray<string> | null, readonly locations?: ReadonlyArray<{ readonly __typename?: 'Location', readonly id: string, readonly locationString?: string | null }> | null } | null } | null, readonly userProperties: { readonly __typename?: 'UserProperties', readonly id: string, readonly shouldDisplayFirstFavoriteMessage: boolean } } | null, readonly profileCompletionSummary: { readonly __typename?: 'ProfileCompletionSummary', readonly id: string, readonly completedAt?: GraphQLISO8601DateTime | null, readonly meta: { readonly __typename?: 'ProfileMeta', readonly id: string, readonly completeCount: number, readonly expiredCount: number, readonly expiringCount: number, readonly incompleteCount: number, readonly pendingCount: number, readonly percentCompleted: number }, readonly steps: ReadonlyArray<{ readonly __typename?: 'ProfileStep', readonly estimatedTimeInMinutes?: number | null, readonly key: ProfileStepsEnum, readonly title?: string | null, readonly subtitle?: string | null, readonly messages?: ReadonlyArray<string> | null, readonly sectionName: string, readonly status: ProfileStatusEnum, readonly hasExpiringItems: boolean, readonly hasExpiredItems: boolean, readonly hasInvalidItems: boolean }> } };

export type CuratedJobsPageUpdateNursePreferencesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateNursePreferencesInput;
}>;


export type CuratedJobsPageUpdateNursePreferencesMutation = { readonly __typename?: 'Mutation', readonly updateNursePreferences?: { readonly __typename?: 'UpdateNursePreferencesPayload', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly broadPrefLocations?: ReadonlyArray<BroadPrefLocations> | null, readonly careSettingOther?: string | null, readonly careSettingPrefs?: ReadonlyArray<string> | null, readonly contractLengths?: ReadonlyArray<string> | null, readonly earliestStartDate?: GraphQLISO8601Date | null, readonly jobSortColumn?: JobsCollectionSortField | null, readonly jobSortOrder?: JobsCollectionSortOrder | null, readonly jobTypes?: ReadonlyArray<string> | null, readonly shiftLengths?: ReadonlyArray<string> | null, readonly shiftPrefs?: ReadonlyArray<string> | null, readonly startPref?: string | null, readonly technologies?: ReadonlyArray<string> | null, readonly locations?: ReadonlyArray<{ readonly __typename?: 'Location', readonly id: string, readonly locationString?: string | null }> | null } | null } | null } | null };

export type ExplorerIndexPageExplorerStateFragment = { readonly __typename?: 'User', readonly id: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly educations?: ReadonlyArray<{ readonly __typename?: 'Education', readonly id: string, readonly locationString?: string | null }> | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly locationString?: string | null } | null, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly locations?: ReadonlyArray<{ readonly __typename?: 'Location', readonly id: string, readonly locationString?: string | null }> | null } | null } | null };

export type ExplorerPageLocationByCoordQueryVariables = Exact<{
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
}>;


export type ExplorerPageLocationByCoordQuery = { readonly __typename?: 'Query', readonly location?: { readonly __typename?: 'Location', readonly locationString?: string | null, readonly city?: string | null, readonly stateCode?: string | null, readonly id: string } | null };

export type ExplorerPageLocationBySharedIdQueryVariables = Exact<{
  sharedId?: InputMaybe<Scalars['ID']['input']>;
  statsSource?: InputMaybe<Scalars['String']['input']>;
}>;


export type ExplorerPageLocationBySharedIdQuery = { readonly __typename?: 'Query', readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly latitude?: number | null, readonly longitude?: number | null, readonly locationString?: string | null, readonly city?: string | null, readonly stateCode?: string | null, readonly stateName?: string | null, readonly facilities?: ReadonlyArray<{ readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly slug: string, readonly logo?: string | null, readonly city?: string | null, readonly state?: string | null, readonly latitude: number, readonly longitude: number, readonly hospital?: { readonly __typename?: 'Hospital', readonly id: string, readonly teaching: boolean, readonly affiliatedUnion?: string | null, readonly hospitalType?: string | null, readonly magnet: boolean, readonly jointCommission: boolean, readonly traumaCenterLevel?: number | null, readonly totalLicensedBeds?: number | null } | null, readonly rankings?: ReadonlyArray<{ readonly __typename?: 'UsnewsRanking', readonly id: string, readonly usnewsType: string }> | null, readonly residencyPrograms?: ReadonlyArray<{ readonly __typename?: 'ResidencyProgram', readonly id: string, readonly name?: string | null }> | null }> | null, readonly costOfLivingStats?: ReadonlyArray<{ readonly __typename?: 'Stat', readonly locationName: string, readonly statId: string, readonly statName: string, readonly valueInt?: number | null, readonly valueFloat?: number | null, readonly valueString?: string | null }> | null, readonly cityWalkscore?: { readonly __typename?: 'Walkscore', readonly walkScore?: number | null, readonly walkDescription?: string | null, readonly walkExtraInfo?: string | null, readonly bikeScore?: number | null, readonly bikeDescription?: string | null, readonly bikeExtraInfo?: string | null, readonly transitScore?: number | null, readonly transitDescription?: string | null, readonly transitExtraInfo?: string | null } | null } | null };

export type ExplorerPageLocationQueryVariables = Exact<{
  locationString?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  sharedId?: InputMaybe<Scalars['ID']['input']>;
  statsSource?: InputMaybe<Scalars['String']['input']>;
}>;


export type ExplorerPageLocationQuery = { readonly __typename?: 'Query', readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateName?: string | null, readonly locationString?: string | null, readonly latitude?: number | null, readonly longitude?: number | null, readonly stateCode?: string | null, readonly costOfLivingStats?: ReadonlyArray<{ readonly __typename?: 'Stat', readonly statId: string, readonly valueFloat?: number | null }> | null, readonly cityWalkscore?: { readonly __typename?: 'Walkscore', readonly walkScore?: number | null, readonly walkDescription?: string | null, readonly walkExtraInfo?: string | null, readonly bikeScore?: number | null, readonly bikeDescription?: string | null, readonly bikeExtraInfo?: string | null, readonly transitScore?: number | null, readonly transitDescription?: string | null, readonly transitExtraInfo?: string | null } | null, readonly facilities?: ReadonlyArray<{ readonly __typename?: 'Facility', readonly id: string, readonly slug: string, readonly name: string, readonly logo?: string | null, readonly city?: string | null, readonly state?: string | null, readonly latitude: number, readonly longitude: number, readonly hospital?: { readonly __typename?: 'Hospital', readonly id: string, readonly affiliatedUnion?: string | null, readonly jointCommission: boolean, readonly magnet: boolean, readonly teaching: boolean, readonly totalLicensedBeds?: number | null, readonly traumaCenterLevel?: number | null, readonly hospitalType?: string | null } | null, readonly residencyPrograms?: ReadonlyArray<{ readonly __typename?: 'ResidencyProgram', readonly id: string }> | null, readonly rankings?: ReadonlyArray<{ readonly __typename?: 'UsnewsRanking', readonly id: string, readonly usnewsType: string }> | null }> | null } | null };

export type ExplorerLocationPageLocationByCoordQueryVariables = Exact<{
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
}>;


export type ExplorerLocationPageLocationByCoordQuery = { readonly __typename?: 'Query', readonly location?: { readonly __typename?: 'Location', readonly locationString?: string | null, readonly id: string } | null };

export type FacilitiesPageQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationString?: InputMaybe<Scalars['String']['input']>;
  includeLocation: Scalars['Boolean']['input'];
  hospitalType?: InputMaybe<HospitalTypesEnum>;
  accreditation?: InputMaybe<AccreditationsEnum>;
  accreditingBodies?: InputMaybe<ReadonlyArray<AccreditingBodiesEnum> | AccreditingBodiesEnum>;
}>;


export type FacilitiesPageQuery = { readonly __typename?: 'Query', readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly stateCode?: string | null, readonly stateName?: string | null, readonly city?: string | null } | null, readonly facilitiesPaginated?: { readonly __typename?: 'FacilitiesConnection', readonly totalCount: number, readonly edges?: ReadonlyArray<{ readonly __typename?: 'FacilitiesEdge', readonly node?: { readonly __typename?: 'Facility', readonly id: string, readonly slug: string, readonly logo?: string | null, readonly name: string, readonly state?: string | null, readonly city?: string | null, readonly hospital?: { readonly __typename?: 'Hospital', readonly id: string, readonly totalLicensedBeds?: number | null, readonly traumaCenterLevel?: number | null, readonly hospitalType?: string | null, readonly affiliatedUnion?: string | null, readonly teaching: boolean, readonly jointCommission: boolean, readonly magnet: boolean } | null, readonly residencyPrograms?: ReadonlyArray<{ readonly __typename?: 'ResidencyProgram', readonly id: string, readonly url?: string | null, readonly accreditingBody?: string | null }> | null } | null }> | null, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly hasPreviousPage: boolean, readonly startCursor?: string | null, readonly endCursor?: string | null } } };

export type JobAlertsNurseProfileFragment = { readonly __typename?: 'NurseProfile', readonly id: string, readonly jobAlerts: ReadonlyArray<{ readonly __typename?: 'JobAlert', readonly id: string, readonly broadPrefLocations: ReadonlyArray<BroadPrefLocations>, readonly contractLengths: ReadonlyArray<ContractLength>, readonly locationStrings: ReadonlyArray<string>, readonly shiftLengths: ReadonlyArray<string>, readonly shiftPrefs: ReadonlyArray<string>, readonly smsEnabled: boolean, readonly specialties: ReadonlyArray<string>, readonly clinicalSpecialties: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly slug: string }> }> };

export type JobAlertFragment = { readonly __typename?: 'JobAlert', readonly id: string, readonly broadPrefLocations: ReadonlyArray<BroadPrefLocations>, readonly contractLengths: ReadonlyArray<ContractLength>, readonly locationStrings: ReadonlyArray<string>, readonly shiftLengths: ReadonlyArray<string>, readonly shiftPrefs: ReadonlyArray<string>, readonly smsEnabled: boolean, readonly specialties: ReadonlyArray<string>, readonly clinicalSpecialties: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly slug: string }> };

export type CreateJobAlertMutationVariables = Exact<{
  input: CreateJobAlertInput;
}>;


export type CreateJobAlertMutation = { readonly __typename?: 'Mutation', readonly createJobAlert?: { readonly __typename?: 'CreateJobAlertPayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly jobAlerts: ReadonlyArray<{ readonly __typename?: 'JobAlert', readonly id: string, readonly broadPrefLocations: ReadonlyArray<BroadPrefLocations>, readonly contractLengths: ReadonlyArray<ContractLength>, readonly locationStrings: ReadonlyArray<string>, readonly shiftLengths: ReadonlyArray<string>, readonly shiftPrefs: ReadonlyArray<string>, readonly smsEnabled: boolean, readonly specialties: ReadonlyArray<string>, readonly clinicalSpecialties: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly slug: string }> }> } } | null };

export type UpdateJobAlertMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateJobAlertInput;
}>;


export type UpdateJobAlertMutation = { readonly __typename?: 'Mutation', readonly updateJobAlert?: { readonly __typename?: 'UpdateJobAlertPayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly jobAlerts: ReadonlyArray<{ readonly __typename?: 'JobAlert', readonly id: string, readonly broadPrefLocations: ReadonlyArray<BroadPrefLocations>, readonly contractLengths: ReadonlyArray<ContractLength>, readonly locationStrings: ReadonlyArray<string>, readonly shiftLengths: ReadonlyArray<string>, readonly shiftPrefs: ReadonlyArray<string>, readonly smsEnabled: boolean, readonly specialties: ReadonlyArray<string>, readonly clinicalSpecialties: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly slug: string }> }> } } | null };

export type DeleteJobAlertMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteJobAlertMutation = { readonly __typename?: 'Mutation', readonly deleteJobAlert?: { readonly __typename?: 'DeleteJobAlertPayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly jobAlerts: ReadonlyArray<{ readonly __typename?: 'JobAlert', readonly id: string, readonly broadPrefLocations: ReadonlyArray<BroadPrefLocations>, readonly contractLengths: ReadonlyArray<ContractLength>, readonly locationStrings: ReadonlyArray<string>, readonly shiftLengths: ReadonlyArray<string>, readonly shiftPrefs: ReadonlyArray<string>, readonly smsEnabled: boolean, readonly specialties: ReadonlyArray<string>, readonly clinicalSpecialties: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly slug: string }> }> } } | null };

export type JobAlertsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type JobAlertsPageQuery = { readonly __typename?: 'Query', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly isActivated?: boolean | null, readonly percentComplete?: number | null, readonly state?: string | null, readonly activeClinicalSpecialties: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly slug: string }>, readonly positionSpecialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly slug: string }> | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly percentCompleted: number } } | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly key?: string | null, readonly name: string, readonly type?: RoleType | null } | null, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly broadPrefLocations?: ReadonlyArray<BroadPrefLocations> | null, readonly careSettingOther?: string | null, readonly careSettingPrefs?: ReadonlyArray<string> | null, readonly contractLengths?: ReadonlyArray<string> | null, readonly earliestStartDate?: GraphQLISO8601Date | null, readonly jobSortColumn?: JobsCollectionSortField | null, readonly jobSortOrder?: JobsCollectionSortOrder | null, readonly jobTypes?: ReadonlyArray<string> | null, readonly shiftLengths?: ReadonlyArray<string> | null, readonly shiftPrefs?: ReadonlyArray<string> | null, readonly startPref?: string | null, readonly technologies?: ReadonlyArray<string> | null, readonly locations?: ReadonlyArray<{ readonly __typename?: 'Location', readonly id: string, readonly locationString?: string | null }> | null } | null, readonly jobAlerts: ReadonlyArray<{ readonly __typename?: 'JobAlert', readonly id: string, readonly broadPrefLocations: ReadonlyArray<BroadPrefLocations>, readonly contractLengths: ReadonlyArray<ContractLength>, readonly locationStrings: ReadonlyArray<string>, readonly shiftLengths: ReadonlyArray<string>, readonly shiftPrefs: ReadonlyArray<string>, readonly smsEnabled: boolean, readonly specialties: ReadonlyArray<string>, readonly clinicalSpecialties: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly slug: string }> }> } | null, readonly profileCompletionSummary: { readonly __typename?: 'ProfileCompletionSummary', readonly id: string, readonly completedAt?: GraphQLISO8601DateTime | null, readonly meta: { readonly __typename?: 'ProfileMeta', readonly id: string, readonly completeCount: number, readonly expiredCount: number, readonly expiringCount: number, readonly incompleteCount: number, readonly pendingCount: number, readonly percentCompleted: number }, readonly steps: ReadonlyArray<{ readonly __typename?: 'ProfileStep', readonly estimatedTimeInMinutes?: number | null, readonly key: ProfileStepsEnum, readonly title?: string | null, readonly subtitle?: string | null, readonly messages?: ReadonlyArray<string> | null, readonly sectionName: string, readonly status: ProfileStatusEnum, readonly hasExpiringItems: boolean, readonly hasExpiredItems: boolean, readonly hasInvalidItems: boolean }> } };

export type JobApplicationDetailPageQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type JobApplicationDetailPageQuery = { readonly __typename?: 'Query', readonly jobApplication: { readonly __typename?: 'JobApplication', readonly id: string, readonly state?: string | null, readonly preferredStartDate?: GraphQLISO8601Date | null, readonly specialRequest?: string | null, readonly interviewAvailability?: string | null, readonly candidateHoldReasons: ReadonlyArray<string>, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nurseAdvocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly phone?: string | null, readonly firstName?: string | null, readonly lastName?: string | null, readonly profileImgUrl: string, readonly isNurseAdvocate?: boolean | null, readonly isAlliedAdvocate?: boolean | null, readonly clinicalRole?: string | null } | null } | null, readonly esMatch?: { readonly __typename?: 'Match', readonly id: string, readonly userState?: string | null } | null, readonly timeOffRequests?: ReadonlyArray<{ readonly __typename?: 'TimeOffRequest', readonly id: string, readonly fromDate: GraphQLISO8601Date, readonly toDate: GraphQLISO8601Date }> | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly localAllowed: boolean, readonly onHold?: boolean | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly facilityName?: string | null, readonly cancellationPolicy?: string | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly business?: { readonly __typename?: 'Facility', readonly city?: string | null, readonly state?: string | null, readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null } } };

export type JobApplicationDetailFragment = { readonly __typename?: 'JobApplication', readonly id: string, readonly state?: string | null, readonly preferredStartDate?: GraphQLISO8601Date | null, readonly specialRequest?: string | null, readonly interviewAvailability?: string | null, readonly candidateHoldReasons: ReadonlyArray<string>, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nurseAdvocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly phone?: string | null, readonly firstName?: string | null, readonly lastName?: string | null, readonly profileImgUrl: string, readonly isNurseAdvocate?: boolean | null, readonly isAlliedAdvocate?: boolean | null, readonly clinicalRole?: string | null } | null } | null, readonly esMatch?: { readonly __typename?: 'Match', readonly id: string, readonly userState?: string | null } | null, readonly timeOffRequests?: ReadonlyArray<{ readonly __typename?: 'TimeOffRequest', readonly id: string, readonly fromDate: GraphQLISO8601Date, readonly toDate: GraphQLISO8601Date }> | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly localAllowed: boolean, readonly onHold?: boolean | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly facilityName?: string | null, readonly cancellationPolicy?: string | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly business?: { readonly __typename?: 'Facility', readonly city?: string | null, readonly state?: string | null, readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null } };

export type JobApplicationJobFragment = { readonly __typename?: 'Job', readonly id: string, readonly hoursPerShift?: number | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly onHold?: boolean | null, readonly programName?: string | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly state?: string | null, readonly travelAllowed: boolean, readonly localAllowed: boolean, readonly grossPayWeekly?: number | null, readonly jobType?: string | null, readonly localGrossPayWeekly?: number | null, readonly allowedFacilities: ReadonlyArray<{ readonly __typename?: 'Facility', readonly id: string, readonly city?: string | null, readonly name: string, readonly state?: string | null }>, readonly business?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly jarMaximumTimeOff?: { readonly __typename?: 'JobApplicationRequirementsMaximumTimeOffRule', readonly id: string, readonly maximumTimeOff: number } | null, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string, readonly state?: string | null, readonly preferredStartDate?: GraphQLISO8601Date | null, readonly hasSpecialRequest?: boolean | null, readonly specialRequest?: string | null, readonly hasTimeoffRequest?: boolean | null, readonly interviewAvailability?: string | null, readonly hasAllowedFacilities?: boolean | null, readonly allowedFacilitiesShifts?: ReadonlyArray<string> | null, readonly timeOffRequests?: ReadonlyArray<{ readonly __typename?: 'TimeOffRequest', readonly id: string, readonly fromDate: GraphQLISO8601Date, readonly toDate: GraphQLISO8601Date }> | null, readonly allowedFacilities?: ReadonlyArray<{ readonly __typename?: 'JobApplicationAllowedFacility', readonly facilityId: string }> | null } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null };

export type JobApplicationJobApplicationFragment = { readonly __typename?: 'JobApplication', readonly id: string, readonly state?: string | null, readonly preferredStartDate?: GraphQLISO8601Date | null, readonly hasSpecialRequest?: boolean | null, readonly specialRequest?: string | null, readonly hasTimeoffRequest?: boolean | null, readonly interviewAvailability?: string | null, readonly hasAllowedFacilities?: boolean | null, readonly allowedFacilitiesShifts?: ReadonlyArray<string> | null, readonly timeOffRequests?: ReadonlyArray<{ readonly __typename?: 'TimeOffRequest', readonly id: string, readonly fromDate: GraphQLISO8601Date, readonly toDate: GraphQLISO8601Date }> | null, readonly allowedFacilities?: ReadonlyArray<{ readonly __typename?: 'JobApplicationAllowedFacility', readonly facilityId: string }> | null };

export type RuleValidationFragment = { readonly __typename?: 'JobApplicationRequirementRuleEngineVerification', readonly type: string, readonly valid?: boolean | null, readonly errorMessages?: ReadonlyArray<string> | null };

export type JobApplicationCompletedPagesUserFragment = { readonly __typename?: 'User', readonly id: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string } | null };

export type JobApplicationNurseProfileFragment = { readonly __typename?: 'NurseProfile', readonly id: string };

export type JobApplicationCanApplyJobFragment = { readonly __typename?: 'Job', readonly id: string, readonly onHold?: boolean | null, readonly state?: string | null, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string, readonly state?: string | null } | null };

export type JobAllowedFacilityFragment = { readonly __typename?: 'Facility', readonly id: string, readonly city?: string | null, readonly name: string, readonly state?: string | null };

export type CreateDraftJobApplicationMutationVariables = Exact<{
  jobId: Scalars['ID']['input'];
  input: CreateJobApplicationInput;
}>;


export type CreateDraftJobApplicationMutation = { readonly __typename?: 'Mutation', readonly createJobApplication?: { readonly __typename?: 'JobApplication', readonly id: string, readonly state?: string | null, readonly job: { readonly __typename?: 'Job', readonly id: string }, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string } | null } | null };

export type JobApplicationAutoSaveMutationVariables = Exact<{
  jobId: Scalars['ID']['input'];
  input: AutoSaveApplicationInput;
}>;


export type JobApplicationAutoSaveMutation = { readonly __typename?: 'Mutation', readonly jobApplicationAutoSave?: { readonly __typename?: 'JobApplication', readonly id: string, readonly state?: string | null, readonly preferredStartDate?: GraphQLISO8601Date | null, readonly hasSpecialRequest?: boolean | null, readonly specialRequest?: string | null, readonly hasTimeoffRequest?: boolean | null, readonly interviewAvailability?: string | null, readonly hasAllowedFacilities?: boolean | null, readonly allowedFacilitiesShifts?: ReadonlyArray<string> | null, readonly timeOffRequests?: ReadonlyArray<{ readonly __typename?: 'TimeOffRequest', readonly id: string, readonly fromDate: GraphQLISO8601Date, readonly toDate: GraphQLISO8601Date }> | null, readonly allowedFacilities?: ReadonlyArray<{ readonly __typename?: 'JobApplicationAllowedFacility', readonly facilityId: string }> | null } | null };

export type SubmitJobApplicationMutationVariables = Exact<{
  jobId: Scalars['ID']['input'];
  input: CreateJobApplicationInput;
}>;


export type SubmitJobApplicationMutation = { readonly __typename?: 'Mutation', readonly createJobApplication?: { readonly __typename?: 'JobApplication', readonly id: string, readonly state?: string | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly shiftsPerWeek?: number | null, readonly shiftType?: string | null, readonly startDate?: GraphQLISO8601Date | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly business?: { readonly __typename?: 'Facility', readonly id: string, readonly city?: string | null, readonly logo?: string | null, readonly name: string, readonly state?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null }, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly isActivated?: boolean | null, readonly state?: string | null, readonly percentComplete?: number | null, readonly user?: { readonly __typename?: 'User', readonly id: string, readonly email: string } | null, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly background: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly label: string, readonly status: ApplicationReadinessStatus }, readonly certifications: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly label: string, readonly status: ApplicationReadinessStatus }, readonly education: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly label: string, readonly status: ApplicationReadinessStatus }, readonly employment: { readonly __typename?: 'ApplicationReadinessEmploymentResult', readonly label: string, readonly status: ApplicationReadinessStatus }, readonly licenses: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly label: string, readonly status: ApplicationReadinessStatus }, readonly references: { readonly __typename?: 'ApplicationReadinessReferencesResult', readonly label: string, readonly status: ApplicationReadinessStatus, readonly completeReferenceCount: number }, readonly skillsChecklist: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly label: string, readonly status: ApplicationReadinessStatus } } }, readonly nurseAdvocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly email?: string | null, readonly fullName?: string | null } | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly percentCompleted: number } } | null } | null } | null };

export type JobApplicationPageQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
}>;


export type JobApplicationPageQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string } | null } | null, readonly job?: { readonly __typename?: 'Job', readonly id: string, readonly hoursPerShift?: number | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly onHold?: boolean | null, readonly programName?: string | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly state?: string | null, readonly travelAllowed: boolean, readonly localAllowed: boolean, readonly grossPayWeekly?: number | null, readonly jobType?: string | null, readonly localGrossPayWeekly?: number | null, readonly allowedFacilities: ReadonlyArray<{ readonly __typename?: 'Facility', readonly id: string, readonly city?: string | null, readonly name: string, readonly state?: string | null }>, readonly business?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly jarMaximumTimeOff?: { readonly __typename?: 'JobApplicationRequirementsMaximumTimeOffRule', readonly id: string, readonly maximumTimeOff: number } | null, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string, readonly state?: string | null, readonly preferredStartDate?: GraphQLISO8601Date | null, readonly hasSpecialRequest?: boolean | null, readonly specialRequest?: string | null, readonly hasTimeoffRequest?: boolean | null, readonly interviewAvailability?: string | null, readonly hasAllowedFacilities?: boolean | null, readonly allowedFacilitiesShifts?: ReadonlyArray<string> | null, readonly timeOffRequests?: ReadonlyArray<{ readonly __typename?: 'TimeOffRequest', readonly id: string, readonly fromDate: GraphQLISO8601Date, readonly toDate: GraphQLISO8601Date }> | null, readonly allowedFacilities?: ReadonlyArray<{ readonly __typename?: 'JobApplicationAllowedFacility', readonly facilityId: string }> | null } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null } | null };

export type JobApplicationStrengthenJobFragment = { readonly __typename?: 'Job', readonly id: string, readonly ruleValidations?: ReadonlyArray<{ readonly __typename?: 'JobApplicationRequirementRuleEngineVerification', readonly type: string, readonly valid?: boolean | null, readonly errorMessages?: ReadonlyArray<string> | null }> | null };

export type JobApplicationStrengthenRuleValidationFragment = { readonly __typename?: 'JobApplicationRequirementRuleEngineVerification', readonly type: string, readonly valid?: boolean | null, readonly errorMessages?: ReadonlyArray<string> | null };

export type JobApplicationStrengthenNurseProfileFragment = { readonly __typename?: 'NurseProfile', readonly id: string, readonly hasPositionsLocationOverlap: boolean, readonly hasPositionsInvalidHoursOverlap: boolean, readonly idDocs?: ReadonlyArray<{ readonly __typename?: 'Document', readonly id: string, readonly title?: string | null, readonly docType?: string | null, readonly docSubtype?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly expirationType?: DocumentExpiration | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null, readonly nurseHealthDocs?: ReadonlyArray<{ readonly __typename?: 'NurseHealthDoc', readonly id: string, readonly isCovidVax?: boolean | null, readonly isFluVax?: boolean | null }> | null, readonly sortedExperienceItems?: ReadonlyArray<{ readonly __typename?: 'Employment' } | { readonly __typename?: 'Gap', readonly id: string, readonly reason?: string | null } | { readonly __typename?: 'Position' }> | null };

export type JobApplicationStrengthenNurseHealthDocFragment = { readonly __typename?: 'NurseHealthDoc', readonly id: string, readonly isCovidVax?: boolean | null, readonly isFluVax?: boolean | null };

export type JobApplicationStrengthenPageQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
  documentCategories?: InputMaybe<ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type JobApplicationStrengthenPageQuery = { readonly __typename?: 'Query', readonly defaultCovidVaccineHealthDoc?: { readonly __typename?: 'HealthDoc', readonly id: string } | null, readonly documentTemplates: ReadonlyArray<{ readonly __typename?: 'DocumentTemplate', readonly id: number, readonly key?: string | null, readonly name?: string | null, readonly types?: ReadonlyArray<string> | null, readonly expirationType?: DocumentExpiration | null }>, readonly fluVaccineHealthDoc?: { readonly __typename?: 'HealthDoc', readonly id: string } | null, readonly job?: { readonly __typename?: 'Job', readonly id: string, readonly ruleValidations?: ReadonlyArray<{ readonly __typename?: 'JobApplicationRequirementRuleEngineVerification', readonly type: string, readonly valid?: boolean | null, readonly errorMessages?: ReadonlyArray<string> | null }> | null } | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly hasPositionsLocationOverlap: boolean, readonly hasPositionsInvalidHoursOverlap: boolean, readonly idDocs?: ReadonlyArray<{ readonly __typename?: 'Document', readonly id: string, readonly title?: string | null, readonly docType?: string | null, readonly docSubtype?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly expirationType?: DocumentExpiration | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null, readonly nurseHealthDocs?: ReadonlyArray<{ readonly __typename?: 'NurseHealthDoc', readonly id: string, readonly isCovidVax?: boolean | null, readonly isFluVax?: boolean | null }> | null, readonly sortedExperienceItems?: ReadonlyArray<{ readonly __typename?: 'Employment' } | { readonly __typename?: 'Gap', readonly id: string, readonly reason?: string | null } | { readonly __typename?: 'Position' }> | null } | null };

export type JobDetailPageUserFragment = { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly initialReferringDomain?: string | null, readonly userProperties: { readonly __typename?: 'UserProperties', readonly shouldDisplayFirstFavoriteMessage: boolean, readonly shouldDisplayStaleProfileNotification: boolean } };

export type JobDetailPageJobFragment = { readonly __typename?: 'Job', readonly id: string, readonly state?: string | null, readonly onHold?: boolean | null, readonly jobType?: string | null, readonly licenseType?: string | null, readonly friendlyLicenseType?: string | null, readonly grossPayWeekly?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly lengthInWeeks?: number | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string, readonly slug: string } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null };

export type JobDetailPageVisibilityJobFragment = { readonly __typename?: 'Job', readonly id: string, readonly state?: string | null, readonly onHold?: boolean | null, readonly jobType?: string | null };

export type JobDetailPageJobTitleFragment = { readonly __typename?: 'Job', readonly id: string, readonly jobType?: string | null, readonly licenseType?: string | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string, readonly slug: string } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null };

export type JobDetailPageStartDateFragment = { readonly __typename?: 'Job', readonly id: string, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly lengthInWeeks?: number | null };

export type JobDetailPageDescriptionFragment = { readonly __typename?: 'Job', readonly id: string, readonly jobType?: string | null, readonly friendlyLicenseType?: string | null, readonly grossPayWeekly?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly lengthInWeeks?: number | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null };

export type JobDetailPageRelatedJobsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type JobDetailPageRelatedJobsQuery = { readonly __typename?: 'Query', readonly relatedJobsConnection: { readonly __typename?: 'JobConnection', readonly edges?: ReadonlyArray<{ readonly __typename?: 'JobEdge', readonly node?: { readonly __typename?: 'Job', readonly id: string, readonly grossPayWeekly?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly lengthInWeeks?: number | null, readonly localAllowed: boolean, readonly travelAllowed: boolean, readonly jobType?: string | null, readonly licenseType?: string | null, readonly roles?: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: string, readonly abbreviation: string, readonly name: string }> | null, readonly business?: { readonly __typename?: 'Facility', readonly id: string, readonly bgImageFlickrUrl?: string | null, readonly state?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string, readonly slug: string } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null } | null } | null> | null, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly hasPreviousPage: boolean, readonly startCursor?: string | null, readonly endCursor?: string | null } } };

export type JobDetailPageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  loggedIn: Scalars['Boolean']['input'];
}>;


export type JobDetailPageQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly initialReferringDomain?: string | null, readonly userProperties: { readonly __typename?: 'UserProperties', readonly shouldDisplayFirstFavoriteMessage: boolean, readonly shouldDisplayStaleProfileNotification: boolean } } | null, readonly adJob?: { readonly __typename?: 'Job', readonly id: string, readonly licenseType?: string | null, readonly friendlyLicenseType?: string | null, readonly grossPayWeekly?: number | null, readonly jobType?: string | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly hoursPerShift?: number | null, readonly nursePatientRatio?: string | null, readonly description?: string | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly lengthInWeeks?: number | null, readonly licenseState?: string | null, readonly certifications?: string | null, readonly requiredSpecialties?: string | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly radiusRule?: number | null, readonly publicDescription?: string | null, readonly state?: string | null, readonly onHold?: boolean | null, readonly preferredJarsV2?: ReadonlyArray<{ readonly __typename: 'JobApplicationRequirementsCertification', readonly id: string, readonly type: string, readonly title?: string | null, readonly description?: string | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly credential?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly issuingBodies: ReadonlyArray<string> } } | { readonly __typename: 'JobApplicationRequirementsCovidBooster', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsCovidVaccine', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsDriverLicense', readonly id: string, readonly required?: boolean | null, readonly type: string, readonly stage: JobApplicationRequirementStageEnum } | { readonly __typename: 'JobApplicationRequirementsEducation', readonly id: string, readonly type: string, readonly description?: string | null, readonly enforcementType: string } | { readonly __typename: 'JobApplicationRequirementsFluVaccination', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsFluVaccine', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsLocationFloating', readonly id: string, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsMaximumTimeOffRule', readonly id: string, readonly type: string, readonly maximumTimeOff: number, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsNurseReference', readonly id: string, readonly description?: string | null, readonly occurrences?: number | null, readonly timeframe?: number | null, readonly type: string } | { readonly __typename: 'JobApplicationRequirementsProofOfIdentification', readonly id: string, readonly type: string, readonly description?: string | null, readonly required?: boolean | null, readonly stage: JobApplicationRequirementStageEnum } | { readonly __typename: 'JobApplicationRequirementsRadiusRule', readonly id: string, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsRoleExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsStateLicense', readonly id: string, readonly stage: JobApplicationRequirementStageEnum, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsTechnologyExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null, readonly technology: { readonly __typename?: 'Technology', readonly id: string, readonly uuid: string, readonly name: string } } | { readonly __typename: 'JobApplicationRequirementsTraumaLevelExperience', readonly id: string, readonly type: string, readonly description?: string | null, readonly enforcementType: string } | { readonly __typename: 'JobApplicationRequirementsTravelExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsUnitExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsUnitFloating', readonly id: string, readonly type: string, readonly description?: string | null }> | null, readonly requiredJarsV2?: ReadonlyArray<{ readonly __typename: 'JobApplicationRequirementsCertification', readonly id: string, readonly type: string, readonly title?: string | null, readonly description?: string | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly credential?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly issuingBodies: ReadonlyArray<string> } } | { readonly __typename: 'JobApplicationRequirementsCovidBooster', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsCovidVaccine', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsDriverLicense', readonly id: string, readonly required?: boolean | null, readonly type: string, readonly stage: JobApplicationRequirementStageEnum } | { readonly __typename: 'JobApplicationRequirementsEducation', readonly id: string, readonly type: string, readonly description?: string | null, readonly enforcementType: string } | { readonly __typename: 'JobApplicationRequirementsFluVaccination', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsFluVaccine', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsLocationFloating', readonly id: string, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsMaximumTimeOffRule', readonly id: string, readonly type: string, readonly maximumTimeOff: number, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsNurseReference', readonly id: string, readonly description?: string | null, readonly occurrences?: number | null, readonly timeframe?: number | null, readonly type: string } | { readonly __typename: 'JobApplicationRequirementsProofOfIdentification', readonly id: string, readonly type: string, readonly description?: string | null, readonly required?: boolean | null, readonly stage: JobApplicationRequirementStageEnum } | { readonly __typename: 'JobApplicationRequirementsRadiusRule', readonly id: string, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsRoleExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsStateLicense', readonly id: string, readonly stage: JobApplicationRequirementStageEnum, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsTechnologyExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null, readonly technology: { readonly __typename?: 'Technology', readonly id: string, readonly uuid: string, readonly name: string } } | { readonly __typename: 'JobApplicationRequirementsTraumaLevelExperience', readonly id: string, readonly type: string, readonly description?: string | null, readonly enforcementType: string } | { readonly __typename: 'JobApplicationRequirementsTravelExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsUnitExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsUnitFloating', readonly id: string, readonly type: string, readonly description?: string | null }> | null, readonly roles?: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: string, readonly key?: string | null, readonly name: string, readonly type?: RoleType | null, readonly abbreviation: string }> | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly stateCode?: string | null, readonly city?: string | null, readonly country?: string | null, readonly postalCode?: string | null } | null, readonly business?: { readonly __typename?: 'Facility', readonly id: string, readonly bgImageFlickrUrl?: string | null } | null, readonly cityLocation?: { readonly __typename?: 'Location', readonly id: string, readonly latitude?: number | null, readonly longitude?: number | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string, readonly slug: string } | null } | null };

export type ContractDetailFragment = { readonly __typename?: 'Contract', readonly id: string, readonly contractStatus?: string | null, readonly contractStartDate: GraphQLISO8601Date, readonly contractEndDate: GraphQLISO8601Date, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly state?: string | null, readonly city?: string | null } | null, readonly jobOffer?: { readonly __typename?: 'JobOffer', readonly id: string, readonly uuid: string, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly facilityName?: string | null, readonly title?: string | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null } } | null };

export type JobOfferDetailFragment = { readonly __typename?: 'JobOffer', readonly id: string, readonly uuid: string, readonly status: JobOfferEnum, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly contractNotes?: string | null, readonly clinicianAcceptedInapp?: boolean | null, readonly nurseAdvocateEmail?: string | null, readonly lengthInWeeks?: number | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly hoursPerShift?: number | null, readonly contracts?: ReadonlyArray<{ readonly __typename?: 'Contract', readonly id: string, readonly contractStatus?: string | null, readonly contractStartDate: GraphQLISO8601Date, readonly contractEndDate: GraphQLISO8601Date, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly state?: string | null, readonly city?: string | null } | null, readonly jobOffer?: { readonly __typename?: 'JobOffer', readonly id: string, readonly uuid: string, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly facilityName?: string | null, readonly title?: string | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null } } | null }> | null, readonly timeOffs?: ReadonlyArray<{ readonly __typename?: 'TimeOff', readonly id: string, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly approvalStatus?: string | null }> | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly localAllowed: boolean, readonly onHold?: boolean | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly facilityName?: string | null, readonly cancellationPolicy?: string | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly business?: { readonly __typename?: 'Facility', readonly city?: string | null, readonly state?: string | null, readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null }, readonly jobApplication: { readonly __typename?: 'JobApplication', readonly id: string, readonly paymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly nonTaxableStipendWeekly?: number | null, readonly taxableWageRateWeekly?: number | null, readonly grossPayWeekly?: number | null } | null }, readonly paymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly nonTaxableStipendWeekly?: number | null, readonly taxableWageRateWeekly?: number | null, readonly grossPayWeekly?: number | null, readonly incidentalsStipendDaily?: number | null, readonly lodgingStipendDaily?: number | null, readonly regularWageRate?: number | null, readonly overtimeMultiplier?: number | null, readonly doubleTimeMultiplier?: number | null, readonly overtimeWageRate?: number | null, readonly regularHoursPerWeek?: number | null, readonly overtimeHoursPerWeek?: number | null, readonly blendedWageRate?: number | null, readonly totalHoursPerWeek?: number | null, readonly holidayRate?: number | null, readonly chargeRate?: number | null, readonly onCallRate?: number | null, readonly callBackRate?: number | null, readonly extraRate?: number | null } | null };

export type AcceptOfferMutationVariables = Exact<{
  jobOfferId: Scalars['ID']['input'];
}>;


export type AcceptOfferMutation = { readonly __typename?: 'Mutation', readonly acceptOffer?: { readonly __typename?: 'AcceptOfferPayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string }, readonly jobOffer: { readonly __typename?: 'JobOffer', readonly id: string, readonly status: JobOfferEnum, readonly clinicianAcceptedInapp?: boolean | null } } | null };

export type JobOfferItemQueryVariables = Exact<{
  jobOfferId: Scalars['ID']['input'];
}>;


export type JobOfferItemQuery = { readonly __typename?: 'Query', readonly jobOffer?: { readonly __typename?: 'JobOffer', readonly id: string, readonly uuid: string, readonly status: JobOfferEnum, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly contractNotes?: string | null, readonly clinicianAcceptedInapp?: boolean | null, readonly nurseAdvocateEmail?: string | null, readonly lengthInWeeks?: number | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly hoursPerShift?: number | null, readonly contracts?: ReadonlyArray<{ readonly __typename?: 'Contract', readonly id: string, readonly contractStatus?: string | null, readonly contractStartDate: GraphQLISO8601Date, readonly contractEndDate: GraphQLISO8601Date, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly state?: string | null, readonly city?: string | null } | null, readonly jobOffer?: { readonly __typename?: 'JobOffer', readonly id: string, readonly uuid: string, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly facilityName?: string | null, readonly title?: string | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null } } | null }> | null, readonly timeOffs?: ReadonlyArray<{ readonly __typename?: 'TimeOff', readonly id: string, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly approvalStatus?: string | null }> | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly localAllowed: boolean, readonly onHold?: boolean | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly facilityName?: string | null, readonly cancellationPolicy?: string | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly business?: { readonly __typename?: 'Facility', readonly city?: string | null, readonly state?: string | null, readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null }, readonly jobApplication: { readonly __typename?: 'JobApplication', readonly id: string, readonly paymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly nonTaxableStipendWeekly?: number | null, readonly taxableWageRateWeekly?: number | null, readonly grossPayWeekly?: number | null } | null }, readonly paymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly nonTaxableStipendWeekly?: number | null, readonly taxableWageRateWeekly?: number | null, readonly grossPayWeekly?: number | null, readonly incidentalsStipendDaily?: number | null, readonly lodgingStipendDaily?: number | null, readonly regularWageRate?: number | null, readonly overtimeMultiplier?: number | null, readonly doubleTimeMultiplier?: number | null, readonly overtimeWageRate?: number | null, readonly regularHoursPerWeek?: number | null, readonly overtimeHoursPerWeek?: number | null, readonly blendedWageRate?: number | null, readonly totalHoursPerWeek?: number | null, readonly holidayRate?: number | null, readonly chargeRate?: number | null, readonly onCallRate?: number | null, readonly callBackRate?: number | null, readonly extraRate?: number | null } | null } | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly name?: string | null, readonly nurseAdvocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly phone?: string | null, readonly firstName?: string | null, readonly lastName?: string | null, readonly profileImgUrl: string, readonly isNurseAdvocate?: boolean | null, readonly isAlliedAdvocate?: boolean | null, readonly clinicalRole?: string | null } | null } | null };

export type JobOfferDetailPageViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type JobOfferDetailPageViewerQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly firstName?: string | null } | null };

export type RoleQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type RoleQuery = { readonly __typename?: 'Query', readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly name: string, readonly key?: string | null, readonly abbreviation: string, readonly type?: RoleType | null } | null };

export type JobsPageQueryVariables = Exact<{
  role: JobRole;
}>;


export type JobsPageQuery = { readonly __typename?: 'Query', readonly clinicalUnits: ReadonlyArray<{ readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string, readonly slug: string }>, readonly usStateLocations: ReadonlyArray<{ readonly __typename?: 'Location', readonly id: string, readonly stateCode?: string | null, readonly stateName?: string | null }> };

export type JobsPageJobsQueryVariables = Exact<{
  paginate?: InputMaybe<OffsetPaginationInput>;
  filters?: InputMaybe<JobsCollectionFiltersInput>;
  sortBy?: InputMaybe<JobsCollectionSortInput>;
  locationString?: InputMaybe<Scalars['String']['input']>;
  includeLocation: Scalars['Boolean']['input'];
  clinicalUnitSlug?: InputMaybe<Scalars['String']['input']>;
  includeClinicalUnit: Scalars['Boolean']['input'];
}>;


export type JobsPageJobsQuery = { readonly __typename?: 'Query', readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string, readonly slug: string } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly stateCode?: string | null, readonly stateName?: string | null, readonly city?: string | null } | null, readonly jobsCollection?: { readonly __typename?: 'JobsCollection', readonly id: string, readonly totalRecords: number, readonly records: ReadonlyArray<{ readonly __typename?: 'Job', readonly id: string, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly hoursPerShift?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly lengthInWeeks?: number | null, readonly grossPayWeekly?: number | null, readonly jobType?: string | null, readonly licenseType?: string | null, readonly localGrossPayWeekly?: number | null, readonly radiusRule?: number | null, readonly travelAllowed: boolean, readonly localAllowed: boolean, readonly role?: string | null, readonly roles?: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: string, readonly name: string, readonly abbreviation: string, readonly key?: string | null, readonly type?: RoleType | null }> | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly blendedWageRate?: number | null, readonly callBackRate?: number | null, readonly doubleTimeMultiplier?: number | null, readonly grossPayWeekly?: number | null, readonly holidayRate?: number | null, readonly incidentalsStipendDaily?: number | null, readonly lodgingStipendDaily?: number | null, readonly onCallRate?: number | null, readonly overtimeHoursPerWeek?: number | null, readonly overtimeMultiplier?: number | null, readonly overtimeWageRate?: number | null, readonly regularHoursPerWeek?: number | null, readonly regularWageRate?: number | null, readonly totalHoursPerWeek?: number | null, readonly totalStipendDaily?: number | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly jarRadiusRuleV2?: { readonly __typename?: 'JobApplicationRequirementsRadiusRule', readonly id: string, readonly type: string, readonly description?: string | null } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null }> } };

export type BackfillLoginUserDataMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: NestedUpdateUserInput;
}>;


export type BackfillLoginUserDataMutation = { readonly __typename?: 'Mutation', readonly nestedUpdateUser?: { readonly __typename?: 'NestedUpdateUserPayload', readonly user: { readonly __typename?: 'User', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly preferredName?: string | null } } | null };

export type MatchDetailPageUserFragment = { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly referralCode?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly isActivated?: boolean | null, readonly canApplyJobs: boolean, readonly state?: string | null, readonly percentComplete?: number | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly percentCompleted: number } } | null, readonly nurseAdvocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly email?: string | null, readonly fullName?: string | null } | null } | null, readonly userProperties: { readonly __typename?: 'UserProperties', readonly id: string, readonly shouldDisplayFirstFavoriteMessage: boolean } };

export type MatchDetailPageJobFragment = { readonly __typename?: 'Job', readonly id: string, readonly state?: string | null, readonly endDate?: GraphQLISO8601Date | null, readonly friendlyLicenseType?: string | null, readonly hoursPerShift?: number | null, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly nursePatientRatio?: string | null, readonly publicDescription?: string | null, readonly shiftEnd?: string | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly shiftStart?: string | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly grossPayWeekly?: number | null, readonly instantOffer: boolean, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly positionCount?: number | null, readonly travelAllowed: boolean, readonly localAllowed: boolean, readonly localGrossPayWeekly?: number | null, readonly onHold?: boolean | null, readonly business?: { readonly __typename?: 'Facility', readonly id: string, readonly bgImageFlickrUrl?: string | null, readonly hideMatchInfo: boolean, readonly state?: string | null, readonly name: string, readonly city?: string | null, readonly address: string, readonly logo?: string | null, readonly zipcode?: string | null, readonly slug: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly rankings?: ReadonlyArray<{ readonly __typename?: 'UsnewsRanking', readonly id: string, readonly usnewsType: string }> | null, readonly hospital?: { readonly __typename?: 'Hospital', readonly id: string, readonly teaching: boolean, readonly traumaCenterLevel?: number | null, readonly affiliatedUnion?: string | null, readonly totalLicensedBeds?: number | null, readonly hospitalSystem?: string | null, readonly hospitalType?: string | null, readonly jointCommission: boolean, readonly magnet: boolean } | null } | null, readonly cityLocation?: { readonly __typename?: 'Location', readonly id: string, readonly latitude?: number | null, readonly longitude?: number | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string, readonly candidateHoldReasons: ReadonlyArray<string>, readonly state?: string | null } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null, readonly blendedWageRate?: number | null, readonly callBackRate?: number | null, readonly doubleTimeMultiplier?: number | null, readonly extraRate?: number | null, readonly holidayRate?: number | null, readonly incidentalsStipendDaily?: number | null, readonly lodgingStipendDaily?: number | null, readonly onCallRate?: number | null, readonly overtimeHoursPerWeek?: number | null, readonly overtimeMultiplier?: number | null, readonly overtimeWageRate?: number | null, readonly regularHoursPerWeek?: number | null, readonly regularWageRate?: number | null, readonly totalHoursPerWeek?: number | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null, readonly blendedWageRate?: number | null, readonly callBackRate?: number | null, readonly doubleTimeMultiplier?: number | null, readonly extraRate?: number | null, readonly holidayRate?: number | null, readonly incidentalsStipendDaily?: number | null, readonly lodgingStipendDaily?: number | null, readonly onCallRate?: number | null, readonly overtimeHoursPerWeek?: number | null, readonly overtimeMultiplier?: number | null, readonly overtimeWageRate?: number | null, readonly regularHoursPerWeek?: number | null, readonly regularWageRate?: number | null, readonly totalHoursPerWeek?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null, readonly latitude?: number | null, readonly longitude?: number | null } | null, readonly roles?: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: string, readonly type?: RoleType | null }> | null, readonly preferredJarsV2?: ReadonlyArray<{ readonly __typename: 'JobApplicationRequirementsCertification', readonly id: string, readonly type: string, readonly title?: string | null, readonly description?: string | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly credential?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly issuingBodies: ReadonlyArray<string> } } | { readonly __typename: 'JobApplicationRequirementsCovidBooster', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsCovidVaccine', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsDriverLicense', readonly id: string, readonly required?: boolean | null, readonly type: string, readonly stage: JobApplicationRequirementStageEnum } | { readonly __typename: 'JobApplicationRequirementsEducation', readonly id: string, readonly type: string, readonly description?: string | null, readonly enforcementType: string } | { readonly __typename: 'JobApplicationRequirementsFluVaccination', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsFluVaccine', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsLocationFloating', readonly id: string, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsMaximumTimeOffRule', readonly id: string, readonly type: string, readonly maximumTimeOff: number, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsNurseReference', readonly id: string, readonly description?: string | null, readonly occurrences?: number | null, readonly timeframe?: number | null, readonly type: string } | { readonly __typename: 'JobApplicationRequirementsProofOfIdentification', readonly id: string, readonly type: string, readonly description?: string | null, readonly required?: boolean | null, readonly stage: JobApplicationRequirementStageEnum } | { readonly __typename: 'JobApplicationRequirementsRadiusRule', readonly id: string, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsRoleExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsStateLicense', readonly id: string, readonly stage: JobApplicationRequirementStageEnum, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsTechnologyExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null, readonly technology: { readonly __typename?: 'Technology', readonly id: string, readonly uuid: string, readonly name: string } } | { readonly __typename: 'JobApplicationRequirementsTraumaLevelExperience', readonly id: string, readonly type: string, readonly description?: string | null, readonly enforcementType: string } | { readonly __typename: 'JobApplicationRequirementsTravelExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsUnitExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsUnitFloating', readonly id: string, readonly type: string, readonly description?: string | null }> | null, readonly requiredJarsV2?: ReadonlyArray<{ readonly __typename: 'JobApplicationRequirementsCertification', readonly id: string, readonly type: string, readonly title?: string | null, readonly description?: string | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly credential?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly issuingBodies: ReadonlyArray<string> } } | { readonly __typename: 'JobApplicationRequirementsCovidBooster', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsCovidVaccine', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsDriverLicense', readonly id: string, readonly required?: boolean | null, readonly type: string, readonly stage: JobApplicationRequirementStageEnum } | { readonly __typename: 'JobApplicationRequirementsEducation', readonly id: string, readonly type: string, readonly description?: string | null, readonly enforcementType: string } | { readonly __typename: 'JobApplicationRequirementsFluVaccination', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsFluVaccine', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsLocationFloating', readonly id: string, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsMaximumTimeOffRule', readonly id: string, readonly type: string, readonly maximumTimeOff: number, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsNurseReference', readonly id: string, readonly description?: string | null, readonly occurrences?: number | null, readonly timeframe?: number | null, readonly type: string } | { readonly __typename: 'JobApplicationRequirementsProofOfIdentification', readonly id: string, readonly type: string, readonly description?: string | null, readonly required?: boolean | null, readonly stage: JobApplicationRequirementStageEnum } | { readonly __typename: 'JobApplicationRequirementsRadiusRule', readonly id: string, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsRoleExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsStateLicense', readonly id: string, readonly stage: JobApplicationRequirementStageEnum, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsTechnologyExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null, readonly technology: { readonly __typename?: 'Technology', readonly id: string, readonly uuid: string, readonly name: string } } | { readonly __typename: 'JobApplicationRequirementsTraumaLevelExperience', readonly id: string, readonly type: string, readonly description?: string | null, readonly enforcementType: string } | { readonly __typename: 'JobApplicationRequirementsTravelExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsUnitExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsUnitFloating', readonly id: string, readonly type: string, readonly description?: string | null }> | null, readonly canApply: { readonly __typename?: 'AuthorizationResult', readonly value: boolean, readonly reasons?: { readonly __typename?: 'FailureReasons', readonly fullMessages: ReadonlyArray<string> } | null }, readonly esMatch?: { readonly __typename?: 'Match', readonly id: string, readonly userState?: string | null } | null, readonly canFavorite: { readonly __typename?: 'AuthorizationResult', readonly value: boolean, readonly reasons?: { readonly __typename?: 'FailureReasons', readonly fullMessages: ReadonlyArray<string> } | null }, readonly canWithdraw: { readonly __typename?: 'AuthorizationResult', readonly value: boolean, readonly reasons?: { readonly __typename?: 'FailureReasons', readonly fullMessages: ReadonlyArray<string> } | null } };

export type MatchDetailPageExpressInterestMutationVariables = Exact<{
  id: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
}>;


export type MatchDetailPageExpressInterestMutation = { readonly __typename?: 'Mutation', readonly expressInterest?: { readonly __typename?: 'Job', readonly id: string, readonly instantOffer: boolean, readonly hoursPerShift?: number | null, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly positionCount?: number | null, readonly shiftsPerWeek?: number | null, readonly shiftType?: string | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly localAllowed: boolean, readonly grossPayWeekly?: number | null, readonly localGrossPayWeekly?: number | null, readonly onHold?: boolean | null, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly business?: { readonly __typename?: 'Facility', readonly id: string, readonly hideMatchInfo: boolean, readonly name: string, readonly city?: string | null, readonly state?: string | null, readonly logo?: string | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string, readonly state?: string | null } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly canApply: { readonly __typename?: 'AuthorizationResult', readonly value: boolean, readonly reasons?: { readonly __typename?: 'FailureReasons', readonly fullMessages: ReadonlyArray<string> } | null }, readonly esMatch?: { readonly __typename?: 'Match', readonly id: string, readonly userState?: string | null } | null, readonly canFavorite: { readonly __typename?: 'AuthorizationResult', readonly value: boolean, readonly reasons?: { readonly __typename?: 'FailureReasons', readonly fullMessages: ReadonlyArray<string> } | null }, readonly canWithdraw: { readonly __typename?: 'AuthorizationResult', readonly value: boolean, readonly reasons?: { readonly __typename?: 'FailureReasons', readonly fullMessages: ReadonlyArray<string> } | null }, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null } | null };

export type MatchDetailPageRemoveInterestMutationVariables = Exact<{
  id: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
}>;


export type MatchDetailPageRemoveInterestMutation = { readonly __typename?: 'Mutation', readonly removeInterest?: { readonly __typename?: 'Job', readonly id: string, readonly instantOffer: boolean, readonly hoursPerShift?: number | null, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly positionCount?: number | null, readonly shiftsPerWeek?: number | null, readonly shiftType?: string | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly localAllowed: boolean, readonly grossPayWeekly?: number | null, readonly localGrossPayWeekly?: number | null, readonly onHold?: boolean | null, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly business?: { readonly __typename?: 'Facility', readonly id: string, readonly hideMatchInfo: boolean, readonly name: string, readonly city?: string | null, readonly state?: string | null, readonly logo?: string | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string, readonly state?: string | null } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly canApply: { readonly __typename?: 'AuthorizationResult', readonly value: boolean, readonly reasons?: { readonly __typename?: 'FailureReasons', readonly fullMessages: ReadonlyArray<string> } | null }, readonly esMatch?: { readonly __typename?: 'Match', readonly id: string, readonly userState?: string | null } | null, readonly canFavorite: { readonly __typename?: 'AuthorizationResult', readonly value: boolean, readonly reasons?: { readonly __typename?: 'FailureReasons', readonly fullMessages: ReadonlyArray<string> } | null }, readonly canWithdraw: { readonly __typename?: 'AuthorizationResult', readonly value: boolean, readonly reasons?: { readonly __typename?: 'FailureReasons', readonly fullMessages: ReadonlyArray<string> } | null }, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null } | null };

export type MatchDetailPageQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MatchDetailPageQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly referralCode?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly isActivated?: boolean | null, readonly canApplyJobs: boolean, readonly state?: string | null, readonly percentComplete?: number | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly percentCompleted: number } } | null, readonly nurseAdvocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly email?: string | null, readonly fullName?: string | null } | null } | null, readonly userProperties: { readonly __typename?: 'UserProperties', readonly id: string, readonly shouldDisplayFirstFavoriteMessage: boolean } } | null, readonly job?: { readonly __typename?: 'Job', readonly id: string, readonly state?: string | null, readonly endDate?: GraphQLISO8601Date | null, readonly friendlyLicenseType?: string | null, readonly hoursPerShift?: number | null, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly nursePatientRatio?: string | null, readonly publicDescription?: string | null, readonly shiftEnd?: string | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly shiftStart?: string | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly grossPayWeekly?: number | null, readonly instantOffer: boolean, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly positionCount?: number | null, readonly travelAllowed: boolean, readonly localAllowed: boolean, readonly localGrossPayWeekly?: number | null, readonly onHold?: boolean | null, readonly business?: { readonly __typename?: 'Facility', readonly id: string, readonly bgImageFlickrUrl?: string | null, readonly hideMatchInfo: boolean, readonly state?: string | null, readonly name: string, readonly city?: string | null, readonly address: string, readonly logo?: string | null, readonly zipcode?: string | null, readonly slug: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly rankings?: ReadonlyArray<{ readonly __typename?: 'UsnewsRanking', readonly id: string, readonly usnewsType: string }> | null, readonly hospital?: { readonly __typename?: 'Hospital', readonly id: string, readonly teaching: boolean, readonly traumaCenterLevel?: number | null, readonly affiliatedUnion?: string | null, readonly totalLicensedBeds?: number | null, readonly hospitalSystem?: string | null, readonly hospitalType?: string | null, readonly jointCommission: boolean, readonly magnet: boolean } | null } | null, readonly cityLocation?: { readonly __typename?: 'Location', readonly id: string, readonly latitude?: number | null, readonly longitude?: number | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string, readonly candidateHoldReasons: ReadonlyArray<string>, readonly state?: string | null } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null, readonly blendedWageRate?: number | null, readonly callBackRate?: number | null, readonly doubleTimeMultiplier?: number | null, readonly extraRate?: number | null, readonly holidayRate?: number | null, readonly incidentalsStipendDaily?: number | null, readonly lodgingStipendDaily?: number | null, readonly onCallRate?: number | null, readonly overtimeHoursPerWeek?: number | null, readonly overtimeMultiplier?: number | null, readonly overtimeWageRate?: number | null, readonly regularHoursPerWeek?: number | null, readonly regularWageRate?: number | null, readonly totalHoursPerWeek?: number | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null, readonly blendedWageRate?: number | null, readonly callBackRate?: number | null, readonly doubleTimeMultiplier?: number | null, readonly extraRate?: number | null, readonly holidayRate?: number | null, readonly incidentalsStipendDaily?: number | null, readonly lodgingStipendDaily?: number | null, readonly onCallRate?: number | null, readonly overtimeHoursPerWeek?: number | null, readonly overtimeMultiplier?: number | null, readonly overtimeWageRate?: number | null, readonly regularHoursPerWeek?: number | null, readonly regularWageRate?: number | null, readonly totalHoursPerWeek?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null, readonly latitude?: number | null, readonly longitude?: number | null } | null, readonly roles?: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: string, readonly type?: RoleType | null }> | null, readonly preferredJarsV2?: ReadonlyArray<{ readonly __typename: 'JobApplicationRequirementsCertification', readonly id: string, readonly type: string, readonly title?: string | null, readonly description?: string | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly credential?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly issuingBodies: ReadonlyArray<string> } } | { readonly __typename: 'JobApplicationRequirementsCovidBooster', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsCovidVaccine', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsDriverLicense', readonly id: string, readonly required?: boolean | null, readonly type: string, readonly stage: JobApplicationRequirementStageEnum } | { readonly __typename: 'JobApplicationRequirementsEducation', readonly id: string, readonly type: string, readonly description?: string | null, readonly enforcementType: string } | { readonly __typename: 'JobApplicationRequirementsFluVaccination', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsFluVaccine', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsLocationFloating', readonly id: string, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsMaximumTimeOffRule', readonly id: string, readonly type: string, readonly maximumTimeOff: number, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsNurseReference', readonly id: string, readonly description?: string | null, readonly occurrences?: number | null, readonly timeframe?: number | null, readonly type: string } | { readonly __typename: 'JobApplicationRequirementsProofOfIdentification', readonly id: string, readonly type: string, readonly description?: string | null, readonly required?: boolean | null, readonly stage: JobApplicationRequirementStageEnum } | { readonly __typename: 'JobApplicationRequirementsRadiusRule', readonly id: string, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsRoleExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsStateLicense', readonly id: string, readonly stage: JobApplicationRequirementStageEnum, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsTechnologyExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null, readonly technology: { readonly __typename?: 'Technology', readonly id: string, readonly uuid: string, readonly name: string } } | { readonly __typename: 'JobApplicationRequirementsTraumaLevelExperience', readonly id: string, readonly type: string, readonly description?: string | null, readonly enforcementType: string } | { readonly __typename: 'JobApplicationRequirementsTravelExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsUnitExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsUnitFloating', readonly id: string, readonly type: string, readonly description?: string | null }> | null, readonly requiredJarsV2?: ReadonlyArray<{ readonly __typename: 'JobApplicationRequirementsCertification', readonly id: string, readonly type: string, readonly title?: string | null, readonly description?: string | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly credential?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly issuingBodies: ReadonlyArray<string> } } | { readonly __typename: 'JobApplicationRequirementsCovidBooster', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsCovidVaccine', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsDriverLicense', readonly id: string, readonly required?: boolean | null, readonly type: string, readonly stage: JobApplicationRequirementStageEnum } | { readonly __typename: 'JobApplicationRequirementsEducation', readonly id: string, readonly type: string, readonly description?: string | null, readonly enforcementType: string } | { readonly __typename: 'JobApplicationRequirementsFluVaccination', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsFluVaccine', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsLocationFloating', readonly id: string, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsMaximumTimeOffRule', readonly id: string, readonly type: string, readonly maximumTimeOff: number, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsNurseReference', readonly id: string, readonly description?: string | null, readonly occurrences?: number | null, readonly timeframe?: number | null, readonly type: string } | { readonly __typename: 'JobApplicationRequirementsProofOfIdentification', readonly id: string, readonly type: string, readonly description?: string | null, readonly required?: boolean | null, readonly stage: JobApplicationRequirementStageEnum } | { readonly __typename: 'JobApplicationRequirementsRadiusRule', readonly id: string, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsRoleExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsStateLicense', readonly id: string, readonly stage: JobApplicationRequirementStageEnum, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsTechnologyExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null, readonly technology: { readonly __typename?: 'Technology', readonly id: string, readonly uuid: string, readonly name: string } } | { readonly __typename: 'JobApplicationRequirementsTraumaLevelExperience', readonly id: string, readonly type: string, readonly description?: string | null, readonly enforcementType: string } | { readonly __typename: 'JobApplicationRequirementsTravelExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsUnitExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsUnitFloating', readonly id: string, readonly type: string, readonly description?: string | null }> | null, readonly canApply: { readonly __typename?: 'AuthorizationResult', readonly value: boolean, readonly reasons?: { readonly __typename?: 'FailureReasons', readonly fullMessages: ReadonlyArray<string> } | null }, readonly esMatch?: { readonly __typename?: 'Match', readonly id: string, readonly userState?: string | null } | null, readonly canFavorite: { readonly __typename?: 'AuthorizationResult', readonly value: boolean, readonly reasons?: { readonly __typename?: 'FailureReasons', readonly fullMessages: ReadonlyArray<string> } | null }, readonly canWithdraw: { readonly __typename?: 'AuthorizationResult', readonly value: boolean, readonly reasons?: { readonly __typename?: 'FailureReasons', readonly fullMessages: ReadonlyArray<string> } | null } } | null };

export type EmbeddedMatchDetailPageQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EmbeddedMatchDetailPageQuery = { readonly __typename?: 'Query', readonly job?: { readonly __typename?: 'Job', readonly id: string, readonly state?: string | null, readonly endDate?: GraphQLISO8601Date | null, readonly friendlyLicenseType?: string | null, readonly hoursPerShift?: number | null, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly nursePatientRatio?: string | null, readonly publicDescription?: string | null, readonly shiftEnd?: string | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly shiftStart?: string | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly grossPayWeekly?: number | null, readonly instantOffer: boolean, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly positionCount?: number | null, readonly travelAllowed: boolean, readonly localAllowed: boolean, readonly localGrossPayWeekly?: number | null, readonly onHold?: boolean | null, readonly business?: { readonly __typename?: 'Facility', readonly id: string, readonly bgImageFlickrUrl?: string | null, readonly hideMatchInfo: boolean, readonly state?: string | null, readonly name: string, readonly city?: string | null, readonly address: string, readonly logo?: string | null, readonly zipcode?: string | null, readonly slug: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly rankings?: ReadonlyArray<{ readonly __typename?: 'UsnewsRanking', readonly id: string, readonly usnewsType: string }> | null, readonly hospital?: { readonly __typename?: 'Hospital', readonly id: string, readonly teaching: boolean, readonly traumaCenterLevel?: number | null, readonly affiliatedUnion?: string | null, readonly totalLicensedBeds?: number | null, readonly hospitalSystem?: string | null, readonly hospitalType?: string | null, readonly jointCommission: boolean, readonly magnet: boolean } | null } | null, readonly cityLocation?: { readonly __typename?: 'Location', readonly id: string, readonly latitude?: number | null, readonly longitude?: number | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly jobApplication?: { readonly __typename?: 'JobApplication', readonly id: string, readonly candidateHoldReasons: ReadonlyArray<string>, readonly state?: string | null } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null, readonly blendedWageRate?: number | null, readonly callBackRate?: number | null, readonly doubleTimeMultiplier?: number | null, readonly extraRate?: number | null, readonly holidayRate?: number | null, readonly incidentalsStipendDaily?: number | null, readonly lodgingStipendDaily?: number | null, readonly onCallRate?: number | null, readonly overtimeHoursPerWeek?: number | null, readonly overtimeMultiplier?: number | null, readonly overtimeWageRate?: number | null, readonly regularHoursPerWeek?: number | null, readonly regularWageRate?: number | null, readonly totalHoursPerWeek?: number | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null, readonly blendedWageRate?: number | null, readonly callBackRate?: number | null, readonly doubleTimeMultiplier?: number | null, readonly extraRate?: number | null, readonly holidayRate?: number | null, readonly incidentalsStipendDaily?: number | null, readonly lodgingStipendDaily?: number | null, readonly onCallRate?: number | null, readonly overtimeHoursPerWeek?: number | null, readonly overtimeMultiplier?: number | null, readonly overtimeWageRate?: number | null, readonly regularHoursPerWeek?: number | null, readonly regularWageRate?: number | null, readonly totalHoursPerWeek?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null, readonly latitude?: number | null, readonly longitude?: number | null } | null, readonly roles?: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: string, readonly type?: RoleType | null }> | null, readonly preferredJarsV2?: ReadonlyArray<{ readonly __typename: 'JobApplicationRequirementsCertification', readonly id: string, readonly type: string, readonly title?: string | null, readonly description?: string | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly credential?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly issuingBodies: ReadonlyArray<string> } } | { readonly __typename: 'JobApplicationRequirementsCovidBooster', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsCovidVaccine', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsDriverLicense', readonly id: string, readonly required?: boolean | null, readonly type: string, readonly stage: JobApplicationRequirementStageEnum } | { readonly __typename: 'JobApplicationRequirementsEducation', readonly id: string, readonly type: string, readonly description?: string | null, readonly enforcementType: string } | { readonly __typename: 'JobApplicationRequirementsFluVaccination', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsFluVaccine', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsLocationFloating', readonly id: string, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsMaximumTimeOffRule', readonly id: string, readonly type: string, readonly maximumTimeOff: number, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsNurseReference', readonly id: string, readonly description?: string | null, readonly occurrences?: number | null, readonly timeframe?: number | null, readonly type: string } | { readonly __typename: 'JobApplicationRequirementsProofOfIdentification', readonly id: string, readonly type: string, readonly description?: string | null, readonly required?: boolean | null, readonly stage: JobApplicationRequirementStageEnum } | { readonly __typename: 'JobApplicationRequirementsRadiusRule', readonly id: string, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsRoleExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsStateLicense', readonly id: string, readonly stage: JobApplicationRequirementStageEnum, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsTechnologyExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null, readonly technology: { readonly __typename?: 'Technology', readonly id: string, readonly uuid: string, readonly name: string } } | { readonly __typename: 'JobApplicationRequirementsTraumaLevelExperience', readonly id: string, readonly type: string, readonly description?: string | null, readonly enforcementType: string } | { readonly __typename: 'JobApplicationRequirementsTravelExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsUnitExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsUnitFloating', readonly id: string, readonly type: string, readonly description?: string | null }> | null, readonly requiredJarsV2?: ReadonlyArray<{ readonly __typename: 'JobApplicationRequirementsCertification', readonly id: string, readonly type: string, readonly title?: string | null, readonly description?: string | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly credential?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly issuingBodies: ReadonlyArray<string> } } | { readonly __typename: 'JobApplicationRequirementsCovidBooster', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsCovidVaccine', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsDriverLicense', readonly id: string, readonly required?: boolean | null, readonly type: string, readonly stage: JobApplicationRequirementStageEnum } | { readonly __typename: 'JobApplicationRequirementsEducation', readonly id: string, readonly type: string, readonly description?: string | null, readonly enforcementType: string } | { readonly __typename: 'JobApplicationRequirementsFluVaccination', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsFluVaccine', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsLocationFloating', readonly id: string, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsMaximumTimeOffRule', readonly id: string, readonly type: string, readonly maximumTimeOff: number, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsNurseReference', readonly id: string, readonly description?: string | null, readonly occurrences?: number | null, readonly timeframe?: number | null, readonly type: string } | { readonly __typename: 'JobApplicationRequirementsProofOfIdentification', readonly id: string, readonly type: string, readonly description?: string | null, readonly required?: boolean | null, readonly stage: JobApplicationRequirementStageEnum } | { readonly __typename: 'JobApplicationRequirementsRadiusRule', readonly id: string, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsRoleExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsStateLicense', readonly id: string, readonly stage: JobApplicationRequirementStageEnum, readonly type: string, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsTechnologyExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null, readonly technology: { readonly __typename?: 'Technology', readonly id: string, readonly uuid: string, readonly name: string } } | { readonly __typename: 'JobApplicationRequirementsTraumaLevelExperience', readonly id: string, readonly type: string, readonly description?: string | null, readonly enforcementType: string } | { readonly __typename: 'JobApplicationRequirementsTravelExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsUnitExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null } | { readonly __typename: 'JobApplicationRequirementsUnitFloating', readonly id: string, readonly type: string, readonly description?: string | null }> | null, readonly canApply: { readonly __typename?: 'AuthorizationResult', readonly value: boolean, readonly reasons?: { readonly __typename?: 'FailureReasons', readonly fullMessages: ReadonlyArray<string> } | null }, readonly esMatch?: { readonly __typename?: 'Match', readonly id: string, readonly userState?: string | null } | null, readonly canFavorite: { readonly __typename?: 'AuthorizationResult', readonly value: boolean, readonly reasons?: { readonly __typename?: 'FailureReasons', readonly fullMessages: ReadonlyArray<string> } | null }, readonly canWithdraw: { readonly __typename?: 'AuthorizationResult', readonly value: boolean, readonly reasons?: { readonly __typename?: 'FailureReasons', readonly fullMessages: ReadonlyArray<string> } | null } } | null };

export type MatchDetailPageRelatedJobsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MatchDetailPageRelatedJobsQuery = { readonly __typename?: 'Query', readonly relatedJobsConnection: { readonly __typename?: 'JobConnection', readonly nodes?: ReadonlyArray<{ readonly __typename?: 'Job', readonly id: string, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly localAllowed: boolean, readonly onHold?: boolean | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly facilityName?: string | null, readonly cancellationPolicy?: string | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly esMatch?: { readonly __typename?: 'Match', readonly id: string, readonly userState?: string | null } | null, readonly business?: { readonly __typename?: 'Facility', readonly city?: string | null, readonly state?: string | null, readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null } | null> | null } };

export type MatchesFavoritesPageUnavailableFavoritedMatchesMutationVariables = Exact<{ [key: string]: never; }>;


export type MatchesFavoritesPageUnavailableFavoritedMatchesMutation = { readonly __typename?: 'Mutation', readonly clearUnavailableFavoritedMatches: { readonly __typename?: 'ClearUnavailableFavoritedMatchesPayload', readonly jobs: ReadonlyArray<{ readonly __typename?: 'Job', readonly id: string }> } };

export type MatchesFavoritesPageQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MatchesFavoritesPageQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly canApplyJobs: boolean, readonly canViewJobs: boolean, readonly wizardCompleted: boolean, readonly isActivated?: boolean | null, readonly percentComplete?: number | null, readonly state?: string | null, readonly jobs: { readonly __typename?: 'CandidateJobs', readonly paginatedAvailableFavorited: { readonly __typename?: 'JobsConnection', readonly nodes?: ReadonlyArray<{ readonly __typename?: 'Job', readonly id: string, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly localAllowed: boolean, readonly onHold?: boolean | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly facilityName?: string | null, readonly cancellationPolicy?: string | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly esMatch?: { readonly __typename?: 'Match', readonly id: string, readonly userState?: string | null } | null, readonly business?: { readonly __typename?: 'Facility', readonly city?: string | null, readonly state?: string | null, readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null } | null> | null, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly hasPreviousPage: boolean, readonly startCursor?: string | null, readonly endCursor?: string | null } }, readonly unavailableFavorited: { readonly __typename?: 'JobsConnection', readonly nodes?: ReadonlyArray<{ readonly __typename?: 'Job', readonly id: string, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly localAllowed: boolean, readonly onHold?: boolean | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly facilityName?: string | null, readonly cancellationPolicy?: string | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly esMatch?: { readonly __typename?: 'Match', readonly id: string, readonly userState?: string | null } | null, readonly business?: { readonly __typename?: 'Facility', readonly city?: string | null, readonly state?: string | null, readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null } | null> | null } }, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly percentCompleted: number } } | null, readonly nurseAdvocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly email?: string | null, readonly fullName?: string | null } | null } | null } | null };

export type OnboardingContainerQueryVariables = Exact<{ [key: string]: never; }>;


export type OnboardingContainerQuery = { readonly __typename?: 'Query', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly canViewJobs: boolean, readonly updatedAt: GraphQLISO8601DateTime, readonly isOnboarding: boolean, readonly todoLists: ReadonlyArray<{ readonly __typename?: 'TodoList', readonly uuid?: string | null, readonly id: string, readonly markedCompleteAt?: GraphQLISO8601Date | null, readonly contractSignedDate?: GraphQLISO8601Date | null, readonly completeByDate?: GraphQLISO8601Date | null, readonly status?: string | null, readonly startDate?: GraphQLISO8601Date | null, readonly incentiveDeadline?: GraphQLISO8601Date | null, readonly publishedAt?: GraphQLISO8601Date | null, readonly createdAt: GraphQLISO8601DateTime, readonly numTasksDue?: number | null, readonly listType?: string | null, readonly targetBusinessName?: string | null, readonly numTasksNeedingAttention?: number | null, readonly numTasksPending?: number | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly user?: { readonly __typename?: 'User', readonly id: string, readonly city?: string | null, readonly state?: string | null, readonly streetAddress?: string | null, readonly zipcode?: string | null } | null } | null, readonly todoListItems: ReadonlyArray<{ readonly __typename?: 'TodoListItem', readonly id: string, readonly name?: string | null, readonly itemType?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly itemState?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly uuid?: string | null, readonly candidateNotes?: string | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }>, readonly nurseAssessmentTarget?: { readonly __typename?: 'NurseAssessment', readonly id: string, readonly uuid?: string | null, readonly completedOn?: GraphQLISO8601Date | null, readonly score?: number | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly requestable?: boolean | null, readonly uuid?: string | null, readonly name?: string | null, readonly category?: string | null, readonly issuingBody?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseHealthDocTarget?: { readonly __typename?: 'NurseHealthDoc', readonly id: string } | null, readonly documentTarget?: { readonly __typename?: 'Document', readonly id: string, readonly uuid?: string | null, readonly title?: string | null, readonly isExpirable: boolean, readonly isExpiringSoon?: boolean | null, readonly isExpired?: boolean | null, readonly expirationType?: DocumentExpiration | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly docType?: string | null, readonly docSubtype?: string | null, readonly trackCompletionDate?: boolean | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseCertificationTarget?: { readonly __typename?: 'NurseCertification', readonly id: string, readonly certificationUuid?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null }>, readonly timelineTodoListItems: { readonly __typename?: 'TimelineTodoListItems', readonly externalItems: ReadonlyArray<{ readonly __typename?: 'SortedTodoListItemsExternal', readonly displayName?: string | null, readonly formattedDueDate: string, readonly categories: { readonly __typename?: 'SortedTodoListItemsCategories', readonly general?: { readonly __typename?: 'SortedTodoListItemsCategory', readonly displayName: string, readonly items: ReadonlyArray<{ readonly __typename?: 'TodoListItem', readonly id: string, readonly order?: number | null, readonly itemType?: string | null, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly itemState?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly uuid?: string | null, readonly candidateNotes?: string | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }>, readonly nurseAssessmentTarget?: { readonly __typename?: 'NurseAssessment', readonly id: string, readonly uuid?: string | null, readonly completedOn?: GraphQLISO8601Date | null, readonly score?: number | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly requestable?: boolean | null, readonly uuid?: string | null, readonly name?: string | null, readonly category?: string | null, readonly issuingBody?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseHealthDocTarget?: { readonly __typename?: 'NurseHealthDoc', readonly id: string } | null, readonly documentTarget?: { readonly __typename?: 'Document', readonly id: string, readonly uuid?: string | null, readonly title?: string | null, readonly isExpirable: boolean, readonly isExpiringSoon?: boolean | null, readonly isExpired?: boolean | null, readonly expirationType?: DocumentExpiration | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly docType?: string | null, readonly docSubtype?: string | null, readonly trackCompletionDate?: boolean | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseCertificationTarget?: { readonly __typename?: 'NurseCertification', readonly id: string, readonly certificationUuid?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null }> } | null, readonly backgroundAndIdentification?: { readonly __typename?: 'SortedTodoListItemsCategory', readonly displayName: string, readonly items: ReadonlyArray<{ readonly __typename?: 'TodoListItem', readonly id: string, readonly order?: number | null, readonly itemType?: string | null, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly itemState?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly uuid?: string | null, readonly candidateNotes?: string | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }>, readonly nurseAssessmentTarget?: { readonly __typename?: 'NurseAssessment', readonly id: string, readonly uuid?: string | null, readonly completedOn?: GraphQLISO8601Date | null, readonly score?: number | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly requestable?: boolean | null, readonly uuid?: string | null, readonly name?: string | null, readonly category?: string | null, readonly issuingBody?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseHealthDocTarget?: { readonly __typename?: 'NurseHealthDoc', readonly id: string } | null, readonly documentTarget?: { readonly __typename?: 'Document', readonly id: string, readonly uuid?: string | null, readonly title?: string | null, readonly isExpirable: boolean, readonly isExpiringSoon?: boolean | null, readonly isExpired?: boolean | null, readonly expirationType?: DocumentExpiration | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly docType?: string | null, readonly docSubtype?: string | null, readonly trackCompletionDate?: boolean | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseCertificationTarget?: { readonly __typename?: 'NurseCertification', readonly id: string, readonly certificationUuid?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null }> } | null, readonly licensesAndCertifications?: { readonly __typename?: 'SortedTodoListItemsCategory', readonly displayName: string, readonly items: ReadonlyArray<{ readonly __typename?: 'TodoListItem', readonly id: string, readonly order?: number | null, readonly itemType?: string | null, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly itemState?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly uuid?: string | null, readonly candidateNotes?: string | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }>, readonly nurseAssessmentTarget?: { readonly __typename?: 'NurseAssessment', readonly id: string, readonly uuid?: string | null, readonly completedOn?: GraphQLISO8601Date | null, readonly score?: number | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly requestable?: boolean | null, readonly uuid?: string | null, readonly name?: string | null, readonly category?: string | null, readonly issuingBody?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseHealthDocTarget?: { readonly __typename?: 'NurseHealthDoc', readonly id: string } | null, readonly documentTarget?: { readonly __typename?: 'Document', readonly id: string, readonly uuid?: string | null, readonly title?: string | null, readonly isExpirable: boolean, readonly isExpiringSoon?: boolean | null, readonly isExpired?: boolean | null, readonly expirationType?: DocumentExpiration | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly docType?: string | null, readonly docSubtype?: string | null, readonly trackCompletionDate?: boolean | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseCertificationTarget?: { readonly __typename?: 'NurseCertification', readonly id: string, readonly certificationUuid?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null }> } | null, readonly assessments?: { readonly __typename?: 'SortedTodoListItemsCategory', readonly displayName: string, readonly items: ReadonlyArray<{ readonly __typename?: 'TodoListItem', readonly id: string, readonly order?: number | null, readonly itemType?: string | null, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly itemState?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly uuid?: string | null, readonly candidateNotes?: string | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }>, readonly nurseAssessmentTarget?: { readonly __typename?: 'NurseAssessment', readonly id: string, readonly uuid?: string | null, readonly completedOn?: GraphQLISO8601Date | null, readonly score?: number | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly requestable?: boolean | null, readonly uuid?: string | null, readonly name?: string | null, readonly category?: string | null, readonly issuingBody?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseHealthDocTarget?: { readonly __typename?: 'NurseHealthDoc', readonly id: string } | null, readonly documentTarget?: { readonly __typename?: 'Document', readonly id: string, readonly uuid?: string | null, readonly title?: string | null, readonly isExpirable: boolean, readonly isExpiringSoon?: boolean | null, readonly isExpired?: boolean | null, readonly expirationType?: DocumentExpiration | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly docType?: string | null, readonly docSubtype?: string | null, readonly trackCompletionDate?: boolean | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseCertificationTarget?: { readonly __typename?: 'NurseCertification', readonly id: string, readonly certificationUuid?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null }> } | null, readonly healthDocuments?: { readonly __typename?: 'SortedTodoListItemsCategory', readonly displayName: string, readonly items: ReadonlyArray<{ readonly __typename?: 'TodoListItem', readonly id: string, readonly order?: number | null, readonly itemType?: string | null, readonly name?: string | null, readonly description?: string | null, readonly verificationNotes?: string | null, readonly rejectionReason?: string | null, readonly itemState?: string | null, readonly schedulable: boolean, readonly needsToBeScheduled?: boolean | null, readonly uuid?: string | null, readonly candidateNotes?: string | null, readonly karmaCheckCaseServiceOrder?: { readonly __typename?: 'CaseServiceOrder', readonly id: string, readonly isPending: boolean } | null, readonly actionLinks: ReadonlyArray<{ readonly __typename?: 'ActionLink', readonly id: string, readonly title: string, readonly url: string }>, readonly nurseAssessmentTarget?: { readonly __typename?: 'NurseAssessment', readonly id: string, readonly uuid?: string | null, readonly completedOn?: GraphQLISO8601Date | null, readonly score?: number | null, readonly assessment?: { readonly __typename?: 'Assessment', readonly id: string, readonly requestable?: boolean | null, readonly uuid?: string | null, readonly name?: string | null, readonly category?: string | null, readonly issuingBody?: string | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseHealthDocTarget?: { readonly __typename?: 'NurseHealthDoc', readonly id: string } | null, readonly documentTarget?: { readonly __typename?: 'Document', readonly id: string, readonly uuid?: string | null, readonly title?: string | null, readonly isExpirable: boolean, readonly isExpiringSoon?: boolean | null, readonly isExpired?: boolean | null, readonly expirationType?: DocumentExpiration | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly docType?: string | null, readonly docSubtype?: string | null, readonly trackCompletionDate?: boolean | null, readonly stateCode?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null, readonly nurseCertificationTarget?: { readonly __typename?: 'NurseCertification', readonly id: string, readonly certificationUuid?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly useCompletionDate?: boolean | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null } | null }> } | null } }> }, readonly targetBusinessLocation?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null }>, readonly onboardingPlacement?: { readonly __typename?: 'JobPlacement', readonly isOnboardingCompleted?: boolean | null, readonly id: string, readonly isOnboardingListPending?: boolean | null, readonly facilityName?: string | null, readonly locationCityState?: string | null, readonly startDate?: GraphQLISO8601Date | null, readonly status?: string | null, readonly onboardingJobOffer?: { readonly __typename?: 'JobOffer', readonly id: string, readonly uuid: string } | null } | null } | null, readonly documentTemplates: ReadonlyArray<{ readonly __typename?: 'DocumentTemplate', readonly id: number, readonly key?: string | null, readonly types?: ReadonlyArray<string> | null }> };

export type PayrollItemQueryVariables = Exact<{
  payrollId: Scalars['String']['input'];
}>;


export type PayrollItemQuery = { readonly __typename?: 'Query', readonly payrollItem: { readonly __typename?: 'Payroll', readonly id: string, readonly periodEnd: GraphQLISO8601Date, readonly netAmount: number, readonly lineItems?: ReadonlyArray<{ readonly __typename?: 'PayrollLineItem', readonly id: string, readonly kind: string, readonly hours?: number | null, readonly rate?: number | null, readonly netAmount: number, readonly order: number, readonly groupType: PayrollLineItemGroup, readonly humanizedLabel: string }> | null } };

export type PayrollShiftDetailsQueryVariables = Exact<{
  payrollId: Scalars['String']['input'];
}>;


export type PayrollShiftDetailsQuery = { readonly __typename?: 'Query', readonly payrollShiftDetails: { readonly __typename?: 'PayrollShiftDetails', readonly id: string, readonly externalNotes?: string | null, readonly shifts?: ReadonlyArray<{ readonly __typename?: 'Shift', readonly id: string, readonly duration: number, readonly startSec?: number | null, readonly timezone: string, readonly timeEntries?: ReadonlyArray<{ readonly __typename?: 'TimeEntry', readonly id: string, readonly entryType?: string | null, readonly archived?: boolean | null, readonly startSec?: number | null, readonly endSec?: number | null, readonly timezone?: string | null, readonly timeType: TimeEntryTime, readonly duration?: number | null }> | null }> | null } };

export type PayPreviewDetailPageViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type PayPreviewDetailPageViewerQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly firstName?: string | null } | null };

export type PayPreviewListPagePayrollFragment = { readonly __typename?: 'Payroll', readonly id: string, readonly periodStart: GraphQLISO8601Date, readonly periodEnd: GraphQLISO8601Date };

export type PayPreviewListPageQueryVariables = Exact<{
  showAllHistory?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PayPreviewListPageQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string } | null, readonly payrollItems?: ReadonlyArray<{ readonly __typename?: 'Payroll', readonly id: string, readonly periodStart: GraphQLISO8601Date, readonly periodEnd: GraphQLISO8601Date, readonly businessName?: string | null, readonly contract?: { readonly __typename?: 'Contract', readonly id: string, readonly contractStartDate: GraphQLISO8601Date, readonly contractEndDate: GraphQLISO8601Date } | null }> | null };

export type PopularCitiesContainerQueryVariables = Exact<{
  loggedIn: Scalars['Boolean']['input'];
}>;


export type PopularCitiesContainerQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly yearsOfExp?: number | null, readonly canViewJobs: boolean, readonly nurseType?: string | null } | null } | null, readonly popularCitiesPay?: ReadonlyArray<{ readonly __typename?: 'PopularCityPay', readonly id: string, readonly city: string, readonly stateCode: string, readonly travelWeeklyIncome?: number | null, readonly staffHourlyIncome?: number | null }> | null, readonly popularCitiesCostOfLiving?: ReadonlyArray<{ readonly __typename?: 'PopularCityCostOfLiving', readonly id: string, readonly city: string, readonly stateCode: string, readonly avgRent?: number | null }> | null };

export type ProfilePageV2UserFragment = { readonly __typename?: 'User', readonly id: string, readonly profilePic?: string | null, readonly firstName?: string | null, readonly preferredName?: string | null, readonly middleName?: string | null, readonly lastName?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly state?: string | null, readonly applicationSummary?: string | null, readonly nurseAdvocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly phone?: string | null, readonly firstName?: string | null, readonly lastName?: string | null, readonly profileImgUrl: string, readonly isNurseAdvocate?: boolean | null, readonly isAlliedAdvocate?: boolean | null, readonly clinicalRole?: string | null } | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly type?: RoleType | null, readonly name: string } | null, readonly primarySpecialty?: { readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly fullName?: string | null } | null } | null };

export type ProfilePageV2QueryVariables = Exact<{ [key: string]: never; }>;


export type ProfilePageV2Query = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly profilePic?: string | null, readonly firstName?: string | null, readonly preferredName?: string | null, readonly middleName?: string | null, readonly lastName?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly state?: string | null, readonly applicationSummary?: string | null, readonly nurseAdvocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly phone?: string | null, readonly firstName?: string | null, readonly lastName?: string | null, readonly profileImgUrl: string, readonly isNurseAdvocate?: boolean | null, readonly isAlliedAdvocate?: boolean | null, readonly clinicalRole?: string | null } | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly type?: RoleType | null, readonly name: string } | null, readonly primarySpecialty?: { readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly fullName?: string | null } | null } | null } | null, readonly profileCompletionSummary: { readonly __typename?: 'ProfileCompletionSummary', readonly id: string, readonly completedAt?: GraphQLISO8601DateTime | null, readonly meta: { readonly __typename?: 'ProfileMeta', readonly id: string, readonly completeCount: number, readonly expiredCount: number, readonly expiringCount: number, readonly incompleteCount: number, readonly pendingCount: number, readonly percentCompleted: number }, readonly steps: ReadonlyArray<{ readonly __typename?: 'ProfileStep', readonly estimatedTimeInMinutes?: number | null, readonly key: ProfileStepsEnum, readonly title?: string | null, readonly subtitle?: string | null, readonly messages?: ReadonlyArray<string> | null, readonly sectionName: string, readonly status: ProfileStatusEnum, readonly hasExpiringItems: boolean, readonly hasExpiredItems: boolean, readonly hasInvalidItems: boolean }> } };

export type AboutMePanelNurseProfileFragment = { readonly __typename?: 'NurseProfile', readonly id: string, readonly yearsOfExp?: number | null, readonly yearsOfTravelExp?: number | null, readonly birthday?: GraphQLISO8601Date | null, readonly ssnLast4?: string | null, readonly fullSsnCollected: boolean, readonly state?: string | null, readonly phoneVerified: boolean, readonly role?: { readonly __typename?: 'Role', readonly id: string } | null, readonly primarySpecialty?: { readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly slug: string, readonly fullName?: string | null } | null };

export type AboutMePanelUserFragment = { readonly __typename?: 'User', readonly id: string, readonly profilePic?: string | null, readonly firstName?: string | null, readonly middleName?: string | null, readonly lastName?: string | null, readonly preferredName?: string | null, readonly preferredPronoun?: string | null, readonly phone?: string | null, readonly phoneVerified: boolean, readonly streetAddressPermanent?: string | null, readonly streetNumberPermanent?: string | null, readonly cityPermanent?: string | null, readonly statePermanent?: string | null, readonly zipcodePermanent?: string | null, readonly countryPermanentName?: string | null, readonly countryPermanentCode?: string | null, readonly googlePlaceIdPermanent?: string | null };

export type AboutMeUpdateMutationVariables = Exact<{
  input: UpdateAboutMeInput;
}>;


export type AboutMeUpdateMutation = { readonly __typename?: 'Mutation', readonly updateAboutMe?: { readonly __typename?: 'UpdateAboutMePayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly yearsOfExp?: number | null, readonly yearsOfTravelExp?: number | null, readonly birthday?: GraphQLISO8601Date | null, readonly ssnLast4?: string | null, readonly fullSsnCollected: boolean, readonly state?: string | null, readonly phoneVerified: boolean, readonly role?: { readonly __typename?: 'Role', readonly id: string } | null, readonly primarySpecialty?: { readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly slug: string, readonly fullName?: string | null } | null }, readonly user: { readonly __typename?: 'User', readonly id: string, readonly profilePic?: string | null, readonly firstName?: string | null, readonly middleName?: string | null, readonly lastName?: string | null, readonly preferredName?: string | null, readonly preferredPronoun?: string | null, readonly phone?: string | null, readonly phoneVerified: boolean, readonly streetAddressPermanent?: string | null, readonly streetNumberPermanent?: string | null, readonly cityPermanent?: string | null, readonly statePermanent?: string | null, readonly zipcodePermanent?: string | null, readonly countryPermanentName?: string | null, readonly countryPermanentCode?: string | null, readonly googlePlaceIdPermanent?: string | null }, readonly profileCompletionSummary: { readonly __typename?: 'ProfileCompletionSummary', readonly id: string, readonly completedAt?: GraphQLISO8601DateTime | null, readonly meta: { readonly __typename?: 'ProfileMeta', readonly id: string, readonly completeCount: number, readonly expiredCount: number, readonly expiringCount: number, readonly incompleteCount: number, readonly pendingCount: number, readonly percentCompleted: number }, readonly steps: ReadonlyArray<{ readonly __typename?: 'ProfileStep', readonly estimatedTimeInMinutes?: number | null, readonly key: ProfileStepsEnum, readonly title?: string | null, readonly subtitle?: string | null, readonly messages?: ReadonlyArray<string> | null, readonly sectionName: string, readonly status: ProfileStatusEnum, readonly hasExpiringItems: boolean, readonly hasExpiredItems: boolean, readonly hasInvalidItems: boolean }> } } | null };

export type AboutMePanelQueryVariables = Exact<{ [key: string]: never; }>;


export type AboutMePanelQuery = { readonly __typename?: 'Query', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly yearsOfExp?: number | null, readonly yearsOfTravelExp?: number | null, readonly birthday?: GraphQLISO8601Date | null, readonly ssnLast4?: string | null, readonly fullSsnCollected: boolean, readonly state?: string | null, readonly phoneVerified: boolean, readonly role?: { readonly __typename?: 'Role', readonly id: string } | null, readonly primarySpecialty?: { readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly slug: string, readonly fullName?: string | null } | null } | null, readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly profilePic?: string | null, readonly firstName?: string | null, readonly middleName?: string | null, readonly lastName?: string | null, readonly preferredName?: string | null, readonly preferredPronoun?: string | null, readonly phone?: string | null, readonly phoneVerified: boolean, readonly streetAddressPermanent?: string | null, readonly streetNumberPermanent?: string | null, readonly cityPermanent?: string | null, readonly statePermanent?: string | null, readonly zipcodePermanent?: string | null, readonly countryPermanentName?: string | null, readonly countryPermanentCode?: string | null, readonly googlePlaceIdPermanent?: string | null } | null };

export type ReferralsQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReferralsQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly referrals?: { readonly __typename?: 'ReferralResponse', readonly totalCount: number, readonly users: ReadonlyArray<{ readonly __typename?: 'Referral', readonly firstName: string, readonly lastName: string, readonly status: string, readonly statusDate: GraphQLISO8601Date }> } | null } | null };

export type ResetPasswordMutationVariables = Exact<{
  input: SendUserResetPasswordInstructionsInput;
}>;


export type ResetPasswordMutation = { readonly __typename?: 'Mutation', readonly sendUserResetPasswordInstructions?: { readonly __typename?: 'SendUserResetPasswordInstructionsPayload', readonly success: boolean } | null };

export type ParsedAboutMeUserInfoFragment = { readonly __typename?: 'PersonalInformation', readonly dateOfBirth?: GraphQLISO8601Date | null, readonly firstName?: string | null, readonly lastName?: string | null, readonly middleName?: string | null };

export type ParsedAboutMeUserAddressFragment = { readonly __typename?: 'PermanentAddress', readonly city?: string | null, readonly state?: string | null, readonly country?: string | null, readonly streetAddress?: string | null, readonly zipcode?: string | null };

export type ResumeParserUploadResumeMutationVariables = Exact<{
  upload: FileUploadTypeInput;
}>;


export type ResumeParserUploadResumeMutation = { readonly __typename?: 'Mutation', readonly uploadResume?: { readonly __typename?: 'UploadResumePayload', readonly uploadedResume: { readonly __typename?: 'UploadedResume', readonly id: string, readonly resumeParserStep?: string | null } } | null };

export type ResumeParserHideSuggestionMutationVariables = Exact<{
  parserId: Scalars['String']['input'];
}>;


export type ResumeParserHideSuggestionMutation = { readonly __typename?: 'Mutation', readonly hideSuggestion?: { readonly __typename?: 'HideSuggestionPayload', readonly uploadedResume: { readonly __typename?: 'UploadedResume', readonly id: string, readonly hiddenSuggestions?: ReadonlyArray<string> | null } } | null };

export type ResumeParserPageQueryVariables = Exact<{ [key: string]: never; }>;


export type ResumeParserPageQuery = { readonly __typename?: 'Query', readonly uploadedResume?: { readonly __typename?: 'UploadedResume', readonly id: string, readonly status: ParsingStatusEnum } | null };

export type ResumeParserItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type ResumeParserItemsQuery = { readonly __typename?: 'Query', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly permanentAddress: { readonly __typename?: 'ProfileCompletionStep', readonly status: ProfileCompletionStatusEnum }, readonly personalInfo: { readonly __typename?: 'ProfileCompletionStep', readonly status: ProfileCompletionStatusEnum } } } | null, readonly positions?: ReadonlyArray<{ readonly __typename?: 'Position', readonly id: string, readonly usableForReferences: boolean }> | null } | null, readonly parsedPersonalInformation?: { readonly __typename?: 'PersonalInformation', readonly firstName?: string | null, readonly lastName?: string | null, readonly middleName?: string | null, readonly dateOfBirth?: GraphQLISO8601Date | null } | null, readonly parsedWorkExperiences?: ReadonlyArray<{ readonly __typename?: 'WorkExperienceSuggestion', readonly parserId?: string | null }> | null, readonly parsedReferences: ReadonlyArray<{ readonly __typename?: 'ReferenceSuggestion', readonly parserId?: string | null }>, readonly parsedEducations: ReadonlyArray<{ readonly __typename?: 'EducationSuggestion', readonly parserId?: string | null }> };

export type ParsedAboutMePanelQueryVariables = Exact<{ [key: string]: never; }>;


export type ParsedAboutMePanelQuery = { readonly __typename?: 'Query', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly yearsOfExp?: number | null, readonly yearsOfTravelExp?: number | null, readonly birthday?: GraphQLISO8601Date | null, readonly ssnLast4?: string | null, readonly fullSsnCollected: boolean, readonly state?: string | null, readonly phoneVerified: boolean, readonly role?: { readonly __typename?: 'Role', readonly id: string } | null, readonly primarySpecialty?: { readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly slug: string, readonly fullName?: string | null } | null } | null, readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly profilePic?: string | null, readonly firstName?: string | null, readonly middleName?: string | null, readonly lastName?: string | null, readonly preferredName?: string | null, readonly preferredPronoun?: string | null, readonly phone?: string | null, readonly phoneVerified: boolean, readonly streetAddressPermanent?: string | null, readonly streetNumberPermanent?: string | null, readonly cityPermanent?: string | null, readonly statePermanent?: string | null, readonly zipcodePermanent?: string | null, readonly countryPermanentName?: string | null, readonly countryPermanentCode?: string | null, readonly googlePlaceIdPermanent?: string | null } | null, readonly parsedPersonalInformation?: { readonly __typename?: 'PersonalInformation', readonly dateOfBirth?: GraphQLISO8601Date | null, readonly firstName?: string | null, readonly lastName?: string | null, readonly middleName?: string | null } | null, readonly parsedPermanentAddress?: { readonly __typename?: 'PermanentAddress', readonly city?: string | null, readonly state?: string | null, readonly country?: string | null, readonly streetAddress?: string | null, readonly zipcode?: string | null } | null };

export type ResumePreviewExperiencedNurseQueryVariables = Exact<{ [key: string]: never; }>;


export type ResumePreviewExperiencedNurseQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly phone?: string | null, readonly email: string, readonly streetAddressPermanent?: string | null, readonly cityPermanent?: string | null, readonly statePermanent?: string | null, readonly zipcodePermanent?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly professionalTitles?: ReadonlyArray<string> | null, readonly applicationSummary?: string | null, readonly locationAddress?: string | null, readonly gapBetweenEducationAndEmploymentPosition: boolean, readonly sortedExperienceItems?: ReadonlyArray<{ readonly __typename?: 'Employment' } | { readonly __typename?: 'Gap', readonly gapId: string, readonly gapEndAt: GraphQLISO8601Date, readonly gapExplanation?: string | null, readonly gapIsEducationGap?: boolean | null, readonly gapLocationAddress?: string | null, readonly gapReason?: string | null, readonly gapStartAt: GraphQLISO8601Date } | { readonly __typename?: 'Position', readonly id: string, readonly title: string, readonly classification?: EmploymentTypes | null, readonly additionalSkills?: string | null, readonly startAt?: GraphQLISO8601Date | null, readonly endAt?: GraphQLISO8601Date | null, readonly floatFrequency?: PositionFloatFrequency | null, readonly hoursWorked?: number | null, readonly hoursWorkedText?: string | null, readonly hoursWorkedTimeframe?: HoursWorkedTimeframe | null, readonly leadExperience?: boolean | null, readonly chargeExperience?: boolean | null, readonly preceptorExperience?: boolean | null, readonly unitBedCount?: number | null, readonly hospitalBedCount?: number | null, readonly magnet: boolean, readonly teaching: boolean, readonly traumaLevel?: number | null, readonly patientRatio?: number | null, readonly nicuCareLevels?: ReadonlyArray<number> | null, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null } | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly name: string } | null, readonly floatUnits?: ReadonlyArray<{ readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string }> | null, readonly agency?: { readonly __typename?: 'Agency', readonly id: string, readonly name: string } | null, readonly specialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string }> | null, readonly technologies?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null }> | null, readonly studentClinicalExperiences?: ReadonlyArray<{ readonly __typename?: 'StudentClinicalExperience', readonly id: string, readonly facilityName: string, readonly locationAddress?: string | null, readonly experienceYear: number, readonly experienceYearTerm: YearTerms, readonly experienceType: StudentExperienceTypes, readonly studentClinicalExperienceUnits?: ReadonlyArray<{ readonly __typename?: 'StudentClinicalExperienceUnit', readonly id: string, readonly name: string, readonly hoursWorked: number, readonly descriptions: ReadonlyArray<string> }> | null }> | null, readonly educations?: ReadonlyArray<{ readonly __typename?: 'Education', readonly id: string, readonly locationAddress?: string | null, readonly startedOn?: GraphQLISO8601Date | null, readonly graduatedOn: GraphQLISO8601Date, readonly schoolName: string, readonly degree: string, readonly hasGap?: boolean | null, readonly gapStartOn?: GraphQLISO8601Date | null, readonly gapEndOn?: GraphQLISO8601Date | null, readonly gapReason?: string | null, readonly gapExplanation?: string | null, readonly descriptions: ReadonlyArray<string>, readonly gapLocation?: { readonly __typename?: 'Location', readonly id: string, readonly address?: string | null } | null }> | null, readonly awards?: ReadonlyArray<{ readonly __typename?: 'Award', readonly id: string, readonly awardedOn?: GraphQLISO8601Date | null, readonly name: string, readonly organization: string, readonly descriptions: ReadonlyArray<string> }> | null, readonly researches?: ReadonlyArray<{ readonly __typename?: 'Research', readonly id: string, readonly startOn: GraphQLISO8601Date, readonly endOn?: GraphQLISO8601Date | null, readonly orgName: string, readonly descriptions: ReadonlyArray<string>, readonly locationAddress?: string | null }> | null, readonly affiliationHistory: ReadonlyArray<{ readonly __typename?: 'AffiliationHistory', readonly id: string, readonly organizationName: string, readonly startDate: GraphQLISO8601Date, readonly endDate?: GraphQLISO8601Date | null, readonly role?: string | null, readonly descriptions: ReadonlyArray<string> }>, readonly languages?: ReadonlyArray<{ readonly __typename?: 'Language', readonly id: string, readonly language: string, readonly proficiency: string }> | null, readonly licenses?: ReadonlyArray<{ readonly __typename?: 'License', readonly id: string, readonly expiresOn?: GraphQLISO8601Date | null, readonly state?: string | null, readonly friendlyLicenseType?: string | null, readonly number?: string | null, readonly compact?: boolean | null }> | null, readonly nurseCertifications?: ReadonlyArray<{ readonly __typename?: 'NurseCertification', readonly id: string, readonly expiresOn?: GraphQLISO8601Date | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly name?: string | null, readonly issuingBody?: string | null } }> | null } | null } | null };

export type UpdatePasswordPageResetUserPasswordMutationVariables = Exact<{
  input: ResetUserPasswordInput;
}>;


export type UpdatePasswordPageResetUserPasswordMutation = { readonly __typename?: 'Mutation', readonly resetUserPassword?: { readonly __typename?: 'ResetUserPasswordPayload', readonly token: string, readonly user: { readonly __typename?: 'User', readonly id: string } } | null };

export type WebChatDataQueryVariables = Exact<{ [key: string]: never; }>;


export type WebChatDataQuery = { readonly __typename?: 'Query', readonly sunshineUnreadCount: number, readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly sunshineToken?: string | null } | null };

export type UserCreationStepSignupMutationVariables = Exact<{
  input: SignUpInput;
}>;


export type UserCreationStepSignupMutation = { readonly __typename?: 'Mutation', readonly signUp?: { readonly __typename?: 'SignUpPayload', readonly token: string, readonly user: { readonly __typename?: 'User', readonly id: string, readonly firstName?: string | null, readonly preferredName?: string | null, readonly lastName?: string | null, readonly email: string, readonly intercomUserHash?: string | null, readonly signupSource?: SignupTypes | null, readonly signupSourceQualifier?: SignupSourceQualifiers | null, readonly createdAt: GraphQLISO8601DateTime } } | null };

export type CreateClinicianProfileMutationVariables = Exact<{
  roleId: Scalars['ID']['input'];
  nurseType?: InputMaybe<NurseTypes>;
}>;


export type CreateClinicianProfileMutation = { readonly __typename?: 'Mutation', readonly createClinicianProfile?: { readonly __typename?: 'CreateClinicianProfilePayload', readonly user?: { readonly __typename?: 'User', readonly id: string } | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string } | null } | null };

export type UpdateNurseRoleMutationVariables = Exact<{
  roleId: Scalars['ID']['input'];
}>;


export type UpdateNurseRoleMutation = { readonly __typename?: 'Mutation', readonly updateNurseRole?: { readonly __typename?: 'UpdateNurseRolePayload', readonly user: { readonly __typename?: 'User', readonly id: string, readonly signupSource?: SignupTypes | null, readonly profilePic?: string | null, readonly firstName?: string | null, readonly middleName?: string | null, readonly lastName?: string | null, readonly preferredName?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly canViewJobs: boolean, readonly locationAddress?: string | null, readonly hasBeenPlaced: boolean, readonly roleAbbreviation?: string | null, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly startPref?: string | null } | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly key?: string | null, readonly name: string, readonly type?: RoleType | null } | null, readonly primarySpecialty?: { readonly __typename?: 'ClinicalSpecialty', readonly displayName: string, readonly id: string, readonly fullName?: string | null, readonly slug: string } | null, readonly currentEmployment?: { readonly __typename?: 'Employment', readonly id: string, readonly locationAddress?: string | null } | null, readonly educations?: ReadonlyArray<{ readonly __typename?: 'Education', readonly id: string, readonly locationAddress?: string | null }> | null } | null } } | null };

export type ClinicianLanguagesFragment = { readonly __typename?: 'Language', readonly id: string, readonly language: string, readonly proficiency: string };

export type LanguageNurseProfileUpdateCacheFragment = { readonly __typename?: 'NurseProfile', readonly id: string, readonly languages?: ReadonlyArray<{ readonly __typename?: 'Language', readonly id: string, readonly language: string, readonly proficiency: string }> | null };

export type UpsertClinicianLanguageMutationVariables = Exact<{
  input: UpsertClinicianLanguageInput;
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpsertClinicianLanguageMutation = { readonly __typename?: 'Mutation', readonly upsertClinicianLanguage?: { readonly __typename?: 'UpsertLanguagePayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly languages?: ReadonlyArray<{ readonly __typename?: 'Language', readonly id: string, readonly language: string, readonly proficiency: string }> | null } } | null };

export type DeleteClinicianLanguageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteClinicianLanguageMutation = { readonly __typename?: 'Mutation', readonly deleteClinicianLanguage?: { readonly __typename?: 'DeleteLanguagePayload', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly languages?: ReadonlyArray<{ readonly __typename?: 'Language', readonly id: string, readonly language: string, readonly proficiency: string }> | null } | null } | null };

export type ClinicianLanguageListQueryVariables = Exact<{ [key: string]: never; }>;


export type ClinicianLanguageListQuery = { readonly __typename?: 'Query', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly languages?: ReadonlyArray<{ readonly __typename?: 'Language', readonly id: string, readonly language: string, readonly proficiency: string }> | null } | null };

export type UpsertClinicianLanguageFormDataQueryVariables = Exact<{ [key: string]: never; }>;


export type UpsertClinicianLanguageFormDataQuery = { readonly __typename?: 'Query', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly languages?: ReadonlyArray<{ readonly __typename?: 'Language', readonly id: string, readonly language: string, readonly proficiency: string }> | null } | null, readonly languageType?: { readonly __typename?: '__Type', readonly name?: string | null, readonly enumValues?: ReadonlyArray<{ readonly __typename?: '__EnumValue', readonly name: string, readonly description?: string | null }> | null } | null, readonly languageProficiencyType?: { readonly __typename?: '__Type', readonly name?: string | null, readonly enumValues?: ReadonlyArray<{ readonly __typename?: '__EnumValue', readonly name: string, readonly description?: string | null }> | null } | null };

export type ReferenceResponseReferenceDetailsFragment = { readonly __typename?: 'Reference', readonly id: string, readonly name?: string | null, readonly candidateName?: string | null, readonly employmentOther?: string | null, readonly jobTitle?: string | null, readonly relationship?: string | null, readonly responseAt?: GraphQLISO8601Date | null, readonly unit?: string | null };

export type SubmitReferenceResponseMutationVariables = Exact<{
  chargeDuties: Scalars['String']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  employmentDateComments?: InputMaybe<Scalars['String']['input']>;
  employmentDateConfirmation: Scalars['Boolean']['input'];
  employmentOther: Scalars['String']['input'];
  jobTitle: Scalars['String']['input'];
  ratingCare: Scalars['String']['input'];
  ratingDocumentation: Scalars['String']['input'];
  ratingFlexible: Scalars['String']['input'];
  ratingPatientCommunication: Scalars['String']['input'];
  ratingPolicies: Scalars['String']['input'];
  ratingProfessional: Scalars['String']['input'];
  ratingPunctual: Scalars['String']['input'];
  ratingStaffCommunication: Scalars['String']['input'];
  relationship: Scalars['String']['input'];
  responseToken: Scalars['String']['input'];
  signedName: Scalars['String']['input'];
  unit: Scalars['String']['input'];
  wouldRehire: Scalars['Boolean']['input'];
}>;


export type SubmitReferenceResponseMutation = { readonly __typename?: 'Mutation', readonly submitReferenceResponse?: { readonly __typename?: 'Reference', readonly id: string } | null };

export type ReferenceResponsePageQueryVariables = Exact<{
  responseToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReferenceResponsePageQuery = { readonly __typename?: 'Query', readonly reference?: { readonly __typename?: 'Reference', readonly id: string, readonly name?: string | null, readonly candidateName?: string | null, readonly employmentOther?: string | null, readonly jobTitle?: string | null, readonly relationship?: string | null, readonly responseAt?: GraphQLISO8601Date | null, readonly unit?: string | null } | null };

export type ReferenceNurseProfileUpdateCacheFragment = { readonly __typename?: 'NurseProfile', readonly id: string, readonly canApplyJobs: boolean, readonly numActiveReferences: number, readonly referencesComplete: boolean, readonly references?: ReadonlyArray<{ readonly __typename?: 'Reference', readonly id: string, readonly bedCount?: number | null, readonly chargeExp?: boolean | null, readonly email?: string | null, readonly expired: boolean, readonly facilityName?: string | null, readonly isLocked: boolean, readonly jobTitle?: string | null, readonly lastFailedDelivery?: GraphQLISO8601Date | null, readonly name?: string | null, readonly patientsPerNurse?: number | null, readonly phone?: string | null, readonly preferredContactMethod?: string | null, readonly relationship?: string | null, readonly responseAt?: GraphQLISO8601Date | null, readonly signedName?: string | null, readonly unit?: string | null, readonly unitName?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null, readonly position?: { readonly __typename?: 'Position', readonly id: string, readonly startAt?: GraphQLISO8601Date | null, readonly endAt?: GraphQLISO8601Date | null, readonly title: string, readonly usableForReferences: boolean, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly formattedLocationString?: string | null, readonly googlePlaceId?: string | null } | null } | null } | null }> | null, readonly positions?: ReadonlyArray<{ readonly __typename?: 'Position', readonly id: string, readonly startAt?: GraphQLISO8601Date | null, readonly endAt?: GraphQLISO8601Date | null, readonly usableForReferences: boolean, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly formattedLocationString?: string | null, readonly googlePlaceId?: string | null } | null } | null }> | null, readonly licenses?: ReadonlyArray<{ readonly __typename?: 'License', readonly id: string }> | null, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly meta: { readonly __typename?: 'ApplicationReadinessResultsMeta', readonly requirements: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly status: ApplicationReadinessStatus } }, readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly references: { readonly __typename?: 'ApplicationReadinessReferencesResult', readonly label: string, readonly status: ApplicationReadinessStatus, readonly completeReferenceCount: number, readonly pendingReferenceCount: number } } }, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly references: { readonly __typename?: 'ProfileCompletionStep', readonly status: ProfileCompletionStatusEnum } } } | null };

export type ReferenceDetailsFragment = { readonly __typename?: 'Reference', readonly id: string, readonly bedCount?: number | null, readonly chargeExp?: boolean | null, readonly email?: string | null, readonly expired: boolean, readonly facilityName?: string | null, readonly isLocked: boolean, readonly jobTitle?: string | null, readonly lastFailedDelivery?: GraphQLISO8601Date | null, readonly name?: string | null, readonly patientsPerNurse?: number | null, readonly phone?: string | null, readonly preferredContactMethod?: string | null, readonly relationship?: string | null, readonly responseAt?: GraphQLISO8601Date | null, readonly signedName?: string | null, readonly unit?: string | null, readonly unitName?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null, readonly position?: { readonly __typename?: 'Position', readonly id: string, readonly startAt?: GraphQLISO8601Date | null, readonly endAt?: GraphQLISO8601Date | null, readonly title: string, readonly usableForReferences: boolean, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly formattedLocationString?: string | null, readonly googlePlaceId?: string | null } | null } | null } | null };

export type ReferencesItemFragment = { readonly __typename?: 'Reference', readonly id: string, readonly belowExpectations?: boolean | null, readonly canEdit?: boolean | null, readonly chargeExp?: boolean | null, readonly email?: string | null, readonly employmentOther?: string | null, readonly expired: boolean, readonly isExpiringSoon?: boolean | null, readonly isLocked: boolean, readonly jobTitle?: string | null, readonly lastFailedDelivery?: GraphQLISO8601Date | null, readonly name?: string | null, readonly phone?: string | null, readonly preferredContactMethod?: string | null, readonly referenceFormSentAt?: GraphQLISO8601Date | null, readonly relationship?: string | null, readonly responseAt?: GraphQLISO8601Date | null, readonly signedName?: string | null, readonly unit?: string | null, readonly wouldRehire?: boolean | null, readonly position?: { readonly __typename?: 'Position', readonly id: string, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string } | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null };

export type ReferenceDetailsPositionFragment = { readonly __typename?: 'Position', readonly id: string, readonly startAt?: GraphQLISO8601Date | null, readonly endAt?: GraphQLISO8601Date | null, readonly title: string, readonly usableForReferences: boolean, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly formattedLocationString?: string | null, readonly googlePlaceId?: string | null } | null } | null };

export type ResumeParserReferenceSuggestionsFragment = { readonly __typename?: 'ReferenceSuggestion', readonly email?: string | null, readonly jobTitle?: string | null, readonly mobileNumber?: string | null, readonly name?: string | null, readonly parserId?: string | null, readonly preferredContactMethod?: string | null, readonly text?: string | null };

export type UpsertReferenceMutationVariables = Exact<{
  input: UpsertReferenceInput;
  parserId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertReferenceMutation = { readonly __typename?: 'Mutation', readonly upsertReference?: { readonly __typename?: 'UpsertReferencePayload', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly canApplyJobs: boolean, readonly numActiveReferences: number, readonly referencesComplete: boolean, readonly references?: ReadonlyArray<{ readonly __typename?: 'Reference', readonly id: string, readonly bedCount?: number | null, readonly chargeExp?: boolean | null, readonly email?: string | null, readonly expired: boolean, readonly facilityName?: string | null, readonly isLocked: boolean, readonly jobTitle?: string | null, readonly lastFailedDelivery?: GraphQLISO8601Date | null, readonly name?: string | null, readonly patientsPerNurse?: number | null, readonly phone?: string | null, readonly preferredContactMethod?: string | null, readonly relationship?: string | null, readonly responseAt?: GraphQLISO8601Date | null, readonly signedName?: string | null, readonly unit?: string | null, readonly unitName?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null, readonly position?: { readonly __typename?: 'Position', readonly id: string, readonly startAt?: GraphQLISO8601Date | null, readonly endAt?: GraphQLISO8601Date | null, readonly title: string, readonly usableForReferences: boolean, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly formattedLocationString?: string | null, readonly googlePlaceId?: string | null } | null } | null } | null }> | null, readonly positions?: ReadonlyArray<{ readonly __typename?: 'Position', readonly id: string, readonly startAt?: GraphQLISO8601Date | null, readonly endAt?: GraphQLISO8601Date | null, readonly usableForReferences: boolean, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly formattedLocationString?: string | null, readonly googlePlaceId?: string | null } | null } | null }> | null, readonly licenses?: ReadonlyArray<{ readonly __typename?: 'License', readonly id: string }> | null, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly meta: { readonly __typename?: 'ApplicationReadinessResultsMeta', readonly requirements: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly status: ApplicationReadinessStatus } }, readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly references: { readonly __typename?: 'ApplicationReadinessReferencesResult', readonly label: string, readonly status: ApplicationReadinessStatus, readonly completeReferenceCount: number, readonly pendingReferenceCount: number } } }, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly references: { readonly __typename?: 'ProfileCompletionStep', readonly status: ProfileCompletionStatusEnum } } } | null } | null } | null };

export type RemoveReferenceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveReferenceMutation = { readonly __typename?: 'Mutation', readonly removeReference?: { readonly __typename?: 'RemoveReferencePayload', readonly error?: string | null, readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly canApplyJobs: boolean, readonly numActiveReferences: number, readonly referencesComplete: boolean, readonly references?: ReadonlyArray<{ readonly __typename?: 'Reference', readonly id: string, readonly bedCount?: number | null, readonly chargeExp?: boolean | null, readonly email?: string | null, readonly expired: boolean, readonly facilityName?: string | null, readonly isLocked: boolean, readonly jobTitle?: string | null, readonly lastFailedDelivery?: GraphQLISO8601Date | null, readonly name?: string | null, readonly patientsPerNurse?: number | null, readonly phone?: string | null, readonly preferredContactMethod?: string | null, readonly relationship?: string | null, readonly responseAt?: GraphQLISO8601Date | null, readonly signedName?: string | null, readonly unit?: string | null, readonly unitName?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null, readonly position?: { readonly __typename?: 'Position', readonly id: string, readonly startAt?: GraphQLISO8601Date | null, readonly endAt?: GraphQLISO8601Date | null, readonly title: string, readonly usableForReferences: boolean, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly formattedLocationString?: string | null, readonly googlePlaceId?: string | null } | null } | null } | null }> | null, readonly positions?: ReadonlyArray<{ readonly __typename?: 'Position', readonly id: string, readonly startAt?: GraphQLISO8601Date | null, readonly endAt?: GraphQLISO8601Date | null, readonly usableForReferences: boolean, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly formattedLocationString?: string | null, readonly googlePlaceId?: string | null } | null } | null }> | null, readonly licenses?: ReadonlyArray<{ readonly __typename?: 'License', readonly id: string }> | null, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly meta: { readonly __typename?: 'ApplicationReadinessResultsMeta', readonly requirements: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly status: ApplicationReadinessStatus } }, readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly references: { readonly __typename?: 'ApplicationReadinessReferencesResult', readonly label: string, readonly status: ApplicationReadinessStatus, readonly completeReferenceCount: number, readonly pendingReferenceCount: number } } }, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly references: { readonly __typename?: 'ProfileCompletionStep', readonly status: ProfileCompletionStatusEnum } } } | null } } | null };

export type ReferenceListQueryVariables = Exact<{ [key: string]: never; }>;


export type ReferenceListQuery = { readonly __typename?: 'Query', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly state?: string | null, readonly name?: string | null, readonly references?: ReadonlyArray<{ readonly __typename?: 'Reference', readonly id: string, readonly belowExpectations?: boolean | null, readonly canEdit?: boolean | null, readonly chargeExp?: boolean | null, readonly email?: string | null, readonly employmentOther?: string | null, readonly expired: boolean, readonly isExpiringSoon?: boolean | null, readonly isLocked: boolean, readonly jobTitle?: string | null, readonly lastFailedDelivery?: GraphQLISO8601Date | null, readonly name?: string | null, readonly phone?: string | null, readonly preferredContactMethod?: string | null, readonly referenceFormSentAt?: GraphQLISO8601Date | null, readonly relationship?: string | null, readonly responseAt?: GraphQLISO8601Date | null, readonly signedName?: string | null, readonly unit?: string | null, readonly wouldRehire?: boolean | null, readonly position?: { readonly __typename?: 'Position', readonly id: string, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string } | null } | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null } | null, readonly parsedReferences: ReadonlyArray<{ readonly __typename?: 'ReferenceSuggestion', readonly email?: string | null, readonly jobTitle?: string | null, readonly mobileNumber?: string | null, readonly name?: string | null, readonly parserId?: string | null, readonly preferredContactMethod?: string | null, readonly text?: string | null }> };

export type EditReferenceFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EditReferenceFormQuery = { readonly __typename?: 'Query', readonly reference?: { readonly __typename?: 'Reference', readonly id: string, readonly bedCount?: number | null, readonly chargeExp?: boolean | null, readonly email?: string | null, readonly expired: boolean, readonly facilityName?: string | null, readonly isLocked: boolean, readonly jobTitle?: string | null, readonly lastFailedDelivery?: GraphQLISO8601Date | null, readonly name?: string | null, readonly patientsPerNurse?: number | null, readonly phone?: string | null, readonly preferredContactMethod?: string | null, readonly relationship?: string | null, readonly responseAt?: GraphQLISO8601Date | null, readonly signedName?: string | null, readonly unit?: string | null, readonly unitName?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null, readonly position?: { readonly __typename?: 'Position', readonly id: string, readonly startAt?: GraphQLISO8601Date | null, readonly endAt?: GraphQLISO8601Date | null, readonly title: string, readonly usableForReferences: boolean, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly formattedLocationString?: string | null, readonly googlePlaceId?: string | null } | null } | null } | null } | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly positions?: ReadonlyArray<{ readonly __typename?: 'Position', readonly id: string, readonly startAt?: GraphQLISO8601Date | null, readonly endAt?: GraphQLISO8601Date | null, readonly title: string, readonly usableForReferences: boolean, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly formattedLocationString?: string | null, readonly googlePlaceId?: string | null } | null } | null }> | null } | null };

export type CreateReferenceFormQueryVariables = Exact<{ [key: string]: never; }>;


export type CreateReferenceFormQuery = { readonly __typename?: 'Query', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly positions?: ReadonlyArray<{ readonly __typename?: 'Position', readonly id: string, readonly startAt?: GraphQLISO8601Date | null, readonly endAt?: GraphQLISO8601Date | null, readonly title: string, readonly usableForReferences: boolean, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly formattedLocationString?: string | null, readonly googlePlaceId?: string | null } | null } | null }> | null } | null };

export type EditReferenceSuggestionFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EditReferenceSuggestionFormQuery = { readonly __typename?: 'Query', readonly parsedReference: { readonly __typename?: 'ReferenceSuggestion', readonly email?: string | null, readonly jobTitle?: string | null, readonly mobileNumber?: string | null, readonly name?: string | null, readonly parserId?: string | null, readonly preferredContactMethod?: string | null, readonly text?: string | null }, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly positions?: ReadonlyArray<{ readonly __typename?: 'Position', readonly id: string, readonly startAt?: GraphQLISO8601Date | null, readonly endAt?: GraphQLISO8601Date | null, readonly title: string, readonly usableForReferences: boolean, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly formattedLocationString?: string | null, readonly googlePlaceId?: string | null } | null } | null }> | null } | null };

export type WorkExperiencePanelPositionFragment = { readonly __typename?: 'Position', readonly id: string, readonly title: string, readonly positionType?: PositionTypes | null, readonly classification?: EmploymentTypes | null, readonly startAt?: GraphQLISO8601Date | null, readonly endAt?: GraphQLISO8601Date | null, readonly patientRatio?: number | null, readonly hoursWorked?: number | null, readonly hoursWorkedTimeframe?: HoursWorkedTimeframe | null, readonly traumaLevel?: number | null, readonly additionalSkills?: string | null, readonly chargeExperience?: boolean | null, readonly preceptorExperience?: boolean | null, readonly leadExperience?: boolean | null, readonly trauma?: boolean | null, readonly magnet: boolean, readonly teaching: boolean, readonly wouldWorkAgain?: boolean | null, readonly unitBedCount?: number | null, readonly floatFrequency?: PositionFloatFrequency | null, readonly friendlyEmploymentType?: string | null, readonly invalidOverlapByHours?: boolean | null, readonly invalidOverlapByLocation?: boolean | null, readonly pediatricTraumaLevel?: number | null, readonly nicuCareLevels?: ReadonlyArray<number> | null, readonly facilityBedCount?: number | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly name: string } | null, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly formattedLocationString?: string | null, readonly googlePlaceId?: string | null } | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly slug: string, readonly displayName: string } | null, readonly agency?: { readonly __typename?: 'Agency', readonly id: string, readonly name: string } | null, readonly specialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly fullName?: string | null, readonly nicu: boolean, readonly pediatric: boolean, readonly slug: string }> | null, readonly technologies?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null, readonly floatUnits?: ReadonlyArray<{ readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string }> | null };

export type PositionNurseProfileUpdateCacheFragment = { readonly __typename?: 'NurseProfile', readonly id: string, readonly canApplyJobs: boolean, readonly hasPositionsInvalidHoursOverlap: boolean, readonly hasPositionsLocationOverlap: boolean, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly licenses: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly label: string, readonly status: ApplicationReadinessStatus } } }, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly workExperience: { readonly __typename?: 'ProfileCompletionStep', readonly status: ProfileCompletionStatusEnum, readonly message?: string | null } }, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly incompleteCount: number, readonly expiredCount: number, readonly percentCompleted: number, readonly pendingCount: number } } | null, readonly positions?: ReadonlyArray<{ readonly __typename?: 'Position', readonly id: string, readonly title: string, readonly positionType?: PositionTypes | null, readonly classification?: EmploymentTypes | null, readonly startAt?: GraphQLISO8601Date | null, readonly endAt?: GraphQLISO8601Date | null, readonly patientRatio?: number | null, readonly hoursWorked?: number | null, readonly hoursWorkedTimeframe?: HoursWorkedTimeframe | null, readonly traumaLevel?: number | null, readonly additionalSkills?: string | null, readonly chargeExperience?: boolean | null, readonly preceptorExperience?: boolean | null, readonly leadExperience?: boolean | null, readonly trauma?: boolean | null, readonly magnet: boolean, readonly teaching: boolean, readonly wouldWorkAgain?: boolean | null, readonly unitBedCount?: number | null, readonly floatFrequency?: PositionFloatFrequency | null, readonly friendlyEmploymentType?: string | null, readonly invalidOverlapByHours?: boolean | null, readonly invalidOverlapByLocation?: boolean | null, readonly pediatricTraumaLevel?: number | null, readonly nicuCareLevels?: ReadonlyArray<number> | null, readonly facilityBedCount?: number | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly name: string } | null, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly formattedLocationString?: string | null, readonly googlePlaceId?: string | null } | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly slug: string, readonly displayName: string } | null, readonly agency?: { readonly __typename?: 'Agency', readonly id: string, readonly name: string } | null, readonly specialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly fullName?: string | null, readonly nicu: boolean, readonly pediatric: boolean, readonly slug: string }> | null, readonly technologies?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null, readonly floatUnits?: ReadonlyArray<{ readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string }> | null }> | null };

export type EducationGraduatedOnFragment = { readonly __typename?: 'Education', readonly id: string, readonly graduatedOn: GraphQLISO8601Date };

export type ResumeParserWorkExperienceSuggestionsFragment = { readonly __typename?: 'WorkExperienceSuggestion', readonly startAt?: GraphQLISO8601Date | null, readonly endAt?: GraphQLISO8601Date | null, readonly additionalSkills?: string | null, readonly facilityName?: string | null, readonly traumaLevel?: number | null, readonly trauma?: boolean | null, readonly magnet?: boolean | null, readonly teaching?: boolean | null, readonly parserId?: string | null, readonly positionType?: PositionTypes | null, readonly facilityBedCount?: number | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly name: string } | null, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly formattedLocationString?: string | null, readonly googlePlaceId?: string | null, readonly city?: string | null, readonly stateCode?: string | null } | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly slug: string, readonly displayName: string } | null, readonly specialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string }> | null, readonly technologies?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null };

export type WorkExperienceSectionNurseProfileFragment = { readonly __typename?: 'NurseProfile', readonly id: string, readonly computedYearsOfExp?: number | null, readonly computedYearsOfExpWithGaps: number, readonly computedDaysOfExpWithGaps: number, readonly gapBetweenEducationAndEmploymentPosition: boolean, readonly hasPositionsLocationOverlap: boolean, readonly hasPositionsInvalidHoursOverlap: boolean, readonly isYearsOfExpCompleted: boolean, readonly yearsOfExp?: number | null, readonly yearsOfTravelExp?: number | null, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly employment: { readonly __typename?: 'ApplicationReadinessEmploymentResult', readonly label: string, readonly status: ApplicationReadinessStatus } } }, readonly educations?: ReadonlyArray<{ readonly __typename?: 'Education', readonly id: string, readonly graduatedOn: GraphQLISO8601Date }> | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly workExperience: { readonly __typename?: 'ProfileCompletionStep', readonly status: ProfileCompletionStatusEnum, readonly message?: string | null } } } | null, readonly sortedExperienceItems?: ReadonlyArray<{ readonly __typename?: 'Employment' } | { readonly __typename?: 'Gap', readonly gapId: string, readonly gapEndAt: GraphQLISO8601Date, readonly gapExplanation?: string | null, readonly gapGooglePlaceId?: string | null, readonly gapIsEducationGap?: boolean | null, readonly gapLocationAddress?: string | null, readonly gapReason?: string | null, readonly gapStartAt: GraphQLISO8601Date } | { readonly __typename?: 'Position', readonly id: string, readonly title: string, readonly positionType?: PositionTypes | null, readonly startAt?: GraphQLISO8601Date | null, readonly endAt?: GraphQLISO8601Date | null, readonly humanReadableLength?: string | null, readonly hoursWorked?: number | null, readonly hoursWorkedTimeframe?: HoursWorkedTimeframe | null, readonly additionalSkills?: string | null, readonly chargeExperience?: boolean | null, readonly leadExperience?: boolean | null, readonly preceptorExperience?: boolean | null, readonly floatFrequency?: PositionFloatFrequency | null, readonly friendlyEmploymentType?: string | null, readonly invalidOverlapByHours?: boolean | null, readonly invalidOverlapByLocation?: boolean | null, readonly usableForReferences: boolean, readonly nicuCareLevels?: ReadonlyArray<number> | null, readonly activeReferences?: ReadonlyArray<{ readonly __typename?: 'Reference', readonly id: string, readonly name?: string | null, readonly relationship?: string | null, readonly responseAt?: GraphQLISO8601Date | null }> | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly name: string } | null, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null, readonly country?: string | null } | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly agency?: { readonly __typename?: 'Agency', readonly id: string, readonly name: string } | null, readonly technologies?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null, readonly specialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string }> | null, readonly floatUnits?: ReadonlyArray<{ readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string }> | null }> | null };

type WorkExperienceSectionExperienceItem_Employment_Fragment = { readonly __typename?: 'Employment' };

type WorkExperienceSectionExperienceItem_Gap_Fragment = { readonly __typename?: 'Gap', readonly gapId: string, readonly gapEndAt: GraphQLISO8601Date, readonly gapExplanation?: string | null, readonly gapGooglePlaceId?: string | null, readonly gapIsEducationGap?: boolean | null, readonly gapLocationAddress?: string | null, readonly gapReason?: string | null, readonly gapStartAt: GraphQLISO8601Date };

type WorkExperienceSectionExperienceItem_Position_Fragment = { readonly __typename?: 'Position', readonly id: string, readonly title: string, readonly positionType?: PositionTypes | null, readonly startAt?: GraphQLISO8601Date | null, readonly endAt?: GraphQLISO8601Date | null, readonly humanReadableLength?: string | null, readonly hoursWorked?: number | null, readonly hoursWorkedTimeframe?: HoursWorkedTimeframe | null, readonly additionalSkills?: string | null, readonly chargeExperience?: boolean | null, readonly leadExperience?: boolean | null, readonly preceptorExperience?: boolean | null, readonly floatFrequency?: PositionFloatFrequency | null, readonly friendlyEmploymentType?: string | null, readonly invalidOverlapByHours?: boolean | null, readonly invalidOverlapByLocation?: boolean | null, readonly usableForReferences: boolean, readonly nicuCareLevels?: ReadonlyArray<number> | null, readonly activeReferences?: ReadonlyArray<{ readonly __typename?: 'Reference', readonly id: string, readonly name?: string | null, readonly relationship?: string | null, readonly responseAt?: GraphQLISO8601Date | null }> | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly name: string } | null, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null, readonly country?: string | null } | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly agency?: { readonly __typename?: 'Agency', readonly id: string, readonly name: string } | null, readonly technologies?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null, readonly specialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string }> | null, readonly floatUnits?: ReadonlyArray<{ readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string }> | null };

export type WorkExperienceSectionExperienceItemFragment = WorkExperienceSectionExperienceItem_Employment_Fragment | WorkExperienceSectionExperienceItem_Gap_Fragment | WorkExperienceSectionExperienceItem_Position_Fragment;

export type WorkExperienceSectionPositionFragment = { readonly __typename?: 'Position', readonly id: string, readonly title: string, readonly positionType?: PositionTypes | null, readonly startAt?: GraphQLISO8601Date | null, readonly endAt?: GraphQLISO8601Date | null, readonly humanReadableLength?: string | null, readonly hoursWorked?: number | null, readonly hoursWorkedTimeframe?: HoursWorkedTimeframe | null, readonly additionalSkills?: string | null, readonly chargeExperience?: boolean | null, readonly leadExperience?: boolean | null, readonly preceptorExperience?: boolean | null, readonly floatFrequency?: PositionFloatFrequency | null, readonly friendlyEmploymentType?: string | null, readonly invalidOverlapByHours?: boolean | null, readonly invalidOverlapByLocation?: boolean | null, readonly usableForReferences: boolean, readonly nicuCareLevels?: ReadonlyArray<number> | null, readonly activeReferences?: ReadonlyArray<{ readonly __typename?: 'Reference', readonly id: string, readonly name?: string | null, readonly relationship?: string | null, readonly responseAt?: GraphQLISO8601Date | null }> | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly name: string } | null, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null, readonly country?: string | null } | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly agency?: { readonly __typename?: 'Agency', readonly id: string, readonly name: string } | null, readonly technologies?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null, readonly specialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string }> | null, readonly floatUnits?: ReadonlyArray<{ readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string }> | null };

export type WorkExperienceSectionGapFragment = { readonly __typename?: 'Gap', readonly gapId: string, readonly gapEndAt: GraphQLISO8601Date, readonly gapExplanation?: string | null, readonly gapGooglePlaceId?: string | null, readonly gapIsEducationGap?: boolean | null, readonly gapLocationAddress?: string | null, readonly gapReason?: string | null, readonly gapStartAt: GraphQLISO8601Date };

export type UpsertEmploymentPositionMutationVariables = Exact<{
  parserId?: InputMaybe<Scalars['String']['input']>;
  input: UpsertEmploymentPositionInput;
  facilityInput: UpsertEmploymentPositionFacilityInput;
  agencyInput?: InputMaybe<UpsertEmploymentPositionAgencyInput>;
}>;


export type UpsertEmploymentPositionMutation = { readonly __typename?: 'Mutation', readonly upsertEmploymentPosition?: { readonly __typename?: 'UpsertEmploymentPositionPayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly canApplyJobs: boolean, readonly hasPositionsInvalidHoursOverlap: boolean, readonly hasPositionsLocationOverlap: boolean, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly licenses: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly label: string, readonly status: ApplicationReadinessStatus } } }, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly workExperience: { readonly __typename?: 'ProfileCompletionStep', readonly status: ProfileCompletionStatusEnum, readonly message?: string | null } }, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly incompleteCount: number, readonly expiredCount: number, readonly percentCompleted: number, readonly pendingCount: number } } | null, readonly positions?: ReadonlyArray<{ readonly __typename?: 'Position', readonly id: string, readonly title: string, readonly positionType?: PositionTypes | null, readonly classification?: EmploymentTypes | null, readonly startAt?: GraphQLISO8601Date | null, readonly endAt?: GraphQLISO8601Date | null, readonly patientRatio?: number | null, readonly hoursWorked?: number | null, readonly hoursWorkedTimeframe?: HoursWorkedTimeframe | null, readonly traumaLevel?: number | null, readonly additionalSkills?: string | null, readonly chargeExperience?: boolean | null, readonly preceptorExperience?: boolean | null, readonly leadExperience?: boolean | null, readonly trauma?: boolean | null, readonly magnet: boolean, readonly teaching: boolean, readonly wouldWorkAgain?: boolean | null, readonly unitBedCount?: number | null, readonly floatFrequency?: PositionFloatFrequency | null, readonly friendlyEmploymentType?: string | null, readonly invalidOverlapByHours?: boolean | null, readonly invalidOverlapByLocation?: boolean | null, readonly pediatricTraumaLevel?: number | null, readonly nicuCareLevels?: ReadonlyArray<number> | null, readonly facilityBedCount?: number | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly name: string } | null, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly formattedLocationString?: string | null, readonly googlePlaceId?: string | null } | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly slug: string, readonly displayName: string } | null, readonly agency?: { readonly __typename?: 'Agency', readonly id: string, readonly name: string } | null, readonly specialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly fullName?: string | null, readonly nicu: boolean, readonly pediatric: boolean, readonly slug: string }> | null, readonly technologies?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null, readonly floatUnits?: ReadonlyArray<{ readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string }> | null }> | null } } | null };

export type DeleteEmploymentPositionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteEmploymentPositionMutation = { readonly __typename?: 'Mutation', readonly deleteEmploymentPosition?: { readonly __typename?: 'DeleteEmploymentPositionPayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly canApplyJobs: boolean, readonly hasPositionsInvalidHoursOverlap: boolean, readonly hasPositionsLocationOverlap: boolean, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly licenses: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly label: string, readonly status: ApplicationReadinessStatus } } }, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly workExperience: { readonly __typename?: 'ProfileCompletionStep', readonly status: ProfileCompletionStatusEnum, readonly message?: string | null } }, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly incompleteCount: number, readonly expiredCount: number, readonly percentCompleted: number, readonly pendingCount: number } } | null, readonly positions?: ReadonlyArray<{ readonly __typename?: 'Position', readonly id: string, readonly title: string, readonly positionType?: PositionTypes | null, readonly classification?: EmploymentTypes | null, readonly startAt?: GraphQLISO8601Date | null, readonly endAt?: GraphQLISO8601Date | null, readonly patientRatio?: number | null, readonly hoursWorked?: number | null, readonly hoursWorkedTimeframe?: HoursWorkedTimeframe | null, readonly traumaLevel?: number | null, readonly additionalSkills?: string | null, readonly chargeExperience?: boolean | null, readonly preceptorExperience?: boolean | null, readonly leadExperience?: boolean | null, readonly trauma?: boolean | null, readonly magnet: boolean, readonly teaching: boolean, readonly wouldWorkAgain?: boolean | null, readonly unitBedCount?: number | null, readonly floatFrequency?: PositionFloatFrequency | null, readonly friendlyEmploymentType?: string | null, readonly invalidOverlapByHours?: boolean | null, readonly invalidOverlapByLocation?: boolean | null, readonly pediatricTraumaLevel?: number | null, readonly nicuCareLevels?: ReadonlyArray<number> | null, readonly facilityBedCount?: number | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly name: string } | null, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly formattedLocationString?: string | null, readonly googlePlaceId?: string | null } | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly slug: string, readonly displayName: string } | null, readonly agency?: { readonly __typename?: 'Agency', readonly id: string, readonly name: string } | null, readonly specialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly fullName?: string | null, readonly nicu: boolean, readonly pediatric: boolean, readonly slug: string }> | null, readonly technologies?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null, readonly floatUnits?: ReadonlyArray<{ readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string }> | null }> | null } } | null };

export type WorkExperienceListPanelQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkExperienceListPanelQuery = { readonly __typename?: 'Query', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly state?: string | null, readonly id: string, readonly computedYearsOfExp?: number | null, readonly computedYearsOfExpWithGaps: number, readonly computedDaysOfExpWithGaps: number, readonly gapBetweenEducationAndEmploymentPosition: boolean, readonly hasPositionsLocationOverlap: boolean, readonly hasPositionsInvalidHoursOverlap: boolean, readonly isYearsOfExpCompleted: boolean, readonly yearsOfExp?: number | null, readonly yearsOfTravelExp?: number | null, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly employment: { readonly __typename?: 'ApplicationReadinessEmploymentResult', readonly label: string, readonly status: ApplicationReadinessStatus } } }, readonly educations?: ReadonlyArray<{ readonly __typename?: 'Education', readonly id: string, readonly graduatedOn: GraphQLISO8601Date }> | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly workExperience: { readonly __typename?: 'ProfileCompletionStep', readonly status: ProfileCompletionStatusEnum, readonly message?: string | null } } } | null, readonly sortedExperienceItems?: ReadonlyArray<{ readonly __typename?: 'Employment' } | { readonly __typename?: 'Gap', readonly gapId: string, readonly gapEndAt: GraphQLISO8601Date, readonly gapExplanation?: string | null, readonly gapGooglePlaceId?: string | null, readonly gapIsEducationGap?: boolean | null, readonly gapLocationAddress?: string | null, readonly gapReason?: string | null, readonly gapStartAt: GraphQLISO8601Date } | { readonly __typename?: 'Position', readonly id: string, readonly title: string, readonly positionType?: PositionTypes | null, readonly startAt?: GraphQLISO8601Date | null, readonly endAt?: GraphQLISO8601Date | null, readonly humanReadableLength?: string | null, readonly hoursWorked?: number | null, readonly hoursWorkedTimeframe?: HoursWorkedTimeframe | null, readonly additionalSkills?: string | null, readonly chargeExperience?: boolean | null, readonly leadExperience?: boolean | null, readonly preceptorExperience?: boolean | null, readonly floatFrequency?: PositionFloatFrequency | null, readonly friendlyEmploymentType?: string | null, readonly invalidOverlapByHours?: boolean | null, readonly invalidOverlapByLocation?: boolean | null, readonly usableForReferences: boolean, readonly nicuCareLevels?: ReadonlyArray<number> | null, readonly activeReferences?: ReadonlyArray<{ readonly __typename?: 'Reference', readonly id: string, readonly name?: string | null, readonly relationship?: string | null, readonly responseAt?: GraphQLISO8601Date | null }> | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly name: string } | null, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null, readonly country?: string | null } | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly agency?: { readonly __typename?: 'Agency', readonly id: string, readonly name: string } | null, readonly technologies?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null, readonly specialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string }> | null, readonly floatUnits?: ReadonlyArray<{ readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string }> | null }> | null } | null, readonly parsedWorkExperiences?: ReadonlyArray<{ readonly __typename?: 'WorkExperienceSuggestion', readonly startAt?: GraphQLISO8601Date | null, readonly endAt?: GraphQLISO8601Date | null, readonly additionalSkills?: string | null, readonly facilityName?: string | null, readonly traumaLevel?: number | null, readonly trauma?: boolean | null, readonly magnet?: boolean | null, readonly teaching?: boolean | null, readonly parserId?: string | null, readonly positionType?: PositionTypes | null, readonly facilityBedCount?: number | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly name: string } | null, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly formattedLocationString?: string | null, readonly googlePlaceId?: string | null, readonly city?: string | null, readonly stateCode?: string | null } | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly slug: string, readonly displayName: string } | null, readonly specialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string }> | null, readonly technologies?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null }> | null };

export type BaseWorkExperienceFormQueryVariables = Exact<{ [key: string]: never; }>;


export type BaseWorkExperienceFormQuery = { readonly __typename?: 'Query', readonly educations: ReadonlyArray<{ readonly __typename?: 'Education', readonly id: string, readonly graduatedOn: GraphQLISO8601Date }>, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly type?: RoleType | null } | null } | null };

export type EditEmploymentPositionFormQueryVariables = Exact<{
  positionId: Scalars['ID']['input'];
}>;


export type EditEmploymentPositionFormQuery = { readonly __typename?: 'Query', readonly employmentPosition: { readonly __typename?: 'Position', readonly id: string, readonly title: string, readonly positionType?: PositionTypes | null, readonly classification?: EmploymentTypes | null, readonly startAt?: GraphQLISO8601Date | null, readonly endAt?: GraphQLISO8601Date | null, readonly patientRatio?: number | null, readonly hoursWorked?: number | null, readonly hoursWorkedTimeframe?: HoursWorkedTimeframe | null, readonly traumaLevel?: number | null, readonly additionalSkills?: string | null, readonly chargeExperience?: boolean | null, readonly preceptorExperience?: boolean | null, readonly leadExperience?: boolean | null, readonly trauma?: boolean | null, readonly magnet: boolean, readonly teaching: boolean, readonly wouldWorkAgain?: boolean | null, readonly unitBedCount?: number | null, readonly floatFrequency?: PositionFloatFrequency | null, readonly friendlyEmploymentType?: string | null, readonly invalidOverlapByHours?: boolean | null, readonly invalidOverlapByLocation?: boolean | null, readonly pediatricTraumaLevel?: number | null, readonly nicuCareLevels?: ReadonlyArray<number> | null, readonly facilityBedCount?: number | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly name: string } | null, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly formattedLocationString?: string | null, readonly googlePlaceId?: string | null } | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly slug: string, readonly displayName: string } | null, readonly agency?: { readonly __typename?: 'Agency', readonly id: string, readonly name: string } | null, readonly specialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string, readonly fullName?: string | null, readonly nicu: boolean, readonly pediatric: boolean, readonly slug: string }> | null, readonly technologies?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null, readonly floatUnits?: ReadonlyArray<{ readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string }> | null } };

export type EditWorkExperienceSuggestionFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EditWorkExperienceSuggestionFormQuery = { readonly __typename?: 'Query', readonly parsedWorkExperience: { readonly __typename?: 'WorkExperienceSuggestion', readonly startAt?: GraphQLISO8601Date | null, readonly endAt?: GraphQLISO8601Date | null, readonly additionalSkills?: string | null, readonly facilityName?: string | null, readonly traumaLevel?: number | null, readonly trauma?: boolean | null, readonly magnet?: boolean | null, readonly teaching?: boolean | null, readonly parserId?: string | null, readonly positionType?: PositionTypes | null, readonly facilityBedCount?: number | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly name: string } | null, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly formattedLocationString?: string | null, readonly googlePlaceId?: string | null, readonly city?: string | null, readonly stateCode?: string | null } | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly slug: string, readonly displayName: string } | null, readonly specialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string }> | null, readonly technologies?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null } };

export type EmploymentPositionRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type EmploymentPositionRolesQuery = { readonly __typename?: 'Query', readonly employmentPositionRoles?: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: string, readonly abbreviation: string, readonly key?: string | null, readonly name: string, readonly type?: RoleType | null }> | null };

export type TechnologySuggestionsQueryVariables = Exact<{
  searchString: Scalars['String']['input'];
}>;


export type TechnologySuggestionsQuery = { readonly __typename?: 'Query', readonly technologySuggestions?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null };

export type AgencySuggestionsQueryVariables = Exact<{
  searchString?: InputMaybe<Scalars['String']['input']>;
}>;


export type AgencySuggestionsQuery = { readonly __typename?: 'Query', readonly getAgencySuggestions: ReadonlyArray<{ readonly __typename?: 'Agency', readonly id: string, readonly name: string }> };

export type HomeUserFragment = { readonly __typename?: 'User', readonly id: string, readonly firstName?: string | null, readonly preferredName?: string | null, readonly lastName?: string | null, readonly email: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly isActivated?: boolean | null, readonly isOnboarding: boolean, readonly squatchShareUrl?: string | null, readonly wizardCompleted: boolean, readonly state?: string | null, readonly requestReview: { readonly __typename?: 'RequestReview', readonly status: RequestReviewStatusEnum, readonly title: string, readonly description: string, readonly ctaText: string, readonly error?: string | null }, readonly nurseAdvocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly email?: string | null, readonly phone?: string | null, readonly firstName?: string | null, readonly profileImgUrl: string } | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly type?: RoleType | null } | null } | null };

export type ClinicianCredentialsOverviewFragment = { readonly __typename?: 'ClinicianCredentialsOverview', readonly id: string, readonly credentialTotalCount: number, readonly credentialExpiringCount: number, readonly credentialExpiredCount: number };

export type JobPlacementScheduleSummaryFragment = { readonly __typename?: 'JobPlacementSchedule', readonly id: string, readonly name?: string | null, readonly timezone?: string | null, readonly endSec?: number | null, readonly jobPlacement: { readonly __typename?: 'JobPlacement', readonly id: string, readonly facilityLocation?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null } };

export type TodoListFragment = { readonly __typename?: 'TodoList', readonly id: string, readonly completeByDate?: GraphQLISO8601Date | null, readonly targetBusinessName?: string | null, readonly todoListItems: ReadonlyArray<{ readonly __typename?: 'TodoListItem', readonly id: string, readonly itemState?: string | null }> };

export type RequestReviewFragment = { readonly __typename?: 'RequestReview', readonly status: RequestReviewStatusEnum, readonly title: string, readonly description: string, readonly ctaText: string, readonly error?: string | null };

export type HomeResourceLinkFragment = { readonly __typename?: 'HomeResourceLink', readonly id: string, readonly title: string, readonly link: string };

export type NurseAdvocateFragment = { readonly __typename?: 'SalesforceUser', readonly id: string, readonly email?: string | null, readonly phone?: string | null, readonly firstName?: string | null, readonly profileImgUrl: string };

export type HomePageUserFragment = { readonly __typename?: 'User', readonly id: string, readonly preferredName?: string | null, readonly email: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly isActivated?: boolean | null, readonly percentComplete?: number | null, readonly state?: string | null, readonly wizardCompleted: boolean, readonly displayName?: string | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly percentCompleted: number } } | null, readonly nurseAdvocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly email?: string | null, readonly fullName?: string | null, readonly phone?: string | null, readonly firstName?: string | null, readonly lastName?: string | null, readonly profileImgUrl: string, readonly isNurseAdvocate?: boolean | null, readonly isAlliedAdvocate?: boolean | null, readonly clinicalRole?: string | null } | null, readonly activationRequest: { readonly __typename?: 'ActivationRequest', readonly earliestStartDateAt?: GraphQLISO8601Date | null } } | null };

export type HomePageNurseProfileFragment = { readonly __typename?: 'NurseProfile', readonly id: string, readonly wizardCompleted: boolean, readonly displayName?: string | null, readonly state?: string | null, readonly activationRequest: { readonly __typename?: 'ActivationRequest', readonly earliestStartDateAt?: GraphQLISO8601Date | null }, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly percentCompleted: number } } | null, readonly nurseAdvocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly phone?: string | null, readonly firstName?: string | null, readonly lastName?: string | null, readonly profileImgUrl: string, readonly isNurseAdvocate?: boolean | null, readonly isAlliedAdvocate?: boolean | null, readonly clinicalRole?: string | null } | null };

export type HomePageClinicianJobSummaryFragment = { readonly __typename?: 'HomeClinicianJobSummary', readonly id: string, readonly favoritedCount?: { readonly __typename?: 'SimpleCount', readonly id: string, readonly value?: number | null } | null, readonly applicationsCount?: { readonly __typename?: 'SimpleCount', readonly id: string, readonly value?: number | null } | null, readonly offersCount?: { readonly __typename?: 'SimpleCount', readonly id: string, readonly value?: number | null } | null, readonly submissionsCount?: { readonly __typename?: 'SimpleCount', readonly id: string, readonly value?: number | null } | null };

export type ApprovedUserQueryVariables = Exact<{ [key: string]: never; }>;


export type ApprovedUserQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly requestReview: { readonly __typename?: 'RequestReview', readonly error?: string | null, readonly status: RequestReviewStatusEnum }, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly name: string } | null } | null } | null, readonly profileCompletionSummary: { readonly __typename?: 'ProfileCompletionSummary', readonly id: string, readonly completedAt?: GraphQLISO8601DateTime | null, readonly meta: { readonly __typename?: 'ProfileMeta', readonly id: string, readonly completeCount: number, readonly expiredCount: number, readonly expiringCount: number, readonly incompleteCount: number, readonly pendingCount: number, readonly percentCompleted: number }, readonly steps: ReadonlyArray<{ readonly __typename?: 'ProfileStep', readonly estimatedTimeInMinutes?: number | null, readonly key: ProfileStepsEnum, readonly title?: string | null, readonly subtitle?: string | null, readonly messages?: ReadonlyArray<string> | null, readonly sectionName: string, readonly status: ProfileStatusEnum, readonly hasExpiringItems: boolean, readonly hasExpiredItems: boolean, readonly hasInvalidItems: boolean }> } };

export type DeactivatedUserQueryVariables = Exact<{ [key: string]: never; }>;


export type DeactivatedUserQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly isActivated?: boolean | null, readonly percentComplete?: number | null, readonly state?: string | null, readonly nurseAdvocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly firstName?: string | null, readonly email?: string | null, readonly fullName?: string | null } | null, readonly requestReview: { readonly __typename?: 'RequestReview', readonly error?: string | null, readonly status: RequestReviewStatusEnum }, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly name: string } | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly percentCompleted: number } } | null } | null } | null, readonly profileCompletionSummary: { readonly __typename?: 'ProfileCompletionSummary', readonly id: string, readonly completedAt?: GraphQLISO8601DateTime | null, readonly meta: { readonly __typename?: 'ProfileMeta', readonly id: string, readonly completeCount: number, readonly expiredCount: number, readonly expiringCount: number, readonly incompleteCount: number, readonly pendingCount: number, readonly percentCompleted: number }, readonly steps: ReadonlyArray<{ readonly __typename?: 'ProfileStep', readonly estimatedTimeInMinutes?: number | null, readonly key: ProfileStepsEnum, readonly title?: string | null, readonly subtitle?: string | null, readonly messages?: ReadonlyArray<string> | null, readonly sectionName: string, readonly status: ProfileStatusEnum, readonly hasExpiringItems: boolean, readonly hasExpiredItems: boolean, readonly hasInvalidItems: boolean }> } };

export type ClinicianWorkingDownloadAppCardQueryVariables = Exact<{ [key: string]: never; }>;


export type ClinicianWorkingDownloadAppCardQuery = { readonly __typename?: 'Query', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly jobPlacements?: ReadonlyArray<{ readonly __typename?: 'JobPlacement', readonly id: string, readonly facilityName?: string | null, readonly endDate?: GraphQLISO8601Date | null, readonly job?: { readonly __typename?: 'Job', readonly id: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null } | null }> | null } | null };

export type JobOfferStateQueryVariables = Exact<{ [key: string]: never; }>;


export type JobOfferStateQuery = { readonly __typename?: 'Query', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly jobApplicationsSummary: { readonly __typename?: 'JobApplicationsSummary', readonly id: string, readonly offer: ReadonlyArray<{ readonly __typename?: 'JobOffer', readonly id: string, readonly uuid: string, readonly status: JobOfferEnum, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly contractNotes?: string | null, readonly clinicianAcceptedInapp?: boolean | null, readonly nurseAdvocateEmail?: string | null, readonly lengthInWeeks?: number | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly hoursPerShift?: number | null, readonly contracts?: ReadonlyArray<{ readonly __typename?: 'Contract', readonly id: string, readonly contractStatus?: string | null, readonly contractStartDate: GraphQLISO8601Date, readonly contractEndDate: GraphQLISO8601Date, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly state?: string | null, readonly city?: string | null } | null, readonly jobOffer?: { readonly __typename?: 'JobOffer', readonly id: string, readonly uuid: string, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly facilityName?: string | null, readonly title?: string | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null } } | null }> | null, readonly timeOffs?: ReadonlyArray<{ readonly __typename?: 'TimeOff', readonly id: string, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly approvalStatus?: string | null }> | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly localAllowed: boolean, readonly onHold?: boolean | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly facilityName?: string | null, readonly cancellationPolicy?: string | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly business?: { readonly __typename?: 'Facility', readonly city?: string | null, readonly state?: string | null, readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null }, readonly jobApplication: { readonly __typename?: 'JobApplication', readonly id: string, readonly paymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly nonTaxableStipendWeekly?: number | null, readonly taxableWageRateWeekly?: number | null, readonly grossPayWeekly?: number | null } | null }, readonly paymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly nonTaxableStipendWeekly?: number | null, readonly taxableWageRateWeekly?: number | null, readonly grossPayWeekly?: number | null, readonly incidentalsStipendDaily?: number | null, readonly lodgingStipendDaily?: number | null, readonly regularWageRate?: number | null, readonly overtimeMultiplier?: number | null, readonly doubleTimeMultiplier?: number | null, readonly overtimeWageRate?: number | null, readonly regularHoursPerWeek?: number | null, readonly overtimeHoursPerWeek?: number | null, readonly blendedWageRate?: number | null, readonly totalHoursPerWeek?: number | null, readonly holidayRate?: number | null, readonly chargeRate?: number | null, readonly onCallRate?: number | null, readonly callBackRate?: number | null, readonly extraRate?: number | null } | null }> } } | null };

export type JobOffersQueryVariables = Exact<{
  filter: JobOffersFilter;
}>;


export type JobOffersQuery = { readonly __typename?: 'Query', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly jobOffers: ReadonlyArray<{ readonly __typename?: 'JobOffer', readonly id: string, readonly uuid: string, readonly status: JobOfferEnum, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly contractNotes?: string | null, readonly clinicianAcceptedInapp?: boolean | null, readonly nurseAdvocateEmail?: string | null, readonly lengthInWeeks?: number | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly hoursPerShift?: number | null, readonly contracts?: ReadonlyArray<{ readonly __typename?: 'Contract', readonly id: string, readonly contractStatus?: string | null, readonly contractStartDate: GraphQLISO8601Date, readonly contractEndDate: GraphQLISO8601Date, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly state?: string | null, readonly city?: string | null } | null, readonly jobOffer?: { readonly __typename?: 'JobOffer', readonly id: string, readonly uuid: string, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly facilityName?: string | null, readonly title?: string | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null } } | null }> | null, readonly timeOffs?: ReadonlyArray<{ readonly __typename?: 'TimeOff', readonly id: string, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly approvalStatus?: string | null }> | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly localAllowed: boolean, readonly onHold?: boolean | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly facilityName?: string | null, readonly cancellationPolicy?: string | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly business?: { readonly __typename?: 'Facility', readonly city?: string | null, readonly state?: string | null, readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null }, readonly jobApplication: { readonly __typename?: 'JobApplication', readonly id: string, readonly paymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly nonTaxableStipendWeekly?: number | null, readonly taxableWageRateWeekly?: number | null, readonly grossPayWeekly?: number | null } | null }, readonly paymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly nonTaxableStipendWeekly?: number | null, readonly taxableWageRateWeekly?: number | null, readonly grossPayWeekly?: number | null, readonly incidentalsStipendDaily?: number | null, readonly lodgingStipendDaily?: number | null, readonly regularWageRate?: number | null, readonly overtimeMultiplier?: number | null, readonly doubleTimeMultiplier?: number | null, readonly overtimeWageRate?: number | null, readonly regularHoursPerWeek?: number | null, readonly overtimeHoursPerWeek?: number | null, readonly blendedWageRate?: number | null, readonly totalHoursPerWeek?: number | null, readonly holidayRate?: number | null, readonly chargeRate?: number | null, readonly onCallRate?: number | null, readonly callBackRate?: number | null, readonly extraRate?: number | null } | null }> } | null };

export type ContractsByFilterQueryVariables = Exact<{
  filter: ContractsFilter;
}>;


export type ContractsByFilterQuery = { readonly __typename?: 'Query', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly contractsByFilter?: ReadonlyArray<{ readonly __typename?: 'Contract', readonly id: string, readonly contractStatus?: string | null, readonly contractStartDate: GraphQLISO8601Date, readonly contractEndDate: GraphQLISO8601Date, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly state?: string | null, readonly city?: string | null } | null, readonly jobOffer?: { readonly __typename?: 'JobOffer', readonly id: string, readonly uuid: string, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly facilityName?: string | null, readonly title?: string | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null } } | null }> | null } | null };

export type HomePageQueryVariables = Exact<{ [key: string]: never; }>;


export type HomePageQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly preferredName?: string | null, readonly email: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly isActivated?: boolean | null, readonly percentComplete?: number | null, readonly state?: string | null, readonly wizardCompleted: boolean, readonly displayName?: string | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly percentCompleted: number } } | null, readonly nurseAdvocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly email?: string | null, readonly fullName?: string | null, readonly phone?: string | null, readonly firstName?: string | null, readonly lastName?: string | null, readonly profileImgUrl: string, readonly isNurseAdvocate?: boolean | null, readonly isAlliedAdvocate?: boolean | null, readonly clinicalRole?: string | null } | null, readonly activationRequest: { readonly __typename?: 'ActivationRequest', readonly earliestStartDateAt?: GraphQLISO8601Date | null } } | null } | null, readonly homeStepMapper: { readonly __typename?: 'HomeStepMapper', readonly state: StateEnum, readonly sort: ReadonlyArray<StateEnum> }, readonly homeClinicianJobSummary?: { readonly __typename?: 'HomeClinicianJobSummary', readonly id: string, readonly favoritedOnce?: { readonly __typename?: 'SimpleBoolean', readonly id: string, readonly value?: boolean | null } | null, readonly favoritedCount?: { readonly __typename?: 'SimpleCount', readonly id: string, readonly value?: number | null } | null, readonly applicationsCount?: { readonly __typename?: 'SimpleCount', readonly id: string, readonly value?: number | null } | null, readonly offersCount?: { readonly __typename?: 'SimpleCount', readonly id: string, readonly value?: number | null } | null, readonly submissionsCount?: { readonly __typename?: 'SimpleCount', readonly id: string, readonly value?: number | null } | null } | null };

export type HomePageOnboardingQueryVariables = Exact<{ [key: string]: never; }>;


export type HomePageOnboardingQuery = { readonly __typename?: 'Query', readonly activeOnboardingLists?: ReadonlyArray<{ readonly __typename?: 'TodoList', readonly id: string, readonly completeByDate?: GraphQLISO8601Date | null, readonly targetBusinessName?: string | null, readonly todoListItems: ReadonlyArray<{ readonly __typename?: 'TodoListItem', readonly id: string, readonly itemState?: string | null }> }> | null };

export type HomePageNewStateQueryVariables = Exact<{ [key: string]: never; }>;


export type HomePageNewStateQuery = { readonly __typename?: 'Query', readonly homeTotalMatches: { readonly __typename?: 'HomeTotalMatches', readonly matchesWaiting: number } };

export type HomeClinicianJobSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeClinicianJobSummaryQuery = { readonly __typename?: 'Query', readonly homeClinicianJobSummary?: { readonly __typename?: 'HomeClinicianJobSummary', readonly id: string, readonly favoritedCount?: { readonly __typename?: 'SimpleCount', readonly id: string, readonly value?: number | null } | null, readonly applicationsCount?: { readonly __typename?: 'SimpleCount', readonly id: string, readonly value?: number | null } | null, readonly offersCount?: { readonly __typename?: 'SimpleCount', readonly id: string, readonly value?: number | null } | null, readonly submissionsCount?: { readonly __typename?: 'SimpleCount', readonly id: string, readonly value?: number | null } | null } | null };

export type ComplianceQuestionsPermanentAddressUserFragment = { readonly __typename?: 'User', readonly id: string, readonly cityPermanent?: string | null, readonly countryPermanentCode?: string | null, readonly countryPermanentName?: string | null, readonly googlePlaceIdPermanent?: string | null, readonly statePermanent?: string | null, readonly streetAddressPermanent?: string | null, readonly streetNumberPermanent?: string | null, readonly zipcodePermanent?: string | null };

export type ComplianceQuestionsMutationVariables = Exact<{
  input: CreateComplianceQuestionsInput;
  jobOfferId: Scalars['ID']['input'];
}>;


export type ComplianceQuestionsMutation = { readonly __typename?: 'Mutation', readonly createComplianceQuestions?: { readonly __typename?: 'CreateComplianceQuestionsPayload', readonly jobOffer: { readonly __typename?: 'JobOffer', readonly id: string } } | null };

export type ComplianceQuestionsDataQueryVariables = Exact<{
  jobOfferId: Scalars['ID']['input'];
}>;


export type ComplianceQuestionsDataQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly firstName?: string | null, readonly middleName?: string | null, readonly lastName?: string | null, readonly cityPermanent?: string | null, readonly countryPermanentCode?: string | null, readonly countryPermanentName?: string | null, readonly googlePlaceIdPermanent?: string | null, readonly statePermanent?: string | null, readonly streetAddressPermanent?: string | null, readonly streetNumberPermanent?: string | null, readonly zipcodePermanent?: string | null, readonly city?: string | null, readonly state?: string | null, readonly streetAddress?: string | null, readonly zipcode?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly birthday?: GraphQLISO8601Date | null } | null } | null, readonly jobOffer?: { readonly __typename?: 'JobOffer', readonly id: string, readonly uuid: string, readonly status: JobOfferEnum, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly contractNotes?: string | null, readonly clinicianAcceptedInapp?: boolean | null, readonly nurseAdvocateEmail?: string | null, readonly lengthInWeeks?: number | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly hoursPerShift?: number | null, readonly contracts?: ReadonlyArray<{ readonly __typename?: 'Contract', readonly id: string, readonly contractStatus?: string | null, readonly contractStartDate: GraphQLISO8601Date, readonly contractEndDate: GraphQLISO8601Date, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly state?: string | null, readonly city?: string | null } | null, readonly jobOffer?: { readonly __typename?: 'JobOffer', readonly id: string, readonly uuid: string, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly facilityName?: string | null, readonly title?: string | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null } } | null }> | null, readonly timeOffs?: ReadonlyArray<{ readonly __typename?: 'TimeOff', readonly id: string, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly approvalStatus?: string | null }> | null, readonly job: { readonly __typename?: 'Job', readonly id: string, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly licenseType?: string | null, readonly localAllowed: boolean, readonly onHold?: boolean | null, readonly shiftType?: string | null, readonly shiftsPerWeek?: number | null, readonly startAsap?: boolean | null, readonly startDate?: GraphQLISO8601Date | null, readonly endDate?: GraphQLISO8601Date | null, readonly facilityName?: string | null, readonly cancellationPolicy?: string | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly travelAllowed: boolean, readonly business?: { readonly __typename?: 'Facility', readonly city?: string | null, readonly state?: string | null, readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateCode?: string | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly emr?: ReadonlyArray<{ readonly __typename?: 'Technology', readonly id: string, readonly name: string }> | null }, readonly jobApplication: { readonly __typename?: 'JobApplication', readonly id: string, readonly paymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly nonTaxableStipendWeekly?: number | null, readonly taxableWageRateWeekly?: number | null, readonly grossPayWeekly?: number | null } | null }, readonly paymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly nonTaxableStipendWeekly?: number | null, readonly taxableWageRateWeekly?: number | null, readonly grossPayWeekly?: number | null, readonly incidentalsStipendDaily?: number | null, readonly lodgingStipendDaily?: number | null, readonly regularWageRate?: number | null, readonly overtimeMultiplier?: number | null, readonly doubleTimeMultiplier?: number | null, readonly overtimeWageRate?: number | null, readonly regularHoursPerWeek?: number | null, readonly overtimeHoursPerWeek?: number | null, readonly blendedWageRate?: number | null, readonly totalHoursPerWeek?: number | null, readonly holidayRate?: number | null, readonly chargeRate?: number | null, readonly onCallRate?: number | null, readonly callBackRate?: number | null, readonly extraRate?: number | null } | null } | null };

export type RequestReviewFormCopyFragment = { readonly __typename?: 'RequestReviewForm', readonly title: string, readonly ctaText: string, readonly experienceDateQuestion: { readonly __typename?: 'RequestReviewQuestion', readonly title: string, readonly description: string }, readonly experienceQuestion: { readonly __typename?: 'RequestReviewQuestion', readonly title: string, readonly description: string }, readonly startDateQuestion: { readonly __typename?: 'RequestReviewQuestion', readonly title: string, readonly description: string }, readonly notesQuestion: { readonly __typename?: 'RequestReviewQuestion', readonly title: string, readonly description: string }, readonly licenseOrCertificationQuestion: { readonly __typename?: 'RequestReviewQuestion', readonly title: string, readonly description: string }, readonly licenseOrCertificationIntentionQuestion: { readonly __typename?: 'RequestReviewQuestion', readonly title: string, readonly description: string }, readonly licenseOrCertificationDateQuestion: { readonly __typename?: 'RequestReviewQuestion', readonly title: string, readonly description: string }, readonly followingStepQuestion: { readonly __typename?: 'RequestReviewQuestion', readonly title: string, readonly description: string } };

export type ActivationRequestFragment = { readonly __typename?: 'ActivationRequest', readonly id: string, readonly earliestStartDateAt?: GraphQLISO8601Date | null, readonly notes?: string | null, readonly requiredExperience?: boolean | null, readonly requiredExperienceDateAt?: GraphQLISO8601Date | null, readonly followingStepQuestion?: string | null, readonly advocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly phone?: string | null, readonly firstName?: string | null, readonly lastName?: string | null, readonly profileImgUrl: string, readonly isNurseAdvocate?: boolean | null, readonly isAlliedAdvocate?: boolean | null, readonly clinicalRole?: string | null } | null };

export type ActivationRequestNurseProfileFragment = { readonly __typename?: 'NurseProfile', readonly id: string, readonly state?: string | null, readonly wizardCompleted: boolean, readonly yearsOfExp?: number | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly abbreviation: string, readonly key?: string | null, readonly name: string, readonly type?: RoleType | null } | null, readonly activationRequest: { readonly __typename?: 'ActivationRequest', readonly id: string, readonly earliestStartDateAt?: GraphQLISO8601Date | null, readonly notes?: string | null, readonly requiredExperience?: boolean | null, readonly requiredExperienceDateAt?: GraphQLISO8601Date | null, readonly followingStepQuestion?: string | null, readonly advocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly phone?: string | null, readonly firstName?: string | null, readonly lastName?: string | null, readonly profileImgUrl: string, readonly isNurseAdvocate?: boolean | null, readonly isAlliedAdvocate?: boolean | null, readonly clinicalRole?: string | null } | null } };

export type RequestActivationMutationVariables = Exact<{
  input: RequestActivationInput;
}>;


export type RequestActivationMutation = { readonly __typename?: 'Mutation', readonly requestActivation?: { readonly __typename?: 'RequestActivationPayload', readonly reasons: ReadonlyArray<string>, readonly errorCode?: string | null, readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly isActivated?: boolean | null, readonly activationRequest: { readonly __typename?: 'ActivationRequest', readonly id: string, readonly earliestStartDateAt?: GraphQLISO8601Date | null, readonly notes?: string | null, readonly requiredExperience?: boolean | null, readonly requiredExperienceDateAt?: GraphQLISO8601Date | null, readonly followingStepQuestion?: string | null, readonly advocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly phone?: string | null, readonly firstName?: string | null, readonly lastName?: string | null, readonly profileImgUrl: string, readonly isNurseAdvocate?: boolean | null, readonly isAlliedAdvocate?: boolean | null, readonly clinicalRole?: string | null } | null }, readonly requestReview: { readonly __typename?: 'RequestReview', readonly status: RequestReviewStatusEnum, readonly title: string, readonly description: string, readonly ctaText: string, readonly error?: string | null } } } | null };

export type RequestActivationAssignAdvocateMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestActivationAssignAdvocateMutation = { readonly __typename?: 'Mutation', readonly assignAdvocate?: { readonly __typename?: 'AssignAdvocatePayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly state?: string | null, readonly wizardCompleted: boolean, readonly yearsOfExp?: number | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly abbreviation: string, readonly key?: string | null, readonly name: string, readonly type?: RoleType | null } | null, readonly activationRequest: { readonly __typename?: 'ActivationRequest', readonly id: string, readonly earliestStartDateAt?: GraphQLISO8601Date | null, readonly notes?: string | null, readonly requiredExperience?: boolean | null, readonly requiredExperienceDateAt?: GraphQLISO8601Date | null, readonly followingStepQuestion?: string | null, readonly advocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly phone?: string | null, readonly firstName?: string | null, readonly lastName?: string | null, readonly profileImgUrl: string, readonly isNurseAdvocate?: boolean | null, readonly isAlliedAdvocate?: boolean | null, readonly clinicalRole?: string | null } | null } } } | null };

export type RequestReviewPageDataQueryVariables = Exact<{ [key: string]: never; }>;


export type RequestReviewPageDataQuery = { readonly __typename?: 'Query', readonly requestReviewFormCopy: { readonly __typename?: 'RequestReviewForm', readonly title: string, readonly ctaText: string, readonly experienceDateQuestion: { readonly __typename?: 'RequestReviewQuestion', readonly title: string, readonly description: string }, readonly experienceQuestion: { readonly __typename?: 'RequestReviewQuestion', readonly title: string, readonly description: string }, readonly startDateQuestion: { readonly __typename?: 'RequestReviewQuestion', readonly title: string, readonly description: string }, readonly notesQuestion: { readonly __typename?: 'RequestReviewQuestion', readonly title: string, readonly description: string }, readonly licenseOrCertificationQuestion: { readonly __typename?: 'RequestReviewQuestion', readonly title: string, readonly description: string }, readonly licenseOrCertificationIntentionQuestion: { readonly __typename?: 'RequestReviewQuestion', readonly title: string, readonly description: string }, readonly licenseOrCertificationDateQuestion: { readonly __typename?: 'RequestReviewQuestion', readonly title: string, readonly description: string }, readonly followingStepQuestion: { readonly __typename?: 'RequestReviewQuestion', readonly title: string, readonly description: string } }, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly state?: string | null, readonly wizardCompleted: boolean, readonly yearsOfExp?: number | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly abbreviation: string, readonly key?: string | null, readonly name: string, readonly type?: RoleType | null } | null, readonly activationRequest: { readonly __typename?: 'ActivationRequest', readonly id: string, readonly earliestStartDateAt?: GraphQLISO8601Date | null, readonly notes?: string | null, readonly requiredExperience?: boolean | null, readonly requiredExperienceDateAt?: GraphQLISO8601Date | null, readonly followingStepQuestion?: string | null, readonly advocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly phone?: string | null, readonly firstName?: string | null, readonly lastName?: string | null, readonly profileImgUrl: string, readonly isNurseAdvocate?: boolean | null, readonly isAlliedAdvocate?: boolean | null, readonly clinicalRole?: string | null } | null } } | null };

export type TrackFacilityPageViewUserFragment = { readonly __typename?: 'User', readonly id: string, readonly email: string };

export type TrackFacilityPageViewFacilityFragment = { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly city?: string | null, readonly state?: string | null };

export type AnalyticsUserFragment = { readonly __typename?: 'User', readonly id: string, readonly uuid: string, readonly email: string, readonly intercomUserHash?: string | null };

export type CeuTrackerQueryVariables = Exact<{ [key: string]: never; }>;


export type CeuTrackerQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly email: string, readonly intercomUserHash?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly ceuGoals?: ReadonlyArray<{ readonly __typename?: 'CeuGoal', readonly id: string, readonly goalType?: string | null, readonly requiredContactHours: number, readonly startDate: GraphQLISO8601Date, readonly endDate?: GraphQLISO8601Date | null, readonly description?: string | null, readonly systemCreated: boolean, readonly accepted: boolean, readonly deleted: boolean, readonly completedContactHours: number, readonly ceuStateRequirement?: { readonly __typename?: 'CeuStateRequirement', readonly id: string, readonly state: string, readonly requiredContactHours?: number | null, readonly notes?: string | null, readonly requirementQuantity?: number | null, readonly requirementDescription?: ReadonlyArray<string> | null, readonly stateBonUrl?: string | null, readonly durationDays?: number | null, readonly licenseType?: string | null } | null, readonly ceuCertificates: ReadonlyArray<{ readonly __typename?: 'CeuCertificate', readonly id: string }> }> | null, readonly ceuCertificates: ReadonlyArray<{ readonly __typename?: 'CeuCertificate', readonly id: string, readonly name: string, readonly contactHours: number, readonly ceuCertificateType: CeuCertificateType, readonly completionDate: GraphQLISO8601Date, readonly providerNumber: string, readonly files: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> }> } | null } | null };

export type CredentialsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type CredentialsPageQuery = { readonly __typename?: 'Query', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly state?: string | null, readonly numExpiredCredentials?: number | null, readonly numExpiringCredentials?: number | null, readonly numTotalCredentials?: number | null } | null, readonly clinicianCredentialsOverview?: { readonly __typename?: 'ClinicianCredentialsOverview', readonly id: string, readonly credentialExpiredCount: number, readonly credentialExpiringCount: number, readonly credentialTotalCount: number } | null };

export type ExplorerPageUserFragment = { readonly __typename?: 'User', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly intercomUserHash?: string | null, readonly email: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nurseType?: string | null, readonly canViewJobs: boolean, readonly yearsOfExp?: number | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly key?: string | null, readonly name: string, readonly type?: RoleType | null } | null, readonly licenses?: ReadonlyArray<{ readonly __typename?: 'License', readonly id: string, readonly licenseType?: string | null }> | null, readonly educations?: ReadonlyArray<{ readonly __typename?: 'Education', readonly id: string, readonly locationString?: string | null }> | null, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly explorerRole?: string | null, readonly locations?: ReadonlyArray<{ readonly __typename?: 'Location', readonly id: string, readonly locationString?: string | null }> | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly locationString?: string | null } | null, readonly businesses?: ReadonlyArray<{ readonly __typename?: 'Facility', readonly name: string, readonly address: string, readonly state?: string | null, readonly id: string, readonly slug: string, readonly city?: string | null, readonly hospital?: { readonly __typename?: 'Hospital', readonly id: string, readonly hospitalSystem?: string | null } | null, readonly residencyPrograms?: ReadonlyArray<{ readonly __typename?: 'ResidencyProgram', readonly id: string, readonly name?: string | null }> | null }> | null, readonly searchHistory?: { readonly __typename?: 'SearchHistory', readonly id: string, readonly searchForm: string, readonly searchHistoryEntries: ReadonlyArray<{ readonly __typename?: 'SearchHistoryEntry', readonly id: string, readonly searchParams: string }> } | null } | null };

export type NurseProfileBusinessFragment = { readonly __typename?: 'Facility', readonly id: string, readonly slug: string, readonly name: string, readonly address: string, readonly city?: string | null, readonly state?: string | null, readonly hospital?: { readonly __typename?: 'Hospital', readonly id: string, readonly hospitalSystem?: string | null } | null, readonly residencyPrograms?: ReadonlyArray<{ readonly __typename?: 'ResidencyProgram', readonly id: string, readonly name?: string | null }> | null };

export type ExplorerPageQueryVariables = Exact<{
  searchForm: Scalars['String']['input'];
  loggedIn: Scalars['Boolean']['input'];
}>;


export type ExplorerPageQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly intercomUserHash?: string | null, readonly email: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nurseType?: string | null, readonly canViewJobs: boolean, readonly yearsOfExp?: number | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly key?: string | null, readonly name: string, readonly type?: RoleType | null } | null, readonly licenses?: ReadonlyArray<{ readonly __typename?: 'License', readonly id: string, readonly licenseType?: string | null }> | null, readonly educations?: ReadonlyArray<{ readonly __typename?: 'Education', readonly id: string, readonly locationString?: string | null }> | null, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly explorerRole?: string | null, readonly locations?: ReadonlyArray<{ readonly __typename?: 'Location', readonly id: string, readonly locationString?: string | null }> | null } | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly locationString?: string | null } | null, readonly businesses?: ReadonlyArray<{ readonly __typename?: 'Facility', readonly name: string, readonly address: string, readonly state?: string | null, readonly id: string, readonly slug: string, readonly city?: string | null, readonly hospital?: { readonly __typename?: 'Hospital', readonly id: string, readonly hospitalSystem?: string | null } | null, readonly residencyPrograms?: ReadonlyArray<{ readonly __typename?: 'ResidencyProgram', readonly id: string, readonly name?: string | null }> | null }> | null, readonly searchHistory?: { readonly __typename?: 'SearchHistory', readonly id: string, readonly searchForm: string, readonly searchHistoryEntries: ReadonlyArray<{ readonly __typename?: 'SearchHistoryEntry', readonly id: string, readonly searchParams: string }> } | null } | null } | null };

export type FacilityPageQueryVariables = Exact<{
  facilitySlug: Scalars['String']['input'];
  loggedIn: Scalars['Boolean']['input'];
  statsSource?: InputMaybe<Scalars['String']['input']>;
  statsIds?: InputMaybe<ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type FacilityPageQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly uuid: string, readonly email: string, readonly intercomUserHash?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nurseType?: string | null, readonly savedFacility: boolean } | null } | null, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly slug: string, readonly name: string, readonly city?: string | null, readonly state?: string | null, readonly latitude: number, readonly longitude: number, readonly address: string, readonly zipcode?: string | null, readonly logo?: string | null, readonly dhcProviderWebsite?: string | null, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly city?: string | null, readonly stateName?: string | null } | null, readonly rankings?: ReadonlyArray<{ readonly __typename?: 'UsnewsRanking', readonly id: string, readonly usnewsType: string, readonly rank?: number | null, readonly specialtyName?: string | null }> | null, readonly residencyPrograms?: ReadonlyArray<{ readonly __typename?: 'ResidencyProgram', readonly id: string, readonly accreditingBody?: string | null, readonly name?: string | null, readonly url?: string | null, readonly offersAllSpecialties: boolean, readonly clinicalSpecialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly displayName: string }> | null }> | null, readonly nearbyFacilities?: ReadonlyArray<{ readonly __typename?: 'NearbyFacility', readonly distance?: number | null, readonly facility: { readonly __typename?: 'Facility', readonly id: string, readonly slug: string, readonly logo?: string | null, readonly name: string, readonly city?: string | null, readonly state?: string | null } }> | null, readonly costOfLivingStats?: ReadonlyArray<{ readonly __typename?: 'Stat', readonly statId: string, readonly statName: string, readonly valueFloat?: number | null }> | null, readonly hospital?: { readonly __typename?: 'Hospital', readonly id: string, readonly hospitalType?: string | null, readonly totalLicensedBeds?: number | null, readonly traumaCenterLevel?: number | null, readonly jointCommission: boolean, readonly magnet: boolean, readonly teaching: boolean, readonly affiliatedUnion?: string | null, readonly hospitalSystem?: string | null } | null, readonly walkscoreByCoordinates?: { readonly __typename?: 'Walkscore', readonly walkScore?: number | null, readonly walkDescription?: string | null, readonly walkExtraInfo?: string | null, readonly transitScore?: number | null, readonly transitDescription?: string | null, readonly transitExtraInfo?: string | null, readonly bikeScore?: number | null, readonly bikeDescription?: string | null, readonly bikeExtraInfo?: string | null } | null, readonly cityWalkscore?: { readonly __typename?: 'Walkscore', readonly walkScore?: number | null, readonly walkDescription?: string | null, readonly walkExtraInfo?: string | null, readonly transitScore?: number | null, readonly transitDescription?: string | null, readonly transitExtraInfo?: string | null, readonly bikeScore?: number | null, readonly bikeDescription?: string | null, readonly bikeExtraInfo?: string | null } | null, readonly surveyForUser?: { readonly __typename?: 'FacilitySurveyResponse', readonly completedAt?: GraphQLISO8601Date | null } | null } | null };

export type IndexPageQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type IndexPageQueryQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly uuid: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly isOnboarding: boolean, readonly uuid?: string | null, readonly wizardCompleted: boolean, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly percentCompleted: number } } | null } | null } | null };

export type IndexPageUserFragment = { readonly __typename?: 'User', readonly id: string, readonly uuid: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly isOnboarding: boolean, readonly uuid?: string | null, readonly wizardCompleted: boolean, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly percentCompleted: number } } | null } | null };

export type InviteUserFragment = { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly saasquatchToken?: string | null, readonly referredByUuid?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly squatchShareUrl?: string | null } | null };

export type InvitePageQueryVariables = Exact<{ [key: string]: never; }>;


export type InvitePageQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly saasquatchToken?: string | null, readonly referredByUuid?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly squatchShareUrl?: string | null } | null } | null };

export type BoardOfNursingUrlsQueryVariables = Exact<{ [key: string]: never; }>;


export type BoardOfNursingUrlsQuery = { readonly __typename?: 'Query', readonly boardOfNursingUrls: ReadonlyArray<{ readonly __typename?: 'BoardOfNursingUrl', readonly state: string, readonly url: string }> };

export type LoginPageQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type LoginPageQueryQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string } | null };

export type JobRuleValidationsQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
}>;


export type JobRuleValidationsQuery = { readonly __typename?: 'Query', readonly job?: { readonly __typename?: 'Job', readonly id: string, readonly ruleValidations?: ReadonlyArray<{ readonly __typename?: 'JobApplicationRequirementRuleEngineVerification', readonly type: string, readonly valid?: boolean | null, readonly errorMessages?: ReadonlyArray<string> | null }> | null, readonly requiredJarsV2?: ReadonlyArray<{ readonly __typename?: 'JobApplicationRequirementsCertification', readonly id: string, readonly type: string, readonly title?: string | null, readonly description?: string | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly credential?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly issuingBodies: ReadonlyArray<string> } } | { readonly __typename?: 'JobApplicationRequirementsCovidBooster' } | { readonly __typename?: 'JobApplicationRequirementsCovidVaccine' } | { readonly __typename?: 'JobApplicationRequirementsDriverLicense' } | { readonly __typename?: 'JobApplicationRequirementsEducation' } | { readonly __typename?: 'JobApplicationRequirementsFluVaccination' } | { readonly __typename?: 'JobApplicationRequirementsFluVaccine' } | { readonly __typename?: 'JobApplicationRequirementsLocationFloating' } | { readonly __typename?: 'JobApplicationRequirementsMaximumTimeOffRule' } | { readonly __typename?: 'JobApplicationRequirementsNurseReference' } | { readonly __typename?: 'JobApplicationRequirementsProofOfIdentification' } | { readonly __typename?: 'JobApplicationRequirementsRadiusRule' } | { readonly __typename?: 'JobApplicationRequirementsRoleExperience' } | { readonly __typename?: 'JobApplicationRequirementsStateLicense' } | { readonly __typename?: 'JobApplicationRequirementsTechnologyExperience' } | { readonly __typename?: 'JobApplicationRequirementsTraumaLevelExperience' } | { readonly __typename?: 'JobApplicationRequirementsTravelExperience' } | { readonly __typename?: 'JobApplicationRequirementsUnitExperience' } | { readonly __typename?: 'JobApplicationRequirementsUnitFloating' }> | null } | null };

export type NurseCertificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type NurseCertificationsQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly nurseCertifications?: ReadonlyArray<{ readonly __typename?: 'NurseCertification', readonly id: string, readonly name?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly completedOn?: GraphQLISO8601Date | null, readonly isExpired?: boolean | null, readonly isExpiringSoon?: boolean | null, readonly issuingBody?: string | null, readonly useCompletionDate?: boolean | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly name?: string | null, readonly issuingBodies: ReadonlyArray<string>, readonly credential?: string | null } }> | null } | null } | null };

export type StrengthenLicenseQueryVariables = Exact<{ [key: string]: never; }>;


export type StrengthenLicenseQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly licenses?: ReadonlyArray<{ readonly __typename?: 'License', readonly id: string, readonly uuid?: string | null, readonly licenseType?: string | null, readonly friendlyLicenseType?: string | null, readonly licensureCompact?: string | null, readonly compact?: boolean | null, readonly stateCode?: LocationUsStates | null, readonly state?: string | null, readonly number?: string | null, readonly expiresOn?: GraphQLISO8601Date | null, readonly title: string, readonly isExpired: boolean, readonly isExpiringSoon: boolean, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null }> | null } | null } | null };

export type StrengthenReferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type StrengthenReferencesQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly canApplyJobs: boolean, readonly numActiveReferences: number, readonly referencesComplete: boolean, readonly references?: ReadonlyArray<{ readonly __typename?: 'Reference', readonly id: string, readonly bedCount?: number | null, readonly chargeExp?: boolean | null, readonly email?: string | null, readonly expired: boolean, readonly facilityName?: string | null, readonly isLocked: boolean, readonly jobTitle?: string | null, readonly lastFailedDelivery?: GraphQLISO8601Date | null, readonly name?: string | null, readonly patientsPerNurse?: number | null, readonly phone?: string | null, readonly preferredContactMethod?: string | null, readonly relationship?: string | null, readonly responseAt?: GraphQLISO8601Date | null, readonly signedName?: string | null, readonly unit?: string | null, readonly unitName?: string | null, readonly files?: ReadonlyArray<{ readonly __typename?: 'File', readonly id: string, readonly contentType: string, readonly createdAt: GraphQLISO8601DateTime, readonly downloadUrl?: string | null, readonly filename: string, readonly previewUrl?: string | null, readonly viewUrl?: string | null }> | null, readonly position?: { readonly __typename?: 'Position', readonly id: string, readonly startAt?: GraphQLISO8601Date | null, readonly endAt?: GraphQLISO8601Date | null, readonly title: string, readonly usableForReferences: boolean, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly formattedLocationString?: string | null, readonly googlePlaceId?: string | null } | null } | null } | null }> | null, readonly positions?: ReadonlyArray<{ readonly __typename?: 'Position', readonly id: string, readonly startAt?: GraphQLISO8601Date | null, readonly endAt?: GraphQLISO8601Date | null, readonly usableForReferences: boolean, readonly facility?: { readonly __typename?: 'Facility', readonly id: string, readonly name: string, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly formattedLocationString?: string | null, readonly googlePlaceId?: string | null } | null } | null }> | null, readonly licenses?: ReadonlyArray<{ readonly __typename?: 'License', readonly id: string }> | null, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly meta: { readonly __typename?: 'ApplicationReadinessResultsMeta', readonly requirements: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly status: ApplicationReadinessStatus } }, readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly references: { readonly __typename?: 'ApplicationReadinessReferencesResult', readonly label: string, readonly status: ApplicationReadinessStatus, readonly completeReferenceCount: number, readonly pendingReferenceCount: number } } }, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly references: { readonly __typename?: 'ProfileCompletionStep', readonly status: ProfileCompletionStatusEnum } } } | null } | null } | null };

export type MatchesIndexPageQueryVariables = Exact<{ [key: string]: never; }>;


export type MatchesIndexPageQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly canViewJobs: boolean, readonly wizardCompleted: boolean, readonly isActivated?: boolean | null, readonly canApplyJobs: boolean, readonly state?: string | null, readonly percentComplete?: number | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly percentCompleted: number } } | null, readonly nurseAdvocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly email?: string | null, readonly fullName?: string | null } | null } | null } | null };

export type MatchesLandingPageNursePreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type MatchesLandingPageNursePreferencesQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly canViewJobs: boolean, readonly wizardCompleted: boolean, readonly activeClinicalSpecialties: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly slug: string }>, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly incompleteCount: number, readonly expiredCount: number, readonly percentCompleted: number, readonly pendingCount: number, readonly completeCount: number, readonly expiringCount: number }, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly backgroundQuestions: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly status: ProfileCompletionStatusEnum }, readonly certification: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly message?: string | null, readonly status: ProfileCompletionStatusEnum }, readonly education: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly message?: string | null, readonly status: ProfileCompletionStatusEnum }, readonly license: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly message?: string | null, readonly status: ProfileCompletionStatusEnum }, readonly permanentAddress: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly status: ProfileCompletionStatusEnum }, readonly personalInfo: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly status: ProfileCompletionStatusEnum }, readonly references: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly message?: string | null, readonly status: ProfileCompletionStatusEnum }, readonly skillsChecklist: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly message?: string | null, readonly status: ProfileCompletionStatusEnum }, readonly verifyEmail: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly status: ProfileCompletionStatusEnum }, readonly workExperience: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly status: ProfileCompletionStatusEnum }, readonly yearsOfExperience: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly status: ProfileCompletionStatusEnum } } } | null, readonly role?: { readonly __typename?: 'Role', readonly id: string } | null, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly broadPrefLocations?: ReadonlyArray<BroadPrefLocations> | null, readonly contractLengths?: ReadonlyArray<string> | null, readonly shiftPrefs?: ReadonlyArray<string> | null, readonly shiftLengths?: ReadonlyArray<string> | null, readonly locations?: ReadonlyArray<{ readonly __typename?: 'Location', readonly id: string, readonly locationString?: string | null }> | null } | null } | null } | null };

export type MatchesLandingPageNurseProfileFragment = { readonly __typename?: 'NurseProfile', readonly id: string, readonly canViewJobs: boolean, readonly wizardCompleted: boolean, readonly activeClinicalSpecialties: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly slug: string }>, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly incompleteCount: number, readonly expiredCount: number, readonly percentCompleted: number, readonly pendingCount: number, readonly completeCount: number, readonly expiringCount: number }, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly backgroundQuestions: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly status: ProfileCompletionStatusEnum }, readonly certification: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly message?: string | null, readonly status: ProfileCompletionStatusEnum }, readonly education: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly message?: string | null, readonly status: ProfileCompletionStatusEnum }, readonly license: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly message?: string | null, readonly status: ProfileCompletionStatusEnum }, readonly permanentAddress: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly status: ProfileCompletionStatusEnum }, readonly personalInfo: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly status: ProfileCompletionStatusEnum }, readonly references: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly message?: string | null, readonly status: ProfileCompletionStatusEnum }, readonly skillsChecklist: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly message?: string | null, readonly status: ProfileCompletionStatusEnum }, readonly verifyEmail: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly status: ProfileCompletionStatusEnum }, readonly workExperience: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly status: ProfileCompletionStatusEnum }, readonly yearsOfExperience: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly status: ProfileCompletionStatusEnum } } } | null, readonly role?: { readonly __typename?: 'Role', readonly id: string } | null, readonly nursePreferences?: { readonly __typename?: 'NursePreferences', readonly id: string, readonly broadPrefLocations?: ReadonlyArray<BroadPrefLocations> | null, readonly contractLengths?: ReadonlyArray<string> | null, readonly shiftPrefs?: ReadonlyArray<string> | null, readonly shiftLengths?: ReadonlyArray<string> | null, readonly locations?: ReadonlyArray<{ readonly __typename?: 'Location', readonly id: string, readonly locationString?: string | null }> | null } | null };

export type BucketConfigurationQueryVariables = Exact<{
  bucketUuid?: InputMaybe<Scalars['ID']['input']>;
  bucketKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type BucketConfigurationQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string } | null } | null, readonly bucketConfiguration?: { readonly __typename?: 'BucketConfiguration', readonly id: string, readonly key: string, readonly name: string } | null };

export type ProfilePageProfileCompletionFragment = { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly steps: { readonly __typename?: 'ProfileCompletionSteps', readonly backgroundQuestions: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly status: ProfileCompletionStatusEnum }, readonly certification: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly message?: string | null, readonly status: ProfileCompletionStatusEnum }, readonly education: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly message?: string | null, readonly status: ProfileCompletionStatusEnum }, readonly license: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly message?: string | null, readonly status: ProfileCompletionStatusEnum }, readonly permanentAddress: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly status: ProfileCompletionStatusEnum }, readonly personalInfo: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly status: ProfileCompletionStatusEnum }, readonly references: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly message?: string | null, readonly status: ProfileCompletionStatusEnum }, readonly skillsChecklist: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly message?: string | null, readonly status: ProfileCompletionStatusEnum }, readonly verifyEmail: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly status: ProfileCompletionStatusEnum }, readonly workExperience: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly status: ProfileCompletionStatusEnum }, readonly yearsOfExperience: { readonly __typename?: 'ProfileCompletionStep', readonly label: string, readonly status: ProfileCompletionStatusEnum } }, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly completeCount: number, readonly expiredCount: number, readonly expiringCount: number, readonly incompleteCount: number, readonly pendingCount: number, readonly percentCompleted: number } };

export type ProfilePageProfileCompletionMetaFragment = { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly completeCount: number, readonly expiredCount: number, readonly expiringCount: number, readonly incompleteCount: number, readonly pendingCount: number, readonly percentCompleted: number } };

export type AfterSignupRedirectWizardCompleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateNurseProfileInput;
}>;


export type AfterSignupRedirectWizardCompleteMutation = { readonly __typename?: 'Mutation', readonly updateNurseProfile?: { readonly __typename?: 'UpdateNurseProfilePayload', readonly nurseProfile: { readonly __typename?: 'NurseProfile', readonly id: string, readonly wizardCompleted: boolean, readonly state?: string | null } } | null };

export type AfterSignupRedirectQueryVariables = Exact<{ [key: string]: never; }>;


export type AfterSignupRedirectQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly wizardCompleted: boolean, readonly location?: { readonly __typename?: 'Location', readonly googlePlaceId?: string | null, readonly id: string, readonly locationString?: string | null } | null } | null } | null };

export type ApprovalFlowMissingStepQueryVariables = Exact<{ [key: string]: never; }>;


export type ApprovalFlowMissingStepQuery = { readonly __typename?: 'Query', readonly missingStep: { readonly __typename?: 'ApprovalFlowMissingStep', readonly name?: string | null, readonly forRoleType?: RoleType | null, readonly stage?: string | null, readonly flowCompleted: boolean } };

export type SignupQueryVariables = Exact<{
  type?: InputMaybe<RoleType>;
  loggedIn: Scalars['Boolean']['input'];
}>;


export type SignupQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly preferredName?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly wizardCompleted: boolean, readonly clinicalExperienceLevel?: ClinicalExperienceLevelTypes | null, readonly state?: string | null, readonly nurseType?: string | null, readonly clinicalSpecialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly specialty?: string | null }> | null, readonly location?: { readonly __typename?: 'Location', readonly id: string } | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly key?: string | null, readonly name: string, readonly type?: RoleType | null } | null } | null } | null, readonly roles?: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: string, readonly abbreviation: string, readonly key?: string | null, readonly name: string, readonly type?: RoleType | null }>, readonly __type?: { readonly __typename?: '__Type', readonly name?: string | null, readonly enumValues?: ReadonlyArray<{ readonly __typename?: '__EnumValue', readonly name: string, readonly description?: string | null }> | null } | null };

export type ExistingClinicianQueryVariables = Exact<{ [key: string]: never; }>;


export type ExistingClinicianQuery = { readonly __typename?: 'Query', readonly viewer?: { readonly __typename?: 'AdminUser' } | { readonly __typename?: 'User', readonly id: string } | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string } | null };

export type UserByEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
  csrfToken: Scalars['String']['input'];
}>;


export type UserByEmailQuery = { readonly __typename?: 'Query', readonly userByEmail: boolean };

export type UptimeQueryVariables = Exact<{ [key: string]: never; }>;


export type UptimeQuery = { readonly __typename?: 'Query', readonly roles: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: string, readonly name: string }> };

export type NearbyFacilityCardFacilityFragment = { readonly __typename?: 'Facility', readonly id: string, readonly slug: string, readonly logo?: string | null, readonly name: string, readonly city?: string | null, readonly state?: string | null };

export type FacilityUtilityFragment = { readonly __typename?: 'Facility', readonly name: string, readonly city?: string | null, readonly state?: string | null, readonly hospital?: { readonly __typename?: 'Hospital', readonly id: string, readonly hospitalType?: string | null, readonly totalLicensedBeds?: number | null, readonly traumaCenterLevel?: number | null, readonly magnet: boolean, readonly jointCommission: boolean, readonly teaching: boolean, readonly affiliatedUnion?: string | null } | null, readonly rankings?: ReadonlyArray<{ readonly __typename?: 'UsnewsRanking', readonly usnewsType: string }> | null, readonly residencyPrograms?: ReadonlyArray<{ readonly __typename?: 'ResidencyProgram', readonly id: string }> | null };

export type FacilityUtilityAccreditationInfoFragment = { readonly __typename?: 'Facility', readonly residencyPrograms?: ReadonlyArray<{ readonly __typename?: 'ResidencyProgram', readonly id: string }> | null, readonly hospital?: { readonly __typename?: 'Hospital', readonly id: string, readonly magnet: boolean, readonly jointCommission: boolean, readonly teaching: boolean, readonly affiliatedUnion?: string | null } | null };

export type FacilityUtilityRankingsFragment = { readonly __typename?: 'UsnewsRanking', readonly usnewsType: string };

export type JarRadiusRuleFragment = { readonly __typename?: 'JobApplicationRequirementsRadiusRule', readonly id: string, readonly type: string, readonly description?: string | null };

export type JarCertificationFragment = { readonly __typename?: 'JobApplicationRequirementsCertification', readonly id: string, readonly type: string, readonly title?: string | null, readonly description?: string | null, readonly certification: { readonly __typename?: 'Certification', readonly id: string, readonly credential?: string | null, readonly name?: string | null, readonly uuid?: string | null, readonly issuingBodies: ReadonlyArray<string> } };

export type JarNurseReferenceFragment = { readonly __typename?: 'JobApplicationRequirementsNurseReference', readonly id: string, readonly description?: string | null, readonly occurrences?: number | null, readonly timeframe?: number | null, readonly type: string };

export type JarDriverLicenseFragment = { readonly __typename?: 'JobApplicationRequirementsDriverLicense', readonly id: string, readonly required?: boolean | null, readonly type: string, readonly stage: JobApplicationRequirementStageEnum };

export type JarCovidVaccineFragment = { readonly __typename?: 'JobApplicationRequirementsCovidVaccine', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null };

export type JarCovidBoosterFragment = { readonly __typename?: 'JobApplicationRequirementsCovidBooster', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null };

export type JarFluVaccineFragment = { readonly __typename?: 'JobApplicationRequirementsFluVaccine', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null };

export type JarFluVaccinationFragment = { readonly __typename?: 'JobApplicationRequirementsFluVaccination', readonly id: string, readonly type: string, readonly stage: JobApplicationRequirementStageEnum, readonly description?: string | null };

export type JarLocationFloatingFragment = { readonly __typename?: 'JobApplicationRequirementsLocationFloating', readonly id: string, readonly type: string, readonly description?: string | null };

export type JarMaximumTimeOffRuleFragment = { readonly __typename?: 'JobApplicationRequirementsMaximumTimeOffRule', readonly id: string, readonly type: string, readonly maximumTimeOff: number, readonly description?: string | null };

export type JarUnitFloatingFragment = { readonly __typename?: 'JobApplicationRequirementsUnitFloating', readonly id: string, readonly type: string, readonly description?: string | null };

export type JarStateLicenseFragment = { readonly __typename?: 'JobApplicationRequirementsStateLicense', readonly id: string, readonly stage: JobApplicationRequirementStageEnum, readonly type: string, readonly description?: string | null };

export type JarTravelExperienceFragment = { readonly __typename?: 'JobApplicationRequirementsTravelExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null };

export type JarRoleExperienceFragment = { readonly __typename?: 'JobApplicationRequirementsRoleExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null };

export type JarUnitExperienceFragment = { readonly __typename?: 'JobApplicationRequirementsUnitExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null };

export type JarTechnologyExperienceFragment = { readonly __typename?: 'JobApplicationRequirementsTechnologyExperience', readonly id: string, readonly type: string, readonly months?: number | null, readonly description?: string | null, readonly technology: { readonly __typename?: 'Technology', readonly id: string, readonly uuid: string, readonly name: string } };

export type JarProofOfIdentificationFragment = { readonly __typename?: 'JobApplicationRequirementsProofOfIdentification', readonly id: string, readonly type: string, readonly description?: string | null, readonly required?: boolean | null, readonly stage: JobApplicationRequirementStageEnum };

export type JarTraumaLevelExperienceFragment = { readonly __typename?: 'JobApplicationRequirementsTraumaLevelExperience', readonly id: string, readonly type: string, readonly description?: string | null, readonly enforcementType: string };

export type JarEducationFragment = { readonly __typename?: 'JobApplicationRequirementsEducation', readonly id: string, readonly type: string, readonly description?: string | null, readonly enforcementType: string };

export type JobUtilsJobFragment = { readonly __typename?: 'Job', readonly id: string, readonly radiusRule?: number | null, readonly travelAllowed: boolean, readonly localAllowed: boolean, readonly grossPayWeekly?: number | null, readonly localGrossPayWeekly?: number | null, readonly jobType?: string | null, readonly role?: string | null, readonly jarRadiusRuleV2?: { readonly __typename?: 'JobApplicationRequirementsRadiusRule', readonly id: string, readonly type: string, readonly description?: string | null } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly roles?: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: string, readonly name: string, readonly key?: string | null, readonly type?: RoleType | null }> | null };

export type JobUtilsPayRateJobFragment = { readonly __typename?: 'Job', readonly id: string, readonly travelAllowed: boolean, readonly localAllowed: boolean, readonly grossPayWeekly?: number | null, readonly jobType?: string | null, readonly localGrossPayWeekly?: number | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null, readonly localPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null };

export type ShouldRedirectUserFragment = { readonly __typename?: 'User', readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly canViewJobs: boolean, readonly wizardCompleted: boolean } | null };

export type JobApplicationEventsUserFragment = { readonly __typename?: 'User', readonly id: string, readonly email: string };

export type JobApplicationEventsNurseProfileFragment = { readonly __typename?: 'NurseProfile', readonly id: string, readonly isActivated?: boolean | null, readonly state?: string | null, readonly percentComplete?: number | null, readonly applicationReadiness: { readonly __typename?: 'ApplicationReadiness', readonly results: { readonly __typename?: 'ApplicationReadinessResults', readonly background: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly label: string, readonly status: ApplicationReadinessStatus }, readonly certifications: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly label: string, readonly status: ApplicationReadinessStatus }, readonly education: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly label: string, readonly status: ApplicationReadinessStatus }, readonly employment: { readonly __typename?: 'ApplicationReadinessEmploymentResult', readonly label: string, readonly status: ApplicationReadinessStatus }, readonly licenses: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly label: string, readonly status: ApplicationReadinessStatus }, readonly references: { readonly __typename?: 'ApplicationReadinessReferencesResult', readonly label: string, readonly status: ApplicationReadinessStatus, readonly completeReferenceCount: number }, readonly skillsChecklist: { readonly __typename?: 'ApplicationReadinessBaseResult', readonly label: string, readonly status: ApplicationReadinessStatus } } }, readonly nurseAdvocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly email?: string | null, readonly fullName?: string | null } | null, readonly profileCompletion?: { readonly __typename?: 'NurseProfileCompletion', readonly id: string, readonly meta: { readonly __typename?: 'ProfileCompletionMeta', readonly id: string, readonly percentCompleted: number } } | null };

export type JobApplicationEventsJobFragment = { readonly __typename?: 'Job', readonly id: string, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly shiftsPerWeek?: number | null, readonly shiftType?: string | null, readonly startDate?: GraphQLISO8601Date | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly business?: { readonly __typename?: 'Facility', readonly id: string, readonly city?: string | null, readonly logo?: string | null, readonly name: string, readonly state?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null };

export type UserViewedMatchEventUserFragment = { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly percentComplete?: number | null, readonly nurseAdvocate?: { readonly __typename?: 'SalesforceUser', readonly id: string, readonly email?: string | null, readonly fullName?: string | null } | null } | null };

export type UserViewedMatchEventJobFragment = { readonly __typename?: 'Job', readonly id: string, readonly activeApplicantsCount?: number | null, readonly favoritedCount?: number | null, readonly grossPayWeekly?: number | null, readonly hoursPerShift?: number | null, readonly instantOffer: boolean, readonly jobType?: string | null, readonly lengthInWeeks?: number | null, readonly shiftsPerWeek?: number | null, readonly shiftType?: string | null, readonly startDate?: GraphQLISO8601Date | null, readonly stateActiveAt?: GraphQLISO8601DateTime | null, readonly title?: string | null, readonly business?: { readonly __typename?: 'Facility', readonly id: string, readonly city?: string | null, readonly name: string, readonly logo?: string | null, readonly state?: string | null } | null, readonly clinicalUnit?: { readonly __typename?: 'ClinicalUnit', readonly id: string, readonly displayName: string } | null, readonly defaultPaymentDetails?: { readonly __typename?: 'JobPaymentDetails', readonly id: string, readonly grossPayWeekly?: number | null } | null };

export type ClinicianSignupInitialPathFragment = { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly preferredName?: string | null, readonly nurseProfile?: { readonly __typename?: 'NurseProfile', readonly id: string, readonly clinicalExperienceLevel?: ClinicalExperienceLevelTypes | null, readonly state?: string | null, readonly nurseType?: string | null, readonly clinicalSpecialties?: ReadonlyArray<{ readonly __typename?: 'ClinicalSpecialty', readonly id: string, readonly specialty?: string | null }> | null, readonly location?: { readonly __typename?: 'Location', readonly id: string } | null, readonly role?: { readonly __typename?: 'Role', readonly id: string, readonly key?: string | null, readonly name: string, readonly type?: RoleType | null } | null } | null };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: DocumentTypeDecoration<TResult, TVariables>['__apiType'];
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const AdvocateFragmentDoc = new TypedDocumentString(`
    fragment Advocate on NurseProfile {
  id
  nurseAdvocate {
    id
    profileImgUrl
    email
    firstName
    phone
    fullName
  }
}
    `, {"fragmentName":"Advocate"}) as unknown as TypedDocumentString<AdvocateFragment, unknown>;
export const ClinicianFragmentDoc = new TypedDocumentString(`
    fragment Clinician on NurseProfile {
  id
  canUploadResume
  state
  nurseType
  wizardCompleted
  role {
    id
    key
    name
    type
  }
}
    `, {"fragmentName":"Clinician"}) as unknown as TypedDocumentString<ClinicianFragment, unknown>;
export const HospitalInSuggestionFragmentDoc = new TypedDocumentString(`
    fragment HospitalInSuggestion on Hospital {
  id
  nicuTraumaLevel
  pediatricTraumaCenterLevel
  totalLicensedBeds
  magnet
  teaching
  traumaCenter
  traumaCenterLevel
  technology {
    id
    name
  }
}
    `, {"fragmentName":"HospitalInSuggestion"}) as unknown as TypedDocumentString<HospitalInSuggestionFragment, unknown>;
export const FacilitySuggestionFragmentDoc = new TypedDocumentString(`
    fragment FacilitySuggestion on Facility {
  id
  address
  city
  name
  state
  uuid
  zipcode
  hospital {
    ...HospitalInSuggestion
  }
}
    fragment HospitalInSuggestion on Hospital {
  id
  nicuTraumaLevel
  pediatricTraumaCenterLevel
  totalLicensedBeds
  magnet
  teaching
  traumaCenter
  traumaCenterLevel
  technology {
    id
    name
  }
}`, {"fragmentName":"FacilitySuggestion"}) as unknown as TypedDocumentString<FacilitySuggestionFragment, unknown>;
export const ProfileCompletionSummaryFragmentDoc = new TypedDocumentString(`
    fragment ProfileCompletionSummary on ProfileCompletionSummary {
  id
  completedAt
  meta {
    id
    completeCount
    expiredCount
    expiringCount
    incompleteCount
    pendingCount
    percentCompleted
  }
  steps {
    estimatedTimeInMinutes
    key
    title
    subtitle
    messages
    sectionName
    status
    hasExpiringItems
    hasExpiredItems
    hasInvalidItems
  }
}
    `, {"fragmentName":"ProfileCompletionSummary"}) as unknown as TypedDocumentString<ProfileCompletionSummaryFragment, unknown>;
export const SmsVerificationUserFragmentDoc = new TypedDocumentString(`
    fragment SMSVerificationUser on User {
  id
  phone
  phoneVerified
  marketingSmsAllowed
}
    `, {"fragmentName":"SMSVerificationUser"}) as unknown as TypedDocumentString<SmsVerificationUserFragment, unknown>;
export const EnumValueFragmentDoc = new TypedDocumentString(`
    fragment EnumValue on __EnumValue {
  name
  description
}
    `, {"fragmentName":"EnumValue"}) as unknown as TypedDocumentString<EnumValueFragment, unknown>;
export const EnumValuesTypeFragmentDoc = new TypedDocumentString(`
    fragment EnumValuesType on __Type {
  name
  enumValues {
    ...EnumValue
  }
}
    fragment EnumValue on __EnumValue {
  name
  description
}`, {"fragmentName":"EnumValuesType"}) as unknown as TypedDocumentString<EnumValuesTypeFragment, unknown>;
export const IncreasedPayFragmentDoc = new TypedDocumentString(`
    fragment IncreasedPay on IncreasedPayBanner {
  title
  description
  note
  redirectTo
  cta
}
    `, {"fragmentName":"IncreasedPay"}) as unknown as TypedDocumentString<IncreasedPayFragment, unknown>;
export const BackgroundInfoNurseBackgroundQuestionFragmentDoc = new TypedDocumentString(`
    fragment BackgroundInfoNurseBackgroundQuestion on NurseBackgroundQuestion {
  id
  answer
  date
  explanation
  licenseAffected
  open
  questionType
}
    `, {"fragmentName":"BackgroundInfoNurseBackgroundQuestion"}) as unknown as TypedDocumentString<BackgroundInfoNurseBackgroundQuestionFragment, unknown>;
export const BackgroundInfoUserFragmentDoc = new TypedDocumentString(`
    fragment BackgroundInfoUser on User {
  id
  nurseProfile {
    id
    state
    backgroundComplete
    backgroundQuestions {
      ...BackgroundInfoNurseBackgroundQuestion
    }
    applicationReadiness {
      results {
        background {
          status
        }
      }
    }
    profileCompletion {
      id
      steps {
        backgroundQuestions {
          message
          label
          status
        }
      }
    }
  }
}
    fragment BackgroundInfoNurseBackgroundQuestion on NurseBackgroundQuestion {
  id
  answer
  date
  explanation
  licenseAffected
  open
  questionType
}`, {"fragmentName":"BackgroundInfoUser"}) as unknown as TypedDocumentString<BackgroundInfoUserFragment, unknown>;
export const FileMetadataFragmentDoc = new TypedDocumentString(`
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
    `, {"fragmentName":"FileMetadata"}) as unknown as TypedDocumentString<FileMetadataFragment, unknown>;
export const CeuCertificatesListItemCeuCertificateFragmentDoc = new TypedDocumentString(`
    fragment CeuCertificatesListItemCeuCertificate on CeuCertificate {
  id
  name
  contactHours
  ceuCertificateType
  completionDate
  providerNumber
  files {
    ...FileMetadata
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}`, {"fragmentName":"CeuCertificatesListItemCeuCertificate"}) as unknown as TypedDocumentString<CeuCertificatesListItemCeuCertificateFragment, unknown>;
export const CeuGoalFormCeuGoalFragmentDoc = new TypedDocumentString(`
    fragment CeuGoalFormCeuGoal on CeuGoal {
  id
  goalType
  requiredContactHours
  startDate
  endDate
  description
  ceuStateRequirement {
    id
  }
  ceuCertificates {
    id
  }
}
    `, {"fragmentName":"CeuGoalFormCeuGoal"}) as unknown as TypedDocumentString<CeuGoalFormCeuGoalFragment, unknown>;
export const CeuGoalsTrackerCeuGoalFragmentDoc = new TypedDocumentString(`
    fragment CeuGoalsTrackerCeuGoal on CeuGoal {
  id
  goalType
  accepted
  deleted
  requiredContactHours
  startDate
  endDate
  systemCreated
  description
  completedContactHours
  ceuStateRequirement {
    id
    state
    requirementDescription
  }
  ...CeuGoalFormCeuGoal
}
    fragment CeuGoalFormCeuGoal on CeuGoal {
  id
  goalType
  requiredContactHours
  startDate
  endDate
  description
  ceuStateRequirement {
    id
  }
  ceuCertificates {
    id
  }
}`, {"fragmentName":"CeuGoalsTrackerCeuGoal"}) as unknown as TypedDocumentString<CeuGoalsTrackerCeuGoalFragment, unknown>;
export const CeuCertificatesListNurseProfileFragmentDoc = new TypedDocumentString(`
    fragment CeuCertificatesListNurseProfile on NurseProfile {
  id
  ceuCertificates {
    id
    ...CeuCertificatesListItemCeuCertificate
  }
  ceuGoals {
    id
    ...CeuGoalsTrackerCeuGoal
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment CeuCertificatesListItemCeuCertificate on CeuCertificate {
  id
  name
  contactHours
  ceuCertificateType
  completionDate
  providerNumber
  files {
    ...FileMetadata
  }
}
fragment CeuGoalFormCeuGoal on CeuGoal {
  id
  goalType
  requiredContactHours
  startDate
  endDate
  description
  ceuStateRequirement {
    id
  }
  ceuCertificates {
    id
  }
}
fragment CeuGoalsTrackerCeuGoal on CeuGoal {
  id
  goalType
  accepted
  deleted
  requiredContactHours
  startDate
  endDate
  systemCreated
  description
  completedContactHours
  ceuStateRequirement {
    id
    state
    requirementDescription
  }
  ...CeuGoalFormCeuGoal
}`, {"fragmentName":"CeuCertificatesListNurseProfile"}) as unknown as TypedDocumentString<CeuCertificatesListNurseProfileFragment, unknown>;
export const CostOfLivingStatFragmentDoc = new TypedDocumentString(`
    fragment CostOfLivingStat on Stat {
  statId
  valueFloat
}
    `, {"fragmentName":"CostOfLivingStat"}) as unknown as TypedDocumentString<CostOfLivingStatFragment, unknown>;
export const BackgroundAndIdPanelDocumentFragmentDoc = new TypedDocumentString(`
    fragment BackgroundAndIdPanelDocument on Document {
  id
  title
  docType
  docSubtype
  expiresOn
  expirationType
  files {
    ...FileMetadata
  }
  stateCode
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}`, {"fragmentName":"BackgroundAndIdPanelDocument"}) as unknown as TypedDocumentString<BackgroundAndIdPanelDocumentFragment, unknown>;
export const BackgroundAndIdDocumentTableIdDocumentFragmentDoc = new TypedDocumentString(`
    fragment BackgroundAndIdDocumentTableIdDocument on Document {
  id
  title
  docType
  isExpirable
  isExpired
  isExpiringSoon
  expiresOn
  files {
    ...FileMetadata
  }
  ...BackgroundAndIdPanelDocument
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment BackgroundAndIdPanelDocument on Document {
  id
  title
  docType
  docSubtype
  expiresOn
  expirationType
  files {
    ...FileMetadata
  }
  stateCode
}`, {"fragmentName":"BackgroundAndIdDocumentTableIdDocument"}) as unknown as TypedDocumentString<BackgroundAndIdDocumentTableIdDocumentFragment, unknown>;
export const BackgroundAndIdDocumentTableNurseProfileFragmentDoc = new TypedDocumentString(`
    fragment BackgroundAndIdDocumentTableNurseProfile on NurseProfile {
  id
  idDocs {
    id
    ...BackgroundAndIdDocumentTableIdDocument
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment BackgroundAndIdDocumentTableIdDocument on Document {
  id
  title
  docType
  isExpirable
  isExpired
  isExpiringSoon
  expiresOn
  files {
    ...FileMetadata
  }
  ...BackgroundAndIdPanelDocument
}
fragment BackgroundAndIdPanelDocument on Document {
  id
  title
  docType
  docSubtype
  expiresOn
  expirationType
  files {
    ...FileMetadata
  }
  stateCode
}`, {"fragmentName":"BackgroundAndIdDocumentTableNurseProfile"}) as unknown as TypedDocumentString<BackgroundAndIdDocumentTableNurseProfileFragment, unknown>;
export const BackgroundAndIdPanelDocumentTemplateFragmentDoc = new TypedDocumentString(`
    fragment BackgroundAndIdPanelDocumentTemplate on DocumentTemplate {
  id
  key
  name
  types
  expirationType
}
    `, {"fragmentName":"BackgroundAndIdPanelDocumentTemplate"}) as unknown as TypedDocumentString<BackgroundAndIdPanelDocumentTemplateFragment, unknown>;
export const BackgroundAndIdDocumentTableDocumentTemplateFragmentDoc = new TypedDocumentString(`
    fragment BackgroundAndIdDocumentTableDocumentTemplate on DocumentTemplate {
  id
  key
  name
  types
  expirationType
  ...BackgroundAndIdPanelDocumentTemplate
}
    fragment BackgroundAndIdPanelDocumentTemplate on DocumentTemplate {
  id
  key
  name
  types
  expirationType
}`, {"fragmentName":"BackgroundAndIdDocumentTableDocumentTemplate"}) as unknown as TypedDocumentString<BackgroundAndIdDocumentTableDocumentTemplateFragment, unknown>;
export const CertificationsTableRowNurseCertificationFragmentDoc = new TypedDocumentString(`
    fragment CertificationsTableRowNurseCertification on NurseCertification {
  id
  issuingBody
  isExpiringSoon
  isExpired
  expiresOn
  files {
    ...FileMetadata
  }
  certification {
    id
    name
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}`, {"fragmentName":"CertificationsTableRowNurseCertification"}) as unknown as TypedDocumentString<CertificationsTableRowNurseCertificationFragment, unknown>;
export const HealthDocumentsTableHealthDocFragmentDoc = new TypedDocumentString(`
    fragment HealthDocumentsTableHealthDoc on NurseHealthDoc {
  id
  isExpired
  isExpiringSoon
  category
  completedOn
  files {
    ...FileMetadata
  }
  healthDoc {
    id
    name
    categories
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}`, {"fragmentName":"HealthDocumentsTableHealthDoc"}) as unknown as TypedDocumentString<HealthDocumentsTableHealthDocFragment, unknown>;
export const LicensesTableItemLicenseFragmentDoc = new TypedDocumentString(`
    fragment LicensesTableItemLicense on License {
  id
  number
  state
  licensureCompact
  isExpiringSoon
  isExpired
  expiresOn
  friendlyLicenseType
  files {
    ...FileMetadata
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}`, {"fragmentName":"LicensesTableItemLicense"}) as unknown as TypedDocumentString<LicensesTableItemLicenseFragment, unknown>;
export const LicensesTableVerificationItemLicenseVerificationFragmentDoc = new TypedDocumentString(`
    fragment LicensesTableVerificationItemLicenseVerification on NurseLicenseVerification {
  id
  state
  states
  verificationType
  expiresOn
  isExpired
  isExpiringSoon
  dateOfDownload
  files {
    ...FileMetadata
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}`, {"fragmentName":"LicensesTableVerificationItemLicenseVerification"}) as unknown as TypedDocumentString<LicensesTableVerificationItemLicenseVerificationFragment, unknown>;
export const MiscDocumentsTableDocumentFragmentDoc = new TypedDocumentString(`
    fragment MiscDocumentsTableDocument on Document {
  id
  title
  docType
  expiresOn
  isExpired
  isExpiringSoon
  files {
    ...FileMetadata
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}`, {"fragmentName":"MiscDocumentsTableDocument"}) as unknown as TypedDocumentString<MiscDocumentsTableDocumentFragment, unknown>;
export const AssessmentItemFragmentDoc = new TypedDocumentString(`
    fragment AssessmentItem on Assessment {
  id
  category
  issuingBody
  name
}
    `, {"fragmentName":"AssessmentItem"}) as unknown as TypedDocumentString<AssessmentItemFragment, unknown>;
export const NurseAssessmentsTableNurseAssessmentFragmentDoc = new TypedDocumentString(`
    fragment NurseAssessmentsTableNurseAssessment on NurseAssessment {
  id
  completedOn
  expiresOn
  isArchived
  isExpired
  isExpiringSoon
  score
  assessment {
    ...AssessmentItem
  }
  files {
    ...FileMetadata
  }
  assessmentRequest {
    id
    score
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment AssessmentItem on Assessment {
  id
  category
  issuingBody
  name
}`, {"fragmentName":"NurseAssessmentsTableNurseAssessment"}) as unknown as TypedDocumentString<NurseAssessmentsTableNurseAssessmentFragment, unknown>;
export const ExplorerPageHeaderLocationFragmentDoc = new TypedDocumentString(`
    fragment ExplorerPageHeaderLocation on Location {
  id
  city
  stateCode
}
    `, {"fragmentName":"ExplorerPageHeaderLocation"}) as unknown as TypedDocumentString<ExplorerPageHeaderLocationFragment, unknown>;
export const TrackFacilityPageViewFacilityFragmentDoc = new TypedDocumentString(`
    fragment TrackFacilityPageViewFacility on Facility {
  id
  name
  city
  state
}
    `, {"fragmentName":"TrackFacilityPageViewFacility"}) as unknown as TypedDocumentString<TrackFacilityPageViewFacilityFragment, unknown>;
export const FacilityResultCardFacilityFragmentDoc = new TypedDocumentString(`
    fragment FacilityResultCardFacility on Facility {
  id
  slug
  name
  logo
  city
  state
  hospital {
    id
    affiliatedUnion
    jointCommission
    magnet
    teaching
    totalLicensedBeds
    traumaCenterLevel
    hospitalType
  }
  residencyPrograms {
    id
  }
  rankings {
    id
    usnewsType
  }
  ...TrackFacilityPageViewFacility
}
    fragment TrackFacilityPageViewFacility on Facility {
  id
  name
  city
  state
}`, {"fragmentName":"FacilityResultCardFacility"}) as unknown as TypedDocumentString<FacilityResultCardFacilityFragment, unknown>;
export const FacilityGoogleMapFacilityFragmentDoc = new TypedDocumentString(`
    fragment FacilityGoogleMapFacility on Facility {
  id
  slug
  name
  logo
  latitude
  longitude
}
    `, {"fragmentName":"FacilityGoogleMapFacility"}) as unknown as TypedDocumentString<FacilityGoogleMapFacilityFragment, unknown>;
export const FacilitiesCardLocationFragmentDoc = new TypedDocumentString(`
    fragment FacilitiesCardLocation on Location {
  locationString
  latitude
  longitude
  facilities {
    id
    ...FacilityResultCardFacility
    ...FacilityGoogleMapFacility
  }
}
    fragment FacilityGoogleMapFacility on Facility {
  id
  slug
  name
  logo
  latitude
  longitude
}
fragment FacilityResultCardFacility on Facility {
  id
  slug
  name
  logo
  city
  state
  hospital {
    id
    affiliatedUnion
    jointCommission
    magnet
    teaching
    totalLicensedBeds
    traumaCenterLevel
    hospitalType
  }
  residencyPrograms {
    id
  }
  rankings {
    id
    usnewsType
  }
  ...TrackFacilityPageViewFacility
}
fragment TrackFacilityPageViewFacility on Facility {
  id
  name
  city
  state
}`, {"fragmentName":"FacilitiesCardLocation"}) as unknown as TypedDocumentString<FacilitiesCardLocationFragment, unknown>;
export const FacilitiesSearchItemSummaryFacilityFragmentDoc = new TypedDocumentString(`
    fragment FacilitiesSearchItemSummaryFacility on Facility {
  id
  hospital {
    id
    totalLicensedBeds
    traumaCenterLevel
    hospitalType
    affiliatedUnion
    teaching
    jointCommission
    magnet
  }
  residencyPrograms {
    id
    url
    accreditingBody
  }
}
    `, {"fragmentName":"FacilitiesSearchItemSummaryFacility"}) as unknown as TypedDocumentString<FacilitiesSearchItemSummaryFacilityFragment, unknown>;
export const FacilitiesSearchItemFacilityFragmentDoc = new TypedDocumentString(`
    fragment FacilitiesSearchItemFacility on Facility {
  id
  logo
  name
  state
  city
  ...FacilitiesSearchItemSummaryFacility
}
    fragment FacilitiesSearchItemSummaryFacility on Facility {
  id
  hospital {
    id
    totalLicensedBeds
    traumaCenterLevel
    hospitalType
    affiliatedUnion
    teaching
    jointCommission
    magnet
  }
  residencyPrograms {
    id
    url
    accreditingBody
  }
}`, {"fragmentName":"FacilitiesSearchItemFacility"}) as unknown as TypedDocumentString<FacilitiesSearchItemFacilityFragment, unknown>;
export const UsnewsRankingContainerUsnewsRankingFragmentDoc = new TypedDocumentString(`
    fragment UsnewsRankingContainerUsnewsRanking on UsnewsRanking {
  id
  rank
  specialtyName
  usnewsType
}
    `, {"fragmentName":"UsnewsRankingContainerUsnewsRanking"}) as unknown as TypedDocumentString<UsnewsRankingContainerUsnewsRankingFragment, unknown>;
export const FacilityPageUsnewsRankingFragmentDoc = new TypedDocumentString(`
    fragment FacilityPageUsnewsRanking on UsnewsRanking {
  id
  usnewsType
  ...UsnewsRankingContainerUsnewsRanking
}
    fragment UsnewsRankingContainerUsnewsRanking on UsnewsRanking {
  id
  rank
  specialtyName
  usnewsType
}`, {"fragmentName":"FacilityPageUsnewsRanking"}) as unknown as TypedDocumentString<FacilityPageUsnewsRankingFragment, unknown>;
export const ResidencyProgramsCardFragmentDoc = new TypedDocumentString(`
    fragment ResidencyProgramsCard on ResidencyProgram {
  id
  name
  accreditingBody
  url
  offersAllSpecialties
  clinicalSpecialties {
    id
    displayName
  }
}
    `, {"fragmentName":"ResidencyProgramsCard"}) as unknown as TypedDocumentString<ResidencyProgramsCardFragment, unknown>;
export const NearbyFacilityCardFacilityFragmentDoc = new TypedDocumentString(`
    fragment NearbyFacilityCardFacility on Facility {
  id
  slug
  logo
  name
  city
  state
}
    `, {"fragmentName":"NearbyFacilityCardFacility"}) as unknown as TypedDocumentString<NearbyFacilityCardFacilityFragment, unknown>;
export const NearbyFacilitiesCardFacilityFragmentDoc = new TypedDocumentString(`
    fragment NearbyFacilitiesCardFacility on NearbyFacility {
  distance
  facility {
    ...NearbyFacilityCardFacility
  }
}
    fragment NearbyFacilityCardFacility on Facility {
  id
  slug
  logo
  name
  city
  state
}`, {"fragmentName":"NearbyFacilitiesCardFacility"}) as unknown as TypedDocumentString<NearbyFacilitiesCardFacilityFragment, unknown>;
export const CostOfLivingFocusedStatFragmentDoc = new TypedDocumentString(`
    fragment CostOfLivingFocusedStat on Stat {
  statId
  statName
  valueFloat
}
    `, {"fragmentName":"CostOfLivingFocusedStat"}) as unknown as TypedDocumentString<CostOfLivingFocusedStatFragment, unknown>;
export const WalkscoreMapFragmentDoc = new TypedDocumentString(`
    fragment WalkscoreMap on Walkscore {
  walkScore
  walkDescription
  walkExtraInfo
  transitScore
  transitDescription
  transitExtraInfo
  bikeScore
  bikeDescription
  bikeExtraInfo
}
    `, {"fragmentName":"WalkscoreMap"}) as unknown as TypedDocumentString<WalkscoreMapFragment, unknown>;
export const WalkscoreMapFacilityFragmentDoc = new TypedDocumentString(`
    fragment WalkscoreMapFacility on Facility {
  latitude
  longitude
  name
  address
  city
  state
  zipcode
  walkscoreByCoordinates {
    ...WalkscoreMap
  }
  cityWalkscore {
    ...WalkscoreMap
  }
}
    fragment WalkscoreMap on Walkscore {
  walkScore
  walkDescription
  walkExtraInfo
  transitScore
  transitDescription
  transitExtraInfo
  bikeScore
  bikeDescription
  bikeExtraInfo
}`, {"fragmentName":"WalkscoreMapFacility"}) as unknown as TypedDocumentString<WalkscoreMapFacilityFragment, unknown>;
export const FacilityHospitalSummaryFeaturesFacilityFragmentDoc = new TypedDocumentString(`
    fragment FacilityHospitalSummaryFeaturesFacility on Hospital {
  id
  totalLicensedBeds
  traumaCenterLevel
  hospitalType
}
    `, {"fragmentName":"FacilityHospitalSummaryFeaturesFacility"}) as unknown as TypedDocumentString<FacilityHospitalSummaryFeaturesFacilityFragment, unknown>;
export const FacilitySummaryInformationFacilityFragmentDoc = new TypedDocumentString(`
    fragment FacilitySummaryInformationFacility on Facility {
  name
  address
  city
  state
  zipcode
  hospital {
    id
    hospitalSystem
  }
  dhcProviderWebsite
}
    `, {"fragmentName":"FacilitySummaryInformationFacility"}) as unknown as TypedDocumentString<FacilitySummaryInformationFacilityFragment, unknown>;
export const FacilitySummaryAccreditationsFacilityFragmentDoc = new TypedDocumentString(`
    fragment FacilitySummaryAccreditationsFacility on Facility {
  hospital {
    affiliatedUnion
    teaching
    jointCommission
    magnet
  }
  residencyPrograms {
    accreditingBody
  }
}
    `, {"fragmentName":"FacilitySummaryAccreditationsFacility"}) as unknown as TypedDocumentString<FacilitySummaryAccreditationsFacilityFragment, unknown>;
export const FacilityReviewPanelFacilityFragmentDoc = new TypedDocumentString(`
    fragment FacilityReviewPanelFacility on Facility {
  id
  name
  slug
}
    `, {"fragmentName":"FacilityReviewPanelFacility"}) as unknown as TypedDocumentString<FacilityReviewPanelFacilityFragment, unknown>;
export const FacilitySummarySurveyFacilityFragmentDoc = new TypedDocumentString(`
    fragment FacilitySummarySurveyFacility on Facility {
  id
  slug
  name
  surveyForUser {
    completedAt
  }
  ...FacilityReviewPanelFacility
}
    fragment FacilityReviewPanelFacility on Facility {
  id
  name
  slug
}`, {"fragmentName":"FacilitySummarySurveyFacility"}) as unknown as TypedDocumentString<FacilitySummarySurveyFacilityFragment, unknown>;
export const FacilitySummaryFacilityFragmentDoc = new TypedDocumentString(`
    fragment FacilitySummaryFacility on Facility {
  id
  slug
  logo
  residencyPrograms {
    id
  }
  hospital {
    id
    jointCommission
    magnet
    ...FacilityHospitalSummaryFeaturesFacility
  }
  ...FacilitySummaryInformationFacility
  ...FacilitySummaryAccreditationsFacility
  ...FacilitySummarySurveyFacility
}
    fragment FacilitySummarySurveyFacility on Facility {
  id
  slug
  name
  surveyForUser {
    completedAt
  }
  ...FacilityReviewPanelFacility
}
fragment FacilitySummaryInformationFacility on Facility {
  name
  address
  city
  state
  zipcode
  hospital {
    id
    hospitalSystem
  }
  dhcProviderWebsite
}
fragment FacilityHospitalSummaryFeaturesFacility on Hospital {
  id
  totalLicensedBeds
  traumaCenterLevel
  hospitalType
}
fragment FacilitySummaryAccreditationsFacility on Facility {
  hospital {
    affiliatedUnion
    teaching
    jointCommission
    magnet
  }
  residencyPrograms {
    accreditingBody
  }
}
fragment FacilityReviewPanelFacility on Facility {
  id
  name
  slug
}`, {"fragmentName":"FacilitySummaryFacility"}) as unknown as TypedDocumentString<FacilitySummaryFacilityFragment, unknown>;
export const FacilityPageFacilityFragmentDoc = new TypedDocumentString(`
    fragment FacilityPageFacility on Facility {
  id
  city
  state
  rankings {
    ...FacilityPageUsnewsRanking
  }
  location {
    id
    city
    stateName
  }
  residencyPrograms {
    ...ResidencyProgramsCard
  }
  nearbyFacilities {
    ...NearbyFacilitiesCardFacility
  }
  costOfLivingStats(source: $statsSource, statsIds: $statsIds) {
    ...CostOfLivingFocusedStat
  }
  ...WalkscoreMapFacility
  ...FacilitySummaryFacility
}
    fragment CostOfLivingFocusedStat on Stat {
  statId
  statName
  valueFloat
}
fragment FacilityPageUsnewsRanking on UsnewsRanking {
  id
  usnewsType
  ...UsnewsRankingContainerUsnewsRanking
}
fragment FacilitySummaryFacility on Facility {
  id
  slug
  logo
  residencyPrograms {
    id
  }
  hospital {
    id
    jointCommission
    magnet
    ...FacilityHospitalSummaryFeaturesFacility
  }
  ...FacilitySummaryInformationFacility
  ...FacilitySummaryAccreditationsFacility
  ...FacilitySummarySurveyFacility
}
fragment FacilitySummarySurveyFacility on Facility {
  id
  slug
  name
  surveyForUser {
    completedAt
  }
  ...FacilityReviewPanelFacility
}
fragment FacilitySummaryInformationFacility on Facility {
  name
  address
  city
  state
  zipcode
  hospital {
    id
    hospitalSystem
  }
  dhcProviderWebsite
}
fragment FacilityHospitalSummaryFeaturesFacility on Hospital {
  id
  totalLicensedBeds
  traumaCenterLevel
  hospitalType
}
fragment FacilitySummaryAccreditationsFacility on Facility {
  hospital {
    affiliatedUnion
    teaching
    jointCommission
    magnet
  }
  residencyPrograms {
    accreditingBody
  }
}
fragment NearbyFacilitiesCardFacility on NearbyFacility {
  distance
  facility {
    ...NearbyFacilityCardFacility
  }
}
fragment ResidencyProgramsCard on ResidencyProgram {
  id
  name
  accreditingBody
  url
  offersAllSpecialties
  clinicalSpecialties {
    id
    displayName
  }
}
fragment UsnewsRankingContainerUsnewsRanking on UsnewsRanking {
  id
  rank
  specialtyName
  usnewsType
}
fragment WalkscoreMapFacility on Facility {
  latitude
  longitude
  name
  address
  city
  state
  zipcode
  walkscoreByCoordinates {
    ...WalkscoreMap
  }
  cityWalkscore {
    ...WalkscoreMap
  }
}
fragment WalkscoreMap on Walkscore {
  walkScore
  walkDescription
  walkExtraInfo
  transitScore
  transitDescription
  transitExtraInfo
  bikeScore
  bikeDescription
  bikeExtraInfo
}
fragment FacilityReviewPanelFacility on Facility {
  id
  name
  slug
}
fragment NearbyFacilityCardFacility on Facility {
  id
  slug
  logo
  name
  city
  state
}`, {"fragmentName":"FacilityPageFacility"}) as unknown as TypedDocumentString<FacilityPageFacilityFragment, unknown>;
export const FacilityPageHeroContainerFragmentDoc = new TypedDocumentString(`
    fragment FacilityPageHeroContainer on Facility {
  id
  location {
    id
    city
    stateName
  }
}
    `, {"fragmentName":"FacilityPageHeroContainer"}) as unknown as TypedDocumentString<FacilityPageHeroContainerFragment, unknown>;
export const FacilityUtilityRankingsFragmentDoc = new TypedDocumentString(`
    fragment FacilityUtilityRankings on UsnewsRanking {
  usnewsType
}
    `, {"fragmentName":"FacilityUtilityRankings"}) as unknown as TypedDocumentString<FacilityUtilityRankingsFragment, unknown>;
export const FacilityUtilityAccreditationInfoFragmentDoc = new TypedDocumentString(`
    fragment FacilityUtilityAccreditationInfo on Facility {
  residencyPrograms {
    id
  }
  hospital {
    id
    magnet
    jointCommission
    teaching
    affiliatedUnion
  }
}
    `, {"fragmentName":"FacilityUtilityAccreditationInfo"}) as unknown as TypedDocumentString<FacilityUtilityAccreditationInfoFragment, unknown>;
export const FacilityUtilityFragmentDoc = new TypedDocumentString(`
    fragment FacilityUtility on Facility {
  name
  city
  state
  hospital {
    id
    hospitalType
    totalLicensedBeds
    traumaCenterLevel
  }
  rankings {
    ...FacilityUtilityRankings
  }
  ...FacilityUtilityAccreditationInfo
}
    fragment FacilityUtilityAccreditationInfo on Facility {
  residencyPrograms {
    id
  }
  hospital {
    id
    magnet
    jointCommission
    teaching
    affiliatedUnion
  }
}
fragment FacilityUtilityRankings on UsnewsRanking {
  usnewsType
}`, {"fragmentName":"FacilityUtility"}) as unknown as TypedDocumentString<FacilityUtilityFragment, unknown>;
export const FacilityLoggedInPageFacilityFragmentDoc = new TypedDocumentString(`
    fragment FacilityLoggedInPageFacility on Facility {
  id
  name
  ...FacilityPageFacility
  ...FacilityPageHeroContainer
  ...FacilityUtility
}
    fragment CostOfLivingFocusedStat on Stat {
  statId
  statName
  valueFloat
}
fragment FacilityPageFacility on Facility {
  id
  city
  state
  rankings {
    ...FacilityPageUsnewsRanking
  }
  location {
    id
    city
    stateName
  }
  residencyPrograms {
    ...ResidencyProgramsCard
  }
  nearbyFacilities {
    ...NearbyFacilitiesCardFacility
  }
  costOfLivingStats(source: $statsSource, statsIds: $statsIds) {
    ...CostOfLivingFocusedStat
  }
  ...WalkscoreMapFacility
  ...FacilitySummaryFacility
}
fragment FacilityPageUsnewsRanking on UsnewsRanking {
  id
  usnewsType
  ...UsnewsRankingContainerUsnewsRanking
}
fragment FacilityPageHeroContainer on Facility {
  id
  location {
    id
    city
    stateName
  }
}
fragment FacilitySummaryFacility on Facility {
  id
  slug
  logo
  residencyPrograms {
    id
  }
  hospital {
    id
    jointCommission
    magnet
    ...FacilityHospitalSummaryFeaturesFacility
  }
  ...FacilitySummaryInformationFacility
  ...FacilitySummaryAccreditationsFacility
  ...FacilitySummarySurveyFacility
}
fragment FacilitySummarySurveyFacility on Facility {
  id
  slug
  name
  surveyForUser {
    completedAt
  }
  ...FacilityReviewPanelFacility
}
fragment FacilitySummaryInformationFacility on Facility {
  name
  address
  city
  state
  zipcode
  hospital {
    id
    hospitalSystem
  }
  dhcProviderWebsite
}
fragment FacilityHospitalSummaryFeaturesFacility on Hospital {
  id
  totalLicensedBeds
  traumaCenterLevel
  hospitalType
}
fragment FacilitySummaryAccreditationsFacility on Facility {
  hospital {
    affiliatedUnion
    teaching
    jointCommission
    magnet
  }
  residencyPrograms {
    accreditingBody
  }
}
fragment NearbyFacilitiesCardFacility on NearbyFacility {
  distance
  facility {
    ...NearbyFacilityCardFacility
  }
}
fragment ResidencyProgramsCard on ResidencyProgram {
  id
  name
  accreditingBody
  url
  offersAllSpecialties
  clinicalSpecialties {
    id
    displayName
  }
}
fragment UsnewsRankingContainerUsnewsRanking on UsnewsRanking {
  id
  rank
  specialtyName
  usnewsType
}
fragment WalkscoreMapFacility on Facility {
  latitude
  longitude
  name
  address
  city
  state
  zipcode
  walkscoreByCoordinates {
    ...WalkscoreMap
  }
  cityWalkscore {
    ...WalkscoreMap
  }
}
fragment WalkscoreMap on Walkscore {
  walkScore
  walkDescription
  walkExtraInfo
  transitScore
  transitDescription
  transitExtraInfo
  bikeScore
  bikeDescription
  bikeExtraInfo
}
fragment FacilityReviewPanelFacility on Facility {
  id
  name
  slug
}
fragment NearbyFacilityCardFacility on Facility {
  id
  slug
  logo
  name
  city
  state
}
fragment FacilityUtility on Facility {
  name
  city
  state
  hospital {
    id
    hospitalType
    totalLicensedBeds
    traumaCenterLevel
  }
  rankings {
    ...FacilityUtilityRankings
  }
  ...FacilityUtilityAccreditationInfo
}
fragment FacilityUtilityAccreditationInfo on Facility {
  residencyPrograms {
    id
  }
  hospital {
    id
    magnet
    jointCommission
    teaching
    affiliatedUnion
  }
}
fragment FacilityUtilityRankings on UsnewsRanking {
  usnewsType
}`, {"fragmentName":"FacilityLoggedInPageFacility"}) as unknown as TypedDocumentString<FacilityLoggedInPageFacilityFragment, unknown>;
export const AnalyticsUserFragmentDoc = new TypedDocumentString(`
    fragment AnalyticsUser on User {
  id
  uuid
  email
  intercomUserHash
}
    `, {"fragmentName":"AnalyticsUser"}) as unknown as TypedDocumentString<AnalyticsUserFragment, unknown>;
export const TrackFacilityPageViewUserFragmentDoc = new TypedDocumentString(`
    fragment TrackFacilityPageViewUser on User {
  id
  email
}
    `, {"fragmentName":"TrackFacilityPageViewUser"}) as unknown as TypedDocumentString<TrackFacilityPageViewUserFragment, unknown>;
export const FacilityPageUserFragmentDoc = new TypedDocumentString(`
    fragment FacilityPageUser on User {
  id
  nurseProfile {
    id
    nurseType
    savedFacility(facilitySlug: $facilitySlug)
  }
  ...TrackFacilityPageViewUser
}
    fragment TrackFacilityPageViewUser on User {
  id
  email
}`, {"fragmentName":"FacilityPageUser"}) as unknown as TypedDocumentString<FacilityPageUserFragment, unknown>;
export const FacilityLoggedInPageUserFragmentDoc = new TypedDocumentString(`
    fragment FacilityLoggedInPageUser on User {
  id
  ...AnalyticsUser
  ...FacilityPageUser
}
    fragment FacilityPageUser on User {
  id
  nurseProfile {
    id
    nurseType
    savedFacility(facilitySlug: $facilitySlug)
  }
  ...TrackFacilityPageViewUser
}
fragment TrackFacilityPageViewUser on User {
  id
  email
}
fragment AnalyticsUser on User {
  id
  uuid
  email
  intercomUserHash
}`, {"fragmentName":"FacilityLoggedInPageUser"}) as unknown as TypedDocumentString<FacilityLoggedInPageUserFragment, unknown>;
export const FacilityLoggedOutPageFacilityFragmentDoc = new TypedDocumentString(`
    fragment FacilityLoggedOutPageFacility on Facility {
  id
  slug
  ...FacilityPageHeroContainer
  ...FacilityPageFacility
}
    fragment CostOfLivingFocusedStat on Stat {
  statId
  statName
  valueFloat
}
fragment FacilityPageFacility on Facility {
  id
  city
  state
  rankings {
    ...FacilityPageUsnewsRanking
  }
  location {
    id
    city
    stateName
  }
  residencyPrograms {
    ...ResidencyProgramsCard
  }
  nearbyFacilities {
    ...NearbyFacilitiesCardFacility
  }
  costOfLivingStats(source: $statsSource, statsIds: $statsIds) {
    ...CostOfLivingFocusedStat
  }
  ...WalkscoreMapFacility
  ...FacilitySummaryFacility
}
fragment FacilityPageUsnewsRanking on UsnewsRanking {
  id
  usnewsType
  ...UsnewsRankingContainerUsnewsRanking
}
fragment FacilityPageHeroContainer on Facility {
  id
  location {
    id
    city
    stateName
  }
}
fragment FacilitySummaryFacility on Facility {
  id
  slug
  logo
  residencyPrograms {
    id
  }
  hospital {
    id
    jointCommission
    magnet
    ...FacilityHospitalSummaryFeaturesFacility
  }
  ...FacilitySummaryInformationFacility
  ...FacilitySummaryAccreditationsFacility
  ...FacilitySummarySurveyFacility
}
fragment FacilitySummarySurveyFacility on Facility {
  id
  slug
  name
  surveyForUser {
    completedAt
  }
  ...FacilityReviewPanelFacility
}
fragment FacilitySummaryInformationFacility on Facility {
  name
  address
  city
  state
  zipcode
  hospital {
    id
    hospitalSystem
  }
  dhcProviderWebsite
}
fragment FacilityHospitalSummaryFeaturesFacility on Hospital {
  id
  totalLicensedBeds
  traumaCenterLevel
  hospitalType
}
fragment FacilitySummaryAccreditationsFacility on Facility {
  hospital {
    affiliatedUnion
    teaching
    jointCommission
    magnet
  }
  residencyPrograms {
    accreditingBody
  }
}
fragment NearbyFacilitiesCardFacility on NearbyFacility {
  distance
  facility {
    ...NearbyFacilityCardFacility
  }
}
fragment ResidencyProgramsCard on ResidencyProgram {
  id
  name
  accreditingBody
  url
  offersAllSpecialties
  clinicalSpecialties {
    id
    displayName
  }
}
fragment UsnewsRankingContainerUsnewsRanking on UsnewsRanking {
  id
  rank
  specialtyName
  usnewsType
}
fragment WalkscoreMapFacility on Facility {
  latitude
  longitude
  name
  address
  city
  state
  zipcode
  walkscoreByCoordinates {
    ...WalkscoreMap
  }
  cityWalkscore {
    ...WalkscoreMap
  }
}
fragment WalkscoreMap on Walkscore {
  walkScore
  walkDescription
  walkExtraInfo
  transitScore
  transitDescription
  transitExtraInfo
  bikeScore
  bikeDescription
  bikeExtraInfo
}
fragment FacilityReviewPanelFacility on Facility {
  id
  name
  slug
}
fragment NearbyFacilityCardFacility on Facility {
  id
  slug
  logo
  name
  city
  state
}`, {"fragmentName":"FacilityLoggedOutPageFacility"}) as unknown as TypedDocumentString<FacilityLoggedOutPageFacilityFragment, unknown>;
export const NurseProfileIntentFragmentDoc = new TypedDocumentString(`
    fragment NurseProfileIntent on NurseProfile {
  id
  staleIntent
  activationRequest {
    id
    earliestStartDateAt
  }
  nursePreferences {
    id
    startPref
    broadPrefLocations
    locations {
      id
      locationString
    }
  }
}
    `, {"fragmentName":"NurseProfileIntent"}) as unknown as TypedDocumentString<NurseProfileIntentFragment, unknown>;
export const IntentFormModalNursePreferencesFragmentDoc = new TypedDocumentString(`
    fragment IntentFormModalNursePreferences on NursePreferences {
  id
  startPref
  earliestStartDate
}
    `, {"fragmentName":"IntentFormModalNursePreferences"}) as unknown as TypedDocumentString<IntentFormModalNursePreferencesFragment, unknown>;
export const ReferralListReferralFragmentDoc = new TypedDocumentString(`
    fragment ReferralListReferral on Referral {
  firstName
  lastName
  status
  statusDate
}
    `, {"fragmentName":"ReferralListReferral"}) as unknown as TypedDocumentString<ReferralListReferralFragment, unknown>;
export const JobLocationBlockJobFragmentDoc = new TypedDocumentString(`
    fragment JobLocationBlockJob on Job {
  id
  location {
    id
    walkscore {
      bikeDescription
      bikeScore
      transitDescription
      transitScore
      walkDescription
      walkScore
    }
    weatherForecast {
      icon
      temperature
      temperatureHigh
      temperatureLow
    }
  }
}
    `, {"fragmentName":"JobLocationBlockJob"}) as unknown as TypedDocumentString<JobLocationBlockJobFragment, unknown>;
export const ContractFragmentDoc = new TypedDocumentString(`
    fragment Contract on Contract {
  id
  hoursPerShift
  shiftsPerWeek
  cancellationPolicy
  contractNotes
  contractStatus
  contractStartDate
  contractEndDate
  contractType
  shiftType
  currentGrossPayWeek
  baseRate
  lengthInWeeks
  job {
    id
    startDate
    endDate
    title
    facilityName
    clinicalUnit {
      id
      displayName
    }
    lengthInWeeks
    hoursPerShift
    shiftsPerWeek
    shiftType
    emr {
      id
      name
    }
  }
  jobPlacement {
    id
    nurseProfile {
      id
      name
      user {
        id
        email
      }
    }
  }
  timeOffs {
    id
    startDate
    endDate
    approvalStatus
  }
  jobApplication {
    id
    paymentDetails {
      id
      nonTaxableStipendWeekly
      taxableWageRateWeekly
      grossPayWeekly
    }
  }
  paymentDetails {
    id
    nonTaxableStipendWeekly
    taxableWageRateWeekly
    grossPayWeekly
  }
}
    `, {"fragmentName":"Contract"}) as unknown as TypedDocumentString<ContractFragment, unknown>;
export const ContractSignUrlFragmentDoc = new TypedDocumentString(`
    fragment ContractSignUrl on Contract {
  ...Contract
  docusignSignUrl
}
    fragment Contract on Contract {
  id
  hoursPerShift
  shiftsPerWeek
  cancellationPolicy
  contractNotes
  contractStatus
  contractStartDate
  contractEndDate
  contractType
  shiftType
  currentGrossPayWeek
  baseRate
  lengthInWeeks
  job {
    id
    startDate
    endDate
    title
    facilityName
    clinicalUnit {
      id
      displayName
    }
    lengthInWeeks
    hoursPerShift
    shiftsPerWeek
    shiftType
    emr {
      id
      name
    }
  }
  jobPlacement {
    id
    nurseProfile {
      id
      name
      user {
        id
        email
      }
    }
  }
  timeOffs {
    id
    startDate
    endDate
    approvalStatus
  }
  jobApplication {
    id
    paymentDetails {
      id
      nonTaxableStipendWeekly
      taxableWageRateWeekly
      grossPayWeekly
    }
  }
  paymentDetails {
    id
    nonTaxableStipendWeekly
    taxableWageRateWeekly
    grossPayWeekly
  }
}`, {"fragmentName":"ContractSignUrl"}) as unknown as TypedDocumentString<ContractSignUrlFragment, unknown>;
export const JobOfferSignContractFragmentDoc = new TypedDocumentString(`
    fragment JobOfferSignContract on JobOffer {
  id
  contracts {
    ...ContractSignUrl
  }
}
    fragment ContractSignUrl on Contract {
  ...Contract
  docusignSignUrl
}
fragment Contract on Contract {
  id
  hoursPerShift
  shiftsPerWeek
  cancellationPolicy
  contractNotes
  contractStatus
  contractStartDate
  contractEndDate
  contractType
  shiftType
  currentGrossPayWeek
  baseRate
  lengthInWeeks
  job {
    id
    startDate
    endDate
    title
    facilityName
    clinicalUnit {
      id
      displayName
    }
    lengthInWeeks
    hoursPerShift
    shiftsPerWeek
    shiftType
    emr {
      id
      name
    }
  }
  jobPlacement {
    id
    nurseProfile {
      id
      name
      user {
        id
        email
      }
    }
  }
  timeOffs {
    id
    startDate
    endDate
    approvalStatus
  }
  jobApplication {
    id
    paymentDetails {
      id
      nonTaxableStipendWeekly
      taxableWageRateWeekly
      grossPayWeekly
    }
  }
  paymentDetails {
    id
    nonTaxableStipendWeekly
    taxableWageRateWeekly
    grossPayWeekly
  }
}`, {"fragmentName":"JobOfferSignContract"}) as unknown as TypedDocumentString<JobOfferSignContractFragment, unknown>;
export const JarRadiusRuleFragmentDoc = new TypedDocumentString(`
    fragment JarRadiusRule on JobApplicationRequirementsRadiusRule {
  id
  type
  description
}
    `, {"fragmentName":"JarRadiusRule"}) as unknown as TypedDocumentString<JarRadiusRuleFragment, unknown>;
export const JobUtilsJobFragmentDoc = new TypedDocumentString(`
    fragment JobUtilsJob on Job {
  id
  radiusRule
  travelAllowed
  localAllowed
  jarRadiusRuleV2 {
    ...JarRadiusRule
  }
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  grossPayWeekly
  localGrossPayWeekly
  localPaymentDetails {
    id
    grossPayWeekly
  }
  clinicalUnit {
    id
    displayName
  }
  jobType
  role
  roles {
    id
    name
    key
    type
  }
}
    fragment JarRadiusRule on JobApplicationRequirementsRadiusRule {
  id
  type
  description
}`, {"fragmentName":"JobUtilsJob"}) as unknown as TypedDocumentString<JobUtilsJobFragment, unknown>;
export const JobSearchItemJobFragmentDoc = new TypedDocumentString(`
    fragment JobSearchItemJob on Job {
  id
  shiftType
  shiftsPerWeek
  hoursPerShift
  startAsap
  startDate
  lengthInWeeks
  grossPayWeekly
  jobType
  licenseType
  localGrossPayWeekly
  roles {
    id
    name
    abbreviation
  }
  localPaymentDetails {
    id
    blendedWageRate
    callBackRate
    doubleTimeMultiplier
    grossPayWeekly
    holidayRate
    incidentalsStipendDaily
    lodgingStipendDaily
    onCallRate
    overtimeHoursPerWeek
    overtimeMultiplier
    overtimeWageRate
    regularHoursPerWeek
    regularWageRate
    totalHoursPerWeek
    totalStipendDaily
  }
  clinicalUnit {
    id
    displayName
  }
  location {
    id
    city
    stateCode
  }
  ...JobUtilsJob
}
    fragment JarRadiusRule on JobApplicationRequirementsRadiusRule {
  id
  type
  description
}
fragment JobUtilsJob on Job {
  id
  radiusRule
  travelAllowed
  localAllowed
  jarRadiusRuleV2 {
    ...JarRadiusRule
  }
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  grossPayWeekly
  localGrossPayWeekly
  localPaymentDetails {
    id
    grossPayWeekly
  }
  clinicalUnit {
    id
    displayName
  }
  jobType
  role
  roles {
    id
    name
    key
    type
  }
}`, {"fragmentName":"JobSearchItemJob"}) as unknown as TypedDocumentString<JobSearchItemJobFragment, unknown>;
export const MatchCardFacilityFragmentDoc = new TypedDocumentString(`
    fragment MatchCardFacility on Facility {
  id
  name
  logo
}
    `, {"fragmentName":"MatchCardFacility"}) as unknown as TypedDocumentString<MatchCardFacilityFragment, unknown>;
export const MatchCardJobFragmentDoc = new TypedDocumentString(`
    fragment MatchCardJob on Job {
  id
  activeApplicantsCount
  favoritedCount
  hoursPerShift
  instantOffer
  jobType
  lengthInWeeks
  licenseType
  localAllowed
  onHold
  shiftType
  shiftsPerWeek
  startAsap
  startDate
  endDate
  facilityName
  cancellationPolicy
  stateActiveAt
  title
  travelAllowed
  business {
    city
    state
    ...MatchCardFacility
  }
  clinicalUnit {
    id
    displayName
  }
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  location {
    id
    city
    stateCode
  }
  localPaymentDetails {
    id
    grossPayWeekly
  }
  emr {
    id
    name
  }
}
    fragment MatchCardFacility on Facility {
  id
  name
  logo
}`, {"fragmentName":"MatchCardJob"}) as unknown as TypedDocumentString<MatchCardJobFragment, unknown>;
export const ApplicableMatchCardJobFragmentDoc = new TypedDocumentString(`
    fragment ApplicableMatchCardJob on Job {
  ...MatchCardJob
  esMatch {
    id
    userState
  }
}
    fragment MatchCardJob on Job {
  id
  activeApplicantsCount
  favoritedCount
  hoursPerShift
  instantOffer
  jobType
  lengthInWeeks
  licenseType
  localAllowed
  onHold
  shiftType
  shiftsPerWeek
  startAsap
  startDate
  endDate
  facilityName
  cancellationPolicy
  stateActiveAt
  title
  travelAllowed
  business {
    city
    state
    ...MatchCardFacility
  }
  clinicalUnit {
    id
    displayName
  }
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  location {
    id
    city
    stateCode
  }
  localPaymentDetails {
    id
    grossPayWeekly
  }
  emr {
    id
    name
  }
}
fragment MatchCardFacility on Facility {
  id
  name
  logo
}`, {"fragmentName":"ApplicableMatchCardJob"}) as unknown as TypedDocumentString<ApplicableMatchCardJobFragment, unknown>;
export const MatchCriteriaNursePreferencesFragmentDoc = new TypedDocumentString(`
    fragment MatchCriteriaNursePreferences on NursePreferences {
  id
  broadPrefLocations
  careSettingOther
  careSettingPrefs
  contractLengths
  earliestStartDate
  jobSortColumn
  jobSortOrder
  jobTypes
  locations {
    id
    locationString
  }
  shiftLengths
  shiftPrefs
  startPref
  technologies
}
    `, {"fragmentName":"MatchCriteriaNursePreferences"}) as unknown as TypedDocumentString<MatchCriteriaNursePreferencesFragment, unknown>;
export const MatchCriteriaNurseProfileFragmentDoc = new TypedDocumentString(`
    fragment MatchCriteriaNurseProfile on NurseProfile {
  id
  isActivated
  activeClinicalSpecialties {
    id
    displayName
    slug
  }
  percentComplete
  positionSpecialties {
    id
    displayName
    slug
  }
  profileCompletion {
    id
    meta {
      id
      percentCompleted
    }
  }
  role {
    id
    key
    name
    type
  }
  state
  nursePreferences {
    id
    ...MatchCriteriaNursePreferences
  }
}
    fragment MatchCriteriaNursePreferences on NursePreferences {
  id
  broadPrefLocations
  careSettingOther
  careSettingPrefs
  contractLengths
  earliestStartDate
  jobSortColumn
  jobSortOrder
  jobTypes
  locations {
    id
    locationString
  }
  shiftLengths
  shiftPrefs
  startPref
  technologies
}`, {"fragmentName":"MatchCriteriaNurseProfile"}) as unknown as TypedDocumentString<MatchCriteriaNurseProfileFragment, unknown>;
export const MatchCriteriaUserFragmentDoc = new TypedDocumentString(`
    fragment MatchCriteriaUser on User {
  id
  cityPermanent
  statePermanent
  streetAddressPermanent
  nurseProfile {
    ...MatchCriteriaNurseProfile
  }
}
    fragment MatchCriteriaNurseProfile on NurseProfile {
  id
  isActivated
  activeClinicalSpecialties {
    id
    displayName
    slug
  }
  percentComplete
  positionSpecialties {
    id
    displayName
    slug
  }
  profileCompletion {
    id
    meta {
      id
      percentCompleted
    }
  }
  role {
    id
    key
    name
    type
  }
  state
  nursePreferences {
    id
    ...MatchCriteriaNursePreferences
  }
}
fragment MatchCriteriaNursePreferences on NursePreferences {
  id
  broadPrefLocations
  careSettingOther
  careSettingPrefs
  contractLengths
  earliestStartDate
  jobSortColumn
  jobSortOrder
  jobTypes
  locations {
    id
    locationString
  }
  shiftLengths
  shiftPrefs
  startPref
  technologies
}`, {"fragmentName":"MatchCriteriaUser"}) as unknown as TypedDocumentString<MatchCriteriaUserFragment, unknown>;
export const ProfileCompletionWidgetProfileCompletionMetaFragmentDoc = new TypedDocumentString(`
    fragment ProfileCompletionWidgetProfileCompletionMeta on NurseProfileCompletion {
  id
  meta {
    id
    completeCount
    expiredCount
    expiringCount
    incompleteCount
    pendingCount
    percentCompleted
  }
}
    `, {"fragmentName":"ProfileCompletionWidgetProfileCompletionMeta"}) as unknown as TypedDocumentString<ProfileCompletionWidgetProfileCompletionMetaFragment, unknown>;
export const NavigationProfileDropdownUserFragmentDoc = new TypedDocumentString(`
    fragment NavigationProfileDropdownUser on User {
  id
  firstName
  preferredName
  middleName
  lastName
  profilePic
  nurseProfile {
    id
    profileCompletion {
      id
      ...ProfileCompletionWidgetProfileCompletionMeta
    }
    role {
      id
      name
    }
  }
}
    fragment ProfileCompletionWidgetProfileCompletionMeta on NurseProfileCompletion {
  id
  meta {
    id
    completeCount
    expiredCount
    expiringCount
    incompleteCount
    pendingCount
    percentCompleted
  }
}`, {"fragmentName":"NavigationProfileDropdownUser"}) as unknown as TypedDocumentString<NavigationProfileDropdownUserFragment, unknown>;
export const UserFullNameFragmentDoc = new TypedDocumentString(`
    fragment UserFullName on User {
  firstName
  preferredName
  middleName
  lastName
}
    `, {"fragmentName":"UserFullName"}) as unknown as TypedDocumentString<UserFullNameFragment, unknown>;
export const NavigationUserFragmentDoc = new TypedDocumentString(`
    fragment NavigationUser on User {
  id
  ...UserFullName
  profilePic
  nurseProfile {
    id
    profileCompletion {
      id
      meta {
        id
        incompleteCount
        expiredCount
        percentCompleted
        pendingCount
      }
    }
    role {
      id
      name
    }
  }
}
    fragment UserFullName on User {
  firstName
  preferredName
  middleName
  lastName
}`, {"fragmentName":"NavigationUser"}) as unknown as TypedDocumentString<NavigationUserFragment, unknown>;
export const OnboardingCompletedBannerJobPlacementFragmentDoc = new TypedDocumentString(`
    fragment OnboardingCompletedBannerJobPlacement on JobPlacement {
  id
  startDate
  locationCityState
  facilityName
  isOnboardingCompleted
}
    `, {"fragmentName":"OnboardingCompletedBannerJobPlacement"}) as unknown as TypedDocumentString<OnboardingCompletedBannerJobPlacementFragment, unknown>;
export const BaseItemFragmentDoc = new TypedDocumentString(`
    fragment BaseItem on TodoListItem {
  id
  name
  description
  verificationNotes
  rejectionReason
  itemState
  schedulable
  needsToBeScheduled
  karmaCheckCaseServiceOrder {
    id
    isPending
  }
  itemType
  actionLinks {
    id
    title
    url
  }
}
    `, {"fragmentName":"BaseItem"}) as unknown as TypedDocumentString<BaseItemFragment, unknown>;
export const OnboardingDocumentPanelDocumentFragmentDoc = new TypedDocumentString(`
    fragment OnboardingDocumentPanelDocument on Document {
  id
  uuid
  title
  isExpirable
  isExpiringSoon
  isExpired
  expirationType
  expiresOn
  completedOn
  docType
  docSubtype
  trackCompletionDate
  files {
    ...FileMetadata
  }
  stateCode
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}`, {"fragmentName":"OnboardingDocumentPanelDocument"}) as unknown as TypedDocumentString<OnboardingDocumentPanelDocumentFragment, unknown>;
export const OnboardingDocumentPanelTodoListItemFragmentDoc = new TypedDocumentString(`
    fragment OnboardingDocumentPanelTodoListItem on TodoListItem {
  id
  name
  description
  documentTarget {
    ...OnboardingDocumentPanelDocument
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment OnboardingDocumentPanelDocument on Document {
  id
  uuid
  title
  isExpirable
  isExpiringSoon
  isExpired
  expirationType
  expiresOn
  completedOn
  docType
  docSubtype
  trackCompletionDate
  files {
    ...FileMetadata
  }
  stateCode
}`, {"fragmentName":"OnboardingDocumentPanelTodoListItem"}) as unknown as TypedDocumentString<OnboardingDocumentPanelTodoListItemFragment, unknown>;
export const DocumentItemFragmentDoc = new TypedDocumentString(`
    fragment DocumentItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingDocumentPanelTodoListItem
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment BaseItem on TodoListItem {
  id
  name
  description
  verificationNotes
  rejectionReason
  itemState
  schedulable
  needsToBeScheduled
  karmaCheckCaseServiceOrder {
    id
    isPending
  }
  itemType
  actionLinks {
    id
    title
    url
  }
}
fragment OnboardingDocumentPanelDocument on Document {
  id
  uuid
  title
  isExpirable
  isExpiringSoon
  isExpired
  expirationType
  expiresOn
  completedOn
  docType
  docSubtype
  trackCompletionDate
  files {
    ...FileMetadata
  }
  stateCode
}
fragment OnboardingDocumentPanelTodoListItem on TodoListItem {
  id
  name
  description
  documentTarget {
    ...OnboardingDocumentPanelDocument
  }
}`, {"fragmentName":"DocumentItem"}) as unknown as TypedDocumentString<DocumentItemFragment, unknown>;
export const OnboardingCertificationPanelTodoListItemFragmentDoc = new TypedDocumentString(`
    fragment OnboardingCertificationPanelTodoListItem on TodoListItem {
  id
  name
  description
  nurseCertificationTarget {
    id
    certificationUuid
    expiresOn
    completedOn
    isExpired
    isExpiringSoon
    issuingBody
    name
    uuid
    useCompletionDate
    files {
      ...FileMetadata
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}`, {"fragmentName":"OnboardingCertificationPanelTodoListItem"}) as unknown as TypedDocumentString<OnboardingCertificationPanelTodoListItemFragment, unknown>;
export const NurseCertificationItemFragmentDoc = new TypedDocumentString(`
    fragment NurseCertificationItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingCertificationPanelTodoListItem
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment BaseItem on TodoListItem {
  id
  name
  description
  verificationNotes
  rejectionReason
  itemState
  schedulable
  needsToBeScheduled
  karmaCheckCaseServiceOrder {
    id
    isPending
  }
  itemType
  actionLinks {
    id
    title
    url
  }
}
fragment OnboardingCertificationPanelTodoListItem on TodoListItem {
  id
  name
  description
  nurseCertificationTarget {
    id
    certificationUuid
    expiresOn
    completedOn
    isExpired
    isExpiringSoon
    issuingBody
    name
    uuid
    useCompletionDate
    files {
      ...FileMetadata
    }
  }
}`, {"fragmentName":"NurseCertificationItem"}) as unknown as TypedDocumentString<NurseCertificationItemFragment, unknown>;
export const OnboardingNurseAssessmentPanelAssessmentFragmentDoc = new TypedDocumentString(`
    fragment OnboardingNurseAssessmentPanelAssessment on Assessment {
  id
  uuid
  category
  issuingBody
  name
  requestable
}
    `, {"fragmentName":"OnboardingNurseAssessmentPanelAssessment"}) as unknown as TypedDocumentString<OnboardingNurseAssessmentPanelAssessmentFragment, unknown>;
export const OnboardingNurseAssessmentPanelTodoListItemFragmentDoc = new TypedDocumentString(`
    fragment OnboardingNurseAssessmentPanelTodoListItem on TodoListItem {
  id
  name
  description
  itemState
  nurseAssessmentTarget {
    id
    uuid
    completedOn
    score
    assessment {
      ...OnboardingNurseAssessmentPanelAssessment
    }
    files {
      ...FileMetadata
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment OnboardingNurseAssessmentPanelAssessment on Assessment {
  id
  uuid
  category
  issuingBody
  name
  requestable
}`, {"fragmentName":"OnboardingNurseAssessmentPanelTodoListItem"}) as unknown as TypedDocumentString<OnboardingNurseAssessmentPanelTodoListItemFragment, unknown>;
export const OnboardingRequestAssessmentPanelTodoListItemFragmentDoc = new TypedDocumentString(`
    fragment OnboardingRequestAssessmentPanelTodoListItem on TodoListItem {
  id
  nurseAssessmentTarget {
    id
    assessment {
      uuid
      name
    }
  }
}
    `, {"fragmentName":"OnboardingRequestAssessmentPanelTodoListItem"}) as unknown as TypedDocumentString<OnboardingRequestAssessmentPanelTodoListItemFragment, unknown>;
export const NurseAssessmentItemTodoListItemFragmentDoc = new TypedDocumentString(`
    fragment NurseAssessmentItemTodoListItem on TodoListItem {
  id
  itemState
  nurseAssessmentTarget {
    id
    assessment {
      id
      requestable
    }
  }
  ...BaseItem
  ...OnboardingNurseAssessmentPanelTodoListItem
  ...OnboardingRequestAssessmentPanelTodoListItem
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment BaseItem on TodoListItem {
  id
  name
  description
  verificationNotes
  rejectionReason
  itemState
  schedulable
  needsToBeScheduled
  karmaCheckCaseServiceOrder {
    id
    isPending
  }
  itemType
  actionLinks {
    id
    title
    url
  }
}
fragment OnboardingNurseAssessmentPanelAssessment on Assessment {
  id
  uuid
  category
  issuingBody
  name
  requestable
}
fragment OnboardingNurseAssessmentPanelTodoListItem on TodoListItem {
  id
  name
  description
  itemState
  nurseAssessmentTarget {
    id
    uuid
    completedOn
    score
    assessment {
      ...OnboardingNurseAssessmentPanelAssessment
    }
    files {
      ...FileMetadata
    }
  }
}
fragment OnboardingRequestAssessmentPanelTodoListItem on TodoListItem {
  id
  nurseAssessmentTarget {
    id
    assessment {
      uuid
      name
    }
  }
}`, {"fragmentName":"NurseAssessmentItemTodoListItem"}) as unknown as TypedDocumentString<NurseAssessmentItemTodoListItemFragment, unknown>;
export const NurseHealthDocItemFragmentDoc = new TypedDocumentString(`
    fragment NurseHealthDocItem on TodoListItem {
  id
  itemState
  nurseHealthDocTarget {
    id
  }
  ...BaseItem
}
    fragment BaseItem on TodoListItem {
  id
  name
  description
  verificationNotes
  rejectionReason
  itemState
  schedulable
  needsToBeScheduled
  karmaCheckCaseServiceOrder {
    id
    isPending
  }
  itemType
  actionLinks {
    id
    title
    url
  }
}`, {"fragmentName":"NurseHealthDocItem"}) as unknown as TypedDocumentString<NurseHealthDocItemFragment, unknown>;
export const OnboardingPlainTextPanelTodoListItemFragmentDoc = new TypedDocumentString(`
    fragment OnboardingPlainTextPanelTodoListItem on TodoListItem {
  id
  uuid
  itemType
  itemState
  candidateNotes
  description
  name
}
    `, {"fragmentName":"OnboardingPlainTextPanelTodoListItem"}) as unknown as TypedDocumentString<OnboardingPlainTextPanelTodoListItemFragment, unknown>;
export const PlaintextItemFragmentDoc = new TypedDocumentString(`
    fragment PlaintextItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingPlainTextPanelTodoListItem
}
    fragment BaseItem on TodoListItem {
  id
  name
  description
  verificationNotes
  rejectionReason
  itemState
  schedulable
  needsToBeScheduled
  karmaCheckCaseServiceOrder {
    id
    isPending
  }
  itemType
  actionLinks {
    id
    title
    url
  }
}
fragment OnboardingPlainTextPanelTodoListItem on TodoListItem {
  id
  uuid
  itemType
  itemState
  candidateNotes
  description
  name
}`, {"fragmentName":"PlaintextItem"}) as unknown as TypedDocumentString<PlaintextItemFragment, unknown>;
export const OnboardingAppointmentPanelTodoListItemFragmentDoc = new TypedDocumentString(`
    fragment OnboardingAppointmentPanelTodoListItem on TodoListItem {
  id
  name
  description
  candidateNotes
}
    `, {"fragmentName":"OnboardingAppointmentPanelTodoListItem"}) as unknown as TypedDocumentString<OnboardingAppointmentPanelTodoListItemFragment, unknown>;
export const AppointmentItemFragmentDoc = new TypedDocumentString(`
    fragment AppointmentItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingAppointmentPanelTodoListItem
}
    fragment BaseItem on TodoListItem {
  id
  name
  description
  verificationNotes
  rejectionReason
  itemState
  schedulable
  needsToBeScheduled
  karmaCheckCaseServiceOrder {
    id
    isPending
  }
  itemType
  actionLinks {
    id
    title
    url
  }
}
fragment OnboardingAppointmentPanelTodoListItem on TodoListItem {
  id
  name
  description
  candidateNotes
}`, {"fragmentName":"AppointmentItem"}) as unknown as TypedDocumentString<AppointmentItemFragment, unknown>;
export const OnboardingListItemContainerTodoListItemFragmentDoc = new TypedDocumentString(`
    fragment OnboardingListItemContainerTodoListItem on TodoListItem {
  id
  itemType
  ...BaseItem
  ...DocumentItem
  ...NurseCertificationItem
  ...NurseAssessmentItemTodoListItem
  ...NurseHealthDocItem
  ...PlaintextItem
  ...AppointmentItem
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment AppointmentItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingAppointmentPanelTodoListItem
}
fragment BaseItem on TodoListItem {
  id
  name
  description
  verificationNotes
  rejectionReason
  itemState
  schedulable
  needsToBeScheduled
  karmaCheckCaseServiceOrder {
    id
    isPending
  }
  itemType
  actionLinks {
    id
    title
    url
  }
}
fragment DocumentItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingDocumentPanelTodoListItem
}
fragment NurseAssessmentItemTodoListItem on TodoListItem {
  id
  itemState
  nurseAssessmentTarget {
    id
    assessment {
      id
      requestable
    }
  }
  ...BaseItem
  ...OnboardingNurseAssessmentPanelTodoListItem
  ...OnboardingRequestAssessmentPanelTodoListItem
}
fragment NurseCertificationItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingCertificationPanelTodoListItem
}
fragment NurseHealthDocItem on TodoListItem {
  id
  itemState
  nurseHealthDocTarget {
    id
  }
  ...BaseItem
}
fragment PlaintextItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingPlainTextPanelTodoListItem
}
fragment OnboardingAppointmentPanelTodoListItem on TodoListItem {
  id
  name
  description
  candidateNotes
}
fragment OnboardingCertificationPanelTodoListItem on TodoListItem {
  id
  name
  description
  nurseCertificationTarget {
    id
    certificationUuid
    expiresOn
    completedOn
    isExpired
    isExpiringSoon
    issuingBody
    name
    uuid
    useCompletionDate
    files {
      ...FileMetadata
    }
  }
}
fragment OnboardingDocumentPanelDocument on Document {
  id
  uuid
  title
  isExpirable
  isExpiringSoon
  isExpired
  expirationType
  expiresOn
  completedOn
  docType
  docSubtype
  trackCompletionDate
  files {
    ...FileMetadata
  }
  stateCode
}
fragment OnboardingDocumentPanelTodoListItem on TodoListItem {
  id
  name
  description
  documentTarget {
    ...OnboardingDocumentPanelDocument
  }
}
fragment OnboardingNurseAssessmentPanelAssessment on Assessment {
  id
  uuid
  category
  issuingBody
  name
  requestable
}
fragment OnboardingNurseAssessmentPanelTodoListItem on TodoListItem {
  id
  name
  description
  itemState
  nurseAssessmentTarget {
    id
    uuid
    completedOn
    score
    assessment {
      ...OnboardingNurseAssessmentPanelAssessment
    }
    files {
      ...FileMetadata
    }
  }
}
fragment OnboardingPlainTextPanelTodoListItem on TodoListItem {
  id
  uuid
  itemType
  itemState
  candidateNotes
  description
  name
}
fragment OnboardingRequestAssessmentPanelTodoListItem on TodoListItem {
  id
  nurseAssessmentTarget {
    id
    assessment {
      uuid
      name
    }
  }
}`, {"fragmentName":"OnboardingListItemContainerTodoListItem"}) as unknown as TypedDocumentString<OnboardingListItemContainerTodoListItemFragment, unknown>;
export const ExternalSortedTodoListItemsCategoryFragmentDoc = new TypedDocumentString(`
    fragment ExternalSortedTodoListItemsCategory on SortedTodoListItemsCategory {
  displayName
  items {
    id
    order
    ...OnboardingListItemContainerTodoListItem
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment OnboardingListItemContainerTodoListItem on TodoListItem {
  id
  itemType
  ...BaseItem
  ...DocumentItem
  ...NurseCertificationItem
  ...NurseAssessmentItemTodoListItem
  ...NurseHealthDocItem
  ...PlaintextItem
  ...AppointmentItem
}
fragment AppointmentItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingAppointmentPanelTodoListItem
}
fragment BaseItem on TodoListItem {
  id
  name
  description
  verificationNotes
  rejectionReason
  itemState
  schedulable
  needsToBeScheduled
  karmaCheckCaseServiceOrder {
    id
    isPending
  }
  itemType
  actionLinks {
    id
    title
    url
  }
}
fragment DocumentItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingDocumentPanelTodoListItem
}
fragment NurseAssessmentItemTodoListItem on TodoListItem {
  id
  itemState
  nurseAssessmentTarget {
    id
    assessment {
      id
      requestable
    }
  }
  ...BaseItem
  ...OnboardingNurseAssessmentPanelTodoListItem
  ...OnboardingRequestAssessmentPanelTodoListItem
}
fragment NurseCertificationItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingCertificationPanelTodoListItem
}
fragment NurseHealthDocItem on TodoListItem {
  id
  itemState
  nurseHealthDocTarget {
    id
  }
  ...BaseItem
}
fragment PlaintextItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingPlainTextPanelTodoListItem
}
fragment OnboardingAppointmentPanelTodoListItem on TodoListItem {
  id
  name
  description
  candidateNotes
}
fragment OnboardingCertificationPanelTodoListItem on TodoListItem {
  id
  name
  description
  nurseCertificationTarget {
    id
    certificationUuid
    expiresOn
    completedOn
    isExpired
    isExpiringSoon
    issuingBody
    name
    uuid
    useCompletionDate
    files {
      ...FileMetadata
    }
  }
}
fragment OnboardingDocumentPanelDocument on Document {
  id
  uuid
  title
  isExpirable
  isExpiringSoon
  isExpired
  expirationType
  expiresOn
  completedOn
  docType
  docSubtype
  trackCompletionDate
  files {
    ...FileMetadata
  }
  stateCode
}
fragment OnboardingDocumentPanelTodoListItem on TodoListItem {
  id
  name
  description
  documentTarget {
    ...OnboardingDocumentPanelDocument
  }
}
fragment OnboardingNurseAssessmentPanelAssessment on Assessment {
  id
  uuid
  category
  issuingBody
  name
  requestable
}
fragment OnboardingNurseAssessmentPanelTodoListItem on TodoListItem {
  id
  name
  description
  itemState
  nurseAssessmentTarget {
    id
    uuid
    completedOn
    score
    assessment {
      ...OnboardingNurseAssessmentPanelAssessment
    }
    files {
      ...FileMetadata
    }
  }
}
fragment OnboardingPlainTextPanelTodoListItem on TodoListItem {
  id
  uuid
  itemType
  itemState
  candidateNotes
  description
  name
}
fragment OnboardingRequestAssessmentPanelTodoListItem on TodoListItem {
  id
  nurseAssessmentTarget {
    id
    assessment {
      uuid
      name
    }
  }
}`, {"fragmentName":"ExternalSortedTodoListItemsCategory"}) as unknown as TypedDocumentString<ExternalSortedTodoListItemsCategoryFragment, unknown>;
export const CategoriesFragmentDoc = new TypedDocumentString(`
    fragment Categories on SortedTodoListItemsExternal {
  categories {
    general {
      ...ExternalSortedTodoListItemsCategory
    }
    backgroundAndIdentification {
      ...ExternalSortedTodoListItemsCategory
    }
    licensesAndCertifications {
      ...ExternalSortedTodoListItemsCategory
    }
    assessments {
      ...ExternalSortedTodoListItemsCategory
    }
    healthDocuments {
      ...ExternalSortedTodoListItemsCategory
    }
  }
  displayName
  formattedDueDate
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment ExternalSortedTodoListItemsCategory on SortedTodoListItemsCategory {
  displayName
  items {
    id
    order
    ...OnboardingListItemContainerTodoListItem
  }
}
fragment OnboardingListItemContainerTodoListItem on TodoListItem {
  id
  itemType
  ...BaseItem
  ...DocumentItem
  ...NurseCertificationItem
  ...NurseAssessmentItemTodoListItem
  ...NurseHealthDocItem
  ...PlaintextItem
  ...AppointmentItem
}
fragment AppointmentItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingAppointmentPanelTodoListItem
}
fragment BaseItem on TodoListItem {
  id
  name
  description
  verificationNotes
  rejectionReason
  itemState
  schedulable
  needsToBeScheduled
  karmaCheckCaseServiceOrder {
    id
    isPending
  }
  itemType
  actionLinks {
    id
    title
    url
  }
}
fragment DocumentItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingDocumentPanelTodoListItem
}
fragment NurseAssessmentItemTodoListItem on TodoListItem {
  id
  itemState
  nurseAssessmentTarget {
    id
    assessment {
      id
      requestable
    }
  }
  ...BaseItem
  ...OnboardingNurseAssessmentPanelTodoListItem
  ...OnboardingRequestAssessmentPanelTodoListItem
}
fragment NurseCertificationItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingCertificationPanelTodoListItem
}
fragment NurseHealthDocItem on TodoListItem {
  id
  itemState
  nurseHealthDocTarget {
    id
  }
  ...BaseItem
}
fragment PlaintextItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingPlainTextPanelTodoListItem
}
fragment OnboardingAppointmentPanelTodoListItem on TodoListItem {
  id
  name
  description
  candidateNotes
}
fragment OnboardingCertificationPanelTodoListItem on TodoListItem {
  id
  name
  description
  nurseCertificationTarget {
    id
    certificationUuid
    expiresOn
    completedOn
    isExpired
    isExpiringSoon
    issuingBody
    name
    uuid
    useCompletionDate
    files {
      ...FileMetadata
    }
  }
}
fragment OnboardingDocumentPanelDocument on Document {
  id
  uuid
  title
  isExpirable
  isExpiringSoon
  isExpired
  expirationType
  expiresOn
  completedOn
  docType
  docSubtype
  trackCompletionDate
  files {
    ...FileMetadata
  }
  stateCode
}
fragment OnboardingDocumentPanelTodoListItem on TodoListItem {
  id
  name
  description
  documentTarget {
    ...OnboardingDocumentPanelDocument
  }
}
fragment OnboardingNurseAssessmentPanelAssessment on Assessment {
  id
  uuid
  category
  issuingBody
  name
  requestable
}
fragment OnboardingNurseAssessmentPanelTodoListItem on TodoListItem {
  id
  name
  description
  itemState
  nurseAssessmentTarget {
    id
    uuid
    completedOn
    score
    assessment {
      ...OnboardingNurseAssessmentPanelAssessment
    }
    files {
      ...FileMetadata
    }
  }
}
fragment OnboardingPlainTextPanelTodoListItem on TodoListItem {
  id
  uuid
  itemType
  itemState
  candidateNotes
  description
  name
}
fragment OnboardingRequestAssessmentPanelTodoListItem on TodoListItem {
  id
  nurseAssessmentTarget {
    id
    assessment {
      uuid
      name
    }
  }
}`, {"fragmentName":"Categories"}) as unknown as TypedDocumentString<CategoriesFragment, unknown>;
export const ExternalTimelineTodoListItemsFragmentDoc = new TypedDocumentString(`
    fragment ExternalTimelineTodoListItems on TodoList {
  id
  timelineTodoListItems(filter: LIVE) {
    externalItems {
      ...Categories
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment ExternalSortedTodoListItemsCategory on SortedTodoListItemsCategory {
  displayName
  items {
    id
    order
    ...OnboardingListItemContainerTodoListItem
  }
}
fragment Categories on SortedTodoListItemsExternal {
  categories {
    general {
      ...ExternalSortedTodoListItemsCategory
    }
    backgroundAndIdentification {
      ...ExternalSortedTodoListItemsCategory
    }
    licensesAndCertifications {
      ...ExternalSortedTodoListItemsCategory
    }
    assessments {
      ...ExternalSortedTodoListItemsCategory
    }
    healthDocuments {
      ...ExternalSortedTodoListItemsCategory
    }
  }
  displayName
  formattedDueDate
}
fragment OnboardingListItemContainerTodoListItem on TodoListItem {
  id
  itemType
  ...BaseItem
  ...DocumentItem
  ...NurseCertificationItem
  ...NurseAssessmentItemTodoListItem
  ...NurseHealthDocItem
  ...PlaintextItem
  ...AppointmentItem
}
fragment AppointmentItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingAppointmentPanelTodoListItem
}
fragment BaseItem on TodoListItem {
  id
  name
  description
  verificationNotes
  rejectionReason
  itemState
  schedulable
  needsToBeScheduled
  karmaCheckCaseServiceOrder {
    id
    isPending
  }
  itemType
  actionLinks {
    id
    title
    url
  }
}
fragment DocumentItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingDocumentPanelTodoListItem
}
fragment NurseAssessmentItemTodoListItem on TodoListItem {
  id
  itemState
  nurseAssessmentTarget {
    id
    assessment {
      id
      requestable
    }
  }
  ...BaseItem
  ...OnboardingNurseAssessmentPanelTodoListItem
  ...OnboardingRequestAssessmentPanelTodoListItem
}
fragment NurseCertificationItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingCertificationPanelTodoListItem
}
fragment NurseHealthDocItem on TodoListItem {
  id
  itemState
  nurseHealthDocTarget {
    id
  }
  ...BaseItem
}
fragment PlaintextItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingPlainTextPanelTodoListItem
}
fragment OnboardingAppointmentPanelTodoListItem on TodoListItem {
  id
  name
  description
  candidateNotes
}
fragment OnboardingCertificationPanelTodoListItem on TodoListItem {
  id
  name
  description
  nurseCertificationTarget {
    id
    certificationUuid
    expiresOn
    completedOn
    isExpired
    isExpiringSoon
    issuingBody
    name
    uuid
    useCompletionDate
    files {
      ...FileMetadata
    }
  }
}
fragment OnboardingDocumentPanelDocument on Document {
  id
  uuid
  title
  isExpirable
  isExpiringSoon
  isExpired
  expirationType
  expiresOn
  completedOn
  docType
  docSubtype
  trackCompletionDate
  files {
    ...FileMetadata
  }
  stateCode
}
fragment OnboardingDocumentPanelTodoListItem on TodoListItem {
  id
  name
  description
  documentTarget {
    ...OnboardingDocumentPanelDocument
  }
}
fragment OnboardingNurseAssessmentPanelAssessment on Assessment {
  id
  uuid
  category
  issuingBody
  name
  requestable
}
fragment OnboardingNurseAssessmentPanelTodoListItem on TodoListItem {
  id
  name
  description
  itemState
  nurseAssessmentTarget {
    id
    uuid
    completedOn
    score
    assessment {
      ...OnboardingNurseAssessmentPanelAssessment
    }
    files {
      ...FileMetadata
    }
  }
}
fragment OnboardingPlainTextPanelTodoListItem on TodoListItem {
  id
  uuid
  itemType
  itemState
  candidateNotes
  description
  name
}
fragment OnboardingRequestAssessmentPanelTodoListItem on TodoListItem {
  id
  nurseAssessmentTarget {
    id
    assessment {
      uuid
      name
    }
  }
}`, {"fragmentName":"ExternalTimelineTodoListItems"}) as unknown as TypedDocumentString<ExternalTimelineTodoListItemsFragment, unknown>;
export const OnboardingHeaderTitleFragmentDoc = new TypedDocumentString(`
    fragment OnboardingHeaderTitle on TodoList {
  id
  publishedAt
  completeByDate
  createdAt
  numTasksDue
  listType
  markedCompleteAt
}
    `, {"fragmentName":"OnboardingHeaderTitle"}) as unknown as TypedDocumentString<OnboardingHeaderTitleFragment, unknown>;
export const OnboardingHeaderSubtitleFragmentDoc = new TypedDocumentString(`
    fragment OnboardingHeaderSubtitle on TodoList {
  id
  markedCompleteAt
  targetBusinessName
  targetBusinessLocation {
    id
    city
    stateCode
  }
}
    `, {"fragmentName":"OnboardingHeaderSubtitle"}) as unknown as TypedDocumentString<OnboardingHeaderSubtitleFragment, unknown>;
export const OnboardingHeaderBodyFragmentDoc = new TypedDocumentString(`
    fragment OnboardingHeaderBody on TodoList {
  markedCompleteAt
  publishedAt
  targetBusinessName
}
    `, {"fragmentName":"OnboardingHeaderBody"}) as unknown as TypedDocumentString<OnboardingHeaderBodyFragment, unknown>;
export const OnboardingHeaderCountersTodoListFragmentDoc = new TypedDocumentString(`
    fragment OnboardingHeaderCountersTodoList on TodoList {
  markedCompleteAt
  numTasksNeedingAttention
  numTasksPending
}
    `, {"fragmentName":"OnboardingHeaderCountersTodoList"}) as unknown as TypedDocumentString<OnboardingHeaderCountersTodoListFragment, unknown>;
export const OnboardingHeaderTodoListFragmentDoc = new TypedDocumentString(`
    fragment OnboardingHeaderTodoList on TodoList {
  id
  startDate
  ...OnboardingHeaderTitle
  ...OnboardingHeaderSubtitle
  ...OnboardingHeaderBody
  ...OnboardingHeaderCountersTodoList
}
    fragment OnboardingHeaderTitle on TodoList {
  id
  publishedAt
  completeByDate
  createdAt
  numTasksDue
  listType
  markedCompleteAt
}
fragment OnboardingHeaderBody on TodoList {
  markedCompleteAt
  publishedAt
  targetBusinessName
}
fragment OnboardingHeaderCountersTodoList on TodoList {
  markedCompleteAt
  numTasksNeedingAttention
  numTasksPending
}
fragment OnboardingHeaderSubtitle on TodoList {
  id
  markedCompleteAt
  targetBusinessName
  targetBusinessLocation {
    id
    city
    stateCode
  }
}`, {"fragmentName":"OnboardingHeaderTodoList"}) as unknown as TypedDocumentString<OnboardingHeaderTodoListFragment, unknown>;
export const IncentiveBannerTodoListFragmentDoc = new TypedDocumentString(`
    fragment IncentiveBannerTodoList on TodoList {
  incentiveDeadline
  completeByDate
}
    `, {"fragmentName":"IncentiveBannerTodoList"}) as unknown as TypedDocumentString<IncentiveBannerTodoListFragment, unknown>;
export const OnboardingListTodoListFragmentDoc = new TypedDocumentString(`
    fragment OnboardingListTodoList on TodoList {
  uuid
  id
  markedCompleteAt
  contractSignedDate
  completeByDate
  status
  nurseProfile {
    id
    user {
      id
      city
      state
      streetAddress
      zipcode
    }
  }
  todoListItems(filter: LIVE) {
    id
    name
    itemType
    ...OnboardingListItemContainerTodoListItem
  }
  ...ExternalTimelineTodoListItems
  ...OnboardingHeaderTodoList
  ...IncentiveBannerTodoList
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment ExternalSortedTodoListItemsCategory on SortedTodoListItemsCategory {
  displayName
  items {
    id
    order
    ...OnboardingListItemContainerTodoListItem
  }
}
fragment Categories on SortedTodoListItemsExternal {
  categories {
    general {
      ...ExternalSortedTodoListItemsCategory
    }
    backgroundAndIdentification {
      ...ExternalSortedTodoListItemsCategory
    }
    licensesAndCertifications {
      ...ExternalSortedTodoListItemsCategory
    }
    assessments {
      ...ExternalSortedTodoListItemsCategory
    }
    healthDocuments {
      ...ExternalSortedTodoListItemsCategory
    }
  }
  displayName
  formattedDueDate
}
fragment ExternalTimelineTodoListItems on TodoList {
  id
  timelineTodoListItems(filter: LIVE) {
    externalItems {
      ...Categories
    }
  }
}
fragment IncentiveBannerTodoList on TodoList {
  incentiveDeadline
  completeByDate
}
fragment OnboardingHeaderTodoList on TodoList {
  id
  startDate
  ...OnboardingHeaderTitle
  ...OnboardingHeaderSubtitle
  ...OnboardingHeaderBody
  ...OnboardingHeaderCountersTodoList
}
fragment OnboardingHeaderTitle on TodoList {
  id
  publishedAt
  completeByDate
  createdAt
  numTasksDue
  listType
  markedCompleteAt
}
fragment OnboardingHeaderBody on TodoList {
  markedCompleteAt
  publishedAt
  targetBusinessName
}
fragment OnboardingHeaderCountersTodoList on TodoList {
  markedCompleteAt
  numTasksNeedingAttention
  numTasksPending
}
fragment OnboardingHeaderSubtitle on TodoList {
  id
  markedCompleteAt
  targetBusinessName
  targetBusinessLocation {
    id
    city
    stateCode
  }
}
fragment OnboardingListItemContainerTodoListItem on TodoListItem {
  id
  itemType
  ...BaseItem
  ...DocumentItem
  ...NurseCertificationItem
  ...NurseAssessmentItemTodoListItem
  ...NurseHealthDocItem
  ...PlaintextItem
  ...AppointmentItem
}
fragment AppointmentItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingAppointmentPanelTodoListItem
}
fragment BaseItem on TodoListItem {
  id
  name
  description
  verificationNotes
  rejectionReason
  itemState
  schedulable
  needsToBeScheduled
  karmaCheckCaseServiceOrder {
    id
    isPending
  }
  itemType
  actionLinks {
    id
    title
    url
  }
}
fragment DocumentItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingDocumentPanelTodoListItem
}
fragment NurseAssessmentItemTodoListItem on TodoListItem {
  id
  itemState
  nurseAssessmentTarget {
    id
    assessment {
      id
      requestable
    }
  }
  ...BaseItem
  ...OnboardingNurseAssessmentPanelTodoListItem
  ...OnboardingRequestAssessmentPanelTodoListItem
}
fragment NurseCertificationItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingCertificationPanelTodoListItem
}
fragment NurseHealthDocItem on TodoListItem {
  id
  itemState
  nurseHealthDocTarget {
    id
  }
  ...BaseItem
}
fragment PlaintextItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingPlainTextPanelTodoListItem
}
fragment OnboardingAppointmentPanelTodoListItem on TodoListItem {
  id
  name
  description
  candidateNotes
}
fragment OnboardingCertificationPanelTodoListItem on TodoListItem {
  id
  name
  description
  nurseCertificationTarget {
    id
    certificationUuid
    expiresOn
    completedOn
    isExpired
    isExpiringSoon
    issuingBody
    name
    uuid
    useCompletionDate
    files {
      ...FileMetadata
    }
  }
}
fragment OnboardingDocumentPanelDocument on Document {
  id
  uuid
  title
  isExpirable
  isExpiringSoon
  isExpired
  expirationType
  expiresOn
  completedOn
  docType
  docSubtype
  trackCompletionDate
  files {
    ...FileMetadata
  }
  stateCode
}
fragment OnboardingDocumentPanelTodoListItem on TodoListItem {
  id
  name
  description
  documentTarget {
    ...OnboardingDocumentPanelDocument
  }
}
fragment OnboardingNurseAssessmentPanelAssessment on Assessment {
  id
  uuid
  category
  issuingBody
  name
  requestable
}
fragment OnboardingNurseAssessmentPanelTodoListItem on TodoListItem {
  id
  name
  description
  itemState
  nurseAssessmentTarget {
    id
    uuid
    completedOn
    score
    assessment {
      ...OnboardingNurseAssessmentPanelAssessment
    }
    files {
      ...FileMetadata
    }
  }
}
fragment OnboardingPlainTextPanelTodoListItem on TodoListItem {
  id
  uuid
  itemType
  itemState
  candidateNotes
  description
  name
}
fragment OnboardingRequestAssessmentPanelTodoListItem on TodoListItem {
  id
  nurseAssessmentTarget {
    id
    assessment {
      uuid
      name
    }
  }
}`, {"fragmentName":"OnboardingListTodoList"}) as unknown as TypedDocumentString<OnboardingListTodoListFragment, unknown>;
export const NurseAssessmentItemNurseAssessmentFragmentDoc = new TypedDocumentString(`
    fragment NurseAssessmentItemNurseAssessment on NurseAssessment {
  id
  name
  category
  requestedOn
  completedOn
  assessment {
    id
    issuingBody
  }
}
    `, {"fragmentName":"NurseAssessmentItemNurseAssessment"}) as unknown as TypedDocumentString<NurseAssessmentItemNurseAssessmentFragment, unknown>;
export const OnboardingPlaceholderJobPlacementFragmentDoc = new TypedDocumentString(`
    fragment OnboardingPlaceholderJobPlacement on JobPlacement {
  id
  isOnboardingCompleted
  isOnboardingListPending
  facilityName
  locationCityState
  startDate
  status
}
    `, {"fragmentName":"OnboardingPlaceholderJobPlacement"}) as unknown as TypedDocumentString<OnboardingPlaceholderJobPlacementFragment, unknown>;
export const CeuCertificatePanelNurseProfileFragmentDoc = new TypedDocumentString(`
    fragment CeuCertificatePanelNurseProfile on NurseProfile {
  id
  ceuGoals {
    id
    completedContactHours
  }
  ceuCertificates {
    id
    name
    contactHours
    ceuCertificateType
    completionDate
    providerNumber
    files {
      ...FileMetadata
    }
    ceuGoals {
      id
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}`, {"fragmentName":"CeuCertificatePanelNurseProfile"}) as unknown as TypedDocumentString<CeuCertificatePanelNurseProfileFragment, unknown>;
export const CeuCertificatePanelCeuGoalFragmentDoc = new TypedDocumentString(`
    fragment CeuCertificatePanelCeuGoal on CeuGoal {
  id
  goalType
  requiredContactHours
  endDate
  ceuStateRequirement {
    id
    state
  }
  description
}
    `, {"fragmentName":"CeuCertificatePanelCeuGoal"}) as unknown as TypedDocumentString<CeuCertificatePanelCeuGoalFragment, unknown>;
export const EducationPanelEducationFragmentDoc = new TypedDocumentString(`
    fragment EducationPanelEducation on Education {
  id
  schoolName
  degree
  major
  gpa
  graduatedOn
  location {
    id
    address
    googlePlaceId
  }
  startedOn
  descriptions
}
    `, {"fragmentName":"EducationPanelEducation"}) as unknown as TypedDocumentString<EducationPanelEducationFragment, unknown>;
export const EducationListItemEducationFragmentDoc = new TypedDocumentString(`
    fragment EducationListItemEducation on Education {
  id
  startedOn
  graduatedOn
  schoolName
  locationAddress
  googlePlaceId
  degree
  descriptions
}
    `, {"fragmentName":"EducationListItemEducation"}) as unknown as TypedDocumentString<EducationListItemEducationFragment, unknown>;
export const EducationPanelUpdateCacheFragmentDoc = new TypedDocumentString(`
    fragment EducationPanelUpdateCache on NurseProfile {
  id
  educationComplete
  canApplyJobs
  applicationReadiness {
    results {
      education {
        label
        status
      }
    }
  }
  educations {
    ...EducationListItemEducation
  }
  profileCompletion {
    id
    steps {
      education {
        status
      }
    }
    meta {
      id
      incompleteCount
      expiredCount
      percentCompleted
      pendingCount
    }
  }
}
    fragment EducationListItemEducation on Education {
  id
  startedOn
  graduatedOn
  schoolName
  locationAddress
  googlePlaceId
  degree
  descriptions
}`, {"fragmentName":"EducationPanelUpdateCache"}) as unknown as TypedDocumentString<EducationPanelUpdateCacheFragment, unknown>;
export const ResumeParserEducationSuggestionsFragmentDoc = new TypedDocumentString(`
    fragment ResumeParserEducationSuggestions on EducationSuggestion {
  suggestionDegree: degree
  graduationDate
  parserId
  startDate
  institutionName
  suggestionLocation: location
  locationGoogle {
    address
    placeId
  }
}
    `, {"fragmentName":"ResumeParserEducationSuggestions"}) as unknown as TypedDocumentString<ResumeParserEducationSuggestionsFragment, unknown>;
export const EmailConfirmationPanelUserFragmentDoc = new TypedDocumentString(`
    fragment EmailConfirmationPanelUser on User {
  id
  email
  confirmedAt
  confirmationSentAt
  receivedEmailConfirmationLink
}
    `, {"fragmentName":"EmailConfirmationPanelUser"}) as unknown as TypedDocumentString<EmailConfirmationPanelUserFragment, unknown>;
export const LegalNameAndBirthdayFormUserFragmentDoc = new TypedDocumentString(`
    fragment LegalNameAndBirthdayFormUser on User {
  id
  firstName
  middleName
  lastName
  nurseProfile {
    id
    birthday
  }
}
    `, {"fragmentName":"LegalNameAndBirthdayFormUser"}) as unknown as TypedDocumentString<LegalNameAndBirthdayFormUserFragment, unknown>;
export const LicenseListItemLicenseFragmentDoc = new TypedDocumentString(`
    fragment LicenseListItemLicense on License {
  id
  uuid
  licenseType
  friendlyLicenseType
  licensureCompact
  compact
  stateCode
  state
  number
  expiresOn
  title
  isExpired
  isExpiringSoon
  files {
    ...FileMetadata
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}`, {"fragmentName":"LicenseListItemLicense"}) as unknown as TypedDocumentString<LicenseListItemLicenseFragment, unknown>;
export const LicensePanelUpdateCacheFragmentDoc = new TypedDocumentString(`
    fragment LicensePanelUpdateCache on NurseProfile {
  id
  applicationReadiness {
    results {
      licenses {
        label
        status
      }
    }
  }
  licensesComplete
  profileCompletion {
    id
    steps {
      license {
        status
      }
    }
  }
  licenses {
    ...LicenseListItemLicense
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment LicenseListItemLicense on License {
  id
  uuid
  licenseType
  friendlyLicenseType
  licensureCompact
  compact
  stateCode
  state
  number
  expiresOn
  title
  isExpired
  isExpiringSoon
  files {
    ...FileMetadata
  }
}`, {"fragmentName":"LicensePanelUpdateCache"}) as unknown as TypedDocumentString<LicensePanelUpdateCacheFragment, unknown>;
export const NurseAssessmentPanelsNurseAssessmentFragmentDoc = new TypedDocumentString(`
    fragment NurseAssessmentPanelsNurseAssessment on NurseAssessment {
  id
  completedOn
  expiresOn
  isExpired
  isExpiringSoon
  isArchived
  score
  requestedOn
  assessment {
    ...AssessmentItem
  }
  assessmentRequest {
    id
    score
  }
  files {
    ...FileMetadata
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment AssessmentItem on Assessment {
  id
  category
  issuingBody
  name
}`, {"fragmentName":"NurseAssessmentPanelsNurseAssessment"}) as unknown as TypedDocumentString<NurseAssessmentPanelsNurseAssessmentFragment, unknown>;
export const NurseAssessmentPanelProfileCompletionFragmentDoc = new TypedDocumentString(`
    fragment NurseAssessmentPanelProfileCompletion on NurseProfile {
  id
  profileCompletion {
    id
    steps {
      skillsChecklist {
        status
      }
    }
  }
}
    `, {"fragmentName":"NurseAssessmentPanelProfileCompletion"}) as unknown as TypedDocumentString<NurseAssessmentPanelProfileCompletionFragment, unknown>;
export const NurseHealthDocumentPanelAvailableHealthDocFragmentDoc = new TypedDocumentString(`
    fragment NurseHealthDocumentPanelAvailableHealthDoc on HealthDoc {
  id
  name
  categories
  formType
  validFor
}
    `, {"fragmentName":"NurseHealthDocumentPanelAvailableHealthDoc"}) as unknown as TypedDocumentString<NurseHealthDocumentPanelAvailableHealthDocFragment, unknown>;
export const NurseHealthDocumentPanelHealthDocFragmentDoc = new TypedDocumentString(`
    fragment NurseHealthDocumentPanelHealthDoc on NurseHealthDoc {
  id
  completedOn
  isExpired
  isExpiringSoon
  category
  nurseProfile {
    id
  }
  healthDoc {
    ...NurseHealthDocumentPanelAvailableHealthDoc
  }
  details {
    ... on NurseHealthDocVaccination {
      entries {
        ... on NurseHealthDocVaccineShot {
          type
          kind
          brand
          completedOn
        }
        ... on NurseHealthDocVaccineDeclination {
          type
          kind
          reason
        }
        ... on NurseHealthDocVaccineWilling {
          type
          kind
        }
      }
    }
  }
  files {
    ...FileMetadata
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment NurseHealthDocumentPanelAvailableHealthDoc on HealthDoc {
  id
  name
  categories
  formType
  validFor
}`, {"fragmentName":"NurseHealthDocumentPanelHealthDoc"}) as unknown as TypedDocumentString<NurseHealthDocumentPanelHealthDocFragment, unknown>;
export const AllBasicErrorsFragmentDoc = new TypedDocumentString(`
    fragment AllBasicErrors on BasicErrorsUnion {
  ... on NotFoundError {
    model
    message
  }
  ... on BadUserInputError {
    argument
    message
  }
  ... on RecordNotUniqueError {
    model
    message
  }
  ... on ModelValidationError {
    message
    attributes {
      attribute
      humanAttribute
      errors {
        message
        fullMessage
        code
      }
    }
  }
}
    `, {"fragmentName":"AllBasicErrors"}) as unknown as TypedDocumentString<AllBasicErrorsFragment, unknown>;
export const CovidVaccinationCardNurseProfileFragmentDoc = new TypedDocumentString(`
    fragment CovidVaccinationCardNurseProfile on NurseProfile {
  id
  covidVaccination {
    id
    completedOn
    isExpired
  }
  applicationReadiness {
    results {
      covidVaccination {
        status
      }
    }
  }
}
    `, {"fragmentName":"CovidVaccinationCardNurseProfile"}) as unknown as TypedDocumentString<CovidVaccinationCardNurseProfileFragment, unknown>;
export const OnboardingItemLicensePanelTodoListItemFragmentDoc = new TypedDocumentString(`
    fragment OnboardingItemLicensePanelTodoListItem on TodoListItem {
  id
  name
  description
  requiresVerification
  actionLinks {
    id
    url
    title
  }
  licenseTarget {
    id
    licenseType
  }
}
    `, {"fragmentName":"OnboardingItemLicensePanelTodoListItem"}) as unknown as TypedDocumentString<OnboardingItemLicensePanelTodoListItemFragment, unknown>;
export const OnboardingItemLicenseFormLicenseFragmentDoc = new TypedDocumentString(`
    fragment OnboardingItemLicenseFormLicense on License {
  id
  number
  licenseType
  expiresOn
  stateCode
  licensureCompact
  friendlyLicenseType
}
    `, {"fragmentName":"OnboardingItemLicenseFormLicense"}) as unknown as TypedDocumentString<OnboardingItemLicenseFormLicenseFragment, unknown>;
export const PermanentAddressUserFragmentDoc = new TypedDocumentString(`
    fragment PermanentAddressUser on User {
  id
  cityPermanent
  countryPermanentCode
  countryPermanentName
  googlePlaceIdPermanent
  statePermanent
  streetAddressPermanent
  streetNumberPermanent
  zipcodePermanent
  nurseProfile {
    id
    profileCompletion {
      id
      steps {
        permanentAddress {
          label
          message
          status
        }
      }
    }
  }
}
    `, {"fragmentName":"PermanentAddressUser"}) as unknown as TypedDocumentString<PermanentAddressUserFragment, unknown>;
export const PersonalInfoSectionUserFragmentDoc = new TypedDocumentString(`
    fragment PersonalInfoSectionUser on User {
  id
  firstName
  middleName
  lastName
  preferredName
  phone
  preferredPronoun
  nurseProfile {
    id
    state
    birthday
    fullSsnCollected
    ssnLast4
    role {
      id
      name
      type
    }
    primarySpecialty {
      id
      displayName
      fullName
      slug
    }
    profileCompletion {
      id
      steps {
        personalInfo {
          status
        }
      }
    }
  }
  ...PermanentAddressUser
}
    fragment PermanentAddressUser on User {
  id
  cityPermanent
  countryPermanentCode
  countryPermanentName
  googlePlaceIdPermanent
  statePermanent
  streetAddressPermanent
  streetNumberPermanent
  zipcodePermanent
  nurseProfile {
    id
    profileCompletion {
      id
      steps {
        permanentAddress {
          label
          message
          status
        }
      }
    }
  }
}`, {"fragmentName":"PersonalInfoSectionUser"}) as unknown as TypedDocumentString<PersonalInfoSectionUserFragment, unknown>;
export const AssignAssessmentPanelNurseAssessmentFragmentDoc = new TypedDocumentString(`
    fragment AssignAssessmentPanelNurseAssessment on NurseAssessment {
  id
  name
  category
  requestedOn
  completedOn
  assessment {
    id
    issuingBody
  }
}
    `, {"fragmentName":"AssignAssessmentPanelNurseAssessment"}) as unknown as TypedDocumentString<AssignAssessmentPanelNurseAssessmentFragment, unknown>;
export const RequestableAssessmentSuggestionFragmentDoc = new TypedDocumentString(`
    fragment RequestableAssessmentSuggestion on Assessment {
  id
  name
  category
}
    `, {"fragmentName":"RequestableAssessmentSuggestion"}) as unknown as TypedDocumentString<RequestableAssessmentSuggestionFragment, unknown>;
export const PayPeriodRowPayrollFragmentDoc = new TypedDocumentString(`
    fragment PayPeriodRowPayroll on Payroll {
  id
  periodStart
  periodEnd
  businessName
}
    `, {"fragmentName":"PayPeriodRowPayroll"}) as unknown as TypedDocumentString<PayPeriodRowPayrollFragment, unknown>;
export const PayPeriodTablePayrollFragmentDoc = new TypedDocumentString(`
    fragment PayPeriodTablePayroll on Payroll {
  id
  contract {
    id
    contractStartDate
    contractEndDate
  }
  ...PayPeriodRowPayroll
}
    fragment PayPeriodRowPayroll on Payroll {
  id
  periodStart
  periodEnd
  businessName
}`, {"fragmentName":"PayPeriodTablePayroll"}) as unknown as TypedDocumentString<PayPeriodTablePayrollFragment, unknown>;
export const PaymentSummaryPayrollLineItemFragmentDoc = new TypedDocumentString(`
    fragment PaymentSummaryPayrollLineItem on PayrollLineItem {
  kind
  hours
  rate
  netAmount
  order
  groupType
  humanizedLabel
}
    `, {"fragmentName":"PaymentSummaryPayrollLineItem"}) as unknown as TypedDocumentString<PaymentSummaryPayrollLineItemFragment, unknown>;
export const PopularCitiesCostOfLivingFragmentDoc = new TypedDocumentString(`
    fragment PopularCitiesCostOfLiving on PopularCityCostOfLiving {
  id
  city
  stateCode
  avgRent
}
    `, {"fragmentName":"PopularCitiesCostOfLiving"}) as unknown as TypedDocumentString<PopularCitiesCostOfLivingFragment, unknown>;
export const CityCardContainerCityPayFragmentDoc = new TypedDocumentString(`
    fragment CityCardContainerCityPay on PopularCityPay {
  id
  city
  stateCode
  travelWeeklyIncome
  staffHourlyIncome
}
    `, {"fragmentName":"CityCardContainerCityPay"}) as unknown as TypedDocumentString<CityCardContainerCityPayFragment, unknown>;
export const CertificationsListProfileCompletionFragmentDoc = new TypedDocumentString(`
    fragment CertificationsListProfileCompletion on NurseProfile {
  id
  profileCompletion {
    id
    steps {
      certification {
        status
      }
    }
  }
}
    `, {"fragmentName":"CertificationsListProfileCompletion"}) as unknown as TypedDocumentString<CertificationsListProfileCompletionFragment, unknown>;
export const CertificationsListNurseProfileFragmentDoc = new TypedDocumentString(`
    fragment CertificationsListNurseProfile on NurseProfile {
  id
  canApplyJobs
  certificationsComplete
  licenses {
    id
  }
  ...CertificationsListProfileCompletion
}
    fragment CertificationsListProfileCompletion on NurseProfile {
  id
  profileCompletion {
    id
    steps {
      certification {
        status
      }
    }
  }
}`, {"fragmentName":"CertificationsListNurseProfile"}) as unknown as TypedDocumentString<CertificationsListNurseProfileFragment, unknown>;
export const NurseCertificationFormFragmentDoc = new TypedDocumentString(`
    fragment NurseCertificationForm on NurseCertification {
  id
  name
  expiresOn
  completedOn
  isExpired
  isExpiringSoon
  issuingBody
  useCompletionDate
  certification {
    id
    name
    issuingBody
    issuingBodies
    credential
  }
  files {
    ...FileMetadata
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}`, {"fragmentName":"NurseCertificationForm"}) as unknown as TypedDocumentString<NurseCertificationFormFragment, unknown>;
export const CertificationsListNurseCertificationFragmentDoc = new TypedDocumentString(`
    fragment CertificationsListNurseCertification on NurseCertification {
  id
  name
  issuingBody
  expiresOn
  files {
    ...FileMetadata
  }
  ...NurseCertificationForm
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment NurseCertificationForm on NurseCertification {
  id
  name
  expiresOn
  completedOn
  isExpired
  isExpiringSoon
  issuingBody
  useCompletionDate
  certification {
    id
    name
    issuingBody
    issuingBodies
    credential
  }
  files {
    ...FileMetadata
  }
}`, {"fragmentName":"CertificationsListNurseCertification"}) as unknown as TypedDocumentString<CertificationsListNurseCertificationFragment, unknown>;
export const ThisIsMeIntentSelectorUserFragmentDoc = new TypedDocumentString(`
    fragment ThisIsMeIntentSelectorUser on User {
  id
  signupSource
  nurseProfile {
    id
    canViewJobs
    nursePreferences {
      id
      startPref
    }
  }
}
    `, {"fragmentName":"ThisIsMeIntentSelectorUser"}) as unknown as TypedDocumentString<ThisIsMeIntentSelectorUserFragment, unknown>;
export const ThisIsMeProfileProfilePhotoFragmentDoc = new TypedDocumentString(`
    fragment ThisIsMeProfileProfilePhoto on User {
  id
  profilePic
}
    `, {"fragmentName":"ThisIsMeProfileProfilePhoto"}) as unknown as TypedDocumentString<ThisIsMeProfileProfilePhotoFragment, unknown>;
export const ThisIsMeGetLocationFragmentDoc = new TypedDocumentString(`
    fragment ThisIsMeGetLocation on NurseProfile {
  currentEmployment {
    id
    locationAddress
  }
  educations {
    id
    locationAddress
  }
}
    `, {"fragmentName":"ThisIsMeGetLocation"}) as unknown as TypedDocumentString<ThisIsMeGetLocationFragment, unknown>;
export const ThisIsMeProfileSubheaderUserFragmentDoc = new TypedDocumentString(`
    fragment ThisIsMeProfileSubheaderUser on User {
  id
  firstName
  middleName
  lastName
  preferredName
  nurseProfile {
    id
    locationAddress
    hasBeenPlaced
    roleAbbreviation
    role {
      id
      key
      name
      type
    }
    primarySpecialty {
      displayName
    }
    ...ThisIsMeGetLocation
  }
}
    fragment ThisIsMeGetLocation on NurseProfile {
  currentEmployment {
    id
    locationAddress
  }
  educations {
    id
    locationAddress
  }
}`, {"fragmentName":"ThisIsMeProfileSubheaderUser"}) as unknown as TypedDocumentString<ThisIsMeProfileSubheaderUserFragment, unknown>;
export const ThisIsMeProfileNurseProfileFragmentDoc = new TypedDocumentString(`
    fragment ThisIsMeProfileNurseProfile on NurseProfile {
  id
  primarySpecialty {
    id
    fullName
    slug
  }
  role {
    id
    key
    name
    type
  }
}
    `, {"fragmentName":"ThisIsMeProfileNurseProfile"}) as unknown as TypedDocumentString<ThisIsMeProfileNurseProfileFragment, unknown>;
export const ThisIsMeProfileUserFragmentDoc = new TypedDocumentString(`
    fragment ThisIsMeProfileUser on User {
  id
  ...ThisIsMeIntentSelectorUser
  ...ThisIsMeProfileProfilePhoto
  ...ThisIsMeProfileSubheaderUser
  nurseProfile {
    id
    ...ThisIsMeProfileNurseProfile
  }
}
    fragment ThisIsMeProfileNurseProfile on NurseProfile {
  id
  primarySpecialty {
    id
    fullName
    slug
  }
  role {
    id
    key
    name
    type
  }
}
fragment ThisIsMeIntentSelectorUser on User {
  id
  signupSource
  nurseProfile {
    id
    canViewJobs
    nursePreferences {
      id
      startPref
    }
  }
}
fragment ThisIsMeProfileProfilePhoto on User {
  id
  profilePic
}
fragment ThisIsMeProfileSubheaderUser on User {
  id
  firstName
  middleName
  lastName
  preferredName
  nurseProfile {
    id
    locationAddress
    hasBeenPlaced
    roleAbbreviation
    role {
      id
      key
      name
      type
    }
    primarySpecialty {
      displayName
    }
    ...ThisIsMeGetLocation
  }
}
fragment ThisIsMeGetLocation on NurseProfile {
  currentEmployment {
    id
    locationAddress
  }
  educations {
    id
    locationAddress
  }
}`, {"fragmentName":"ThisIsMeProfileUser"}) as unknown as TypedDocumentString<ThisIsMeProfileUserFragment, unknown>;
export const QualificationQuestionsCareSettingNursePreferencesFragmentDoc = new TypedDocumentString(`
    fragment QualificationQuestionsCareSettingNursePreferences on NursePreferences {
  id
  careSettingOther
  careSettingPrefs
}
    `, {"fragmentName":"QualificationQuestionsCareSettingNursePreferences"}) as unknown as TypedDocumentString<QualificationQuestionsCareSettingNursePreferencesFragment, unknown>;
export const ClinicalExperienceFormSpecialtyFragmentDoc = new TypedDocumentString(`
    fragment ClinicalExperienceFormSpecialty on ClinicalSpecialty {
  displayName
  fullName
  id
  nicu
  pediatric
  slug
  uuid
}
    `, {"fragmentName":"ClinicalExperienceFormSpecialty"}) as unknown as TypedDocumentString<ClinicalExperienceFormSpecialtyFragment, unknown>;
export const ClinicalExperienceFormPositionFragmentDoc = new TypedDocumentString(`
    fragment ClinicalExperienceFormPosition on Position {
  id
  specialties {
    ...ClinicalExperienceFormSpecialty
  }
}
    fragment ClinicalExperienceFormSpecialty on ClinicalSpecialty {
  displayName
  fullName
  id
  nicu
  pediatric
  slug
  uuid
}`, {"fragmentName":"ClinicalExperienceFormPosition"}) as unknown as TypedDocumentString<ClinicalExperienceFormPositionFragment, unknown>;
export const QualificationQuestionsNursePreferencesFragmentDoc = new TypedDocumentString(`
    fragment QualificationQuestionsNursePreferences on NursePreferences {
  id
  startPref
  earliestStartDate
}
    `, {"fragmentName":"QualificationQuestionsNursePreferences"}) as unknown as TypedDocumentString<QualificationQuestionsNursePreferencesFragment, unknown>;
export const QualificationQuestionsNurseProfileFragmentDoc = new TypedDocumentString(`
    fragment QualificationQuestionsNurseProfile on NurseProfile {
  id
  roleKey
  licenses {
    id
    state
    stateCode
    licensureCompact
    licenseType
  }
}
    `, {"fragmentName":"QualificationQuestionsNurseProfile"}) as unknown as TypedDocumentString<QualificationQuestionsNurseProfileFragment, unknown>;
export const QualificationQuestionsLicenseFragmentDoc = new TypedDocumentString(`
    fragment QualificationQuestionsLicense on License {
  id
  licensureCompact
}
    `, {"fragmentName":"QualificationQuestionsLicense"}) as unknown as TypedDocumentString<QualificationQuestionsLicenseFragment, unknown>;
export const LocationPreferencesNursePreferencesFragmentDoc = new TypedDocumentString(`
    fragment LocationPreferencesNursePreferences on NursePreferences {
  id
  broadPrefLocations
  locations {
    id
    locationString
    googlePlaceId
    formattedLocationString
  }
}
    `, {"fragmentName":"LocationPreferencesNursePreferences"}) as unknown as TypedDocumentString<LocationPreferencesNursePreferencesFragment, unknown>;
export const ShiftPrefNursePreferencesFragmentDoc = new TypedDocumentString(`
    fragment ShiftPrefNursePreferences on NursePreferences {
  id
  shiftPref
  shiftPrefs
}
    `, {"fragmentName":"ShiftPrefNursePreferences"}) as unknown as TypedDocumentString<ShiftPrefNursePreferencesFragment, unknown>;
export const PhoneConfirmationStepUserFragmentDoc = new TypedDocumentString(`
    fragment PhoneConfirmationStepUser on User {
  id
  intercomUserHash
  signupSource
  phone
  phoneVerified
  nurseProfile {
    id
    nursePreferences {
      id
    }
  }
}
    `, {"fragmentName":"PhoneConfirmationStepUser"}) as unknown as TypedDocumentString<PhoneConfirmationStepUserFragment, unknown>;
export const TravelExperienceStepNursePreferencesFragmentDoc = new TypedDocumentString(`
    fragment TravelExperienceStepNursePreferences on NursePreferences {
  id
  travelExperience
}
    `, {"fragmentName":"TravelExperienceStepNursePreferences"}) as unknown as TypedDocumentString<TravelExperienceStepNursePreferencesFragment, unknown>;
export const ResumePreviewAffiliationHistoryFragmentDoc = new TypedDocumentString(`
    fragment ResumePreviewAffiliationHistory on AffiliationHistory {
  id
  organizationName
  startDate
  endDate
  role
  descriptions
}
    `, {"fragmentName":"ResumePreviewAffiliationHistory"}) as unknown as TypedDocumentString<ResumePreviewAffiliationHistoryFragment, unknown>;
export const ResumePreviewAwardsHonorsFragmentDoc = new TypedDocumentString(`
    fragment ResumePreviewAwardsHonors on Award {
  id
  awardedOn
  name
  organization
  descriptions
}
    `, {"fragmentName":"ResumePreviewAwardsHonors"}) as unknown as TypedDocumentString<ResumePreviewAwardsHonorsFragment, unknown>;
export const ResumePreviewCertificationNurseCertificationFragmentDoc = new TypedDocumentString(`
    fragment ResumePreviewCertificationNurseCertification on NurseCertification {
  id
  expiresOn
  certification {
    id
    name
    issuingBody
  }
}
    `, {"fragmentName":"ResumePreviewCertificationNurseCertification"}) as unknown as TypedDocumentString<ResumePreviewCertificationNurseCertificationFragment, unknown>;
export const ResumePreviewEducationFragmentDoc = new TypedDocumentString(`
    fragment ResumePreviewEducation on Education {
  id
  locationAddress
  startedOn
  graduatedOn
  schoolName
  degree
  hasGap
  gapStartOn
  gapEndOn
  gapLocation {
    id
    address
  }
  gapReason
  gapExplanation
  descriptions
}
    `, {"fragmentName":"ResumePreviewEducation"}) as unknown as TypedDocumentString<ResumePreviewEducationFragment, unknown>;
export const ResumePreviewLanguageFragmentDoc = new TypedDocumentString(`
    fragment ResumePreviewLanguage on Language {
  id
  language
  proficiency
}
    `, {"fragmentName":"ResumePreviewLanguage"}) as unknown as TypedDocumentString<ResumePreviewLanguageFragment, unknown>;
export const ResumePreviewLicenseLicenseFragmentDoc = new TypedDocumentString(`
    fragment ResumePreviewLicenseLicense on License {
  id
  expiresOn
  state
  friendlyLicenseType
  number
  compact
}
    `, {"fragmentName":"ResumePreviewLicenseLicense"}) as unknown as TypedDocumentString<ResumePreviewLicenseLicenseFragment, unknown>;
export const ResumePreviewResearchFragmentDoc = new TypedDocumentString(`
    fragment ResumePreviewResearch on Research {
  id
  startOn
  endOn
  orgName
  descriptions
  locationAddress
}
    `, {"fragmentName":"ResumePreviewResearch"}) as unknown as TypedDocumentString<ResumePreviewResearchFragment, unknown>;
export const ResumePreviewStudentClinicalExperienceFragmentDoc = new TypedDocumentString(`
    fragment ResumePreviewStudentClinicalExperience on StudentClinicalExperience {
  id
  facilityName
  locationAddress
  experienceYear
  experienceYearTerm
  experienceType
  studentClinicalExperienceUnits {
    id
    name
    hoursWorked
    descriptions
  }
}
    `, {"fragmentName":"ResumePreviewStudentClinicalExperience"}) as unknown as TypedDocumentString<ResumePreviewStudentClinicalExperienceFragment, unknown>;
export const ResumePreviewWorkExperienceEmploymentPositionFragmentDoc = new TypedDocumentString(`
    fragment ResumePreviewWorkExperienceEmploymentPosition on Position {
  id
  title
  classification
  additionalSkills
  startAt
  endAt
  floatFrequency
  hoursWorked
  hoursWorkedText
  hoursWorkedTimeframe
  leadExperience
  nicuCareLevels: nicuLevel
  chargeExperience
  preceptorExperience
  unitBedCount
  hospitalBedCount
  magnet
  teaching
  traumaLevel
  patientRatio
  facility {
    id
    name
    location {
      id
      city
      stateCode
    }
  }
  role {
    id
    name
  }
  floatUnits {
    id
    displayName
  }
  agency {
    id
    name
  }
  specialties {
    id
    displayName
  }
  technologies {
    id
    name
  }
  clinicalUnit {
    id
    displayName
  }
}
    `, {"fragmentName":"ResumePreviewWorkExperienceEmploymentPosition"}) as unknown as TypedDocumentString<ResumePreviewWorkExperienceEmploymentPositionFragment, unknown>;
export const ResumePreviewWorkExperienceEmploymentGapFragmentDoc = new TypedDocumentString(`
    fragment ResumePreviewWorkExperienceEmploymentGap on Gap {
  gapId: id
  gapEndAt: endAt
  gapExplanation: explanation
  gapIsEducationGap: isEducationGap
  gapLocationAddress: locationAddress
  gapReason: reason
  gapStartAt: startAt
}
    `, {"fragmentName":"ResumePreviewWorkExperienceEmploymentGap"}) as unknown as TypedDocumentString<ResumePreviewWorkExperienceEmploymentGapFragment, unknown>;
export const ResumePreviewWorkExperienceItemFragmentDoc = new TypedDocumentString(`
    fragment ResumePreviewWorkExperienceItem on ExperienceItemUnion {
  ... on Position {
    ...ResumePreviewWorkExperienceEmploymentPosition
  }
  ... on Gap {
    ...ResumePreviewWorkExperienceEmploymentGap
  }
}
    fragment ResumePreviewWorkExperienceEmploymentPosition on Position {
  id
  title
  classification
  additionalSkills
  startAt
  endAt
  floatFrequency
  hoursWorked
  hoursWorkedText
  hoursWorkedTimeframe
  leadExperience
  nicuCareLevels: nicuLevel
  chargeExperience
  preceptorExperience
  unitBedCount
  hospitalBedCount
  magnet
  teaching
  traumaLevel
  patientRatio
  facility {
    id
    name
    location {
      id
      city
      stateCode
    }
  }
  role {
    id
    name
  }
  floatUnits {
    id
    displayName
  }
  agency {
    id
    name
  }
  specialties {
    id
    displayName
  }
  technologies {
    id
    name
  }
  clinicalUnit {
    id
    displayName
  }
}
fragment ResumePreviewWorkExperienceEmploymentGap on Gap {
  gapId: id
  gapEndAt: endAt
  gapExplanation: explanation
  gapIsEducationGap: isEducationGap
  gapLocationAddress: locationAddress
  gapReason: reason
  gapStartAt: startAt
}`, {"fragmentName":"ResumePreviewWorkExperienceItem"}) as unknown as TypedDocumentString<ResumePreviewWorkExperienceItemFragment, unknown>;
export const ClinicalSpecialtySuggestionsClinicalSpecialtyFragmentDoc = new TypedDocumentString(`
    fragment ClinicalSpecialtySuggestionsClinicalSpecialty on ClinicalSpecialty {
  id
  slug
  fullName
  displayName
  pediatric
  nicu
}
    `, {"fragmentName":"ClinicalSpecialtySuggestionsClinicalSpecialty"}) as unknown as TypedDocumentString<ClinicalSpecialtySuggestionsClinicalSpecialtyFragment, unknown>;
export const ClinicalExperienceListNurseProfileFragmentDoc = new TypedDocumentString(`
    fragment ClinicalExperienceListNurseProfile on NurseProfile {
  id
  clinicalSpecialties {
    ...ClinicalSpecialtySuggestionsClinicalSpecialty
  }
  nursePreferences {
    id
  }
  role {
    id
    key
    name
    type
  }
}
    fragment ClinicalSpecialtySuggestionsClinicalSpecialty on ClinicalSpecialty {
  id
  slug
  fullName
  displayName
  pediatric
  nicu
}`, {"fragmentName":"ClinicalExperienceListNurseProfile"}) as unknown as TypedDocumentString<ClinicalExperienceListNurseProfileFragment, unknown>;
export const ClinicalExperienceStepUserFragmentDoc = new TypedDocumentString(`
    fragment ClinicalExperienceStepUser on User {
  id
  signupSource
  intercomUserHash
  nurseProfile {
    id
    clinicalExperienceLevel
  }
}
    `, {"fragmentName":"ClinicalExperienceStepUser"}) as unknown as TypedDocumentString<ClinicalExperienceStepUserFragment, unknown>;
export const CurrentLocationUserFragmentDoc = new TypedDocumentString(`
    fragment CurrentLocationUser on User {
  id
  signupSource
  nurseProfile {
    id
    wizardCompleted
    location {
      id
      googlePlaceId
      locationString
    }
  }
}
    `, {"fragmentName":"CurrentLocationUser"}) as unknown as TypedDocumentString<CurrentLocationUserFragment, unknown>;
export const UserCreationStepUserFragmentDoc = new TypedDocumentString(`
    fragment UserCreationStepUser on User {
  id
  signupSource
  intercomUserHash
  initialReferringDomain
  userProperties {
    shouldSendAppcastPixel
  }
}
    `, {"fragmentName":"UserCreationStepUser"}) as unknown as TypedDocumentString<UserCreationStepUserFragment, unknown>;
export const TimeEnteredShiftFragmentDoc = new TypedDocumentString(`
    fragment TimeEnteredShift on Shift {
  id
  duration
  startSec
  timezone
  timeEntries {
    id
    entryType
    archived
    startSec
    endSec
    timezone
    timeType
    duration
  }
}
    `, {"fragmentName":"TimeEnteredShift"}) as unknown as TypedDocumentString<TimeEnteredShiftFragment, unknown>;
export const WalkscoreCardFragmentDoc = new TypedDocumentString(`
    fragment WalkscoreCard on Walkscore {
  walkScore
  walkDescription
  walkExtraInfo
  bikeScore
  bikeDescription
  bikeExtraInfo
  transitScore
  transitDescription
  transitExtraInfo
}
    `, {"fragmentName":"WalkscoreCard"}) as unknown as TypedDocumentString<WalkscoreCardFragment, unknown>;
export const CurrentAddressUserFragmentDoc = new TypedDocumentString(`
    fragment CurrentAddressUser on User {
  id
  city
  state
  streetAddress
  zipcode
}
    `, {"fragmentName":"CurrentAddressUser"}) as unknown as TypedDocumentString<CurrentAddressUserFragment, unknown>;
export const EmailVerificationHintUserFragmentDoc = new TypedDocumentString(`
    fragment EmailVerificationHintUser on User {
  id
  email
  confirmedAt
}
    `, {"fragmentName":"EmailVerificationHintUser"}) as unknown as TypedDocumentString<EmailVerificationHintUserFragment, unknown>;
export const PhoneVerificationHintUserFragmentDoc = new TypedDocumentString(`
    fragment PhoneVerificationHintUser on User {
  id
  phone
  phoneVerified
}
    `, {"fragmentName":"PhoneVerificationHintUser"}) as unknown as TypedDocumentString<PhoneVerificationHintUserFragment, unknown>;
export const AccountContactInformationPaperUserFragmentDoc = new TypedDocumentString(`
    fragment AccountContactInformationPaperUser on User {
  id
  firstName
  lastName
  middleName
  preferredName
  preferredPronoun
  ...CurrentAddressUser
  ...EmailVerificationHintUser
  ...PermanentAddressUser
  ...PhoneVerificationHintUser
}
    fragment PermanentAddressUser on User {
  id
  cityPermanent
  countryPermanentCode
  countryPermanentName
  googlePlaceIdPermanent
  statePermanent
  streetAddressPermanent
  streetNumberPermanent
  zipcodePermanent
  nurseProfile {
    id
    profileCompletion {
      id
      steps {
        permanentAddress {
          label
          message
          status
        }
      }
    }
  }
}
fragment EmailVerificationHintUser on User {
  id
  email
  confirmedAt
}
fragment PhoneVerificationHintUser on User {
  id
  phone
  phoneVerified
}
fragment CurrentAddressUser on User {
  id
  city
  state
  streetAddress
  zipcode
}`, {"fragmentName":"AccountContactInformationPaperUser"}) as unknown as TypedDocumentString<AccountContactInformationPaperUserFragment, unknown>;
export const AccountPageFormUserFragmentDoc = new TypedDocumentString(`
    fragment AccountPageFormUser on User {
  id
  intercomUserHash
  subscribedCeuEmail
  subscribedInvitesEmail
  subscribedMatchesEmail
  subscribedBrazeRootEmail
  subscribedNewsletterEmail
  subscribedReferencesEmail
  subscribedCredentialsEmail
  subscribedProductUpdatesEmail
  subscribedJobApplicationsEmail
  marketingSmsAllowed
  nurseProfile {
    id
    birthday
    dlNumber
    dlState
    dlExpiresOn
    ssnLast4
    fullSsnCollected
  }
  ...AccountContactInformationPaperUser
}
    fragment PermanentAddressUser on User {
  id
  cityPermanent
  countryPermanentCode
  countryPermanentName
  googlePlaceIdPermanent
  statePermanent
  streetAddressPermanent
  streetNumberPermanent
  zipcodePermanent
  nurseProfile {
    id
    profileCompletion {
      id
      steps {
        permanentAddress {
          label
          message
          status
        }
      }
    }
  }
}
fragment EmailVerificationHintUser on User {
  id
  email
  confirmedAt
}
fragment PhoneVerificationHintUser on User {
  id
  phone
  phoneVerified
}
fragment CurrentAddressUser on User {
  id
  city
  state
  streetAddress
  zipcode
}
fragment AccountContactInformationPaperUser on User {
  id
  firstName
  lastName
  middleName
  preferredName
  preferredPronoun
  ...CurrentAddressUser
  ...EmailVerificationHintUser
  ...PermanentAddressUser
  ...PhoneVerificationHintUser
}`, {"fragmentName":"AccountPageFormUser"}) as unknown as TypedDocumentString<AccountPageFormUserFragment, unknown>;
export const DraftApplicationMatchCardJobFragmentDoc = new TypedDocumentString(`
    fragment DraftApplicationMatchCardJob on Job {
  ...MatchCardJob
  jobApplication {
    id
  }
}
    fragment MatchCardJob on Job {
  id
  activeApplicantsCount
  favoritedCount
  hoursPerShift
  instantOffer
  jobType
  lengthInWeeks
  licenseType
  localAllowed
  onHold
  shiftType
  shiftsPerWeek
  startAsap
  startDate
  endDate
  facilityName
  cancellationPolicy
  stateActiveAt
  title
  travelAllowed
  business {
    city
    state
    ...MatchCardFacility
  }
  clinicalUnit {
    id
    displayName
  }
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  location {
    id
    city
    stateCode
  }
  localPaymentDetails {
    id
    grossPayWeekly
  }
  emr {
    id
    name
  }
}
fragment MatchCardFacility on Facility {
  id
  name
  logo
}`, {"fragmentName":"DraftApplicationMatchCardJob"}) as unknown as TypedDocumentString<DraftApplicationMatchCardJobFragment, unknown>;
export const JobApplicationSummaryJobApplicationFragmentDoc = new TypedDocumentString(`
    fragment JobApplicationSummaryJobApplication on JobApplication {
  id
  state
  candidateHoldReasons
  requestedAt
  job {
    ...DraftApplicationMatchCardJob
  }
}
    fragment MatchCardJob on Job {
  id
  activeApplicantsCount
  favoritedCount
  hoursPerShift
  instantOffer
  jobType
  lengthInWeeks
  licenseType
  localAllowed
  onHold
  shiftType
  shiftsPerWeek
  startAsap
  startDate
  endDate
  facilityName
  cancellationPolicy
  stateActiveAt
  title
  travelAllowed
  business {
    city
    state
    ...MatchCardFacility
  }
  clinicalUnit {
    id
    displayName
  }
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  location {
    id
    city
    stateCode
  }
  localPaymentDetails {
    id
    grossPayWeekly
  }
  emr {
    id
    name
  }
}
fragment DraftApplicationMatchCardJob on Job {
  ...MatchCardJob
  jobApplication {
    id
  }
}
fragment MatchCardFacility on Facility {
  id
  name
  logo
}`, {"fragmentName":"JobApplicationSummaryJobApplication"}) as unknown as TypedDocumentString<JobApplicationSummaryJobApplicationFragment, unknown>;
export const JobApplicationSummaryJobOfferV2FragmentDoc = new TypedDocumentString(`
    fragment JobApplicationSummaryJobOfferV2 on JobOffer {
  id
  startDate
  lengthInWeeks
  shiftsPerWeek
  shiftType
  hoursPerShift
  paymentDetails {
    id
    grossPayWeekly
  }
  jobApplication {
    id
    paymentDetails {
      grossPayWeekly
    }
  }
  job {
    id
    startDate
    lengthInWeeks
    shiftsPerWeek
    shiftType
    hoursPerShift
    facilityName
    title
    location {
      id
      city
      stateCode
    }
  }
}
    `, {"fragmentName":"JobApplicationSummaryJobOfferV2"}) as unknown as TypedDocumentString<JobApplicationSummaryJobOfferV2Fragment, unknown>;
export const JobApplicationSummaryJobOfferFragmentDoc = new TypedDocumentString(`
    fragment JobApplicationSummaryJobOffer on JobOffer {
  id
  jobApplication {
    ...JobApplicationSummaryJobApplication
  }
  ...JobApplicationSummaryJobOfferV2
}
    fragment MatchCardJob on Job {
  id
  activeApplicantsCount
  favoritedCount
  hoursPerShift
  instantOffer
  jobType
  lengthInWeeks
  licenseType
  localAllowed
  onHold
  shiftType
  shiftsPerWeek
  startAsap
  startDate
  endDate
  facilityName
  cancellationPolicy
  stateActiveAt
  title
  travelAllowed
  business {
    city
    state
    ...MatchCardFacility
  }
  clinicalUnit {
    id
    displayName
  }
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  location {
    id
    city
    stateCode
  }
  localPaymentDetails {
    id
    grossPayWeekly
  }
  emr {
    id
    name
  }
}
fragment DraftApplicationMatchCardJob on Job {
  ...MatchCardJob
  jobApplication {
    id
  }
}
fragment MatchCardFacility on Facility {
  id
  name
  logo
}
fragment JobApplicationSummaryJobOfferV2 on JobOffer {
  id
  startDate
  lengthInWeeks
  shiftsPerWeek
  shiftType
  hoursPerShift
  paymentDetails {
    id
    grossPayWeekly
  }
  jobApplication {
    id
    paymentDetails {
      grossPayWeekly
    }
  }
  job {
    id
    startDate
    lengthInWeeks
    shiftsPerWeek
    shiftType
    hoursPerShift
    facilityName
    title
    location {
      id
      city
      stateCode
    }
  }
}
fragment JobApplicationSummaryJobApplication on JobApplication {
  id
  state
  candidateHoldReasons
  requestedAt
  job {
    ...DraftApplicationMatchCardJob
  }
}`, {"fragmentName":"JobApplicationSummaryJobOffer"}) as unknown as TypedDocumentString<JobApplicationSummaryJobOfferFragment, unknown>;
export const JobApplicationsSummaryFragmentDoc = new TypedDocumentString(`
    fragment JobApplicationsSummary on JobApplicationsSummary {
  id
  offer {
    ...JobApplicationSummaryJobOffer
  }
  actionRequired {
    ...JobApplicationSummaryJobApplication
  }
  submittedToFacility {
    ...JobApplicationSummaryJobApplication
  }
  pendingTrustedReview {
    ...JobApplicationSummaryJobApplication
  }
  previous {
    ...JobApplicationSummaryJobApplication
  }
  drafted {
    ...JobApplicationSummaryJobApplication
  }
}
    fragment MatchCardJob on Job {
  id
  activeApplicantsCount
  favoritedCount
  hoursPerShift
  instantOffer
  jobType
  lengthInWeeks
  licenseType
  localAllowed
  onHold
  shiftType
  shiftsPerWeek
  startAsap
  startDate
  endDate
  facilityName
  cancellationPolicy
  stateActiveAt
  title
  travelAllowed
  business {
    city
    state
    ...MatchCardFacility
  }
  clinicalUnit {
    id
    displayName
  }
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  location {
    id
    city
    stateCode
  }
  localPaymentDetails {
    id
    grossPayWeekly
  }
  emr {
    id
    name
  }
}
fragment DraftApplicationMatchCardJob on Job {
  ...MatchCardJob
  jobApplication {
    id
  }
}
fragment MatchCardFacility on Facility {
  id
  name
  logo
}
fragment JobApplicationSummaryJobOfferV2 on JobOffer {
  id
  startDate
  lengthInWeeks
  shiftsPerWeek
  shiftType
  hoursPerShift
  paymentDetails {
    id
    grossPayWeekly
  }
  jobApplication {
    id
    paymentDetails {
      grossPayWeekly
    }
  }
  job {
    id
    startDate
    lengthInWeeks
    shiftsPerWeek
    shiftType
    hoursPerShift
    facilityName
    title
    location {
      id
      city
      stateCode
    }
  }
}
fragment JobApplicationSummaryJobOffer on JobOffer {
  id
  jobApplication {
    ...JobApplicationSummaryJobApplication
  }
  ...JobApplicationSummaryJobOfferV2
}
fragment JobApplicationSummaryJobApplication on JobApplication {
  id
  state
  candidateHoldReasons
  requestedAt
  job {
    ...DraftApplicationMatchCardJob
  }
}`, {"fragmentName":"JobApplicationsSummary"}) as unknown as TypedDocumentString<JobApplicationsSummaryFragment, unknown>;
export const JobApplicationsSummaryUserFragmentDoc = new TypedDocumentString(`
    fragment JobApplicationsSummaryUser on User {
  id
  email
  firstName
  userProperties {
    shouldDisplayFirstFavoriteMessage
  }
  nurseProfile {
    id
    canApplyJobs
    profileCompletion {
      id
      meta {
        id
        percentCompleted
      }
    }
  }
}
    `, {"fragmentName":"JobApplicationsSummaryUser"}) as unknown as TypedDocumentString<JobApplicationsSummaryUserFragment, unknown>;
export const PreviousOffersSummaryFragmentDoc = new TypedDocumentString(`
    fragment PreviousOffersSummary on NurseProfile {
  previousOffers: jobOffers(filter: previous) {
    id
  }
}
    `, {"fragmentName":"PreviousOffersSummary"}) as unknown as TypedDocumentString<PreviousOffersSummaryFragment, unknown>;
export const JobWithErrorFragmentDoc = new TypedDocumentString(`
    fragment JobWithError on JobWithError {
  job {
    id
    grossPayWeekly
    location {
      id
      city
      stateCode
    }
    business {
      id
      name
    }
  }
  errors
}
    `, {"fragmentName":"JobWithError"}) as unknown as TypedDocumentString<JobWithErrorFragment, unknown>;
export const CeuGoalsTrackingContainerNurseProfileFragmentDoc = new TypedDocumentString(`
    fragment CeuGoalsTrackingContainerNurseProfile on NurseProfile {
  id
  ceuGoals {
    id
    goalType
    requiredContactHours
    startDate
    endDate
    description
    systemCreated
    accepted
    deleted
    ceuStateRequirement {
      id
      state
      requiredContactHours
      notes
      requirementQuantity
      requirementDescription
      stateBonUrl
      durationDays
      licenseType
    }
    completedContactHours
    ceuCertificates {
      id
    }
    ...CeuGoalFormCeuGoal
  }
}
    fragment CeuGoalFormCeuGoal on CeuGoal {
  id
  goalType
  requiredContactHours
  startDate
  endDate
  description
  ceuStateRequirement {
    id
  }
  ceuCertificates {
    id
  }
}`, {"fragmentName":"CeuGoalsTrackingContainerNurseProfile"}) as unknown as TypedDocumentString<CeuGoalsTrackingContainerNurseProfileFragment, unknown>;
export const CeuGoalContainerCeuGoalFragmentDoc = new TypedDocumentString(`
    fragment CeuGoalContainerCeuGoal on CeuGoal {
  id
  goalType
  requiredContactHours
  startDate
  endDate
  description
  systemCreated
  accepted
  deleted
  completedContactHours
  ceuStateRequirement {
    id
    state
    requiredContactHours
    notes
    requirementQuantity
    requirementDescription
    stateBonUrl
    durationDays
    licenseType
  }
  ceuCertificates {
    id
  }
}
    `, {"fragmentName":"CeuGoalContainerCeuGoal"}) as unknown as TypedDocumentString<CeuGoalContainerCeuGoalFragment, unknown>;
export const MatchCardUserFragmentDoc = new TypedDocumentString(`
    fragment MatchCardUser on User {
  id
  email
  nurseProfile {
    id
    isActivated
    percentComplete
    state
    profileCompletion {
      id
      meta {
        id
        percentCompleted
      }
    }
    nurseAdvocate {
      id
      email
      fullName
    }
  }
}
    `, {"fragmentName":"MatchCardUser"}) as unknown as TypedDocumentString<MatchCardUserFragment, unknown>;
export const RequestInterviewButtonNurseProfileFragmentDoc = new TypedDocumentString(`
    fragment RequestInterviewButtonNurseProfile on NurseProfile {
  id
  isActivated
  canApplyJobs
  profileCompletion {
    id
    meta {
      id
      percentCompleted
    }
  }
  state
}
    `, {"fragmentName":"RequestInterviewButtonNurseProfile"}) as unknown as TypedDocumentString<RequestInterviewButtonNurseProfileFragment, unknown>;
export const JobApplicationRequirementsNurseAdvocateFragmentDoc = new TypedDocumentString(`
    fragment JobApplicationRequirementsNurseAdvocate on SalesforceUser {
  id
  email
  fullName
}
    `, {"fragmentName":"JobApplicationRequirementsNurseAdvocate"}) as unknown as TypedDocumentString<JobApplicationRequirementsNurseAdvocateFragment, unknown>;
export const JobApplicationRequirementsNurseProfileFragmentDoc = new TypedDocumentString(`
    fragment JobApplicationRequirementsNurseProfile on NurseProfile {
  id
  state
  percentComplete
  profileCompletion {
    id
  }
  nurseAdvocate {
    ...JobApplicationRequirementsNurseAdvocate
  }
}
    fragment JobApplicationRequirementsNurseAdvocate on SalesforceUser {
  id
  email
  fullName
}`, {"fragmentName":"JobApplicationRequirementsNurseProfile"}) as unknown as TypedDocumentString<JobApplicationRequirementsNurseProfileFragment, unknown>;
export const JobApplicationRequirementsUserFragmentDoc = new TypedDocumentString(`
    fragment JobApplicationRequirementsUser on User {
  id
  email
  firstName
  lastName
  nurseProfile {
    ...JobApplicationRequirementsNurseProfile
  }
}
    fragment JobApplicationRequirementsNurseAdvocate on SalesforceUser {
  id
  email
  fullName
}
fragment JobApplicationRequirementsNurseProfile on NurseProfile {
  id
  state
  percentComplete
  profileCompletion {
    id
  }
  nurseAdvocate {
    ...JobApplicationRequirementsNurseAdvocate
  }
}`, {"fragmentName":"JobApplicationRequirementsUser"}) as unknown as TypedDocumentString<JobApplicationRequirementsUserFragment, unknown>;
export const RequestInterviewButtonUserFragmentDoc = new TypedDocumentString(`
    fragment RequestInterviewButtonUser on User {
  id
  nurseProfile {
    ...RequestInterviewButtonNurseProfile
  }
  ...JobApplicationRequirementsUser
}
    fragment RequestInterviewButtonNurseProfile on NurseProfile {
  id
  isActivated
  canApplyJobs
  profileCompletion {
    id
    meta {
      id
      percentCompleted
    }
  }
  state
}
fragment JobApplicationRequirementsUser on User {
  id
  email
  firstName
  lastName
  nurseProfile {
    ...JobApplicationRequirementsNurseProfile
  }
}
fragment JobApplicationRequirementsNurseAdvocate on SalesforceUser {
  id
  email
  fullName
}
fragment JobApplicationRequirementsNurseProfile on NurseProfile {
  id
  state
  percentComplete
  profileCompletion {
    id
  }
  nurseAdvocate {
    ...JobApplicationRequirementsNurseAdvocate
  }
}`, {"fragmentName":"RequestInterviewButtonUser"}) as unknown as TypedDocumentString<RequestInterviewButtonUserFragment, unknown>;
export const MatchApplyButtonUserFragmentDoc = new TypedDocumentString(`
    fragment MatchApplyButtonUser on User {
  id
  ...RequestInterviewButtonUser
}
    fragment RequestInterviewButtonUser on User {
  id
  nurseProfile {
    ...RequestInterviewButtonNurseProfile
  }
  ...JobApplicationRequirementsUser
}
fragment RequestInterviewButtonNurseProfile on NurseProfile {
  id
  isActivated
  canApplyJobs
  profileCompletion {
    id
    meta {
      id
      percentCompleted
    }
  }
  state
}
fragment JobApplicationRequirementsUser on User {
  id
  email
  firstName
  lastName
  nurseProfile {
    ...JobApplicationRequirementsNurseProfile
  }
}
fragment JobApplicationRequirementsNurseAdvocate on SalesforceUser {
  id
  email
  fullName
}
fragment JobApplicationRequirementsNurseProfile on NurseProfile {
  id
  state
  percentComplete
  profileCompletion {
    id
  }
  nurseAdvocate {
    ...JobApplicationRequirementsNurseAdvocate
  }
}`, {"fragmentName":"MatchApplyButtonUser"}) as unknown as TypedDocumentString<MatchApplyButtonUserFragment, unknown>;
export const MatchFavoriteButtonUserFragmentDoc = new TypedDocumentString(`
    fragment MatchFavoriteButtonUser on User {
  id
  userProperties {
    id
    shouldDisplayFirstFavoriteMessage
  }
}
    `, {"fragmentName":"MatchFavoriteButtonUser"}) as unknown as TypedDocumentString<MatchFavoriteButtonUserFragment, unknown>;
export const JobMatchTopCardBlockUserFragmentDoc = new TypedDocumentString(`
    fragment JobMatchTopCardBlockUser on User {
  id
  referralCode
  ...MatchApplyButtonUser
  ...MatchFavoriteButtonUser
}
    fragment MatchApplyButtonUser on User {
  id
  ...RequestInterviewButtonUser
}
fragment MatchFavoriteButtonUser on User {
  id
  userProperties {
    id
    shouldDisplayFirstFavoriteMessage
  }
}
fragment RequestInterviewButtonUser on User {
  id
  nurseProfile {
    ...RequestInterviewButtonNurseProfile
  }
  ...JobApplicationRequirementsUser
}
fragment RequestInterviewButtonNurseProfile on NurseProfile {
  id
  isActivated
  canApplyJobs
  profileCompletion {
    id
    meta {
      id
      percentCompleted
    }
  }
  state
}
fragment JobApplicationRequirementsUser on User {
  id
  email
  firstName
  lastName
  nurseProfile {
    ...JobApplicationRequirementsNurseProfile
  }
}
fragment JobApplicationRequirementsNurseAdvocate on SalesforceUser {
  id
  email
  fullName
}
fragment JobApplicationRequirementsNurseProfile on NurseProfile {
  id
  state
  percentComplete
  profileCompletion {
    id
  }
  nurseAdvocate {
    ...JobApplicationRequirementsNurseAdvocate
  }
}`, {"fragmentName":"JobMatchTopCardBlockUser"}) as unknown as TypedDocumentString<JobMatchTopCardBlockUserFragment, unknown>;
export const MatchFiltersClinicalSpecialtyFragmentDoc = new TypedDocumentString(`
    fragment MatchFiltersClinicalSpecialty on ClinicalSpecialty {
  id
  displayName
  slug
}
    `, {"fragmentName":"MatchFiltersClinicalSpecialty"}) as unknown as TypedDocumentString<MatchFiltersClinicalSpecialtyFragment, unknown>;
export const MatchFiltersNursePreferencesFragmentDoc = new TypedDocumentString(`
    fragment MatchFiltersNursePreferences on NursePreferences {
  id
  broadPrefLocations
  contractLengths
  locations {
    id
    locationString
  }
  shiftLengths
  shiftPrefs
}
    `, {"fragmentName":"MatchFiltersNursePreferences"}) as unknown as TypedDocumentString<MatchFiltersNursePreferencesFragment, unknown>;
export const MatchFiltersNurseProfileFragmentDoc = new TypedDocumentString(`
    fragment MatchFiltersNurseProfile on NurseProfile {
  id
  activeClinicalSpecialties {
    ...MatchFiltersClinicalSpecialty
  }
  positionSpecialties {
    ...MatchFiltersClinicalSpecialty
  }
  role {
    id
    type
  }
  nursePreferences {
    ...MatchFiltersNursePreferences
  }
}
    fragment MatchFiltersClinicalSpecialty on ClinicalSpecialty {
  id
  displayName
  slug
}
fragment MatchFiltersNursePreferences on NursePreferences {
  id
  broadPrefLocations
  contractLengths
  locations {
    id
    locationString
  }
  shiftLengths
  shiftPrefs
}`, {"fragmentName":"MatchFiltersNurseProfile"}) as unknown as TypedDocumentString<MatchFiltersNurseProfileFragment, unknown>;
export const CuratedJobsPageUserFragmentDoc = new TypedDocumentString(`
    fragment CuratedJobsPageUser on User {
  ...MatchCardUser
  ...JobMatchTopCardBlockUser
  nurseProfile {
    ...MatchCriteriaNurseProfile
    ...MatchFiltersNurseProfile
  }
}
    fragment MatchCardUser on User {
  id
  email
  nurseProfile {
    id
    isActivated
    percentComplete
    state
    profileCompletion {
      id
      meta {
        id
        percentCompleted
      }
    }
    nurseAdvocate {
      id
      email
      fullName
    }
  }
}
fragment MatchCriteriaNurseProfile on NurseProfile {
  id
  isActivated
  activeClinicalSpecialties {
    id
    displayName
    slug
  }
  percentComplete
  positionSpecialties {
    id
    displayName
    slug
  }
  profileCompletion {
    id
    meta {
      id
      percentCompleted
    }
  }
  role {
    id
    key
    name
    type
  }
  state
  nursePreferences {
    id
    ...MatchCriteriaNursePreferences
  }
}
fragment MatchCriteriaNursePreferences on NursePreferences {
  id
  broadPrefLocations
  careSettingOther
  careSettingPrefs
  contractLengths
  earliestStartDate
  jobSortColumn
  jobSortOrder
  jobTypes
  locations {
    id
    locationString
  }
  shiftLengths
  shiftPrefs
  startPref
  technologies
}
fragment MatchApplyButtonUser on User {
  id
  ...RequestInterviewButtonUser
}
fragment MatchFavoriteButtonUser on User {
  id
  userProperties {
    id
    shouldDisplayFirstFavoriteMessage
  }
}
fragment JobMatchTopCardBlockUser on User {
  id
  referralCode
  ...MatchApplyButtonUser
  ...MatchFavoriteButtonUser
}
fragment MatchFiltersNurseProfile on NurseProfile {
  id
  activeClinicalSpecialties {
    ...MatchFiltersClinicalSpecialty
  }
  positionSpecialties {
    ...MatchFiltersClinicalSpecialty
  }
  role {
    id
    type
  }
  nursePreferences {
    ...MatchFiltersNursePreferences
  }
}
fragment MatchFiltersClinicalSpecialty on ClinicalSpecialty {
  id
  displayName
  slug
}
fragment MatchFiltersNursePreferences on NursePreferences {
  id
  broadPrefLocations
  contractLengths
  locations {
    id
    locationString
  }
  shiftLengths
  shiftPrefs
}
fragment RequestInterviewButtonUser on User {
  id
  nurseProfile {
    ...RequestInterviewButtonNurseProfile
  }
  ...JobApplicationRequirementsUser
}
fragment RequestInterviewButtonNurseProfile on NurseProfile {
  id
  isActivated
  canApplyJobs
  profileCompletion {
    id
    meta {
      id
      percentCompleted
    }
  }
  state
}
fragment JobApplicationRequirementsUser on User {
  id
  email
  firstName
  lastName
  nurseProfile {
    ...JobApplicationRequirementsNurseProfile
  }
}
fragment JobApplicationRequirementsNurseAdvocate on SalesforceUser {
  id
  email
  fullName
}
fragment JobApplicationRequirementsNurseProfile on NurseProfile {
  id
  state
  percentComplete
  profileCompletion {
    id
  }
  nurseAdvocate {
    ...JobApplicationRequirementsNurseAdvocate
  }
}`, {"fragmentName":"CuratedJobsPageUser"}) as unknown as TypedDocumentString<CuratedJobsPageUserFragment, unknown>;
export const JobAlertFragmentDoc = new TypedDocumentString(`
    fragment JobAlert on JobAlert {
  id
  broadPrefLocations
  clinicalSpecialties {
    id
    displayName
    slug
  }
  contractLengths
  locationStrings
  shiftLengths
  shiftPrefs
  smsEnabled
  specialties
}
    `, {"fragmentName":"JobAlert"}) as unknown as TypedDocumentString<JobAlertFragment, unknown>;
export const JobAlertsNurseProfileFragmentDoc = new TypedDocumentString(`
    fragment JobAlertsNurseProfile on NurseProfile {
  id
  jobAlerts {
    ...JobAlert
  }
}
    fragment JobAlert on JobAlert {
  id
  broadPrefLocations
  clinicalSpecialties {
    id
    displayName
    slug
  }
  contractLengths
  locationStrings
  shiftLengths
  shiftPrefs
  smsEnabled
  specialties
}`, {"fragmentName":"JobAlertsNurseProfile"}) as unknown as TypedDocumentString<JobAlertsNurseProfileFragment, unknown>;
export const NurseAdvocateWidgetSalesforceUserFragmentDoc = new TypedDocumentString(`
    fragment NurseAdvocateWidgetSalesforceUser on SalesforceUser {
  id
  phone
  firstName
  lastName
  profileImgUrl
  isNurseAdvocate
  isAlliedAdvocate
  clinicalRole
}
    `, {"fragmentName":"NurseAdvocateWidgetSalesforceUser"}) as unknown as TypedDocumentString<NurseAdvocateWidgetSalesforceUserFragment, unknown>;
export const JobApplicationDetailFragmentDoc = new TypedDocumentString(`
    fragment JobApplicationDetail on JobApplication {
  id
  state
  nurseProfile {
    id
    nurseAdvocate {
      ...NurseAdvocateWidgetSalesforceUser
    }
  }
  esMatch {
    id
    userState
  }
  preferredStartDate
  specialRequest
  interviewAvailability
  timeOffRequests {
    id
    fromDate
    toDate
  }
  job {
    ...MatchCardJob
  }
  candidateHoldReasons
}
    fragment MatchCardJob on Job {
  id
  activeApplicantsCount
  favoritedCount
  hoursPerShift
  instantOffer
  jobType
  lengthInWeeks
  licenseType
  localAllowed
  onHold
  shiftType
  shiftsPerWeek
  startAsap
  startDate
  endDate
  facilityName
  cancellationPolicy
  stateActiveAt
  title
  travelAllowed
  business {
    city
    state
    ...MatchCardFacility
  }
  clinicalUnit {
    id
    displayName
  }
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  location {
    id
    city
    stateCode
  }
  localPaymentDetails {
    id
    grossPayWeekly
  }
  emr {
    id
    name
  }
}
fragment MatchCardFacility on Facility {
  id
  name
  logo
}
fragment NurseAdvocateWidgetSalesforceUser on SalesforceUser {
  id
  phone
  firstName
  lastName
  profileImgUrl
  isNurseAdvocate
  isAlliedAdvocate
  clinicalRole
}`, {"fragmentName":"JobApplicationDetail"}) as unknown as TypedDocumentString<JobApplicationDetailFragment, unknown>;
export const JobAllowedFacilityFragmentDoc = new TypedDocumentString(`
    fragment JobAllowedFacility on Facility {
  id
  city
  name
  state
}
    `, {"fragmentName":"JobAllowedFacility"}) as unknown as TypedDocumentString<JobAllowedFacilityFragment, unknown>;
export const JobApplicationJobApplicationFragmentDoc = new TypedDocumentString(`
    fragment JobApplicationJobApplication on JobApplication {
  id
  state
  preferredStartDate
  hasSpecialRequest
  specialRequest
  hasTimeoffRequest
  timeOffRequests {
    id
    fromDate
    toDate
  }
  interviewAvailability
  hasAllowedFacilities
  allowedFacilitiesShifts
  allowedFacilities {
    facilityId
  }
}
    `, {"fragmentName":"JobApplicationJobApplication"}) as unknown as TypedDocumentString<JobApplicationJobApplicationFragment, unknown>;
export const JobUtilsPayRateJobFragmentDoc = new TypedDocumentString(`
    fragment JobUtilsPayRateJob on Job {
  id
  travelAllowed
  localAllowed
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  grossPayWeekly
  jobType
  localGrossPayWeekly
  localPaymentDetails {
    id
    grossPayWeekly
  }
}
    `, {"fragmentName":"JobUtilsPayRateJob"}) as unknown as TypedDocumentString<JobUtilsPayRateJobFragment, unknown>;
export const JobApplicationJobFragmentDoc = new TypedDocumentString(`
    fragment JobApplicationJob on Job {
  id
  allowedFacilities {
    ...JobAllowedFacility
  }
  business {
    id
    name
  }
  clinicalUnit {
    id
    displayName
  }
  hoursPerShift
  lengthInWeeks
  licenseType
  location {
    id
    city
    stateCode
  }
  jarMaximumTimeOff {
    id
    maximumTimeOff
  }
  jobApplication {
    ...JobApplicationJobApplication
  }
  onHold
  programName
  shiftType
  shiftsPerWeek
  startAsap
  startDate
  state
  ...JobUtilsPayRateJob
}
    fragment JobApplicationJobApplication on JobApplication {
  id
  state
  preferredStartDate
  hasSpecialRequest
  specialRequest
  hasTimeoffRequest
  timeOffRequests {
    id
    fromDate
    toDate
  }
  interviewAvailability
  hasAllowedFacilities
  allowedFacilitiesShifts
  allowedFacilities {
    facilityId
  }
}
fragment JobAllowedFacility on Facility {
  id
  city
  name
  state
}
fragment JobUtilsPayRateJob on Job {
  id
  travelAllowed
  localAllowed
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  grossPayWeekly
  jobType
  localGrossPayWeekly
  localPaymentDetails {
    id
    grossPayWeekly
  }
}`, {"fragmentName":"JobApplicationJob"}) as unknown as TypedDocumentString<JobApplicationJobFragment, unknown>;
export const RuleValidationFragmentDoc = new TypedDocumentString(`
    fragment RuleValidation on JobApplicationRequirementRuleEngineVerification {
  type
  valid
  errorMessages
}
    `, {"fragmentName":"RuleValidation"}) as unknown as TypedDocumentString<RuleValidationFragment, unknown>;
export const JobApplicationNurseProfileFragmentDoc = new TypedDocumentString(`
    fragment JobApplicationNurseProfile on NurseProfile {
  id
}
    `, {"fragmentName":"JobApplicationNurseProfile"}) as unknown as TypedDocumentString<JobApplicationNurseProfileFragment, unknown>;
export const JobApplicationCompletedPagesUserFragmentDoc = new TypedDocumentString(`
    fragment JobApplicationCompletedPagesUser on User {
  id
  nurseProfile {
    ...JobApplicationNurseProfile
  }
}
    fragment JobApplicationNurseProfile on NurseProfile {
  id
}`, {"fragmentName":"JobApplicationCompletedPagesUser"}) as unknown as TypedDocumentString<JobApplicationCompletedPagesUserFragment, unknown>;
export const JobApplicationCanApplyJobFragmentDoc = new TypedDocumentString(`
    fragment JobApplicationCanApplyJob on Job {
  id
  jobApplication {
    id
    state
  }
  onHold
  state
}
    `, {"fragmentName":"JobApplicationCanApplyJob"}) as unknown as TypedDocumentString<JobApplicationCanApplyJobFragment, unknown>;
export const JobApplicationStrengthenRuleValidationFragmentDoc = new TypedDocumentString(`
    fragment JobApplicationStrengthenRuleValidation on JobApplicationRequirementRuleEngineVerification {
  type
  valid
  errorMessages
}
    `, {"fragmentName":"JobApplicationStrengthenRuleValidation"}) as unknown as TypedDocumentString<JobApplicationStrengthenRuleValidationFragment, unknown>;
export const JobApplicationStrengthenJobFragmentDoc = new TypedDocumentString(`
    fragment JobApplicationStrengthenJob on Job {
  id
  ruleValidations {
    ...JobApplicationStrengthenRuleValidation
  }
}
    fragment JobApplicationStrengthenRuleValidation on JobApplicationRequirementRuleEngineVerification {
  type
  valid
  errorMessages
}`, {"fragmentName":"JobApplicationStrengthenJob"}) as unknown as TypedDocumentString<JobApplicationStrengthenJobFragment, unknown>;
export const JobApplicationStrengthenNurseHealthDocFragmentDoc = new TypedDocumentString(`
    fragment JobApplicationStrengthenNurseHealthDoc on NurseHealthDoc {
  id
  isCovidVax
  isFluVax
}
    `, {"fragmentName":"JobApplicationStrengthenNurseHealthDoc"}) as unknown as TypedDocumentString<JobApplicationStrengthenNurseHealthDocFragment, unknown>;
export const JobApplicationStrengthenNurseProfileFragmentDoc = new TypedDocumentString(`
    fragment JobApplicationStrengthenNurseProfile on NurseProfile {
  id
  hasPositionsLocationOverlap
  hasPositionsInvalidHoursOverlap
  idDocs {
    ...BackgroundAndIdPanelDocument
  }
  nurseHealthDocs {
    ...JobApplicationStrengthenNurseHealthDoc
  }
  sortedExperienceItems {
    ... on Gap {
      id
      reason
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment BackgroundAndIdPanelDocument on Document {
  id
  title
  docType
  docSubtype
  expiresOn
  expirationType
  files {
    ...FileMetadata
  }
  stateCode
}
fragment JobApplicationStrengthenNurseHealthDoc on NurseHealthDoc {
  id
  isCovidVax
  isFluVax
}`, {"fragmentName":"JobApplicationStrengthenNurseProfile"}) as unknown as TypedDocumentString<JobApplicationStrengthenNurseProfileFragment, unknown>;
export const JobDetailPageUserFragmentDoc = new TypedDocumentString(`
    fragment JobDetailPageUser on User {
  id
  email
  initialReferringDomain
  userProperties {
    shouldDisplayFirstFavoriteMessage
    shouldDisplayStaleProfileNotification
  }
}
    `, {"fragmentName":"JobDetailPageUser"}) as unknown as TypedDocumentString<JobDetailPageUserFragment, unknown>;
export const JobDetailPageVisibilityJobFragmentDoc = new TypedDocumentString(`
    fragment JobDetailPageVisibilityJob on Job {
  id
  state
  onHold
  jobType
}
    `, {"fragmentName":"JobDetailPageVisibilityJob"}) as unknown as TypedDocumentString<JobDetailPageVisibilityJobFragment, unknown>;
export const JobDetailPageJobTitleFragmentDoc = new TypedDocumentString(`
    fragment JobDetailPageJobTitle on Job {
  id
  jobType
  licenseType
  clinicalUnit {
    id
    displayName
    slug
  }
  location {
    id
    city
    stateCode
  }
}
    `, {"fragmentName":"JobDetailPageJobTitle"}) as unknown as TypedDocumentString<JobDetailPageJobTitleFragment, unknown>;
export const JobDetailPageStartDateFragmentDoc = new TypedDocumentString(`
    fragment JobDetailPageStartDate on Job {
  id
  startAsap
  startDate
  lengthInWeeks
}
    `, {"fragmentName":"JobDetailPageStartDate"}) as unknown as TypedDocumentString<JobDetailPageStartDateFragment, unknown>;
export const JobDetailPageDescriptionFragmentDoc = new TypedDocumentString(`
    fragment JobDetailPageDescription on Job {
  id
  jobType
  friendlyLicenseType
  location {
    id
    city
    stateCode
  }
  grossPayWeekly
  ...JobDetailPageStartDate
}
    fragment JobDetailPageStartDate on Job {
  id
  startAsap
  startDate
  lengthInWeeks
}`, {"fragmentName":"JobDetailPageDescription"}) as unknown as TypedDocumentString<JobDetailPageDescriptionFragment, unknown>;
export const JobDetailPageJobFragmentDoc = new TypedDocumentString(`
    fragment JobDetailPageJob on Job {
  ...JobDetailPageVisibilityJob
  ...JobDetailPageJobTitle
  ...JobDetailPageDescription
}
    fragment JobDetailPageVisibilityJob on Job {
  id
  state
  onHold
  jobType
}
fragment JobDetailPageJobTitle on Job {
  id
  jobType
  licenseType
  clinicalUnit {
    id
    displayName
    slug
  }
  location {
    id
    city
    stateCode
  }
}
fragment JobDetailPageStartDate on Job {
  id
  startAsap
  startDate
  lengthInWeeks
}
fragment JobDetailPageDescription on Job {
  id
  jobType
  friendlyLicenseType
  location {
    id
    city
    stateCode
  }
  grossPayWeekly
  ...JobDetailPageStartDate
}`, {"fragmentName":"JobDetailPageJob"}) as unknown as TypedDocumentString<JobDetailPageJobFragment, unknown>;
export const ContractDetailFragmentDoc = new TypedDocumentString(`
    fragment ContractDetail on Contract {
  id
  contractStatus
  contractStartDate
  contractEndDate
  facility {
    id
    name
    state
    city
  }
  jobOffer {
    id
    uuid
    job {
      id
      facilityName
      location {
        id
        city
        stateCode
      }
      title
    }
  }
}
    `, {"fragmentName":"ContractDetail"}) as unknown as TypedDocumentString<ContractDetailFragment, unknown>;
export const JobOfferDetailFragmentDoc = new TypedDocumentString(`
    fragment JobOfferDetail on JobOffer {
  id
  uuid
  status
  startDate
  endDate
  contractNotes
  clinicianAcceptedInapp
  nurseAdvocateEmail
  lengthInWeeks
  shiftType
  shiftsPerWeek
  hoursPerShift
  contracts {
    ...ContractDetail
  }
  timeOffs {
    id
    startDate
    endDate
    approvalStatus
  }
  job {
    ...MatchCardJob
  }
  jobApplication {
    id
    paymentDetails {
      id
      nonTaxableStipendWeekly
      taxableWageRateWeekly
      grossPayWeekly
    }
  }
  paymentDetails {
    id
    nonTaxableStipendWeekly
    taxableWageRateWeekly
    grossPayWeekly
    incidentalsStipendDaily
    lodgingStipendDaily
    regularWageRate
    overtimeMultiplier
    doubleTimeMultiplier
    overtimeWageRate
    regularHoursPerWeek
    overtimeHoursPerWeek
    blendedWageRate
    totalHoursPerWeek
    holidayRate
    chargeRate
    onCallRate
    callBackRate
    extraRate
  }
}
    fragment MatchCardJob on Job {
  id
  activeApplicantsCount
  favoritedCount
  hoursPerShift
  instantOffer
  jobType
  lengthInWeeks
  licenseType
  localAllowed
  onHold
  shiftType
  shiftsPerWeek
  startAsap
  startDate
  endDate
  facilityName
  cancellationPolicy
  stateActiveAt
  title
  travelAllowed
  business {
    city
    state
    ...MatchCardFacility
  }
  clinicalUnit {
    id
    displayName
  }
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  location {
    id
    city
    stateCode
  }
  localPaymentDetails {
    id
    grossPayWeekly
  }
  emr {
    id
    name
  }
}
fragment MatchCardFacility on Facility {
  id
  name
  logo
}
fragment ContractDetail on Contract {
  id
  contractStatus
  contractStartDate
  contractEndDate
  facility {
    id
    name
    state
    city
  }
  jobOffer {
    id
    uuid
    job {
      id
      facilityName
      location {
        id
        city
        stateCode
      }
      title
    }
  }
}`, {"fragmentName":"JobOfferDetail"}) as unknown as TypedDocumentString<JobOfferDetailFragment, unknown>;
export const MatchDetailsUserFragmentDoc = new TypedDocumentString(`
    fragment MatchDetailsUser on User {
  id
  ...JobMatchTopCardBlockUser
}
    fragment MatchApplyButtonUser on User {
  id
  ...RequestInterviewButtonUser
}
fragment MatchFavoriteButtonUser on User {
  id
  userProperties {
    id
    shouldDisplayFirstFavoriteMessage
  }
}
fragment JobMatchTopCardBlockUser on User {
  id
  referralCode
  ...MatchApplyButtonUser
  ...MatchFavoriteButtonUser
}
fragment RequestInterviewButtonUser on User {
  id
  nurseProfile {
    ...RequestInterviewButtonNurseProfile
  }
  ...JobApplicationRequirementsUser
}
fragment RequestInterviewButtonNurseProfile on NurseProfile {
  id
  isActivated
  canApplyJobs
  profileCompletion {
    id
    meta {
      id
      percentCompleted
    }
  }
  state
}
fragment JobApplicationRequirementsUser on User {
  id
  email
  firstName
  lastName
  nurseProfile {
    ...JobApplicationRequirementsNurseProfile
  }
}
fragment JobApplicationRequirementsNurseAdvocate on SalesforceUser {
  id
  email
  fullName
}
fragment JobApplicationRequirementsNurseProfile on NurseProfile {
  id
  state
  percentComplete
  profileCompletion {
    id
  }
  nurseAdvocate {
    ...JobApplicationRequirementsNurseAdvocate
  }
}`, {"fragmentName":"MatchDetailsUser"}) as unknown as TypedDocumentString<MatchDetailsUserFragment, unknown>;
export const UserViewedMatchEventUserFragmentDoc = new TypedDocumentString(`
    fragment UserViewedMatchEventUser on User {
  id
  email
  firstName
  lastName
  nurseProfile {
    id
    percentComplete
    nurseAdvocate {
      id
      email
      fullName
    }
  }
}
    `, {"fragmentName":"UserViewedMatchEventUser"}) as unknown as TypedDocumentString<UserViewedMatchEventUserFragment, unknown>;
export const MatchDetailPageUserFragmentDoc = new TypedDocumentString(`
    fragment MatchDetailPageUser on User {
  id
  ...MatchDetailsUser
  ...UserViewedMatchEventUser
}
    fragment MatchApplyButtonUser on User {
  id
  ...RequestInterviewButtonUser
}
fragment MatchFavoriteButtonUser on User {
  id
  userProperties {
    id
    shouldDisplayFirstFavoriteMessage
  }
}
fragment JobMatchTopCardBlockUser on User {
  id
  referralCode
  ...MatchApplyButtonUser
  ...MatchFavoriteButtonUser
}
fragment MatchDetailsUser on User {
  id
  ...JobMatchTopCardBlockUser
}
fragment RequestInterviewButtonUser on User {
  id
  nurseProfile {
    ...RequestInterviewButtonNurseProfile
  }
  ...JobApplicationRequirementsUser
}
fragment RequestInterviewButtonNurseProfile on NurseProfile {
  id
  isActivated
  canApplyJobs
  profileCompletion {
    id
    meta {
      id
      percentCompleted
    }
  }
  state
}
fragment JobApplicationRequirementsUser on User {
  id
  email
  firstName
  lastName
  nurseProfile {
    ...JobApplicationRequirementsNurseProfile
  }
}
fragment JobApplicationRequirementsNurseAdvocate on SalesforceUser {
  id
  email
  fullName
}
fragment JobApplicationRequirementsNurseProfile on NurseProfile {
  id
  state
  percentComplete
  profileCompletion {
    id
  }
  nurseAdvocate {
    ...JobApplicationRequirementsNurseAdvocate
  }
}
fragment UserViewedMatchEventUser on User {
  id
  email
  firstName
  lastName
  nurseProfile {
    id
    percentComplete
    nurseAdvocate {
      id
      email
      fullName
    }
  }
}`, {"fragmentName":"MatchDetailPageUser"}) as unknown as TypedDocumentString<MatchDetailPageUserFragment, unknown>;
export const JobGoogleMapLocationFragmentDoc = new TypedDocumentString(`
    fragment JobGoogleMapLocation on Location {
  id
  latitude
  longitude
}
    `, {"fragmentName":"JobGoogleMapLocation"}) as unknown as TypedDocumentString<JobGoogleMapLocationFragment, unknown>;
export const MatchDetailsJobPaymentDetailsFragmentDoc = new TypedDocumentString(`
    fragment MatchDetailsJobPaymentDetails on JobPaymentDetails {
  id
  blendedWageRate
  callBackRate
  doubleTimeMultiplier
  extraRate
  grossPayWeekly
  holidayRate
  incidentalsStipendDaily
  lodgingStipendDaily
  onCallRate
  overtimeHoursPerWeek
  overtimeMultiplier
  overtimeWageRate
  regularHoursPerWeek
  regularWageRate
  totalHoursPerWeek
}
    `, {"fragmentName":"MatchDetailsJobPaymentDetails"}) as unknown as TypedDocumentString<MatchDetailsJobPaymentDetailsFragment, unknown>;
export const UserViewedMatchEventJobFragmentDoc = new TypedDocumentString(`
    fragment UserViewedMatchEventJob on Job {
  id
  activeApplicantsCount
  business {
    id
    city
    name
    logo
    state
  }
  clinicalUnit {
    id
    displayName
  }
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  favoritedCount
  grossPayWeekly
  hoursPerShift
  instantOffer
  jobType
  lengthInWeeks
  shiftsPerWeek
  shiftType
  startDate
  stateActiveAt
  title
}
    `, {"fragmentName":"UserViewedMatchEventJob"}) as unknown as TypedDocumentString<UserViewedMatchEventJobFragment, unknown>;
export const RequestInterviewButtonJobFragmentDoc = new TypedDocumentString(`
    fragment RequestInterviewButtonJob on Job {
  id
  canApply {
    value
    reasons {
      fullMessages
    }
  }
  instantOffer
  jobApplication {
    id
    state
  }
  onHold
  ...UserViewedMatchEventJob
}
    fragment UserViewedMatchEventJob on Job {
  id
  activeApplicantsCount
  business {
    id
    city
    name
    logo
    state
  }
  clinicalUnit {
    id
    displayName
  }
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  favoritedCount
  grossPayWeekly
  hoursPerShift
  instantOffer
  jobType
  lengthInWeeks
  shiftsPerWeek
  shiftType
  startDate
  stateActiveAt
  title
}`, {"fragmentName":"RequestInterviewButtonJob"}) as unknown as TypedDocumentString<RequestInterviewButtonJobFragment, unknown>;
export const MatchApplyButtonJobFragmentDoc = new TypedDocumentString(`
    fragment MatchApplyButtonJob on Job {
  id
  canApply {
    value
    reasons {
      fullMessages
    }
  }
  esMatch {
    id
  }
  ...RequestInterviewButtonJob
}
    fragment RequestInterviewButtonJob on Job {
  id
  canApply {
    value
    reasons {
      fullMessages
    }
  }
  instantOffer
  jobApplication {
    id
    state
  }
  onHold
  ...UserViewedMatchEventJob
}
fragment UserViewedMatchEventJob on Job {
  id
  activeApplicantsCount
  business {
    id
    city
    name
    logo
    state
  }
  clinicalUnit {
    id
    displayName
  }
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  favoritedCount
  grossPayWeekly
  hoursPerShift
  instantOffer
  jobType
  lengthInWeeks
  shiftsPerWeek
  shiftType
  startDate
  stateActiveAt
  title
}`, {"fragmentName":"MatchApplyButtonJob"}) as unknown as TypedDocumentString<MatchApplyButtonJobFragment, unknown>;
export const MatchFavoriteButtonJobFragmentDoc = new TypedDocumentString(`
    fragment MatchFavoriteButtonJob on Job {
  id
  canFavorite {
    value
    reasons {
      fullMessages
    }
  }
  esMatch {
    id
    userState
  }
}
    `, {"fragmentName":"MatchFavoriteButtonJob"}) as unknown as TypedDocumentString<MatchFavoriteButtonJobFragment, unknown>;
export const MatchWithdrawButtonJobFragmentDoc = new TypedDocumentString(`
    fragment MatchWithdrawButtonJob on Job {
  id
  canWithdraw {
    value
    reasons {
      fullMessages
    }
  }
}
    `, {"fragmentName":"MatchWithdrawButtonJob"}) as unknown as TypedDocumentString<MatchWithdrawButtonJobFragment, unknown>;
export const JobMatchTopCardBlockJobFragmentDoc = new TypedDocumentString(`
    fragment JobMatchTopCardBlockJob on Job {
  id
  instantOffer
  business {
    id
    hideMatchInfo
    name
    city
    state
  }
  hoursPerShift
  jobType
  lengthInWeeks
  location {
    id
    city
    stateCode
  }
  positionCount
  shiftsPerWeek
  shiftType
  startAsap
  startDate
  title
  jobApplication {
    id
    state
  }
  ...JobUtilsPayRateJob
  ...MatchApplyButtonJob
  ...MatchFavoriteButtonJob
  ...MatchWithdrawButtonJob
}
    fragment MatchApplyButtonJob on Job {
  id
  canApply {
    value
    reasons {
      fullMessages
    }
  }
  esMatch {
    id
  }
  ...RequestInterviewButtonJob
}
fragment MatchFavoriteButtonJob on Job {
  id
  canFavorite {
    value
    reasons {
      fullMessages
    }
  }
  esMatch {
    id
    userState
  }
}
fragment MatchWithdrawButtonJob on Job {
  id
  canWithdraw {
    value
    reasons {
      fullMessages
    }
  }
}
fragment RequestInterviewButtonJob on Job {
  id
  canApply {
    value
    reasons {
      fullMessages
    }
  }
  instantOffer
  jobApplication {
    id
    state
  }
  onHold
  ...UserViewedMatchEventJob
}
fragment JobUtilsPayRateJob on Job {
  id
  travelAllowed
  localAllowed
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  grossPayWeekly
  jobType
  localGrossPayWeekly
  localPaymentDetails {
    id
    grossPayWeekly
  }
}
fragment UserViewedMatchEventJob on Job {
  id
  activeApplicantsCount
  business {
    id
    city
    name
    logo
    state
  }
  clinicalUnit {
    id
    displayName
  }
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  favoritedCount
  grossPayWeekly
  hoursPerShift
  instantOffer
  jobType
  lengthInWeeks
  shiftsPerWeek
  shiftType
  startDate
  stateActiveAt
  title
}`, {"fragmentName":"JobMatchTopCardBlockJob"}) as unknown as TypedDocumentString<JobMatchTopCardBlockJobFragment, unknown>;
export const JobMatchFacilityBlockJobFragmentDoc = new TypedDocumentString(`
    fragment JobMatchFacilityBlockJob on Job {
  business {
    id
    name
    address
    city
    logo
    state
    zipcode
    slug
    rankings {
      id
      usnewsType
    }
    hospital {
      id
      teaching
      traumaCenterLevel
      affiliatedUnion
      totalLicensedBeds
      hospitalSystem
      hospitalType
      jointCommission
      magnet
    }
  }
}
    `, {"fragmentName":"JobMatchFacilityBlockJob"}) as unknown as TypedDocumentString<JobMatchFacilityBlockJobFragment, unknown>;
export const JarMaximumTimeOffRuleFragmentDoc = new TypedDocumentString(`
    fragment JarMaximumTimeOffRule on JobApplicationRequirementsMaximumTimeOffRule {
  id
  type
  maximumTimeOff
  description
}
    `, {"fragmentName":"JarMaximumTimeOffRule"}) as unknown as TypedDocumentString<JarMaximumTimeOffRuleFragment, unknown>;
export const JarLocationFloatingFragmentDoc = new TypedDocumentString(`
    fragment JarLocationFloating on JobApplicationRequirementsLocationFloating {
  id
  type
  description
}
    `, {"fragmentName":"JarLocationFloating"}) as unknown as TypedDocumentString<JarLocationFloatingFragment, unknown>;
export const JarUnitFloatingFragmentDoc = new TypedDocumentString(`
    fragment JarUnitFloating on JobApplicationRequirementsUnitFloating {
  id
  type
  description
}
    `, {"fragmentName":"JarUnitFloating"}) as unknown as TypedDocumentString<JarUnitFloatingFragment, unknown>;
export const JarCovidVaccineFragmentDoc = new TypedDocumentString(`
    fragment JarCovidVaccine on JobApplicationRequirementsCovidVaccine {
  id
  type
  stage
  description
}
    `, {"fragmentName":"JarCovidVaccine"}) as unknown as TypedDocumentString<JarCovidVaccineFragment, unknown>;
export const JarCovidBoosterFragmentDoc = new TypedDocumentString(`
    fragment JarCovidBooster on JobApplicationRequirementsCovidBooster {
  id
  type
  stage
  description
}
    `, {"fragmentName":"JarCovidBooster"}) as unknown as TypedDocumentString<JarCovidBoosterFragment, unknown>;
export const JarFluVaccineFragmentDoc = new TypedDocumentString(`
    fragment JarFluVaccine on JobApplicationRequirementsFluVaccine {
  id
  type
  stage
  description
}
    `, {"fragmentName":"JarFluVaccine"}) as unknown as TypedDocumentString<JarFluVaccineFragment, unknown>;
export const JarFluVaccinationFragmentDoc = new TypedDocumentString(`
    fragment JarFluVaccination on JobApplicationRequirementsFluVaccination {
  id
  type
  stage
  description
}
    `, {"fragmentName":"JarFluVaccination"}) as unknown as TypedDocumentString<JarFluVaccinationFragment, unknown>;
export const JarRoleExperienceFragmentDoc = new TypedDocumentString(`
    fragment JarRoleExperience on JobApplicationRequirementsRoleExperience {
  id
  type
  months
  description
}
    `, {"fragmentName":"JarRoleExperience"}) as unknown as TypedDocumentString<JarRoleExperienceFragment, unknown>;
export const JarUnitExperienceFragmentDoc = new TypedDocumentString(`
    fragment JarUnitExperience on JobApplicationRequirementsUnitExperience {
  id
  type
  months
  description
}
    `, {"fragmentName":"JarUnitExperience"}) as unknown as TypedDocumentString<JarUnitExperienceFragment, unknown>;
export const JarTechnologyExperienceFragmentDoc = new TypedDocumentString(`
    fragment JarTechnologyExperience on JobApplicationRequirementsTechnologyExperience {
  id
  type
  months
  description
  technology {
    id
    uuid
    name
  }
}
    `, {"fragmentName":"JarTechnologyExperience"}) as unknown as TypedDocumentString<JarTechnologyExperienceFragment, unknown>;
export const JarTravelExperienceFragmentDoc = new TypedDocumentString(`
    fragment JarTravelExperience on JobApplicationRequirementsTravelExperience {
  id
  type
  months
  description
}
    `, {"fragmentName":"JarTravelExperience"}) as unknown as TypedDocumentString<JarTravelExperienceFragment, unknown>;
export const JarStateLicenseFragmentDoc = new TypedDocumentString(`
    fragment JarStateLicense on JobApplicationRequirementsStateLicense {
  id
  stage
  type
  description
}
    `, {"fragmentName":"JarStateLicense"}) as unknown as TypedDocumentString<JarStateLicenseFragment, unknown>;
export const JarDriverLicenseFragmentDoc = new TypedDocumentString(`
    fragment JarDriverLicense on JobApplicationRequirementsDriverLicense {
  id
  required
  type
  stage
}
    `, {"fragmentName":"JarDriverLicense"}) as unknown as TypedDocumentString<JarDriverLicenseFragment, unknown>;
export const JarNurseReferenceFragmentDoc = new TypedDocumentString(`
    fragment JarNurseReference on JobApplicationRequirementsNurseReference {
  id
  description
  occurrences
  timeframe
  type
}
    `, {"fragmentName":"JarNurseReference"}) as unknown as TypedDocumentString<JarNurseReferenceFragment, unknown>;
export const JarCertificationFragmentDoc = new TypedDocumentString(`
    fragment JarCertification on JobApplicationRequirementsCertification {
  id
  type
  title
  description
  certification {
    id
    credential
    name
    uuid
    issuingBodies
  }
}
    `, {"fragmentName":"JarCertification"}) as unknown as TypedDocumentString<JarCertificationFragment, unknown>;
export const JarProofOfIdentificationFragmentDoc = new TypedDocumentString(`
    fragment JarProofOfIdentification on JobApplicationRequirementsProofOfIdentification {
  id
  type
  description
  required
  stage
}
    `, {"fragmentName":"JarProofOfIdentification"}) as unknown as TypedDocumentString<JarProofOfIdentificationFragment, unknown>;
export const JarTraumaLevelExperienceFragmentDoc = new TypedDocumentString(`
    fragment JarTraumaLevelExperience on JobApplicationRequirementsTraumaLevelExperience {
  id
  type
  description
  enforcementType
}
    `, {"fragmentName":"JarTraumaLevelExperience"}) as unknown as TypedDocumentString<JarTraumaLevelExperienceFragment, unknown>;
export const JarEducationFragmentDoc = new TypedDocumentString(`
    fragment JarEducation on JobApplicationRequirementsEducation {
  id
  type
  description
  enforcementType
}
    `, {"fragmentName":"JarEducation"}) as unknown as TypedDocumentString<JarEducationFragment, unknown>;
export const MatchDetailsPreferredJarsFragmentDoc = new TypedDocumentString(`
    fragment MatchDetailsPreferredJars on Job {
  preferredJarsV2 {
    __typename
    ... on JobApplicationRequirementsMaximumTimeOffRule {
      ...JarMaximumTimeOffRule
    }
    ... on JobApplicationRequirementsRadiusRule {
      ...JarRadiusRule
    }
    ... on JobApplicationRequirementsLocationFloating {
      ...JarLocationFloating
    }
    ... on JobApplicationRequirementsUnitFloating {
      ...JarUnitFloating
    }
    ... on JobApplicationRequirementsCovidVaccine {
      ...JarCovidVaccine
    }
    ... on JobApplicationRequirementsCovidBooster {
      ...JarCovidBooster
    }
    ... on JobApplicationRequirementsFluVaccine {
      ...JarFluVaccine
    }
    ... on JobApplicationRequirementsFluVaccination {
      ...JarFluVaccination
    }
    ... on JobApplicationRequirementsRoleExperience {
      ...JarRoleExperience
    }
    ... on JobApplicationRequirementsUnitExperience {
      ...JarUnitExperience
    }
    ... on JobApplicationRequirementsTechnologyExperience {
      ...JarTechnologyExperience
    }
    ... on JobApplicationRequirementsTravelExperience {
      ...JarTravelExperience
    }
    ... on JobApplicationRequirementsStateLicense {
      ...JarStateLicense
    }
    ... on JobApplicationRequirementsDriverLicense {
      ...JarDriverLicense
    }
    ... on JobApplicationRequirementsNurseReference {
      ...JarNurseReference
    }
    ... on JobApplicationRequirementsCertification {
      ...JarCertification
    }
    ... on JobApplicationRequirementsProofOfIdentification {
      ...JarProofOfIdentification
    }
    ... on JobApplicationRequirementsTraumaLevelExperience {
      ...JarTraumaLevelExperience
    }
    ... on JobApplicationRequirementsEducation {
      ...JarEducation
    }
  }
}
    fragment JarRadiusRule on JobApplicationRequirementsRadiusRule {
  id
  type
  description
}
fragment JarCertification on JobApplicationRequirementsCertification {
  id
  type
  title
  description
  certification {
    id
    credential
    name
    uuid
    issuingBodies
  }
}
fragment JarNurseReference on JobApplicationRequirementsNurseReference {
  id
  description
  occurrences
  timeframe
  type
}
fragment JarDriverLicense on JobApplicationRequirementsDriverLicense {
  id
  required
  type
  stage
}
fragment JarCovidVaccine on JobApplicationRequirementsCovidVaccine {
  id
  type
  stage
  description
}
fragment JarCovidBooster on JobApplicationRequirementsCovidBooster {
  id
  type
  stage
  description
}
fragment JarFluVaccine on JobApplicationRequirementsFluVaccine {
  id
  type
  stage
  description
}
fragment JarFluVaccination on JobApplicationRequirementsFluVaccination {
  id
  type
  stage
  description
}
fragment JarLocationFloating on JobApplicationRequirementsLocationFloating {
  id
  type
  description
}
fragment JarMaximumTimeOffRule on JobApplicationRequirementsMaximumTimeOffRule {
  id
  type
  maximumTimeOff
  description
}
fragment JarUnitFloating on JobApplicationRequirementsUnitFloating {
  id
  type
  description
}
fragment JarStateLicense on JobApplicationRequirementsStateLicense {
  id
  stage
  type
  description
}
fragment JarTravelExperience on JobApplicationRequirementsTravelExperience {
  id
  type
  months
  description
}
fragment JarRoleExperience on JobApplicationRequirementsRoleExperience {
  id
  type
  months
  description
}
fragment JarUnitExperience on JobApplicationRequirementsUnitExperience {
  id
  type
  months
  description
}
fragment JarTechnologyExperience on JobApplicationRequirementsTechnologyExperience {
  id
  type
  months
  description
  technology {
    id
    uuid
    name
  }
}
fragment JarProofOfIdentification on JobApplicationRequirementsProofOfIdentification {
  id
  type
  description
  required
  stage
}
fragment JarTraumaLevelExperience on JobApplicationRequirementsTraumaLevelExperience {
  id
  type
  description
  enforcementType
}
fragment JarEducation on JobApplicationRequirementsEducation {
  id
  type
  description
  enforcementType
}`, {"fragmentName":"MatchDetailsPreferredJars"}) as unknown as TypedDocumentString<MatchDetailsPreferredJarsFragment, unknown>;
export const MatchDetailsRequiredJarsFragmentDoc = new TypedDocumentString(`
    fragment MatchDetailsRequiredJars on Job {
  requiredJarsV2 {
    __typename
    ... on JobApplicationRequirementsRadiusRule {
      ...JarRadiusRule
    }
    ... on JobApplicationRequirementsMaximumTimeOffRule {
      ...JarMaximumTimeOffRule
    }
    ... on JobApplicationRequirementsLocationFloating {
      ...JarLocationFloating
    }
    ... on JobApplicationRequirementsUnitFloating {
      ...JarUnitFloating
    }
    ... on JobApplicationRequirementsCovidVaccine {
      ...JarCovidVaccine
    }
    ... on JobApplicationRequirementsCovidBooster {
      ...JarCovidBooster
    }
    ... on JobApplicationRequirementsFluVaccine {
      ...JarFluVaccine
    }
    ... on JobApplicationRequirementsFluVaccination {
      ...JarFluVaccination
    }
    ... on JobApplicationRequirementsRoleExperience {
      ...JarRoleExperience
    }
    ... on JobApplicationRequirementsUnitExperience {
      ...JarUnitExperience
    }
    ... on JobApplicationRequirementsTechnologyExperience {
      ...JarTechnologyExperience
    }
    ... on JobApplicationRequirementsTravelExperience {
      ...JarTravelExperience
    }
    ... on JobApplicationRequirementsStateLicense {
      ...JarStateLicense
    }
    ... on JobApplicationRequirementsDriverLicense {
      ...JarDriverLicense
    }
    ... on JobApplicationRequirementsNurseReference {
      ...JarNurseReference
    }
    ... on JobApplicationRequirementsCertification {
      ...JarCertification
    }
    ... on JobApplicationRequirementsProofOfIdentification {
      ...JarProofOfIdentification
    }
    ... on JobApplicationRequirementsTraumaLevelExperience {
      ...JarTraumaLevelExperience
    }
    ... on JobApplicationRequirementsEducation {
      ...JarEducation
    }
  }
}
    fragment JarRadiusRule on JobApplicationRequirementsRadiusRule {
  id
  type
  description
}
fragment JarCertification on JobApplicationRequirementsCertification {
  id
  type
  title
  description
  certification {
    id
    credential
    name
    uuid
    issuingBodies
  }
}
fragment JarNurseReference on JobApplicationRequirementsNurseReference {
  id
  description
  occurrences
  timeframe
  type
}
fragment JarDriverLicense on JobApplicationRequirementsDriverLicense {
  id
  required
  type
  stage
}
fragment JarCovidVaccine on JobApplicationRequirementsCovidVaccine {
  id
  type
  stage
  description
}
fragment JarCovidBooster on JobApplicationRequirementsCovidBooster {
  id
  type
  stage
  description
}
fragment JarFluVaccine on JobApplicationRequirementsFluVaccine {
  id
  type
  stage
  description
}
fragment JarFluVaccination on JobApplicationRequirementsFluVaccination {
  id
  type
  stage
  description
}
fragment JarLocationFloating on JobApplicationRequirementsLocationFloating {
  id
  type
  description
}
fragment JarMaximumTimeOffRule on JobApplicationRequirementsMaximumTimeOffRule {
  id
  type
  maximumTimeOff
  description
}
fragment JarUnitFloating on JobApplicationRequirementsUnitFloating {
  id
  type
  description
}
fragment JarStateLicense on JobApplicationRequirementsStateLicense {
  id
  stage
  type
  description
}
fragment JarTravelExperience on JobApplicationRequirementsTravelExperience {
  id
  type
  months
  description
}
fragment JarRoleExperience on JobApplicationRequirementsRoleExperience {
  id
  type
  months
  description
}
fragment JarUnitExperience on JobApplicationRequirementsUnitExperience {
  id
  type
  months
  description
}
fragment JarTechnologyExperience on JobApplicationRequirementsTechnologyExperience {
  id
  type
  months
  description
  technology {
    id
    uuid
    name
  }
}
fragment JarProofOfIdentification on JobApplicationRequirementsProofOfIdentification {
  id
  type
  description
  required
  stage
}
fragment JarTraumaLevelExperience on JobApplicationRequirementsTraumaLevelExperience {
  id
  type
  description
  enforcementType
}
fragment JarEducation on JobApplicationRequirementsEducation {
  id
  type
  description
  enforcementType
}`, {"fragmentName":"MatchDetailsRequiredJars"}) as unknown as TypedDocumentString<MatchDetailsRequiredJarsFragment, unknown>;
export const MatchDetailsJobFragmentDoc = new TypedDocumentString(`
    fragment MatchDetailsJob on Job {
  id
  state
  business {
    id
    bgImageFlickrUrl
    hideMatchInfo
    state
    location {
      id
      city
      stateCode
    }
  }
  cityLocation {
    ...JobGoogleMapLocation
  }
  clinicalUnit {
    id
    displayName
  }
  endDate
  friendlyLicenseType
  hoursPerShift
  jobType
  jobApplication {
    id
    candidateHoldReasons
    state
  }
  defaultPaymentDetails {
    ...MatchDetailsJobPaymentDetails
  }
  localPaymentDetails {
    ...MatchDetailsJobPaymentDetails
  }
  location {
    id
    city
    stateCode
    ...JobGoogleMapLocation
  }
  lengthInWeeks
  licenseType
  nursePatientRatio
  publicDescription
  roles {
    id
    type
  }
  shiftEnd
  shiftType
  shiftsPerWeek
  shiftStart
  startAsap
  startDate
  ...JobMatchTopCardBlockJob
  ...JobMatchFacilityBlockJob
  ...MatchDetailsPreferredJars
  ...MatchDetailsRequiredJars
  ...UserViewedMatchEventJob
}
    fragment JobGoogleMapLocation on Location {
  id
  latitude
  longitude
}
fragment JobMatchFacilityBlockJob on Job {
  business {
    id
    name
    address
    city
    logo
    state
    zipcode
    slug
    rankings {
      id
      usnewsType
    }
    hospital {
      id
      teaching
      traumaCenterLevel
      affiliatedUnion
      totalLicensedBeds
      hospitalSystem
      hospitalType
      jointCommission
      magnet
    }
  }
}
fragment MatchApplyButtonJob on Job {
  id
  canApply {
    value
    reasons {
      fullMessages
    }
  }
  esMatch {
    id
  }
  ...RequestInterviewButtonJob
}
fragment MatchFavoriteButtonJob on Job {
  id
  canFavorite {
    value
    reasons {
      fullMessages
    }
  }
  esMatch {
    id
    userState
  }
}
fragment MatchWithdrawButtonJob on Job {
  id
  canWithdraw {
    value
    reasons {
      fullMessages
    }
  }
}
fragment JobMatchTopCardBlockJob on Job {
  id
  instantOffer
  business {
    id
    hideMatchInfo
    name
    city
    state
  }
  hoursPerShift
  jobType
  lengthInWeeks
  location {
    id
    city
    stateCode
  }
  positionCount
  shiftsPerWeek
  shiftType
  startAsap
  startDate
  title
  jobApplication {
    id
    state
  }
  ...JobUtilsPayRateJob
  ...MatchApplyButtonJob
  ...MatchFavoriteButtonJob
  ...MatchWithdrawButtonJob
}
fragment MatchDetailsPreferredJars on Job {
  preferredJarsV2 {
    __typename
    ... on JobApplicationRequirementsMaximumTimeOffRule {
      ...JarMaximumTimeOffRule
    }
    ... on JobApplicationRequirementsRadiusRule {
      ...JarRadiusRule
    }
    ... on JobApplicationRequirementsLocationFloating {
      ...JarLocationFloating
    }
    ... on JobApplicationRequirementsUnitFloating {
      ...JarUnitFloating
    }
    ... on JobApplicationRequirementsCovidVaccine {
      ...JarCovidVaccine
    }
    ... on JobApplicationRequirementsCovidBooster {
      ...JarCovidBooster
    }
    ... on JobApplicationRequirementsFluVaccine {
      ...JarFluVaccine
    }
    ... on JobApplicationRequirementsFluVaccination {
      ...JarFluVaccination
    }
    ... on JobApplicationRequirementsRoleExperience {
      ...JarRoleExperience
    }
    ... on JobApplicationRequirementsUnitExperience {
      ...JarUnitExperience
    }
    ... on JobApplicationRequirementsTechnologyExperience {
      ...JarTechnologyExperience
    }
    ... on JobApplicationRequirementsTravelExperience {
      ...JarTravelExperience
    }
    ... on JobApplicationRequirementsStateLicense {
      ...JarStateLicense
    }
    ... on JobApplicationRequirementsDriverLicense {
      ...JarDriverLicense
    }
    ... on JobApplicationRequirementsNurseReference {
      ...JarNurseReference
    }
    ... on JobApplicationRequirementsCertification {
      ...JarCertification
    }
    ... on JobApplicationRequirementsProofOfIdentification {
      ...JarProofOfIdentification
    }
    ... on JobApplicationRequirementsTraumaLevelExperience {
      ...JarTraumaLevelExperience
    }
    ... on JobApplicationRequirementsEducation {
      ...JarEducation
    }
  }
}
fragment MatchDetailsRequiredJars on Job {
  requiredJarsV2 {
    __typename
    ... on JobApplicationRequirementsRadiusRule {
      ...JarRadiusRule
    }
    ... on JobApplicationRequirementsMaximumTimeOffRule {
      ...JarMaximumTimeOffRule
    }
    ... on JobApplicationRequirementsLocationFloating {
      ...JarLocationFloating
    }
    ... on JobApplicationRequirementsUnitFloating {
      ...JarUnitFloating
    }
    ... on JobApplicationRequirementsCovidVaccine {
      ...JarCovidVaccine
    }
    ... on JobApplicationRequirementsCovidBooster {
      ...JarCovidBooster
    }
    ... on JobApplicationRequirementsFluVaccine {
      ...JarFluVaccine
    }
    ... on JobApplicationRequirementsFluVaccination {
      ...JarFluVaccination
    }
    ... on JobApplicationRequirementsRoleExperience {
      ...JarRoleExperience
    }
    ... on JobApplicationRequirementsUnitExperience {
      ...JarUnitExperience
    }
    ... on JobApplicationRequirementsTechnologyExperience {
      ...JarTechnologyExperience
    }
    ... on JobApplicationRequirementsTravelExperience {
      ...JarTravelExperience
    }
    ... on JobApplicationRequirementsStateLicense {
      ...JarStateLicense
    }
    ... on JobApplicationRequirementsDriverLicense {
      ...JarDriverLicense
    }
    ... on JobApplicationRequirementsNurseReference {
      ...JarNurseReference
    }
    ... on JobApplicationRequirementsCertification {
      ...JarCertification
    }
    ... on JobApplicationRequirementsProofOfIdentification {
      ...JarProofOfIdentification
    }
    ... on JobApplicationRequirementsTraumaLevelExperience {
      ...JarTraumaLevelExperience
    }
    ... on JobApplicationRequirementsEducation {
      ...JarEducation
    }
  }
}
fragment MatchDetailsJobPaymentDetails on JobPaymentDetails {
  id
  blendedWageRate
  callBackRate
  doubleTimeMultiplier
  extraRate
  grossPayWeekly
  holidayRate
  incidentalsStipendDaily
  lodgingStipendDaily
  onCallRate
  overtimeHoursPerWeek
  overtimeMultiplier
  overtimeWageRate
  regularHoursPerWeek
  regularWageRate
  totalHoursPerWeek
}
fragment RequestInterviewButtonJob on Job {
  id
  canApply {
    value
    reasons {
      fullMessages
    }
  }
  instantOffer
  jobApplication {
    id
    state
  }
  onHold
  ...UserViewedMatchEventJob
}
fragment JarRadiusRule on JobApplicationRequirementsRadiusRule {
  id
  type
  description
}
fragment JarCertification on JobApplicationRequirementsCertification {
  id
  type
  title
  description
  certification {
    id
    credential
    name
    uuid
    issuingBodies
  }
}
fragment JarNurseReference on JobApplicationRequirementsNurseReference {
  id
  description
  occurrences
  timeframe
  type
}
fragment JarDriverLicense on JobApplicationRequirementsDriverLicense {
  id
  required
  type
  stage
}
fragment JarCovidVaccine on JobApplicationRequirementsCovidVaccine {
  id
  type
  stage
  description
}
fragment JarCovidBooster on JobApplicationRequirementsCovidBooster {
  id
  type
  stage
  description
}
fragment JarFluVaccine on JobApplicationRequirementsFluVaccine {
  id
  type
  stage
  description
}
fragment JarFluVaccination on JobApplicationRequirementsFluVaccination {
  id
  type
  stage
  description
}
fragment JarLocationFloating on JobApplicationRequirementsLocationFloating {
  id
  type
  description
}
fragment JarMaximumTimeOffRule on JobApplicationRequirementsMaximumTimeOffRule {
  id
  type
  maximumTimeOff
  description
}
fragment JarUnitFloating on JobApplicationRequirementsUnitFloating {
  id
  type
  description
}
fragment JarStateLicense on JobApplicationRequirementsStateLicense {
  id
  stage
  type
  description
}
fragment JarTravelExperience on JobApplicationRequirementsTravelExperience {
  id
  type
  months
  description
}
fragment JarRoleExperience on JobApplicationRequirementsRoleExperience {
  id
  type
  months
  description
}
fragment JarUnitExperience on JobApplicationRequirementsUnitExperience {
  id
  type
  months
  description
}
fragment JarTechnologyExperience on JobApplicationRequirementsTechnologyExperience {
  id
  type
  months
  description
  technology {
    id
    uuid
    name
  }
}
fragment JarProofOfIdentification on JobApplicationRequirementsProofOfIdentification {
  id
  type
  description
  required
  stage
}
fragment JarTraumaLevelExperience on JobApplicationRequirementsTraumaLevelExperience {
  id
  type
  description
  enforcementType
}
fragment JarEducation on JobApplicationRequirementsEducation {
  id
  type
  description
  enforcementType
}
fragment JobUtilsPayRateJob on Job {
  id
  travelAllowed
  localAllowed
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  grossPayWeekly
  jobType
  localGrossPayWeekly
  localPaymentDetails {
    id
    grossPayWeekly
  }
}
fragment UserViewedMatchEventJob on Job {
  id
  activeApplicantsCount
  business {
    id
    city
    name
    logo
    state
  }
  clinicalUnit {
    id
    displayName
  }
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  favoritedCount
  grossPayWeekly
  hoursPerShift
  instantOffer
  jobType
  lengthInWeeks
  shiftsPerWeek
  shiftType
  startDate
  stateActiveAt
  title
}`, {"fragmentName":"MatchDetailsJob"}) as unknown as TypedDocumentString<MatchDetailsJobFragment, unknown>;
export const MatchDetailPageJobFragmentDoc = new TypedDocumentString(`
    fragment MatchDetailPageJob on Job {
  id
  ...MatchDetailsJob
  ...UserViewedMatchEventJob
}
    fragment JobGoogleMapLocation on Location {
  id
  latitude
  longitude
}
fragment JobMatchFacilityBlockJob on Job {
  business {
    id
    name
    address
    city
    logo
    state
    zipcode
    slug
    rankings {
      id
      usnewsType
    }
    hospital {
      id
      teaching
      traumaCenterLevel
      affiliatedUnion
      totalLicensedBeds
      hospitalSystem
      hospitalType
      jointCommission
      magnet
    }
  }
}
fragment MatchApplyButtonJob on Job {
  id
  canApply {
    value
    reasons {
      fullMessages
    }
  }
  esMatch {
    id
  }
  ...RequestInterviewButtonJob
}
fragment MatchFavoriteButtonJob on Job {
  id
  canFavorite {
    value
    reasons {
      fullMessages
    }
  }
  esMatch {
    id
    userState
  }
}
fragment MatchWithdrawButtonJob on Job {
  id
  canWithdraw {
    value
    reasons {
      fullMessages
    }
  }
}
fragment JobMatchTopCardBlockJob on Job {
  id
  instantOffer
  business {
    id
    hideMatchInfo
    name
    city
    state
  }
  hoursPerShift
  jobType
  lengthInWeeks
  location {
    id
    city
    stateCode
  }
  positionCount
  shiftsPerWeek
  shiftType
  startAsap
  startDate
  title
  jobApplication {
    id
    state
  }
  ...JobUtilsPayRateJob
  ...MatchApplyButtonJob
  ...MatchFavoriteButtonJob
  ...MatchWithdrawButtonJob
}
fragment MatchDetailsJob on Job {
  id
  state
  business {
    id
    bgImageFlickrUrl
    hideMatchInfo
    state
    location {
      id
      city
      stateCode
    }
  }
  cityLocation {
    ...JobGoogleMapLocation
  }
  clinicalUnit {
    id
    displayName
  }
  endDate
  friendlyLicenseType
  hoursPerShift
  jobType
  jobApplication {
    id
    candidateHoldReasons
    state
  }
  defaultPaymentDetails {
    ...MatchDetailsJobPaymentDetails
  }
  localPaymentDetails {
    ...MatchDetailsJobPaymentDetails
  }
  location {
    id
    city
    stateCode
    ...JobGoogleMapLocation
  }
  lengthInWeeks
  licenseType
  nursePatientRatio
  publicDescription
  roles {
    id
    type
  }
  shiftEnd
  shiftType
  shiftsPerWeek
  shiftStart
  startAsap
  startDate
  ...JobMatchTopCardBlockJob
  ...JobMatchFacilityBlockJob
  ...MatchDetailsPreferredJars
  ...MatchDetailsRequiredJars
  ...UserViewedMatchEventJob
}
fragment MatchDetailsPreferredJars on Job {
  preferredJarsV2 {
    __typename
    ... on JobApplicationRequirementsMaximumTimeOffRule {
      ...JarMaximumTimeOffRule
    }
    ... on JobApplicationRequirementsRadiusRule {
      ...JarRadiusRule
    }
    ... on JobApplicationRequirementsLocationFloating {
      ...JarLocationFloating
    }
    ... on JobApplicationRequirementsUnitFloating {
      ...JarUnitFloating
    }
    ... on JobApplicationRequirementsCovidVaccine {
      ...JarCovidVaccine
    }
    ... on JobApplicationRequirementsCovidBooster {
      ...JarCovidBooster
    }
    ... on JobApplicationRequirementsFluVaccine {
      ...JarFluVaccine
    }
    ... on JobApplicationRequirementsFluVaccination {
      ...JarFluVaccination
    }
    ... on JobApplicationRequirementsRoleExperience {
      ...JarRoleExperience
    }
    ... on JobApplicationRequirementsUnitExperience {
      ...JarUnitExperience
    }
    ... on JobApplicationRequirementsTechnologyExperience {
      ...JarTechnologyExperience
    }
    ... on JobApplicationRequirementsTravelExperience {
      ...JarTravelExperience
    }
    ... on JobApplicationRequirementsStateLicense {
      ...JarStateLicense
    }
    ... on JobApplicationRequirementsDriverLicense {
      ...JarDriverLicense
    }
    ... on JobApplicationRequirementsNurseReference {
      ...JarNurseReference
    }
    ... on JobApplicationRequirementsCertification {
      ...JarCertification
    }
    ... on JobApplicationRequirementsProofOfIdentification {
      ...JarProofOfIdentification
    }
    ... on JobApplicationRequirementsTraumaLevelExperience {
      ...JarTraumaLevelExperience
    }
    ... on JobApplicationRequirementsEducation {
      ...JarEducation
    }
  }
}
fragment MatchDetailsRequiredJars on Job {
  requiredJarsV2 {
    __typename
    ... on JobApplicationRequirementsRadiusRule {
      ...JarRadiusRule
    }
    ... on JobApplicationRequirementsMaximumTimeOffRule {
      ...JarMaximumTimeOffRule
    }
    ... on JobApplicationRequirementsLocationFloating {
      ...JarLocationFloating
    }
    ... on JobApplicationRequirementsUnitFloating {
      ...JarUnitFloating
    }
    ... on JobApplicationRequirementsCovidVaccine {
      ...JarCovidVaccine
    }
    ... on JobApplicationRequirementsCovidBooster {
      ...JarCovidBooster
    }
    ... on JobApplicationRequirementsFluVaccine {
      ...JarFluVaccine
    }
    ... on JobApplicationRequirementsFluVaccination {
      ...JarFluVaccination
    }
    ... on JobApplicationRequirementsRoleExperience {
      ...JarRoleExperience
    }
    ... on JobApplicationRequirementsUnitExperience {
      ...JarUnitExperience
    }
    ... on JobApplicationRequirementsTechnologyExperience {
      ...JarTechnologyExperience
    }
    ... on JobApplicationRequirementsTravelExperience {
      ...JarTravelExperience
    }
    ... on JobApplicationRequirementsStateLicense {
      ...JarStateLicense
    }
    ... on JobApplicationRequirementsDriverLicense {
      ...JarDriverLicense
    }
    ... on JobApplicationRequirementsNurseReference {
      ...JarNurseReference
    }
    ... on JobApplicationRequirementsCertification {
      ...JarCertification
    }
    ... on JobApplicationRequirementsProofOfIdentification {
      ...JarProofOfIdentification
    }
    ... on JobApplicationRequirementsTraumaLevelExperience {
      ...JarTraumaLevelExperience
    }
    ... on JobApplicationRequirementsEducation {
      ...JarEducation
    }
  }
}
fragment MatchDetailsJobPaymentDetails on JobPaymentDetails {
  id
  blendedWageRate
  callBackRate
  doubleTimeMultiplier
  extraRate
  grossPayWeekly
  holidayRate
  incidentalsStipendDaily
  lodgingStipendDaily
  onCallRate
  overtimeHoursPerWeek
  overtimeMultiplier
  overtimeWageRate
  regularHoursPerWeek
  regularWageRate
  totalHoursPerWeek
}
fragment RequestInterviewButtonJob on Job {
  id
  canApply {
    value
    reasons {
      fullMessages
    }
  }
  instantOffer
  jobApplication {
    id
    state
  }
  onHold
  ...UserViewedMatchEventJob
}
fragment JarRadiusRule on JobApplicationRequirementsRadiusRule {
  id
  type
  description
}
fragment JarCertification on JobApplicationRequirementsCertification {
  id
  type
  title
  description
  certification {
    id
    credential
    name
    uuid
    issuingBodies
  }
}
fragment JarNurseReference on JobApplicationRequirementsNurseReference {
  id
  description
  occurrences
  timeframe
  type
}
fragment JarDriverLicense on JobApplicationRequirementsDriverLicense {
  id
  required
  type
  stage
}
fragment JarCovidVaccine on JobApplicationRequirementsCovidVaccine {
  id
  type
  stage
  description
}
fragment JarCovidBooster on JobApplicationRequirementsCovidBooster {
  id
  type
  stage
  description
}
fragment JarFluVaccine on JobApplicationRequirementsFluVaccine {
  id
  type
  stage
  description
}
fragment JarFluVaccination on JobApplicationRequirementsFluVaccination {
  id
  type
  stage
  description
}
fragment JarLocationFloating on JobApplicationRequirementsLocationFloating {
  id
  type
  description
}
fragment JarMaximumTimeOffRule on JobApplicationRequirementsMaximumTimeOffRule {
  id
  type
  maximumTimeOff
  description
}
fragment JarUnitFloating on JobApplicationRequirementsUnitFloating {
  id
  type
  description
}
fragment JarStateLicense on JobApplicationRequirementsStateLicense {
  id
  stage
  type
  description
}
fragment JarTravelExperience on JobApplicationRequirementsTravelExperience {
  id
  type
  months
  description
}
fragment JarRoleExperience on JobApplicationRequirementsRoleExperience {
  id
  type
  months
  description
}
fragment JarUnitExperience on JobApplicationRequirementsUnitExperience {
  id
  type
  months
  description
}
fragment JarTechnologyExperience on JobApplicationRequirementsTechnologyExperience {
  id
  type
  months
  description
  technology {
    id
    uuid
    name
  }
}
fragment JarProofOfIdentification on JobApplicationRequirementsProofOfIdentification {
  id
  type
  description
  required
  stage
}
fragment JarTraumaLevelExperience on JobApplicationRequirementsTraumaLevelExperience {
  id
  type
  description
  enforcementType
}
fragment JarEducation on JobApplicationRequirementsEducation {
  id
  type
  description
  enforcementType
}
fragment JobUtilsPayRateJob on Job {
  id
  travelAllowed
  localAllowed
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  grossPayWeekly
  jobType
  localGrossPayWeekly
  localPaymentDetails {
    id
    grossPayWeekly
  }
}
fragment UserViewedMatchEventJob on Job {
  id
  activeApplicantsCount
  business {
    id
    city
    name
    logo
    state
  }
  clinicalUnit {
    id
    displayName
  }
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  favoritedCount
  grossPayWeekly
  hoursPerShift
  instantOffer
  jobType
  lengthInWeeks
  shiftsPerWeek
  shiftType
  startDate
  stateActiveAt
  title
}`, {"fragmentName":"MatchDetailPageJob"}) as unknown as TypedDocumentString<MatchDetailPageJobFragment, unknown>;
export const PayPreviewListPagePayrollFragmentDoc = new TypedDocumentString(`
    fragment PayPreviewListPagePayroll on Payroll {
  id
  periodStart
  periodEnd
}
    `, {"fragmentName":"PayPreviewListPagePayroll"}) as unknown as TypedDocumentString<PayPreviewListPagePayrollFragment, unknown>;
export const ThisIsMeUserFragmentDoc = new TypedDocumentString(`
    fragment ThisIsMeUser on User {
  id
  profilePic
  ...UserFullName
  nurseProfile {
    id
    applicationSummary
    role {
      id
      name
    }
    primarySpecialty {
      id
      displayName
      fullName
    }
  }
}
    fragment UserFullName on User {
  firstName
  preferredName
  middleName
  lastName
}`, {"fragmentName":"ThisIsMeUser"}) as unknown as TypedDocumentString<ThisIsMeUserFragment, unknown>;
export const ProfilePageV2UserFragmentDoc = new TypedDocumentString(`
    fragment ProfilePageV2User on User {
  ...ThisIsMeUser
  nurseProfile {
    id
    nurseAdvocate {
      ...NurseAdvocateWidgetSalesforceUser
    }
    role {
      id
      type
    }
    state
  }
}
    fragment UserFullName on User {
  firstName
  preferredName
  middleName
  lastName
}
fragment NurseAdvocateWidgetSalesforceUser on SalesforceUser {
  id
  phone
  firstName
  lastName
  profileImgUrl
  isNurseAdvocate
  isAlliedAdvocate
  clinicalRole
}
fragment ThisIsMeUser on User {
  id
  profilePic
  ...UserFullName
  nurseProfile {
    id
    applicationSummary
    role {
      id
      name
    }
    primarySpecialty {
      id
      displayName
      fullName
    }
  }
}`, {"fragmentName":"ProfilePageV2User"}) as unknown as TypedDocumentString<ProfilePageV2UserFragment, unknown>;
export const AboutMePanelNurseProfileFragmentDoc = new TypedDocumentString(`
    fragment AboutMePanelNurseProfile on NurseProfile {
  id
  yearsOfExp
  yearsOfTravelExp
  birthday
  ssnLast4
  fullSsnCollected
  state
  phoneVerified
  role {
    id
  }
  primarySpecialty {
    id
    slug
    fullName
  }
}
    `, {"fragmentName":"AboutMePanelNurseProfile"}) as unknown as TypedDocumentString<AboutMePanelNurseProfileFragment, unknown>;
export const AboutMePanelUserFragmentDoc = new TypedDocumentString(`
    fragment AboutMePanelUser on User {
  id
  profilePic
  firstName
  middleName
  lastName
  preferredName
  preferredPronoun
  phone
  phoneVerified
  streetAddressPermanent
  streetNumberPermanent
  cityPermanent
  statePermanent
  zipcodePermanent
  countryPermanentName
  countryPermanentCode
  googlePlaceIdPermanent
}
    `, {"fragmentName":"AboutMePanelUser"}) as unknown as TypedDocumentString<AboutMePanelUserFragment, unknown>;
export const ParsedAboutMeUserInfoFragmentDoc = new TypedDocumentString(`
    fragment ParsedAboutMeUserInfo on PersonalInformation {
  dateOfBirth
  firstName
  lastName
  middleName
}
    `, {"fragmentName":"ParsedAboutMeUserInfo"}) as unknown as TypedDocumentString<ParsedAboutMeUserInfoFragment, unknown>;
export const ParsedAboutMeUserAddressFragmentDoc = new TypedDocumentString(`
    fragment ParsedAboutMeUserAddress on PermanentAddress {
  streetAddress: permanentAddress
  city
  state
  country
  zipcode: postalCode
}
    `, {"fragmentName":"ParsedAboutMeUserAddress"}) as unknown as TypedDocumentString<ParsedAboutMeUserAddressFragment, unknown>;
export const ClinicianLanguagesFragmentDoc = new TypedDocumentString(`
    fragment ClinicianLanguages on Language {
  id
  language
  proficiency
}
    `, {"fragmentName":"ClinicianLanguages"}) as unknown as TypedDocumentString<ClinicianLanguagesFragment, unknown>;
export const LanguageNurseProfileUpdateCacheFragmentDoc = new TypedDocumentString(`
    fragment LanguageNurseProfileUpdateCache on NurseProfile {
  id
  languages {
    ...ClinicianLanguages
  }
}
    fragment ClinicianLanguages on Language {
  id
  language
  proficiency
}`, {"fragmentName":"LanguageNurseProfileUpdateCache"}) as unknown as TypedDocumentString<LanguageNurseProfileUpdateCacheFragment, unknown>;
export const ReferenceResponseReferenceDetailsFragmentDoc = new TypedDocumentString(`
    fragment ReferenceResponseReferenceDetails on Reference {
  id
  name
  candidateName
  employmentOther
  jobTitle
  relationship
  responseAt
  unit
}
    `, {"fragmentName":"ReferenceResponseReferenceDetails"}) as unknown as TypedDocumentString<ReferenceResponseReferenceDetailsFragment, unknown>;
export const ReferenceDetailsFragmentDoc = new TypedDocumentString(`
    fragment ReferenceDetails on Reference {
  id
  bedCount
  chargeExp
  email
  expired
  facilityName
  isLocked
  jobTitle
  lastFailedDelivery
  name
  patientsPerNurse
  phone
  preferredContactMethod
  relationship
  responseAt
  signedName
  unit
  unitName
  files {
    ...FileMetadata
  }
  position {
    id
    startAt
    endAt
    title
    usableForReferences
    facility {
      id
      name
      location {
        id
        formattedLocationString
        googlePlaceId
      }
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}`, {"fragmentName":"ReferenceDetails"}) as unknown as TypedDocumentString<ReferenceDetailsFragment, unknown>;
export const ReferenceNurseProfileUpdateCacheFragmentDoc = new TypedDocumentString(`
    fragment ReferenceNurseProfileUpdateCache on NurseProfile {
  id
  canApplyJobs
  numActiveReferences
  referencesComplete
  references {
    ...ReferenceDetails
  }
  positions {
    id
    startAt
    endAt
    usableForReferences
    facility {
      id
      name
      location {
        id
        formattedLocationString
        googlePlaceId
      }
    }
  }
  licenses {
    id
  }
  applicationReadiness {
    meta {
      requirements {
        status
      }
    }
    results {
      references {
        label
        status
        completeReferenceCount
        pendingReferenceCount
      }
    }
  }
  profileCompletion {
    id
    steps {
      references {
        status
      }
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment ReferenceDetails on Reference {
  id
  bedCount
  chargeExp
  email
  expired
  facilityName
  isLocked
  jobTitle
  lastFailedDelivery
  name
  patientsPerNurse
  phone
  preferredContactMethod
  relationship
  responseAt
  signedName
  unit
  unitName
  files {
    ...FileMetadata
  }
  position {
    id
    startAt
    endAt
    title
    usableForReferences
    facility {
      id
      name
      location {
        id
        formattedLocationString
        googlePlaceId
      }
    }
  }
}`, {"fragmentName":"ReferenceNurseProfileUpdateCache"}) as unknown as TypedDocumentString<ReferenceNurseProfileUpdateCacheFragment, unknown>;
export const ReferencesItemFragmentDoc = new TypedDocumentString(`
    fragment ReferencesItem on Reference {
  id
  belowExpectations
  canEdit
  chargeExp
  email
  employmentOther
  expired
  isExpiringSoon
  isLocked
  jobTitle
  lastFailedDelivery
  name
  phone
  preferredContactMethod
  referenceFormSentAt
  relationship
  responseAt
  signedName
  unit
  wouldRehire
  position {
    id
    facility {
      id
      name
    }
  }
  files {
    ...FileMetadata
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}`, {"fragmentName":"ReferencesItem"}) as unknown as TypedDocumentString<ReferencesItemFragment, unknown>;
export const ReferenceDetailsPositionFragmentDoc = new TypedDocumentString(`
    fragment ReferenceDetailsPosition on Position {
  id
  startAt
  endAt
  title
  usableForReferences
  facility {
    id
    name
    location {
      id
      formattedLocationString
      googlePlaceId
    }
  }
}
    `, {"fragmentName":"ReferenceDetailsPosition"}) as unknown as TypedDocumentString<ReferenceDetailsPositionFragment, unknown>;
export const ResumeParserReferenceSuggestionsFragmentDoc = new TypedDocumentString(`
    fragment ResumeParserReferenceSuggestions on ReferenceSuggestion {
  email
  jobTitle
  mobileNumber
  name
  parserId
  preferredContactMethod
  text
}
    `, {"fragmentName":"ResumeParserReferenceSuggestions"}) as unknown as TypedDocumentString<ResumeParserReferenceSuggestionsFragment, unknown>;
export const WorkExperiencePanelPositionFragmentDoc = new TypedDocumentString(`
    fragment WorkExperiencePanelPosition on Position {
  id
  title
  positionType
  classification
  startAt
  endAt
  patientRatio
  hoursWorked
  hoursWorkedTimeframe
  nicuCareLevels: nicuLevel
  traumaLevel
  additionalSkills
  chargeExperience
  preceptorExperience
  leadExperience
  trauma
  magnet
  teaching
  wouldWorkAgain
  facilityBedCount: hospitalBedCount
  unitBedCount
  floatFrequency
  friendlyEmploymentType
  invalidOverlapByHours
  invalidOverlapByLocation
  pediatricTraumaLevel
  role {
    id
    name
  }
  facility {
    id
    name
    location {
      id
      formattedLocationString
      googlePlaceId
    }
  }
  clinicalUnit {
    id
    slug
    displayName
  }
  agency {
    id
    name
  }
  specialties {
    id
    displayName
    fullName
    nicu
    pediatric
    slug
  }
  technologies {
    id
    name
  }
  floatUnits {
    id
    displayName
  }
}
    `, {"fragmentName":"WorkExperiencePanelPosition"}) as unknown as TypedDocumentString<WorkExperiencePanelPositionFragment, unknown>;
export const PositionNurseProfileUpdateCacheFragmentDoc = new TypedDocumentString(`
    fragment PositionNurseProfileUpdateCache on NurseProfile {
  id
  canApplyJobs
  hasPositionsInvalidHoursOverlap
  hasPositionsLocationOverlap
  applicationReadiness {
    results {
      licenses {
        label
        status
      }
    }
  }
  profileCompletion {
    id
    steps {
      workExperience {
        status
        message
      }
    }
    meta {
      id
      incompleteCount
      expiredCount
      percentCompleted
      pendingCount
    }
  }
  positions {
    ...WorkExperiencePanelPosition
  }
}
    fragment WorkExperiencePanelPosition on Position {
  id
  title
  positionType
  classification
  startAt
  endAt
  patientRatio
  hoursWorked
  hoursWorkedTimeframe
  nicuCareLevels: nicuLevel
  traumaLevel
  additionalSkills
  chargeExperience
  preceptorExperience
  leadExperience
  trauma
  magnet
  teaching
  wouldWorkAgain
  facilityBedCount: hospitalBedCount
  unitBedCount
  floatFrequency
  friendlyEmploymentType
  invalidOverlapByHours
  invalidOverlapByLocation
  pediatricTraumaLevel
  role {
    id
    name
  }
  facility {
    id
    name
    location {
      id
      formattedLocationString
      googlePlaceId
    }
  }
  clinicalUnit {
    id
    slug
    displayName
  }
  agency {
    id
    name
  }
  specialties {
    id
    displayName
    fullName
    nicu
    pediatric
    slug
  }
  technologies {
    id
    name
  }
  floatUnits {
    id
    displayName
  }
}`, {"fragmentName":"PositionNurseProfileUpdateCache"}) as unknown as TypedDocumentString<PositionNurseProfileUpdateCacheFragment, unknown>;
export const EducationGraduatedOnFragmentDoc = new TypedDocumentString(`
    fragment EducationGraduatedOn on Education {
  id
  graduatedOn
}
    `, {"fragmentName":"EducationGraduatedOn"}) as unknown as TypedDocumentString<EducationGraduatedOnFragment, unknown>;
export const ResumeParserWorkExperienceSuggestionsFragmentDoc = new TypedDocumentString(`
    fragment ResumeParserWorkExperienceSuggestions on WorkExperienceSuggestion {
  startAt
  endAt
  additionalSkills
  facilityName
  traumaLevel
  facilityBedCount: hospitalBedCount
  trauma
  magnet
  teaching
  parserId
  positionType
  role {
    id
    name
  }
  facility {
    id
    name
    location {
      id
      formattedLocationString
      googlePlaceId
      city
      stateCode
    }
  }
  clinicalUnit {
    id
    slug
    displayName
  }
  specialties {
    id
    displayName
  }
  technologies {
    id
    name
  }
}
    `, {"fragmentName":"ResumeParserWorkExperienceSuggestions"}) as unknown as TypedDocumentString<ResumeParserWorkExperienceSuggestionsFragment, unknown>;
export const WorkExperienceSectionPositionFragmentDoc = new TypedDocumentString(`
    fragment WorkExperienceSectionPosition on Position {
  id
  title
  positionType
  startAt
  endAt
  humanReadableLength
  hoursWorked
  hoursWorkedTimeframe
  nicuCareLevels: nicuLevel
  additionalSkills
  chargeExperience
  leadExperience
  preceptorExperience
  floatFrequency
  friendlyEmploymentType
  invalidOverlapByHours
  invalidOverlapByLocation
  usableForReferences
  activeReferences {
    id
    name
    relationship
    responseAt
  }
  role {
    id
    name
  }
  facility {
    id
    name
    location {
      id
      city
      stateCode
      country
    }
  }
  clinicalUnit {
    id
    displayName
  }
  agency {
    id
    name
  }
  technologies {
    id
    name
  }
  specialties {
    id
    displayName
  }
  floatUnits {
    id
    displayName
  }
}
    `, {"fragmentName":"WorkExperienceSectionPosition"}) as unknown as TypedDocumentString<WorkExperienceSectionPositionFragment, unknown>;
export const WorkExperienceSectionGapFragmentDoc = new TypedDocumentString(`
    fragment WorkExperienceSectionGap on Gap {
  gapId: id
  gapEndAt: endAt
  gapExplanation: explanation
  gapGooglePlaceId: googlePlaceId
  gapIsEducationGap: isEducationGap
  gapLocationAddress: locationAddress
  gapReason: reason
  gapStartAt: startAt
}
    `, {"fragmentName":"WorkExperienceSectionGap"}) as unknown as TypedDocumentString<WorkExperienceSectionGapFragment, unknown>;
export const WorkExperienceSectionExperienceItemFragmentDoc = new TypedDocumentString(`
    fragment WorkExperienceSectionExperienceItem on ExperienceItemUnion {
  ... on Position {
    ...WorkExperienceSectionPosition
  }
  ... on Gap {
    ...WorkExperienceSectionGap
  }
}
    fragment WorkExperienceSectionPosition on Position {
  id
  title
  positionType
  startAt
  endAt
  humanReadableLength
  hoursWorked
  hoursWorkedTimeframe
  nicuCareLevels: nicuLevel
  additionalSkills
  chargeExperience
  leadExperience
  preceptorExperience
  floatFrequency
  friendlyEmploymentType
  invalidOverlapByHours
  invalidOverlapByLocation
  usableForReferences
  activeReferences {
    id
    name
    relationship
    responseAt
  }
  role {
    id
    name
  }
  facility {
    id
    name
    location {
      id
      city
      stateCode
      country
    }
  }
  clinicalUnit {
    id
    displayName
  }
  agency {
    id
    name
  }
  technologies {
    id
    name
  }
  specialties {
    id
    displayName
  }
  floatUnits {
    id
    displayName
  }
}
fragment WorkExperienceSectionGap on Gap {
  gapId: id
  gapEndAt: endAt
  gapExplanation: explanation
  gapGooglePlaceId: googlePlaceId
  gapIsEducationGap: isEducationGap
  gapLocationAddress: locationAddress
  gapReason: reason
  gapStartAt: startAt
}`, {"fragmentName":"WorkExperienceSectionExperienceItem"}) as unknown as TypedDocumentString<WorkExperienceSectionExperienceItemFragment, unknown>;
export const WorkExperienceSectionNurseProfileFragmentDoc = new TypedDocumentString(`
    fragment WorkExperienceSectionNurseProfile on NurseProfile {
  id
  applicationReadiness {
    results {
      employment {
        label
        status
      }
    }
  }
  computedYearsOfExp
  computedYearsOfExpWithGaps
  computedDaysOfExpWithGaps
  educations {
    id
    graduatedOn
  }
  gapBetweenEducationAndEmploymentPosition
  hasPositionsLocationOverlap
  hasPositionsInvalidHoursOverlap
  isYearsOfExpCompleted
  profileCompletion {
    id
    steps {
      workExperience {
        status
        message
      }
    }
  }
  sortedExperienceItems {
    ...WorkExperienceSectionExperienceItem
  }
  yearsOfExp
  yearsOfTravelExp
}
    fragment WorkExperienceSectionExperienceItem on ExperienceItemUnion {
  ... on Position {
    ...WorkExperienceSectionPosition
  }
  ... on Gap {
    ...WorkExperienceSectionGap
  }
}
fragment WorkExperienceSectionPosition on Position {
  id
  title
  positionType
  startAt
  endAt
  humanReadableLength
  hoursWorked
  hoursWorkedTimeframe
  nicuCareLevels: nicuLevel
  additionalSkills
  chargeExperience
  leadExperience
  preceptorExperience
  floatFrequency
  friendlyEmploymentType
  invalidOverlapByHours
  invalidOverlapByLocation
  usableForReferences
  activeReferences {
    id
    name
    relationship
    responseAt
  }
  role {
    id
    name
  }
  facility {
    id
    name
    location {
      id
      city
      stateCode
      country
    }
  }
  clinicalUnit {
    id
    displayName
  }
  agency {
    id
    name
  }
  technologies {
    id
    name
  }
  specialties {
    id
    displayName
  }
  floatUnits {
    id
    displayName
  }
}
fragment WorkExperienceSectionGap on Gap {
  gapId: id
  gapEndAt: endAt
  gapExplanation: explanation
  gapGooglePlaceId: googlePlaceId
  gapIsEducationGap: isEducationGap
  gapLocationAddress: locationAddress
  gapReason: reason
  gapStartAt: startAt
}`, {"fragmentName":"WorkExperienceSectionNurseProfile"}) as unknown as TypedDocumentString<WorkExperienceSectionNurseProfileFragment, unknown>;
export const RequestReviewFragmentDoc = new TypedDocumentString(`
    fragment RequestReview on RequestReview {
  status
  title
  description
  ctaText
  error
}
    `, {"fragmentName":"RequestReview"}) as unknown as TypedDocumentString<RequestReviewFragment, unknown>;
export const NurseAdvocateFragmentDoc = new TypedDocumentString(`
    fragment NurseAdvocate on SalesforceUser {
  id
  email
  phone
  firstName
  profileImgUrl
}
    `, {"fragmentName":"NurseAdvocate"}) as unknown as TypedDocumentString<NurseAdvocateFragment, unknown>;
export const HomeUserFragmentDoc = new TypedDocumentString(`
    fragment HomeUser on User {
  id
  firstName
  preferredName
  lastName
  email
  nurseProfile {
    id
    isActivated
    isOnboarding
    squatchShareUrl
    wizardCompleted
    state
    requestReview {
      ...RequestReview
    }
    nurseAdvocate {
      ...NurseAdvocate
    }
    role {
      id
      type
    }
  }
}
    fragment RequestReview on RequestReview {
  status
  title
  description
  ctaText
  error
}
fragment NurseAdvocate on SalesforceUser {
  id
  email
  phone
  firstName
  profileImgUrl
}`, {"fragmentName":"HomeUser"}) as unknown as TypedDocumentString<HomeUserFragment, unknown>;
export const ClinicianCredentialsOverviewFragmentDoc = new TypedDocumentString(`
    fragment ClinicianCredentialsOverview on ClinicianCredentialsOverview {
  id
  credentialTotalCount
  credentialExpiringCount
  credentialExpiredCount
}
    `, {"fragmentName":"ClinicianCredentialsOverview"}) as unknown as TypedDocumentString<ClinicianCredentialsOverviewFragment, unknown>;
export const JobPlacementScheduleSummaryFragmentDoc = new TypedDocumentString(`
    fragment JobPlacementScheduleSummary on JobPlacementSchedule {
  id
  name
  timezone
  endSec
  jobPlacement {
    id
    facilityLocation {
      id
      city
      stateCode
    }
  }
}
    `, {"fragmentName":"JobPlacementScheduleSummary"}) as unknown as TypedDocumentString<JobPlacementScheduleSummaryFragment, unknown>;
export const TodoListFragmentDoc = new TypedDocumentString(`
    fragment TodoList on TodoList {
  id
  completeByDate
  targetBusinessName
  todoListItems(filter: LIVE) {
    id
    itemState
  }
}
    `, {"fragmentName":"TodoList"}) as unknown as TypedDocumentString<TodoListFragment, unknown>;
export const HomeResourceLinkFragmentDoc = new TypedDocumentString(`
    fragment HomeResourceLink on HomeResourceLink {
  id
  title
  link
}
    `, {"fragmentName":"HomeResourceLink"}) as unknown as TypedDocumentString<HomeResourceLinkFragment, unknown>;
export const HomePageNurseProfileFragmentDoc = new TypedDocumentString(`
    fragment HomePageNurseProfile on NurseProfile {
  id
  wizardCompleted
  displayName
  activationRequest {
    earliestStartDateAt
  }
  profileCompletion {
    id
    meta {
      id
      percentCompleted
    }
  }
  nurseAdvocate {
    ...NurseAdvocateWidgetSalesforceUser
  }
  state
}
    fragment NurseAdvocateWidgetSalesforceUser on SalesforceUser {
  id
  phone
  firstName
  lastName
  profileImgUrl
  isNurseAdvocate
  isAlliedAdvocate
  clinicalRole
}`, {"fragmentName":"HomePageNurseProfile"}) as unknown as TypedDocumentString<HomePageNurseProfileFragment, unknown>;
export const HomePageUserFragmentDoc = new TypedDocumentString(`
    fragment HomePageUser on User {
  id
  preferredName
  nurseProfile {
    ...HomePageNurseProfile
  }
  ...MatchCardUser
}
    fragment MatchCardUser on User {
  id
  email
  nurseProfile {
    id
    isActivated
    percentComplete
    state
    profileCompletion {
      id
      meta {
        id
        percentCompleted
      }
    }
    nurseAdvocate {
      id
      email
      fullName
    }
  }
}
fragment NurseAdvocateWidgetSalesforceUser on SalesforceUser {
  id
  phone
  firstName
  lastName
  profileImgUrl
  isNurseAdvocate
  isAlliedAdvocate
  clinicalRole
}
fragment HomePageNurseProfile on NurseProfile {
  id
  wizardCompleted
  displayName
  activationRequest {
    earliestStartDateAt
  }
  profileCompletion {
    id
    meta {
      id
      percentCompleted
    }
  }
  nurseAdvocate {
    ...NurseAdvocateWidgetSalesforceUser
  }
  state
}`, {"fragmentName":"HomePageUser"}) as unknown as TypedDocumentString<HomePageUserFragment, unknown>;
export const HomePageClinicianJobSummaryFragmentDoc = new TypedDocumentString(`
    fragment HomePageClinicianJobSummary on HomeClinicianJobSummary {
  id
  favoritedCount {
    id
    value
  }
  applicationsCount {
    id
    value
  }
  offersCount {
    id
    value
  }
  submissionsCount {
    id
    value
  }
}
    `, {"fragmentName":"HomePageClinicianJobSummary"}) as unknown as TypedDocumentString<HomePageClinicianJobSummaryFragment, unknown>;
export const ComplianceQuestionsPermanentAddressUserFragmentDoc = new TypedDocumentString(`
    fragment ComplianceQuestionsPermanentAddressUser on User {
  id
  cityPermanent
  countryPermanentCode
  countryPermanentName
  googlePlaceIdPermanent
  statePermanent
  streetAddressPermanent
  streetNumberPermanent
  zipcodePermanent
}
    `, {"fragmentName":"ComplianceQuestionsPermanentAddressUser"}) as unknown as TypedDocumentString<ComplianceQuestionsPermanentAddressUserFragment, unknown>;
export const RequestReviewFormCopyFragmentDoc = new TypedDocumentString(`
    fragment RequestReviewFormCopy on RequestReviewForm {
  title
  ctaText
  experienceDateQuestion {
    title
    description
  }
  experienceQuestion {
    title
    description
  }
  startDateQuestion {
    title
    description
  }
  notesQuestion {
    title
    description
  }
  licenseOrCertificationQuestion {
    title
    description
  }
  licenseOrCertificationIntentionQuestion {
    title
    description
  }
  licenseOrCertificationDateQuestion {
    title
    description
  }
  followingStepQuestion {
    title
    description
  }
}
    `, {"fragmentName":"RequestReviewFormCopy"}) as unknown as TypedDocumentString<RequestReviewFormCopyFragment, unknown>;
export const CompleteRoleFragmentDoc = new TypedDocumentString(`
    fragment CompleteRole on Role {
  id
  abbreviation
  key
  name
  type
}
    `, {"fragmentName":"CompleteRole"}) as unknown as TypedDocumentString<CompleteRoleFragment, unknown>;
export const ActivationRequestFragmentDoc = new TypedDocumentString(`
    fragment ActivationRequest on ActivationRequest {
  id
  earliestStartDateAt
  notes
  requiredExperience
  requiredExperienceDateAt
  followingStepQuestion
  advocate {
    ...NurseAdvocateWidgetSalesforceUser
  }
}
    fragment NurseAdvocateWidgetSalesforceUser on SalesforceUser {
  id
  phone
  firstName
  lastName
  profileImgUrl
  isNurseAdvocate
  isAlliedAdvocate
  clinicalRole
}`, {"fragmentName":"ActivationRequest"}) as unknown as TypedDocumentString<ActivationRequestFragment, unknown>;
export const ActivationRequestNurseProfileFragmentDoc = new TypedDocumentString(`
    fragment ActivationRequestNurseProfile on NurseProfile {
  id
  state
  wizardCompleted
  yearsOfExp
  role {
    ...CompleteRole
  }
  activationRequest {
    ...ActivationRequest
  }
}
    fragment CompleteRole on Role {
  id
  abbreviation
  key
  name
  type
}
fragment NurseAdvocateWidgetSalesforceUser on SalesforceUser {
  id
  phone
  firstName
  lastName
  profileImgUrl
  isNurseAdvocate
  isAlliedAdvocate
  clinicalRole
}
fragment ActivationRequest on ActivationRequest {
  id
  earliestStartDateAt
  notes
  requiredExperience
  requiredExperienceDateAt
  followingStepQuestion
  advocate {
    ...NurseAdvocateWidgetSalesforceUser
  }
}`, {"fragmentName":"ActivationRequestNurseProfile"}) as unknown as TypedDocumentString<ActivationRequestNurseProfileFragment, unknown>;
export const ExplorerIndexPageExplorerStateFragmentDoc = new TypedDocumentString(`
    fragment ExplorerIndexPageExplorerState on User {
  id
  nurseProfile {
    id
    educations {
      id
      locationString
    }
    location {
      id
      locationString
    }
    nursePreferences {
      id
      locations {
        id
        locationString
      }
    }
  }
}
    `, {"fragmentName":"ExplorerIndexPageExplorerState"}) as unknown as TypedDocumentString<ExplorerIndexPageExplorerStateFragment, unknown>;
export const NurseProfileBusinessFragmentDoc = new TypedDocumentString(`
    fragment NurseProfileBusiness on Facility {
  id
  slug
  name
  address
  city
  state
  hospital {
    id
    hospitalSystem
  }
  residencyPrograms {
    id
    name
  }
}
    `, {"fragmentName":"NurseProfileBusiness"}) as unknown as TypedDocumentString<NurseProfileBusinessFragment, unknown>;
export const RecentSearchesCardSearchHistoryEntryFragmentDoc = new TypedDocumentString(`
    fragment RecentSearchesCardSearchHistoryEntry on SearchHistoryEntry {
  id
  searchParams
}
    `, {"fragmentName":"RecentSearchesCardSearchHistoryEntry"}) as unknown as TypedDocumentString<RecentSearchesCardSearchHistoryEntryFragment, unknown>;
export const RecentSearchesCardSearchHistoryFragmentDoc = new TypedDocumentString(`
    fragment RecentSearchesCardSearchHistory on SearchHistory {
  id
  searchForm
  searchHistoryEntries {
    ...RecentSearchesCardSearchHistoryEntry
  }
}
    fragment RecentSearchesCardSearchHistoryEntry on SearchHistoryEntry {
  id
  searchParams
}`, {"fragmentName":"RecentSearchesCardSearchHistory"}) as unknown as TypedDocumentString<RecentSearchesCardSearchHistoryFragment, unknown>;
export const FacilityResultCardBusinessFragmentDoc = new TypedDocumentString(`
    fragment FacilityResultCardBusiness on Facility {
  id
  slug
}
    `, {"fragmentName":"FacilityResultCardBusiness"}) as unknown as TypedDocumentString<FacilityResultCardBusinessFragment, unknown>;
export const SavedFacilitiesSectionUserFragmentDoc = new TypedDocumentString(`
    fragment SavedFacilitiesSectionUser on User {
  id
  email
}
    `, {"fragmentName":"SavedFacilitiesSectionUser"}) as unknown as TypedDocumentString<SavedFacilitiesSectionUserFragment, unknown>;
export const ExplorerPageHeaderUserFragmentDoc = new TypedDocumentString(`
    fragment ExplorerPageHeaderUser on User {
  id
  nurseProfile {
    businesses {
      ...FacilityResultCardBusiness
      name
      address
      state
    }
    id
    canViewJobs
    yearsOfExp
    searchHistory(searchForm: $searchForm) {
      ...RecentSearchesCardSearchHistory
    }
  }
  ...SavedFacilitiesSectionUser
}
    fragment RecentSearchesCardSearchHistory on SearchHistory {
  id
  searchForm
  searchHistoryEntries {
    ...RecentSearchesCardSearchHistoryEntry
  }
}
fragment RecentSearchesCardSearchHistoryEntry on SearchHistoryEntry {
  id
  searchParams
}
fragment FacilityResultCardBusiness on Facility {
  id
  slug
}
fragment SavedFacilitiesSectionUser on User {
  id
  email
}`, {"fragmentName":"ExplorerPageHeaderUser"}) as unknown as TypedDocumentString<ExplorerPageHeaderUserFragment, unknown>;
export const FacilityResultCardUserFragmentDoc = new TypedDocumentString(`
    fragment FacilityResultCardUser on User {
  id
  nurseProfile {
    id
    businesses {
      ...FacilityResultCardBusiness
    }
  }
  ...TrackFacilityPageViewUser
}
    fragment FacilityResultCardBusiness on Facility {
  id
  slug
}
fragment TrackFacilityPageViewUser on User {
  id
  email
}`, {"fragmentName":"FacilityResultCardUser"}) as unknown as TypedDocumentString<FacilityResultCardUserFragment, unknown>;
export const FacilitiesCardUserFragmentDoc = new TypedDocumentString(`
    fragment FacilitiesCardUser on User {
  id
  nurseProfile {
    id
  }
  ...FacilityResultCardUser
}
    fragment FacilityResultCardUser on User {
  id
  nurseProfile {
    id
    businesses {
      ...FacilityResultCardBusiness
    }
  }
  ...TrackFacilityPageViewUser
}
fragment FacilityResultCardBusiness on Facility {
  id
  slug
}
fragment TrackFacilityPageViewUser on User {
  id
  email
}`, {"fragmentName":"FacilitiesCardUser"}) as unknown as TypedDocumentString<FacilitiesCardUserFragment, unknown>;
export const ExplorerPageUserFragmentDoc = new TypedDocumentString(`
    fragment ExplorerPageUser on User {
  id
  ...ExplorerIndexPageExplorerState
  firstName
  lastName
  intercomUserHash
  nurseProfile {
    id
    nurseType
    role {
      id
      key
      name
      type
    }
    licenses {
      id
      licenseType
    }
    educations {
      id
      locationString
    }
    nursePreferences {
      id
      explorerRole
      locations {
        id
        locationString
      }
    }
    location {
      id
      locationString
    }
    businesses {
      ...NurseProfileBusiness
    }
    searchHistory(searchForm: $searchForm) {
      ...RecentSearchesCardSearchHistory
    }
  }
  ...ExplorerPageHeaderUser
  ...FacilitiesCardUser
}
    fragment ExplorerPageHeaderUser on User {
  id
  nurseProfile {
    businesses {
      ...FacilityResultCardBusiness
      name
      address
      state
    }
    id
    canViewJobs
    yearsOfExp
    searchHistory(searchForm: $searchForm) {
      ...RecentSearchesCardSearchHistory
    }
  }
  ...SavedFacilitiesSectionUser
}
fragment FacilitiesCardUser on User {
  id
  nurseProfile {
    id
  }
  ...FacilityResultCardUser
}
fragment RecentSearchesCardSearchHistory on SearchHistory {
  id
  searchForm
  searchHistoryEntries {
    ...RecentSearchesCardSearchHistoryEntry
  }
}
fragment RecentSearchesCardSearchHistoryEntry on SearchHistoryEntry {
  id
  searchParams
}
fragment FacilityResultCardUser on User {
  id
  nurseProfile {
    id
    businesses {
      ...FacilityResultCardBusiness
    }
  }
  ...TrackFacilityPageViewUser
}
fragment FacilityResultCardBusiness on Facility {
  id
  slug
}
fragment SavedFacilitiesSectionUser on User {
  id
  email
}
fragment ExplorerIndexPageExplorerState on User {
  id
  nurseProfile {
    id
    educations {
      id
      locationString
    }
    location {
      id
      locationString
    }
    nursePreferences {
      id
      locations {
        id
        locationString
      }
    }
  }
}
fragment TrackFacilityPageViewUser on User {
  id
  email
}
fragment NurseProfileBusiness on Facility {
  id
  slug
  name
  address
  city
  state
  hospital {
    id
    hospitalSystem
  }
  residencyPrograms {
    id
    name
  }
}`, {"fragmentName":"ExplorerPageUser"}) as unknown as TypedDocumentString<ExplorerPageUserFragment, unknown>;
export const IndexPageUserFragmentDoc = new TypedDocumentString(`
    fragment IndexPageUser on User {
  id
  uuid
  nurseProfile {
    id
    isOnboarding
    profileCompletion {
      id
      meta {
        percentCompleted
      }
    }
    uuid
    wizardCompleted
  }
}
    `, {"fragmentName":"IndexPageUser"}) as unknown as TypedDocumentString<IndexPageUserFragment, unknown>;
export const InviteUserFragmentDoc = new TypedDocumentString(`
    fragment InviteUser on User {
  id
  email
  firstName
  lastName
  saasquatchToken
  referredByUuid
  nurseProfile {
    id
    squatchShareUrl
  }
}
    `, {"fragmentName":"InviteUser"}) as unknown as TypedDocumentString<InviteUserFragment, unknown>;
export const ProfilePageProfileCompletionMetaFragmentDoc = new TypedDocumentString(`
    fragment ProfilePageProfileCompletionMeta on NurseProfileCompletion {
  id
  meta {
    id
    completeCount
    expiredCount
    expiringCount
    incompleteCount
    pendingCount
    percentCompleted
  }
}
    `, {"fragmentName":"ProfilePageProfileCompletionMeta"}) as unknown as TypedDocumentString<ProfilePageProfileCompletionMetaFragment, unknown>;
export const ProfilePageProfileCompletionFragmentDoc = new TypedDocumentString(`
    fragment ProfilePageProfileCompletion on NurseProfileCompletion {
  id
  ...ProfilePageProfileCompletionMeta
  steps {
    backgroundQuestions {
      label
      status
    }
    certification {
      label
      message
      status
    }
    education {
      label
      message
      status
    }
    license {
      label
      message
      status
    }
    permanentAddress {
      label
      status
    }
    personalInfo {
      label
      status
    }
    references {
      label
      message
      status
    }
    skillsChecklist {
      label
      message
      status
    }
    verifyEmail {
      label
      status
    }
    workExperience {
      label
      status
    }
    yearsOfExperience {
      label
      status
    }
  }
}
    fragment ProfilePageProfileCompletionMeta on NurseProfileCompletion {
  id
  meta {
    id
    completeCount
    expiredCount
    expiringCount
    incompleteCount
    pendingCount
    percentCompleted
  }
}`, {"fragmentName":"ProfilePageProfileCompletion"}) as unknown as TypedDocumentString<ProfilePageProfileCompletionFragment, unknown>;
export const MatchesLandingPageNurseProfileFragmentDoc = new TypedDocumentString(`
    fragment MatchesLandingPageNurseProfile on NurseProfile {
  id
  canViewJobs
  wizardCompleted
  activeClinicalSpecialties {
    id
    slug
  }
  profileCompletion {
    id
    meta {
      id
      percentCompleted
    }
    ...ProfilePageProfileCompletion
  }
  role {
    id
  }
  nursePreferences {
    id
    broadPrefLocations
    contractLengths
    locations {
      id
      locationString
    }
    shiftPrefs
    shiftLengths
  }
}
    fragment ProfilePageProfileCompletion on NurseProfileCompletion {
  id
  ...ProfilePageProfileCompletionMeta
  steps {
    backgroundQuestions {
      label
      status
    }
    certification {
      label
      message
      status
    }
    education {
      label
      message
      status
    }
    license {
      label
      message
      status
    }
    permanentAddress {
      label
      status
    }
    personalInfo {
      label
      status
    }
    references {
      label
      message
      status
    }
    skillsChecklist {
      label
      message
      status
    }
    verifyEmail {
      label
      status
    }
    workExperience {
      label
      status
    }
    yearsOfExperience {
      label
      status
    }
  }
}
fragment ProfilePageProfileCompletionMeta on NurseProfileCompletion {
  id
  meta {
    id
    completeCount
    expiredCount
    expiringCount
    incompleteCount
    pendingCount
    percentCompleted
  }
}`, {"fragmentName":"MatchesLandingPageNurseProfile"}) as unknown as TypedDocumentString<MatchesLandingPageNurseProfileFragment, unknown>;
export const ShouldRedirectUserFragmentDoc = new TypedDocumentString(`
    fragment ShouldRedirectUser on User {
  nurseProfile {
    id
    canViewJobs
    wizardCompleted
  }
}
    `, {"fragmentName":"ShouldRedirectUser"}) as unknown as TypedDocumentString<ShouldRedirectUserFragment, unknown>;
export const JobApplicationEventsUserFragmentDoc = new TypedDocumentString(`
    fragment JobApplicationEventsUser on User {
  id
  email
}
    `, {"fragmentName":"JobApplicationEventsUser"}) as unknown as TypedDocumentString<JobApplicationEventsUserFragment, unknown>;
export const JobApplicationEventsNurseProfileFragmentDoc = new TypedDocumentString(`
    fragment JobApplicationEventsNurseProfile on NurseProfile {
  id
  isActivated
  state
  percentComplete
  applicationReadiness {
    results {
      background {
        label
        status
      }
      certifications {
        label
        status
      }
      education {
        label
        status
      }
      employment {
        label
        status
      }
      licenses {
        label
        status
      }
      references {
        label
        status
        completeReferenceCount
      }
      skillsChecklist {
        label
        status
      }
    }
  }
  nurseAdvocate {
    id
    email
    fullName
  }
  profileCompletion {
    id
    meta {
      id
      percentCompleted
    }
  }
}
    `, {"fragmentName":"JobApplicationEventsNurseProfile"}) as unknown as TypedDocumentString<JobApplicationEventsNurseProfileFragment, unknown>;
export const JobApplicationEventsJobFragmentDoc = new TypedDocumentString(`
    fragment JobApplicationEventsJob on Job {
  id
  activeApplicantsCount
  favoritedCount
  hoursPerShift
  instantOffer
  jobType
  lengthInWeeks
  shiftsPerWeek
  shiftType
  startDate
  stateActiveAt
  title
  business {
    id
    city
    logo
    name
    state
  }
  clinicalUnit {
    id
    displayName
  }
}
    `, {"fragmentName":"JobApplicationEventsJob"}) as unknown as TypedDocumentString<JobApplicationEventsJobFragment, unknown>;
export const ClinicianSignupInitialPathFragmentDoc = new TypedDocumentString(`
    fragment ClinicianSignupInitialPath on User {
  id
  email
  firstName
  lastName
  preferredName
  nurseProfile {
    id
    clinicalExperienceLevel
    state
    nurseType
    clinicalSpecialties {
      id
      specialty
    }
    location {
      id
    }
    role {
      id
      key
      name
      type
    }
  }
}
    `, {"fragmentName":"ClinicianSignupInitialPath"}) as unknown as TypedDocumentString<ClinicianSignupInitialPathFragment, unknown>;
export const CreateSharedLinkDocument = new TypedDocumentString(`
    mutation CreateSharedLink($input: CreateSharedLinkInput!) {
  createSharedLink(input: $input) {
    sharedLink {
      id
      shortUrl
      longUrl
    }
  }
}
    `) as unknown as TypedDocumentString<CreateSharedLinkMutation, CreateSharedLinkMutationVariables>;
export const FavoriteJobDocument = new TypedDocumentString(`
    mutation FavoriteJob($id: ID!, $source: String) {
  favoriteJob(id: $id, source: $source) {
    job {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<FavoriteJobMutation, FavoriteJobMutationVariables>;
export const DeleteFileDocument = new TypedDocumentString(`
    mutation DeleteFile($id: ID!) {
  deleteFile(id: $id) {
    id
  }
}
    `) as unknown as TypedDocumentString<DeleteFileMutation, DeleteFileMutationVariables>;
export const RecordEventDocument = new TypedDocumentString(`
    mutation RecordEvent($event: UserPropertiesEvent!) {
  userProperties {
    recordEvent(event: $event) {
      user {
        id
        userProperties {
          id
          shouldDisplayFirstFavoriteMessage
          shouldDisplayProfileIncompleteWarning
          shouldDisplayStaleProfileNotification
          shouldSendSprigSurvey
          shouldSendAppcastPixel
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<RecordEventMutation, RecordEventMutationVariables>;
export const SaveFacilityDocument = new TypedDocumentString(`
    mutation SaveFacility($nurseProfileId: ID!, $facilitySlug: String!) {
  saveFacility(nurseProfileId: $nurseProfileId, facilitySlug: $facilitySlug) {
    nurseProfile {
      id
      savedFacility(facilitySlug: $facilitySlug)
      businesses {
        id
        slug
        name
        address
        city
        state
        hospital {
          id
          hospitalSystem
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SaveFacilityMutation, SaveFacilityMutationVariables>;
export const DeleteSavedFacilityDocument = new TypedDocumentString(`
    mutation DeleteSavedFacility($nurseProfileId: ID!, $facilitySlug: String!) {
  deleteSavedFacility(
    nurseProfileId: $nurseProfileId
    facilitySlug: $facilitySlug
  ) {
    nurseProfile {
      id
      savedFacility(facilitySlug: $facilitySlug)
      businesses {
        id
        slug
        name
        address
        city
        state
        hospital {
          id
          hospitalSystem
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DeleteSavedFacilityMutation, DeleteSavedFacilityMutationVariables>;
export const RequestSmsVerificationDocument = new TypedDocumentString(`
    mutation RequestSMSVerification($userId: ID!, $phone: String!, $marketingSmsAllowed: Boolean) {
  requestSMSVerification(
    userId: $userId
    phone: $phone
    raiseValidationErrors: false
  ) {
    user {
      ...SMSVerificationUser
    }
    errors {
      errors
    }
  }
  nestedUpdateUser(
    id: $userId
    input: {marketingSmsAllowed: $marketingSmsAllowed}
  ) {
    user {
      ...SMSVerificationUser
    }
    errors {
      errors
    }
  }
}
    fragment SMSVerificationUser on User {
  id
  phone
  phoneVerified
  marketingSmsAllowed
}`) as unknown as TypedDocumentString<RequestSmsVerificationMutation, RequestSmsVerificationMutationVariables>;
export const CheckSmsVerificationCodeDocument = new TypedDocumentString(`
    mutation CheckSMSVerificationCode($userId: ID!, $code: String!) {
  checkSMSVerificationCode(userId: $userId, code: $code) {
    user {
      ...SMSVerificationUser
    }
  }
}
    fragment SMSVerificationUser on User {
  id
  phone
  phoneVerified
  marketingSmsAllowed
}`) as unknown as TypedDocumentString<CheckSmsVerificationCodeMutation, CheckSmsVerificationCodeMutationVariables>;
export const UpdateProfilePicDocument = new TypedDocumentString(`
    mutation UpdateProfilePic($userId: ID!, $file: Upload) {
  updateProfilePhoto(userId: $userId, file: $file) {
    user {
      id
      profilePic
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateProfilePicMutation, UpdateProfilePicMutationVariables>;
export const SignInUserDocument = new TypedDocumentString(`
    mutation SignInUser($input: SignInUserInput!) {
  signInUser(input: $input) {
    token
    roleType
    user {
      id
      email
      firstName
      lastName
      intercomUserHash
    }
  }
}
    `) as unknown as TypedDocumentString<SignInUserMutation, SignInUserMutationVariables>;
export const SignOutUserDocument = new TypedDocumentString(`
    mutation SignOutUser {
  signOut {
    user {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<SignOutUserMutation, SignOutUserMutationVariables>;
export const AdvocateDocument = new TypedDocumentString(`
    query Advocate {
  nurseProfile {
    ...Advocate
  }
}
    fragment Advocate on NurseProfile {
  id
  nurseAdvocate {
    id
    profileImgUrl
    email
    firstName
    phone
    fullName
  }
}`) as unknown as TypedDocumentString<AdvocateQuery, AdvocateQueryVariables>;
export const ClinicianDocument = new TypedDocumentString(`
    query Clinician {
  nurseProfile {
    ...Clinician
  }
}
    fragment Clinician on NurseProfile {
  id
  canUploadResume
  state
  nurseType
  wizardCompleted
  role {
    id
    key
    name
    type
  }
}`) as unknown as TypedDocumentString<ClinicianQuery, ClinicianQueryVariables>;
export const CeuCertificateTypesDocument = new TypedDocumentString(`
    query CeuCertificateTypes {
  __type(name: "CeuCertificateType") {
    ...EnumValuesType
  }
}
    fragment EnumValue on __EnumValue {
  name
  description
}
fragment EnumValuesType on __Type {
  name
  enumValues {
    ...EnumValue
  }
}`) as unknown as TypedDocumentString<CeuCertificateTypesQuery, CeuCertificateTypesQueryVariables>;
export const NurseTypesDocument = new TypedDocumentString(`
    query NurseTypes {
  __type(name: "NurseTypes") {
    ...EnumValuesType
  }
}
    fragment EnumValue on __EnumValue {
  name
  description
}
fragment EnumValuesType on __Type {
  name
  enumValues {
    ...EnumValue
  }
}`) as unknown as TypedDocumentString<NurseTypesQuery, NurseTypesQueryVariables>;
export const EmploymentTypesDocument = new TypedDocumentString(`
    query EmploymentTypes {
  __type(name: "EmploymentTypes") {
    ...EnumValuesType
  }
}
    fragment EnumValue on __EnumValue {
  name
  description
}
fragment EnumValuesType on __Type {
  name
  enumValues {
    ...EnumValue
  }
}`) as unknown as TypedDocumentString<EmploymentTypesQuery, EmploymentTypesQueryVariables>;
export const HoursWorkedTimeframesDocument = new TypedDocumentString(`
    query HoursWorkedTimeframes {
  __type(name: "HoursWorkedTimeframe") {
    ...EnumValuesType
  }
}
    fragment EnumValue on __EnumValue {
  name
  description
}
fragment EnumValuesType on __Type {
  name
  enumValues {
    ...EnumValue
  }
}`) as unknown as TypedDocumentString<HoursWorkedTimeframesQuery, HoursWorkedTimeframesQueryVariables>;
export const GapReasonsDocument = new TypedDocumentString(`
    query GapReasons {
  __type(name: "GapReasons") {
    ...EnumValuesType
  }
}
    fragment EnumValue on __EnumValue {
  name
  description
}
fragment EnumValuesType on __Type {
  name
  enumValues {
    ...EnumValue
  }
}`) as unknown as TypedDocumentString<GapReasonsQuery, GapReasonsQueryVariables>;
export const RecommenderRelationshipsDocument = new TypedDocumentString(`
    query RecommenderRelationships {
  __type(name: "RecommenderRelationship") {
    ...EnumValuesType
  }
}
    fragment EnumValue on __EnumValue {
  name
  description
}
fragment EnumValuesType on __Type {
  name
  enumValues {
    ...EnumValue
  }
}`) as unknown as TypedDocumentString<RecommenderRelationshipsQuery, RecommenderRelationshipsQueryVariables>;
export const FacilityTypesDocument = new TypedDocumentString(`
    query FacilityTypes {
  __type(name: "FacilityTypes") {
    ...EnumValuesType
  }
}
    fragment EnumValue on __EnumValue {
  name
  description
}
fragment EnumValuesType on __Type {
  name
  enumValues {
    ...EnumValue
  }
}`) as unknown as TypedDocumentString<FacilityTypesQuery, FacilityTypesQueryVariables>;
export const YearTermsDocument = new TypedDocumentString(`
    query YearTerms {
  __type(name: "YearTerms") {
    ...EnumValuesType
  }
}
    fragment EnumValue on __EnumValue {
  name
  description
}
fragment EnumValuesType on __Type {
  name
  enumValues {
    ...EnumValue
  }
}`) as unknown as TypedDocumentString<YearTermsQuery, YearTermsQueryVariables>;
export const StudentExperienceTypesDocument = new TypedDocumentString(`
    query StudentExperienceTypes {
  __type(name: "StudentExperienceTypes") {
    ...EnumValuesType
  }
}
    fragment EnumValue on __EnumValue {
  name
  description
}
fragment EnumValuesType on __Type {
  name
  enumValues {
    ...EnumValue
  }
}`) as unknown as TypedDocumentString<StudentExperienceTypesQuery, StudentExperienceTypesQueryVariables>;
export const ContractLengthDocument = new TypedDocumentString(`
    query ContractLength {
  __type(name: "ContractLength") {
    ...EnumValuesType
  }
}
    fragment EnumValue on __EnumValue {
  name
  description
}
fragment EnumValuesType on __Type {
  name
  enumValues {
    ...EnumValue
  }
}`) as unknown as TypedDocumentString<ContractLengthQuery, ContractLengthQueryVariables>;
export const ShiftLengthDocument = new TypedDocumentString(`
    query ShiftLength {
  __type(name: "ShiftLength") {
    ...EnumValuesType
  }
}
    fragment EnumValue on __EnumValue {
  name
  description
}
fragment EnumValuesType on __Type {
  name
  enumValues {
    ...EnumValue
  }
}`) as unknown as TypedDocumentString<ShiftLengthQuery, ShiftLengthQueryVariables>;
export const RoleTypesDocument = new TypedDocumentString(`
    query RoleTypes {
  __type(name: "RoleType") {
    ...EnumValuesType
  }
}
    fragment EnumValue on __EnumValue {
  name
  description
}
fragment EnumValuesType on __Type {
  name
  enumValues {
    ...EnumValue
  }
}`) as unknown as TypedDocumentString<RoleTypesQuery, RoleTypesQueryVariables>;
export const FeatureFlagsDocument = new TypedDocumentString(`
    query FeatureFlags {
  featureFlags
}
    `) as unknown as TypedDocumentString<FeatureFlagsQuery, FeatureFlagsQueryVariables>;
export const RolesDocument = new TypedDocumentString(`
    query Roles($type: RoleType) {
  roles(type: $type) {
    ...CompleteRole
  }
}
    fragment CompleteRole on Role {
  id
  abbreviation
  key
  name
  type
}`) as unknown as TypedDocumentString<RolesQuery, RolesQueryVariables>;
export const CertificationSuggestionsDocument = new TypedDocumentString(`
    query CertificationSuggestions($query: String) {
  getCertificationSuggestions(search_string: $query) {
    id
    name
    credential
    issuingBody
    issuingBodies
    useCompletionDate
  }
}
    `) as unknown as TypedDocumentString<CertificationSuggestionsQuery, CertificationSuggestionsQueryVariables>;
export const ClinicalSpecialtySuggestionsDocument = new TypedDocumentString(`
    query ClinicalSpecialtySuggestions($query: String) {
  getClinicalSpecialtySuggestions(search_string: $query) {
    ...ClinicalSpecialtySuggestionsClinicalSpecialty
  }
}
    fragment ClinicalSpecialtySuggestionsClinicalSpecialty on ClinicalSpecialty {
  id
  slug
  fullName
  displayName
  pediatric
  nicu
}`) as unknown as TypedDocumentString<ClinicalSpecialtySuggestionsQuery, ClinicalSpecialtySuggestionsQueryVariables>;
export const ClinicalUnitSuggestionsDocument = new TypedDocumentString(`
    query ClinicalUnitSuggestions($query: String) {
  getClinicalUnitSuggestions(search_string: $query) {
    id
    slug
    displayName
    defaultClinicalSpecialties {
      id
      slug
      displayName
      pediatric
    }
  }
}
    `) as unknown as TypedDocumentString<ClinicalUnitSuggestionsQuery, ClinicalUnitSuggestionsQueryVariables>;
export const FacilitySuggestionsDocument = new TypedDocumentString(`
    query FacilitySuggestions($query: String!) {
  facilitySuggestions(query: $query) {
    ...FacilitySuggestion
  }
}
    fragment FacilitySuggestion on Facility {
  id
  address
  city
  name
  state
  uuid
  zipcode
  hospital {
    ...HospitalInSuggestion
  }
}
fragment HospitalInSuggestion on Hospital {
  id
  nicuTraumaLevel
  pediatricTraumaCenterLevel
  totalLicensedBeds
  magnet
  teaching
  traumaCenter
  traumaCenterLevel
  technology {
    id
    name
  }
}`) as unknown as TypedDocumentString<FacilitySuggestionsQuery, FacilitySuggestionsQueryVariables>;
export const IncreasedPayBannerDocument = new TypedDocumentString(`
    query IncreasedPayBanner($sourcePage: BannerSourcePageEnum!) {
  increasedPayBanner(sourcePage: $sourcePage) {
    ...IncreasedPay
  }
}
    fragment IncreasedPay on IncreasedPayBanner {
  title
  description
  note
  redirectTo
  cta
}`) as unknown as TypedDocumentString<IncreasedPayBannerQuery, IncreasedPayBannerQueryVariables>;
export const PermanentAddressPanelDocument = new TypedDocumentString(`
    query PermanentAddressPanel {
  viewer {
    ... on User {
      ...PermanentAddressUser
    }
  }
}
    fragment PermanentAddressUser on User {
  id
  cityPermanent
  countryPermanentCode
  countryPermanentName
  googlePlaceIdPermanent
  statePermanent
  streetAddressPermanent
  streetNumberPermanent
  zipcodePermanent
  nurseProfile {
    id
    profileCompletion {
      id
      steps {
        permanentAddress {
          label
          message
          status
        }
      }
    }
  }
}`) as unknown as TypedDocumentString<PermanentAddressPanelQuery, PermanentAddressPanelQueryVariables>;
export const BackgroundQuestionsUpsertDocument = new TypedDocumentString(`
    mutation BackgroundQuestionsUpsert($input: [BackgroundQuestionInput!]!) {
  backgroundQuestionsUpsert(input: $input) {
    user {
      id
      ...BackgroundInfoUser
    }
  }
}
    fragment BackgroundInfoUser on User {
  id
  nurseProfile {
    id
    state
    backgroundComplete
    backgroundQuestions {
      ...BackgroundInfoNurseBackgroundQuestion
    }
    applicationReadiness {
      results {
        background {
          status
        }
      }
    }
    profileCompletion {
      id
      steps {
        backgroundQuestions {
          message
          label
          status
        }
      }
    }
  }
}
fragment BackgroundInfoNurseBackgroundQuestion on NurseBackgroundQuestion {
  id
  answer
  date
  explanation
  licenseAffected
  open
  questionType
}`) as unknown as TypedDocumentString<BackgroundQuestionsUpsertMutation, BackgroundQuestionsUpsertMutationVariables>;
export const BackgroundInfoUserPanelDocument = new TypedDocumentString(`
    query BackgroundInfoUserPanel {
  viewer {
    ... on User {
      ...BackgroundInfoUser
    }
  }
}
    fragment BackgroundInfoUser on User {
  id
  nurseProfile {
    id
    state
    backgroundComplete
    backgroundQuestions {
      ...BackgroundInfoNurseBackgroundQuestion
    }
    applicationReadiness {
      results {
        background {
          status
        }
      }
    }
    profileCompletion {
      id
      steps {
        backgroundQuestions {
          message
          label
          status
        }
      }
    }
  }
}
fragment BackgroundInfoNurseBackgroundQuestion on NurseBackgroundQuestion {
  id
  answer
  date
  explanation
  licenseAffected
  open
  questionType
}`) as unknown as TypedDocumentString<BackgroundInfoUserPanelQuery, BackgroundInfoUserPanelQueryVariables>;
export const CeuCertsByTimeAndGoalTypeDocument = new TypedDocumentString(`
    query CeuCertsByTimeAndGoalType($timePeriod: String, $goalType: String, $state: String, $first: Int, $last: Int, $after: String, $before: String, $sortDirection: String) {
  ceuCertsByTimeAndGoalType(
    timePeriod: $timePeriod
    goalType: $goalType
    state: $state
    first: $first
    last: $last
    after: $after
    before: $before
    sortDirection: $sortDirection
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasPreviousPage
      hasNextPage
    }
    edges {
      cursor
      node {
        id
        ...CeuCertificatesListItemCeuCertificate
      }
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment CeuCertificatesListItemCeuCertificate on CeuCertificate {
  id
  name
  contactHours
  ceuCertificateType
  completionDate
  providerNumber
  files {
    ...FileMetadata
  }
}`) as unknown as TypedDocumentString<CeuCertsByTimeAndGoalTypeQuery, CeuCertsByTimeAndGoalTypeQueryVariables>;
export const CeuCertificatesForDateDocument = new TypedDocumentString(`
    query CeuCertificatesForDate($startDate: ISO8601Date!, $endDate: ISO8601Date!) {
  nurseProfile {
    id
    ceuCertificatesForDate(startDate: $startDate, endDate: $endDate) {
      id
      name
      contactHours
    }
  }
}
    `) as unknown as TypedDocumentString<CeuCertificatesForDateQuery, CeuCertificatesForDateQueryVariables>;
export const CeuStateRequirementsDocument = new TypedDocumentString(`
    query CeuStateRequirements {
  ceuStateRequirements {
    id
    state
    requirementQuantity
    requirementDescription
    requiredContactHours
    durationDays
    stateBonUrl
    notes
  }
}
    `) as unknown as TypedDocumentString<CeuStateRequirementsQuery, CeuStateRequirementsQueryVariables>;
export const CreateIdentificationDocumentDocument = new TypedDocumentString(`
    mutation CreateIdentificationDocument($input: CreateIdentificationDocumentInput!, $fileUuids: [ID]) {
  createIdentificationDocument(input: $input, fileUuids: $fileUuids) {
    nurseProfile {
      id
      ...BackgroundAndIdDocumentTableNurseProfile
    }
    errors {
      errors
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment BackgroundAndIdDocumentTableNurseProfile on NurseProfile {
  id
  idDocs {
    id
    ...BackgroundAndIdDocumentTableIdDocument
  }
}
fragment BackgroundAndIdDocumentTableIdDocument on Document {
  id
  title
  docType
  isExpirable
  isExpired
  isExpiringSoon
  expiresOn
  files {
    ...FileMetadata
  }
  ...BackgroundAndIdPanelDocument
}
fragment BackgroundAndIdPanelDocument on Document {
  id
  title
  docType
  docSubtype
  expiresOn
  expirationType
  files {
    ...FileMetadata
  }
  stateCode
}`) as unknown as TypedDocumentString<CreateIdentificationDocumentMutation, CreateIdentificationDocumentMutationVariables>;
export const UpdateIdentificationDocumentDocument = new TypedDocumentString(`
    mutation UpdateIdentificationDocument($input: UpdateIdentificationDocumentInput!, $documentId: ID!, $fileUuids: [ID]) {
  updateIdentificationDocument(
    input: $input
    documentId: $documentId
    fileUuids: $fileUuids
  ) {
    nurseProfile {
      id
      ...BackgroundAndIdDocumentTableNurseProfile
    }
    errors {
      errors
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment BackgroundAndIdDocumentTableNurseProfile on NurseProfile {
  id
  idDocs {
    id
    ...BackgroundAndIdDocumentTableIdDocument
  }
}
fragment BackgroundAndIdDocumentTableIdDocument on Document {
  id
  title
  docType
  isExpirable
  isExpired
  isExpiringSoon
  expiresOn
  files {
    ...FileMetadata
  }
  ...BackgroundAndIdPanelDocument
}
fragment BackgroundAndIdPanelDocument on Document {
  id
  title
  docType
  docSubtype
  expiresOn
  expirationType
  files {
    ...FileMetadata
  }
  stateCode
}`) as unknown as TypedDocumentString<UpdateIdentificationDocumentMutation, UpdateIdentificationDocumentMutationVariables>;
export const DeleteIdentificationDocumentDocument = new TypedDocumentString(`
    mutation DeleteIdentificationDocument($id: ID!) {
  deleteIdentificationDocument(id: $id) {
    nurseProfile {
      id
      ...BackgroundAndIdDocumentTableNurseProfile
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment BackgroundAndIdDocumentTableNurseProfile on NurseProfile {
  id
  idDocs {
    id
    ...BackgroundAndIdDocumentTableIdDocument
  }
}
fragment BackgroundAndIdDocumentTableIdDocument on Document {
  id
  title
  docType
  isExpirable
  isExpired
  isExpiringSoon
  expiresOn
  files {
    ...FileMetadata
  }
  ...BackgroundAndIdPanelDocument
}
fragment BackgroundAndIdPanelDocument on Document {
  id
  title
  docType
  docSubtype
  expiresOn
  expirationType
  files {
    ...FileMetadata
  }
  stateCode
}`) as unknown as TypedDocumentString<DeleteIdentificationDocumentMutation, DeleteIdentificationDocumentMutationVariables>;
export const BackgroundAndIdTableDocument = new TypedDocumentString(`
    query BackgroundAndIdTable {
  nurseProfile {
    id
    ...BackgroundAndIdDocumentTableNurseProfile
  }
  documentTemplates {
    id
    ...BackgroundAndIdDocumentTableDocumentTemplate
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment BackgroundAndIdDocumentTableNurseProfile on NurseProfile {
  id
  idDocs {
    id
    ...BackgroundAndIdDocumentTableIdDocument
  }
}
fragment BackgroundAndIdDocumentTableDocumentTemplate on DocumentTemplate {
  id
  key
  name
  types
  expirationType
  ...BackgroundAndIdPanelDocumentTemplate
}
fragment BackgroundAndIdDocumentTableIdDocument on Document {
  id
  title
  docType
  isExpirable
  isExpired
  isExpiringSoon
  expiresOn
  files {
    ...FileMetadata
  }
  ...BackgroundAndIdPanelDocument
}
fragment BackgroundAndIdPanelDocument on Document {
  id
  title
  docType
  docSubtype
  expiresOn
  expirationType
  files {
    ...FileMetadata
  }
  stateCode
}
fragment BackgroundAndIdPanelDocumentTemplate on DocumentTemplate {
  id
  key
  name
  types
  expirationType
}`) as unknown as TypedDocumentString<BackgroundAndIdTableQuery, BackgroundAndIdTableQueryVariables>;
export const CertificationsTableDocument = new TypedDocumentString(`
    query CertificationsTable {
  nurseProfile {
    id
    nurseCertifications {
      id
      ...CertificationsTableRowNurseCertification
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment CertificationsTableRowNurseCertification on NurseCertification {
  id
  issuingBody
  isExpiringSoon
  isExpired
  expiresOn
  files {
    ...FileMetadata
  }
  certification {
    id
    name
  }
}`) as unknown as TypedDocumentString<CertificationsTableQuery, CertificationsTableQueryVariables>;
export const HealthDocumentsTableDocument = new TypedDocumentString(`
    query HealthDocumentsTable {
  viewer {
    ... on User {
      id
      nurseProfile {
        id
        nurseHealthDocs {
          id
          ...HealthDocumentsTableHealthDoc
        }
      }
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment HealthDocumentsTableHealthDoc on NurseHealthDoc {
  id
  isExpired
  isExpiringSoon
  category
  completedOn
  files {
    ...FileMetadata
  }
  healthDoc {
    id
    name
    categories
  }
}`) as unknown as TypedDocumentString<HealthDocumentsTableQuery, HealthDocumentsTableQueryVariables>;
export const LicensesTableDocument = new TypedDocumentString(`
    query LicensesTable {
  viewer {
    ... on User {
      id
      nurseProfile {
        id
        ssnLast4
        birthday
        licenses {
          id
          ...LicensesTableItemLicense
        }
        nurseLicenseVerifications {
          id
          ...LicensesTableVerificationItemLicenseVerification
        }
        role {
          id
          key
          name
          type
        }
      }
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment LicensesTableItemLicense on License {
  id
  number
  state
  licensureCompact
  isExpiringSoon
  isExpired
  expiresOn
  friendlyLicenseType
  files {
    ...FileMetadata
  }
}
fragment LicensesTableVerificationItemLicenseVerification on NurseLicenseVerification {
  id
  state
  states
  verificationType
  expiresOn
  isExpired
  isExpiringSoon
  dateOfDownload
  files {
    ...FileMetadata
  }
}`) as unknown as TypedDocumentString<LicensesTableQuery, LicensesTableQueryVariables>;
export const MiscDocumentsTableDocument = new TypedDocumentString(`
    query MiscDocumentsTable {
  nurseProfile {
    id
    documents {
      ...MiscDocumentsTableDocument
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment MiscDocumentsTableDocument on Document {
  id
  title
  docType
  expiresOn
  isExpired
  isExpiringSoon
  files {
    ...FileMetadata
  }
}`) as unknown as TypedDocumentString<MiscDocumentsTableQuery, MiscDocumentsTableQueryVariables>;
export const NurseAssessmentsTableDocument = new TypedDocumentString(`
    query NurseAssessmentsTable {
  nurseProfile {
    id
    nurseAssessments {
      ...NurseAssessmentsTableNurseAssessment
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment NurseAssessmentsTableNurseAssessment on NurseAssessment {
  id
  completedOn
  expiresOn
  isArchived
  isExpired
  isExpiringSoon
  score
  assessment {
    ...AssessmentItem
  }
  files {
    ...FileMetadata
  }
  assessmentRequest {
    id
    score
  }
}
fragment AssessmentItem on Assessment {
  id
  category
  issuingBody
  name
}`) as unknown as TypedDocumentString<NurseAssessmentsTableQuery, NurseAssessmentsTableQueryVariables>;
export const CreateLocationSharedLinkDocument = new TypedDocumentString(`
    mutation CreateLocationSharedLink($input: CreateLocationSharedLinkInput!) {
  createLocationSharedLink(input: $input) {
    sharedLink {
      id
      shortUrl
      longUrl
    }
  }
}
    `) as unknown as TypedDocumentString<CreateLocationSharedLinkMutation, CreateLocationSharedLinkMutationVariables>;
export const CreateSalarySearchHistoryEntryDocument = new TypedDocumentString(`
    mutation CreateSalarySearchHistoryEntry($nurseProfileId: ID!, $searchForm: String!, $input: CreateSalarySearchHistoryEntryInput!) {
  createSalarySearchHistoryEntry(
    nurseProfileId: $nurseProfileId
    searchForm: $searchForm
    input: $input
  ) {
    nurseProfile {
      id
      searchHistory(searchForm: $searchForm) {
        id
        searchForm
        searchHistoryEntries {
          id
          searchParams
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CreateSalarySearchHistoryEntryMutation, CreateSalarySearchHistoryEntryMutationVariables>;
export const UpdateSearchHistoryEntryDocument = new TypedDocumentString(`
    mutation UpdateSearchHistoryEntry($id: ID!, $input: UpdateSearchHistoryEntryInput!, $searchForm: String!) {
  updateSearchHistoryEntry(id: $id, input: $input) {
    nurseProfile {
      id
      searchHistory(searchForm: $searchForm) {
        id
        searchForm
        searchHistoryEntries {
          id
          searchParams
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateSearchHistoryEntryMutation, UpdateSearchHistoryEntryMutationVariables>;
export const DeleteSearchHistoryEntryDocument = new TypedDocumentString(`
    mutation DeleteSearchHistoryEntry($id: ID!, $searchForm: String!) {
  deleteSearchHistoryEntry(id: $id) {
    nurseProfile {
      id
      searchHistory(searchForm: $searchForm) {
        id
        searchForm
        searchHistoryEntries {
          id
          searchParams
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DeleteSearchHistoryEntryMutation, DeleteSearchHistoryEntryMutationVariables>;
export const FacilitySurveyResponseForUserDocument = new TypedDocumentString(`
    query FacilitySurveyResponseForUser($facilitySlug: String!) {
  facility(slug: $facilitySlug) {
    id
    surveyForUser {
      id
      completedAt
    }
  }
}
    `) as unknown as TypedDocumentString<FacilitySurveyResponseForUserQuery, FacilitySurveyResponseForUserQueryVariables>;
export const IntentFormModalUpdateStaleIntentDocument = new TypedDocumentString(`
    mutation IntentFormModalUpdateStaleIntent($input: UpdateStaleIntentInput!) {
  updateStaleIntent(input: $input) {
    nursePreferences {
      id
      ...IntentFormModalNursePreferences
    }
  }
}
    fragment IntentFormModalNursePreferences on NursePreferences {
  id
  startPref
  earliestStartDate
}`) as unknown as TypedDocumentString<IntentFormModalUpdateStaleIntentMutation, IntentFormModalUpdateStaleIntentMutationVariables>;
export const IntentFormDataDocument = new TypedDocumentString(`
    query IntentFormData {
  nurseProfile {
    ...NurseProfileIntent
  }
}
    fragment NurseProfileIntent on NurseProfile {
  id
  staleIntent
  activationRequest {
    id
    earliestStartDateAt
  }
  nursePreferences {
    id
    startPref
    broadPrefLocations
    locations {
      id
      locationString
    }
  }
}`) as unknown as TypedDocumentString<IntentFormDataQuery, IntentFormDataQueryVariables>;
export const ActivationJobAlertModalDocument = new TypedDocumentString(`
    query ActivationJobAlertModal {
  jobAlertsPendingView {
    ...JobAlert
  }
  nurseProfile {
    ...MatchCriteriaNurseProfile
  }
}
    fragment MatchCriteriaNurseProfile on NurseProfile {
  id
  isActivated
  activeClinicalSpecialties {
    id
    displayName
    slug
  }
  percentComplete
  positionSpecialties {
    id
    displayName
    slug
  }
  profileCompletion {
    id
    meta {
      id
      percentCompleted
    }
  }
  role {
    id
    key
    name
    type
  }
  state
  nursePreferences {
    id
    ...MatchCriteriaNursePreferences
  }
}
fragment MatchCriteriaNursePreferences on NursePreferences {
  id
  broadPrefLocations
  careSettingOther
  careSettingPrefs
  contractLengths
  earliestStartDate
  jobSortColumn
  jobSortOrder
  jobTypes
  locations {
    id
    locationString
  }
  shiftLengths
  shiftPrefs
  startPref
  technologies
}
fragment JobAlert on JobAlert {
  id
  broadPrefLocations
  clinicalSpecialties {
    id
    displayName
    slug
  }
  contractLengths
  locationStrings
  shiftLengths
  shiftPrefs
  smsEnabled
  specialties
}`) as unknown as TypedDocumentString<ActivationJobAlertModalQuery, ActivationJobAlertModalQueryVariables>;
export const JobDetailWeatherForecastDocument = new TypedDocumentString(`
    query JobDetailWeatherForecast($id: ID!) {
  adJob(id: $id) {
    id
    ...JobLocationBlockJob
  }
}
    fragment JobLocationBlockJob on Job {
  id
  location {
    id
    walkscore {
      bikeDescription
      bikeScore
      transitDescription
      transitScore
      walkDescription
      walkScore
    }
    weatherForecast {
      icon
      temperature
      temperatureHigh
      temperatureLow
    }
  }
}`) as unknown as TypedDocumentString<JobDetailWeatherForecastQuery, JobDetailWeatherForecastQueryVariables>;
export const JobOffersSignContractDocument = new TypedDocumentString(`
    query JobOffersSignContract($filter: JobOffersFilter!) {
  nurseProfile {
    id
    jobOffers(filter: $filter) {
      ...JobOfferSignContract
    }
  }
}
    fragment ContractSignUrl on Contract {
  ...Contract
  docusignSignUrl
}
fragment JobOfferSignContract on JobOffer {
  id
  contracts {
    ...ContractSignUrl
  }
}
fragment Contract on Contract {
  id
  hoursPerShift
  shiftsPerWeek
  cancellationPolicy
  contractNotes
  contractStatus
  contractStartDate
  contractEndDate
  contractType
  shiftType
  currentGrossPayWeek
  baseRate
  lengthInWeeks
  job {
    id
    startDate
    endDate
    title
    facilityName
    clinicalUnit {
      id
      displayName
    }
    lengthInWeeks
    hoursPerShift
    shiftsPerWeek
    shiftType
    emr {
      id
      name
    }
  }
  jobPlacement {
    id
    nurseProfile {
      id
      name
      user {
        id
        email
      }
    }
  }
  timeOffs {
    id
    startDate
    endDate
    approvalStatus
  }
  jobApplication {
    id
    paymentDetails {
      id
      nonTaxableStipendWeekly
      taxableWageRateWeekly
      grossPayWeekly
    }
  }
  paymentDetails {
    id
    nonTaxableStipendWeekly
    taxableWageRateWeekly
    grossPayWeekly
  }
}`) as unknown as TypedDocumentString<JobOffersSignContractQuery, JobOffersSignContractQueryVariables>;
export const MatchCardExpressInterestDocument = new TypedDocumentString(`
    mutation MatchCardExpressInterest($id: String!, $source: String) {
  expressInterest(job_uuid: $id, source: $source) {
    id
    esMatch {
      id
      userState
    }
  }
}
    `) as unknown as TypedDocumentString<MatchCardExpressInterestMutation, MatchCardExpressInterestMutationVariables>;
export const MatchCardRemoveInterestDocument = new TypedDocumentString(`
    mutation MatchCardRemoveInterest($id: String!, $source: String) {
  removeInterest(job_uuid: $id, source: $source) {
    id
    esMatch {
      id
      userState
    }
  }
}
    `) as unknown as TypedDocumentString<MatchCardRemoveInterestMutation, MatchCardRemoveInterestMutationVariables>;
export const MatchCardUnhideEsMatchDocument = new TypedDocumentString(`
    mutation MatchCardUnhideEsMatch($id: String!) {
  unhideEsMatch(uuid: $id) {
    id
    userState
  }
}
    `) as unknown as TypedDocumentString<MatchCardUnhideEsMatchMutation, MatchCardUnhideEsMatchMutationVariables>;
export const MatchCriteriaOnUpdateDocument = new TypedDocumentString(`
    mutation MatchCriteriaOnUpdate($id: ID!, $input: UpdateNursePreferencesInput!, $specialtySlugs: [String!]!) {
  updateNursePreferences(id: $id, input: $input) {
    nursePreferences {
      id
      ...MatchCriteriaNursePreferences
    }
  }
  nurseProfileClinicalExperiencesUpdate(specialtySlugs: $specialtySlugs) {
    ...MatchCriteriaNurseProfile
  }
}
    fragment MatchCriteriaNurseProfile on NurseProfile {
  id
  isActivated
  activeClinicalSpecialties {
    id
    displayName
    slug
  }
  percentComplete
  positionSpecialties {
    id
    displayName
    slug
  }
  profileCompletion {
    id
    meta {
      id
      percentCompleted
    }
  }
  role {
    id
    key
    name
    type
  }
  state
  nursePreferences {
    id
    ...MatchCriteriaNursePreferences
  }
}
fragment MatchCriteriaNursePreferences on NursePreferences {
  id
  broadPrefLocations
  careSettingOther
  careSettingPrefs
  contractLengths
  earliestStartDate
  jobSortColumn
  jobSortOrder
  jobTypes
  locations {
    id
    locationString
  }
  shiftLengths
  shiftPrefs
  startPref
  technologies
}`) as unknown as TypedDocumentString<MatchCriteriaOnUpdateMutation, MatchCriteriaOnUpdateMutationVariables>;
export const MatchCriteriaResetDocument = new TypedDocumentString(`
    mutation MatchCriteriaReset($id: ID!, $input: UpdateNursePreferencesInput!) {
  updateNursePreferences(id: $id, input: $input) {
    nurseProfile {
      id
      nursePreferences {
        id
        ...MatchCriteriaNursePreferences
      }
    }
  }
}
    fragment MatchCriteriaNursePreferences on NursePreferences {
  id
  broadPrefLocations
  careSettingOther
  careSettingPrefs
  contractLengths
  earliestStartDate
  jobSortColumn
  jobSortOrder
  jobTypes
  locations {
    id
    locationString
  }
  shiftLengths
  shiftPrefs
  startPref
  technologies
}`) as unknown as TypedDocumentString<MatchCriteriaResetMutation, MatchCriteriaResetMutationVariables>;
export const MarkStaleProfileNotificationDismissedDocument = new TypedDocumentString(`
    mutation MarkStaleProfileNotificationDismissed {
  userProperties {
    markStaleProfileNotificationDismissed {
      viewer {
        ... on User {
          ...MatchApplyButtonUser
        }
      }
    }
  }
}
    fragment MatchApplyButtonUser on User {
  id
  ...RequestInterviewButtonUser
}
fragment RequestInterviewButtonUser on User {
  id
  nurseProfile {
    ...RequestInterviewButtonNurseProfile
  }
  ...JobApplicationRequirementsUser
}
fragment RequestInterviewButtonNurseProfile on NurseProfile {
  id
  isActivated
  canApplyJobs
  profileCompletion {
    id
    meta {
      id
      percentCompleted
    }
  }
  state
}
fragment JobApplicationRequirementsUser on User {
  id
  email
  firstName
  lastName
  nurseProfile {
    ...JobApplicationRequirementsNurseProfile
  }
}
fragment JobApplicationRequirementsNurseAdvocate on SalesforceUser {
  id
  email
  fullName
}
fragment JobApplicationRequirementsNurseProfile on NurseProfile {
  id
  state
  percentComplete
  profileCompletion {
    id
  }
  nurseAdvocate {
    ...JobApplicationRequirementsNurseAdvocate
  }
}`) as unknown as TypedDocumentString<MarkStaleProfileNotificationDismissedMutation, MarkStaleProfileNotificationDismissedMutationVariables>;
export const MatchDetailsViewJobDocument = new TypedDocumentString(`
    mutation MatchDetailsViewJob($id: String!) {
  viewJob(job_uuid: $id) {
    id
  }
}
    `) as unknown as TypedDocumentString<MatchDetailsViewJobMutation, MatchDetailsViewJobMutationVariables>;
export const UpdateClickIdsDocument = new TypedDocumentString(`
    mutation UpdateClickIds($gclid: String, $wbraid: String, $gbraid: String, $utmSource: String, $utmTerm: String) {
  updateClickIds(
    gclid: $gclid
    wbraid: $wbraid
    gbraid: $gbraid
    utmSource: $utmSource
    utmTerm: $utmTerm
  ) {
    ok
  }
}
    `) as unknown as TypedDocumentString<UpdateClickIdsMutation, UpdateClickIdsMutationVariables>;
export const NavigationDocument = new TypedDocumentString(`
    query Navigation {
  systemMessages(limit: 1) {
    id
    body
  }
  saasquatchMainPageWidget {
    titleText
  }
  viewer {
    ... on User {
      id
      uuid
      intercomUserHash
      nurseProfile {
        id
        canViewJobs
        hasBeenPlaced
        uuid
        isOnboarding
        state
        jobApplicationsSummary {
          id
          actionRequired {
            id
          }
          offer {
            id
          }
        }
      }
      ...NavigationUser
      ...NavigationProfileDropdownUser
    }
  }
  profileCompletionSummary {
    ...ProfileCompletionSummary
  }
  badgesItemsCount {
    id
    credentialsCount
    favoritesCount
    matchesCount
    completionItemsCount
  }
}
    fragment ProfileCompletionSummary on ProfileCompletionSummary {
  id
  completedAt
  meta {
    id
    completeCount
    expiredCount
    expiringCount
    incompleteCount
    pendingCount
    percentCompleted
  }
  steps {
    estimatedTimeInMinutes
    key
    title
    subtitle
    messages
    sectionName
    status
    hasExpiringItems
    hasExpiredItems
    hasInvalidItems
  }
}
fragment UserFullName on User {
  firstName
  preferredName
  middleName
  lastName
}
fragment NavigationProfileDropdownUser on User {
  id
  firstName
  preferredName
  middleName
  lastName
  profilePic
  nurseProfile {
    id
    profileCompletion {
      id
      ...ProfileCompletionWidgetProfileCompletionMeta
    }
    role {
      id
      name
    }
  }
}
fragment ProfileCompletionWidgetProfileCompletionMeta on NurseProfileCompletion {
  id
  meta {
    id
    completeCount
    expiredCount
    expiringCount
    incompleteCount
    pendingCount
    percentCompleted
  }
}
fragment NavigationUser on User {
  id
  ...UserFullName
  profilePic
  nurseProfile {
    id
    profileCompletion {
      id
      meta {
        id
        incompleteCount
        expiredCount
        percentCompleted
        pendingCount
      }
    }
    role {
      id
      name
    }
  }
}`) as unknown as TypedDocumentString<NavigationQuery, NavigationQueryVariables>;
export const UpdateCurrentAddressDocument = new TypedDocumentString(`
    mutation UpdateCurrentAddress($id: ID!, $input: NestedUpdateUserInput!) {
  nestedUpdateUser(id: $id, input: $input) {
    user {
      id
      ...CurrentAddressUser
    }
  }
}
    fragment CurrentAddressUser on User {
  id
  city
  state
  streetAddress
  zipcode
}`) as unknown as TypedDocumentString<UpdateCurrentAddressMutation, UpdateCurrentAddressMutationVariables>;
export const AppointmentItemUpdateTodoCandidateNotesDocument = new TypedDocumentString(`
    mutation AppointmentItemUpdateTodoCandidateNotes($uuid: String!, $candidateNotes: String!) {
  updateTodoCandidateNotes(uuid: $uuid, text_blob: $candidateNotes) {
    id
    actionLinks {
      id
      url
      title
    }
    description
    itemState
    itemType
    uuid
    verificationNotes
    candidateNotes
  }
}
    `) as unknown as TypedDocumentString<AppointmentItemUpdateTodoCandidateNotesMutation, AppointmentItemUpdateTodoCandidateNotesMutationVariables>;
export const ConfirmationItemConfirmTodoDoneDocument = new TypedDocumentString(`
    mutation ConfirmationItemConfirmTodoDone($uuid: String!) {
  confirmTodoDone(uuid: $uuid) {
    id
    actionLinks {
      id
      url
      title
    }
    description
    itemState
    itemType
    uuid
    verificationNotes
  }
}
    `) as unknown as TypedDocumentString<ConfirmationItemConfirmTodoDoneMutation, ConfirmationItemConfirmTodoDoneMutationVariables>;
export const DocumentItemUpdateTodoListItemDocumentTargetDocument = new TypedDocumentString(`
    mutation DocumentItemUpdateTodoListItemDocumentTarget($id: ID!, $input: UpdateTodoListItemDocumentTargetInput!, $fileUuids: [ID!]) {
  updateTodoListItemDocumentTarget(id: $id, input: $input, fileUuids: $fileUuids) {
    todoListItem {
      ...DocumentItem
    }
    errors {
      errors
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment BaseItem on TodoListItem {
  id
  name
  description
  verificationNotes
  rejectionReason
  itemState
  schedulable
  needsToBeScheduled
  karmaCheckCaseServiceOrder {
    id
    isPending
  }
  itemType
  actionLinks {
    id
    title
    url
  }
}
fragment DocumentItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingDocumentPanelTodoListItem
}
fragment OnboardingDocumentPanelDocument on Document {
  id
  uuid
  title
  isExpirable
  isExpiringSoon
  isExpired
  expirationType
  expiresOn
  completedOn
  docType
  docSubtype
  trackCompletionDate
  files {
    ...FileMetadata
  }
  stateCode
}
fragment OnboardingDocumentPanelTodoListItem on TodoListItem {
  id
  name
  description
  documentTarget {
    ...OnboardingDocumentPanelDocument
  }
}`) as unknown as TypedDocumentString<DocumentItemUpdateTodoListItemDocumentTargetMutation, DocumentItemUpdateTodoListItemDocumentTargetMutationVariables>;
export const UpdateTodoListItemNurseAssessmentTargetDocument = new TypedDocumentString(`
    mutation UpdateTodoListItemNurseAssessmentTarget($id: ID!, $input: UpdateTodoListItemNurseAssessmentTargetInput!, $fileUuids: [ID]) {
  updateTodoListItemNurseAssessmentTarget(
    id: $id
    input: $input
    fileUuids: $fileUuids
  ) {
    todoListItem {
      ...NurseAssessmentItemTodoListItem
    }
    errors {
      errors
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment BaseItem on TodoListItem {
  id
  name
  description
  verificationNotes
  rejectionReason
  itemState
  schedulable
  needsToBeScheduled
  karmaCheckCaseServiceOrder {
    id
    isPending
  }
  itemType
  actionLinks {
    id
    title
    url
  }
}
fragment NurseAssessmentItemTodoListItem on TodoListItem {
  id
  itemState
  nurseAssessmentTarget {
    id
    assessment {
      id
      requestable
    }
  }
  ...BaseItem
  ...OnboardingNurseAssessmentPanelTodoListItem
  ...OnboardingRequestAssessmentPanelTodoListItem
}
fragment OnboardingNurseAssessmentPanelAssessment on Assessment {
  id
  uuid
  category
  issuingBody
  name
  requestable
}
fragment OnboardingNurseAssessmentPanelTodoListItem on TodoListItem {
  id
  name
  description
  itemState
  nurseAssessmentTarget {
    id
    uuid
    completedOn
    score
    assessment {
      ...OnboardingNurseAssessmentPanelAssessment
    }
    files {
      ...FileMetadata
    }
  }
}
fragment OnboardingRequestAssessmentPanelTodoListItem on TodoListItem {
  id
  nurseAssessmentTarget {
    id
    assessment {
      uuid
      name
    }
  }
}`) as unknown as TypedDocumentString<UpdateTodoListItemNurseAssessmentTargetMutation, UpdateTodoListItemNurseAssessmentTargetMutationVariables>;
export const AssignReliasAssessmentDocument = new TypedDocumentString(`
    mutation AssignReliasAssessment($assessmentIds: [String]!) {
  assignReliasAssessments(assessment_uuid_list: $assessmentIds) {
    nurseAssessments {
      id
      ...NurseAssessmentItemNurseAssessment
    }
  }
}
    fragment NurseAssessmentItemNurseAssessment on NurseAssessment {
  id
  name
  category
  requestedOn
  completedOn
  assessment {
    id
    issuingBody
  }
}`) as unknown as TypedDocumentString<AssignReliasAssessmentMutation, AssignReliasAssessmentMutationVariables>;
export const UpdateOnboardingItemDocument = new TypedDocumentString(`
    mutation UpdateOnboardingItem($id: ID!, $targetId: ID!) {
  updateOnboardingItemTarget(id: $id, targetId: $targetId) {
    todoListItem {
      id
      itemState
      target {
        ... on NurseAssessment {
          id
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateOnboardingItemMutation, UpdateOnboardingItemMutationVariables>;
export const NurseCertificationItemUpdateTodoListItemHealthDocTargetDocument = new TypedDocumentString(`
    mutation NurseCertificationItemUpdateTodoListItemHealthDocTarget($id: ID!, $input: UpdateTodoListItemNurseCertificationTargetInput!, $certificationInput: UpdateTodoListItemNurseCertificationInput!, $fileUuids: [ID!]) {
  updateTodoListItemNurseCertificationTarget(
    id: $id
    input: $input
    certificationInput: $certificationInput
    fileUuids: $fileUuids
  ) {
    todoListItem {
      ...NurseCertificationItem
    }
    errors {
      errors
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment BaseItem on TodoListItem {
  id
  name
  description
  verificationNotes
  rejectionReason
  itemState
  schedulable
  needsToBeScheduled
  karmaCheckCaseServiceOrder {
    id
    isPending
  }
  itemType
  actionLinks {
    id
    title
    url
  }
}
fragment NurseCertificationItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingCertificationPanelTodoListItem
}
fragment OnboardingCertificationPanelTodoListItem on TodoListItem {
  id
  name
  description
  nurseCertificationTarget {
    id
    certificationUuid
    expiresOn
    completedOn
    isExpired
    isExpiringSoon
    issuingBody
    name
    uuid
    useCompletionDate
    files {
      ...FileMetadata
    }
  }
}`) as unknown as TypedDocumentString<NurseCertificationItemUpdateTodoListItemHealthDocTargetMutation, NurseCertificationItemUpdateTodoListItemHealthDocTargetMutationVariables>;
export const PlaintextItemUpdateTodoCandidateNotesDocument = new TypedDocumentString(`
    mutation PlaintextItemUpdateTodoCandidateNotes($uuid: String!, $candidateNotes: String!) {
  updateTodoCandidateNotes(uuid: $uuid, text_blob: $candidateNotes) {
    id
    actionLinks {
      id
      url
      title
    }
    description
    itemState
    itemType
    uuid
    verificationNotes
    candidateNotes
  }
}
    `) as unknown as TypedDocumentString<PlaintextItemUpdateTodoCandidateNotesMutation, PlaintextItemUpdateTodoCandidateNotesMutationVariables>;
export const OnboardingListOwnerInfoDocument = new TypedDocumentString(`
    query OnboardingListOwnerInfo($todoListId: String!) {
  getOnboardingListOwnerInfo(todoListId: $todoListId) {
    iconUrl
    name
  }
}
    `) as unknown as TypedDocumentString<OnboardingListOwnerInfoQuery, OnboardingListOwnerInfoQueryVariables>;
export const OnboardingListAttentionItemsDocument = new TypedDocumentString(`
    query OnboardingListAttentionItems($id: ID!) {
  getOnboardingListNeedsAttention(id: $id) {
    dueDate
    ...OnboardingListItemContainerTodoListItem
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment OnboardingListItemContainerTodoListItem on TodoListItem {
  id
  itemType
  ...BaseItem
  ...DocumentItem
  ...NurseCertificationItem
  ...NurseAssessmentItemTodoListItem
  ...NurseHealthDocItem
  ...PlaintextItem
  ...AppointmentItem
}
fragment AppointmentItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingAppointmentPanelTodoListItem
}
fragment BaseItem on TodoListItem {
  id
  name
  description
  verificationNotes
  rejectionReason
  itemState
  schedulable
  needsToBeScheduled
  karmaCheckCaseServiceOrder {
    id
    isPending
  }
  itemType
  actionLinks {
    id
    title
    url
  }
}
fragment DocumentItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingDocumentPanelTodoListItem
}
fragment NurseAssessmentItemTodoListItem on TodoListItem {
  id
  itemState
  nurseAssessmentTarget {
    id
    assessment {
      id
      requestable
    }
  }
  ...BaseItem
  ...OnboardingNurseAssessmentPanelTodoListItem
  ...OnboardingRequestAssessmentPanelTodoListItem
}
fragment NurseCertificationItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingCertificationPanelTodoListItem
}
fragment NurseHealthDocItem on TodoListItem {
  id
  itemState
  nurseHealthDocTarget {
    id
  }
  ...BaseItem
}
fragment PlaintextItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingPlainTextPanelTodoListItem
}
fragment OnboardingAppointmentPanelTodoListItem on TodoListItem {
  id
  name
  description
  candidateNotes
}
fragment OnboardingCertificationPanelTodoListItem on TodoListItem {
  id
  name
  description
  nurseCertificationTarget {
    id
    certificationUuid
    expiresOn
    completedOn
    isExpired
    isExpiringSoon
    issuingBody
    name
    uuid
    useCompletionDate
    files {
      ...FileMetadata
    }
  }
}
fragment OnboardingDocumentPanelDocument on Document {
  id
  uuid
  title
  isExpirable
  isExpiringSoon
  isExpired
  expirationType
  expiresOn
  completedOn
  docType
  docSubtype
  trackCompletionDate
  files {
    ...FileMetadata
  }
  stateCode
}
fragment OnboardingDocumentPanelTodoListItem on TodoListItem {
  id
  name
  description
  documentTarget {
    ...OnboardingDocumentPanelDocument
  }
}
fragment OnboardingNurseAssessmentPanelAssessment on Assessment {
  id
  uuid
  category
  issuingBody
  name
  requestable
}
fragment OnboardingNurseAssessmentPanelTodoListItem on TodoListItem {
  id
  name
  description
  itemState
  nurseAssessmentTarget {
    id
    uuid
    completedOn
    score
    assessment {
      ...OnboardingNurseAssessmentPanelAssessment
    }
    files {
      ...FileMetadata
    }
  }
}
fragment OnboardingPlainTextPanelTodoListItem on TodoListItem {
  id
  uuid
  itemType
  itemState
  candidateNotes
  description
  name
}
fragment OnboardingRequestAssessmentPanelTodoListItem on TodoListItem {
  id
  nurseAssessmentTarget {
    id
    assessment {
      uuid
      name
    }
  }
}`) as unknown as TypedDocumentString<OnboardingListAttentionItemsQuery, OnboardingListAttentionItemsQueryVariables>;
export const OnboardingItemSampleImageDocument = new TypedDocumentString(`
    query OnboardingItemSampleImage($id: ID!) {
  onboardingItemSampleImage(id: $id)
}
    `) as unknown as TypedDocumentString<OnboardingItemSampleImageQuery, OnboardingItemSampleImageQueryVariables>;
export const CertificationsListPanelDocument = new TypedDocumentString(`
    query CertificationsListPanel {
  nurseProfile {
    id
    state
    nurseCertifications {
      id
      ...CertificationsListNurseCertification
    }
    role {
      id
      type
    }
  }
  profileCompletionSummary {
    id
    steps {
      key
      status
      messages
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment NurseCertificationForm on NurseCertification {
  id
  name
  expiresOn
  completedOn
  isExpired
  isExpiringSoon
  issuingBody
  useCompletionDate
  certification {
    id
    name
    issuingBody
    issuingBodies
    credential
  }
  files {
    ...FileMetadata
  }
}
fragment CertificationsListNurseCertification on NurseCertification {
  id
  name
  issuingBody
  expiresOn
  files {
    ...FileMetadata
  }
  ...NurseCertificationForm
}`) as unknown as TypedDocumentString<CertificationsListPanelQuery, CertificationsListPanelQueryVariables>;
export const CreateCeuCertificateDocument = new TypedDocumentString(`
    mutation CreateCeuCertificate($nurseProfileId: ID!, $input: CreateCeuCertificateInput!, $goalUuids: [ID!], $fileUuids: [ID]) {
  createCeuCertificate(
    input: $input
    nurseProfileId: $nurseProfileId
    fileUuids: $fileUuids
    goalUuids: $goalUuids
  ) {
    nurseProfile {
      ...CeuCertificatePanelNurseProfile
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment CeuCertificatePanelNurseProfile on NurseProfile {
  id
  ceuGoals {
    id
    completedContactHours
  }
  ceuCertificates {
    id
    name
    contactHours
    ceuCertificateType
    completionDate
    providerNumber
    files {
      ...FileMetadata
    }
    ceuGoals {
      id
    }
  }
}`) as unknown as TypedDocumentString<CreateCeuCertificateMutation, CreateCeuCertificateMutationVariables>;
export const DeleteCeuCertificateDocument = new TypedDocumentString(`
    mutation DeleteCeuCertificate($id: ID!) {
  deleteCeuCertificate(id: $id) {
    nurseProfile {
      ...CeuCertificatePanelNurseProfile
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment CeuCertificatePanelNurseProfile on NurseProfile {
  id
  ceuGoals {
    id
    completedContactHours
  }
  ceuCertificates {
    id
    name
    contactHours
    ceuCertificateType
    completionDate
    providerNumber
    files {
      ...FileMetadata
    }
    ceuGoals {
      id
    }
  }
}`) as unknown as TypedDocumentString<DeleteCeuCertificateMutation, DeleteCeuCertificateMutationVariables>;
export const UpdateCeuCertificateDocument = new TypedDocumentString(`
    mutation UpdateCeuCertificate($id: ID!, $fileUuids: [ID], $goalUuids: [ID!], $input: UpdateCeuCertificateInput!) {
  updateCeuCertificate(
    input: $input
    fileUuids: $fileUuids
    goalUuids: $goalUuids
    id: $id
  ) {
    nurseProfile {
      ...CeuCertificatePanelNurseProfile
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment CeuCertificatePanelNurseProfile on NurseProfile {
  id
  ceuGoals {
    id
    completedContactHours
  }
  ceuCertificates {
    id
    name
    contactHours
    ceuCertificateType
    completionDate
    providerNumber
    files {
      ...FileMetadata
    }
    ceuGoals {
      id
    }
  }
}`) as unknown as TypedDocumentString<UpdateCeuCertificateMutation, UpdateCeuCertificateMutationVariables>;
export const CeuGoalsForDateDocument = new TypedDocumentString(`
    query CeuGoalsForDate($date: ISO8601Date!) {
  nurseProfile {
    id
    ceuGoalsForDate(date: $date) {
      ...CeuCertificatePanelCeuGoal
    }
  }
}
    fragment CeuCertificatePanelCeuGoal on CeuGoal {
  id
  goalType
  requiredContactHours
  endDate
  ceuStateRequirement {
    id
    state
  }
  description
}`) as unknown as TypedDocumentString<CeuGoalsForDateQuery, CeuGoalsForDateQueryVariables>;
export const UpdateCeuCertificateContainerDocument = new TypedDocumentString(`
    query UpdateCeuCertificateContainer($id: ID!) {
  ceuCertificate(id: $id) {
    id
    name
    contactHours
    ceuCertificateType
    completionDate
    providerNumber
    files {
      ...FileMetadata
    }
    ceuGoals {
      id
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}`) as unknown as TypedDocumentString<UpdateCeuCertificateContainerQuery, UpdateCeuCertificateContainerQueryVariables>;
export const ChatHelpTopicsDocument = new TypedDocumentString(`
    query ChatHelpTopics {
  nurseProfile {
    id
    statusForHelpArticles
  }
  chatHelpTopicsByStatus
}
    `) as unknown as TypedDocumentString<ChatHelpTopicsQuery, ChatHelpTopicsQueryVariables>;
export const IntercomCollectionsDocument = new TypedDocumentString(`
    query IntercomCollections($isDuckling: Boolean) {
  viewer {
    ... on User {
      id
      nurseProfile {
        id
        statusForHelpArticles
      }
    }
  }
  collections(isDuckling: $isDuckling) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<IntercomCollectionsQuery, IntercomCollectionsQueryVariables>;
export const IntercomSectionsDocument = new TypedDocumentString(`
    query IntercomSections($parentId: Int!) {
  sections(parentId: $parentId) {
    id
    name
    type
    parentId
  }
}
    `) as unknown as TypedDocumentString<IntercomSectionsQuery, IntercomSectionsQueryVariables>;
export const IntercomArticlesDocument = new TypedDocumentString(`
    query IntercomArticles($parentId: Int!, $parentType: String!) {
  articles(parentId: $parentId, parentType: $parentType) {
    id
    parentId
    parentType
    title
    description
    body
    url
  }
}
    `) as unknown as TypedDocumentString<IntercomArticlesQuery, IntercomArticlesQueryVariables>;
export const ArticleContentDocument = new TypedDocumentString(`
    query ArticleContent($id: ID!) {
  article(id: $id) {
    id
    title
    description
    body
  }
}
    `) as unknown as TypedDocumentString<ArticleContentQuery, ArticleContentQueryVariables>;
export const LicensesAndCertificationsDocument = new TypedDocumentString(`
    query LicensesAndCertifications {
  nurseProfile {
    id
    state
    nurseCertifications {
      id
      ...NurseCertificationForm
    }
    licenses {
      ...LicenseListItemLicense
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment NurseCertificationForm on NurseCertification {
  id
  name
  expiresOn
  completedOn
  isExpired
  isExpiringSoon
  issuingBody
  useCompletionDate
  certification {
    id
    name
    issuingBody
    issuingBodies
    credential
  }
  files {
    ...FileMetadata
  }
}
fragment LicenseListItemLicense on License {
  id
  uuid
  licenseType
  friendlyLicenseType
  licensureCompact
  compact
  stateCode
  state
  number
  expiresOn
  title
  isExpired
  isExpiringSoon
  files {
    ...FileMetadata
  }
}`) as unknown as TypedDocumentString<LicensesAndCertificationsQuery, LicensesAndCertificationsQueryVariables>;
export const CurrentAddressNestedUpdateUserDocument = new TypedDocumentString(`
    mutation CurrentAddressNestedUpdateUser($id: ID!, $input: NestedUpdateUserInput!) {
  nestedUpdateUser(id: $id, input: $input) {
    user {
      ...CurrentAddressUser
    }
  }
}
    fragment CurrentAddressUser on User {
  id
  city
  state
  streetAddress
  zipcode
}`) as unknown as TypedDocumentString<CurrentAddressNestedUpdateUserMutation, CurrentAddressNestedUpdateUserMutationVariables>;
export const CurrentAddressPanelDocument = new TypedDocumentString(`
    query CurrentAddressPanel {
  viewer {
    ... on User {
      ...CurrentAddressUser
    }
  }
}
    fragment CurrentAddressUser on User {
  id
  city
  state
  streetAddress
  zipcode
}`) as unknown as TypedDocumentString<CurrentAddressPanelQuery, CurrentAddressPanelQueryVariables>;
export const CreateEducationDocument = new TypedDocumentString(`
    mutation CreateEducation($input: CreateEducationInput!, $parserId: String) {
  createEducation(input: $input, parserId: $parserId) {
    nurseProfile {
      ...EducationPanelUpdateCache
    }
  }
}
    fragment EducationPanelUpdateCache on NurseProfile {
  id
  educationComplete
  canApplyJobs
  applicationReadiness {
    results {
      education {
        label
        status
      }
    }
  }
  educations {
    ...EducationListItemEducation
  }
  profileCompletion {
    id
    steps {
      education {
        status
      }
    }
    meta {
      id
      incompleteCount
      expiredCount
      percentCompleted
      pendingCount
    }
  }
}
fragment EducationListItemEducation on Education {
  id
  startedOn
  graduatedOn
  schoolName
  locationAddress
  googlePlaceId
  degree
  descriptions
}`) as unknown as TypedDocumentString<CreateEducationMutation, CreateEducationMutationVariables>;
export const UpdateEducationDocument = new TypedDocumentString(`
    mutation UpdateEducation($id: ID!, $input: UpdateEducationInput!) {
  updateEducation(id: $id, input: $input) {
    nurseProfile {
      ...EducationPanelUpdateCache
    }
  }
}
    fragment EducationPanelUpdateCache on NurseProfile {
  id
  educationComplete
  canApplyJobs
  applicationReadiness {
    results {
      education {
        label
        status
      }
    }
  }
  educations {
    ...EducationListItemEducation
  }
  profileCompletion {
    id
    steps {
      education {
        status
      }
    }
    meta {
      id
      incompleteCount
      expiredCount
      percentCompleted
      pendingCount
    }
  }
}
fragment EducationListItemEducation on Education {
  id
  startedOn
  graduatedOn
  schoolName
  locationAddress
  googlePlaceId
  degree
  descriptions
}`) as unknown as TypedDocumentString<UpdateEducationMutation, UpdateEducationMutationVariables>;
export const DeleteEducationDocument = new TypedDocumentString(`
    mutation DeleteEducation($id: ID!) {
  deleteEducation(id: $id) {
    nurseProfile {
      ...EducationPanelUpdateCache
    }
  }
}
    fragment EducationPanelUpdateCache on NurseProfile {
  id
  educationComplete
  canApplyJobs
  applicationReadiness {
    results {
      education {
        label
        status
      }
    }
  }
  educations {
    ...EducationListItemEducation
  }
  profileCompletion {
    id
    steps {
      education {
        status
      }
    }
    meta {
      id
      incompleteCount
      expiredCount
      percentCompleted
      pendingCount
    }
  }
}
fragment EducationListItemEducation on Education {
  id
  startedOn
  graduatedOn
  schoolName
  locationAddress
  googlePlaceId
  degree
  descriptions
}`) as unknown as TypedDocumentString<DeleteEducationMutation, DeleteEducationMutationVariables>;
export const CollegeSuggestionsDocument = new TypedDocumentString(`
    query CollegeSuggestions($searchString: String) {
  getCollegeSuggestions(search_string: $searchString) {
    id
    name
    location
  }
}
    `) as unknown as TypedDocumentString<CollegeSuggestionsQuery, CollegeSuggestionsQueryVariables>;
export const EducationFormOptionsDocument = new TypedDocumentString(`
    query EducationFormOptions {
  educationDegrees: __type(name: "EducationDegreeTypes") {
    ...EnumValuesType
  }
}
    fragment EnumValue on __EnumValue {
  name
  description
}
fragment EnumValuesType on __Type {
  name
  enumValues {
    ...EnumValue
  }
}`) as unknown as TypedDocumentString<EducationFormOptionsQuery, EducationFormOptionsQueryVariables>;
export const EducationListPanelDocument = new TypedDocumentString(`
    query EducationListPanel {
  nurseProfile {
    id
    state
  }
  educations {
    ...EducationPanelEducation
  }
  parsedEducations {
    ...ResumeParserEducationSuggestions
  }
}
    fragment EducationPanelEducation on Education {
  id
  schoolName
  degree
  major
  gpa
  graduatedOn
  location {
    id
    address
    googlePlaceId
  }
  startedOn
  descriptions
}
fragment ResumeParserEducationSuggestions on EducationSuggestion {
  suggestionDegree: degree
  graduationDate
  parserId
  startDate
  institutionName
  suggestionLocation: location
  locationGoogle {
    address
    placeId
  }
}`) as unknown as TypedDocumentString<EducationListPanelQuery, EducationListPanelQueryVariables>;
export const EditEducationFormDocument = new TypedDocumentString(`
    query EditEducationForm($educationId: ID!) {
  education(id: $educationId) {
    ...EducationPanelEducation
  }
}
    fragment EducationPanelEducation on Education {
  id
  schoolName
  degree
  major
  gpa
  graduatedOn
  location {
    id
    address
    googlePlaceId
  }
  startedOn
  descriptions
}`) as unknown as TypedDocumentString<EditEducationFormQuery, EditEducationFormQueryVariables>;
export const EditEducationSuggestionFormDocument = new TypedDocumentString(`
    query EditEducationSuggestionForm($id: ID!) {
  parsedEducation(id: $id) {
    ...ResumeParserEducationSuggestions
  }
}
    fragment ResumeParserEducationSuggestions on EducationSuggestion {
  suggestionDegree: degree
  graduationDate
  parserId
  startDate
  institutionName
  suggestionLocation: location
  locationGoogle {
    address
    placeId
  }
}`) as unknown as TypedDocumentString<EditEducationSuggestionFormQuery, EditEducationSuggestionFormQueryVariables>;
export const EmailConfirmationPanelVerifyCodeDocument = new TypedDocumentString(`
    mutation EmailConfirmationPanelVerifyCode($input: ConfirmUserEmailInput!) {
  confirmUserEmail(input: $input) {
    user {
      ...EmailConfirmationPanelUser
    }
  }
}
    fragment EmailConfirmationPanelUser on User {
  id
  email
  confirmedAt
  confirmationSentAt
  receivedEmailConfirmationLink
}`) as unknown as TypedDocumentString<EmailConfirmationPanelVerifyCodeMutation, EmailConfirmationPanelVerifyCodeMutationVariables>;
export const EmailConfirmationTokenFormResendConfirmationDocument = new TypedDocumentString(`
    mutation EmailConfirmationTokenFormResendConfirmation {
  sendConfirmationEmail
}
    `) as unknown as TypedDocumentString<EmailConfirmationTokenFormResendConfirmationMutation, EmailConfirmationTokenFormResendConfirmationMutationVariables>;
export const EmailConfirmationPanelDocument = new TypedDocumentString(`
    query EmailConfirmationPanel {
  viewer {
    ... on User {
      nurseProfile {
        id
        state
      }
      ...EmailConfirmationPanelUser
    }
  }
}
    fragment EmailConfirmationPanelUser on User {
  id
  email
  confirmedAt
  confirmationSentAt
  receivedEmailConfirmationLink
}`) as unknown as TypedDocumentString<EmailConfirmationPanelQuery, EmailConfirmationPanelQueryVariables>;
export const EmploymentGapPanelUpdateEmploymentGapDocument = new TypedDocumentString(`
    mutation EmploymentGapPanelUpdateEmploymentGap($id: ID!, $input: UpdateEmploymentGapEmploymentInput!) {
  updateEmploymentGap(id: $id, input: $input) {
    nurseProfile {
      id
      sortedExperienceItems {
        ...WorkExperienceSectionExperienceItem
      }
    }
  }
}
    fragment WorkExperienceSectionExperienceItem on ExperienceItemUnion {
  ... on Position {
    ...WorkExperienceSectionPosition
  }
  ... on Gap {
    ...WorkExperienceSectionGap
  }
}
fragment WorkExperienceSectionPosition on Position {
  id
  title
  positionType
  startAt
  endAt
  humanReadableLength
  hoursWorked
  hoursWorkedTimeframe
  nicuCareLevels: nicuLevel
  additionalSkills
  chargeExperience
  leadExperience
  preceptorExperience
  floatFrequency
  friendlyEmploymentType
  invalidOverlapByHours
  invalidOverlapByLocation
  usableForReferences
  activeReferences {
    id
    name
    relationship
    responseAt
  }
  role {
    id
    name
  }
  facility {
    id
    name
    location {
      id
      city
      stateCode
      country
    }
  }
  clinicalUnit {
    id
    displayName
  }
  agency {
    id
    name
  }
  technologies {
    id
    name
  }
  specialties {
    id
    displayName
  }
  floatUnits {
    id
    displayName
  }
}
fragment WorkExperienceSectionGap on Gap {
  gapId: id
  gapEndAt: endAt
  gapExplanation: explanation
  gapGooglePlaceId: googlePlaceId
  gapIsEducationGap: isEducationGap
  gapLocationAddress: locationAddress
  gapReason: reason
  gapStartAt: startAt
}`) as unknown as TypedDocumentString<EmploymentGapPanelUpdateEmploymentGapMutation, EmploymentGapPanelUpdateEmploymentGapMutationVariables>;
export const EmploymentGapPanelDeleteEmploymentGapDocument = new TypedDocumentString(`
    mutation EmploymentGapPanelDeleteEmploymentGap($id: ID!) {
  deleteEmploymentGap(id: $id) {
    nurseProfile {
      id
      sortedExperienceItems {
        ...WorkExperienceSectionExperienceItem
      }
    }
  }
}
    fragment WorkExperienceSectionExperienceItem on ExperienceItemUnion {
  ... on Position {
    ...WorkExperienceSectionPosition
  }
  ... on Gap {
    ...WorkExperienceSectionGap
  }
}
fragment WorkExperienceSectionPosition on Position {
  id
  title
  positionType
  startAt
  endAt
  humanReadableLength
  hoursWorked
  hoursWorkedTimeframe
  nicuCareLevels: nicuLevel
  additionalSkills
  chargeExperience
  leadExperience
  preceptorExperience
  floatFrequency
  friendlyEmploymentType
  invalidOverlapByHours
  invalidOverlapByLocation
  usableForReferences
  activeReferences {
    id
    name
    relationship
    responseAt
  }
  role {
    id
    name
  }
  facility {
    id
    name
    location {
      id
      city
      stateCode
      country
    }
  }
  clinicalUnit {
    id
    displayName
  }
  agency {
    id
    name
  }
  technologies {
    id
    name
  }
  specialties {
    id
    displayName
  }
  floatUnits {
    id
    displayName
  }
}
fragment WorkExperienceSectionGap on Gap {
  gapId: id
  gapEndAt: endAt
  gapExplanation: explanation
  gapGooglePlaceId: googlePlaceId
  gapIsEducationGap: isEducationGap
  gapLocationAddress: locationAddress
  gapReason: reason
  gapStartAt: startAt
}`) as unknown as TypedDocumentString<EmploymentGapPanelDeleteEmploymentGapMutation, EmploymentGapPanelDeleteEmploymentGapMutationVariables>;
export const EmploymentGapPanelDocument = new TypedDocumentString(`
    query EmploymentGapPanel($id: ID!) {
  experienceGap(id: $id) {
    ...WorkExperienceSectionGap
  }
}
    fragment WorkExperienceSectionGap on Gap {
  gapId: id
  gapEndAt: endAt
  gapExplanation: explanation
  gapGooglePlaceId: googlePlaceId
  gapIsEducationGap: isEducationGap
  gapLocationAddress: locationAddress
  gapReason: reason
  gapStartAt: startAt
}`) as unknown as TypedDocumentString<EmploymentGapPanelQuery, EmploymentGapPanelQueryVariables>;
export const FacilityReviewPanelCreateUserAnswerDocument = new TypedDocumentString(`
    mutation FacilityReviewPanelCreateUserAnswer($facilitySlug: String!, $input: CreateSurveyResponseInput!) {
  createSurveyUserAnswers(facilitySlug: $facilitySlug, input: $input) {
    facility {
      id
      surveyResponses {
        id
        answers {
          id
          answerText
          answerJson
          key
        }
        completedAt
      }
      surveyForUser {
        id
        completedAt
      }
    }
  }
}
    `) as unknown as TypedDocumentString<FacilityReviewPanelCreateUserAnswerMutation, FacilityReviewPanelCreateUserAnswerMutationVariables>;
export const FacilityReviewPanelFacilitySurveyQuestionsDocument = new TypedDocumentString(`
    query FacilityReviewPanelFacilitySurveyQuestions {
  facilitySurveyQuestions {
    id
    key
    position
    text
    answerOptions
  }
}
    `) as unknown as TypedDocumentString<FacilityReviewPanelFacilitySurveyQuestionsQuery, FacilityReviewPanelFacilitySurveyQuestionsQueryVariables>;
export const LegalNameAndBirthdayNestedUpdateUserDocument = new TypedDocumentString(`
    mutation LegalNameAndBirthdayNestedUpdateUser($id: ID!, $input: NestedUpdateUserInput!) {
  nestedUpdateUser(id: $id, input: $input) {
    user {
      ...LegalNameAndBirthdayFormUser
    }
  }
}
    fragment LegalNameAndBirthdayFormUser on User {
  id
  firstName
  middleName
  lastName
  nurseProfile {
    id
    birthday
  }
}`) as unknown as TypedDocumentString<LegalNameAndBirthdayNestedUpdateUserMutation, LegalNameAndBirthdayNestedUpdateUserMutationVariables>;
export const LegalNameAndBirthdayPanelDocument = new TypedDocumentString(`
    query LegalNameAndBirthdayPanel {
  viewer {
    ... on User {
      ...LegalNameAndBirthdayFormUser
    }
  }
}
    fragment LegalNameAndBirthdayFormUser on User {
  id
  firstName
  middleName
  lastName
  nurseProfile {
    id
    birthday
  }
}`) as unknown as TypedDocumentString<LegalNameAndBirthdayPanelQuery, LegalNameAndBirthdayPanelQueryVariables>;
export const LicensePanelCreateLicenseDocument = new TypedDocumentString(`
    mutation LicensePanelCreateLicense($input: CreateLicenseInput!, $uploads: [FileUploadTypeInput!]) {
  createLicense(input: $input, uploads: $uploads) {
    nurseProfile {
      ...LicensePanelUpdateCache
    }
    errors {
      errors
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment LicenseListItemLicense on License {
  id
  uuid
  licenseType
  friendlyLicenseType
  licensureCompact
  compact
  stateCode
  state
  number
  expiresOn
  title
  isExpired
  isExpiringSoon
  files {
    ...FileMetadata
  }
}
fragment LicensePanelUpdateCache on NurseProfile {
  id
  applicationReadiness {
    results {
      licenses {
        label
        status
      }
    }
  }
  licensesComplete
  profileCompletion {
    id
    steps {
      license {
        status
      }
    }
  }
  licenses {
    ...LicenseListItemLicense
  }
}`) as unknown as TypedDocumentString<LicensePanelCreateLicenseMutation, LicensePanelCreateLicenseMutationVariables>;
export const LicensePanelUpdateLicenseDocument = new TypedDocumentString(`
    mutation LicensePanelUpdateLicense($id: ID!, $input: UpdateLicenseInput!, $uploads: [FileUploadTypeInput!]) {
  updateLicense(id: $id, input: $input, uploads: $uploads) {
    nurseProfile {
      ...LicensePanelUpdateCache
    }
    license {
      ...LicenseListItemLicense
    }
    errors {
      errors
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment LicenseListItemLicense on License {
  id
  uuid
  licenseType
  friendlyLicenseType
  licensureCompact
  compact
  stateCode
  state
  number
  expiresOn
  title
  isExpired
  isExpiringSoon
  files {
    ...FileMetadata
  }
}
fragment LicensePanelUpdateCache on NurseProfile {
  id
  applicationReadiness {
    results {
      licenses {
        label
        status
      }
    }
  }
  licensesComplete
  profileCompletion {
    id
    steps {
      license {
        status
      }
    }
  }
  licenses {
    ...LicenseListItemLicense
  }
}`) as unknown as TypedDocumentString<LicensePanelUpdateLicenseMutation, LicensePanelUpdateLicenseMutationVariables>;
export const LicensePanelDeleteLicenseDocument = new TypedDocumentString(`
    mutation LicensePanelDeleteLicense($id: ID!) {
  deleteLicense(id: $id) {
    nurseProfile {
      ...LicensePanelUpdateCache
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment LicenseListItemLicense on License {
  id
  uuid
  licenseType
  friendlyLicenseType
  licensureCompact
  compact
  stateCode
  state
  number
  expiresOn
  title
  isExpired
  isExpiringSoon
  files {
    ...FileMetadata
  }
}
fragment LicensePanelUpdateCache on NurseProfile {
  id
  applicationReadiness {
    results {
      licenses {
        label
        status
      }
    }
  }
  licensesComplete
  profileCompletion {
    id
    steps {
      license {
        status
      }
    }
  }
  licenses {
    ...LicenseListItemLicense
  }
}`) as unknown as TypedDocumentString<LicensePanelDeleteLicenseMutation, LicensePanelDeleteLicenseMutationVariables>;
export const LicensePanelDocument = new TypedDocumentString(`
    query LicensePanel($id: ID!) {
  license(id: $id) {
    ...LicenseListItemLicense
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment LicenseListItemLicense on License {
  id
  uuid
  licenseType
  friendlyLicenseType
  licensureCompact
  compact
  stateCode
  state
  number
  expiresOn
  title
  isExpired
  isExpiringSoon
  files {
    ...FileMetadata
  }
}`) as unknown as TypedDocumentString<LicensePanelQuery, LicensePanelQueryVariables>;
export const LicensesListPanelDocument = new TypedDocumentString(`
    query LicensesListPanel {
  nurseProfile {
    id
    state
    licenses {
      ...LicenseListItemLicense
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment LicenseListItemLicense on License {
  id
  uuid
  licenseType
  friendlyLicenseType
  licensureCompact
  compact
  stateCode
  state
  number
  expiresOn
  title
  isExpired
  isExpiringSoon
  files {
    ...FileMetadata
  }
}`) as unknown as TypedDocumentString<LicensesListPanelQuery, LicensesListPanelQueryVariables>;
export const CreateLicenseVerificationDocument = new TypedDocumentString(`
    mutation CreateLicenseVerification($input: CreateLicenseVerificationInput!, $uploads: [FileUploadTypeInput!]) {
  createLicenseVerification(input: $input, uploads: $uploads) {
    nurseProfile {
      id
      nurseLicenseVerifications {
        id
        verificationType
        dateOfDownload
        stateCode
        stateCodes
        state
        states
        expiresOn
        isExpired
        isExpiringSoon
        files {
          ...FileMetadata
        }
      }
    }
    errors {
      errors
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}`) as unknown as TypedDocumentString<CreateLicenseVerificationMutation, CreateLicenseVerificationMutationVariables>;
export const DeleteLicenseVerificationDocument = new TypedDocumentString(`
    mutation DeleteLicenseVerification($id: ID!) {
  deleteLicenseVerification(id: $id) {
    nurseProfile {
      id
      nurseLicenseVerifications {
        id
        verificationType
        dateOfDownload
        stateCode
        stateCodes
        state
        states
        expiresOn
        isExpired
        isExpiringSoon
        files {
          ...FileMetadata
        }
      }
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}`) as unknown as TypedDocumentString<DeleteLicenseVerificationMutation, DeleteLicenseVerificationMutationVariables>;
export const UpdateLicenseVerificationDocument = new TypedDocumentString(`
    mutation UpdateLicenseVerification($id: ID!, $input: UpdateLicenseVerificationInput!, $uploads: [FileUploadTypeInput!]) {
  updateLicenseVerification(id: $id, input: $input, uploads: $uploads) {
    nurseProfile {
      id
      nurseLicenseVerifications {
        id
        verificationType
        dateOfDownload
        stateCode
        stateCodes
        state
        states
        expiresOn
        isExpired
        isExpiringSoon
        files {
          ...FileMetadata
        }
      }
    }
    errors {
      errors
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}`) as unknown as TypedDocumentString<UpdateLicenseVerificationMutation, UpdateLicenseVerificationMutationVariables>;
export const UpdateLicenseVerificationPanelDocument = new TypedDocumentString(`
    query UpdateLicenseVerificationPanel($id: ID!) {
  nurseLicenseVerification(id: $id) {
    id
    verificationType
    dateOfDownload
    stateCode
    stateCodes
    state
    expiresOn
    isExpired
    isExpiringSoon
    files {
      ...FileMetadata
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}`) as unknown as TypedDocumentString<UpdateLicenseVerificationPanelQuery, UpdateLicenseVerificationPanelQueryVariables>;
export const CreateDocumentDocument = new TypedDocumentString(`
    mutation CreateDocument($input: CreateDocumentInput!, $uploads: [FileUploadTypeInput!]) {
  createDocument(input: $input, uploads: $uploads) {
    nurseProfile {
      id
      documents {
        id
        ...MiscDocumentsTableDocument
      }
    }
    errors {
      errors
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment MiscDocumentsTableDocument on Document {
  id
  title
  docType
  expiresOn
  isExpired
  isExpiringSoon
  files {
    ...FileMetadata
  }
}`) as unknown as TypedDocumentString<CreateDocumentMutation, CreateDocumentMutationVariables>;
export const UpdateMiscDocumentDocument = new TypedDocumentString(`
    mutation UpdateMiscDocument($id: ID!, $input: UpdateDocumentInput!, $uploads: [FileUploadTypeInput!]) {
  updateDocument(id: $id, input: $input, uploads: $uploads) {
    document {
      id
      ...MiscDocumentsTableDocument
    }
    errors {
      errors
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment MiscDocumentsTableDocument on Document {
  id
  title
  docType
  expiresOn
  isExpired
  isExpiringSoon
  files {
    ...FileMetadata
  }
}`) as unknown as TypedDocumentString<UpdateMiscDocumentMutation, UpdateMiscDocumentMutationVariables>;
export const DeleteMiscDocumentDocument = new TypedDocumentString(`
    mutation DeleteMiscDocument($id: ID!) {
  deleteDocument(id: $id) {
    nurseProfile {
      id
      documents {
        id
        ...MiscDocumentsTableDocument
      }
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment MiscDocumentsTableDocument on Document {
  id
  title
  docType
  expiresOn
  isExpired
  isExpiringSoon
  files {
    ...FileMetadata
  }
}`) as unknown as TypedDocumentString<DeleteMiscDocumentMutation, DeleteMiscDocumentMutationVariables>;
export const UpdateDocumentPanelDocument = new TypedDocumentString(`
    query UpdateDocumentPanel($id: ID!) {
  document(id: $id) {
    ...MiscDocumentsTableDocument
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment MiscDocumentsTableDocument on Document {
  id
  title
  docType
  expiresOn
  isExpired
  isExpiringSoon
  files {
    ...FileMetadata
  }
}`) as unknown as TypedDocumentString<UpdateDocumentPanelQuery, UpdateDocumentPanelQueryVariables>;
export const CreateNurseAssessmentDocument = new TypedDocumentString(`
    mutation CreateNurseAssessment($fileUuids: [ID], $input: CreateNurseAssessmentInput!) {
  createNurseAssessment(fileUuids: $fileUuids, input: $input) {
    nurseProfile {
      id
      skillsComplete
      nurseAssessments {
        ...NurseAssessmentPanelsNurseAssessment
      }
      skillsChecklists {
        ...NurseAssessmentPanelsNurseAssessment
      }
      applicationReadiness {
        meta {
          requirements {
            status
          }
        }
        results {
          skillsChecklist {
            label
            status
          }
        }
      }
      ...NurseAssessmentPanelProfileCompletion
    }
    errors {
      errors
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment NurseAssessmentPanelsNurseAssessment on NurseAssessment {
  id
  completedOn
  expiresOn
  isExpired
  isExpiringSoon
  isArchived
  score
  requestedOn
  assessment {
    ...AssessmentItem
  }
  assessmentRequest {
    id
    score
  }
  files {
    ...FileMetadata
  }
}
fragment AssessmentItem on Assessment {
  id
  category
  issuingBody
  name
}
fragment NurseAssessmentPanelProfileCompletion on NurseProfile {
  id
  profileCompletion {
    id
    steps {
      skillsChecklist {
        status
      }
    }
  }
}`) as unknown as TypedDocumentString<CreateNurseAssessmentMutation, CreateNurseAssessmentMutationVariables>;
export const DeleteNurseAssessmentDocument = new TypedDocumentString(`
    mutation DeleteNurseAssessment($id: ID!) {
  deleteNurseAssessment(id: $id) {
    nurseProfile {
      id
      skillsComplete
      nurseAssessments {
        ...NurseAssessmentPanelsNurseAssessment
      }
      skillsChecklists {
        ...NurseAssessmentPanelsNurseAssessment
      }
      applicationReadiness {
        meta {
          requirements {
            status
          }
        }
        results {
          skillsChecklist {
            label
            status
          }
        }
      }
      ...NurseAssessmentPanelProfileCompletion
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment NurseAssessmentPanelsNurseAssessment on NurseAssessment {
  id
  completedOn
  expiresOn
  isExpired
  isExpiringSoon
  isArchived
  score
  requestedOn
  assessment {
    ...AssessmentItem
  }
  assessmentRequest {
    id
    score
  }
  files {
    ...FileMetadata
  }
}
fragment AssessmentItem on Assessment {
  id
  category
  issuingBody
  name
}
fragment NurseAssessmentPanelProfileCompletion on NurseProfile {
  id
  profileCompletion {
    id
    steps {
      skillsChecklist {
        status
      }
    }
  }
}`) as unknown as TypedDocumentString<DeleteNurseAssessmentMutation, DeleteNurseAssessmentMutationVariables>;
export const UpdateNurseAssessmentDocument = new TypedDocumentString(`
    mutation UpdateNurseAssessment($id: ID!, $fileUuids: [ID], $input: UpdateNurseAssessmentInput!) {
  updateNurseAssessment(id: $id, fileUuids: $fileUuids, input: $input) {
    nurseProfile {
      id
      skillsComplete
      nurseAssessments {
        ...NurseAssessmentPanelsNurseAssessment
      }
      skillsChecklists {
        ...NurseAssessmentPanelsNurseAssessment
      }
      applicationReadiness {
        meta {
          requirements {
            status
          }
        }
        results {
          skillsChecklist {
            label
            status
          }
        }
      }
      ...NurseAssessmentPanelProfileCompletion
    }
    errors {
      errors
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment NurseAssessmentPanelsNurseAssessment on NurseAssessment {
  id
  completedOn
  expiresOn
  isExpired
  isExpiringSoon
  isArchived
  score
  requestedOn
  assessment {
    ...AssessmentItem
  }
  assessmentRequest {
    id
    score
  }
  files {
    ...FileMetadata
  }
}
fragment AssessmentItem on Assessment {
  id
  category
  issuingBody
  name
}
fragment NurseAssessmentPanelProfileCompletion on NurseProfile {
  id
  profileCompletion {
    id
    steps {
      skillsChecklist {
        status
      }
    }
  }
}`) as unknown as TypedDocumentString<UpdateNurseAssessmentMutation, UpdateNurseAssessmentMutationVariables>;
export const RetakeReliasAssessmentDocument = new TypedDocumentString(`
    mutation RetakeReliasAssessment($id: ID!) {
  retakeReliasAssessment(id: $id) {
    nurseProfile {
      id
      skillsComplete
      nurseAssessments {
        ...NurseAssessmentPanelsNurseAssessment
      }
      skillsChecklists {
        ...NurseAssessmentPanelsNurseAssessment
      }
      applicationReadiness {
        meta {
          requirements {
            status
          }
        }
        results {
          skillsChecklist {
            label
            status
          }
        }
      }
      ...NurseAssessmentPanelProfileCompletion
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment NurseAssessmentPanelsNurseAssessment on NurseAssessment {
  id
  completedOn
  expiresOn
  isExpired
  isExpiringSoon
  isArchived
  score
  requestedOn
  assessment {
    ...AssessmentItem
  }
  assessmentRequest {
    id
    score
  }
  files {
    ...FileMetadata
  }
}
fragment AssessmentItem on Assessment {
  id
  category
  issuingBody
  name
}
fragment NurseAssessmentPanelProfileCompletion on NurseProfile {
  id
  profileCompletion {
    id
    steps {
      skillsChecklist {
        status
      }
    }
  }
}`) as unknown as TypedDocumentString<RetakeReliasAssessmentMutation, RetakeReliasAssessmentMutationVariables>;
export const NurseAssessmentPanelDocument = new TypedDocumentString(`
    query NurseAssessmentPanel($id: ID!) {
  nurseAssessment(id: $id) {
    ...NurseAssessmentPanelsNurseAssessment
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment NurseAssessmentPanelsNurseAssessment on NurseAssessment {
  id
  completedOn
  expiresOn
  isExpired
  isExpiringSoon
  isArchived
  score
  requestedOn
  assessment {
    ...AssessmentItem
  }
  assessmentRequest {
    id
    score
  }
  files {
    ...FileMetadata
  }
}
fragment AssessmentItem on Assessment {
  id
  category
  issuingBody
  name
}`) as unknown as TypedDocumentString<NurseAssessmentPanelQuery, NurseAssessmentPanelQueryVariables>;
export const AssessmentSuggestionsDocument = new TypedDocumentString(`
    query AssessmentSuggestions($searchString: String, $issuingBody: String, $skillsChecklistsOnly: Boolean) {
  getAssessmentSuggestions(
    search_string: $searchString
    issuing_body: $issuingBody
    skills_checklists_only: $skillsChecklistsOnly
  ) {
    id
    issuingBody
    name
    category
  }
}
    `) as unknown as TypedDocumentString<AssessmentSuggestionsQuery, AssessmentSuggestionsQueryVariables>;
export const NurseAssessmentsDocument = new TypedDocumentString(`
    query NurseAssessments {
  nurseProfile {
    id
    state
    skillsChecklists {
      ...NurseAssessmentsTableNurseAssessment
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment NurseAssessmentsTableNurseAssessment on NurseAssessment {
  id
  completedOn
  expiresOn
  isArchived
  isExpired
  isExpiringSoon
  score
  assessment {
    ...AssessmentItem
  }
  files {
    ...FileMetadata
  }
  assessmentRequest {
    id
    score
  }
}
fragment AssessmentItem on Assessment {
  id
  category
  issuingBody
  name
}`) as unknown as TypedDocumentString<NurseAssessmentsQuery, NurseAssessmentsQueryVariables>;
export const CreateNurseCertificationDocument = new TypedDocumentString(`
    mutation CreateNurseCertification($certificationId: ID!, $input: CreateNurseCertificationInput!) {
  createNurseCertification(certificationId: $certificationId, input: $input) {
    nurseProfile {
      id
      certificationsComplete
      nurseCertifications {
        id
        ...NurseCertificationForm
      }
    }
    errors {
      errors
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment NurseCertificationForm on NurseCertification {
  id
  name
  expiresOn
  completedOn
  isExpired
  isExpiringSoon
  issuingBody
  useCompletionDate
  certification {
    id
    name
    issuingBody
    issuingBodies
    credential
  }
  files {
    ...FileMetadata
  }
}`) as unknown as TypedDocumentString<CreateNurseCertificationMutation, CreateNurseCertificationMutationVariables>;
export const UpdateNurseCertificationDocument = new TypedDocumentString(`
    mutation UpdateNurseCertification($id: ID!, $certificationId: ID!, $input: UpdateNurseCertificationInput!) {
  updateNurseCertification(
    id: $id
    certificationId: $certificationId
    input: $input
  ) {
    nurseProfile {
      id
      certificationsComplete
      nurseCertifications {
        id
        ...NurseCertificationForm
      }
    }
    errors {
      errors
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment NurseCertificationForm on NurseCertification {
  id
  name
  expiresOn
  completedOn
  isExpired
  isExpiringSoon
  issuingBody
  useCompletionDate
  certification {
    id
    name
    issuingBody
    issuingBodies
    credential
  }
  files {
    ...FileMetadata
  }
}`) as unknown as TypedDocumentString<UpdateNurseCertificationMutation, UpdateNurseCertificationMutationVariables>;
export const DeleteNurseCertificationDocument = new TypedDocumentString(`
    mutation DeleteNurseCertification($id: ID!) {
  deleteNurseCertification(id: $id) {
    nurseProfile {
      id
      certificationsComplete
      nurseCertifications {
        ...NurseCertificationForm
      }
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment NurseCertificationForm on NurseCertification {
  id
  name
  expiresOn
  completedOn
  isExpired
  isExpiringSoon
  issuingBody
  useCompletionDate
  certification {
    id
    name
    issuingBody
    issuingBodies
    credential
  }
  files {
    ...FileMetadata
  }
}`) as unknown as TypedDocumentString<DeleteNurseCertificationMutation, DeleteNurseCertificationMutationVariables>;
export const NurseCertificationPanelDocument = new TypedDocumentString(`
    query NurseCertificationPanel($id: ID!) {
  nurseCertification(id: $id) {
    id
    ...NurseCertificationForm
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment NurseCertificationForm on NurseCertification {
  id
  name
  expiresOn
  completedOn
  isExpired
  isExpiringSoon
  issuingBody
  useCompletionDate
  certification {
    id
    name
    issuingBody
    issuingBodies
    credential
  }
  files {
    ...FileMetadata
  }
}`) as unknown as TypedDocumentString<NurseCertificationPanelQuery, NurseCertificationPanelQueryVariables>;
export const CreateNurseHealthDocDocument = new TypedDocumentString(`
    mutation CreateNurseHealthDoc($healthDocId: ID!, $fileUuids: [ID], $input: CreateNurseHealthDocInput!) {
  createNurseHealthDoc(
    healthDocId: $healthDocId
    fileUuids: $fileUuids
    input: $input
  ) {
    nurseProfile {
      id
      nurseHealthDocs {
        ...NurseHealthDocumentPanelHealthDoc
      }
      ...CovidVaccinationCardNurseProfile
    }
    errors {
      errors
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment NurseHealthDocumentPanelAvailableHealthDoc on HealthDoc {
  id
  name
  categories
  formType
  validFor
}
fragment NurseHealthDocumentPanelHealthDoc on NurseHealthDoc {
  id
  completedOn
  isExpired
  isExpiringSoon
  category
  nurseProfile {
    id
  }
  healthDoc {
    ...NurseHealthDocumentPanelAvailableHealthDoc
  }
  details {
    ... on NurseHealthDocVaccination {
      entries {
        ... on NurseHealthDocVaccineShot {
          type
          kind
          brand
          completedOn
        }
        ... on NurseHealthDocVaccineDeclination {
          type
          kind
          reason
        }
        ... on NurseHealthDocVaccineWilling {
          type
          kind
        }
      }
    }
  }
  files {
    ...FileMetadata
  }
}
fragment CovidVaccinationCardNurseProfile on NurseProfile {
  id
  covidVaccination {
    id
    completedOn
    isExpired
  }
  applicationReadiness {
    results {
      covidVaccination {
        status
      }
    }
  }
}`) as unknown as TypedDocumentString<CreateNurseHealthDocMutation, CreateNurseHealthDocMutationVariables>;
export const CreateNurseHealthDocVaccinationDocument = new TypedDocumentString(`
    mutation CreateNurseHealthDocVaccination($fileUuids: [ID], $input: [NurseHealthDocVaccinationInput!]!) {
  createNurseHealthDocVaccination(fileUuids: $fileUuids, input: $input) {
    nurseProfile {
      id
      nurseHealthDocs {
        ...NurseHealthDocumentPanelHealthDoc
      }
      ...CovidVaccinationCardNurseProfile
    }
    errors {
      ...AllBasicErrors
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment NurseHealthDocumentPanelAvailableHealthDoc on HealthDoc {
  id
  name
  categories
  formType
  validFor
}
fragment NurseHealthDocumentPanelHealthDoc on NurseHealthDoc {
  id
  completedOn
  isExpired
  isExpiringSoon
  category
  nurseProfile {
    id
  }
  healthDoc {
    ...NurseHealthDocumentPanelAvailableHealthDoc
  }
  details {
    ... on NurseHealthDocVaccination {
      entries {
        ... on NurseHealthDocVaccineShot {
          type
          kind
          brand
          completedOn
        }
        ... on NurseHealthDocVaccineDeclination {
          type
          kind
          reason
        }
        ... on NurseHealthDocVaccineWilling {
          type
          kind
        }
      }
    }
  }
  files {
    ...FileMetadata
  }
}
fragment AllBasicErrors on BasicErrorsUnion {
  ... on NotFoundError {
    model
    message
  }
  ... on BadUserInputError {
    argument
    message
  }
  ... on RecordNotUniqueError {
    model
    message
  }
  ... on ModelValidationError {
    message
    attributes {
      attribute
      humanAttribute
      errors {
        message
        fullMessage
        code
      }
    }
  }
}
fragment CovidVaccinationCardNurseProfile on NurseProfile {
  id
  covidVaccination {
    id
    completedOn
    isExpired
  }
  applicationReadiness {
    results {
      covidVaccination {
        status
      }
    }
  }
}`) as unknown as TypedDocumentString<CreateNurseHealthDocVaccinationMutation, CreateNurseHealthDocVaccinationMutationVariables>;
export const UpdateNurseHealthDocDocument = new TypedDocumentString(`
    mutation UpdateNurseHealthDoc($id: ID!, $healthDocId: ID!, $fileUuids: [ID], $input: UpdateNurseHealthDocInput!) {
  updateNurseHealthDoc(
    id: $id
    healthDocId: $healthDocId
    fileUuids: $fileUuids
    input: $input
  ) {
    nurseProfile {
      id
      nurseHealthDocs {
        ...NurseHealthDocumentPanelHealthDoc
        todoListItems {
          id
          itemState
        }
      }
      ...CovidVaccinationCardNurseProfile
    }
    errors {
      errors
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment NurseHealthDocumentPanelAvailableHealthDoc on HealthDoc {
  id
  name
  categories
  formType
  validFor
}
fragment NurseHealthDocumentPanelHealthDoc on NurseHealthDoc {
  id
  completedOn
  isExpired
  isExpiringSoon
  category
  nurseProfile {
    id
  }
  healthDoc {
    ...NurseHealthDocumentPanelAvailableHealthDoc
  }
  details {
    ... on NurseHealthDocVaccination {
      entries {
        ... on NurseHealthDocVaccineShot {
          type
          kind
          brand
          completedOn
        }
        ... on NurseHealthDocVaccineDeclination {
          type
          kind
          reason
        }
        ... on NurseHealthDocVaccineWilling {
          type
          kind
        }
      }
    }
  }
  files {
    ...FileMetadata
  }
}
fragment CovidVaccinationCardNurseProfile on NurseProfile {
  id
  covidVaccination {
    id
    completedOn
    isExpired
  }
  applicationReadiness {
    results {
      covidVaccination {
        status
      }
    }
  }
}`) as unknown as TypedDocumentString<UpdateNurseHealthDocMutation, UpdateNurseHealthDocMutationVariables>;
export const UpdateNurseHealthDocVaccinationDocument = new TypedDocumentString(`
    mutation UpdateNurseHealthDocVaccination($id: ID!, $fileUuids: [ID], $input: [NurseHealthDocVaccinationInput!]!) {
  updateNurseHealthDocVaccination(id: $id, fileUuids: $fileUuids, input: $input) {
    nurseProfile {
      id
      nurseHealthDocs {
        ...NurseHealthDocumentPanelHealthDoc
        todoListItems {
          id
          itemState
        }
      }
      ...CovidVaccinationCardNurseProfile
    }
    errors {
      ...AllBasicErrors
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment NurseHealthDocumentPanelAvailableHealthDoc on HealthDoc {
  id
  name
  categories
  formType
  validFor
}
fragment NurseHealthDocumentPanelHealthDoc on NurseHealthDoc {
  id
  completedOn
  isExpired
  isExpiringSoon
  category
  nurseProfile {
    id
  }
  healthDoc {
    ...NurseHealthDocumentPanelAvailableHealthDoc
  }
  details {
    ... on NurseHealthDocVaccination {
      entries {
        ... on NurseHealthDocVaccineShot {
          type
          kind
          brand
          completedOn
        }
        ... on NurseHealthDocVaccineDeclination {
          type
          kind
          reason
        }
        ... on NurseHealthDocVaccineWilling {
          type
          kind
        }
      }
    }
  }
  files {
    ...FileMetadata
  }
}
fragment AllBasicErrors on BasicErrorsUnion {
  ... on NotFoundError {
    model
    message
  }
  ... on BadUserInputError {
    argument
    message
  }
  ... on RecordNotUniqueError {
    model
    message
  }
  ... on ModelValidationError {
    message
    attributes {
      attribute
      humanAttribute
      errors {
        message
        fullMessage
        code
      }
    }
  }
}
fragment CovidVaccinationCardNurseProfile on NurseProfile {
  id
  covidVaccination {
    id
    completedOn
    isExpired
  }
  applicationReadiness {
    results {
      covidVaccination {
        status
      }
    }
  }
}`) as unknown as TypedDocumentString<UpdateNurseHealthDocVaccinationMutation, UpdateNurseHealthDocVaccinationMutationVariables>;
export const DeleteNurseHealthDocDocument = new TypedDocumentString(`
    mutation DeleteNurseHealthDoc($id: ID!) {
  deleteNurseHealthDoc(id: $id) {
    nurseProfile {
      id
      nurseHealthDocs {
        ...NurseHealthDocumentPanelHealthDoc
      }
      ...CovidVaccinationCardNurseProfile
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment NurseHealthDocumentPanelAvailableHealthDoc on HealthDoc {
  id
  name
  categories
  formType
  validFor
}
fragment NurseHealthDocumentPanelHealthDoc on NurseHealthDoc {
  id
  completedOn
  isExpired
  isExpiringSoon
  category
  nurseProfile {
    id
  }
  healthDoc {
    ...NurseHealthDocumentPanelAvailableHealthDoc
  }
  details {
    ... on NurseHealthDocVaccination {
      entries {
        ... on NurseHealthDocVaccineShot {
          type
          kind
          brand
          completedOn
        }
        ... on NurseHealthDocVaccineDeclination {
          type
          kind
          reason
        }
        ... on NurseHealthDocVaccineWilling {
          type
          kind
        }
      }
    }
  }
  files {
    ...FileMetadata
  }
}
fragment CovidVaccinationCardNurseProfile on NurseProfile {
  id
  covidVaccination {
    id
    completedOn
    isExpired
  }
  applicationReadiness {
    results {
      covidVaccination {
        status
      }
    }
  }
}`) as unknown as TypedDocumentString<DeleteNurseHealthDocMutation, DeleteNurseHealthDocMutationVariables>;
export const UpdateOnboardingNeedsToBeScheduledDocument = new TypedDocumentString(`
    mutation UpdateOnboardingNeedsToBeScheduled($id: ID!, $needsToBeScheduled: Boolean!) {
  updateOnboardingNeedsToBeScheduled(
    id: $id
    needsToBeScheduled: $needsToBeScheduled
  ) {
    todoListItem {
      id
      needsToBeScheduled
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateOnboardingNeedsToBeScheduledMutation, UpdateOnboardingNeedsToBeScheduledMutationVariables>;
export const AvailableHealthDocsDocument = new TypedDocumentString(`
    query AvailableHealthDocs {
  availableHealthDocs {
    ...NurseHealthDocumentPanelAvailableHealthDoc
  }
}
    fragment NurseHealthDocumentPanelAvailableHealthDoc on HealthDoc {
  id
  name
  categories
  formType
  validFor
}`) as unknown as TypedDocumentString<AvailableHealthDocsQuery, AvailableHealthDocsQueryVariables>;
export const NurseHealthDocumentDocument = new TypedDocumentString(`
    query NurseHealthDocument($id: ID!) {
  nurseHealthDoc(id: $id) {
    id
    ...NurseHealthDocumentPanelHealthDoc
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment NurseHealthDocumentPanelAvailableHealthDoc on HealthDoc {
  id
  name
  categories
  formType
  validFor
}
fragment NurseHealthDocumentPanelHealthDoc on NurseHealthDoc {
  id
  completedOn
  isExpired
  isExpiringSoon
  category
  nurseProfile {
    id
  }
  healthDoc {
    ...NurseHealthDocumentPanelAvailableHealthDoc
  }
  details {
    ... on NurseHealthDocVaccination {
      entries {
        ... on NurseHealthDocVaccineShot {
          type
          kind
          brand
          completedOn
        }
        ... on NurseHealthDocVaccineDeclination {
          type
          kind
          reason
        }
        ... on NurseHealthDocVaccineWilling {
          type
          kind
        }
      }
    }
  }
  files {
    ...FileMetadata
  }
}`) as unknown as TypedDocumentString<NurseHealthDocumentQuery, NurseHealthDocumentQueryVariables>;
export const DefaultCovidVaccineHealthDocDocument = new TypedDocumentString(`
    query DefaultCovidVaccineHealthDoc {
  defaultCovidVaccineHealthDoc {
    id
    name
    categories
    formType
  }
}
    `) as unknown as TypedDocumentString<DefaultCovidVaccineHealthDocQuery, DefaultCovidVaccineHealthDocQueryVariables>;
export const UpdateLicenseOnboardingItemDocument = new TypedDocumentString(`
    mutation UpdateLicenseOnboardingItem($id: ID!, $licenseType: AlliedHealthNursingLicenseType!, $licenseId: ID, $input: UpdateLicenseOnboardingItemInput!) {
  updateLicenseOnboardingItem(
    id: $id
    licenseId: $licenseId
    licenseType: $licenseType
    input: $input
  ) {
    todoListItem {
      id
      itemState
      licenseTarget {
        id
        licenseType
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateLicenseOnboardingItemMutation, UpdateLicenseOnboardingItemMutationVariables>;
export const OnboardingItemLicensePanelDocument = new TypedDocumentString(`
    query OnboardingItemLicensePanel($id: ID!) {
  todoListItem(id: $id) {
    ...OnboardingItemLicensePanelTodoListItem
  }
}
    fragment OnboardingItemLicensePanelTodoListItem on TodoListItem {
  id
  name
  description
  requiresVerification
  actionLinks {
    id
    url
    title
  }
  licenseTarget {
    id
    licenseType
  }
}`) as unknown as TypedDocumentString<OnboardingItemLicensePanelQuery, OnboardingItemLicensePanelQueryVariables>;
export const OnboardingItemLicenseFormExistingLicensesDocument = new TypedDocumentString(`
    query OnboardingItemLicenseFormExistingLicenses {
  nurseProfile {
    id
    licenses {
      ...OnboardingItemLicenseFormLicense
    }
  }
}
    fragment OnboardingItemLicenseFormLicense on License {
  id
  number
  licenseType
  expiresOn
  stateCode
  licensureCompact
  friendlyLicenseType
}`) as unknown as TypedDocumentString<OnboardingItemLicenseFormExistingLicensesQuery, OnboardingItemLicenseFormExistingLicensesQueryVariables>;
export const PermanentAddressNestedUpdateUserDocument = new TypedDocumentString(`
    mutation PermanentAddressNestedUpdateUser($id: ID!, $input: NestedUpdateUserInput!) {
  nestedUpdateUser(id: $id, input: $input) {
    user {
      ...ComplianceQuestionsPermanentAddressUser
    }
  }
}
    fragment ComplianceQuestionsPermanentAddressUser on User {
  id
  cityPermanent
  countryPermanentCode
  countryPermanentName
  googlePlaceIdPermanent
  statePermanent
  streetAddressPermanent
  streetNumberPermanent
  zipcodePermanent
}`) as unknown as TypedDocumentString<PermanentAddressNestedUpdateUserMutation, PermanentAddressNestedUpdateUserMutationVariables>;
export const PermanentAddressPanelV2Document = new TypedDocumentString(`
    query PermanentAddressPanelV2 {
  viewer {
    ... on User {
      ...ComplianceQuestionsPermanentAddressUser
    }
  }
}
    fragment ComplianceQuestionsPermanentAddressUser on User {
  id
  cityPermanent
  countryPermanentCode
  countryPermanentName
  googlePlaceIdPermanent
  statePermanent
  streetAddressPermanent
  streetNumberPermanent
  zipcodePermanent
}`) as unknown as TypedDocumentString<PermanentAddressPanelV2Query, PermanentAddressPanelV2QueryVariables>;
export const PersonalInfoPanelDocument = new TypedDocumentString(`
    query PersonalInfoPanel {
  viewer {
    ... on User {
      ...PersonalInfoSectionUser
    }
  }
}
    fragment PersonalInfoSectionUser on User {
  id
  firstName
  middleName
  lastName
  preferredName
  phone
  preferredPronoun
  nurseProfile {
    id
    state
    birthday
    fullSsnCollected
    ssnLast4
    role {
      id
      name
      type
    }
    primarySpecialty {
      id
      displayName
      fullName
      slug
    }
    profileCompletion {
      id
      steps {
        personalInfo {
          status
        }
      }
    }
  }
  ...PermanentAddressUser
}
fragment PermanentAddressUser on User {
  id
  cityPermanent
  countryPermanentCode
  countryPermanentName
  googlePlaceIdPermanent
  statePermanent
  streetAddressPermanent
  streetNumberPermanent
  zipcodePermanent
  nurseProfile {
    id
    profileCompletion {
      id
      steps {
        permanentAddress {
          label
          message
          status
        }
      }
    }
  }
}`) as unknown as TypedDocumentString<PersonalInfoPanelQuery, PersonalInfoPanelQueryVariables>;
export const AssignAssessmentDocument = new TypedDocumentString(`
    mutation AssignAssessment($assessmentIds: [String]!) {
  assignReliasAssessments(assessment_uuid_list: $assessmentIds) {
    nurseProfile {
      id
      nurseAssessments {
        ...AssignAssessmentPanelNurseAssessment
      }
      skillsChecklists {
        ...AssignAssessmentPanelNurseAssessment
      }
    }
  }
}
    fragment AssignAssessmentPanelNurseAssessment on NurseAssessment {
  id
  name
  category
  requestedOn
  completedOn
  assessment {
    id
    issuingBody
  }
}`) as unknown as TypedDocumentString<AssignAssessmentMutation, AssignAssessmentMutationVariables>;
export const RequestableAssessmentSuggestionsDocument = new TypedDocumentString(`
    query RequestableAssessmentSuggestions($searchString: String) {
  getRequestableAssessmentSuggestions(search_string: $searchString) {
    ...RequestableAssessmentSuggestion
  }
}
    fragment RequestableAssessmentSuggestion on Assessment {
  id
  name
  category
}`) as unknown as TypedDocumentString<RequestableAssessmentSuggestionsQuery, RequestableAssessmentSuggestionsQueryVariables>;
export const CertificationsListCreateNurseCertificationDocument = new TypedDocumentString(`
    mutation CertificationsListCreateNurseCertification($certificationId: ID!, $input: CreateNurseCertificationInput!) {
  createNurseCertification(certificationId: $certificationId, input: $input) {
    nurseProfile {
      id
      applicationReadiness {
        meta {
          requirements {
            status
          }
        }
        results {
          certifications {
            label
            status
          }
        }
      }
      nurseCertifications {
        ...CertificationsListNurseCertification
      }
      ...CertificationsListNurseProfile
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment NurseCertificationForm on NurseCertification {
  id
  name
  expiresOn
  completedOn
  isExpired
  isExpiringSoon
  issuingBody
  useCompletionDate
  certification {
    id
    name
    issuingBody
    issuingBodies
    credential
  }
  files {
    ...FileMetadata
  }
}
fragment CertificationsListNurseProfile on NurseProfile {
  id
  canApplyJobs
  certificationsComplete
  licenses {
    id
  }
  ...CertificationsListProfileCompletion
}
fragment CertificationsListNurseCertification on NurseCertification {
  id
  name
  issuingBody
  expiresOn
  files {
    ...FileMetadata
  }
  ...NurseCertificationForm
}
fragment CertificationsListProfileCompletion on NurseProfile {
  id
  profileCompletion {
    id
    steps {
      certification {
        status
      }
    }
  }
}`) as unknown as TypedDocumentString<CertificationsListCreateNurseCertificationMutation, CertificationsListCreateNurseCertificationMutationVariables>;
export const CertificationsListUpdateNurseCertificationDocument = new TypedDocumentString(`
    mutation CertificationsListUpdateNurseCertification($id: ID!, $certificationId: ID!, $input: UpdateNurseCertificationInput!) {
  updateNurseCertification(
    id: $id
    certificationId: $certificationId
    input: $input
  ) {
    nurseProfile {
      id
      applicationReadiness {
        meta {
          requirements {
            status
          }
        }
        results {
          certifications {
            label
            status
          }
        }
      }
      nurseCertifications {
        ...CertificationsListNurseCertification
      }
      ...CertificationsListNurseProfile
    }
    errors {
      errors
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment NurseCertificationForm on NurseCertification {
  id
  name
  expiresOn
  completedOn
  isExpired
  isExpiringSoon
  issuingBody
  useCompletionDate
  certification {
    id
    name
    issuingBody
    issuingBodies
    credential
  }
  files {
    ...FileMetadata
  }
}
fragment CertificationsListNurseProfile on NurseProfile {
  id
  canApplyJobs
  certificationsComplete
  licenses {
    id
  }
  ...CertificationsListProfileCompletion
}
fragment CertificationsListNurseCertification on NurseCertification {
  id
  name
  issuingBody
  expiresOn
  files {
    ...FileMetadata
  }
  ...NurseCertificationForm
}
fragment CertificationsListProfileCompletion on NurseProfile {
  id
  profileCompletion {
    id
    steps {
      certification {
        status
      }
    }
  }
}`) as unknown as TypedDocumentString<CertificationsListUpdateNurseCertificationMutation, CertificationsListUpdateNurseCertificationMutationVariables>;
export const CertificationsListDeleteNurseCertificationDocument = new TypedDocumentString(`
    mutation CertificationsListDeleteNurseCertification($id: ID!) {
  deleteNurseCertification(id: $id) {
    nurseProfile {
      id
      applicationReadiness {
        meta {
          requirements {
            status
          }
        }
        results {
          certifications {
            label
            status
          }
        }
      }
      nurseCertifications {
        ...CertificationsListNurseCertification
      }
      ...CertificationsListNurseProfile
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment NurseCertificationForm on NurseCertification {
  id
  name
  expiresOn
  completedOn
  isExpired
  isExpiringSoon
  issuingBody
  useCompletionDate
  certification {
    id
    name
    issuingBody
    issuingBodies
    credential
  }
  files {
    ...FileMetadata
  }
}
fragment CertificationsListNurseProfile on NurseProfile {
  id
  canApplyJobs
  certificationsComplete
  licenses {
    id
  }
  ...CertificationsListProfileCompletion
}
fragment CertificationsListNurseCertification on NurseCertification {
  id
  name
  issuingBody
  expiresOn
  files {
    ...FileMetadata
  }
  ...NurseCertificationForm
}
fragment CertificationsListProfileCompletion on NurseProfile {
  id
  profileCompletion {
    id
    steps {
      certification {
        status
      }
    }
  }
}`) as unknown as TypedDocumentString<CertificationsListDeleteNurseCertificationMutation, CertificationsListDeleteNurseCertificationMutationVariables>;
export const CertificationDocument = new TypedDocumentString(`
    query Certification($id: ID!, $includeCertification: Boolean!, $includeCertifications: Boolean!) {
  nurseProfile {
    id
    role {
      id
      type
    }
    ... @include(if: $includeCertifications) {
      nurseCertifications {
        id
        name
      }
    }
  }
  ... @include(if: $includeCertification) {
    nurseCertification(id: $id) {
      id
      ...CertificationsListNurseCertification
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment NurseCertificationForm on NurseCertification {
  id
  name
  expiresOn
  completedOn
  isExpired
  isExpiringSoon
  issuingBody
  useCompletionDate
  certification {
    id
    name
    issuingBody
    issuingBodies
    credential
  }
  files {
    ...FileMetadata
  }
}
fragment CertificationsListNurseCertification on NurseCertification {
  id
  name
  issuingBody
  expiresOn
  files {
    ...FileMetadata
  }
  ...NurseCertificationForm
}`) as unknown as TypedDocumentString<CertificationQuery, CertificationQueryVariables>;
export const CreateResumeFileDocument = new TypedDocumentString(`
    mutation CreateResumeFile($nurseProfileId: ID!) {
  createResumeFile(nurseProfileId: $nurseProfileId) {
    resumeFile {
      ...FileMetadata
    }
    resumeTitle
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}`) as unknown as TypedDocumentString<CreateResumeFileMutation, CreateResumeFileMutationVariables>;
export const DocumentUpsertDocument = new TypedDocumentString(`
    mutation DocumentUpsert($title: String!, $docType: String!, $fileUuids: [String]) {
  documentUpsert(title: $title, doc_type: $docType, file_uuids: $fileUuids) {
    id
    uuid
  }
}
    `) as unknown as TypedDocumentString<DocumentUpsertMutation, DocumentUpsertMutationVariables>;
export const QualificationQuestionsCareSettingDocument = new TypedDocumentString(`
    mutation QualificationQuestionsCareSetting($id: ID!, $input: UpdateNursePreferencesInput!) {
  updateNursePreferences(id: $id, input: $input) {
    nurseProfile {
      id
      nursePreferences {
        id
        ...QualificationQuestionsCareSettingNursePreferences
      }
    }
  }
}
    fragment QualificationQuestionsCareSettingNursePreferences on NursePreferences {
  id
  careSettingOther
  careSettingPrefs
}`) as unknown as TypedDocumentString<QualificationQuestionsCareSettingMutation, QualificationQuestionsCareSettingMutationVariables>;
export const QualificationCareSettingDocument = new TypedDocumentString(`
    query QualificationCareSetting {
  viewer {
    ... on User {
      id
      signupSource
      intercomUserHash
      nurseProfile {
        id
        nursePreferences {
          id
          ...QualificationQuestionsCareSettingNursePreferences
        }
      }
    }
  }
}
    fragment QualificationQuestionsCareSettingNursePreferences on NursePreferences {
  id
  careSettingOther
  careSettingPrefs
}`) as unknown as TypedDocumentString<QualificationCareSettingQuery, QualificationCareSettingQueryVariables>;
export const ClinicalExperienceFormUpdateNurseProfileDocument = new TypedDocumentString(`
    mutation ClinicalExperienceFormUpdateNurseProfile($id: ID!, $clinicalSpecialtyIds: [ID!], $wizardCompleted: Boolean!) {
  updateNurseProfile(
    id: $id
    input: {clinicalSpecialtyIds: $clinicalSpecialtyIds, wizardCompleted: $wizardCompleted}
  ) {
    nurseProfile {
      id
      wizardCompleted
      clinicalExperiences {
        id
        isPrimary
        clinicalSpecialty {
          ...ClinicalSpecialtySuggestionsClinicalSpecialty
        }
      }
    }
  }
}
    fragment ClinicalSpecialtySuggestionsClinicalSpecialty on ClinicalSpecialty {
  id
  slug
  fullName
  displayName
  pediatric
  nicu
}`) as unknown as TypedDocumentString<ClinicalExperienceFormUpdateNurseProfileMutation, ClinicalExperienceFormUpdateNurseProfileMutationVariables>;
export const ClinicalExperienceQualificationStepDocument = new TypedDocumentString(`
    query ClinicalExperienceQualificationStep($transitionFlow: Boolean!) {
  viewer {
    ... on User {
      id
      signupSource
      nurseProfile {
        id
        wizardCompleted
        location {
          id
          locationString
        }
        clinicalExperiences {
          id
          isPrimary
          clinicalSpecialty {
            ...ClinicalSpecialtySuggestionsClinicalSpecialty
          }
        }
        ... @include(if: $transitionFlow) {
          positions {
            ...ClinicalExperienceFormPosition
          }
        }
        role {
          id
          key
          name
          type
        }
      }
    }
  }
}
    fragment ClinicalSpecialtySuggestionsClinicalSpecialty on ClinicalSpecialty {
  id
  slug
  fullName
  displayName
  pediatric
  nicu
}
fragment ClinicalExperienceFormPosition on Position {
  id
  specialties {
    ...ClinicalExperienceFormSpecialty
  }
}
fragment ClinicalExperienceFormSpecialty on ClinicalSpecialty {
  displayName
  fullName
  id
  nicu
  pediatric
  slug
  uuid
}`) as unknown as TypedDocumentString<ClinicalExperienceQualificationStepQuery, ClinicalExperienceQualificationStepQueryVariables>;
export const JobSearchInitialJobSearchDocument = new TypedDocumentString(`
    mutation JobSearchInitialJobSearch($id: ID!, $input: UpdateNursePreferencesInput!) {
  updateNursePreferences(id: $id, input: $input) {
    nurseProfile {
      id
      nursePreferences {
        id
        startPref
        earliestStartDate
      }
    }
  }
}
    `) as unknown as TypedDocumentString<JobSearchInitialJobSearchMutation, JobSearchInitialJobSearchMutationVariables>;
export const JobSearchDocument = new TypedDocumentString(`
    query JobSearch {
  viewer {
    ... on User {
      id
      intercomUserHash
      signupSource
      nurseProfile {
        id
        nursePreferences {
          id
          ...QualificationQuestionsNursePreferences
        }
      }
    }
  }
}
    fragment QualificationQuestionsNursePreferences on NursePreferences {
  id
  startPref
  earliestStartDate
}`) as unknown as TypedDocumentString<JobSearchQuery, JobSearchQueryVariables>;
export const LicensesStepLicensesDocument = new TypedDocumentString(`
    mutation LicensesStepLicenses($id: ID!, $input: CreateMultipleLicensesInput!) {
  createMultipleLicenses(id: $id, input: $input) {
    nurseProfile {
      id
      licenses {
        ...QualificationQuestionsLicense
      }
    }
  }
}
    fragment QualificationQuestionsLicense on License {
  id
  licensureCompact
}`) as unknown as TypedDocumentString<LicensesStepLicensesMutation, LicensesStepLicensesMutationVariables>;
export const LicensesStepDocument = new TypedDocumentString(`
    query LicensesStep {
  viewer {
    ... on User {
      id
      intercomUserHash
      signupSource
      nurseProfile {
        ...QualificationQuestionsNurseProfile
      }
    }
  }
}
    fragment QualificationQuestionsNurseProfile on NurseProfile {
  id
  roleKey
  licenses {
    id
    state
    stateCode
    licensureCompact
    licenseType
  }
}`) as unknown as TypedDocumentString<LicensesStepQuery, LicensesStepQueryVariables>;
export const LocationPreferencesUpdateDocument = new TypedDocumentString(`
    mutation LocationPreferencesUpdate($id: ID!, $input: UpdateNursePreferencesInput!) {
  updateNursePreferences(id: $id, input: $input) {
    nurseProfile {
      id
      nursePreferences {
        id
        broadPrefLocations
      }
    }
  }
}
    `) as unknown as TypedDocumentString<LocationPreferencesUpdateMutation, LocationPreferencesUpdateMutationVariables>;
export const LocationPreferencesDefaultDocument = new TypedDocumentString(`
    query LocationPreferencesDefault {
  viewer {
    ... on User {
      id
      signupSource
      nurseProfile {
        id
        nursePreferences {
          id
          ...LocationPreferencesNursePreferences
        }
      }
    }
  }
}
    fragment LocationPreferencesNursePreferences on NursePreferences {
  id
  broadPrefLocations
  locations {
    id
    locationString
    googlePlaceId
    formattedLocationString
  }
}`) as unknown as TypedDocumentString<LocationPreferencesDefaultQuery, LocationPreferencesDefaultQueryVariables>;
export const MultipleShiftPreferencesStepDocument = new TypedDocumentString(`
    mutation MultipleShiftPreferencesStep($id: ID!, $input: UpdateNursePreferencesInput!) {
  updateNursePreferences(id: $id, input: $input) {
    nurseProfile {
      id
      nursePreferences {
        id
        shiftPrefs
      }
    }
  }
}
    `) as unknown as TypedDocumentString<MultipleShiftPreferencesStepMutation, MultipleShiftPreferencesStepMutationVariables>;
export const QualificationShiftPreferencesDocument = new TypedDocumentString(`
    query QualificationShiftPreferences {
  viewer {
    ... on User {
      id
      intercomUserHash
      signupSource
      nurseProfile {
        id
        nursePreferences {
          id
          ...ShiftPrefNursePreferences
        }
      }
    }
  }
}
    fragment ShiftPrefNursePreferences on NursePreferences {
  id
  shiftPref
  shiftPrefs
}`) as unknown as TypedDocumentString<QualificationShiftPreferencesQuery, QualificationShiftPreferencesQueryVariables>;
export const PrimarySignupPhoneConfirmationDocument = new TypedDocumentString(`
    mutation PrimarySignupPhoneConfirmation($id: ID!, $input: UpdateNursePreferencesInput!) {
  updateNursePreferences(id: $id, input: $input) {
    nurseProfile {
      id
      state
      nursePreferences {
        id
        learningPrefs
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PrimarySignupPhoneConfirmationMutation, PrimarySignupPhoneConfirmationMutationVariables>;
export const PhoneConfirmationStepDocument = new TypedDocumentString(`
    query PhoneConfirmationStep {
  viewer {
    ... on User {
      ...PhoneConfirmationStepUser
    }
  }
}
    fragment PhoneConfirmationStepUser on User {
  id
  intercomUserHash
  signupSource
  phone
  phoneVerified
  nurseProfile {
    id
    nursePreferences {
      id
    }
  }
}`) as unknown as TypedDocumentString<PhoneConfirmationStepQuery, PhoneConfirmationStepQueryVariables>;
export const PhoneNumberStepDocument = new TypedDocumentString(`
    query PhoneNumberStep {
  viewer {
    ... on User {
      id
      intercomUserHash
      signupSource
      ...SMSVerificationUser
    }
  }
}
    fragment SMSVerificationUser on User {
  id
  phone
  phoneVerified
  marketingSmsAllowed
}`) as unknown as TypedDocumentString<PhoneNumberStepQuery, PhoneNumberStepQueryVariables>;
export const StartQualificationQuestionsDocument = new TypedDocumentString(`
    query StartQualificationQuestions {
  viewer {
    ... on User {
      id
      intercomUserHash
      signupSource
    }
  }
}
    `) as unknown as TypedDocumentString<StartQualificationQuestionsQuery, StartQualificationQuestionsQueryVariables>;
export const TravelExperienceDocument = new TypedDocumentString(`
    mutation TravelExperience($id: ID!, $input: UpdateNursePreferencesInput!) {
  updateNursePreferences(id: $id, input: $input) {
    nurseProfile {
      id
      nursePreferences {
        id
        travelExperience
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TravelExperienceMutation, TravelExperienceMutationVariables>;
export const TravelExperienceStepDocument = new TypedDocumentString(`
    query TravelExperienceStep {
  __type(name: "TravelExperiences") {
    name
    enumValues {
      name
      description
    }
  }
  viewer {
    ... on User {
      id
      intercomUserHash
      signupSource
      nurseProfile {
        id
        nursePreferences {
          id
          ...TravelExperienceStepNursePreferences
        }
      }
    }
  }
}
    fragment TravelExperienceStepNursePreferences on NursePreferences {
  id
  travelExperience
}`) as unknown as TypedDocumentString<TravelExperienceStepQuery, TravelExperienceStepQueryVariables>;
export const TravelExperienceTransitionStepDocument = new TypedDocumentString(`
    query TravelExperienceTransitionStep {
  viewer {
    ... on User {
      id
      intercomUserHash
      signupSource
      nurseProfile {
        id
        nursePreferences {
          id
          travelExperience
        }
        role {
          id
          type
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TravelExperienceTransitionStepQuery, TravelExperienceTransitionStepQueryVariables>;
export const RequestInterviewButtonExpressInterestDocument = new TypedDocumentString(`
    mutation RequestInterviewButtonExpressInterest($id: String!, $source: String) {
  expressInterest(job_uuid: $id, source: $source) {
    id
    esMatch {
      id
      userState
    }
  }
}
    `) as unknown as TypedDocumentString<RequestInterviewButtonExpressInterestMutation, RequestInterviewButtonExpressInterestMutationVariables>;
export const RequestAutoOfferButtonDocument = new TypedDocumentString(`
    query RequestAutoOfferButton {
  viewer {
    ... on User {
      id
      nurseProfile {
        id
        requestedJobs {
          inProgressInstantOffers {
            nodes {
              id
              title
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<RequestAutoOfferButtonQuery, RequestAutoOfferButtonQueryVariables>;
export const UploadResumeDocument = new TypedDocumentString(`
    mutation UploadResume($upload: FileUploadTypeInput!) {
  uploadResume(upload: $upload) {
    uploadedResume {
      id
      resumeParserStep
    }
  }
}
    `) as unknown as TypedDocumentString<UploadResumeMutation, UploadResumeMutationVariables>;
export const UploadedResumeDocument = new TypedDocumentString(`
    query UploadedResume {
  uploadedResume {
    id
    fileName
    status
    parserIdsCompleted
  }
}
    `) as unknown as TypedDocumentString<UploadedResumeQuery, UploadedResumeQueryVariables>;
export const ClinicalExperienceListUpdateNurseProfileDocument = new TypedDocumentString(`
    mutation ClinicalExperienceListUpdateNurseProfile($specialtySlugs: [String!]!) {
  nurseProfileClinicalExperiencesUpdate(specialtySlugs: $specialtySlugs) {
    id
    clinicalSpecialties {
      ...ClinicalSpecialtySuggestionsClinicalSpecialty
    }
  }
}
    fragment ClinicalSpecialtySuggestionsClinicalSpecialty on ClinicalSpecialty {
  id
  slug
  fullName
  displayName
  pediatric
  nicu
}`) as unknown as TypedDocumentString<ClinicalExperienceListUpdateNurseProfileMutation, ClinicalExperienceListUpdateNurseProfileMutationVariables>;
export const ClinicalExperienceListDocument = new TypedDocumentString(`
    query ClinicalExperienceList {
  topClinicalSpecialties {
    ...ClinicalSpecialtySuggestionsClinicalSpecialty
  }
  viewer {
    ... on User {
      id
      signupSource
      nurseProfile {
        id
        clinicalSpecialties {
          ...ClinicalSpecialtySuggestionsClinicalSpecialty
        }
        nursePreferences {
          id
        }
        ...ClinicalExperienceListNurseProfile
      }
    }
  }
}
    fragment ClinicalSpecialtySuggestionsClinicalSpecialty on ClinicalSpecialty {
  id
  slug
  fullName
  displayName
  pediatric
  nicu
}
fragment ClinicalExperienceListNurseProfile on NurseProfile {
  id
  clinicalSpecialties {
    ...ClinicalSpecialtySuggestionsClinicalSpecialty
  }
  nursePreferences {
    id
  }
  role {
    id
    key
    name
    type
  }
}`) as unknown as TypedDocumentString<ClinicalExperienceListQuery, ClinicalExperienceListQueryVariables>;
export const ClinicalExperienceStepUpdateNurseProfileDocument = new TypedDocumentString(`
    mutation ClinicalExperienceStepUpdateNurseProfile($id: ID!, $input: UpdateNurseProfileInput!) {
  updateNurseProfile(id: $id, input: $input) {
    nurseProfile {
      id
      clinicalExperienceLevel
    }
  }
}
    `) as unknown as TypedDocumentString<ClinicalExperienceStepUpdateNurseProfileMutation, ClinicalExperienceStepUpdateNurseProfileMutationVariables>;
export const ClinicalExperienceStepDocument = new TypedDocumentString(`
    query ClinicalExperienceStep {
  __type(name: "ClinicalExperienceLevelTypes") {
    name
    enumValues {
      name
      description
    }
  }
  viewer {
    ... on User {
      id
      ...ClinicalExperienceStepUser
    }
  }
}
    fragment ClinicalExperienceStepUser on User {
  id
  signupSource
  intercomUserHash
  nurseProfile {
    id
    clinicalExperienceLevel
  }
}`) as unknown as TypedDocumentString<ClinicalExperienceStepQuery, ClinicalExperienceStepQueryVariables>;
export const UpsertClinicianLocationDocument = new TypedDocumentString(`
    mutation UpsertClinicianLocation($locationString: String!) {
  upsertClinicianLocation(locationString: $locationString) {
    nurseProfile {
      id
      wizardCompleted
      location {
        id
        googlePlaceId
        locationString
      }
      nursePreferences {
        id
        explorerRole
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UpsertClinicianLocationMutation, UpsertClinicianLocationMutationVariables>;
export const CurrentLocationDocument = new TypedDocumentString(`
    query CurrentLocation {
  viewer {
    ... on User {
      id
      ...CurrentLocationUser
    }
  }
}
    fragment CurrentLocationUser on User {
  id
  signupSource
  nurseProfile {
    id
    wizardCompleted
    location {
      id
      googlePlaceId
      locationString
    }
  }
}`) as unknown as TypedDocumentString<CurrentLocationQuery, CurrentLocationQueryVariables>;
export const UserCreationTransitionStepDocument = new TypedDocumentString(`
    query UserCreationTransitionStep {
  viewer {
    ... on User {
      id
      ...UserCreationStepUser
    }
  }
}
    fragment UserCreationStepUser on User {
  id
  signupSource
  intercomUserHash
  initialReferringDomain
  userProperties {
    shouldSendAppcastPixel
  }
}`) as unknown as TypedDocumentString<UserCreationTransitionStepQuery, UserCreationTransitionStepQueryVariables>;
export const WithdrawRequestWithReasonDocument = new TypedDocumentString(`
    mutation WithdrawRequestWithReason($id: String!, $reason: WithdrawReasonsEnum) {
  withdrawRequest(job_uuid: $id, reason: $reason) {
    id
  }
}
    `) as unknown as TypedDocumentString<WithdrawRequestWithReasonMutation, WithdrawRequestWithReasonMutationVariables>;
export const WithdrawModalInformationDocument = new TypedDocumentString(`
    query WithdrawModalInformation {
  __type(name: "WithdrawReasonsEnum") {
    name
    enumValues {
      name
      description
    }
  }
}
    `) as unknown as TypedDocumentString<WithdrawModalInformationQuery, WithdrawModalInformationQueryVariables>;
export const WithdrawJobInformationDocument = new TypedDocumentString(`
    query WithdrawJobInformation($jobId: ID!) {
  job(id: $jobId) {
    id
    licenseType
    business {
      id
      name
    }
    clinicalUnit {
      id
      displayName
    }
  }
}
    `) as unknown as TypedDocumentString<WithdrawJobInformationQuery, WithdrawJobInformationQueryVariables>;
export const AccountPageNestedUpdateUserDocument = new TypedDocumentString(`
    mutation AccountPageNestedUpdateUser($id: ID!, $input: NestedUpdateUserInput!) {
  nestedUpdateUser(id: $id, input: $input, raiseValidationErrors: false) {
    user {
      ...AccountPageFormUser
    }
    token
    roleType
    errors {
      attribute
      errors
    }
  }
}
    fragment PermanentAddressUser on User {
  id
  cityPermanent
  countryPermanentCode
  countryPermanentName
  googlePlaceIdPermanent
  statePermanent
  streetAddressPermanent
  streetNumberPermanent
  zipcodePermanent
  nurseProfile {
    id
    profileCompletion {
      id
      steps {
        permanentAddress {
          label
          message
          status
        }
      }
    }
  }
}
fragment EmailVerificationHintUser on User {
  id
  email
  confirmedAt
}
fragment PhoneVerificationHintUser on User {
  id
  phone
  phoneVerified
}
fragment CurrentAddressUser on User {
  id
  city
  state
  streetAddress
  zipcode
}
fragment AccountContactInformationPaperUser on User {
  id
  firstName
  lastName
  middleName
  preferredName
  preferredPronoun
  ...CurrentAddressUser
  ...EmailVerificationHintUser
  ...PermanentAddressUser
  ...PhoneVerificationHintUser
}
fragment AccountPageFormUser on User {
  id
  intercomUserHash
  subscribedCeuEmail
  subscribedInvitesEmail
  subscribedMatchesEmail
  subscribedBrazeRootEmail
  subscribedNewsletterEmail
  subscribedReferencesEmail
  subscribedCredentialsEmail
  subscribedProductUpdatesEmail
  subscribedJobApplicationsEmail
  marketingSmsAllowed
  nurseProfile {
    id
    birthday
    dlNumber
    dlState
    dlExpiresOn
    ssnLast4
    fullSsnCollected
  }
  ...AccountContactInformationPaperUser
}`) as unknown as TypedDocumentString<AccountPageNestedUpdateUserMutation, AccountPageNestedUpdateUserMutationVariables>;
export const AccountPageDocument = new TypedDocumentString(`
    query AccountPage {
  viewer {
    ... on User {
      ...AccountPageFormUser
    }
  }
}
    fragment PermanentAddressUser on User {
  id
  cityPermanent
  countryPermanentCode
  countryPermanentName
  googlePlaceIdPermanent
  statePermanent
  streetAddressPermanent
  streetNumberPermanent
  zipcodePermanent
  nurseProfile {
    id
    profileCompletion {
      id
      steps {
        permanentAddress {
          label
          message
          status
        }
      }
    }
  }
}
fragment EmailVerificationHintUser on User {
  id
  email
  confirmedAt
}
fragment PhoneVerificationHintUser on User {
  id
  phone
  phoneVerified
}
fragment CurrentAddressUser on User {
  id
  city
  state
  streetAddress
  zipcode
}
fragment AccountContactInformationPaperUser on User {
  id
  firstName
  lastName
  middleName
  preferredName
  preferredPronoun
  ...CurrentAddressUser
  ...EmailVerificationHintUser
  ...PermanentAddressUser
  ...PhoneVerificationHintUser
}
fragment AccountPageFormUser on User {
  id
  intercomUserHash
  subscribedCeuEmail
  subscribedInvitesEmail
  subscribedMatchesEmail
  subscribedBrazeRootEmail
  subscribedNewsletterEmail
  subscribedReferencesEmail
  subscribedCredentialsEmail
  subscribedProductUpdatesEmail
  subscribedJobApplicationsEmail
  marketingSmsAllowed
  nurseProfile {
    id
    birthday
    dlNumber
    dlState
    dlExpiresOn
    ssnLast4
    fullSsnCollected
  }
  ...AccountContactInformationPaperUser
}`) as unknown as TypedDocumentString<AccountPageQuery, AccountPageQueryVariables>;
export const AppSignupCompletePageDocument = new TypedDocumentString(`
    query AppSignupCompletePage {
  viewer {
    ... on User {
      id
      email
      firstName
    }
  }
}
    `) as unknown as TypedDocumentString<AppSignupCompletePageQuery, AppSignupCompletePageQueryVariables>;
export const ClearUnavailableRequestedMatchesDocument = new TypedDocumentString(`
    mutation ClearUnavailableRequestedMatches {
  clearUnavailableRequestedMatches {
    jobs {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<ClearUnavailableRequestedMatchesMutation, ClearUnavailableRequestedMatchesMutationVariables>;
export const JobApplicationsSummaryDocument = new TypedDocumentString(`
    query JobApplicationsSummary {
  viewer {
    ... on User {
      nurseProfile {
        id
        isActivated
        canApplyJobs
        canViewJobs
        jobApplicationsSummary {
          ...JobApplicationsSummary
        }
        ...PreviousOffersSummary
        wizardCompleted
      }
      ...JobApplicationsSummaryUser
    }
  }
  profileCompletionSummary {
    ...ProfileCompletionSummary
  }
}
    fragment ProfileCompletionSummary on ProfileCompletionSummary {
  id
  completedAt
  meta {
    id
    completeCount
    expiredCount
    expiringCount
    incompleteCount
    pendingCount
    percentCompleted
  }
  steps {
    estimatedTimeInMinutes
    key
    title
    subtitle
    messages
    sectionName
    status
    hasExpiringItems
    hasExpiredItems
    hasInvalidItems
  }
}
fragment MatchCardJob on Job {
  id
  activeApplicantsCount
  favoritedCount
  hoursPerShift
  instantOffer
  jobType
  lengthInWeeks
  licenseType
  localAllowed
  onHold
  shiftType
  shiftsPerWeek
  startAsap
  startDate
  endDate
  facilityName
  cancellationPolicy
  stateActiveAt
  title
  travelAllowed
  business {
    city
    state
    ...MatchCardFacility
  }
  clinicalUnit {
    id
    displayName
  }
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  location {
    id
    city
    stateCode
  }
  localPaymentDetails {
    id
    grossPayWeekly
  }
  emr {
    id
    name
  }
}
fragment DraftApplicationMatchCardJob on Job {
  ...MatchCardJob
  jobApplication {
    id
  }
}
fragment MatchCardFacility on Facility {
  id
  name
  logo
}
fragment JobApplicationSummaryJobOfferV2 on JobOffer {
  id
  startDate
  lengthInWeeks
  shiftsPerWeek
  shiftType
  hoursPerShift
  paymentDetails {
    id
    grossPayWeekly
  }
  jobApplication {
    id
    paymentDetails {
      grossPayWeekly
    }
  }
  job {
    id
    startDate
    lengthInWeeks
    shiftsPerWeek
    shiftType
    hoursPerShift
    facilityName
    title
    location {
      id
      city
      stateCode
    }
  }
}
fragment JobApplicationSummaryJobOffer on JobOffer {
  id
  jobApplication {
    ...JobApplicationSummaryJobApplication
  }
  ...JobApplicationSummaryJobOfferV2
}
fragment JobApplicationSummaryJobApplication on JobApplication {
  id
  state
  candidateHoldReasons
  requestedAt
  job {
    ...DraftApplicationMatchCardJob
  }
}
fragment JobApplicationsSummary on JobApplicationsSummary {
  id
  offer {
    ...JobApplicationSummaryJobOffer
  }
  actionRequired {
    ...JobApplicationSummaryJobApplication
  }
  submittedToFacility {
    ...JobApplicationSummaryJobApplication
  }
  pendingTrustedReview {
    ...JobApplicationSummaryJobApplication
  }
  previous {
    ...JobApplicationSummaryJobApplication
  }
  drafted {
    ...JobApplicationSummaryJobApplication
  }
}
fragment JobApplicationsSummaryUser on User {
  id
  email
  firstName
  userProperties {
    shouldDisplayFirstFavoriteMessage
  }
  nurseProfile {
    id
    canApplyJobs
    profileCompletion {
      id
      meta {
        id
        percentCompleted
      }
    }
  }
}
fragment PreviousOffersSummary on NurseProfile {
  previousOffers: jobOffers(filter: previous) {
    id
  }
}`) as unknown as TypedDocumentString<JobApplicationsSummaryQuery, JobApplicationsSummaryQueryVariables>;
export const MatchingJobsForApplicationDocument = new TypedDocumentString(`
    query MatchingJobsForApplication($jobApplicationId: ID!) {
  viewer {
    ... on User {
      id
      ...JobApplicationCompletedPagesUser
      ...MatchDetailPageUser
    }
  }
  matchingJobsForApplication(jobApplicationId: $jobApplicationId) {
    id
    jobApplication {
      id
      state
    }
    ...ApplicableMatchCardJob
    ...JobApplicationCanApplyJob
  }
}
    fragment MatchCardJob on Job {
  id
  activeApplicantsCount
  favoritedCount
  hoursPerShift
  instantOffer
  jobType
  lengthInWeeks
  licenseType
  localAllowed
  onHold
  shiftType
  shiftsPerWeek
  startAsap
  startDate
  endDate
  facilityName
  cancellationPolicy
  stateActiveAt
  title
  travelAllowed
  business {
    city
    state
    ...MatchCardFacility
  }
  clinicalUnit {
    id
    displayName
  }
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  location {
    id
    city
    stateCode
  }
  localPaymentDetails {
    id
    grossPayWeekly
  }
  emr {
    id
    name
  }
}
fragment ApplicableMatchCardJob on Job {
  ...MatchCardJob
  esMatch {
    id
    userState
  }
}
fragment MatchCardFacility on Facility {
  id
  name
  logo
}
fragment MatchApplyButtonUser on User {
  id
  ...RequestInterviewButtonUser
}
fragment MatchFavoriteButtonUser on User {
  id
  userProperties {
    id
    shouldDisplayFirstFavoriteMessage
  }
}
fragment JobMatchTopCardBlockUser on User {
  id
  referralCode
  ...MatchApplyButtonUser
  ...MatchFavoriteButtonUser
}
fragment MatchDetailsUser on User {
  id
  ...JobMatchTopCardBlockUser
}
fragment RequestInterviewButtonUser on User {
  id
  nurseProfile {
    ...RequestInterviewButtonNurseProfile
  }
  ...JobApplicationRequirementsUser
}
fragment RequestInterviewButtonNurseProfile on NurseProfile {
  id
  isActivated
  canApplyJobs
  profileCompletion {
    id
    meta {
      id
      percentCompleted
    }
  }
  state
}
fragment JobApplicationRequirementsUser on User {
  id
  email
  firstName
  lastName
  nurseProfile {
    ...JobApplicationRequirementsNurseProfile
  }
}
fragment JobApplicationRequirementsNurseAdvocate on SalesforceUser {
  id
  email
  fullName
}
fragment JobApplicationRequirementsNurseProfile on NurseProfile {
  id
  state
  percentComplete
  profileCompletion {
    id
  }
  nurseAdvocate {
    ...JobApplicationRequirementsNurseAdvocate
  }
}
fragment JobApplicationCompletedPagesUser on User {
  id
  nurseProfile {
    ...JobApplicationNurseProfile
  }
}
fragment JobApplicationNurseProfile on NurseProfile {
  id
}
fragment JobApplicationCanApplyJob on Job {
  id
  jobApplication {
    id
    state
  }
  onHold
  state
}
fragment MatchDetailPageUser on User {
  id
  ...MatchDetailsUser
  ...UserViewedMatchEventUser
}
fragment UserViewedMatchEventUser on User {
  id
  email
  firstName
  lastName
  nurseProfile {
    id
    percentComplete
    nurseAdvocate {
      id
      email
      fullName
    }
  }
}`) as unknown as TypedDocumentString<MatchingJobsForApplicationQuery, MatchingJobsForApplicationQueryVariables>;
export const ApplyToSimilarJobsDocument = new TypedDocumentString(`
    mutation ApplyToSimilarJobs($jobApplicationId: ID!, $jobIds: [ID!]!) {
  applyToSimilarJobs(jobApplicationId: $jobApplicationId, jobIds: $jobIds) {
    ... on JobApplication {
      id
      job {
        id
      }
      state
    }
    ... on JobWithError {
      ...JobWithError
    }
  }
}
    fragment JobWithError on JobWithError {
  job {
    id
    grossPayWeekly
    location {
      id
      city
      stateCode
    }
    business {
      id
      name
    }
  }
  errors
}`) as unknown as TypedDocumentString<ApplyToSimilarJobsMutation, ApplyToSimilarJobsMutationVariables>;
export const BucketMatchesPageDocument = new TypedDocumentString(`
    query BucketMatchesPage($bucketKey: String!, $excludeFavoritedJobs: Boolean, $paginate: OffsetPaginationInput) {
  bucketJobsByKey(
    bucketKey: $bucketKey
    excludeFavoritedJobs: $excludeFavoritedJobs
    paginate: $paginate
  ) {
    id
    records {
      ...MatchDetailsJob
    }
    totalRecords
  }
}
    fragment JobGoogleMapLocation on Location {
  id
  latitude
  longitude
}
fragment JobMatchFacilityBlockJob on Job {
  business {
    id
    name
    address
    city
    logo
    state
    zipcode
    slug
    rankings {
      id
      usnewsType
    }
    hospital {
      id
      teaching
      traumaCenterLevel
      affiliatedUnion
      totalLicensedBeds
      hospitalSystem
      hospitalType
      jointCommission
      magnet
    }
  }
}
fragment MatchApplyButtonJob on Job {
  id
  canApply {
    value
    reasons {
      fullMessages
    }
  }
  esMatch {
    id
  }
  ...RequestInterviewButtonJob
}
fragment MatchFavoriteButtonJob on Job {
  id
  canFavorite {
    value
    reasons {
      fullMessages
    }
  }
  esMatch {
    id
    userState
  }
}
fragment MatchWithdrawButtonJob on Job {
  id
  canWithdraw {
    value
    reasons {
      fullMessages
    }
  }
}
fragment JobMatchTopCardBlockJob on Job {
  id
  instantOffer
  business {
    id
    hideMatchInfo
    name
    city
    state
  }
  hoursPerShift
  jobType
  lengthInWeeks
  location {
    id
    city
    stateCode
  }
  positionCount
  shiftsPerWeek
  shiftType
  startAsap
  startDate
  title
  jobApplication {
    id
    state
  }
  ...JobUtilsPayRateJob
  ...MatchApplyButtonJob
  ...MatchFavoriteButtonJob
  ...MatchWithdrawButtonJob
}
fragment MatchDetailsJob on Job {
  id
  state
  business {
    id
    bgImageFlickrUrl
    hideMatchInfo
    state
    location {
      id
      city
      stateCode
    }
  }
  cityLocation {
    ...JobGoogleMapLocation
  }
  clinicalUnit {
    id
    displayName
  }
  endDate
  friendlyLicenseType
  hoursPerShift
  jobType
  jobApplication {
    id
    candidateHoldReasons
    state
  }
  defaultPaymentDetails {
    ...MatchDetailsJobPaymentDetails
  }
  localPaymentDetails {
    ...MatchDetailsJobPaymentDetails
  }
  location {
    id
    city
    stateCode
    ...JobGoogleMapLocation
  }
  lengthInWeeks
  licenseType
  nursePatientRatio
  publicDescription
  roles {
    id
    type
  }
  shiftEnd
  shiftType
  shiftsPerWeek
  shiftStart
  startAsap
  startDate
  ...JobMatchTopCardBlockJob
  ...JobMatchFacilityBlockJob
  ...MatchDetailsPreferredJars
  ...MatchDetailsRequiredJars
  ...UserViewedMatchEventJob
}
fragment MatchDetailsPreferredJars on Job {
  preferredJarsV2 {
    __typename
    ... on JobApplicationRequirementsMaximumTimeOffRule {
      ...JarMaximumTimeOffRule
    }
    ... on JobApplicationRequirementsRadiusRule {
      ...JarRadiusRule
    }
    ... on JobApplicationRequirementsLocationFloating {
      ...JarLocationFloating
    }
    ... on JobApplicationRequirementsUnitFloating {
      ...JarUnitFloating
    }
    ... on JobApplicationRequirementsCovidVaccine {
      ...JarCovidVaccine
    }
    ... on JobApplicationRequirementsCovidBooster {
      ...JarCovidBooster
    }
    ... on JobApplicationRequirementsFluVaccine {
      ...JarFluVaccine
    }
    ... on JobApplicationRequirementsFluVaccination {
      ...JarFluVaccination
    }
    ... on JobApplicationRequirementsRoleExperience {
      ...JarRoleExperience
    }
    ... on JobApplicationRequirementsUnitExperience {
      ...JarUnitExperience
    }
    ... on JobApplicationRequirementsTechnologyExperience {
      ...JarTechnologyExperience
    }
    ... on JobApplicationRequirementsTravelExperience {
      ...JarTravelExperience
    }
    ... on JobApplicationRequirementsStateLicense {
      ...JarStateLicense
    }
    ... on JobApplicationRequirementsDriverLicense {
      ...JarDriverLicense
    }
    ... on JobApplicationRequirementsNurseReference {
      ...JarNurseReference
    }
    ... on JobApplicationRequirementsCertification {
      ...JarCertification
    }
    ... on JobApplicationRequirementsProofOfIdentification {
      ...JarProofOfIdentification
    }
    ... on JobApplicationRequirementsTraumaLevelExperience {
      ...JarTraumaLevelExperience
    }
    ... on JobApplicationRequirementsEducation {
      ...JarEducation
    }
  }
}
fragment MatchDetailsRequiredJars on Job {
  requiredJarsV2 {
    __typename
    ... on JobApplicationRequirementsRadiusRule {
      ...JarRadiusRule
    }
    ... on JobApplicationRequirementsMaximumTimeOffRule {
      ...JarMaximumTimeOffRule
    }
    ... on JobApplicationRequirementsLocationFloating {
      ...JarLocationFloating
    }
    ... on JobApplicationRequirementsUnitFloating {
      ...JarUnitFloating
    }
    ... on JobApplicationRequirementsCovidVaccine {
      ...JarCovidVaccine
    }
    ... on JobApplicationRequirementsCovidBooster {
      ...JarCovidBooster
    }
    ... on JobApplicationRequirementsFluVaccine {
      ...JarFluVaccine
    }
    ... on JobApplicationRequirementsFluVaccination {
      ...JarFluVaccination
    }
    ... on JobApplicationRequirementsRoleExperience {
      ...JarRoleExperience
    }
    ... on JobApplicationRequirementsUnitExperience {
      ...JarUnitExperience
    }
    ... on JobApplicationRequirementsTechnologyExperience {
      ...JarTechnologyExperience
    }
    ... on JobApplicationRequirementsTravelExperience {
      ...JarTravelExperience
    }
    ... on JobApplicationRequirementsStateLicense {
      ...JarStateLicense
    }
    ... on JobApplicationRequirementsDriverLicense {
      ...JarDriverLicense
    }
    ... on JobApplicationRequirementsNurseReference {
      ...JarNurseReference
    }
    ... on JobApplicationRequirementsCertification {
      ...JarCertification
    }
    ... on JobApplicationRequirementsProofOfIdentification {
      ...JarProofOfIdentification
    }
    ... on JobApplicationRequirementsTraumaLevelExperience {
      ...JarTraumaLevelExperience
    }
    ... on JobApplicationRequirementsEducation {
      ...JarEducation
    }
  }
}
fragment MatchDetailsJobPaymentDetails on JobPaymentDetails {
  id
  blendedWageRate
  callBackRate
  doubleTimeMultiplier
  extraRate
  grossPayWeekly
  holidayRate
  incidentalsStipendDaily
  lodgingStipendDaily
  onCallRate
  overtimeHoursPerWeek
  overtimeMultiplier
  overtimeWageRate
  regularHoursPerWeek
  regularWageRate
  totalHoursPerWeek
}
fragment RequestInterviewButtonJob on Job {
  id
  canApply {
    value
    reasons {
      fullMessages
    }
  }
  instantOffer
  jobApplication {
    id
    state
  }
  onHold
  ...UserViewedMatchEventJob
}
fragment JarRadiusRule on JobApplicationRequirementsRadiusRule {
  id
  type
  description
}
fragment JarCertification on JobApplicationRequirementsCertification {
  id
  type
  title
  description
  certification {
    id
    credential
    name
    uuid
    issuingBodies
  }
}
fragment JarNurseReference on JobApplicationRequirementsNurseReference {
  id
  description
  occurrences
  timeframe
  type
}
fragment JarDriverLicense on JobApplicationRequirementsDriverLicense {
  id
  required
  type
  stage
}
fragment JarCovidVaccine on JobApplicationRequirementsCovidVaccine {
  id
  type
  stage
  description
}
fragment JarCovidBooster on JobApplicationRequirementsCovidBooster {
  id
  type
  stage
  description
}
fragment JarFluVaccine on JobApplicationRequirementsFluVaccine {
  id
  type
  stage
  description
}
fragment JarFluVaccination on JobApplicationRequirementsFluVaccination {
  id
  type
  stage
  description
}
fragment JarLocationFloating on JobApplicationRequirementsLocationFloating {
  id
  type
  description
}
fragment JarMaximumTimeOffRule on JobApplicationRequirementsMaximumTimeOffRule {
  id
  type
  maximumTimeOff
  description
}
fragment JarUnitFloating on JobApplicationRequirementsUnitFloating {
  id
  type
  description
}
fragment JarStateLicense on JobApplicationRequirementsStateLicense {
  id
  stage
  type
  description
}
fragment JarTravelExperience on JobApplicationRequirementsTravelExperience {
  id
  type
  months
  description
}
fragment JarRoleExperience on JobApplicationRequirementsRoleExperience {
  id
  type
  months
  description
}
fragment JarUnitExperience on JobApplicationRequirementsUnitExperience {
  id
  type
  months
  description
}
fragment JarTechnologyExperience on JobApplicationRequirementsTechnologyExperience {
  id
  type
  months
  description
  technology {
    id
    uuid
    name
  }
}
fragment JarProofOfIdentification on JobApplicationRequirementsProofOfIdentification {
  id
  type
  description
  required
  stage
}
fragment JarTraumaLevelExperience on JobApplicationRequirementsTraumaLevelExperience {
  id
  type
  description
  enforcementType
}
fragment JarEducation on JobApplicationRequirementsEducation {
  id
  type
  description
  enforcementType
}
fragment JobUtilsPayRateJob on Job {
  id
  travelAllowed
  localAllowed
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  grossPayWeekly
  jobType
  localGrossPayWeekly
  localPaymentDetails {
    id
    grossPayWeekly
  }
}
fragment UserViewedMatchEventJob on Job {
  id
  activeApplicantsCount
  business {
    id
    city
    name
    logo
    state
  }
  clinicalUnit {
    id
    displayName
  }
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  favoritedCount
  grossPayWeekly
  hoursPerShift
  instantOffer
  jobType
  lengthInWeeks
  shiftsPerWeek
  shiftType
  startDate
  stateActiveAt
  title
}`) as unknown as TypedDocumentString<BucketMatchesPageQuery, BucketMatchesPageQueryVariables>;
export const CreateCeuGoalDocument = new TypedDocumentString(`
    mutation CreateCeuGoal($nurseProfileId: ID!, $input: CreateCeuGoalInput!) {
  createCeuGoal(nurseProfileId: $nurseProfileId, input: $input) {
    ceuGoal {
      ...CeuGoalContainerCeuGoal
    }
  }
}
    fragment CeuGoalContainerCeuGoal on CeuGoal {
  id
  goalType
  requiredContactHours
  startDate
  endDate
  description
  systemCreated
  accepted
  deleted
  completedContactHours
  ceuStateRequirement {
    id
    state
    requiredContactHours
    notes
    requirementQuantity
    requirementDescription
    stateBonUrl
    durationDays
    licenseType
  }
  ceuCertificates {
    id
  }
}`) as unknown as TypedDocumentString<CreateCeuGoalMutation, CreateCeuGoalMutationVariables>;
export const UpdateCeuGoalDocument = new TypedDocumentString(`
    mutation UpdateCeuGoal($id: ID!, $input: UpdateCeuGoalInput!) {
  updateCeuGoal(id: $id, input: $input) {
    ceuGoal {
      ...CeuGoalContainerCeuGoal
    }
  }
}
    fragment CeuGoalContainerCeuGoal on CeuGoal {
  id
  goalType
  requiredContactHours
  startDate
  endDate
  description
  systemCreated
  accepted
  deleted
  completedContactHours
  ceuStateRequirement {
    id
    state
    requiredContactHours
    notes
    requirementQuantity
    requirementDescription
    stateBonUrl
    durationDays
    licenseType
  }
  ceuCertificates {
    id
  }
}`) as unknown as TypedDocumentString<UpdateCeuGoalMutation, UpdateCeuGoalMutationVariables>;
export const DeleteCeuGoalDocument = new TypedDocumentString(`
    mutation DeleteCeuGoal($id: ID!) {
  deleteCeuGoal(id: $id) {
    nurseProfile {
      id
      ceuGoals {
        ...CeuGoalContainerCeuGoal
      }
    }
  }
}
    fragment CeuGoalContainerCeuGoal on CeuGoal {
  id
  goalType
  requiredContactHours
  startDate
  endDate
  description
  systemCreated
  accepted
  deleted
  completedContactHours
  ceuStateRequirement {
    id
    state
    requiredContactHours
    notes
    requirementQuantity
    requirementDescription
    stateBonUrl
    durationDays
    licenseType
  }
  ceuCertificates {
    id
  }
}`) as unknown as TypedDocumentString<DeleteCeuGoalMutation, DeleteCeuGoalMutationVariables>;
export const ContractItemV2Document = new TypedDocumentString(`
    query ContractItemV2($contractId: ID!) {
  contract(id: $contractId) {
    ...ContractSignUrl
  }
}
    fragment ContractSignUrl on Contract {
  ...Contract
  docusignSignUrl
}
fragment Contract on Contract {
  id
  hoursPerShift
  shiftsPerWeek
  cancellationPolicy
  contractNotes
  contractStatus
  contractStartDate
  contractEndDate
  contractType
  shiftType
  currentGrossPayWeek
  baseRate
  lengthInWeeks
  job {
    id
    startDate
    endDate
    title
    facilityName
    clinicalUnit {
      id
      displayName
    }
    lengthInWeeks
    hoursPerShift
    shiftsPerWeek
    shiftType
    emr {
      id
      name
    }
  }
  jobPlacement {
    id
    nurseProfile {
      id
      name
      user {
        id
        email
      }
    }
  }
  timeOffs {
    id
    startDate
    endDate
    approvalStatus
  }
  jobApplication {
    id
    paymentDetails {
      id
      nonTaxableStipendWeekly
      taxableWageRateWeekly
      grossPayWeekly
    }
  }
  paymentDetails {
    id
    nonTaxableStipendWeekly
    taxableWageRateWeekly
    grossPayWeekly
  }
}`) as unknown as TypedDocumentString<ContractItemV2Query, ContractItemV2QueryVariables>;
export const ContractItemDocument = new TypedDocumentString(`
    query ContractItem($contractId: ID!) {
  contract(id: $contractId) {
    ...Contract
  }
}
    fragment Contract on Contract {
  id
  hoursPerShift
  shiftsPerWeek
  cancellationPolicy
  contractNotes
  contractStatus
  contractStartDate
  contractEndDate
  contractType
  shiftType
  currentGrossPayWeek
  baseRate
  lengthInWeeks
  job {
    id
    startDate
    endDate
    title
    facilityName
    clinicalUnit {
      id
      displayName
    }
    lengthInWeeks
    hoursPerShift
    shiftsPerWeek
    shiftType
    emr {
      id
      name
    }
  }
  jobPlacement {
    id
    nurseProfile {
      id
      name
      user {
        id
        email
      }
    }
  }
  timeOffs {
    id
    startDate
    endDate
    approvalStatus
  }
  jobApplication {
    id
    paymentDetails {
      id
      nonTaxableStipendWeekly
      taxableWageRateWeekly
      grossPayWeekly
    }
  }
  paymentDetails {
    id
    nonTaxableStipendWeekly
    taxableWageRateWeekly
    grossPayWeekly
  }
}`) as unknown as TypedDocumentString<ContractItemQuery, ContractItemQueryVariables>;
export const ContractDetailPageViewerDocument = new TypedDocumentString(`
    query ContractDetailPageViewer {
  viewer {
    ... on User {
      id
      firstName
    }
  }
}
    `) as unknown as TypedDocumentString<ContractDetailPageViewerQuery, ContractDetailPageViewerQueryVariables>;
export const CuratedJobsPageDocument = new TypedDocumentString(`
    query CuratedJobsPage($filters: JobsCollectionFiltersInput, $sortBy: JobsCollectionSortInput, $paginate: OffsetPaginationInput) {
  viewer {
    ... on User {
      ...CuratedJobsPageUser
    }
  }
  jobsCollectionExactV2(filters: $filters, paginate: $paginate, sortBy: $sortBy) {
    id
    filterType
    records {
      id
      ...ApplicableMatchCardJob
    }
    totalRecords
    recommendations {
      id
      ...ApplicableMatchCardJob
    }
  }
}
    fragment MatchCardJob on Job {
  id
  activeApplicantsCount
  favoritedCount
  hoursPerShift
  instantOffer
  jobType
  lengthInWeeks
  licenseType
  localAllowed
  onHold
  shiftType
  shiftsPerWeek
  startAsap
  startDate
  endDate
  facilityName
  cancellationPolicy
  stateActiveAt
  title
  travelAllowed
  business {
    city
    state
    ...MatchCardFacility
  }
  clinicalUnit {
    id
    displayName
  }
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  location {
    id
    city
    stateCode
  }
  localPaymentDetails {
    id
    grossPayWeekly
  }
  emr {
    id
    name
  }
}
fragment ApplicableMatchCardJob on Job {
  ...MatchCardJob
  esMatch {
    id
    userState
  }
}
fragment MatchCardUser on User {
  id
  email
  nurseProfile {
    id
    isActivated
    percentComplete
    state
    profileCompletion {
      id
      meta {
        id
        percentCompleted
      }
    }
    nurseAdvocate {
      id
      email
      fullName
    }
  }
}
fragment MatchCardFacility on Facility {
  id
  name
  logo
}
fragment MatchCriteriaNurseProfile on NurseProfile {
  id
  isActivated
  activeClinicalSpecialties {
    id
    displayName
    slug
  }
  percentComplete
  positionSpecialties {
    id
    displayName
    slug
  }
  profileCompletion {
    id
    meta {
      id
      percentCompleted
    }
  }
  role {
    id
    key
    name
    type
  }
  state
  nursePreferences {
    id
    ...MatchCriteriaNursePreferences
  }
}
fragment MatchCriteriaNursePreferences on NursePreferences {
  id
  broadPrefLocations
  careSettingOther
  careSettingPrefs
  contractLengths
  earliestStartDate
  jobSortColumn
  jobSortOrder
  jobTypes
  locations {
    id
    locationString
  }
  shiftLengths
  shiftPrefs
  startPref
  technologies
}
fragment MatchApplyButtonUser on User {
  id
  ...RequestInterviewButtonUser
}
fragment MatchFavoriteButtonUser on User {
  id
  userProperties {
    id
    shouldDisplayFirstFavoriteMessage
  }
}
fragment JobMatchTopCardBlockUser on User {
  id
  referralCode
  ...MatchApplyButtonUser
  ...MatchFavoriteButtonUser
}
fragment MatchFiltersNurseProfile on NurseProfile {
  id
  activeClinicalSpecialties {
    ...MatchFiltersClinicalSpecialty
  }
  positionSpecialties {
    ...MatchFiltersClinicalSpecialty
  }
  role {
    id
    type
  }
  nursePreferences {
    ...MatchFiltersNursePreferences
  }
}
fragment MatchFiltersClinicalSpecialty on ClinicalSpecialty {
  id
  displayName
  slug
}
fragment MatchFiltersNursePreferences on NursePreferences {
  id
  broadPrefLocations
  contractLengths
  locations {
    id
    locationString
  }
  shiftLengths
  shiftPrefs
}
fragment RequestInterviewButtonUser on User {
  id
  nurseProfile {
    ...RequestInterviewButtonNurseProfile
  }
  ...JobApplicationRequirementsUser
}
fragment RequestInterviewButtonNurseProfile on NurseProfile {
  id
  isActivated
  canApplyJobs
  profileCompletion {
    id
    meta {
      id
      percentCompleted
    }
  }
  state
}
fragment JobApplicationRequirementsUser on User {
  id
  email
  firstName
  lastName
  nurseProfile {
    ...JobApplicationRequirementsNurseProfile
  }
}
fragment JobApplicationRequirementsNurseAdvocate on SalesforceUser {
  id
  email
  fullName
}
fragment JobApplicationRequirementsNurseProfile on NurseProfile {
  id
  state
  percentComplete
  profileCompletion {
    id
  }
  nurseAdvocate {
    ...JobApplicationRequirementsNurseAdvocate
  }
}
fragment CuratedJobsPageUser on User {
  ...MatchCardUser
  ...JobMatchTopCardBlockUser
  nurseProfile {
    ...MatchCriteriaNurseProfile
    ...MatchFiltersNurseProfile
  }
}`) as unknown as TypedDocumentString<CuratedJobsPageQuery, CuratedJobsPageQueryVariables>;
export const CurateJobsPageNurseProfileAndNursePreferencesDocument = new TypedDocumentString(`
    query CurateJobsPageNurseProfileAndNursePreferences {
  viewer {
    ... on User {
      ...CuratedJobsPageUser
      ...MatchCriteriaUser
      ...ShouldRedirectUser
    }
  }
  profileCompletionSummary {
    ...ProfileCompletionSummary
  }
}
    fragment ProfileCompletionSummary on ProfileCompletionSummary {
  id
  completedAt
  meta {
    id
    completeCount
    expiredCount
    expiringCount
    incompleteCount
    pendingCount
    percentCompleted
  }
  steps {
    estimatedTimeInMinutes
    key
    title
    subtitle
    messages
    sectionName
    status
    hasExpiringItems
    hasExpiredItems
    hasInvalidItems
  }
}
fragment MatchCardUser on User {
  id
  email
  nurseProfile {
    id
    isActivated
    percentComplete
    state
    profileCompletion {
      id
      meta {
        id
        percentCompleted
      }
    }
    nurseAdvocate {
      id
      email
      fullName
    }
  }
}
fragment MatchCriteriaUser on User {
  id
  cityPermanent
  statePermanent
  streetAddressPermanent
  nurseProfile {
    ...MatchCriteriaNurseProfile
  }
}
fragment MatchCriteriaNurseProfile on NurseProfile {
  id
  isActivated
  activeClinicalSpecialties {
    id
    displayName
    slug
  }
  percentComplete
  positionSpecialties {
    id
    displayName
    slug
  }
  profileCompletion {
    id
    meta {
      id
      percentCompleted
    }
  }
  role {
    id
    key
    name
    type
  }
  state
  nursePreferences {
    id
    ...MatchCriteriaNursePreferences
  }
}
fragment MatchCriteriaNursePreferences on NursePreferences {
  id
  broadPrefLocations
  careSettingOther
  careSettingPrefs
  contractLengths
  earliestStartDate
  jobSortColumn
  jobSortOrder
  jobTypes
  locations {
    id
    locationString
  }
  shiftLengths
  shiftPrefs
  startPref
  technologies
}
fragment MatchApplyButtonUser on User {
  id
  ...RequestInterviewButtonUser
}
fragment MatchFavoriteButtonUser on User {
  id
  userProperties {
    id
    shouldDisplayFirstFavoriteMessage
  }
}
fragment JobMatchTopCardBlockUser on User {
  id
  referralCode
  ...MatchApplyButtonUser
  ...MatchFavoriteButtonUser
}
fragment MatchFiltersNurseProfile on NurseProfile {
  id
  activeClinicalSpecialties {
    ...MatchFiltersClinicalSpecialty
  }
  positionSpecialties {
    ...MatchFiltersClinicalSpecialty
  }
  role {
    id
    type
  }
  nursePreferences {
    ...MatchFiltersNursePreferences
  }
}
fragment MatchFiltersClinicalSpecialty on ClinicalSpecialty {
  id
  displayName
  slug
}
fragment MatchFiltersNursePreferences on NursePreferences {
  id
  broadPrefLocations
  contractLengths
  locations {
    id
    locationString
  }
  shiftLengths
  shiftPrefs
}
fragment RequestInterviewButtonUser on User {
  id
  nurseProfile {
    ...RequestInterviewButtonNurseProfile
  }
  ...JobApplicationRequirementsUser
}
fragment RequestInterviewButtonNurseProfile on NurseProfile {
  id
  isActivated
  canApplyJobs
  profileCompletion {
    id
    meta {
      id
      percentCompleted
    }
  }
  state
}
fragment JobApplicationRequirementsUser on User {
  id
  email
  firstName
  lastName
  nurseProfile {
    ...JobApplicationRequirementsNurseProfile
  }
}
fragment JobApplicationRequirementsNurseAdvocate on SalesforceUser {
  id
  email
  fullName
}
fragment JobApplicationRequirementsNurseProfile on NurseProfile {
  id
  state
  percentComplete
  profileCompletion {
    id
  }
  nurseAdvocate {
    ...JobApplicationRequirementsNurseAdvocate
  }
}
fragment CuratedJobsPageUser on User {
  ...MatchCardUser
  ...JobMatchTopCardBlockUser
  nurseProfile {
    ...MatchCriteriaNurseProfile
    ...MatchFiltersNurseProfile
  }
}
fragment ShouldRedirectUser on User {
  nurseProfile {
    id
    canViewJobs
    wizardCompleted
  }
}`) as unknown as TypedDocumentString<CurateJobsPageNurseProfileAndNursePreferencesQuery, CurateJobsPageNurseProfileAndNursePreferencesQueryVariables>;
export const CuratedJobsPageUpdateNursePreferencesDocument = new TypedDocumentString(`
    mutation CuratedJobsPageUpdateNursePreferences($id: ID!, $input: UpdateNursePreferencesInput!) {
  updateNursePreferences(id: $id, input: $input) {
    nurseProfile {
      id
      nursePreferences {
        ...MatchCriteriaNursePreferences
      }
    }
  }
}
    fragment MatchCriteriaNursePreferences on NursePreferences {
  id
  broadPrefLocations
  careSettingOther
  careSettingPrefs
  contractLengths
  earliestStartDate
  jobSortColumn
  jobSortOrder
  jobTypes
  locations {
    id
    locationString
  }
  shiftLengths
  shiftPrefs
  startPref
  technologies
}`) as unknown as TypedDocumentString<CuratedJobsPageUpdateNursePreferencesMutation, CuratedJobsPageUpdateNursePreferencesMutationVariables>;
export const ExplorerPageLocationByCoordDocument = new TypedDocumentString(`
    query ExplorerPageLocationByCoord($latitude: Float, $longitude: Float) {
  location(latitude: $latitude, longitude: $longitude) {
    locationString
    city
    stateCode
    id
  }
}
    `) as unknown as TypedDocumentString<ExplorerPageLocationByCoordQuery, ExplorerPageLocationByCoordQueryVariables>;
export const ExplorerPageLocationBySharedIdDocument = new TypedDocumentString(`
    query ExplorerPageLocationBySharedId($sharedId: ID, $statsSource: String) {
  location(sharedId: $sharedId) {
    id
    latitude
    longitude
    locationString
    city
    stateCode
    stateName
    facilities {
      id
      name
      slug
      logo
      city
      state
      latitude
      longitude
      hospital {
        id
        teaching
        affiliatedUnion
        hospitalType
        magnet
        jointCommission
        traumaCenterLevel
        totalLicensedBeds
      }
      rankings {
        id
        usnewsType
      }
      residencyPrograms {
        id
        name
      }
    }
    costOfLivingStats(source: $statsSource) {
      locationName
      statId
      statName
      valueInt
      valueFloat
      valueString
    }
    cityWalkscore {
      walkScore
      walkDescription
      walkExtraInfo
      bikeScore
      bikeDescription
      bikeExtraInfo
      transitScore
      transitDescription
      transitExtraInfo
    }
  }
}
    `) as unknown as TypedDocumentString<ExplorerPageLocationBySharedIdQuery, ExplorerPageLocationBySharedIdQueryVariables>;
export const ExplorerPageLocationDocument = new TypedDocumentString(`
    query ExplorerPageLocation($locationString: String, $latitude: Float, $longitude: Float, $sharedId: ID, $statsSource: String) {
  location(
    locationString: $locationString
    latitude: $latitude
    longitude: $longitude
    sharedId: $sharedId
  ) {
    id
    city
    stateName
    locationString
    costOfLivingStats(source: $statsSource) {
      ...CostOfLivingStat
    }
    cityWalkscore {
      ...WalkscoreCard
    }
    ...FacilitiesCardLocation
    ...ExplorerPageHeaderLocation
  }
}
    fragment CostOfLivingStat on Stat {
  statId
  valueFloat
}
fragment ExplorerPageHeaderLocation on Location {
  id
  city
  stateCode
}
fragment FacilitiesCardLocation on Location {
  locationString
  latitude
  longitude
  facilities {
    id
    ...FacilityResultCardFacility
    ...FacilityGoogleMapFacility
  }
}
fragment FacilityGoogleMapFacility on Facility {
  id
  slug
  name
  logo
  latitude
  longitude
}
fragment FacilityResultCardFacility on Facility {
  id
  slug
  name
  logo
  city
  state
  hospital {
    id
    affiliatedUnion
    jointCommission
    magnet
    teaching
    totalLicensedBeds
    traumaCenterLevel
    hospitalType
  }
  residencyPrograms {
    id
  }
  rankings {
    id
    usnewsType
  }
  ...TrackFacilityPageViewFacility
}
fragment WalkscoreCard on Walkscore {
  walkScore
  walkDescription
  walkExtraInfo
  bikeScore
  bikeDescription
  bikeExtraInfo
  transitScore
  transitDescription
  transitExtraInfo
}
fragment TrackFacilityPageViewFacility on Facility {
  id
  name
  city
  state
}`) as unknown as TypedDocumentString<ExplorerPageLocationQuery, ExplorerPageLocationQueryVariables>;
export const ExplorerLocationPageLocationByCoordDocument = new TypedDocumentString(`
    query ExplorerLocationPageLocationByCoord($latitude: Float, $longitude: Float) {
  location(latitude: $latitude, longitude: $longitude) {
    locationString
    id
  }
}
    `) as unknown as TypedDocumentString<ExplorerLocationPageLocationByCoordQuery, ExplorerLocationPageLocationByCoordQueryVariables>;
export const FacilitiesPageDocument = new TypedDocumentString(`
    query FacilitiesPage($after: String, $before: String, $first: Int, $last: Int, $locationString: String, $includeLocation: Boolean!, $hospitalType: HospitalTypesEnum, $accreditation: AccreditationsEnum, $accreditingBodies: [AccreditingBodiesEnum!]) {
  ... @include(if: $includeLocation) {
    location(locationString: $locationString) {
      id
      stateCode
      stateName
      city
    }
  }
  facilitiesPaginated(
    after: $after
    before: $before
    first: $first
    last: $last
    locationString: $locationString
    hospitalType: $hospitalType
    accreditation: $accreditation
    accreditingBodies: $accreditingBodies
  ) {
    edges {
      node {
        id
        slug
        ...FacilitiesSearchItemFacility
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    fragment FacilitiesSearchItemFacility on Facility {
  id
  logo
  name
  state
  city
  ...FacilitiesSearchItemSummaryFacility
}
fragment FacilitiesSearchItemSummaryFacility on Facility {
  id
  hospital {
    id
    totalLicensedBeds
    traumaCenterLevel
    hospitalType
    affiliatedUnion
    teaching
    jointCommission
    magnet
  }
  residencyPrograms {
    id
    url
    accreditingBody
  }
}`) as unknown as TypedDocumentString<FacilitiesPageQuery, FacilitiesPageQueryVariables>;
export const CreateJobAlertDocument = new TypedDocumentString(`
    mutation CreateJobAlert($input: CreateJobAlertInput!) {
  createJobAlert(input: $input) {
    nurseProfile {
      id
      jobAlerts {
        ...JobAlert
      }
    }
  }
}
    fragment JobAlert on JobAlert {
  id
  broadPrefLocations
  clinicalSpecialties {
    id
    displayName
    slug
  }
  contractLengths
  locationStrings
  shiftLengths
  shiftPrefs
  smsEnabled
  specialties
}`) as unknown as TypedDocumentString<CreateJobAlertMutation, CreateJobAlertMutationVariables>;
export const UpdateJobAlertDocument = new TypedDocumentString(`
    mutation UpdateJobAlert($id: ID!, $input: UpdateJobAlertInput!) {
  updateJobAlert(id: $id, input: $input) {
    nurseProfile {
      id
      jobAlerts {
        ...JobAlert
      }
    }
  }
}
    fragment JobAlert on JobAlert {
  id
  broadPrefLocations
  clinicalSpecialties {
    id
    displayName
    slug
  }
  contractLengths
  locationStrings
  shiftLengths
  shiftPrefs
  smsEnabled
  specialties
}`) as unknown as TypedDocumentString<UpdateJobAlertMutation, UpdateJobAlertMutationVariables>;
export const DeleteJobAlertDocument = new TypedDocumentString(`
    mutation DeleteJobAlert($id: ID!) {
  deleteJobAlert(id: $id) {
    nurseProfile {
      id
      jobAlerts {
        ...JobAlert
      }
    }
  }
}
    fragment JobAlert on JobAlert {
  id
  broadPrefLocations
  clinicalSpecialties {
    id
    displayName
    slug
  }
  contractLengths
  locationStrings
  shiftLengths
  shiftPrefs
  smsEnabled
  specialties
}`) as unknown as TypedDocumentString<DeleteJobAlertMutation, DeleteJobAlertMutationVariables>;
export const JobAlertsPageDocument = new TypedDocumentString(`
    query JobAlertsPage {
  nurseProfile {
    ...MatchCriteriaNurseProfile
    ...JobAlertsNurseProfile
  }
  profileCompletionSummary {
    ...ProfileCompletionSummary
  }
}
    fragment ProfileCompletionSummary on ProfileCompletionSummary {
  id
  completedAt
  meta {
    id
    completeCount
    expiredCount
    expiringCount
    incompleteCount
    pendingCount
    percentCompleted
  }
  steps {
    estimatedTimeInMinutes
    key
    title
    subtitle
    messages
    sectionName
    status
    hasExpiringItems
    hasExpiredItems
    hasInvalidItems
  }
}
fragment MatchCriteriaNurseProfile on NurseProfile {
  id
  isActivated
  activeClinicalSpecialties {
    id
    displayName
    slug
  }
  percentComplete
  positionSpecialties {
    id
    displayName
    slug
  }
  profileCompletion {
    id
    meta {
      id
      percentCompleted
    }
  }
  role {
    id
    key
    name
    type
  }
  state
  nursePreferences {
    id
    ...MatchCriteriaNursePreferences
  }
}
fragment MatchCriteriaNursePreferences on NursePreferences {
  id
  broadPrefLocations
  careSettingOther
  careSettingPrefs
  contractLengths
  earliestStartDate
  jobSortColumn
  jobSortOrder
  jobTypes
  locations {
    id
    locationString
  }
  shiftLengths
  shiftPrefs
  startPref
  technologies
}
fragment JobAlertsNurseProfile on NurseProfile {
  id
  jobAlerts {
    ...JobAlert
  }
}
fragment JobAlert on JobAlert {
  id
  broadPrefLocations
  clinicalSpecialties {
    id
    displayName
    slug
  }
  contractLengths
  locationStrings
  shiftLengths
  shiftPrefs
  smsEnabled
  specialties
}`) as unknown as TypedDocumentString<JobAlertsPageQuery, JobAlertsPageQueryVariables>;
export const JobApplicationDetailPageDocument = new TypedDocumentString(`
    query JobApplicationDetailPage($id: String!) {
  jobApplication(id: $id) {
    ...JobApplicationDetail
  }
}
    fragment MatchCardJob on Job {
  id
  activeApplicantsCount
  favoritedCount
  hoursPerShift
  instantOffer
  jobType
  lengthInWeeks
  licenseType
  localAllowed
  onHold
  shiftType
  shiftsPerWeek
  startAsap
  startDate
  endDate
  facilityName
  cancellationPolicy
  stateActiveAt
  title
  travelAllowed
  business {
    city
    state
    ...MatchCardFacility
  }
  clinicalUnit {
    id
    displayName
  }
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  location {
    id
    city
    stateCode
  }
  localPaymentDetails {
    id
    grossPayWeekly
  }
  emr {
    id
    name
  }
}
fragment MatchCardFacility on Facility {
  id
  name
  logo
}
fragment NurseAdvocateWidgetSalesforceUser on SalesforceUser {
  id
  phone
  firstName
  lastName
  profileImgUrl
  isNurseAdvocate
  isAlliedAdvocate
  clinicalRole
}
fragment JobApplicationDetail on JobApplication {
  id
  state
  nurseProfile {
    id
    nurseAdvocate {
      ...NurseAdvocateWidgetSalesforceUser
    }
  }
  esMatch {
    id
    userState
  }
  preferredStartDate
  specialRequest
  interviewAvailability
  timeOffRequests {
    id
    fromDate
    toDate
  }
  job {
    ...MatchCardJob
  }
  candidateHoldReasons
}`) as unknown as TypedDocumentString<JobApplicationDetailPageQuery, JobApplicationDetailPageQueryVariables>;
export const CreateDraftJobApplicationDocument = new TypedDocumentString(`
    mutation CreateDraftJobApplication($jobId: ID!, $input: CreateJobApplicationInput!) {
  createJobApplication(jobUuid: $jobId, input: $input) {
    id
    state
    job {
      id
    }
    nurseProfile {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<CreateDraftJobApplicationMutation, CreateDraftJobApplicationMutationVariables>;
export const JobApplicationAutoSaveDocument = new TypedDocumentString(`
    mutation JobApplicationAutoSave($jobId: ID!, $input: AutoSaveApplicationInput!) {
  jobApplicationAutoSave(jobUuid: $jobId, input: $input) {
    ...JobApplicationJobApplication
  }
}
    fragment JobApplicationJobApplication on JobApplication {
  id
  state
  preferredStartDate
  hasSpecialRequest
  specialRequest
  hasTimeoffRequest
  timeOffRequests {
    id
    fromDate
    toDate
  }
  interviewAvailability
  hasAllowedFacilities
  allowedFacilitiesShifts
  allowedFacilities {
    facilityId
  }
}`) as unknown as TypedDocumentString<JobApplicationAutoSaveMutation, JobApplicationAutoSaveMutationVariables>;
export const SubmitJobApplicationDocument = new TypedDocumentString(`
    mutation SubmitJobApplication($jobId: ID!, $input: CreateJobApplicationInput!) {
  createJobApplication(jobUuid: $jobId, input: $input) {
    id
    state
    job {
      ...JobApplicationEventsJob
    }
    nurseProfile {
      ...JobApplicationEventsNurseProfile
      user {
        ...JobApplicationEventsUser
      }
    }
  }
}
    fragment JobApplicationEventsUser on User {
  id
  email
}
fragment JobApplicationEventsNurseProfile on NurseProfile {
  id
  isActivated
  state
  percentComplete
  applicationReadiness {
    results {
      background {
        label
        status
      }
      certifications {
        label
        status
      }
      education {
        label
        status
      }
      employment {
        label
        status
      }
      licenses {
        label
        status
      }
      references {
        label
        status
        completeReferenceCount
      }
      skillsChecklist {
        label
        status
      }
    }
  }
  nurseAdvocate {
    id
    email
    fullName
  }
  profileCompletion {
    id
    meta {
      id
      percentCompleted
    }
  }
}
fragment JobApplicationEventsJob on Job {
  id
  activeApplicantsCount
  favoritedCount
  hoursPerShift
  instantOffer
  jobType
  lengthInWeeks
  shiftsPerWeek
  shiftType
  startDate
  stateActiveAt
  title
  business {
    id
    city
    logo
    name
    state
  }
  clinicalUnit {
    id
    displayName
  }
}`) as unknown as TypedDocumentString<SubmitJobApplicationMutation, SubmitJobApplicationMutationVariables>;
export const JobApplicationPageDocument = new TypedDocumentString(`
    query JobApplicationPage($jobId: ID!) {
  viewer {
    ... on User {
      ...JobApplicationCompletedPagesUser
    }
  }
  job(id: $jobId) {
    ...JobApplicationJob
  }
}
    fragment JobApplicationJob on Job {
  id
  allowedFacilities {
    ...JobAllowedFacility
  }
  business {
    id
    name
  }
  clinicalUnit {
    id
    displayName
  }
  hoursPerShift
  lengthInWeeks
  licenseType
  location {
    id
    city
    stateCode
  }
  jarMaximumTimeOff {
    id
    maximumTimeOff
  }
  jobApplication {
    ...JobApplicationJobApplication
  }
  onHold
  programName
  shiftType
  shiftsPerWeek
  startAsap
  startDate
  state
  ...JobUtilsPayRateJob
}
fragment JobApplicationJobApplication on JobApplication {
  id
  state
  preferredStartDate
  hasSpecialRequest
  specialRequest
  hasTimeoffRequest
  timeOffRequests {
    id
    fromDate
    toDate
  }
  interviewAvailability
  hasAllowedFacilities
  allowedFacilitiesShifts
  allowedFacilities {
    facilityId
  }
}
fragment JobApplicationCompletedPagesUser on User {
  id
  nurseProfile {
    ...JobApplicationNurseProfile
  }
}
fragment JobApplicationNurseProfile on NurseProfile {
  id
}
fragment JobAllowedFacility on Facility {
  id
  city
  name
  state
}
fragment JobUtilsPayRateJob on Job {
  id
  travelAllowed
  localAllowed
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  grossPayWeekly
  jobType
  localGrossPayWeekly
  localPaymentDetails {
    id
    grossPayWeekly
  }
}`) as unknown as TypedDocumentString<JobApplicationPageQuery, JobApplicationPageQueryVariables>;
export const JobApplicationStrengthenPageDocument = new TypedDocumentString(`
    query JobApplicationStrengthenPage($jobId: ID!, $documentCategories: [String!]) {
  defaultCovidVaccineHealthDoc {
    id
  }
  documentTemplates(categories: $documentCategories) {
    ...BackgroundAndIdDocumentTableDocumentTemplate
  }
  fluVaccineHealthDoc {
    id
  }
  job(id: $jobId) {
    ...JobApplicationStrengthenJob
  }
  nurseProfile {
    ...JobApplicationStrengthenNurseProfile
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment BackgroundAndIdDocumentTableDocumentTemplate on DocumentTemplate {
  id
  key
  name
  types
  expirationType
  ...BackgroundAndIdPanelDocumentTemplate
}
fragment BackgroundAndIdPanelDocument on Document {
  id
  title
  docType
  docSubtype
  expiresOn
  expirationType
  files {
    ...FileMetadata
  }
  stateCode
}
fragment BackgroundAndIdPanelDocumentTemplate on DocumentTemplate {
  id
  key
  name
  types
  expirationType
}
fragment JobApplicationStrengthenJob on Job {
  id
  ruleValidations {
    ...JobApplicationStrengthenRuleValidation
  }
}
fragment JobApplicationStrengthenRuleValidation on JobApplicationRequirementRuleEngineVerification {
  type
  valid
  errorMessages
}
fragment JobApplicationStrengthenNurseProfile on NurseProfile {
  id
  hasPositionsLocationOverlap
  hasPositionsInvalidHoursOverlap
  idDocs {
    ...BackgroundAndIdPanelDocument
  }
  nurseHealthDocs {
    ...JobApplicationStrengthenNurseHealthDoc
  }
  sortedExperienceItems {
    ... on Gap {
      id
      reason
    }
  }
}
fragment JobApplicationStrengthenNurseHealthDoc on NurseHealthDoc {
  id
  isCovidVax
  isFluVax
}`) as unknown as TypedDocumentString<JobApplicationStrengthenPageQuery, JobApplicationStrengthenPageQueryVariables>;
export const JobDetailPageRelatedJobsDocument = new TypedDocumentString(`
    query JobDetailPageRelatedJobs($id: ID!, $after: String, $before: String, $first: Int, $last: Int) {
  relatedJobsConnection(
    id: $id
    after: $after
    before: $before
    first: $first
    last: $last
  ) {
    edges {
      node {
        id
        grossPayWeekly
        startAsap
        startDate
        endDate
        lengthInWeeks
        localAllowed
        travelAllowed
        roles {
          id
          abbreviation
          name
        }
        business {
          id
          bgImageFlickrUrl
          state
        }
        ...JobDetailPageJobTitle
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    fragment JobDetailPageJobTitle on Job {
  id
  jobType
  licenseType
  clinicalUnit {
    id
    displayName
    slug
  }
  location {
    id
    city
    stateCode
  }
}`) as unknown as TypedDocumentString<JobDetailPageRelatedJobsQuery, JobDetailPageRelatedJobsQueryVariables>;
export const JobDetailPageDocument = new TypedDocumentString(`
    query JobDetailPage($id: ID!, $loggedIn: Boolean!) {
  ... @include(if: $loggedIn) {
    viewer {
      ... on User {
        id
        email
        initialReferringDomain
        ...JobDetailPageUser
      }
    }
  }
  adJob(id: $id) {
    id
    licenseType
    friendlyLicenseType
    grossPayWeekly
    jobType
    shiftType
    shiftsPerWeek
    hoursPerShift
    nursePatientRatio
    description
    startAsap
    startDate
    endDate
    lengthInWeeks
    licenseState
    certifications
    requiredSpecialties
    stateActiveAt
    radiusRule
    publicDescription
    preferredJarsV2 {
      __typename
      ... on JobApplicationRequirementsMaximumTimeOffRule {
        ...JarMaximumTimeOffRule
      }
      ... on JobApplicationRequirementsRadiusRule {
        ...JarRadiusRule
      }
      ... on JobApplicationRequirementsLocationFloating {
        ...JarLocationFloating
      }
      ... on JobApplicationRequirementsUnitFloating {
        ...JarUnitFloating
      }
      ... on JobApplicationRequirementsCovidVaccine {
        ...JarCovidVaccine
      }
      ... on JobApplicationRequirementsCovidBooster {
        ...JarCovidBooster
      }
      ... on JobApplicationRequirementsFluVaccine {
        ...JarFluVaccine
      }
      ... on JobApplicationRequirementsFluVaccination {
        ...JarFluVaccination
      }
      ... on JobApplicationRequirementsRoleExperience {
        ...JarRoleExperience
      }
      ... on JobApplicationRequirementsUnitExperience {
        ...JarUnitExperience
      }
      ... on JobApplicationRequirementsTechnologyExperience {
        ...JarTechnologyExperience
      }
      ... on JobApplicationRequirementsTravelExperience {
        ...JarTravelExperience
      }
      ... on JobApplicationRequirementsStateLicense {
        ...JarStateLicense
      }
      ... on JobApplicationRequirementsDriverLicense {
        ...JarDriverLicense
      }
      ... on JobApplicationRequirementsNurseReference {
        ...JarNurseReference
      }
      ... on JobApplicationRequirementsCertification {
        ...JarCertification
      }
      ... on JobApplicationRequirementsProofOfIdentification {
        ...JarProofOfIdentification
      }
      ... on JobApplicationRequirementsTraumaLevelExperience {
        ...JarTraumaLevelExperience
      }
      ... on JobApplicationRequirementsEducation {
        ...JarEducation
      }
    }
    requiredJarsV2 {
      __typename
      ... on JobApplicationRequirementsRadiusRule {
        ...JarRadiusRule
      }
      ... on JobApplicationRequirementsMaximumTimeOffRule {
        ...JarMaximumTimeOffRule
      }
      ... on JobApplicationRequirementsLocationFloating {
        ...JarLocationFloating
      }
      ... on JobApplicationRequirementsUnitFloating {
        ...JarUnitFloating
      }
      ... on JobApplicationRequirementsCovidVaccine {
        ...JarCovidVaccine
      }
      ... on JobApplicationRequirementsCovidBooster {
        ...JarCovidBooster
      }
      ... on JobApplicationRequirementsFluVaccine {
        ...JarFluVaccine
      }
      ... on JobApplicationRequirementsFluVaccination {
        ...JarFluVaccination
      }
      ... on JobApplicationRequirementsRoleExperience {
        ...JarRoleExperience
      }
      ... on JobApplicationRequirementsUnitExperience {
        ...JarUnitExperience
      }
      ... on JobApplicationRequirementsTechnologyExperience {
        ...JarTechnologyExperience
      }
      ... on JobApplicationRequirementsTravelExperience {
        ...JarTravelExperience
      }
      ... on JobApplicationRequirementsStateLicense {
        ...JarStateLicense
      }
      ... on JobApplicationRequirementsDriverLicense {
        ...JarDriverLicense
      }
      ... on JobApplicationRequirementsNurseReference {
        ...JarNurseReference
      }
      ... on JobApplicationRequirementsCertification {
        ...JarCertification
      }
      ... on JobApplicationRequirementsProofOfIdentification {
        ...JarProofOfIdentification
      }
      ... on JobApplicationRequirementsTraumaLevelExperience {
        ...JarTraumaLevelExperience
      }
      ... on JobApplicationRequirementsEducation {
        ...JarEducation
      }
    }
    roles {
      id
      key
      name
      type
      abbreviation
    }
    location {
      id
      stateCode
      city
      country
      postalCode
    }
    business {
      id
      bgImageFlickrUrl
    }
    cityLocation {
      id
      latitude
      longitude
    }
    ...JobDetailPageJob
  }
}
    fragment JobDetailPageUser on User {
  id
  email
  initialReferringDomain
  userProperties {
    shouldDisplayFirstFavoriteMessage
    shouldDisplayStaleProfileNotification
  }
}
fragment JobDetailPageJob on Job {
  ...JobDetailPageVisibilityJob
  ...JobDetailPageJobTitle
  ...JobDetailPageDescription
}
fragment JobDetailPageVisibilityJob on Job {
  id
  state
  onHold
  jobType
}
fragment JobDetailPageJobTitle on Job {
  id
  jobType
  licenseType
  clinicalUnit {
    id
    displayName
    slug
  }
  location {
    id
    city
    stateCode
  }
}
fragment JobDetailPageStartDate on Job {
  id
  startAsap
  startDate
  lengthInWeeks
}
fragment JobDetailPageDescription on Job {
  id
  jobType
  friendlyLicenseType
  location {
    id
    city
    stateCode
  }
  grossPayWeekly
  ...JobDetailPageStartDate
}
fragment JarRadiusRule on JobApplicationRequirementsRadiusRule {
  id
  type
  description
}
fragment JarCertification on JobApplicationRequirementsCertification {
  id
  type
  title
  description
  certification {
    id
    credential
    name
    uuid
    issuingBodies
  }
}
fragment JarNurseReference on JobApplicationRequirementsNurseReference {
  id
  description
  occurrences
  timeframe
  type
}
fragment JarDriverLicense on JobApplicationRequirementsDriverLicense {
  id
  required
  type
  stage
}
fragment JarCovidVaccine on JobApplicationRequirementsCovidVaccine {
  id
  type
  stage
  description
}
fragment JarCovidBooster on JobApplicationRequirementsCovidBooster {
  id
  type
  stage
  description
}
fragment JarFluVaccine on JobApplicationRequirementsFluVaccine {
  id
  type
  stage
  description
}
fragment JarFluVaccination on JobApplicationRequirementsFluVaccination {
  id
  type
  stage
  description
}
fragment JarLocationFloating on JobApplicationRequirementsLocationFloating {
  id
  type
  description
}
fragment JarMaximumTimeOffRule on JobApplicationRequirementsMaximumTimeOffRule {
  id
  type
  maximumTimeOff
  description
}
fragment JarUnitFloating on JobApplicationRequirementsUnitFloating {
  id
  type
  description
}
fragment JarStateLicense on JobApplicationRequirementsStateLicense {
  id
  stage
  type
  description
}
fragment JarTravelExperience on JobApplicationRequirementsTravelExperience {
  id
  type
  months
  description
}
fragment JarRoleExperience on JobApplicationRequirementsRoleExperience {
  id
  type
  months
  description
}
fragment JarUnitExperience on JobApplicationRequirementsUnitExperience {
  id
  type
  months
  description
}
fragment JarTechnologyExperience on JobApplicationRequirementsTechnologyExperience {
  id
  type
  months
  description
  technology {
    id
    uuid
    name
  }
}
fragment JarProofOfIdentification on JobApplicationRequirementsProofOfIdentification {
  id
  type
  description
  required
  stage
}
fragment JarTraumaLevelExperience on JobApplicationRequirementsTraumaLevelExperience {
  id
  type
  description
  enforcementType
}
fragment JarEducation on JobApplicationRequirementsEducation {
  id
  type
  description
  enforcementType
}`) as unknown as TypedDocumentString<JobDetailPageQuery, JobDetailPageQueryVariables>;
export const AcceptOfferDocument = new TypedDocumentString(`
    mutation AcceptOffer($jobOfferId: ID!) {
  acceptOffer(jobOfferId: $jobOfferId) {
    nurseProfile {
      id
    }
    jobOffer {
      id
      status
      clinicianAcceptedInapp
    }
  }
}
    `) as unknown as TypedDocumentString<AcceptOfferMutation, AcceptOfferMutationVariables>;
export const JobOfferItemDocument = new TypedDocumentString(`
    query JobOfferItem($jobOfferId: ID!) {
  jobOffer(id: $jobOfferId) {
    ...JobOfferDetail
  }
  nurseProfile {
    id
    name
    nurseAdvocate {
      ...NurseAdvocateWidgetSalesforceUser
    }
  }
}
    fragment MatchCardJob on Job {
  id
  activeApplicantsCount
  favoritedCount
  hoursPerShift
  instantOffer
  jobType
  lengthInWeeks
  licenseType
  localAllowed
  onHold
  shiftType
  shiftsPerWeek
  startAsap
  startDate
  endDate
  facilityName
  cancellationPolicy
  stateActiveAt
  title
  travelAllowed
  business {
    city
    state
    ...MatchCardFacility
  }
  clinicalUnit {
    id
    displayName
  }
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  location {
    id
    city
    stateCode
  }
  localPaymentDetails {
    id
    grossPayWeekly
  }
  emr {
    id
    name
  }
}
fragment MatchCardFacility on Facility {
  id
  name
  logo
}
fragment NurseAdvocateWidgetSalesforceUser on SalesforceUser {
  id
  phone
  firstName
  lastName
  profileImgUrl
  isNurseAdvocate
  isAlliedAdvocate
  clinicalRole
}
fragment ContractDetail on Contract {
  id
  contractStatus
  contractStartDate
  contractEndDate
  facility {
    id
    name
    state
    city
  }
  jobOffer {
    id
    uuid
    job {
      id
      facilityName
      location {
        id
        city
        stateCode
      }
      title
    }
  }
}
fragment JobOfferDetail on JobOffer {
  id
  uuid
  status
  startDate
  endDate
  contractNotes
  clinicianAcceptedInapp
  nurseAdvocateEmail
  lengthInWeeks
  shiftType
  shiftsPerWeek
  hoursPerShift
  contracts {
    ...ContractDetail
  }
  timeOffs {
    id
    startDate
    endDate
    approvalStatus
  }
  job {
    ...MatchCardJob
  }
  jobApplication {
    id
    paymentDetails {
      id
      nonTaxableStipendWeekly
      taxableWageRateWeekly
      grossPayWeekly
    }
  }
  paymentDetails {
    id
    nonTaxableStipendWeekly
    taxableWageRateWeekly
    grossPayWeekly
    incidentalsStipendDaily
    lodgingStipendDaily
    regularWageRate
    overtimeMultiplier
    doubleTimeMultiplier
    overtimeWageRate
    regularHoursPerWeek
    overtimeHoursPerWeek
    blendedWageRate
    totalHoursPerWeek
    holidayRate
    chargeRate
    onCallRate
    callBackRate
    extraRate
  }
}`) as unknown as TypedDocumentString<JobOfferItemQuery, JobOfferItemQueryVariables>;
export const JobOfferDetailPageViewerDocument = new TypedDocumentString(`
    query JobOfferDetailPageViewer {
  viewer {
    ... on User {
      id
      firstName
    }
  }
}
    `) as unknown as TypedDocumentString<JobOfferDetailPageViewerQuery, JobOfferDetailPageViewerQueryVariables>;
export const RoleDocument = new TypedDocumentString(`
    query Role($key: String!) {
  role(key: $key) {
    id
    name
    key
    abbreviation
    type
  }
}
    `) as unknown as TypedDocumentString<RoleQuery, RoleQueryVariables>;
export const JobsPageDocument = new TypedDocumentString(`
    query JobsPage($role: JobRole!) {
  clinicalUnits(
    hasActiveJobs: true
    orderBy: {field: DISPLAY_NAME, direction: ASC}
    role: $role
  ) {
    id
    displayName
    slug
  }
  usStateLocations(
    hasActiveJobs: true
    orderBy: {field: STATE_CODE, direction: ASC}
    role: $role
  ) {
    id
    stateCode
    stateName
  }
}
    `) as unknown as TypedDocumentString<JobsPageQuery, JobsPageQueryVariables>;
export const JobsPageJobsDocument = new TypedDocumentString(`
    query JobsPageJobs($paginate: OffsetPaginationInput, $filters: JobsCollectionFiltersInput, $sortBy: JobsCollectionSortInput, $locationString: String, $includeLocation: Boolean!, $clinicalUnitSlug: String, $includeClinicalUnit: Boolean!) {
  ... @include(if: $includeClinicalUnit) {
    clinicalUnit(slug: $clinicalUnitSlug) {
      id
      displayName
      slug
    }
  }
  ... @include(if: $includeLocation) {
    location(locationString: $locationString) {
      id
      stateCode
      stateName
      city
    }
  }
  jobsCollection(paginate: $paginate, filters: $filters, sortBy: $sortBy) {
    id
    records {
      id
      ...JobSearchItemJob
    }
    totalRecords
  }
}
    fragment JobSearchItemJob on Job {
  id
  shiftType
  shiftsPerWeek
  hoursPerShift
  startAsap
  startDate
  lengthInWeeks
  grossPayWeekly
  jobType
  licenseType
  localGrossPayWeekly
  roles {
    id
    name
    abbreviation
  }
  localPaymentDetails {
    id
    blendedWageRate
    callBackRate
    doubleTimeMultiplier
    grossPayWeekly
    holidayRate
    incidentalsStipendDaily
    lodgingStipendDaily
    onCallRate
    overtimeHoursPerWeek
    overtimeMultiplier
    overtimeWageRate
    regularHoursPerWeek
    regularWageRate
    totalHoursPerWeek
    totalStipendDaily
  }
  clinicalUnit {
    id
    displayName
  }
  location {
    id
    city
    stateCode
  }
  ...JobUtilsJob
}
fragment JarRadiusRule on JobApplicationRequirementsRadiusRule {
  id
  type
  description
}
fragment JobUtilsJob on Job {
  id
  radiusRule
  travelAllowed
  localAllowed
  jarRadiusRuleV2 {
    ...JarRadiusRule
  }
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  grossPayWeekly
  localGrossPayWeekly
  localPaymentDetails {
    id
    grossPayWeekly
  }
  clinicalUnit {
    id
    displayName
  }
  jobType
  role
  roles {
    id
    name
    key
    type
  }
}`) as unknown as TypedDocumentString<JobsPageJobsQuery, JobsPageJobsQueryVariables>;
export const BackfillLoginUserDataDocument = new TypedDocumentString(`
    mutation BackfillLoginUserData($id: ID!, $input: NestedUpdateUserInput!) {
  nestedUpdateUser(id: $id, input: $input) {
    user {
      id
      firstName
      lastName
      preferredName
    }
  }
}
    `) as unknown as TypedDocumentString<BackfillLoginUserDataMutation, BackfillLoginUserDataMutationVariables>;
export const MatchDetailPageExpressInterestDocument = new TypedDocumentString(`
    mutation MatchDetailPageExpressInterest($id: String!, $source: String) {
  expressInterest(job_uuid: $id, source: $source) {
    id
    ...JobMatchTopCardBlockJob
  }
}
    fragment MatchApplyButtonJob on Job {
  id
  canApply {
    value
    reasons {
      fullMessages
    }
  }
  esMatch {
    id
  }
  ...RequestInterviewButtonJob
}
fragment MatchFavoriteButtonJob on Job {
  id
  canFavorite {
    value
    reasons {
      fullMessages
    }
  }
  esMatch {
    id
    userState
  }
}
fragment MatchWithdrawButtonJob on Job {
  id
  canWithdraw {
    value
    reasons {
      fullMessages
    }
  }
}
fragment JobMatchTopCardBlockJob on Job {
  id
  instantOffer
  business {
    id
    hideMatchInfo
    name
    city
    state
  }
  hoursPerShift
  jobType
  lengthInWeeks
  location {
    id
    city
    stateCode
  }
  positionCount
  shiftsPerWeek
  shiftType
  startAsap
  startDate
  title
  jobApplication {
    id
    state
  }
  ...JobUtilsPayRateJob
  ...MatchApplyButtonJob
  ...MatchFavoriteButtonJob
  ...MatchWithdrawButtonJob
}
fragment RequestInterviewButtonJob on Job {
  id
  canApply {
    value
    reasons {
      fullMessages
    }
  }
  instantOffer
  jobApplication {
    id
    state
  }
  onHold
  ...UserViewedMatchEventJob
}
fragment JobUtilsPayRateJob on Job {
  id
  travelAllowed
  localAllowed
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  grossPayWeekly
  jobType
  localGrossPayWeekly
  localPaymentDetails {
    id
    grossPayWeekly
  }
}
fragment UserViewedMatchEventJob on Job {
  id
  activeApplicantsCount
  business {
    id
    city
    name
    logo
    state
  }
  clinicalUnit {
    id
    displayName
  }
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  favoritedCount
  grossPayWeekly
  hoursPerShift
  instantOffer
  jobType
  lengthInWeeks
  shiftsPerWeek
  shiftType
  startDate
  stateActiveAt
  title
}`) as unknown as TypedDocumentString<MatchDetailPageExpressInterestMutation, MatchDetailPageExpressInterestMutationVariables>;
export const MatchDetailPageRemoveInterestDocument = new TypedDocumentString(`
    mutation MatchDetailPageRemoveInterest($id: String!, $source: String) {
  removeInterest(job_uuid: $id, source: $source) {
    id
    ...JobMatchTopCardBlockJob
  }
}
    fragment MatchApplyButtonJob on Job {
  id
  canApply {
    value
    reasons {
      fullMessages
    }
  }
  esMatch {
    id
  }
  ...RequestInterviewButtonJob
}
fragment MatchFavoriteButtonJob on Job {
  id
  canFavorite {
    value
    reasons {
      fullMessages
    }
  }
  esMatch {
    id
    userState
  }
}
fragment MatchWithdrawButtonJob on Job {
  id
  canWithdraw {
    value
    reasons {
      fullMessages
    }
  }
}
fragment JobMatchTopCardBlockJob on Job {
  id
  instantOffer
  business {
    id
    hideMatchInfo
    name
    city
    state
  }
  hoursPerShift
  jobType
  lengthInWeeks
  location {
    id
    city
    stateCode
  }
  positionCount
  shiftsPerWeek
  shiftType
  startAsap
  startDate
  title
  jobApplication {
    id
    state
  }
  ...JobUtilsPayRateJob
  ...MatchApplyButtonJob
  ...MatchFavoriteButtonJob
  ...MatchWithdrawButtonJob
}
fragment RequestInterviewButtonJob on Job {
  id
  canApply {
    value
    reasons {
      fullMessages
    }
  }
  instantOffer
  jobApplication {
    id
    state
  }
  onHold
  ...UserViewedMatchEventJob
}
fragment JobUtilsPayRateJob on Job {
  id
  travelAllowed
  localAllowed
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  grossPayWeekly
  jobType
  localGrossPayWeekly
  localPaymentDetails {
    id
    grossPayWeekly
  }
}
fragment UserViewedMatchEventJob on Job {
  id
  activeApplicantsCount
  business {
    id
    city
    name
    logo
    state
  }
  clinicalUnit {
    id
    displayName
  }
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  favoritedCount
  grossPayWeekly
  hoursPerShift
  instantOffer
  jobType
  lengthInWeeks
  shiftsPerWeek
  shiftType
  startDate
  stateActiveAt
  title
}`) as unknown as TypedDocumentString<MatchDetailPageRemoveInterestMutation, MatchDetailPageRemoveInterestMutationVariables>;
export const MatchDetailPageDocument = new TypedDocumentString(`
    query MatchDetailPage($id: String!) {
  viewer {
    ... on User {
      ...MatchDetailPageUser
    }
  }
  job: fetchJobWithEsMatch(uuid: $id) {
    ...MatchDetailPageJob
  }
}
    fragment JobGoogleMapLocation on Location {
  id
  latitude
  longitude
}
fragment JobMatchFacilityBlockJob on Job {
  business {
    id
    name
    address
    city
    logo
    state
    zipcode
    slug
    rankings {
      id
      usnewsType
    }
    hospital {
      id
      teaching
      traumaCenterLevel
      affiliatedUnion
      totalLicensedBeds
      hospitalSystem
      hospitalType
      jointCommission
      magnet
    }
  }
}
fragment MatchApplyButtonJob on Job {
  id
  canApply {
    value
    reasons {
      fullMessages
    }
  }
  esMatch {
    id
  }
  ...RequestInterviewButtonJob
}
fragment MatchApplyButtonUser on User {
  id
  ...RequestInterviewButtonUser
}
fragment MatchFavoriteButtonJob on Job {
  id
  canFavorite {
    value
    reasons {
      fullMessages
    }
  }
  esMatch {
    id
    userState
  }
}
fragment MatchFavoriteButtonUser on User {
  id
  userProperties {
    id
    shouldDisplayFirstFavoriteMessage
  }
}
fragment MatchWithdrawButtonJob on Job {
  id
  canWithdraw {
    value
    reasons {
      fullMessages
    }
  }
}
fragment JobMatchTopCardBlockJob on Job {
  id
  instantOffer
  business {
    id
    hideMatchInfo
    name
    city
    state
  }
  hoursPerShift
  jobType
  lengthInWeeks
  location {
    id
    city
    stateCode
  }
  positionCount
  shiftsPerWeek
  shiftType
  startAsap
  startDate
  title
  jobApplication {
    id
    state
  }
  ...JobUtilsPayRateJob
  ...MatchApplyButtonJob
  ...MatchFavoriteButtonJob
  ...MatchWithdrawButtonJob
}
fragment JobMatchTopCardBlockUser on User {
  id
  referralCode
  ...MatchApplyButtonUser
  ...MatchFavoriteButtonUser
}
fragment MatchDetailsUser on User {
  id
  ...JobMatchTopCardBlockUser
}
fragment MatchDetailsJob on Job {
  id
  state
  business {
    id
    bgImageFlickrUrl
    hideMatchInfo
    state
    location {
      id
      city
      stateCode
    }
  }
  cityLocation {
    ...JobGoogleMapLocation
  }
  clinicalUnit {
    id
    displayName
  }
  endDate
  friendlyLicenseType
  hoursPerShift
  jobType
  jobApplication {
    id
    candidateHoldReasons
    state
  }
  defaultPaymentDetails {
    ...MatchDetailsJobPaymentDetails
  }
  localPaymentDetails {
    ...MatchDetailsJobPaymentDetails
  }
  location {
    id
    city
    stateCode
    ...JobGoogleMapLocation
  }
  lengthInWeeks
  licenseType
  nursePatientRatio
  publicDescription
  roles {
    id
    type
  }
  shiftEnd
  shiftType
  shiftsPerWeek
  shiftStart
  startAsap
  startDate
  ...JobMatchTopCardBlockJob
  ...JobMatchFacilityBlockJob
  ...MatchDetailsPreferredJars
  ...MatchDetailsRequiredJars
  ...UserViewedMatchEventJob
}
fragment MatchDetailsPreferredJars on Job {
  preferredJarsV2 {
    __typename
    ... on JobApplicationRequirementsMaximumTimeOffRule {
      ...JarMaximumTimeOffRule
    }
    ... on JobApplicationRequirementsRadiusRule {
      ...JarRadiusRule
    }
    ... on JobApplicationRequirementsLocationFloating {
      ...JarLocationFloating
    }
    ... on JobApplicationRequirementsUnitFloating {
      ...JarUnitFloating
    }
    ... on JobApplicationRequirementsCovidVaccine {
      ...JarCovidVaccine
    }
    ... on JobApplicationRequirementsCovidBooster {
      ...JarCovidBooster
    }
    ... on JobApplicationRequirementsFluVaccine {
      ...JarFluVaccine
    }
    ... on JobApplicationRequirementsFluVaccination {
      ...JarFluVaccination
    }
    ... on JobApplicationRequirementsRoleExperience {
      ...JarRoleExperience
    }
    ... on JobApplicationRequirementsUnitExperience {
      ...JarUnitExperience
    }
    ... on JobApplicationRequirementsTechnologyExperience {
      ...JarTechnologyExperience
    }
    ... on JobApplicationRequirementsTravelExperience {
      ...JarTravelExperience
    }
    ... on JobApplicationRequirementsStateLicense {
      ...JarStateLicense
    }
    ... on JobApplicationRequirementsDriverLicense {
      ...JarDriverLicense
    }
    ... on JobApplicationRequirementsNurseReference {
      ...JarNurseReference
    }
    ... on JobApplicationRequirementsCertification {
      ...JarCertification
    }
    ... on JobApplicationRequirementsProofOfIdentification {
      ...JarProofOfIdentification
    }
    ... on JobApplicationRequirementsTraumaLevelExperience {
      ...JarTraumaLevelExperience
    }
    ... on JobApplicationRequirementsEducation {
      ...JarEducation
    }
  }
}
fragment MatchDetailsRequiredJars on Job {
  requiredJarsV2 {
    __typename
    ... on JobApplicationRequirementsRadiusRule {
      ...JarRadiusRule
    }
    ... on JobApplicationRequirementsMaximumTimeOffRule {
      ...JarMaximumTimeOffRule
    }
    ... on JobApplicationRequirementsLocationFloating {
      ...JarLocationFloating
    }
    ... on JobApplicationRequirementsUnitFloating {
      ...JarUnitFloating
    }
    ... on JobApplicationRequirementsCovidVaccine {
      ...JarCovidVaccine
    }
    ... on JobApplicationRequirementsCovidBooster {
      ...JarCovidBooster
    }
    ... on JobApplicationRequirementsFluVaccine {
      ...JarFluVaccine
    }
    ... on JobApplicationRequirementsFluVaccination {
      ...JarFluVaccination
    }
    ... on JobApplicationRequirementsRoleExperience {
      ...JarRoleExperience
    }
    ... on JobApplicationRequirementsUnitExperience {
      ...JarUnitExperience
    }
    ... on JobApplicationRequirementsTechnologyExperience {
      ...JarTechnologyExperience
    }
    ... on JobApplicationRequirementsTravelExperience {
      ...JarTravelExperience
    }
    ... on JobApplicationRequirementsStateLicense {
      ...JarStateLicense
    }
    ... on JobApplicationRequirementsDriverLicense {
      ...JarDriverLicense
    }
    ... on JobApplicationRequirementsNurseReference {
      ...JarNurseReference
    }
    ... on JobApplicationRequirementsCertification {
      ...JarCertification
    }
    ... on JobApplicationRequirementsProofOfIdentification {
      ...JarProofOfIdentification
    }
    ... on JobApplicationRequirementsTraumaLevelExperience {
      ...JarTraumaLevelExperience
    }
    ... on JobApplicationRequirementsEducation {
      ...JarEducation
    }
  }
}
fragment MatchDetailsJobPaymentDetails on JobPaymentDetails {
  id
  blendedWageRate
  callBackRate
  doubleTimeMultiplier
  extraRate
  grossPayWeekly
  holidayRate
  incidentalsStipendDaily
  lodgingStipendDaily
  onCallRate
  overtimeHoursPerWeek
  overtimeMultiplier
  overtimeWageRate
  regularHoursPerWeek
  regularWageRate
  totalHoursPerWeek
}
fragment RequestInterviewButtonJob on Job {
  id
  canApply {
    value
    reasons {
      fullMessages
    }
  }
  instantOffer
  jobApplication {
    id
    state
  }
  onHold
  ...UserViewedMatchEventJob
}
fragment RequestInterviewButtonUser on User {
  id
  nurseProfile {
    ...RequestInterviewButtonNurseProfile
  }
  ...JobApplicationRequirementsUser
}
fragment RequestInterviewButtonNurseProfile on NurseProfile {
  id
  isActivated
  canApplyJobs
  profileCompletion {
    id
    meta {
      id
      percentCompleted
    }
  }
  state
}
fragment JobApplicationRequirementsUser on User {
  id
  email
  firstName
  lastName
  nurseProfile {
    ...JobApplicationRequirementsNurseProfile
  }
}
fragment JobApplicationRequirementsNurseAdvocate on SalesforceUser {
  id
  email
  fullName
}
fragment JobApplicationRequirementsNurseProfile on NurseProfile {
  id
  state
  percentComplete
  profileCompletion {
    id
  }
  nurseAdvocate {
    ...JobApplicationRequirementsNurseAdvocate
  }
}
fragment MatchDetailPageUser on User {
  id
  ...MatchDetailsUser
  ...UserViewedMatchEventUser
}
fragment MatchDetailPageJob on Job {
  id
  ...MatchDetailsJob
  ...UserViewedMatchEventJob
}
fragment JarRadiusRule on JobApplicationRequirementsRadiusRule {
  id
  type
  description
}
fragment JarCertification on JobApplicationRequirementsCertification {
  id
  type
  title
  description
  certification {
    id
    credential
    name
    uuid
    issuingBodies
  }
}
fragment JarNurseReference on JobApplicationRequirementsNurseReference {
  id
  description
  occurrences
  timeframe
  type
}
fragment JarDriverLicense on JobApplicationRequirementsDriverLicense {
  id
  required
  type
  stage
}
fragment JarCovidVaccine on JobApplicationRequirementsCovidVaccine {
  id
  type
  stage
  description
}
fragment JarCovidBooster on JobApplicationRequirementsCovidBooster {
  id
  type
  stage
  description
}
fragment JarFluVaccine on JobApplicationRequirementsFluVaccine {
  id
  type
  stage
  description
}
fragment JarFluVaccination on JobApplicationRequirementsFluVaccination {
  id
  type
  stage
  description
}
fragment JarLocationFloating on JobApplicationRequirementsLocationFloating {
  id
  type
  description
}
fragment JarMaximumTimeOffRule on JobApplicationRequirementsMaximumTimeOffRule {
  id
  type
  maximumTimeOff
  description
}
fragment JarUnitFloating on JobApplicationRequirementsUnitFloating {
  id
  type
  description
}
fragment JarStateLicense on JobApplicationRequirementsStateLicense {
  id
  stage
  type
  description
}
fragment JarTravelExperience on JobApplicationRequirementsTravelExperience {
  id
  type
  months
  description
}
fragment JarRoleExperience on JobApplicationRequirementsRoleExperience {
  id
  type
  months
  description
}
fragment JarUnitExperience on JobApplicationRequirementsUnitExperience {
  id
  type
  months
  description
}
fragment JarTechnologyExperience on JobApplicationRequirementsTechnologyExperience {
  id
  type
  months
  description
  technology {
    id
    uuid
    name
  }
}
fragment JarProofOfIdentification on JobApplicationRequirementsProofOfIdentification {
  id
  type
  description
  required
  stage
}
fragment JarTraumaLevelExperience on JobApplicationRequirementsTraumaLevelExperience {
  id
  type
  description
  enforcementType
}
fragment JarEducation on JobApplicationRequirementsEducation {
  id
  type
  description
  enforcementType
}
fragment JobUtilsPayRateJob on Job {
  id
  travelAllowed
  localAllowed
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  grossPayWeekly
  jobType
  localGrossPayWeekly
  localPaymentDetails {
    id
    grossPayWeekly
  }
}
fragment UserViewedMatchEventUser on User {
  id
  email
  firstName
  lastName
  nurseProfile {
    id
    percentComplete
    nurseAdvocate {
      id
      email
      fullName
    }
  }
}
fragment UserViewedMatchEventJob on Job {
  id
  activeApplicantsCount
  business {
    id
    city
    name
    logo
    state
  }
  clinicalUnit {
    id
    displayName
  }
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  favoritedCount
  grossPayWeekly
  hoursPerShift
  instantOffer
  jobType
  lengthInWeeks
  shiftsPerWeek
  shiftType
  startDate
  stateActiveAt
  title
}`) as unknown as TypedDocumentString<MatchDetailPageQuery, MatchDetailPageQueryVariables>;
export const EmbeddedMatchDetailPageDocument = new TypedDocumentString(`
    query EmbeddedMatchDetailPage($id: String!) {
  job: fetchJobWithEsMatch(uuid: $id) {
    ...MatchDetailPageJob
  }
}
    fragment JobGoogleMapLocation on Location {
  id
  latitude
  longitude
}
fragment JobMatchFacilityBlockJob on Job {
  business {
    id
    name
    address
    city
    logo
    state
    zipcode
    slug
    rankings {
      id
      usnewsType
    }
    hospital {
      id
      teaching
      traumaCenterLevel
      affiliatedUnion
      totalLicensedBeds
      hospitalSystem
      hospitalType
      jointCommission
      magnet
    }
  }
}
fragment MatchApplyButtonJob on Job {
  id
  canApply {
    value
    reasons {
      fullMessages
    }
  }
  esMatch {
    id
  }
  ...RequestInterviewButtonJob
}
fragment MatchFavoriteButtonJob on Job {
  id
  canFavorite {
    value
    reasons {
      fullMessages
    }
  }
  esMatch {
    id
    userState
  }
}
fragment MatchWithdrawButtonJob on Job {
  id
  canWithdraw {
    value
    reasons {
      fullMessages
    }
  }
}
fragment JobMatchTopCardBlockJob on Job {
  id
  instantOffer
  business {
    id
    hideMatchInfo
    name
    city
    state
  }
  hoursPerShift
  jobType
  lengthInWeeks
  location {
    id
    city
    stateCode
  }
  positionCount
  shiftsPerWeek
  shiftType
  startAsap
  startDate
  title
  jobApplication {
    id
    state
  }
  ...JobUtilsPayRateJob
  ...MatchApplyButtonJob
  ...MatchFavoriteButtonJob
  ...MatchWithdrawButtonJob
}
fragment MatchDetailsJob on Job {
  id
  state
  business {
    id
    bgImageFlickrUrl
    hideMatchInfo
    state
    location {
      id
      city
      stateCode
    }
  }
  cityLocation {
    ...JobGoogleMapLocation
  }
  clinicalUnit {
    id
    displayName
  }
  endDate
  friendlyLicenseType
  hoursPerShift
  jobType
  jobApplication {
    id
    candidateHoldReasons
    state
  }
  defaultPaymentDetails {
    ...MatchDetailsJobPaymentDetails
  }
  localPaymentDetails {
    ...MatchDetailsJobPaymentDetails
  }
  location {
    id
    city
    stateCode
    ...JobGoogleMapLocation
  }
  lengthInWeeks
  licenseType
  nursePatientRatio
  publicDescription
  roles {
    id
    type
  }
  shiftEnd
  shiftType
  shiftsPerWeek
  shiftStart
  startAsap
  startDate
  ...JobMatchTopCardBlockJob
  ...JobMatchFacilityBlockJob
  ...MatchDetailsPreferredJars
  ...MatchDetailsRequiredJars
  ...UserViewedMatchEventJob
}
fragment MatchDetailsPreferredJars on Job {
  preferredJarsV2 {
    __typename
    ... on JobApplicationRequirementsMaximumTimeOffRule {
      ...JarMaximumTimeOffRule
    }
    ... on JobApplicationRequirementsRadiusRule {
      ...JarRadiusRule
    }
    ... on JobApplicationRequirementsLocationFloating {
      ...JarLocationFloating
    }
    ... on JobApplicationRequirementsUnitFloating {
      ...JarUnitFloating
    }
    ... on JobApplicationRequirementsCovidVaccine {
      ...JarCovidVaccine
    }
    ... on JobApplicationRequirementsCovidBooster {
      ...JarCovidBooster
    }
    ... on JobApplicationRequirementsFluVaccine {
      ...JarFluVaccine
    }
    ... on JobApplicationRequirementsFluVaccination {
      ...JarFluVaccination
    }
    ... on JobApplicationRequirementsRoleExperience {
      ...JarRoleExperience
    }
    ... on JobApplicationRequirementsUnitExperience {
      ...JarUnitExperience
    }
    ... on JobApplicationRequirementsTechnologyExperience {
      ...JarTechnologyExperience
    }
    ... on JobApplicationRequirementsTravelExperience {
      ...JarTravelExperience
    }
    ... on JobApplicationRequirementsStateLicense {
      ...JarStateLicense
    }
    ... on JobApplicationRequirementsDriverLicense {
      ...JarDriverLicense
    }
    ... on JobApplicationRequirementsNurseReference {
      ...JarNurseReference
    }
    ... on JobApplicationRequirementsCertification {
      ...JarCertification
    }
    ... on JobApplicationRequirementsProofOfIdentification {
      ...JarProofOfIdentification
    }
    ... on JobApplicationRequirementsTraumaLevelExperience {
      ...JarTraumaLevelExperience
    }
    ... on JobApplicationRequirementsEducation {
      ...JarEducation
    }
  }
}
fragment MatchDetailsRequiredJars on Job {
  requiredJarsV2 {
    __typename
    ... on JobApplicationRequirementsRadiusRule {
      ...JarRadiusRule
    }
    ... on JobApplicationRequirementsMaximumTimeOffRule {
      ...JarMaximumTimeOffRule
    }
    ... on JobApplicationRequirementsLocationFloating {
      ...JarLocationFloating
    }
    ... on JobApplicationRequirementsUnitFloating {
      ...JarUnitFloating
    }
    ... on JobApplicationRequirementsCovidVaccine {
      ...JarCovidVaccine
    }
    ... on JobApplicationRequirementsCovidBooster {
      ...JarCovidBooster
    }
    ... on JobApplicationRequirementsFluVaccine {
      ...JarFluVaccine
    }
    ... on JobApplicationRequirementsFluVaccination {
      ...JarFluVaccination
    }
    ... on JobApplicationRequirementsRoleExperience {
      ...JarRoleExperience
    }
    ... on JobApplicationRequirementsUnitExperience {
      ...JarUnitExperience
    }
    ... on JobApplicationRequirementsTechnologyExperience {
      ...JarTechnologyExperience
    }
    ... on JobApplicationRequirementsTravelExperience {
      ...JarTravelExperience
    }
    ... on JobApplicationRequirementsStateLicense {
      ...JarStateLicense
    }
    ... on JobApplicationRequirementsDriverLicense {
      ...JarDriverLicense
    }
    ... on JobApplicationRequirementsNurseReference {
      ...JarNurseReference
    }
    ... on JobApplicationRequirementsCertification {
      ...JarCertification
    }
    ... on JobApplicationRequirementsProofOfIdentification {
      ...JarProofOfIdentification
    }
    ... on JobApplicationRequirementsTraumaLevelExperience {
      ...JarTraumaLevelExperience
    }
    ... on JobApplicationRequirementsEducation {
      ...JarEducation
    }
  }
}
fragment MatchDetailsJobPaymentDetails on JobPaymentDetails {
  id
  blendedWageRate
  callBackRate
  doubleTimeMultiplier
  extraRate
  grossPayWeekly
  holidayRate
  incidentalsStipendDaily
  lodgingStipendDaily
  onCallRate
  overtimeHoursPerWeek
  overtimeMultiplier
  overtimeWageRate
  regularHoursPerWeek
  regularWageRate
  totalHoursPerWeek
}
fragment RequestInterviewButtonJob on Job {
  id
  canApply {
    value
    reasons {
      fullMessages
    }
  }
  instantOffer
  jobApplication {
    id
    state
  }
  onHold
  ...UserViewedMatchEventJob
}
fragment MatchDetailPageJob on Job {
  id
  ...MatchDetailsJob
  ...UserViewedMatchEventJob
}
fragment JarRadiusRule on JobApplicationRequirementsRadiusRule {
  id
  type
  description
}
fragment JarCertification on JobApplicationRequirementsCertification {
  id
  type
  title
  description
  certification {
    id
    credential
    name
    uuid
    issuingBodies
  }
}
fragment JarNurseReference on JobApplicationRequirementsNurseReference {
  id
  description
  occurrences
  timeframe
  type
}
fragment JarDriverLicense on JobApplicationRequirementsDriverLicense {
  id
  required
  type
  stage
}
fragment JarCovidVaccine on JobApplicationRequirementsCovidVaccine {
  id
  type
  stage
  description
}
fragment JarCovidBooster on JobApplicationRequirementsCovidBooster {
  id
  type
  stage
  description
}
fragment JarFluVaccine on JobApplicationRequirementsFluVaccine {
  id
  type
  stage
  description
}
fragment JarFluVaccination on JobApplicationRequirementsFluVaccination {
  id
  type
  stage
  description
}
fragment JarLocationFloating on JobApplicationRequirementsLocationFloating {
  id
  type
  description
}
fragment JarMaximumTimeOffRule on JobApplicationRequirementsMaximumTimeOffRule {
  id
  type
  maximumTimeOff
  description
}
fragment JarUnitFloating on JobApplicationRequirementsUnitFloating {
  id
  type
  description
}
fragment JarStateLicense on JobApplicationRequirementsStateLicense {
  id
  stage
  type
  description
}
fragment JarTravelExperience on JobApplicationRequirementsTravelExperience {
  id
  type
  months
  description
}
fragment JarRoleExperience on JobApplicationRequirementsRoleExperience {
  id
  type
  months
  description
}
fragment JarUnitExperience on JobApplicationRequirementsUnitExperience {
  id
  type
  months
  description
}
fragment JarTechnologyExperience on JobApplicationRequirementsTechnologyExperience {
  id
  type
  months
  description
  technology {
    id
    uuid
    name
  }
}
fragment JarProofOfIdentification on JobApplicationRequirementsProofOfIdentification {
  id
  type
  description
  required
  stage
}
fragment JarTraumaLevelExperience on JobApplicationRequirementsTraumaLevelExperience {
  id
  type
  description
  enforcementType
}
fragment JarEducation on JobApplicationRequirementsEducation {
  id
  type
  description
  enforcementType
}
fragment JobUtilsPayRateJob on Job {
  id
  travelAllowed
  localAllowed
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  grossPayWeekly
  jobType
  localGrossPayWeekly
  localPaymentDetails {
    id
    grossPayWeekly
  }
}
fragment UserViewedMatchEventJob on Job {
  id
  activeApplicantsCount
  business {
    id
    city
    name
    logo
    state
  }
  clinicalUnit {
    id
    displayName
  }
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  favoritedCount
  grossPayWeekly
  hoursPerShift
  instantOffer
  jobType
  lengthInWeeks
  shiftsPerWeek
  shiftType
  startDate
  stateActiveAt
  title
}`) as unknown as TypedDocumentString<EmbeddedMatchDetailPageQuery, EmbeddedMatchDetailPageQueryVariables>;
export const MatchDetailPageRelatedJobsDocument = new TypedDocumentString(`
    query MatchDetailPageRelatedJobs($id: ID!) {
  relatedJobsConnection(id: $id) {
    nodes {
      ...ApplicableMatchCardJob
    }
  }
}
    fragment MatchCardJob on Job {
  id
  activeApplicantsCount
  favoritedCount
  hoursPerShift
  instantOffer
  jobType
  lengthInWeeks
  licenseType
  localAllowed
  onHold
  shiftType
  shiftsPerWeek
  startAsap
  startDate
  endDate
  facilityName
  cancellationPolicy
  stateActiveAt
  title
  travelAllowed
  business {
    city
    state
    ...MatchCardFacility
  }
  clinicalUnit {
    id
    displayName
  }
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  location {
    id
    city
    stateCode
  }
  localPaymentDetails {
    id
    grossPayWeekly
  }
  emr {
    id
    name
  }
}
fragment ApplicableMatchCardJob on Job {
  ...MatchCardJob
  esMatch {
    id
    userState
  }
}
fragment MatchCardFacility on Facility {
  id
  name
  logo
}`) as unknown as TypedDocumentString<MatchDetailPageRelatedJobsQuery, MatchDetailPageRelatedJobsQueryVariables>;
export const MatchesFavoritesPageUnavailableFavoritedMatchesDocument = new TypedDocumentString(`
    mutation MatchesFavoritesPageUnavailableFavoritedMatches {
  clearUnavailableFavoritedMatches {
    jobs {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<MatchesFavoritesPageUnavailableFavoritedMatchesMutation, MatchesFavoritesPageUnavailableFavoritedMatchesMutationVariables>;
export const MatchesFavoritesPageDocument = new TypedDocumentString(`
    query MatchesFavoritesPage($after: String, $before: String, $first: Int, $last: Int) {
  viewer {
    ... on User {
      id
      nurseProfile {
        id
        canApplyJobs
        canViewJobs
        jobs {
          paginatedAvailableFavorited: availableFavorited(
            after: $after
            before: $before
            first: $first
            last: $last
          ) {
            nodes {
              id
              ...ApplicableMatchCardJob
            }
            pageInfo {
              hasNextPage
              hasPreviousPage
              startCursor
              endCursor
            }
          }
          unavailableFavorited(first: 20) {
            nodes {
              id
              ...ApplicableMatchCardJob
            }
          }
        }
        wizardCompleted
      }
      ...MatchCardUser
      ...RequestInterviewButtonUser
    }
  }
}
    fragment MatchCardJob on Job {
  id
  activeApplicantsCount
  favoritedCount
  hoursPerShift
  instantOffer
  jobType
  lengthInWeeks
  licenseType
  localAllowed
  onHold
  shiftType
  shiftsPerWeek
  startAsap
  startDate
  endDate
  facilityName
  cancellationPolicy
  stateActiveAt
  title
  travelAllowed
  business {
    city
    state
    ...MatchCardFacility
  }
  clinicalUnit {
    id
    displayName
  }
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  location {
    id
    city
    stateCode
  }
  localPaymentDetails {
    id
    grossPayWeekly
  }
  emr {
    id
    name
  }
}
fragment ApplicableMatchCardJob on Job {
  ...MatchCardJob
  esMatch {
    id
    userState
  }
}
fragment MatchCardUser on User {
  id
  email
  nurseProfile {
    id
    isActivated
    percentComplete
    state
    profileCompletion {
      id
      meta {
        id
        percentCompleted
      }
    }
    nurseAdvocate {
      id
      email
      fullName
    }
  }
}
fragment MatchCardFacility on Facility {
  id
  name
  logo
}
fragment RequestInterviewButtonUser on User {
  id
  nurseProfile {
    ...RequestInterviewButtonNurseProfile
  }
  ...JobApplicationRequirementsUser
}
fragment RequestInterviewButtonNurseProfile on NurseProfile {
  id
  isActivated
  canApplyJobs
  profileCompletion {
    id
    meta {
      id
      percentCompleted
    }
  }
  state
}
fragment JobApplicationRequirementsUser on User {
  id
  email
  firstName
  lastName
  nurseProfile {
    ...JobApplicationRequirementsNurseProfile
  }
}
fragment JobApplicationRequirementsNurseAdvocate on SalesforceUser {
  id
  email
  fullName
}
fragment JobApplicationRequirementsNurseProfile on NurseProfile {
  id
  state
  percentComplete
  profileCompletion {
    id
  }
  nurseAdvocate {
    ...JobApplicationRequirementsNurseAdvocate
  }
}`) as unknown as TypedDocumentString<MatchesFavoritesPageQuery, MatchesFavoritesPageQueryVariables>;
export const OnboardingContainerDocument = new TypedDocumentString(`
    query OnboardingContainer {
  nurseProfile {
    id
    canViewJobs
    updatedAt
    isOnboarding
    todoLists {
      ...OnboardingListTodoList
    }
    onboardingPlacement {
      isOnboardingCompleted
      onboardingJobOffer {
        id
        uuid
      }
      ...OnboardingPlaceholderJobPlacement
      ...OnboardingCompletedBannerJobPlacement
    }
  }
  documentTemplates {
    id
    key
    types
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment OnboardingCompletedBannerJobPlacement on JobPlacement {
  id
  startDate
  locationCityState
  facilityName
  isOnboardingCompleted
}
fragment ExternalSortedTodoListItemsCategory on SortedTodoListItemsCategory {
  displayName
  items {
    id
    order
    ...OnboardingListItemContainerTodoListItem
  }
}
fragment Categories on SortedTodoListItemsExternal {
  categories {
    general {
      ...ExternalSortedTodoListItemsCategory
    }
    backgroundAndIdentification {
      ...ExternalSortedTodoListItemsCategory
    }
    licensesAndCertifications {
      ...ExternalSortedTodoListItemsCategory
    }
    assessments {
      ...ExternalSortedTodoListItemsCategory
    }
    healthDocuments {
      ...ExternalSortedTodoListItemsCategory
    }
  }
  displayName
  formattedDueDate
}
fragment ExternalTimelineTodoListItems on TodoList {
  id
  timelineTodoListItems(filter: LIVE) {
    externalItems {
      ...Categories
    }
  }
}
fragment OnboardingListTodoList on TodoList {
  uuid
  id
  markedCompleteAt
  contractSignedDate
  completeByDate
  status
  nurseProfile {
    id
    user {
      id
      city
      state
      streetAddress
      zipcode
    }
  }
  todoListItems(filter: LIVE) {
    id
    name
    itemType
    ...OnboardingListItemContainerTodoListItem
  }
  ...ExternalTimelineTodoListItems
  ...OnboardingHeaderTodoList
  ...IncentiveBannerTodoList
}
fragment IncentiveBannerTodoList on TodoList {
  incentiveDeadline
  completeByDate
}
fragment OnboardingHeaderTodoList on TodoList {
  id
  startDate
  ...OnboardingHeaderTitle
  ...OnboardingHeaderSubtitle
  ...OnboardingHeaderBody
  ...OnboardingHeaderCountersTodoList
}
fragment OnboardingHeaderTitle on TodoList {
  id
  publishedAt
  completeByDate
  createdAt
  numTasksDue
  listType
  markedCompleteAt
}
fragment OnboardingHeaderBody on TodoList {
  markedCompleteAt
  publishedAt
  targetBusinessName
}
fragment OnboardingHeaderCountersTodoList on TodoList {
  markedCompleteAt
  numTasksNeedingAttention
  numTasksPending
}
fragment OnboardingHeaderSubtitle on TodoList {
  id
  markedCompleteAt
  targetBusinessName
  targetBusinessLocation {
    id
    city
    stateCode
  }
}
fragment OnboardingListItemContainerTodoListItem on TodoListItem {
  id
  itemType
  ...BaseItem
  ...DocumentItem
  ...NurseCertificationItem
  ...NurseAssessmentItemTodoListItem
  ...NurseHealthDocItem
  ...PlaintextItem
  ...AppointmentItem
}
fragment AppointmentItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingAppointmentPanelTodoListItem
}
fragment BaseItem on TodoListItem {
  id
  name
  description
  verificationNotes
  rejectionReason
  itemState
  schedulable
  needsToBeScheduled
  karmaCheckCaseServiceOrder {
    id
    isPending
  }
  itemType
  actionLinks {
    id
    title
    url
  }
}
fragment DocumentItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingDocumentPanelTodoListItem
}
fragment NurseAssessmentItemTodoListItem on TodoListItem {
  id
  itemState
  nurseAssessmentTarget {
    id
    assessment {
      id
      requestable
    }
  }
  ...BaseItem
  ...OnboardingNurseAssessmentPanelTodoListItem
  ...OnboardingRequestAssessmentPanelTodoListItem
}
fragment NurseCertificationItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingCertificationPanelTodoListItem
}
fragment NurseHealthDocItem on TodoListItem {
  id
  itemState
  nurseHealthDocTarget {
    id
  }
  ...BaseItem
}
fragment PlaintextItem on TodoListItem {
  id
  itemState
  ...BaseItem
  ...OnboardingPlainTextPanelTodoListItem
}
fragment OnboardingPlaceholderJobPlacement on JobPlacement {
  id
  isOnboardingCompleted
  isOnboardingListPending
  facilityName
  locationCityState
  startDate
  status
}
fragment OnboardingAppointmentPanelTodoListItem on TodoListItem {
  id
  name
  description
  candidateNotes
}
fragment OnboardingCertificationPanelTodoListItem on TodoListItem {
  id
  name
  description
  nurseCertificationTarget {
    id
    certificationUuid
    expiresOn
    completedOn
    isExpired
    isExpiringSoon
    issuingBody
    name
    uuid
    useCompletionDate
    files {
      ...FileMetadata
    }
  }
}
fragment OnboardingDocumentPanelDocument on Document {
  id
  uuid
  title
  isExpirable
  isExpiringSoon
  isExpired
  expirationType
  expiresOn
  completedOn
  docType
  docSubtype
  trackCompletionDate
  files {
    ...FileMetadata
  }
  stateCode
}
fragment OnboardingDocumentPanelTodoListItem on TodoListItem {
  id
  name
  description
  documentTarget {
    ...OnboardingDocumentPanelDocument
  }
}
fragment OnboardingNurseAssessmentPanelAssessment on Assessment {
  id
  uuid
  category
  issuingBody
  name
  requestable
}
fragment OnboardingNurseAssessmentPanelTodoListItem on TodoListItem {
  id
  name
  description
  itemState
  nurseAssessmentTarget {
    id
    uuid
    completedOn
    score
    assessment {
      ...OnboardingNurseAssessmentPanelAssessment
    }
    files {
      ...FileMetadata
    }
  }
}
fragment OnboardingPlainTextPanelTodoListItem on TodoListItem {
  id
  uuid
  itemType
  itemState
  candidateNotes
  description
  name
}
fragment OnboardingRequestAssessmentPanelTodoListItem on TodoListItem {
  id
  nurseAssessmentTarget {
    id
    assessment {
      uuid
      name
    }
  }
}`) as unknown as TypedDocumentString<OnboardingContainerQuery, OnboardingContainerQueryVariables>;
export const PayrollItemDocument = new TypedDocumentString(`
    query PayrollItem($payrollId: String!) {
  payrollItem(payrollId: $payrollId) {
    id
    periodEnd
    netAmount
    lineItems {
      id
      ...PaymentSummaryPayrollLineItem
    }
  }
}
    fragment PaymentSummaryPayrollLineItem on PayrollLineItem {
  kind
  hours
  rate
  netAmount
  order
  groupType
  humanizedLabel
}`) as unknown as TypedDocumentString<PayrollItemQuery, PayrollItemQueryVariables>;
export const PayrollShiftDetailsDocument = new TypedDocumentString(`
    query PayrollShiftDetails($payrollId: String!) {
  payrollShiftDetails(payrollId: $payrollId) {
    id
    externalNotes
    shifts {
      id
      ...TimeEnteredShift
    }
  }
}
    fragment TimeEnteredShift on Shift {
  id
  duration
  startSec
  timezone
  timeEntries {
    id
    entryType
    archived
    startSec
    endSec
    timezone
    timeType
    duration
  }
}`) as unknown as TypedDocumentString<PayrollShiftDetailsQuery, PayrollShiftDetailsQueryVariables>;
export const PayPreviewDetailPageViewerDocument = new TypedDocumentString(`
    query PayPreviewDetailPageViewer {
  viewer {
    ... on User {
      id
      firstName
    }
  }
}
    `) as unknown as TypedDocumentString<PayPreviewDetailPageViewerQuery, PayPreviewDetailPageViewerQueryVariables>;
export const PayPreviewListPageDocument = new TypedDocumentString(`
    query PayPreviewListPage($showAllHistory: Boolean) {
  viewer {
    ... on User {
      id
    }
  }
  payrollItems(showAllHistory: $showAllHistory) {
    id
    ...PayPreviewListPagePayroll
    ...PayPeriodTablePayroll
  }
}
    fragment PayPeriodTablePayroll on Payroll {
  id
  contract {
    id
    contractStartDate
    contractEndDate
  }
  ...PayPeriodRowPayroll
}
fragment PayPeriodRowPayroll on Payroll {
  id
  periodStart
  periodEnd
  businessName
}
fragment PayPreviewListPagePayroll on Payroll {
  id
  periodStart
  periodEnd
}`) as unknown as TypedDocumentString<PayPreviewListPageQuery, PayPreviewListPageQueryVariables>;
export const PopularCitiesContainerDocument = new TypedDocumentString(`
    query PopularCitiesContainer($loggedIn: Boolean!) {
  ... @include(if: $loggedIn) {
    viewer {
      ... on User {
        id
        nurseProfile {
          id
          yearsOfExp
          canViewJobs
          nurseType
        }
      }
    }
  }
  popularCitiesPay {
    id
    ...CityCardContainerCityPay
  }
  popularCitiesCostOfLiving {
    id
    ...PopularCitiesCostOfLiving
  }
}
    fragment PopularCitiesCostOfLiving on PopularCityCostOfLiving {
  id
  city
  stateCode
  avgRent
}
fragment CityCardContainerCityPay on PopularCityPay {
  id
  city
  stateCode
  travelWeeklyIncome
  staffHourlyIncome
}`) as unknown as TypedDocumentString<PopularCitiesContainerQuery, PopularCitiesContainerQueryVariables>;
export const ProfilePageV2Document = new TypedDocumentString(`
    query ProfilePageV2 {
  viewer {
    ... on User {
      ...ProfilePageV2User
    }
  }
  profileCompletionSummary {
    ...ProfileCompletionSummary
  }
}
    fragment ProfileCompletionSummary on ProfileCompletionSummary {
  id
  completedAt
  meta {
    id
    completeCount
    expiredCount
    expiringCount
    incompleteCount
    pendingCount
    percentCompleted
  }
  steps {
    estimatedTimeInMinutes
    key
    title
    subtitle
    messages
    sectionName
    status
    hasExpiringItems
    hasExpiredItems
    hasInvalidItems
  }
}
fragment UserFullName on User {
  firstName
  preferredName
  middleName
  lastName
}
fragment NurseAdvocateWidgetSalesforceUser on SalesforceUser {
  id
  phone
  firstName
  lastName
  profileImgUrl
  isNurseAdvocate
  isAlliedAdvocate
  clinicalRole
}
fragment ThisIsMeUser on User {
  id
  profilePic
  ...UserFullName
  nurseProfile {
    id
    applicationSummary
    role {
      id
      name
    }
    primarySpecialty {
      id
      displayName
      fullName
    }
  }
}
fragment ProfilePageV2User on User {
  ...ThisIsMeUser
  nurseProfile {
    id
    nurseAdvocate {
      ...NurseAdvocateWidgetSalesforceUser
    }
    role {
      id
      type
    }
    state
  }
}`) as unknown as TypedDocumentString<ProfilePageV2Query, ProfilePageV2QueryVariables>;
export const AboutMeUpdateDocument = new TypedDocumentString(`
    mutation AboutMeUpdate($input: UpdateAboutMeInput!) {
  updateAboutMe(input: $input) {
    nurseProfile {
      ...AboutMePanelNurseProfile
    }
    user {
      ...AboutMePanelUser
    }
    profileCompletionSummary {
      ...ProfileCompletionSummary
    }
  }
}
    fragment ProfileCompletionSummary on ProfileCompletionSummary {
  id
  completedAt
  meta {
    id
    completeCount
    expiredCount
    expiringCount
    incompleteCount
    pendingCount
    percentCompleted
  }
  steps {
    estimatedTimeInMinutes
    key
    title
    subtitle
    messages
    sectionName
    status
    hasExpiringItems
    hasExpiredItems
    hasInvalidItems
  }
}
fragment AboutMePanelNurseProfile on NurseProfile {
  id
  yearsOfExp
  yearsOfTravelExp
  birthday
  ssnLast4
  fullSsnCollected
  state
  phoneVerified
  role {
    id
  }
  primarySpecialty {
    id
    slug
    fullName
  }
}
fragment AboutMePanelUser on User {
  id
  profilePic
  firstName
  middleName
  lastName
  preferredName
  preferredPronoun
  phone
  phoneVerified
  streetAddressPermanent
  streetNumberPermanent
  cityPermanent
  statePermanent
  zipcodePermanent
  countryPermanentName
  countryPermanentCode
  googlePlaceIdPermanent
}`) as unknown as TypedDocumentString<AboutMeUpdateMutation, AboutMeUpdateMutationVariables>;
export const AboutMePanelDocument = new TypedDocumentString(`
    query AboutMePanel {
  nurseProfile {
    ...AboutMePanelNurseProfile
  }
  viewer {
    ... on User {
      ...AboutMePanelUser
    }
  }
}
    fragment AboutMePanelNurseProfile on NurseProfile {
  id
  yearsOfExp
  yearsOfTravelExp
  birthday
  ssnLast4
  fullSsnCollected
  state
  phoneVerified
  role {
    id
  }
  primarySpecialty {
    id
    slug
    fullName
  }
}
fragment AboutMePanelUser on User {
  id
  profilePic
  firstName
  middleName
  lastName
  preferredName
  preferredPronoun
  phone
  phoneVerified
  streetAddressPermanent
  streetNumberPermanent
  cityPermanent
  statePermanent
  zipcodePermanent
  countryPermanentName
  countryPermanentCode
  googlePlaceIdPermanent
}`) as unknown as TypedDocumentString<AboutMePanelQuery, AboutMePanelQueryVariables>;
export const ReferralsDocument = new TypedDocumentString(`
    query Referrals($offset: Int!, $limit: Int!, $sort: String, $filter: String) {
  viewer {
    ... on User {
      id
      referrals(offset: $offset, limit: $limit, sort: $sort, filter: $filter) {
        totalCount
        users {
          ...ReferralListReferral
        }
      }
    }
  }
}
    fragment ReferralListReferral on Referral {
  firstName
  lastName
  status
  statusDate
}`) as unknown as TypedDocumentString<ReferralsQuery, ReferralsQueryVariables>;
export const ResetPasswordDocument = new TypedDocumentString(`
    mutation ResetPassword($input: SendUserResetPasswordInstructionsInput!) {
  sendUserResetPasswordInstructions(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const ResumeParserUploadResumeDocument = new TypedDocumentString(`
    mutation ResumeParserUploadResume($upload: FileUploadTypeInput!) {
  uploadResume(upload: $upload) {
    uploadedResume {
      id
      resumeParserStep
    }
  }
}
    `) as unknown as TypedDocumentString<ResumeParserUploadResumeMutation, ResumeParserUploadResumeMutationVariables>;
export const ResumeParserHideSuggestionDocument = new TypedDocumentString(`
    mutation ResumeParserHideSuggestion($parserId: String!) {
  hideSuggestion(parserId: $parserId) {
    uploadedResume {
      id
      hiddenSuggestions
    }
  }
}
    `) as unknown as TypedDocumentString<ResumeParserHideSuggestionMutation, ResumeParserHideSuggestionMutationVariables>;
export const ResumeParserPageDocument = new TypedDocumentString(`
    query ResumeParserPage {
  uploadedResume {
    id
    status
  }
}
    `) as unknown as TypedDocumentString<ResumeParserPageQuery, ResumeParserPageQueryVariables>;
export const ResumeParserItemsDocument = new TypedDocumentString(`
    query ResumeParserItems {
  nurseProfile {
    id
    profileCompletion {
      id
      steps {
        permanentAddress {
          status
        }
        personalInfo {
          status
        }
      }
    }
    positions {
      id
      usableForReferences
    }
  }
  parsedPersonalInformation {
    firstName
    lastName
    middleName
    dateOfBirth
  }
  parsedWorkExperiences {
    parserId
  }
  parsedReferences {
    parserId
  }
  parsedEducations {
    parserId
  }
}
    `) as unknown as TypedDocumentString<ResumeParserItemsQuery, ResumeParserItemsQueryVariables>;
export const ParsedAboutMePanelDocument = new TypedDocumentString(`
    query ParsedAboutMePanel {
  nurseProfile {
    ...AboutMePanelNurseProfile
  }
  viewer {
    ... on User {
      ...AboutMePanelUser
    }
  }
  parsedPersonalInformation {
    ...ParsedAboutMeUserInfo
  }
  parsedPermanentAddress {
    ...ParsedAboutMeUserAddress
  }
}
    fragment AboutMePanelNurseProfile on NurseProfile {
  id
  yearsOfExp
  yearsOfTravelExp
  birthday
  ssnLast4
  fullSsnCollected
  state
  phoneVerified
  role {
    id
  }
  primarySpecialty {
    id
    slug
    fullName
  }
}
fragment AboutMePanelUser on User {
  id
  profilePic
  firstName
  middleName
  lastName
  preferredName
  preferredPronoun
  phone
  phoneVerified
  streetAddressPermanent
  streetNumberPermanent
  cityPermanent
  statePermanent
  zipcodePermanent
  countryPermanentName
  countryPermanentCode
  googlePlaceIdPermanent
}
fragment ParsedAboutMeUserInfo on PersonalInformation {
  dateOfBirth
  firstName
  lastName
  middleName
}
fragment ParsedAboutMeUserAddress on PermanentAddress {
  streetAddress: permanentAddress
  city
  state
  country
  zipcode: postalCode
}`) as unknown as TypedDocumentString<ParsedAboutMePanelQuery, ParsedAboutMePanelQueryVariables>;
export const ResumePreviewExperiencedNurseDocument = new TypedDocumentString(`
    query ResumePreviewExperiencedNurse {
  viewer {
    ... on User {
      id
      firstName
      lastName
      phone
      email
      streetAddressPermanent
      cityPermanent
      statePermanent
      zipcodePermanent
      nurseProfile {
        id
        professionalTitles
        applicationSummary
        locationAddress
        gapBetweenEducationAndEmploymentPosition
        sortedExperienceItems {
          ...ResumePreviewWorkExperienceItem
        }
        studentClinicalExperiences {
          ...ResumePreviewStudentClinicalExperience
        }
        educations {
          ...ResumePreviewEducation
        }
        awards {
          ...ResumePreviewAwardsHonors
        }
        researches {
          ...ResumePreviewResearch
        }
        affiliationHistory {
          ...ResumePreviewAffiliationHistory
        }
        languages {
          ...ResumePreviewLanguage
        }
        licenses(notExpired: true) {
          ...ResumePreviewLicenseLicense
        }
        nurseCertifications(notExpired: true) {
          ...ResumePreviewCertificationNurseCertification
        }
      }
    }
  }
}
    fragment ResumePreviewAffiliationHistory on AffiliationHistory {
  id
  organizationName
  startDate
  endDate
  role
  descriptions
}
fragment ResumePreviewAwardsHonors on Award {
  id
  awardedOn
  name
  organization
  descriptions
}
fragment ResumePreviewCertificationNurseCertification on NurseCertification {
  id
  expiresOn
  certification {
    id
    name
    issuingBody
  }
}
fragment ResumePreviewEducation on Education {
  id
  locationAddress
  startedOn
  graduatedOn
  schoolName
  degree
  hasGap
  gapStartOn
  gapEndOn
  gapLocation {
    id
    address
  }
  gapReason
  gapExplanation
  descriptions
}
fragment ResumePreviewLanguage on Language {
  id
  language
  proficiency
}
fragment ResumePreviewLicenseLicense on License {
  id
  expiresOn
  state
  friendlyLicenseType
  number
  compact
}
fragment ResumePreviewResearch on Research {
  id
  startOn
  endOn
  orgName
  descriptions
  locationAddress
}
fragment ResumePreviewStudentClinicalExperience on StudentClinicalExperience {
  id
  facilityName
  locationAddress
  experienceYear
  experienceYearTerm
  experienceType
  studentClinicalExperienceUnits {
    id
    name
    hoursWorked
    descriptions
  }
}
fragment ResumePreviewWorkExperienceItem on ExperienceItemUnion {
  ... on Position {
    ...ResumePreviewWorkExperienceEmploymentPosition
  }
  ... on Gap {
    ...ResumePreviewWorkExperienceEmploymentGap
  }
}
fragment ResumePreviewWorkExperienceEmploymentPosition on Position {
  id
  title
  classification
  additionalSkills
  startAt
  endAt
  floatFrequency
  hoursWorked
  hoursWorkedText
  hoursWorkedTimeframe
  leadExperience
  nicuCareLevels: nicuLevel
  chargeExperience
  preceptorExperience
  unitBedCount
  hospitalBedCount
  magnet
  teaching
  traumaLevel
  patientRatio
  facility {
    id
    name
    location {
      id
      city
      stateCode
    }
  }
  role {
    id
    name
  }
  floatUnits {
    id
    displayName
  }
  agency {
    id
    name
  }
  specialties {
    id
    displayName
  }
  technologies {
    id
    name
  }
  clinicalUnit {
    id
    displayName
  }
}
fragment ResumePreviewWorkExperienceEmploymentGap on Gap {
  gapId: id
  gapEndAt: endAt
  gapExplanation: explanation
  gapIsEducationGap: isEducationGap
  gapLocationAddress: locationAddress
  gapReason: reason
  gapStartAt: startAt
}`) as unknown as TypedDocumentString<ResumePreviewExperiencedNurseQuery, ResumePreviewExperiencedNurseQueryVariables>;
export const UpdatePasswordPageResetUserPasswordDocument = new TypedDocumentString(`
    mutation UpdatePasswordPageResetUserPassword($input: ResetUserPasswordInput!) {
  resetUserPassword(input: $input) {
    token
    user {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<UpdatePasswordPageResetUserPasswordMutation, UpdatePasswordPageResetUserPasswordMutationVariables>;
export const WebChatDataDocument = new TypedDocumentString(`
    query WebChatData {
  sunshineUnreadCount
  viewer {
    ... on User {
      id
      sunshineToken
    }
  }
}
    `) as unknown as TypedDocumentString<WebChatDataQuery, WebChatDataQueryVariables>;
export const UserCreationStepSignupDocument = new TypedDocumentString(`
    mutation UserCreationStepSignup($input: SignUpInput!) {
  signUp(input: $input) {
    user {
      id
      firstName
      preferredName
      lastName
      email
      intercomUserHash
      signupSource
      signupSourceQualifier
      createdAt
    }
    token
  }
}
    `) as unknown as TypedDocumentString<UserCreationStepSignupMutation, UserCreationStepSignupMutationVariables>;
export const CreateClinicianProfileDocument = new TypedDocumentString(`
    mutation CreateClinicianProfile($roleId: ID!, $nurseType: NurseTypes) {
  createClinicianProfile(roleId: $roleId, nurseType: $nurseType) {
    user {
      id
    }
    nurseProfile {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<CreateClinicianProfileMutation, CreateClinicianProfileMutationVariables>;
export const UpdateNurseRoleDocument = new TypedDocumentString(`
    mutation UpdateNurseRole($roleId: ID!) {
  updateNurseRole(roleId: $roleId) {
    user {
      ...ThisIsMeProfileUser
    }
  }
}
    fragment ThisIsMeProfileUser on User {
  id
  ...ThisIsMeIntentSelectorUser
  ...ThisIsMeProfileProfilePhoto
  ...ThisIsMeProfileSubheaderUser
  nurseProfile {
    id
    ...ThisIsMeProfileNurseProfile
  }
}
fragment ThisIsMeProfileNurseProfile on NurseProfile {
  id
  primarySpecialty {
    id
    fullName
    slug
  }
  role {
    id
    key
    name
    type
  }
}
fragment ThisIsMeIntentSelectorUser on User {
  id
  signupSource
  nurseProfile {
    id
    canViewJobs
    nursePreferences {
      id
      startPref
    }
  }
}
fragment ThisIsMeProfileProfilePhoto on User {
  id
  profilePic
}
fragment ThisIsMeProfileSubheaderUser on User {
  id
  firstName
  middleName
  lastName
  preferredName
  nurseProfile {
    id
    locationAddress
    hasBeenPlaced
    roleAbbreviation
    role {
      id
      key
      name
      type
    }
    primarySpecialty {
      displayName
    }
    ...ThisIsMeGetLocation
  }
}
fragment ThisIsMeGetLocation on NurseProfile {
  currentEmployment {
    id
    locationAddress
  }
  educations {
    id
    locationAddress
  }
}`) as unknown as TypedDocumentString<UpdateNurseRoleMutation, UpdateNurseRoleMutationVariables>;
export const UpsertClinicianLanguageDocument = new TypedDocumentString(`
    mutation UpsertClinicianLanguage($input: UpsertClinicianLanguageInput!, $id: ID) {
  upsertClinicianLanguage(input: $input, id: $id) {
    nurseProfile {
      ...LanguageNurseProfileUpdateCache
    }
  }
}
    fragment ClinicianLanguages on Language {
  id
  language
  proficiency
}
fragment LanguageNurseProfileUpdateCache on NurseProfile {
  id
  languages {
    ...ClinicianLanguages
  }
}`) as unknown as TypedDocumentString<UpsertClinicianLanguageMutation, UpsertClinicianLanguageMutationVariables>;
export const DeleteClinicianLanguageDocument = new TypedDocumentString(`
    mutation DeleteClinicianLanguage($id: ID!) {
  deleteClinicianLanguage(id: $id) {
    nurseProfile {
      ...LanguageNurseProfileUpdateCache
    }
  }
}
    fragment ClinicianLanguages on Language {
  id
  language
  proficiency
}
fragment LanguageNurseProfileUpdateCache on NurseProfile {
  id
  languages {
    ...ClinicianLanguages
  }
}`) as unknown as TypedDocumentString<DeleteClinicianLanguageMutation, DeleteClinicianLanguageMutationVariables>;
export const ClinicianLanguageListDocument = new TypedDocumentString(`
    query ClinicianLanguageList {
  nurseProfile {
    ...LanguageNurseProfileUpdateCache
  }
}
    fragment ClinicianLanguages on Language {
  id
  language
  proficiency
}
fragment LanguageNurseProfileUpdateCache on NurseProfile {
  id
  languages {
    ...ClinicianLanguages
  }
}`) as unknown as TypedDocumentString<ClinicianLanguageListQuery, ClinicianLanguageListQueryVariables>;
export const UpsertClinicianLanguageFormDataDocument = new TypedDocumentString(`
    query UpsertClinicianLanguageFormData {
  nurseProfile {
    ...LanguageNurseProfileUpdateCache
  }
  languageType: __type(name: "LanguageType") {
    ...EnumValuesType
  }
  languageProficiencyType: __type(name: "LanguageProficiencyType") {
    ...EnumValuesType
  }
}
    fragment EnumValue on __EnumValue {
  name
  description
}
fragment EnumValuesType on __Type {
  name
  enumValues {
    ...EnumValue
  }
}
fragment ClinicianLanguages on Language {
  id
  language
  proficiency
}
fragment LanguageNurseProfileUpdateCache on NurseProfile {
  id
  languages {
    ...ClinicianLanguages
  }
}`) as unknown as TypedDocumentString<UpsertClinicianLanguageFormDataQuery, UpsertClinicianLanguageFormDataQueryVariables>;
export const SubmitReferenceResponseDocument = new TypedDocumentString(`
    mutation SubmitReferenceResponse($chargeDuties: String!, $comments: String, $employmentDateComments: String, $employmentDateConfirmation: Boolean!, $employmentOther: String!, $jobTitle: String!, $ratingCare: String!, $ratingDocumentation: String!, $ratingFlexible: String!, $ratingPatientCommunication: String!, $ratingPolicies: String!, $ratingProfessional: String!, $ratingPunctual: String!, $ratingStaffCommunication: String!, $relationship: String!, $responseToken: String!, $signedName: String!, $unit: String!, $wouldRehire: Boolean!) {
  submitReferenceResponse(
    charge_duties: $chargeDuties
    comments: $comments
    employment_date_comments: $employmentDateComments
    employment_date_confirmation: $employmentDateConfirmation
    employment_other: $employmentOther
    job_title: $jobTitle
    rating_care: $ratingCare
    rating_documentation: $ratingDocumentation
    rating_flexible: $ratingFlexible
    rating_patient_communication: $ratingPatientCommunication
    rating_policies: $ratingPolicies
    rating_professional: $ratingProfessional
    rating_punctual: $ratingPunctual
    rating_staff_communication: $ratingStaffCommunication
    relationship: $relationship
    response_token: $responseToken
    signed_name: $signedName
    unit: $unit
    would_rehire: $wouldRehire
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<SubmitReferenceResponseMutation, SubmitReferenceResponseMutationVariables>;
export const ReferenceResponsePageDocument = new TypedDocumentString(`
    query ReferenceResponsePage($responseToken: String) {
  reference: fetchReference(response_token: $responseToken) {
    ...ReferenceResponseReferenceDetails
  }
}
    fragment ReferenceResponseReferenceDetails on Reference {
  id
  name
  candidateName
  employmentOther
  jobTitle
  relationship
  responseAt
  unit
}`) as unknown as TypedDocumentString<ReferenceResponsePageQuery, ReferenceResponsePageQueryVariables>;
export const UpsertReferenceDocument = new TypedDocumentString(`
    mutation UpsertReference($input: UpsertReferenceInput!, $parserId: String) {
  upsertReference(input: $input, parserId: $parserId) {
    nurseProfile {
      ...ReferenceNurseProfileUpdateCache
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment ReferenceNurseProfileUpdateCache on NurseProfile {
  id
  canApplyJobs
  numActiveReferences
  referencesComplete
  references {
    ...ReferenceDetails
  }
  positions {
    id
    startAt
    endAt
    usableForReferences
    facility {
      id
      name
      location {
        id
        formattedLocationString
        googlePlaceId
      }
    }
  }
  licenses {
    id
  }
  applicationReadiness {
    meta {
      requirements {
        status
      }
    }
    results {
      references {
        label
        status
        completeReferenceCount
        pendingReferenceCount
      }
    }
  }
  profileCompletion {
    id
    steps {
      references {
        status
      }
    }
  }
}
fragment ReferenceDetails on Reference {
  id
  bedCount
  chargeExp
  email
  expired
  facilityName
  isLocked
  jobTitle
  lastFailedDelivery
  name
  patientsPerNurse
  phone
  preferredContactMethod
  relationship
  responseAt
  signedName
  unit
  unitName
  files {
    ...FileMetadata
  }
  position {
    id
    startAt
    endAt
    title
    usableForReferences
    facility {
      id
      name
      location {
        id
        formattedLocationString
        googlePlaceId
      }
    }
  }
}`) as unknown as TypedDocumentString<UpsertReferenceMutation, UpsertReferenceMutationVariables>;
export const RemoveReferenceDocument = new TypedDocumentString(`
    mutation RemoveReference($id: ID!) {
  removeReference(id: $id) {
    nurseProfile {
      ...ReferenceNurseProfileUpdateCache
    }
    error
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment ReferenceNurseProfileUpdateCache on NurseProfile {
  id
  canApplyJobs
  numActiveReferences
  referencesComplete
  references {
    ...ReferenceDetails
  }
  positions {
    id
    startAt
    endAt
    usableForReferences
    facility {
      id
      name
      location {
        id
        formattedLocationString
        googlePlaceId
      }
    }
  }
  licenses {
    id
  }
  applicationReadiness {
    meta {
      requirements {
        status
      }
    }
    results {
      references {
        label
        status
        completeReferenceCount
        pendingReferenceCount
      }
    }
  }
  profileCompletion {
    id
    steps {
      references {
        status
      }
    }
  }
}
fragment ReferenceDetails on Reference {
  id
  bedCount
  chargeExp
  email
  expired
  facilityName
  isLocked
  jobTitle
  lastFailedDelivery
  name
  patientsPerNurse
  phone
  preferredContactMethod
  relationship
  responseAt
  signedName
  unit
  unitName
  files {
    ...FileMetadata
  }
  position {
    id
    startAt
    endAt
    title
    usableForReferences
    facility {
      id
      name
      location {
        id
        formattedLocationString
        googlePlaceId
      }
    }
  }
}`) as unknown as TypedDocumentString<RemoveReferenceMutation, RemoveReferenceMutationVariables>;
export const ReferenceListDocument = new TypedDocumentString(`
    query ReferenceList {
  nurseProfile {
    id
    state
    name
    references {
      ...ReferencesItem
    }
  }
  parsedReferences {
    ...ResumeParserReferenceSuggestions
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment ReferencesItem on Reference {
  id
  belowExpectations
  canEdit
  chargeExp
  email
  employmentOther
  expired
  isExpiringSoon
  isLocked
  jobTitle
  lastFailedDelivery
  name
  phone
  preferredContactMethod
  referenceFormSentAt
  relationship
  responseAt
  signedName
  unit
  wouldRehire
  position {
    id
    facility {
      id
      name
    }
  }
  files {
    ...FileMetadata
  }
}
fragment ResumeParserReferenceSuggestions on ReferenceSuggestion {
  email
  jobTitle
  mobileNumber
  name
  parserId
  preferredContactMethod
  text
}`) as unknown as TypedDocumentString<ReferenceListQuery, ReferenceListQueryVariables>;
export const EditReferenceFormDocument = new TypedDocumentString(`
    query EditReferenceForm($id: ID!) {
  reference(id: $id) {
    id
    ...ReferenceDetails
  }
  nurseProfile {
    id
    positions {
      ...ReferenceDetailsPosition
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment ReferenceDetails on Reference {
  id
  bedCount
  chargeExp
  email
  expired
  facilityName
  isLocked
  jobTitle
  lastFailedDelivery
  name
  patientsPerNurse
  phone
  preferredContactMethod
  relationship
  responseAt
  signedName
  unit
  unitName
  files {
    ...FileMetadata
  }
  position {
    id
    startAt
    endAt
    title
    usableForReferences
    facility {
      id
      name
      location {
        id
        formattedLocationString
        googlePlaceId
      }
    }
  }
}
fragment ReferenceDetailsPosition on Position {
  id
  startAt
  endAt
  title
  usableForReferences
  facility {
    id
    name
    location {
      id
      formattedLocationString
      googlePlaceId
    }
  }
}`) as unknown as TypedDocumentString<EditReferenceFormQuery, EditReferenceFormQueryVariables>;
export const CreateReferenceFormDocument = new TypedDocumentString(`
    query CreateReferenceForm {
  nurseProfile {
    id
    positions {
      ...ReferenceDetailsPosition
    }
  }
}
    fragment ReferenceDetailsPosition on Position {
  id
  startAt
  endAt
  title
  usableForReferences
  facility {
    id
    name
    location {
      id
      formattedLocationString
      googlePlaceId
    }
  }
}`) as unknown as TypedDocumentString<CreateReferenceFormQuery, CreateReferenceFormQueryVariables>;
export const EditReferenceSuggestionFormDocument = new TypedDocumentString(`
    query EditReferenceSuggestionForm($id: ID!) {
  parsedReference(id: $id) {
    ...ResumeParserReferenceSuggestions
  }
  nurseProfile {
    id
    positions {
      ...ReferenceDetailsPosition
    }
  }
}
    fragment ReferenceDetailsPosition on Position {
  id
  startAt
  endAt
  title
  usableForReferences
  facility {
    id
    name
    location {
      id
      formattedLocationString
      googlePlaceId
    }
  }
}
fragment ResumeParserReferenceSuggestions on ReferenceSuggestion {
  email
  jobTitle
  mobileNumber
  name
  parserId
  preferredContactMethod
  text
}`) as unknown as TypedDocumentString<EditReferenceSuggestionFormQuery, EditReferenceSuggestionFormQueryVariables>;
export const UpsertEmploymentPositionDocument = new TypedDocumentString(`
    mutation UpsertEmploymentPosition($parserId: String, $input: UpsertEmploymentPositionInput!, $facilityInput: UpsertEmploymentPositionFacilityInput!, $agencyInput: UpsertEmploymentPositionAgencyInput) {
  upsertEmploymentPosition(
    input: $input
    parserId: $parserId
    facilityInput: $facilityInput
    agencyInput: $agencyInput
  ) {
    nurseProfile {
      ...PositionNurseProfileUpdateCache
    }
  }
}
    fragment WorkExperiencePanelPosition on Position {
  id
  title
  positionType
  classification
  startAt
  endAt
  patientRatio
  hoursWorked
  hoursWorkedTimeframe
  nicuCareLevels: nicuLevel
  traumaLevel
  additionalSkills
  chargeExperience
  preceptorExperience
  leadExperience
  trauma
  magnet
  teaching
  wouldWorkAgain
  facilityBedCount: hospitalBedCount
  unitBedCount
  floatFrequency
  friendlyEmploymentType
  invalidOverlapByHours
  invalidOverlapByLocation
  pediatricTraumaLevel
  role {
    id
    name
  }
  facility {
    id
    name
    location {
      id
      formattedLocationString
      googlePlaceId
    }
  }
  clinicalUnit {
    id
    slug
    displayName
  }
  agency {
    id
    name
  }
  specialties {
    id
    displayName
    fullName
    nicu
    pediatric
    slug
  }
  technologies {
    id
    name
  }
  floatUnits {
    id
    displayName
  }
}
fragment PositionNurseProfileUpdateCache on NurseProfile {
  id
  canApplyJobs
  hasPositionsInvalidHoursOverlap
  hasPositionsLocationOverlap
  applicationReadiness {
    results {
      licenses {
        label
        status
      }
    }
  }
  profileCompletion {
    id
    steps {
      workExperience {
        status
        message
      }
    }
    meta {
      id
      incompleteCount
      expiredCount
      percentCompleted
      pendingCount
    }
  }
  positions {
    ...WorkExperiencePanelPosition
  }
}`) as unknown as TypedDocumentString<UpsertEmploymentPositionMutation, UpsertEmploymentPositionMutationVariables>;
export const DeleteEmploymentPositionDocument = new TypedDocumentString(`
    mutation DeleteEmploymentPosition($id: ID!) {
  deleteEmploymentPosition(id: $id) {
    nurseProfile {
      ...PositionNurseProfileUpdateCache
    }
  }
}
    fragment WorkExperiencePanelPosition on Position {
  id
  title
  positionType
  classification
  startAt
  endAt
  patientRatio
  hoursWorked
  hoursWorkedTimeframe
  nicuCareLevels: nicuLevel
  traumaLevel
  additionalSkills
  chargeExperience
  preceptorExperience
  leadExperience
  trauma
  magnet
  teaching
  wouldWorkAgain
  facilityBedCount: hospitalBedCount
  unitBedCount
  floatFrequency
  friendlyEmploymentType
  invalidOverlapByHours
  invalidOverlapByLocation
  pediatricTraumaLevel
  role {
    id
    name
  }
  facility {
    id
    name
    location {
      id
      formattedLocationString
      googlePlaceId
    }
  }
  clinicalUnit {
    id
    slug
    displayName
  }
  agency {
    id
    name
  }
  specialties {
    id
    displayName
    fullName
    nicu
    pediatric
    slug
  }
  technologies {
    id
    name
  }
  floatUnits {
    id
    displayName
  }
}
fragment PositionNurseProfileUpdateCache on NurseProfile {
  id
  canApplyJobs
  hasPositionsInvalidHoursOverlap
  hasPositionsLocationOverlap
  applicationReadiness {
    results {
      licenses {
        label
        status
      }
    }
  }
  profileCompletion {
    id
    steps {
      workExperience {
        status
        message
      }
    }
    meta {
      id
      incompleteCount
      expiredCount
      percentCompleted
      pendingCount
    }
  }
  positions {
    ...WorkExperiencePanelPosition
  }
}`) as unknown as TypedDocumentString<DeleteEmploymentPositionMutation, DeleteEmploymentPositionMutationVariables>;
export const WorkExperienceListPanelDocument = new TypedDocumentString(`
    query WorkExperienceListPanel {
  nurseProfile {
    state
    ...WorkExperienceSectionNurseProfile
  }
  parsedWorkExperiences {
    ...ResumeParserWorkExperienceSuggestions
  }
}
    fragment ResumeParserWorkExperienceSuggestions on WorkExperienceSuggestion {
  startAt
  endAt
  additionalSkills
  facilityName
  traumaLevel
  facilityBedCount: hospitalBedCount
  trauma
  magnet
  teaching
  parserId
  positionType
  role {
    id
    name
  }
  facility {
    id
    name
    location {
      id
      formattedLocationString
      googlePlaceId
      city
      stateCode
    }
  }
  clinicalUnit {
    id
    slug
    displayName
  }
  specialties {
    id
    displayName
  }
  technologies {
    id
    name
  }
}
fragment WorkExperienceSectionNurseProfile on NurseProfile {
  id
  applicationReadiness {
    results {
      employment {
        label
        status
      }
    }
  }
  computedYearsOfExp
  computedYearsOfExpWithGaps
  computedDaysOfExpWithGaps
  educations {
    id
    graduatedOn
  }
  gapBetweenEducationAndEmploymentPosition
  hasPositionsLocationOverlap
  hasPositionsInvalidHoursOverlap
  isYearsOfExpCompleted
  profileCompletion {
    id
    steps {
      workExperience {
        status
        message
      }
    }
  }
  sortedExperienceItems {
    ...WorkExperienceSectionExperienceItem
  }
  yearsOfExp
  yearsOfTravelExp
}
fragment WorkExperienceSectionExperienceItem on ExperienceItemUnion {
  ... on Position {
    ...WorkExperienceSectionPosition
  }
  ... on Gap {
    ...WorkExperienceSectionGap
  }
}
fragment WorkExperienceSectionPosition on Position {
  id
  title
  positionType
  startAt
  endAt
  humanReadableLength
  hoursWorked
  hoursWorkedTimeframe
  nicuCareLevels: nicuLevel
  additionalSkills
  chargeExperience
  leadExperience
  preceptorExperience
  floatFrequency
  friendlyEmploymentType
  invalidOverlapByHours
  invalidOverlapByLocation
  usableForReferences
  activeReferences {
    id
    name
    relationship
    responseAt
  }
  role {
    id
    name
  }
  facility {
    id
    name
    location {
      id
      city
      stateCode
      country
    }
  }
  clinicalUnit {
    id
    displayName
  }
  agency {
    id
    name
  }
  technologies {
    id
    name
  }
  specialties {
    id
    displayName
  }
  floatUnits {
    id
    displayName
  }
}
fragment WorkExperienceSectionGap on Gap {
  gapId: id
  gapEndAt: endAt
  gapExplanation: explanation
  gapGooglePlaceId: googlePlaceId
  gapIsEducationGap: isEducationGap
  gapLocationAddress: locationAddress
  gapReason: reason
  gapStartAt: startAt
}`) as unknown as TypedDocumentString<WorkExperienceListPanelQuery, WorkExperienceListPanelQueryVariables>;
export const BaseWorkExperienceFormDocument = new TypedDocumentString(`
    query BaseWorkExperienceForm {
  educations {
    ...EducationGraduatedOn
  }
  nurseProfile {
    id
    role {
      id
      type
    }
  }
}
    fragment EducationGraduatedOn on Education {
  id
  graduatedOn
}`) as unknown as TypedDocumentString<BaseWorkExperienceFormQuery, BaseWorkExperienceFormQueryVariables>;
export const EditEmploymentPositionFormDocument = new TypedDocumentString(`
    query EditEmploymentPositionForm($positionId: ID!) {
  employmentPosition(id: $positionId) {
    ...WorkExperiencePanelPosition
  }
}
    fragment WorkExperiencePanelPosition on Position {
  id
  title
  positionType
  classification
  startAt
  endAt
  patientRatio
  hoursWorked
  hoursWorkedTimeframe
  nicuCareLevels: nicuLevel
  traumaLevel
  additionalSkills
  chargeExperience
  preceptorExperience
  leadExperience
  trauma
  magnet
  teaching
  wouldWorkAgain
  facilityBedCount: hospitalBedCount
  unitBedCount
  floatFrequency
  friendlyEmploymentType
  invalidOverlapByHours
  invalidOverlapByLocation
  pediatricTraumaLevel
  role {
    id
    name
  }
  facility {
    id
    name
    location {
      id
      formattedLocationString
      googlePlaceId
    }
  }
  clinicalUnit {
    id
    slug
    displayName
  }
  agency {
    id
    name
  }
  specialties {
    id
    displayName
    fullName
    nicu
    pediatric
    slug
  }
  technologies {
    id
    name
  }
  floatUnits {
    id
    displayName
  }
}`) as unknown as TypedDocumentString<EditEmploymentPositionFormQuery, EditEmploymentPositionFormQueryVariables>;
export const EditWorkExperienceSuggestionFormDocument = new TypedDocumentString(`
    query EditWorkExperienceSuggestionForm($id: ID!) {
  parsedWorkExperience(id: $id) {
    ...ResumeParserWorkExperienceSuggestions
  }
}
    fragment ResumeParserWorkExperienceSuggestions on WorkExperienceSuggestion {
  startAt
  endAt
  additionalSkills
  facilityName
  traumaLevel
  facilityBedCount: hospitalBedCount
  trauma
  magnet
  teaching
  parserId
  positionType
  role {
    id
    name
  }
  facility {
    id
    name
    location {
      id
      formattedLocationString
      googlePlaceId
      city
      stateCode
    }
  }
  clinicalUnit {
    id
    slug
    displayName
  }
  specialties {
    id
    displayName
  }
  technologies {
    id
    name
  }
}`) as unknown as TypedDocumentString<EditWorkExperienceSuggestionFormQuery, EditWorkExperienceSuggestionFormQueryVariables>;
export const EmploymentPositionRolesDocument = new TypedDocumentString(`
    query EmploymentPositionRoles {
  employmentPositionRoles: availableRoles {
    ...CompleteRole
  }
}
    fragment CompleteRole on Role {
  id
  abbreviation
  key
  name
  type
}`) as unknown as TypedDocumentString<EmploymentPositionRolesQuery, EmploymentPositionRolesQueryVariables>;
export const TechnologySuggestionsDocument = new TypedDocumentString(`
    query TechnologySuggestions($searchString: String!) {
  technologySuggestions(searchString: $searchString) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<TechnologySuggestionsQuery, TechnologySuggestionsQueryVariables>;
export const AgencySuggestionsDocument = new TypedDocumentString(`
    query AgencySuggestions($searchString: String) {
  getAgencySuggestions(search_string: $searchString) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<AgencySuggestionsQuery, AgencySuggestionsQueryVariables>;
export const ApprovedUserDocument = new TypedDocumentString(`
    query ApprovedUser {
  viewer {
    ... on User {
      id
      nurseProfile {
        id
        requestReview {
          error
          status
        }
        role {
          id
          name
        }
      }
    }
  }
  profileCompletionSummary {
    ...ProfileCompletionSummary
  }
}
    fragment ProfileCompletionSummary on ProfileCompletionSummary {
  id
  completedAt
  meta {
    id
    completeCount
    expiredCount
    expiringCount
    incompleteCount
    pendingCount
    percentCompleted
  }
  steps {
    estimatedTimeInMinutes
    key
    title
    subtitle
    messages
    sectionName
    status
    hasExpiringItems
    hasExpiredItems
    hasInvalidItems
  }
}`) as unknown as TypedDocumentString<ApprovedUserQuery, ApprovedUserQueryVariables>;
export const DeactivatedUserDocument = new TypedDocumentString(`
    query DeactivatedUser {
  viewer {
    ... on User {
      id
      nurseProfile {
        id
        nurseAdvocate {
          id
          firstName
        }
        requestReview {
          error
          status
        }
        role {
          id
          name
        }
      }
      ...MatchCardUser
    }
  }
  profileCompletionSummary {
    ...ProfileCompletionSummary
  }
}
    fragment ProfileCompletionSummary on ProfileCompletionSummary {
  id
  completedAt
  meta {
    id
    completeCount
    expiredCount
    expiringCount
    incompleteCount
    pendingCount
    percentCompleted
  }
  steps {
    estimatedTimeInMinutes
    key
    title
    subtitle
    messages
    sectionName
    status
    hasExpiringItems
    hasExpiredItems
    hasInvalidItems
  }
}
fragment MatchCardUser on User {
  id
  email
  nurseProfile {
    id
    isActivated
    percentComplete
    state
    profileCompletion {
      id
      meta {
        id
        percentCompleted
      }
    }
    nurseAdvocate {
      id
      email
      fullName
    }
  }
}`) as unknown as TypedDocumentString<DeactivatedUserQuery, DeactivatedUserQueryVariables>;
export const ClinicianWorkingDownloadAppCardDocument = new TypedDocumentString(`
    query ClinicianWorkingDownloadAppCard {
  nurseProfile {
    id
    jobPlacements(scope: working) {
      id
      facilityName
      job {
        id
        location {
          id
          city
          stateCode
        }
      }
      endDate
    }
  }
}
    `) as unknown as TypedDocumentString<ClinicianWorkingDownloadAppCardQuery, ClinicianWorkingDownloadAppCardQueryVariables>;
export const JobOfferStateDocument = new TypedDocumentString(`
    query JobOfferState {
  nurseProfile {
    id
    jobApplicationsSummary {
      id
      offer {
        ...JobOfferDetail
      }
    }
  }
}
    fragment MatchCardJob on Job {
  id
  activeApplicantsCount
  favoritedCount
  hoursPerShift
  instantOffer
  jobType
  lengthInWeeks
  licenseType
  localAllowed
  onHold
  shiftType
  shiftsPerWeek
  startAsap
  startDate
  endDate
  facilityName
  cancellationPolicy
  stateActiveAt
  title
  travelAllowed
  business {
    city
    state
    ...MatchCardFacility
  }
  clinicalUnit {
    id
    displayName
  }
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  location {
    id
    city
    stateCode
  }
  localPaymentDetails {
    id
    grossPayWeekly
  }
  emr {
    id
    name
  }
}
fragment MatchCardFacility on Facility {
  id
  name
  logo
}
fragment ContractDetail on Contract {
  id
  contractStatus
  contractStartDate
  contractEndDate
  facility {
    id
    name
    state
    city
  }
  jobOffer {
    id
    uuid
    job {
      id
      facilityName
      location {
        id
        city
        stateCode
      }
      title
    }
  }
}
fragment JobOfferDetail on JobOffer {
  id
  uuid
  status
  startDate
  endDate
  contractNotes
  clinicianAcceptedInapp
  nurseAdvocateEmail
  lengthInWeeks
  shiftType
  shiftsPerWeek
  hoursPerShift
  contracts {
    ...ContractDetail
  }
  timeOffs {
    id
    startDate
    endDate
    approvalStatus
  }
  job {
    ...MatchCardJob
  }
  jobApplication {
    id
    paymentDetails {
      id
      nonTaxableStipendWeekly
      taxableWageRateWeekly
      grossPayWeekly
    }
  }
  paymentDetails {
    id
    nonTaxableStipendWeekly
    taxableWageRateWeekly
    grossPayWeekly
    incidentalsStipendDaily
    lodgingStipendDaily
    regularWageRate
    overtimeMultiplier
    doubleTimeMultiplier
    overtimeWageRate
    regularHoursPerWeek
    overtimeHoursPerWeek
    blendedWageRate
    totalHoursPerWeek
    holidayRate
    chargeRate
    onCallRate
    callBackRate
    extraRate
  }
}`) as unknown as TypedDocumentString<JobOfferStateQuery, JobOfferStateQueryVariables>;
export const JobOffersDocument = new TypedDocumentString(`
    query JobOffers($filter: JobOffersFilter!) {
  nurseProfile {
    id
    jobOffers(filter: $filter) {
      ...JobOfferDetail
    }
  }
}
    fragment MatchCardJob on Job {
  id
  activeApplicantsCount
  favoritedCount
  hoursPerShift
  instantOffer
  jobType
  lengthInWeeks
  licenseType
  localAllowed
  onHold
  shiftType
  shiftsPerWeek
  startAsap
  startDate
  endDate
  facilityName
  cancellationPolicy
  stateActiveAt
  title
  travelAllowed
  business {
    city
    state
    ...MatchCardFacility
  }
  clinicalUnit {
    id
    displayName
  }
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  location {
    id
    city
    stateCode
  }
  localPaymentDetails {
    id
    grossPayWeekly
  }
  emr {
    id
    name
  }
}
fragment MatchCardFacility on Facility {
  id
  name
  logo
}
fragment ContractDetail on Contract {
  id
  contractStatus
  contractStartDate
  contractEndDate
  facility {
    id
    name
    state
    city
  }
  jobOffer {
    id
    uuid
    job {
      id
      facilityName
      location {
        id
        city
        stateCode
      }
      title
    }
  }
}
fragment JobOfferDetail on JobOffer {
  id
  uuid
  status
  startDate
  endDate
  contractNotes
  clinicianAcceptedInapp
  nurseAdvocateEmail
  lengthInWeeks
  shiftType
  shiftsPerWeek
  hoursPerShift
  contracts {
    ...ContractDetail
  }
  timeOffs {
    id
    startDate
    endDate
    approvalStatus
  }
  job {
    ...MatchCardJob
  }
  jobApplication {
    id
    paymentDetails {
      id
      nonTaxableStipendWeekly
      taxableWageRateWeekly
      grossPayWeekly
    }
  }
  paymentDetails {
    id
    nonTaxableStipendWeekly
    taxableWageRateWeekly
    grossPayWeekly
    incidentalsStipendDaily
    lodgingStipendDaily
    regularWageRate
    overtimeMultiplier
    doubleTimeMultiplier
    overtimeWageRate
    regularHoursPerWeek
    overtimeHoursPerWeek
    blendedWageRate
    totalHoursPerWeek
    holidayRate
    chargeRate
    onCallRate
    callBackRate
    extraRate
  }
}`) as unknown as TypedDocumentString<JobOffersQuery, JobOffersQueryVariables>;
export const ContractsByFilterDocument = new TypedDocumentString(`
    query ContractsByFilter($filter: ContractsFilter!) {
  nurseProfile {
    id
    contractsByFilter(filter: $filter) {
      ...ContractDetail
    }
  }
}
    fragment ContractDetail on Contract {
  id
  contractStatus
  contractStartDate
  contractEndDate
  facility {
    id
    name
    state
    city
  }
  jobOffer {
    id
    uuid
    job {
      id
      facilityName
      location {
        id
        city
        stateCode
      }
      title
    }
  }
}`) as unknown as TypedDocumentString<ContractsByFilterQuery, ContractsByFilterQueryVariables>;
export const HomePageDocument = new TypedDocumentString(`
    query HomePage {
  viewer {
    ... on User {
      ...HomePageUser
    }
  }
  homeStepMapper {
    state
    sort
  }
  homeClinicianJobSummary {
    ...HomePageClinicianJobSummary
    favoritedOnce {
      id
      value
    }
  }
}
    fragment MatchCardUser on User {
  id
  email
  nurseProfile {
    id
    isActivated
    percentComplete
    state
    profileCompletion {
      id
      meta {
        id
        percentCompleted
      }
    }
    nurseAdvocate {
      id
      email
      fullName
    }
  }
}
fragment NurseAdvocateWidgetSalesforceUser on SalesforceUser {
  id
  phone
  firstName
  lastName
  profileImgUrl
  isNurseAdvocate
  isAlliedAdvocate
  clinicalRole
}
fragment HomePageUser on User {
  id
  preferredName
  nurseProfile {
    ...HomePageNurseProfile
  }
  ...MatchCardUser
}
fragment HomePageNurseProfile on NurseProfile {
  id
  wizardCompleted
  displayName
  activationRequest {
    earliestStartDateAt
  }
  profileCompletion {
    id
    meta {
      id
      percentCompleted
    }
  }
  nurseAdvocate {
    ...NurseAdvocateWidgetSalesforceUser
  }
  state
}
fragment HomePageClinicianJobSummary on HomeClinicianJobSummary {
  id
  favoritedCount {
    id
    value
  }
  applicationsCount {
    id
    value
  }
  offersCount {
    id
    value
  }
  submissionsCount {
    id
    value
  }
}`) as unknown as TypedDocumentString<HomePageQuery, HomePageQueryVariables>;
export const HomePageOnboardingDocument = new TypedDocumentString(`
    query HomePageOnboarding {
  activeOnboardingLists {
    ...TodoList
  }
}
    fragment TodoList on TodoList {
  id
  completeByDate
  targetBusinessName
  todoListItems(filter: LIVE) {
    id
    itemState
  }
}`) as unknown as TypedDocumentString<HomePageOnboardingQuery, HomePageOnboardingQueryVariables>;
export const HomePageNewStateDocument = new TypedDocumentString(`
    query HomePageNewState {
  homeTotalMatches {
    matchesWaiting
  }
}
    `) as unknown as TypedDocumentString<HomePageNewStateQuery, HomePageNewStateQueryVariables>;
export const HomeClinicianJobSummaryDocument = new TypedDocumentString(`
    query HomeClinicianJobSummary {
  homeClinicianJobSummary {
    ...HomePageClinicianJobSummary
  }
}
    fragment HomePageClinicianJobSummary on HomeClinicianJobSummary {
  id
  favoritedCount {
    id
    value
  }
  applicationsCount {
    id
    value
  }
  offersCount {
    id
    value
  }
  submissionsCount {
    id
    value
  }
}`) as unknown as TypedDocumentString<HomeClinicianJobSummaryQuery, HomeClinicianJobSummaryQueryVariables>;
export const ComplianceQuestionsDocument = new TypedDocumentString(`
    mutation ComplianceQuestions($input: CreateComplianceQuestionsInput!, $jobOfferId: ID!) {
  createComplianceQuestions(input: $input, jobOfferId: $jobOfferId) {
    jobOffer {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<ComplianceQuestionsMutation, ComplianceQuestionsMutationVariables>;
export const ComplianceQuestionsDataDocument = new TypedDocumentString(`
    query ComplianceQuestionsData($jobOfferId: ID!) {
  viewer {
    ... on User {
      ...LegalNameAndBirthdayFormUser
      ...ComplianceQuestionsPermanentAddressUser
      ...CurrentAddressUser
    }
  }
  jobOffer(id: $jobOfferId) {
    ...JobOfferDetail
  }
}
    fragment MatchCardJob on Job {
  id
  activeApplicantsCount
  favoritedCount
  hoursPerShift
  instantOffer
  jobType
  lengthInWeeks
  licenseType
  localAllowed
  onHold
  shiftType
  shiftsPerWeek
  startAsap
  startDate
  endDate
  facilityName
  cancellationPolicy
  stateActiveAt
  title
  travelAllowed
  business {
    city
    state
    ...MatchCardFacility
  }
  clinicalUnit {
    id
    displayName
  }
  defaultPaymentDetails {
    id
    grossPayWeekly
  }
  location {
    id
    city
    stateCode
  }
  localPaymentDetails {
    id
    grossPayWeekly
  }
  emr {
    id
    name
  }
}
fragment MatchCardFacility on Facility {
  id
  name
  logo
}
fragment LegalNameAndBirthdayFormUser on User {
  id
  firstName
  middleName
  lastName
  nurseProfile {
    id
    birthday
  }
}
fragment CurrentAddressUser on User {
  id
  city
  state
  streetAddress
  zipcode
}
fragment ContractDetail on Contract {
  id
  contractStatus
  contractStartDate
  contractEndDate
  facility {
    id
    name
    state
    city
  }
  jobOffer {
    id
    uuid
    job {
      id
      facilityName
      location {
        id
        city
        stateCode
      }
      title
    }
  }
}
fragment JobOfferDetail on JobOffer {
  id
  uuid
  status
  startDate
  endDate
  contractNotes
  clinicianAcceptedInapp
  nurseAdvocateEmail
  lengthInWeeks
  shiftType
  shiftsPerWeek
  hoursPerShift
  contracts {
    ...ContractDetail
  }
  timeOffs {
    id
    startDate
    endDate
    approvalStatus
  }
  job {
    ...MatchCardJob
  }
  jobApplication {
    id
    paymentDetails {
      id
      nonTaxableStipendWeekly
      taxableWageRateWeekly
      grossPayWeekly
    }
  }
  paymentDetails {
    id
    nonTaxableStipendWeekly
    taxableWageRateWeekly
    grossPayWeekly
    incidentalsStipendDaily
    lodgingStipendDaily
    regularWageRate
    overtimeMultiplier
    doubleTimeMultiplier
    overtimeWageRate
    regularHoursPerWeek
    overtimeHoursPerWeek
    blendedWageRate
    totalHoursPerWeek
    holidayRate
    chargeRate
    onCallRate
    callBackRate
    extraRate
  }
}
fragment ComplianceQuestionsPermanentAddressUser on User {
  id
  cityPermanent
  countryPermanentCode
  countryPermanentName
  googlePlaceIdPermanent
  statePermanent
  streetAddressPermanent
  streetNumberPermanent
  zipcodePermanent
}`) as unknown as TypedDocumentString<ComplianceQuestionsDataQuery, ComplianceQuestionsDataQueryVariables>;
export const RequestActivationDocument = new TypedDocumentString(`
    mutation RequestActivation($input: RequestActivationInput!) {
  requestActivation(input: $input) {
    reasons
    errorCode
    nurseProfile {
      id
      isActivated
      activationRequest {
        ...ActivationRequest
      }
      requestReview {
        ...RequestReview
      }
    }
  }
}
    fragment NurseAdvocateWidgetSalesforceUser on SalesforceUser {
  id
  phone
  firstName
  lastName
  profileImgUrl
  isNurseAdvocate
  isAlliedAdvocate
  clinicalRole
}
fragment RequestReview on RequestReview {
  status
  title
  description
  ctaText
  error
}
fragment ActivationRequest on ActivationRequest {
  id
  earliestStartDateAt
  notes
  requiredExperience
  requiredExperienceDateAt
  followingStepQuestion
  advocate {
    ...NurseAdvocateWidgetSalesforceUser
  }
}`) as unknown as TypedDocumentString<RequestActivationMutation, RequestActivationMutationVariables>;
export const RequestActivationAssignAdvocateDocument = new TypedDocumentString(`
    mutation RequestActivationAssignAdvocate {
  assignAdvocate {
    nurseProfile {
      ...ActivationRequestNurseProfile
    }
  }
}
    fragment CompleteRole on Role {
  id
  abbreviation
  key
  name
  type
}
fragment NurseAdvocateWidgetSalesforceUser on SalesforceUser {
  id
  phone
  firstName
  lastName
  profileImgUrl
  isNurseAdvocate
  isAlliedAdvocate
  clinicalRole
}
fragment ActivationRequest on ActivationRequest {
  id
  earliestStartDateAt
  notes
  requiredExperience
  requiredExperienceDateAt
  followingStepQuestion
  advocate {
    ...NurseAdvocateWidgetSalesforceUser
  }
}
fragment ActivationRequestNurseProfile on NurseProfile {
  id
  state
  wizardCompleted
  yearsOfExp
  role {
    ...CompleteRole
  }
  activationRequest {
    ...ActivationRequest
  }
}`) as unknown as TypedDocumentString<RequestActivationAssignAdvocateMutation, RequestActivationAssignAdvocateMutationVariables>;
export const RequestReviewPageDataDocument = new TypedDocumentString(`
    query RequestReviewPageData {
  requestReviewFormCopy {
    ...RequestReviewFormCopy
  }
  nurseProfile {
    ...ActivationRequestNurseProfile
  }
}
    fragment CompleteRole on Role {
  id
  abbreviation
  key
  name
  type
}
fragment NurseAdvocateWidgetSalesforceUser on SalesforceUser {
  id
  phone
  firstName
  lastName
  profileImgUrl
  isNurseAdvocate
  isAlliedAdvocate
  clinicalRole
}
fragment RequestReviewFormCopy on RequestReviewForm {
  title
  ctaText
  experienceDateQuestion {
    title
    description
  }
  experienceQuestion {
    title
    description
  }
  startDateQuestion {
    title
    description
  }
  notesQuestion {
    title
    description
  }
  licenseOrCertificationQuestion {
    title
    description
  }
  licenseOrCertificationIntentionQuestion {
    title
    description
  }
  licenseOrCertificationDateQuestion {
    title
    description
  }
  followingStepQuestion {
    title
    description
  }
}
fragment ActivationRequest on ActivationRequest {
  id
  earliestStartDateAt
  notes
  requiredExperience
  requiredExperienceDateAt
  followingStepQuestion
  advocate {
    ...NurseAdvocateWidgetSalesforceUser
  }
}
fragment ActivationRequestNurseProfile on NurseProfile {
  id
  state
  wizardCompleted
  yearsOfExp
  role {
    ...CompleteRole
  }
  activationRequest {
    ...ActivationRequest
  }
}`) as unknown as TypedDocumentString<RequestReviewPageDataQuery, RequestReviewPageDataQueryVariables>;
export const CeuTrackerDocument = new TypedDocumentString(`
    query CeuTracker {
  viewer {
    ... on User {
      id
      firstName
      lastName
      email
      intercomUserHash
      nurseProfile {
        id
        ...CeuGoalsTrackingContainerNurseProfile
        ...CeuCertificatesListNurseProfile
      }
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment CeuCertificatesListNurseProfile on NurseProfile {
  id
  ceuCertificates {
    id
    ...CeuCertificatesListItemCeuCertificate
  }
  ceuGoals {
    id
    ...CeuGoalsTrackerCeuGoal
  }
}
fragment CeuCertificatesListItemCeuCertificate on CeuCertificate {
  id
  name
  contactHours
  ceuCertificateType
  completionDate
  providerNumber
  files {
    ...FileMetadata
  }
}
fragment CeuGoalFormCeuGoal on CeuGoal {
  id
  goalType
  requiredContactHours
  startDate
  endDate
  description
  ceuStateRequirement {
    id
  }
  ceuCertificates {
    id
  }
}
fragment CeuGoalsTrackerCeuGoal on CeuGoal {
  id
  goalType
  accepted
  deleted
  requiredContactHours
  startDate
  endDate
  systemCreated
  description
  completedContactHours
  ceuStateRequirement {
    id
    state
    requirementDescription
  }
  ...CeuGoalFormCeuGoal
}
fragment CeuGoalsTrackingContainerNurseProfile on NurseProfile {
  id
  ceuGoals {
    id
    goalType
    requiredContactHours
    startDate
    endDate
    description
    systemCreated
    accepted
    deleted
    ceuStateRequirement {
      id
      state
      requiredContactHours
      notes
      requirementQuantity
      requirementDescription
      stateBonUrl
      durationDays
      licenseType
    }
    completedContactHours
    ceuCertificates {
      id
    }
    ...CeuGoalFormCeuGoal
  }
}`) as unknown as TypedDocumentString<CeuTrackerQuery, CeuTrackerQueryVariables>;
export const CredentialsPageDocument = new TypedDocumentString(`
    query CredentialsPage {
  nurseProfile {
    id
    state
    numExpiredCredentials
    numExpiringCredentials
    numTotalCredentials
  }
  clinicianCredentialsOverview {
    id
    credentialExpiredCount
    credentialExpiringCount
    credentialTotalCount
  }
}
    `) as unknown as TypedDocumentString<CredentialsPageQuery, CredentialsPageQueryVariables>;
export const ExplorerPageDocument = new TypedDocumentString(`
    query ExplorerPage($searchForm: String!, $loggedIn: Boolean!) {
  viewer {
    ... on User {
      id
    }
  }
  ... @include(if: $loggedIn) {
    viewer {
      ... on User {
        ...ExplorerPageUser
      }
    }
  }
}
    fragment ExplorerPageHeaderUser on User {
  id
  nurseProfile {
    businesses {
      ...FacilityResultCardBusiness
      name
      address
      state
    }
    id
    canViewJobs
    yearsOfExp
    searchHistory(searchForm: $searchForm) {
      ...RecentSearchesCardSearchHistory
    }
  }
  ...SavedFacilitiesSectionUser
}
fragment FacilitiesCardUser on User {
  id
  nurseProfile {
    id
  }
  ...FacilityResultCardUser
}
fragment RecentSearchesCardSearchHistory on SearchHistory {
  id
  searchForm
  searchHistoryEntries {
    ...RecentSearchesCardSearchHistoryEntry
  }
}
fragment RecentSearchesCardSearchHistoryEntry on SearchHistoryEntry {
  id
  searchParams
}
fragment FacilityResultCardUser on User {
  id
  nurseProfile {
    id
    businesses {
      ...FacilityResultCardBusiness
    }
  }
  ...TrackFacilityPageViewUser
}
fragment FacilityResultCardBusiness on Facility {
  id
  slug
}
fragment SavedFacilitiesSectionUser on User {
  id
  email
}
fragment ExplorerIndexPageExplorerState on User {
  id
  nurseProfile {
    id
    educations {
      id
      locationString
    }
    location {
      id
      locationString
    }
    nursePreferences {
      id
      locations {
        id
        locationString
      }
    }
  }
}
fragment TrackFacilityPageViewUser on User {
  id
  email
}
fragment ExplorerPageUser on User {
  id
  ...ExplorerIndexPageExplorerState
  firstName
  lastName
  intercomUserHash
  nurseProfile {
    id
    nurseType
    role {
      id
      key
      name
      type
    }
    licenses {
      id
      licenseType
    }
    educations {
      id
      locationString
    }
    nursePreferences {
      id
      explorerRole
      locations {
        id
        locationString
      }
    }
    location {
      id
      locationString
    }
    businesses {
      ...NurseProfileBusiness
    }
    searchHistory(searchForm: $searchForm) {
      ...RecentSearchesCardSearchHistory
    }
  }
  ...ExplorerPageHeaderUser
  ...FacilitiesCardUser
}
fragment NurseProfileBusiness on Facility {
  id
  slug
  name
  address
  city
  state
  hospital {
    id
    hospitalSystem
  }
  residencyPrograms {
    id
    name
  }
}`) as unknown as TypedDocumentString<ExplorerPageQuery, ExplorerPageQueryVariables>;
export const FacilityPageDocument = new TypedDocumentString(`
    query FacilityPage($facilitySlug: String!, $loggedIn: Boolean!, $statsSource: String, $statsIds: [String!]) {
  ... @include(if: $loggedIn) {
    viewer {
      ... on User {
        id
        ...FacilityLoggedInPageUser
      }
    }
  }
  facility(slug: $facilitySlug) {
    id
    ...FacilityLoggedOutPageFacility
    ...FacilityLoggedInPageFacility
  }
}
    fragment CostOfLivingFocusedStat on Stat {
  statId
  statName
  valueFloat
}
fragment FacilityLoggedInPageFacility on Facility {
  id
  name
  ...FacilityPageFacility
  ...FacilityPageHeroContainer
  ...FacilityUtility
}
fragment FacilityLoggedInPageUser on User {
  id
  ...AnalyticsUser
  ...FacilityPageUser
}
fragment FacilityLoggedOutPageFacility on Facility {
  id
  slug
  ...FacilityPageHeroContainer
  ...FacilityPageFacility
}
fragment FacilityPageFacility on Facility {
  id
  city
  state
  rankings {
    ...FacilityPageUsnewsRanking
  }
  location {
    id
    city
    stateName
  }
  residencyPrograms {
    ...ResidencyProgramsCard
  }
  nearbyFacilities {
    ...NearbyFacilitiesCardFacility
  }
  costOfLivingStats(source: $statsSource, statsIds: $statsIds) {
    ...CostOfLivingFocusedStat
  }
  ...WalkscoreMapFacility
  ...FacilitySummaryFacility
}
fragment FacilityPageUsnewsRanking on UsnewsRanking {
  id
  usnewsType
  ...UsnewsRankingContainerUsnewsRanking
}
fragment FacilityPageUser on User {
  id
  nurseProfile {
    id
    nurseType
    savedFacility(facilitySlug: $facilitySlug)
  }
  ...TrackFacilityPageViewUser
}
fragment FacilityPageHeroContainer on Facility {
  id
  location {
    id
    city
    stateName
  }
}
fragment FacilitySummaryFacility on Facility {
  id
  slug
  logo
  residencyPrograms {
    id
  }
  hospital {
    id
    jointCommission
    magnet
    ...FacilityHospitalSummaryFeaturesFacility
  }
  ...FacilitySummaryInformationFacility
  ...FacilitySummaryAccreditationsFacility
  ...FacilitySummarySurveyFacility
}
fragment FacilitySummarySurveyFacility on Facility {
  id
  slug
  name
  surveyForUser {
    completedAt
  }
  ...FacilityReviewPanelFacility
}
fragment FacilitySummaryInformationFacility on Facility {
  name
  address
  city
  state
  zipcode
  hospital {
    id
    hospitalSystem
  }
  dhcProviderWebsite
}
fragment FacilityHospitalSummaryFeaturesFacility on Hospital {
  id
  totalLicensedBeds
  traumaCenterLevel
  hospitalType
}
fragment FacilitySummaryAccreditationsFacility on Facility {
  hospital {
    affiliatedUnion
    teaching
    jointCommission
    magnet
  }
  residencyPrograms {
    accreditingBody
  }
}
fragment NearbyFacilitiesCardFacility on NearbyFacility {
  distance
  facility {
    ...NearbyFacilityCardFacility
  }
}
fragment ResidencyProgramsCard on ResidencyProgram {
  id
  name
  accreditingBody
  url
  offersAllSpecialties
  clinicalSpecialties {
    id
    displayName
  }
}
fragment UsnewsRankingContainerUsnewsRanking on UsnewsRanking {
  id
  rank
  specialtyName
  usnewsType
}
fragment WalkscoreMapFacility on Facility {
  latitude
  longitude
  name
  address
  city
  state
  zipcode
  walkscoreByCoordinates {
    ...WalkscoreMap
  }
  cityWalkscore {
    ...WalkscoreMap
  }
}
fragment WalkscoreMap on Walkscore {
  walkScore
  walkDescription
  walkExtraInfo
  transitScore
  transitDescription
  transitExtraInfo
  bikeScore
  bikeDescription
  bikeExtraInfo
}
fragment FacilityReviewPanelFacility on Facility {
  id
  name
  slug
}
fragment TrackFacilityPageViewUser on User {
  id
  email
}
fragment AnalyticsUser on User {
  id
  uuid
  email
  intercomUserHash
}
fragment NearbyFacilityCardFacility on Facility {
  id
  slug
  logo
  name
  city
  state
}
fragment FacilityUtility on Facility {
  name
  city
  state
  hospital {
    id
    hospitalType
    totalLicensedBeds
    traumaCenterLevel
  }
  rankings {
    ...FacilityUtilityRankings
  }
  ...FacilityUtilityAccreditationInfo
}
fragment FacilityUtilityAccreditationInfo on Facility {
  residencyPrograms {
    id
  }
  hospital {
    id
    magnet
    jointCommission
    teaching
    affiliatedUnion
  }
}
fragment FacilityUtilityRankings on UsnewsRanking {
  usnewsType
}`) as unknown as TypedDocumentString<FacilityPageQuery, FacilityPageQueryVariables>;
export const IndexPageQueryDocument = new TypedDocumentString(`
    query IndexPageQuery {
  viewer {
    ...IndexPageUser
  }
}
    fragment IndexPageUser on User {
  id
  uuid
  nurseProfile {
    id
    isOnboarding
    profileCompletion {
      id
      meta {
        percentCompleted
      }
    }
    uuid
    wizardCompleted
  }
}`) as unknown as TypedDocumentString<IndexPageQueryQuery, IndexPageQueryQueryVariables>;
export const InvitePageDocument = new TypedDocumentString(`
    query InvitePage {
  viewer {
    ...InviteUser
  }
}
    fragment InviteUser on User {
  id
  email
  firstName
  lastName
  saasquatchToken
  referredByUuid
  nurseProfile {
    id
    squatchShareUrl
  }
}`) as unknown as TypedDocumentString<InvitePageQuery, InvitePageQueryVariables>;
export const BoardOfNursingUrlsDocument = new TypedDocumentString(`
    query BoardOfNursingUrls {
  boardOfNursingUrls {
    state
    url
  }
}
    `) as unknown as TypedDocumentString<BoardOfNursingUrlsQuery, BoardOfNursingUrlsQueryVariables>;
export const LoginPageQueryDocument = new TypedDocumentString(`
    query LoginPageQuery {
  viewer {
    ... on User {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<LoginPageQueryQuery, LoginPageQueryQueryVariables>;
export const JobRuleValidationsDocument = new TypedDocumentString(`
    query JobRuleValidations($jobId: ID!) {
  job(id: $jobId) {
    id
    ruleValidations {
      ...RuleValidation
    }
    requiredJarsV2 {
      ... on JobApplicationRequirementsCertification {
        ...JarCertification
      }
    }
  }
}
    fragment RuleValidation on JobApplicationRequirementRuleEngineVerification {
  type
  valid
  errorMessages
}
fragment JarCertification on JobApplicationRequirementsCertification {
  id
  type
  title
  description
  certification {
    id
    credential
    name
    uuid
    issuingBodies
  }
}`) as unknown as TypedDocumentString<JobRuleValidationsQuery, JobRuleValidationsQueryVariables>;
export const NurseCertificationsDocument = new TypedDocumentString(`
    query NurseCertifications {
  viewer {
    ... on User {
      id
      nurseProfile {
        id
        nurseCertifications {
          id
          name
          expiresOn
          completedOn
          isExpired
          isExpiringSoon
          issuingBody
          useCompletionDate
          certification {
            id
            name
            issuingBodies
            credential
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<NurseCertificationsQuery, NurseCertificationsQueryVariables>;
export const StrengthenLicenseDocument = new TypedDocumentString(`
    query StrengthenLicense {
  viewer {
    ... on User {
      id
      nurseProfile {
        id
        licenses {
          ...LicenseListItemLicense
        }
      }
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment LicenseListItemLicense on License {
  id
  uuid
  licenseType
  friendlyLicenseType
  licensureCompact
  compact
  stateCode
  state
  number
  expiresOn
  title
  isExpired
  isExpiringSoon
  files {
    ...FileMetadata
  }
}`) as unknown as TypedDocumentString<StrengthenLicenseQuery, StrengthenLicenseQueryVariables>;
export const StrengthenReferencesDocument = new TypedDocumentString(`
    query StrengthenReferences {
  viewer {
    ... on User {
      id
      nurseProfile {
        ...ReferenceNurseProfileUpdateCache
      }
    }
  }
}
    fragment FileMetadata on File {
  id
  contentType
  createdAt
  downloadUrl
  filename
  previewUrl
  viewUrl
}
fragment ReferenceNurseProfileUpdateCache on NurseProfile {
  id
  canApplyJobs
  numActiveReferences
  referencesComplete
  references {
    ...ReferenceDetails
  }
  positions {
    id
    startAt
    endAt
    usableForReferences
    facility {
      id
      name
      location {
        id
        formattedLocationString
        googlePlaceId
      }
    }
  }
  licenses {
    id
  }
  applicationReadiness {
    meta {
      requirements {
        status
      }
    }
    results {
      references {
        label
        status
        completeReferenceCount
        pendingReferenceCount
      }
    }
  }
  profileCompletion {
    id
    steps {
      references {
        status
      }
    }
  }
}
fragment ReferenceDetails on Reference {
  id
  bedCount
  chargeExp
  email
  expired
  facilityName
  isLocked
  jobTitle
  lastFailedDelivery
  name
  patientsPerNurse
  phone
  preferredContactMethod
  relationship
  responseAt
  signedName
  unit
  unitName
  files {
    ...FileMetadata
  }
  position {
    id
    startAt
    endAt
    title
    usableForReferences
    facility {
      id
      name
      location {
        id
        formattedLocationString
        googlePlaceId
      }
    }
  }
}`) as unknown as TypedDocumentString<StrengthenReferencesQuery, StrengthenReferencesQueryVariables>;
export const MatchesIndexPageDocument = new TypedDocumentString(`
    query MatchesIndexPage {
  viewer {
    ... on User {
      id
      ...ShouldRedirectUser
      ...RequestInterviewButtonUser
    }
  }
}
    fragment RequestInterviewButtonUser on User {
  id
  nurseProfile {
    ...RequestInterviewButtonNurseProfile
  }
  ...JobApplicationRequirementsUser
}
fragment RequestInterviewButtonNurseProfile on NurseProfile {
  id
  isActivated
  canApplyJobs
  profileCompletion {
    id
    meta {
      id
      percentCompleted
    }
  }
  state
}
fragment JobApplicationRequirementsUser on User {
  id
  email
  firstName
  lastName
  nurseProfile {
    ...JobApplicationRequirementsNurseProfile
  }
}
fragment JobApplicationRequirementsNurseAdvocate on SalesforceUser {
  id
  email
  fullName
}
fragment JobApplicationRequirementsNurseProfile on NurseProfile {
  id
  state
  percentComplete
  profileCompletion {
    id
  }
  nurseAdvocate {
    ...JobApplicationRequirementsNurseAdvocate
  }
}
fragment ShouldRedirectUser on User {
  nurseProfile {
    id
    canViewJobs
    wizardCompleted
  }
}`) as unknown as TypedDocumentString<MatchesIndexPageQuery, MatchesIndexPageQueryVariables>;
export const MatchesLandingPageNursePreferencesDocument = new TypedDocumentString(`
    query MatchesLandingPageNursePreferences {
  viewer {
    ... on User {
      id
      nurseProfile {
        ...MatchesLandingPageNurseProfile
      }
    }
  }
}
    fragment MatchesLandingPageNurseProfile on NurseProfile {
  id
  canViewJobs
  wizardCompleted
  activeClinicalSpecialties {
    id
    slug
  }
  profileCompletion {
    id
    meta {
      id
      percentCompleted
    }
    ...ProfilePageProfileCompletion
  }
  role {
    id
  }
  nursePreferences {
    id
    broadPrefLocations
    contractLengths
    locations {
      id
      locationString
    }
    shiftPrefs
    shiftLengths
  }
}
fragment ProfilePageProfileCompletion on NurseProfileCompletion {
  id
  ...ProfilePageProfileCompletionMeta
  steps {
    backgroundQuestions {
      label
      status
    }
    certification {
      label
      message
      status
    }
    education {
      label
      message
      status
    }
    license {
      label
      message
      status
    }
    permanentAddress {
      label
      status
    }
    personalInfo {
      label
      status
    }
    references {
      label
      message
      status
    }
    skillsChecklist {
      label
      message
      status
    }
    verifyEmail {
      label
      status
    }
    workExperience {
      label
      status
    }
    yearsOfExperience {
      label
      status
    }
  }
}
fragment ProfilePageProfileCompletionMeta on NurseProfileCompletion {
  id
  meta {
    id
    completeCount
    expiredCount
    expiringCount
    incompleteCount
    pendingCount
    percentCompleted
  }
}`) as unknown as TypedDocumentString<MatchesLandingPageNursePreferencesQuery, MatchesLandingPageNursePreferencesQueryVariables>;
export const BucketConfigurationDocument = new TypedDocumentString(`
    query BucketConfiguration($bucketUuid: ID, $bucketKey: String) {
  viewer {
    ... on User {
      id
      nurseProfile {
        id
      }
    }
  }
  bucketConfiguration(bucketUuid: $bucketUuid, bucketKey: $bucketKey) {
    id
    key
    name
  }
}
    `) as unknown as TypedDocumentString<BucketConfigurationQuery, BucketConfigurationQueryVariables>;
export const AfterSignupRedirectWizardCompleteDocument = new TypedDocumentString(`
    mutation AfterSignupRedirectWizardComplete($id: ID!, $input: UpdateNurseProfileInput!) {
  updateNurseProfile(id: $id, input: $input) {
    nurseProfile {
      id
      wizardCompleted
      state
    }
  }
}
    `) as unknown as TypedDocumentString<AfterSignupRedirectWizardCompleteMutation, AfterSignupRedirectWizardCompleteMutationVariables>;
export const AfterSignupRedirectDocument = new TypedDocumentString(`
    query AfterSignupRedirect {
  viewer {
    ... on User {
      id
      nurseProfile {
        id
        wizardCompleted
        location {
          googlePlaceId
          id
          locationString
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AfterSignupRedirectQuery, AfterSignupRedirectQueryVariables>;
export const ApprovalFlowMissingStepDocument = new TypedDocumentString(`
    query ApprovalFlowMissingStep {
  missingStep: approvalFlowMissingStep {
    name
    forRoleType
    stage
    flowCompleted
  }
}
    `) as unknown as TypedDocumentString<ApprovalFlowMissingStepQuery, ApprovalFlowMissingStepQueryVariables>;
export const SignupDocument = new TypedDocumentString(`
    query Signup($type: RoleType, $loggedIn: Boolean!) {
  roles(type: $type) {
    ...CompleteRole
  }
  __type(name: "NurseTypes") {
    name
    enumValues {
      name
      description
    }
  }
  ... @include(if: $loggedIn) {
    viewer {
      ... on User {
        id
        ...ClinicianSignupInitialPath
        nurseProfile {
          id
          wizardCompleted
        }
      }
    }
  }
}
    fragment CompleteRole on Role {
  id
  abbreviation
  key
  name
  type
}
fragment ClinicianSignupInitialPath on User {
  id
  email
  firstName
  lastName
  preferredName
  nurseProfile {
    id
    clinicalExperienceLevel
    state
    nurseType
    clinicalSpecialties {
      id
      specialty
    }
    location {
      id
    }
    role {
      id
      key
      name
      type
    }
  }
}`) as unknown as TypedDocumentString<SignupQuery, SignupQueryVariables>;
export const ExistingClinicianDocument = new TypedDocumentString(`
    query ExistingClinician {
  viewer {
    ... on User {
      id
    }
  }
  nurseProfile {
    id
  }
}
    `) as unknown as TypedDocumentString<ExistingClinicianQuery, ExistingClinicianQueryVariables>;
export const UserByEmailDocument = new TypedDocumentString(`
    query UserByEmail($email: String!, $csrfToken: String!) {
  userByEmail(email: $email, csrfToken: $csrfToken)
}
    `) as unknown as TypedDocumentString<UserByEmailQuery, UserByEmailQueryVariables>;
export const UptimeDocument = new TypedDocumentString(`
    query Uptime {
  roles {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<UptimeQuery, UptimeQueryVariables>;